var a_ = Object.defineProperty;
var o_ = (e, t, r) => t in e ? a_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var pe = (e, t, r) => (o_(e, typeof t != "symbol" ? t + "" : t, r), r);
import { j as S } from "./jsx-runtime-944c88e2.js";
import { useQuery as ol, QueryClient as S0, useMutation as s_, QueryClientProvider as u_ } from "@tanstack/react-query";
import * as Fe from "react";
import me, { Children as _0, isValidElement as lx, useMemo as Vn, cloneElement as l_, Fragment as c_, useCallback as Me, useState as Oe, useEffect as He, useContext as sn, createContext as Rr, Suspense as tr, useRef as qr, lazy as Mr, forwardRef as f_, createElement as Ei, useImperativeHandle as d_, useLayoutEffect as h_ } from "react";
import { BrowserRouter as p_, useNavigate as v_ } from "react-router-dom";
import { CheckIcon as m_, CloseIcon as cx, ChevronRightIcon as Rp, Icon as y_, ArrowBackIcon as g_, ArrowForwardIcon as fx } from "@chakra-ui/icons";
import { Box as Ce, Stack as T0, Text as Ct, Spinner as Io, createMultiStyleConfigHelpers as x_, extendTheme as dx, ChakraProvider as b_, Center as Wt, useEditableControls as E_, ButtonGroup as w_, IconButton as wu, useToast as S_, Tooltip as Dc, Skeleton as A0, Editable as __, EditablePreview as T_, useColorModeValue as hx, HStack as Ni, Input as sl, EditableInput as A_, Flex as Cr, Button as ri, Show as px, VStack as Oi, Link as Js, Spacer as sd, Circle as Zs, Image as ul, keyframes as C_, InputGroup as C0, InputRightElement as vx, Heading as mx, UnorderedList as Mp, ListItem as Qi, chakra as O_, FormControl as Fc, FormErrorMessage as Ic } from "@chakra-ui/react";
import { s as O0, q as Gn, b as yx, p as D_, k as F_, a as Jo, r as I_, u as Fa, e as k_, d as N_, c as P_, l as $_, x as R_, y as Ja, z as M_, v as B_, A as j_, g as kc, m as L_, n as Bp, h as U_ } from "./useAccount-2367dbfe.js";
import "./myasurion-shared.mixpanel.es.js";
import { a as ll, g as Xe, b as H_, k as xa, l as ba, h as gx, i as W_, f as z_ } from "./domains-8f7837df.js";
import { a as xx, u as bx, F as q_ } from "./features-325864e1.js";
import { getCountryByCarrier as Ir, getDefaultLanguageByCarrier as Y_ } from "./myasurion-shared.carrier.es.js";
import { g as Nt, c as he } from "./lodash-9598aa3c.js";
import { n as V_, a as Ex, f as wx, c as G_, F as Sx, B as sa, p as K_, q as Q_ } from "./cleave-react-node-c4a374e5.js";
import { C as X_, b as cl, _ as ud, c as Su, d as _u, e as D0, f as J_, g as _x, h as Nc, i as Z_, j as eT, k as tT, A as Ia, t as rT, S as nT, l as iT, m as aT, r as oT, n as sT, M as uT, o as lT, p as Tx, q as cT, v as fT, s as fl, w as Kn, x as Ax, y as dT, z as Ea, B as dl, D as hl, E as Qn, F as pl, G as vl, H as ml, I as yl, J as gl, K as xl, L as hT, N as pT, O as vT, P as mT, Q as yT, R as gT, T as xT, U as bT, V as ET, W as Cx, X as jp, Y as Tu, Z as Ox, $ as wT, a0 as ST, a1 as _T, a2 as TT, a3 as AT, a4 as CT, a5 as OT, a6 as ld } from "./providers-fe718bdb.js";
import { motion as DT } from "framer-motion";
import "@react-oauth/google";
import { Button as cd } from "./myasurion-shared.widgets.es.js";
import { getContentfulImage as FT } from "./myasurion-shared.utils.es.js";
import "@emotion/react";
import { P as IT } from "./ProfileIcon-8cf21b72.js";
import { AvatarInitials as kT } from "./myasurion-shared.profile.es.js";
import * as Pc from "react-dom";
import eu, { createPortal as NT } from "react-dom";
import { getChakraColorScale as Lp } from "./myasurion-shared.colors.es.js";
function We(e, t = {}) {
  let r = !1;
  function n() {
    if (!r) {
      r = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function i(...c) {
    n();
    for (const f of c)
      t[f] = u(f);
    return We(e, t);
  }
  function a(...c) {
    for (const f of c)
      f in t || (t[f] = u(f));
    return We(e, t);
  }
  function o() {
    return Object.fromEntries(
      Object.entries(t).map(([f, d]) => [f, d.selector])
    );
  }
  function s() {
    return Object.fromEntries(
      Object.entries(t).map(([f, d]) => [f, d.className])
    );
  }
  function u(c) {
    const h = `chakra-${(["container", "root"].includes(c ?? "") ? [e] : [e, c]).filter(Boolean).join("__")}`;
    return {
      className: h,
      selector: `.${h}`,
      toString: () => c
    };
  }
  return {
    parts: i,
    toPart: u,
    extend: a,
    selectors: o,
    classnames: s,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
We("accordion").parts("root", "container", "button", "panel").extend("icon");
We("alert").parts("title", "description", "container").extend("icon", "spinner");
We("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
We("breadcrumb").parts("link", "item", "container").extend("separator");
We("button").parts();
We("checkbox").parts("control", "icon", "container").extend("label");
We("progress").parts("track", "filledTrack").extend("label");
We("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
We("editable").parts(
  "preview",
  "input",
  "textarea"
);
We("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
We("formError").parts("text", "icon");
var PT = We("input").parts(
  "addon",
  "field",
  "element",
  "group"
);
We("list").parts("container", "item", "icon");
We("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
We("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
We("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
We("pininput").parts("field");
We("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
We("progress").parts(
  "label",
  "filledTrack",
  "track"
);
We("radio").parts(
  "container",
  "control",
  "label"
);
We("select").parts("field", "icon");
We("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
We("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
We("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
);
We("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
We("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
We("tag").parts(
  "container",
  "label",
  "closeButton"
);
We("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
We("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
function $T(e) {
  return _0.toArray(e).filter(
    (t) => lx(t)
  );
}
function RT(e, t) {
  return Array.isArray(e) ? e.map((r) => r === null ? null : t(r)) : V_(e) ? Object.keys(e).reduce((r, n) => (r[n] = t(e[n]), r), {}) : e != null ? t(e) : null;
}
var Dx = (e) => /* @__PURE__ */ S.jsx(
  Ex.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
Dx.displayName = "StackItem";
function MT(e) {
  const { spacing: t, direction: r } = e, n = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": RT(
      r,
      (i) => n[i]
    )
  };
}
var Fx = wx((e, t) => {
  const {
    isInline: r,
    direction: n,
    align: i,
    justify: a,
    spacing: o = "0.5rem",
    wrap: s,
    children: u,
    divider: l,
    className: c,
    shouldWrapChildren: f,
    ...d
  } = e, h = r ? "row" : n ?? "column", p = Vn(
    () => MT({ spacing: o, direction: h }),
    [o, h]
  ), v = !!l, m = !f && !v, x = Vn(() => {
    const g = $T(u);
    return m ? g : g.map((E, b) => {
      const w = typeof E.key < "u" ? E.key : b, _ = b + 1 === g.length, O = f ? /* @__PURE__ */ S.jsx(Dx, { children: E }, w) : E;
      if (!v)
        return O;
      const T = l_(
        l,
        {
          __css: p
        }
      ), C = _ ? null : T;
      return /* @__PURE__ */ S.jsxs(c_, { children: [
        O,
        C
      ] }, w);
    });
  }, [
    l,
    p,
    v,
    m,
    f,
    u
  ]), y = G_("chakra-stack", c);
  return /* @__PURE__ */ S.jsx(
    Ex.div,
    {
      ref: t,
      display: "flex",
      alignItems: i,
      justifyContent: a,
      flexDirection: h,
      flexWrap: s,
      gap: v ? void 0 : o,
      className: y,
      ...d,
      children: x
    }
  );
});
Fx.displayName = "Stack";
var Ix = wx((e, t) => /* @__PURE__ */ S.jsx(Fx, { align: "center", ...e, direction: "row", ref: t }));
Ix.displayName = "HStack";
function fd(e, t) {
  const r = Me(() => {
    if (typeof window > "u")
      return t;
    try {
      const s = window.localStorage.getItem(e);
      return s ? BT(s) : t;
    } catch (s) {
      return console.warn(`Error reading localStorage key “${e}”:`, s), t;
    }
  }, [t, e]), [n, i] = Oe(r), a = O0((s) => {
    typeof window > "u" && console.warn(`Tried setting localStorage key “${e}” even though environment is not a client`);
    try {
      const u = s instanceof Function ? s(n) : s;
      window.localStorage.setItem(e, JSON.stringify(u)), i(u), window.dispatchEvent(new Event("local-storage"));
    } catch (u) {
      console.warn(`Error setting localStorage key “${e}”:`, u);
    }
  });
  He(() => {
    i(r());
  }, []);
  const o = Me((s) => {
    s != null && s.key && s.key !== e || i(r());
  }, [e, r]);
  return Gn("storage", o), Gn("local-storage", o), [n, a];
}
function BT(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
function kx(e, t) {
  const r = Me(() => {
    if (typeof window > "u")
      return t;
    try {
      const s = window.sessionStorage.getItem(e);
      return s ? jT(s) : t;
    } catch (s) {
      return console.warn(`Error reading sessionStorage key “${e}”:`, s), t;
    }
  }, [t, e]), [n, i] = Oe(r), a = O0((s) => {
    typeof window > "u" && console.warn(`Tried setting sessionStorage key “${e}” even though environment is not a client`);
    try {
      const u = s instanceof Function ? s(n) : s;
      window.sessionStorage.setItem(e, JSON.stringify(u)), i(u), window.dispatchEvent(new Event("session-storage"));
    } catch (u) {
      console.warn(`Error setting sessionStorage key “${e}”:`, u);
    }
  });
  He(() => {
    i(r());
  }, []);
  const o = Me((s) => {
    s != null && s.key && s.key !== e || i(r());
  }, [e, r]);
  return Gn("storage", o), Gn("session-storage", o), [n, a];
}
function jT(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
const LT = (e) => {
  var a, o;
  const t = sn(xx);
  if (t === void 0)
    throw new Error("useFeatureIsOn must be used within a Feature Provider");
  const r = ll(), { features: n } = t, i = (o = (a = n == null ? void 0 : n.featureList) == null ? void 0 : a[r ?? "device_protection"]) == null ? void 0 : o.findIndex(
    (s) => (s == null ? void 0 : s.key) === e
  );
  return i ? i > -1 : !1;
}, Nx = Rr({
  isOpen: !1,
  setIsOpen: () => {
  },
  isNotifsOpen: !1,
  setIsNotifsOpen: () => {
  },
  config: void 0
}), UT = ({
  children: e,
  config: t
}) => {
  const [r, n] = Oe(!1), [i, a] = Oe(!1);
  return /* @__PURE__ */ S.jsx(
    Nx.Provider,
    {
      value: {
        isOpen: r,
        setIsOpen: n,
        isNotifsOpen: i,
        setIsNotifsOpen: a,
        config: t
      },
      children: e
    }
  );
}, Px = () => {
  const e = sn(Nx);
  if (e === void 0)
    throw new Error("useHeader must be used within a HeaderProvider");
  const { isOpen: t, setIsOpen: r, isNotifsOpen: n, setIsNotifsOpen: i, config: a } = e;
  return {
    headerIsOpen: t,
    updateHeaderIsOpen: r,
    notificationsIsOpen: n,
    updateNoficationsIsOpen: i,
    config: a
  };
}, HT = (e, t) => {
  var o, s, u;
  const r = sn(xx);
  if (r === void 0)
    throw new Error("useDisabledFeature must be used within a Feature Provider");
  const n = ll(), { features: i } = r, a = (s = (o = i == null ? void 0 : i.featureList) == null ? void 0 : o[n ?? "device_protection"]) == null ? void 0 : s.find(
    (l) => (l == null ? void 0 : l.key) === e
  );
  return (u = a == null ? void 0 : a.disabledFeatures) == null ? void 0 : u.includes(t);
};
function $x(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: WT } = Object.prototype, { getPrototypeOf: F0 } = Object, bl = ((e) => (t) => {
  const r = WT.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Br = (e) => (e = e.toLowerCase(), (t) => bl(t) === e), El = (e) => (t) => typeof t === e, { isArray: ka } = Array, ko = El("undefined");
function zT(e) {
  return e !== null && !ko(e) && e.constructor !== null && !ko(e.constructor) && sr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Rx = Br("ArrayBuffer");
function qT(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Rx(e.buffer), t;
}
const YT = El("string"), sr = El("function"), Mx = El("number"), wl = (e) => e !== null && typeof e == "object", VT = (e) => e === !0 || e === !1, tu = (e) => {
  if (bl(e) !== "object")
    return !1;
  const t = F0(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, GT = Br("Date"), KT = Br("File"), QT = Br("Blob"), XT = Br("FileList"), JT = (e) => wl(e) && sr(e.pipe), ZT = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || sr(e.append) && ((t = bl(e)) === "formdata" || // detect form-data instance
  t === "object" && sr(e.toString) && e.toString() === "[object FormData]"));
}, eA = Br("URLSearchParams"), [tA, rA, nA, iA] = ["ReadableStream", "Request", "Response", "Headers"].map(Br), aA = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Zo(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, i;
  if (typeof e != "object" && (e = [e]), ka(e))
    for (n = 0, i = e.length; n < i; n++)
      t.call(null, e[n], n, e);
  else {
    const a = r ? Object.getOwnPropertyNames(e) : Object.keys(e), o = a.length;
    let s;
    for (n = 0; n < o; n++)
      s = a[n], t.call(null, e[s], s, e);
  }
}
function Bx(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, i;
  for (; n-- > 0; )
    if (i = r[n], t === i.toLowerCase())
      return i;
  return null;
}
const wi = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), jx = (e) => !ko(e) && e !== wi;
function dd() {
  const { caseless: e } = jx(this) && this || {}, t = {}, r = (n, i) => {
    const a = e && Bx(t, i) || i;
    tu(t[a]) && tu(n) ? t[a] = dd(t[a], n) : tu(n) ? t[a] = dd({}, n) : ka(n) ? t[a] = n.slice() : t[a] = n;
  };
  for (let n = 0, i = arguments.length; n < i; n++)
    arguments[n] && Zo(arguments[n], r);
  return t;
}
const oA = (e, t, r, { allOwnKeys: n } = {}) => (Zo(t, (i, a) => {
  r && sr(i) ? e[a] = $x(i, r) : e[a] = i;
}, { allOwnKeys: n }), e), sA = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), uA = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, lA = (e, t, r, n) => {
  let i, a, o;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0; )
      o = i[a], (!n || n(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
    e = r !== !1 && F0(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, cA = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, fA = (e) => {
  if (!e)
    return null;
  if (ka(e))
    return e;
  let t = e.length;
  if (!Mx(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, dA = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && F0(Uint8Array)), hA = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = n.next()) && !i.done; ) {
    const a = i.value;
    t.call(e, a[0], a[1]);
  }
}, pA = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, vA = Br("HTMLFormElement"), mA = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, i) {
    return n.toUpperCase() + i;
  }
), Up = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), yA = Br("RegExp"), Lx = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Zo(r, (i, a) => {
    let o;
    (o = t(i, a, e)) !== !1 && (n[a] = o || i);
  }), Object.defineProperties(e, n);
}, gA = (e) => {
  Lx(e, (t, r) => {
    if (sr(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (sr(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, xA = (e, t) => {
  const r = {}, n = (i) => {
    i.forEach((a) => {
      r[a] = !0;
    });
  };
  return ka(e) ? n(e) : n(String(e).split(t)), r;
}, bA = () => {
}, EA = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, $c = "abcdefghijklmnopqrstuvwxyz", Hp = "0123456789", Ux = {
  DIGIT: Hp,
  ALPHA: $c,
  ALPHA_DIGIT: $c + $c.toUpperCase() + Hp
}, wA = (e = 16, t = Ux.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function SA(e) {
  return !!(e && sr(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const _A = (e) => {
  const t = new Array(10), r = (n, i) => {
    if (wl(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[i] = n;
        const a = ka(n) ? [] : {};
        return Zo(n, (o, s) => {
          const u = r(o, i + 1);
          !ko(u) && (a[s] = u);
        }), t[i] = void 0, a;
      }
    }
    return n;
  };
  return r(e, 0);
}, TA = Br("AsyncFunction"), AA = (e) => e && (wl(e) || sr(e)) && sr(e.then) && sr(e.catch), Hx = ((e, t) => e ? setImmediate : t ? ((r, n) => (wi.addEventListener("message", ({ source: i, data: a }) => {
  i === wi && a === r && n.length && n.shift()();
}, !1), (i) => {
  n.push(i), wi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  sr(wi.postMessage)
), CA = typeof queueMicrotask < "u" ? queueMicrotask.bind(wi) : typeof process < "u" && process.nextTick || Hx, U = {
  isArray: ka,
  isArrayBuffer: Rx,
  isBuffer: zT,
  isFormData: ZT,
  isArrayBufferView: qT,
  isString: YT,
  isNumber: Mx,
  isBoolean: VT,
  isObject: wl,
  isPlainObject: tu,
  isReadableStream: tA,
  isRequest: rA,
  isResponse: nA,
  isHeaders: iA,
  isUndefined: ko,
  isDate: GT,
  isFile: KT,
  isBlob: QT,
  isRegExp: yA,
  isFunction: sr,
  isStream: JT,
  isURLSearchParams: eA,
  isTypedArray: dA,
  isFileList: XT,
  forEach: Zo,
  merge: dd,
  extend: oA,
  trim: aA,
  stripBOM: sA,
  inherits: uA,
  toFlatObject: lA,
  kindOf: bl,
  kindOfTest: Br,
  endsWith: cA,
  toArray: fA,
  forEachEntry: hA,
  matchAll: pA,
  isHTMLForm: vA,
  hasOwnProperty: Up,
  hasOwnProp: Up,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Lx,
  freezeMethods: gA,
  toObjectSet: xA,
  toCamelCase: mA,
  noop: bA,
  toFiniteNumber: EA,
  findKey: Bx,
  global: wi,
  isContextDefined: jx,
  ALPHABET: Ux,
  generateString: wA,
  isSpecCompliantForm: SA,
  toJSONObject: _A,
  isAsyncFn: TA,
  isThenable: AA,
  setImmediate: Hx,
  asap: CA
};
function Se(e, t, r, n, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), i && (this.response = i);
}
U.inherits(Se, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: U.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Wx = Se.prototype, zx = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  zx[e] = { value: e };
});
Object.defineProperties(Se, zx);
Object.defineProperty(Wx, "isAxiosError", { value: !0 });
Se.from = (e, t, r, n, i, a) => {
  const o = Object.create(Wx);
  return U.toFlatObject(e, o, function(u) {
    return u !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Se.call(o, e.message, t, r, n, i), o.cause = e, o.name = e.name, a && Object.assign(o, a), o;
};
const OA = null;
function hd(e) {
  return U.isPlainObject(e) || U.isArray(e);
}
function qx(e) {
  return U.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Wp(e, t, r) {
  return e ? e.concat(t).map(function(i, a) {
    return i = qx(i), !r && a ? "[" + i + "]" : i;
  }).join(r ? "." : "") : t;
}
function DA(e) {
  return U.isArray(e) && !e.some(hd);
}
const FA = U.toFlatObject(U, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Sl(e, t, r) {
  if (!U.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = U.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(v, m) {
    return !U.isUndefined(m[v]);
  });
  const n = r.metaTokens, i = r.visitor || c, a = r.dots, o = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && U.isSpecCompliantForm(t);
  if (!U.isFunction(i))
    throw new TypeError("visitor must be a function");
  function l(p) {
    if (p === null)
      return "";
    if (U.isDate(p))
      return p.toISOString();
    if (!u && U.isBlob(p))
      throw new Se("Blob is not supported. Use a Buffer instead.");
    return U.isArrayBuffer(p) || U.isTypedArray(p) ? u && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, v, m) {
    let x = p;
    if (p && !m && typeof p == "object") {
      if (U.endsWith(v, "{}"))
        v = n ? v : v.slice(0, -2), p = JSON.stringify(p);
      else if (U.isArray(p) && DA(p) || (U.isFileList(p) || U.endsWith(v, "[]")) && (x = U.toArray(p)))
        return v = qx(v), x.forEach(function(g, E) {
          !(U.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Wp([v], E, a) : o === null ? v : v + "[]",
            l(g)
          );
        }), !1;
    }
    return hd(p) ? !0 : (t.append(Wp(m, v, a), l(p)), !1);
  }
  const f = [], d = Object.assign(FA, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: hd
  });
  function h(p, v) {
    if (!U.isUndefined(p)) {
      if (f.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + v.join("."));
      f.push(p), U.forEach(p, function(x, y) {
        (!(U.isUndefined(x) || x === null) && i.call(
          t,
          x,
          U.isString(y) ? y.trim() : y,
          v,
          d
        )) === !0 && h(x, v ? v.concat(y) : [y]);
      }), f.pop();
    }
  }
  if (!U.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function zp(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function I0(e, t) {
  this._pairs = [], e && Sl(e, this, t);
}
const Yx = I0.prototype;
Yx.append = function(t, r) {
  this._pairs.push([t, r]);
};
Yx.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, zp);
  } : zp;
  return this._pairs.map(function(i) {
    return r(i[0]) + "=" + r(i[1]);
  }, "").join("&");
};
function IA(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Vx(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || IA, i = r && r.serialize;
  let a;
  if (i ? a = i(t, r) : a = U.isURLSearchParams(t) ? t.toString() : new I0(t, r).toString(n), a) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class kA {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    U.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const qp = kA, Gx = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, NA = typeof URLSearchParams < "u" ? URLSearchParams : I0, PA = typeof FormData < "u" ? FormData : null, $A = typeof Blob < "u" ? Blob : null, RA = {
  isBrowser: !0,
  classes: {
    URLSearchParams: NA,
    FormData: PA,
    Blob: $A
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, k0 = typeof window < "u" && typeof document < "u", MA = ((e) => k0 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), BA = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), jA = k0 && window.location.href || "http://localhost", LA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: k0,
  hasStandardBrowserEnv: MA,
  hasStandardBrowserWebWorkerEnv: BA,
  origin: jA
}, Symbol.toStringTag, { value: "Module" })), kr = {
  ...LA,
  ...RA
};
function UA(e, t) {
  return Sl(e, new kr.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, i, a) {
      return kr.isNode && U.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function HA(e) {
  return U.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function WA(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const i = r.length;
  let a;
  for (n = 0; n < i; n++)
    a = r[n], t[a] = e[a];
  return t;
}
function Kx(e) {
  function t(r, n, i, a) {
    let o = r[a++];
    if (o === "__proto__")
      return !0;
    const s = Number.isFinite(+o), u = a >= r.length;
    return o = !o && U.isArray(i) ? i.length : o, u ? (U.hasOwnProp(i, o) ? i[o] = [i[o], n] : i[o] = n, !s) : ((!i[o] || !U.isObject(i[o])) && (i[o] = []), t(r, n, i[o], a) && U.isArray(i[o]) && (i[o] = WA(i[o])), !s);
  }
  if (U.isFormData(e) && U.isFunction(e.entries)) {
    const r = {};
    return U.forEachEntry(e, (n, i) => {
      t(HA(n), i, r, 0);
    }), r;
  }
  return null;
}
function zA(e, t, r) {
  if (U.isString(e))
    try {
      return (t || JSON.parse)(e), U.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const N0 = {
  transitional: Gx,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", i = n.indexOf("application/json") > -1, a = U.isObject(t);
    if (a && U.isHTMLForm(t) && (t = new FormData(t)), U.isFormData(t))
      return i ? JSON.stringify(Kx(t)) : t;
    if (U.isArrayBuffer(t) || U.isBuffer(t) || U.isStream(t) || U.isFile(t) || U.isBlob(t) || U.isReadableStream(t))
      return t;
    if (U.isArrayBufferView(t))
      return t.buffer;
    if (U.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return UA(t, this.formSerializer).toString();
      if ((s = U.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return Sl(
          s ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return a || i ? (r.setContentType("application/json", !1), zA(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || N0.transitional, n = r && r.forcedJSONParsing, i = this.responseType === "json";
    if (U.isResponse(t) || U.isReadableStream(t))
      return t;
    if (t && U.isString(t) && (n && !this.responseType || i)) {
      const o = !(r && r.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? Se.from(s, Se.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: kr.classes.FormData,
    Blob: kr.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
U.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  N0.headers[e] = {};
});
const P0 = N0, qA = U.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), YA = (e) => {
  const t = {};
  let r, n, i;
  return e && e.split(`
`).forEach(function(o) {
    i = o.indexOf(":"), r = o.substring(0, i).trim().toLowerCase(), n = o.substring(i + 1).trim(), !(!r || t[r] && qA[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Yp = Symbol("internals");
function Za(e) {
  return e && String(e).trim().toLowerCase();
}
function ru(e) {
  return e === !1 || e == null ? e : U.isArray(e) ? e.map(ru) : String(e);
}
function VA(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const GA = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Rc(e, t, r, n, i) {
  if (U.isFunction(n))
    return n.call(this, t, r);
  if (i && (t = r), !!U.isString(t)) {
    if (U.isString(n))
      return t.indexOf(n) !== -1;
    if (U.isRegExp(n))
      return n.test(t);
  }
}
function KA(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function QA(e, t) {
  const r = U.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(i, a, o) {
        return this[n].call(this, t, i, a, o);
      },
      configurable: !0
    });
  });
}
class _l {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const i = this;
    function a(s, u, l) {
      const c = Za(u);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const f = U.findKey(i, c);
      (!f || i[f] === void 0 || l === !0 || l === void 0 && i[f] !== !1) && (i[f || u] = ru(s));
    }
    const o = (s, u) => U.forEach(s, (l, c) => a(l, c, u));
    if (U.isPlainObject(t) || t instanceof this.constructor)
      o(t, r);
    else if (U.isString(t) && (t = t.trim()) && !GA(t))
      o(YA(t), r);
    else if (U.isHeaders(t))
      for (const [s, u] of t.entries())
        a(u, s, n);
    else
      t != null && a(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Za(t), t) {
      const n = U.findKey(this, t);
      if (n) {
        const i = this[n];
        if (!r)
          return i;
        if (r === !0)
          return VA(i);
        if (U.isFunction(r))
          return r.call(this, i, n);
        if (U.isRegExp(r))
          return r.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Za(t), t) {
      const n = U.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Rc(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let i = !1;
    function a(o) {
      if (o = Za(o), o) {
        const s = U.findKey(n, o);
        s && (!r || Rc(n, n[s], s, r)) && (delete n[s], i = !0);
      }
    }
    return U.isArray(t) ? t.forEach(a) : a(t), i;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, i = !1;
    for (; n--; ) {
      const a = r[n];
      (!t || Rc(this, this[a], a, t, !0)) && (delete this[a], i = !0);
    }
    return i;
  }
  normalize(t) {
    const r = this, n = {};
    return U.forEach(this, (i, a) => {
      const o = U.findKey(n, a);
      if (o) {
        r[o] = ru(i), delete r[a];
        return;
      }
      const s = t ? KA(a) : String(a).trim();
      s !== a && delete r[a], r[s] = ru(i), n[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return U.forEach(this, (n, i) => {
      n != null && n !== !1 && (r[i] = t && U.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((i) => n.set(i)), n;
  }
  static accessor(t) {
    const n = (this[Yp] = this[Yp] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function a(o) {
      const s = Za(o);
      n[s] || (QA(i, o), n[s] = !0);
    }
    return U.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
_l.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
U.reduceDescriptors(_l.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
U.freezeMethods(_l);
const Nr = _l;
function Mc(e, t) {
  const r = this || P0, n = t || r, i = Nr.from(n.headers);
  let a = n.data;
  return U.forEach(e, function(s) {
    a = s.call(r, a, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), a;
}
function Qx(e) {
  return !!(e && e.__CANCEL__);
}
function Na(e, t, r) {
  Se.call(this, e ?? "canceled", Se.ERR_CANCELED, t, r), this.name = "CanceledError";
}
U.inherits(Na, Se, {
  __CANCEL__: !0
});
function Xx(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new Se(
    "Request failed with status code " + r.status,
    [Se.ERR_BAD_REQUEST, Se.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function XA(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function JA(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let i = 0, a = 0, o;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const l = Date.now(), c = n[a];
    o || (o = l), r[i] = u, n[i] = l;
    let f = a, d = 0;
    for (; f !== i; )
      d += r[f++], f = f % e;
    if (i = (i + 1) % e, i === a && (a = (a + 1) % e), l - o < t)
      return;
    const h = c && l - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function ZA(e, t) {
  let r = 0, n = 1e3 / t, i, a;
  const o = (l, c = Date.now()) => {
    r = c, i = null, a && (clearTimeout(a), a = null), e.apply(null, l);
  };
  return [(...l) => {
    const c = Date.now(), f = c - r;
    f >= n ? o(l, c) : (i = l, a || (a = setTimeout(() => {
      a = null, o(i);
    }, n - f)));
  }, () => i && o(i)];
}
const Au = (e, t, r = 3) => {
  let n = 0;
  const i = JA(50, 250);
  return ZA((a) => {
    const o = a.loaded, s = a.lengthComputable ? a.total : void 0, u = o - n, l = i(u), c = o <= s;
    n = o;
    const f = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: u,
      rate: l || void 0,
      estimated: l && s && c ? (s - o) / l : void 0,
      event: a,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Vp = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Gp = (e) => (...t) => U.asap(() => e(...t)), eC = kr.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function i(a) {
      let o = a;
      return t && (r.setAttribute("href", o), o = r.href), r.setAttribute("href", o), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = i(window.location.href), function(o) {
      const s = U.isString(o) ? i(o) : o;
      return s.protocol === n.protocol && s.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
), tC = kr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, i, a) {
      const o = [e + "=" + encodeURIComponent(t)];
      U.isNumber(r) && o.push("expires=" + new Date(r).toGMTString()), U.isString(n) && o.push("path=" + n), U.isString(i) && o.push("domain=" + i), a === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function rC(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function nC(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Jx(e, t) {
  return e && !rC(t) ? nC(e, t) : t;
}
const Kp = (e) => e instanceof Nr ? { ...e } : e;
function Pi(e, t) {
  t = t || {};
  const r = {};
  function n(l, c, f) {
    return U.isPlainObject(l) && U.isPlainObject(c) ? U.merge.call({ caseless: f }, l, c) : U.isPlainObject(c) ? U.merge({}, c) : U.isArray(c) ? c.slice() : c;
  }
  function i(l, c, f) {
    if (U.isUndefined(c)) {
      if (!U.isUndefined(l))
        return n(void 0, l, f);
    } else
      return n(l, c, f);
  }
  function a(l, c) {
    if (!U.isUndefined(c))
      return n(void 0, c);
  }
  function o(l, c) {
    if (U.isUndefined(c)) {
      if (!U.isUndefined(l))
        return n(void 0, l);
    } else
      return n(void 0, c);
  }
  function s(l, c, f) {
    if (f in t)
      return n(l, c);
    if (f in e)
      return n(void 0, l);
  }
  const u = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (l, c) => i(Kp(l), Kp(c), !0)
  };
  return U.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const f = u[c] || i, d = f(e[c], t[c], c);
    U.isUndefined(d) && f !== s || (r[c] = d);
  }), r;
}
const Zx = (e) => {
  const t = Pi({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: i, xsrfCookieName: a, headers: o, auth: s } = t;
  t.headers = o = Nr.from(o), t.url = Vx(Jx(t.baseURL, t.url), e.params, e.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let u;
  if (U.isFormData(r)) {
    if (kr.hasStandardBrowserEnv || kr.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((u = o.getContentType()) !== !1) {
      const [l, ...c] = u ? u.split(";").map((f) => f.trim()).filter(Boolean) : [];
      o.setContentType([l || "multipart/form-data", ...c].join("; "));
    }
  }
  if (kr.hasStandardBrowserEnv && (n && U.isFunction(n) && (n = n(t)), n || n !== !1 && eC(t.url))) {
    const l = i && a && tC.read(a);
    l && o.set(i, l);
  }
  return t;
}, iC = typeof XMLHttpRequest < "u", aC = iC && function(e) {
  return new Promise(function(r, n) {
    const i = Zx(e);
    let a = i.data;
    const o = Nr.from(i.headers).normalize();
    let { responseType: s, onUploadProgress: u, onDownloadProgress: l } = i, c, f, d, h, p;
    function v() {
      h && h(), p && p(), i.cancelToken && i.cancelToken.unsubscribe(c), i.signal && i.signal.removeEventListener("abort", c);
    }
    let m = new XMLHttpRequest();
    m.open(i.method.toUpperCase(), i.url, !0), m.timeout = i.timeout;
    function x() {
      if (!m)
        return;
      const g = Nr.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), b = {
        data: !s || s === "text" || s === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: g,
        config: e,
        request: m
      };
      Xx(function(_) {
        r(_), v();
      }, function(_) {
        n(_), v();
      }, b), m = null;
    }
    "onloadend" in m ? m.onloadend = x : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(x);
    }, m.onabort = function() {
      m && (n(new Se("Request aborted", Se.ECONNABORTED, e, m)), m = null);
    }, m.onerror = function() {
      n(new Se("Network Error", Se.ERR_NETWORK, e, m)), m = null;
    }, m.ontimeout = function() {
      let E = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const b = i.transitional || Gx;
      i.timeoutErrorMessage && (E = i.timeoutErrorMessage), n(new Se(
        E,
        b.clarifyTimeoutError ? Se.ETIMEDOUT : Se.ECONNABORTED,
        e,
        m
      )), m = null;
    }, a === void 0 && o.setContentType(null), "setRequestHeader" in m && U.forEach(o.toJSON(), function(E, b) {
      m.setRequestHeader(b, E);
    }), U.isUndefined(i.withCredentials) || (m.withCredentials = !!i.withCredentials), s && s !== "json" && (m.responseType = i.responseType), l && ([d, p] = Au(l, !0), m.addEventListener("progress", d)), u && m.upload && ([f, h] = Au(u), m.upload.addEventListener("progress", f), m.upload.addEventListener("loadend", h)), (i.cancelToken || i.signal) && (c = (g) => {
      m && (n(!g || g.type ? new Na(null, e, m) : g), m.abort(), m = null);
    }, i.cancelToken && i.cancelToken.subscribe(c), i.signal && (i.signal.aborted ? c() : i.signal.addEventListener("abort", c)));
    const y = XA(i.url);
    if (y && kr.protocols.indexOf(y) === -1) {
      n(new Se("Unsupported protocol " + y + ":", Se.ERR_BAD_REQUEST, e));
      return;
    }
    m.send(a || null);
  });
}, oC = (e, t) => {
  let r = new AbortController(), n;
  const i = function(u) {
    if (!n) {
      n = !0, o();
      const l = u instanceof Error ? u : this.reason;
      r.abort(l instanceof Se ? l : new Na(l instanceof Error ? l.message : l));
    }
  };
  let a = t && setTimeout(() => {
    i(new Se(`timeout ${t} of ms exceeded`, Se.ETIMEDOUT));
  }, t);
  const o = () => {
    e && (a && clearTimeout(a), a = null, e.forEach((u) => {
      u && (u.removeEventListener ? u.removeEventListener("abort", i) : u.unsubscribe(i));
    }), e = null);
  };
  e.forEach((u) => u && u.addEventListener && u.addEventListener("abort", i));
  const { signal: s } = r;
  return s.unsubscribe = o, [s, () => {
    a && clearTimeout(a), a = null;
  }];
}, sC = oC, uC = function* (e, t) {
  let r = e.byteLength;
  if (!t || r < t) {
    yield e;
    return;
  }
  let n = 0, i;
  for (; n < r; )
    i = n + t, yield e.slice(n, i), n = i;
}, lC = async function* (e, t, r) {
  for await (const n of e)
    yield* uC(ArrayBuffer.isView(n) ? n : await r(String(n)), t);
}, Qp = (e, t, r, n, i) => {
  const a = lC(e, t, i);
  let o = 0, s, u = (l) => {
    s || (s = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: f } = await a.next();
        if (c) {
          u(), l.close();
          return;
        }
        let d = f.byteLength;
        if (r) {
          let h = o += d;
          r(h);
        }
        l.enqueue(new Uint8Array(f));
      } catch (c) {
        throw u(c), c;
      }
    },
    cancel(l) {
      return u(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Tl = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", eb = Tl && typeof ReadableStream == "function", pd = Tl && (typeof TextEncoder == "function" ? ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), tb = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, cC = eb && tb(() => {
  let e = !1;
  const t = new Request(kr.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Xp = 64 * 1024, vd = eb && tb(() => U.isReadableStream(new Response("").body)), Cu = {
  stream: vd && ((e) => e.body)
};
Tl && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Cu[t] && (Cu[t] = U.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new Se(`Response type '${t}' is not supported`, Se.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const fC = async (e) => {
  if (e == null)
    return 0;
  if (U.isBlob(e))
    return e.size;
  if (U.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (U.isArrayBufferView(e) || U.isArrayBuffer(e))
    return e.byteLength;
  if (U.isURLSearchParams(e) && (e = e + ""), U.isString(e))
    return (await pd(e)).byteLength;
}, dC = async (e, t) => {
  const r = U.toFiniteNumber(e.getContentLength());
  return r ?? fC(t);
}, hC = Tl && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: i,
    cancelToken: a,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: u,
    responseType: l,
    headers: c,
    withCredentials: f = "same-origin",
    fetchOptions: d
  } = Zx(e);
  l = l ? (l + "").toLowerCase() : "text";
  let [h, p] = i || a || o ? sC([i, a], o) : [], v, m;
  const x = () => {
    !v && setTimeout(() => {
      h && h.unsubscribe();
    }), v = !0;
  };
  let y;
  try {
    if (u && cC && r !== "get" && r !== "head" && (y = await dC(c, n)) !== 0) {
      let w = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), _;
      if (U.isFormData(n) && (_ = w.headers.get("content-type")) && c.setContentType(_), w.body) {
        const [A, O] = Vp(
          y,
          Au(Gp(u))
        );
        n = Qp(w.body, Xp, A, O, pd);
      }
    }
    U.isString(f) || (f = f ? "include" : "omit"), m = new Request(t, {
      ...d,
      signal: h,
      method: r.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: f
    });
    let g = await fetch(m);
    const E = vd && (l === "stream" || l === "response");
    if (vd && (s || E)) {
      const w = {};
      ["status", "statusText", "headers"].forEach((T) => {
        w[T] = g[T];
      });
      const _ = U.toFiniteNumber(g.headers.get("content-length")), [A, O] = s && Vp(
        _,
        Au(Gp(s), !0)
      ) || [];
      g = new Response(
        Qp(g.body, Xp, A, () => {
          O && O(), E && x();
        }, pd),
        w
      );
    }
    l = l || "text";
    let b = await Cu[U.findKey(Cu, l) || "text"](g, e);
    return !E && x(), p && p(), await new Promise((w, _) => {
      Xx(w, _, {
        data: b,
        headers: Nr.from(g.headers),
        status: g.status,
        statusText: g.statusText,
        config: e,
        request: m
      });
    });
  } catch (g) {
    throw x(), g && g.name === "TypeError" && /fetch/i.test(g.message) ? Object.assign(
      new Se("Network Error", Se.ERR_NETWORK, e, m),
      {
        cause: g.cause || g
      }
    ) : Se.from(g, g && g.code, e, m);
  }
}), md = {
  http: OA,
  xhr: aC,
  fetch: hC
};
U.forEach(md, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Jp = (e) => `- ${e}`, pC = (e) => U.isFunction(e) || e === null || e === !1, rb = {
  getAdapter: (e) => {
    e = U.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const i = {};
    for (let a = 0; a < t; a++) {
      r = e[a];
      let o;
      if (n = r, !pC(r) && (n = md[(o = String(r)).toLowerCase()], n === void 0))
        throw new Se(`Unknown adapter '${o}'`);
      if (n)
        break;
      i[o || "#" + a] = n;
    }
    if (!n) {
      const a = Object.entries(i).map(
        ([s, u]) => `adapter ${s} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? a.length > 1 ? `since :
` + a.map(Jp).join(`
`) : " " + Jp(a[0]) : "as no adapter specified";
      throw new Se(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: md
};
function Bc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Na(null, e);
}
function Zp(e) {
  return Bc(e), e.headers = Nr.from(e.headers), e.data = Mc.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), rb.getAdapter(e.adapter || P0.adapter)(e).then(function(n) {
    return Bc(e), n.data = Mc.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Nr.from(n.headers), n;
  }, function(n) {
    return Qx(n) || (Bc(e), n && n.response && (n.response.data = Mc.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Nr.from(n.response.headers))), Promise.reject(n);
  });
}
const nb = "1.7.4", $0 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  $0[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ev = {};
$0.transitional = function(t, r, n) {
  function i(a, o) {
    return "[Axios v" + nb + "] Transitional option '" + a + "'" + o + (n ? ". " + n : "");
  }
  return (a, o, s) => {
    if (t === !1)
      throw new Se(
        i(o, " has been removed" + (r ? " in " + r : "")),
        Se.ERR_DEPRECATED
      );
    return r && !ev[o] && (ev[o] = !0, console.warn(
      i(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, o, s) : !0;
  };
};
function vC(e, t, r) {
  if (typeof e != "object")
    throw new Se("options must be an object", Se.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let i = n.length;
  for (; i-- > 0; ) {
    const a = n[i], o = t[a];
    if (o) {
      const s = e[a], u = s === void 0 || o(s, a, e);
      if (u !== !0)
        throw new Se("option " + a + " must be " + u, Se.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Se("Unknown option " + a, Se.ERR_BAD_OPTION);
  }
}
const yd = {
  assertOptions: vC,
  validators: $0
}, In = yd.validators;
class Ou {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new qp(),
      response: new qp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let i;
        Error.captureStackTrace ? Error.captureStackTrace(i = {}) : i = new Error();
        const a = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Pi(this.defaults, r);
    const { transitional: n, paramsSerializer: i, headers: a } = r;
    n !== void 0 && yd.assertOptions(n, {
      silentJSONParsing: In.transitional(In.boolean),
      forcedJSONParsing: In.transitional(In.boolean),
      clarifyTimeoutError: In.transitional(In.boolean)
    }, !1), i != null && (U.isFunction(i) ? r.paramsSerializer = {
      serialize: i
    } : yd.assertOptions(i, {
      encode: In.function,
      serialize: In.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = a && U.merge(
      a.common,
      a[r.method]
    );
    a && U.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete a[p];
      }
    ), r.headers = Nr.concat(o, a);
    const s = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(r) === !1 || (u = u && v.synchronous, s.unshift(v.fulfilled, v.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(v) {
      l.push(v.fulfilled, v.rejected);
    });
    let c, f = 0, d;
    if (!u) {
      const p = [Zp.bind(this), void 0];
      for (p.unshift.apply(p, s), p.push.apply(p, l), d = p.length, c = Promise.resolve(r); f < d; )
        c = c.then(p[f++], p[f++]);
      return c;
    }
    d = s.length;
    let h = r;
    for (f = 0; f < d; ) {
      const p = s[f++], v = s[f++];
      try {
        h = p(h);
      } catch (m) {
        v.call(this, m);
        break;
      }
    }
    try {
      c = Zp.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (f = 0, d = l.length; f < d; )
      c = c.then(l[f++], l[f++]);
    return c;
  }
  getUri(t) {
    t = Pi(this.defaults, t);
    const r = Jx(t.baseURL, t.url);
    return Vx(r, t.params, t.paramsSerializer);
  }
}
U.forEach(["delete", "get", "head", "options"], function(t) {
  Ou.prototype[t] = function(r, n) {
    return this.request(Pi(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
U.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(a, o, s) {
      return this.request(Pi(s || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  Ou.prototype[t] = r(), Ou.prototype[t + "Form"] = r(!0);
});
const nu = Ou;
class R0 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const n = this;
    this.promise.then((i) => {
      if (!n._listeners)
        return;
      let a = n._listeners.length;
      for (; a-- > 0; )
        n._listeners[a](i);
      n._listeners = null;
    }), this.promise.then = (i) => {
      let a;
      const o = new Promise((s) => {
        n.subscribe(s), a = s;
      }).then(i);
      return o.cancel = function() {
        n.unsubscribe(a);
      }, o;
    }, t(function(a, o, s) {
      n.reason || (n.reason = new Na(a, o, s), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new R0(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
const mC = R0;
function yC(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function gC(e) {
  return U.isObject(e) && e.isAxiosError === !0;
}
const gd = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(gd).forEach(([e, t]) => {
  gd[t] = e;
});
const xC = gd;
function ib(e) {
  const t = new nu(e), r = $x(nu.prototype.request, t);
  return U.extend(r, nu.prototype, t, { allOwnKeys: !0 }), U.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(i) {
    return ib(Pi(e, i));
  }, r;
}
const St = ib(P0);
St.Axios = nu;
St.CanceledError = Na;
St.CancelToken = mC;
St.isCancel = Qx;
St.VERSION = nb;
St.toFormData = Sl;
St.AxiosError = Se;
St.Cancel = St.CanceledError;
St.all = function(t) {
  return Promise.all(t);
};
St.spread = yC;
St.isAxiosError = gC;
St.mergeConfig = Pi;
St.AxiosHeaders = Nr;
St.formToJSON = (e) => Kx(U.isHTMLForm(e) ? new FormData(e) : e);
St.getAdapter = rb.getAdapter;
St.HttpStatusCode = xC;
St.default = St;
const wt = St, ab = Rr({
  refetch: async () => {
  },
  notifications: [],
  setNotifications: () => {
  },
  updateClients: () => {
  },
  isNotificationsLoading: !1,
  promptCount: 0
}), ob = Xe(), bC = Ir(ob), EC = (e) => {
  const t = yx();
  return {
    token: t.token,
    "x-api-key": e,
    "x-asurion-client": ob,
    "x-asurion-cc": bC.code,
    authorization: t.authorization,
    id: t.userId
  };
}, wC = async (e, t, r, n, i) => {
  const a = EC(i == null ? void 0 : i.apiKey);
  return (await wt.get(
    `${i == null ? void 0 : i.apiBaseUrl}/online/notifications?cid=${e}&aid=${t}&agreementId=${r}`,
    {
      headers: {
        ...a,
        data: n
      }
    }
  )).data.body;
}, SC = ({
  children: e,
  apiKey: t,
  apiBaseUrl: r
}) => {
  const [n, i] = Oe([]), [a, o] = Oe(""), [s, u] = Oe(""), [l, c] = Oe(""), [f, d] = Oe(""), [h, p] = Oe(0), [v] = kx("data", ""), {
    data: m,
    isLoading: x,
    refetch: y
  } = ol({
    queryKey: ["notificationsData", a, s, l],
    queryFn: () => a === "" || s === "" || l === "" || f === "" ? [] : wC(
      a,
      s,
      l,
      f,
      { apiKey: t, apiBaseUrl: r }
    ).then((b) => b).catch(() => [])
  }), g = Me(
    (b) => {
      b != null && b.cid && o(b == null ? void 0 : b.cid), b != null && b.aid && u(b == null ? void 0 : b.aid), b != null && b.agreementId && c(b == null ? void 0 : b.agreementId);
    },
    []
  ), E = async (b, w, _) => {
    if (a === "" || s === "" || l === "") {
      g({ cid: b, aid: w, agreementId: _ });
      return;
    } else {
      y();
      return;
    }
  };
  return He(() => {
    v && v !== "" && d(v);
  }, [v]), He(() => {
    if (m) {
      i(m);
      let b = 0;
      Array.isArray(m) && m.length > 0 && (b = m == null ? void 0 : m.reduce((w, _) => (_ == null ? void 0 : _.IsResolved) === "N" ? w + 1 : w, 0)), p(b);
    }
  }, [m]), /* @__PURE__ */ S.jsx(
    ab.Provider,
    {
      value: {
        refetch: E,
        promptCount: h,
        notifications: n,
        setNotifications: i,
        updateClients: g,
        isNotificationsLoading: x
      },
      children: e
    }
  );
}, _C = () => {
  const e = sn(ab);
  if (e === void 0)
    throw new Error("useNotifications must be used within a Notifications Provider");
  const {
    notifications: t,
    setNotifications: r,
    isNotificationsLoading: n,
    updateClients: i,
    refetch: a,
    promptCount: o
  } = e;
  return {
    notifications: t,
    updateNotifications: r,
    isNotificationsLoading: n,
    updateClients: i,
    fetchNotifications: a,
    promptCount: o
  };
}, M0 = (e, t) => {
  const r = Me(() => {
    if (typeof window > "u")
      return t;
    try {
      const s = window.sessionStorage.getItem(e);
      return s ? D_(s) : t;
    } catch (s) {
      return console.warn(`Error reading sessionStorage key “${e}”:`, s), t;
    }
  }, [t, e]), [n, i] = Oe(r), a = O0((s) => {
    typeof window > "u" && console.warn(
      `Tried setting sessionStorage key “${e}” even though environment is not a client`
    );
    try {
      const u = s instanceof Function ? s(n) : s;
      window.sessionStorage.setItem(e, JSON.stringify(u)), i(u), window.dispatchEvent(new Event("session-storage"));
    } catch (u) {
      console.warn(`Error setting sessionStorage key “${e}”:`, u);
    }
  });
  He(() => {
    i(r());
  }, []);
  const o = Me(
    (s) => {
      s != null && s.key && s.key !== e || i(r());
    },
    [e, r]
  );
  return Gn("storage", o), Gn("session-storage", o), [n, a];
};
function TC() {
}
var AC = TC;
const B0 = /* @__PURE__ */ Nt(AC), CC = B0;
function sb(e, t) {
  const r = OC(t, () => {
  }), n = [], i = Object.keys(t), a = Object.values(t);
  return Fe.Children.forEach(e, (o) => {
    if (!Fe.isValidElement(o)) {
      n.push(o);
      return;
    }
    const s = a.findIndex((l) => o.type === l);
    if (s === -1) {
      n.push(o);
      return;
    }
    const u = i[s];
    if (r[u]) {
      CC(
        !0,
        `Found duplicate "${String(u)}" slot. Only the first will be rendered.`
      );
      return;
    }
    r[u] = o;
  }), [r, n];
}
function OC(e, t) {
  return Object.keys(e).reduce((r, n) => (r[n] = t(e[n]), r), {});
}
const DC = () => /* @__PURE__ */ S.jsx(Ce, { h: "full", id: "myasurion-portal-suspense", children: /* @__PURE__ */ S.jsxs(
  T0,
  {
    h: "100vh",
    w: "full",
    justifyContent: "center",
    alignItems: "center",
    px: 4,
    textAlign: "center",
    children: [
      /* @__PURE__ */ S.jsx(
        XE,
        {
          top: 0,
          signOutProps: { styleProps: { margin: "0 auto" } },
          zIndex: "999999",
          account: { profileId: "", userId: "" }
        }
      ),
      /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        /* @__PURE__ */ S.jsx(Ct, { children: "Please wait..." }),
        /* @__PURE__ */ S.jsx(Io, { my: 2 })
      ] })
    ]
  }
) }), FC = () => {
  const { data: e } = Jt(), { theme: t } = e, { colors: r } = t, { bannerGradient: n } = r, i = {
    background: n
  };
  return /* @__PURE__ */ S.jsx(Ce, { h: "full", id: "myasurion-portal-suspense", children: /* @__PURE__ */ S.jsxs(
    T0,
    {
      h: "100vh",
      w: "full",
      justifyContent: "center",
      alignItems: "center",
      px: 4,
      textAlign: "center",
      children: [
        /* @__PURE__ */ S.jsx(
          XE,
          {
            top: 0,
            signOutProps: { styleProps: { margin: "0 auto" } },
            zIndex: "999999",
            account: { profileId: "", userId: "" }
          }
        ),
        /* @__PURE__ */ S.jsxs("div", { className: "waveLoader", children: [
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i }),
          /* @__PURE__ */ S.jsx("div", { className: "wave", style: i })
        ] })
      ]
    }
  ) });
}, ub = Rr({
  chatConfig: {
    appSyncGraphQL: {
      endpoint: "",
      region: "",
      authType: ""
    },
    amplifyConfig: {
      cognitoIdentityPoolId: "",
      cognitoRegion: "",
      cognitoUserPoolId: "",
      cognitoUserPoolWebClientId: ""
    },
    chat: {
      baseEndpoint: "",
      apiKey: "",
      environment: "",
      clientName: "",
      program: "",
      productName: ""
    },
    contentful: {
      space: "",
      token: "",
      env: ""
    }
  },
  firebaseConfig: null,
  baseApiConfig: {
    baseEndpoint: "",
    apiKey: "",
    hmacKey: ""
  }
}), IC = ({ config: e, baseApiConfig: t, children: r }) => {
  const n = H_() || Xe(), { data: i, refetch: a } = ol({
    queryKey: ["chatConfigData"],
    queryFn: () => {
      var o;
      return F_(e, `chat_config_${n}_${(o = e == null ? void 0 : e.env) == null ? void 0 : o.toLowerCase()}`).then((s) => s ? JSON.parse(s) : null).catch((s) => (console.error("Failed to fetch config ", s), null));
    },
    enabled: !1
  });
  return He(() => {
    e && a();
  }, [e]), /* @__PURE__ */ S.jsx(
    ub.Provider,
    {
      value: {
        chatConfig: i,
        firebaseConfig: e,
        baseApiConfig: t
      },
      children: r
    }
  );
};
var kC = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.wnd, n = r === void 0 ? window : r;
  (function(i, a, o, s, u, l, c, f) {
    if (o in i) {
      i.console && i.console.log && i.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
      return;
    }
    c = i[o] = function(d, h, p) {
      c.q ? c.q.push([d, h, p]) : c._api(d, h, p);
    }, c.q = [], l = a.createElement(s), l.async = 1, l.crossOrigin = "anonymous", l.src = "https://" + _fs_script, f = a.getElementsByTagName(s)[0], f.parentNode.insertBefore(l, f), c.identify = function(d, h, p) {
      c(u, {
        uid: d
      }, p), h && c(u, h, p);
    }, c.setUserVars = function(d, h) {
      c(u, d, h);
    }, c.event = function(d, h, p) {
      c("event", {
        n: d,
        p: h
      }, p);
    }, c.anonymize = function() {
      c.identify(!1);
    }, c.shutdown = function() {
      c("rec", !1);
    }, c.restart = function() {
      c("rec", !0);
    }, c.log = function(d, h) {
      c("log", [d, h]);
    }, c.consent = function(d) {
      c("consent", !arguments.length || d);
    }, c.identifyAccount = function(d, h) {
      l = "account", h = h || {}, h.acctId = d, c(l, h);
    }, c.clearUserCookie = function() {
    }, c.setVars = function(d, h) {
      c("setVars", [d, h]);
    }, c._w = {}, f = "XMLHttpRequest", c._w[f] = i[f], f = "fetch", c._w[f] = i[f], i[f] && (i[f] = function() {
      return c._w[f].apply(this, arguments);
    }), c._v = "1.3.0";
  })(n, n.document, n._fs_namespace, "script", "user");
}, NC = function(t) {
  return t === "window" ? "document" : "".concat(t, ".document");
}, PC = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.shouldInsertScript, n = r === void 0 ? !0 : r, i = t.globalVar, a = i === void 0 ? "window" : i, o = t.apiVersion, s = o === void 0 ? "1.3.0" : o;
  return `(function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];`.concat(n ? `
    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);` : "", `
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.anonymize=function(){g.identify(!!0)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.log = function(a,b){g("log",[a,b])};
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
    g.setVars=function(n, p){g('setVars',[n,p]);};
    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
    g._v="`).concat(s, `";
})(`).concat(a, ",").concat(NC(a), ",").concat(a, "['_fs_namespace'],'script','user');");
}, $C = function(t) {
  var r = t.orgId, n = t.namespace, i = n === void 0 ? "FS" : n, a = t.debug, o = a === void 0 ? !1 : a, s = t.host, u = s === void 0 ? "fullstory.com" : s, l = t.script, c = l === void 0 ? "edge.fullstory.com/s/fs.js" : l;
  if (!r)
    throw new Error("FullStory orgId is a required parameter");
  window._fs_debug = o, window._fs_host = u, window._fs_script = c, window._fs_org = r, window._fs_namespace = i, kC();
};
PC();
function tv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function RC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tv(Object(r), !0).forEach(function(n) {
      MC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function MC(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var No = function() {
  return window[window._fs_namespace];
}, BC = function() {
  var t = !!No();
  if (!t)
    throw Error("FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions");
}, jC = function() {
  BC();
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return r.every(function(i) {
    return No()[i];
  });
}, Al = function(t) {
  return function() {
    if (window._fs_dev_mode) {
      var r = "FullStory is in dev mode and is not recording: ".concat(t, " method not executed");
      return console.warn(r), r;
    }
    if (jC(t)) {
      var n;
      return (n = No())[t].apply(n, arguments);
    }
    return console.warn("FS.".concat(t, " not ready")), null;
  };
}, LC = Al("event"), UC = Al("getCurrentSessionURL"), HC = Al("identify"), WC = Al("shutdown"), zC = function(t, r) {
  var n = RC({}, t);
  if (No()) {
    console.warn("The FullStory snippet has already been defined elsewhere (likely in the <head> element)");
    return;
  }
  if (n.recordCrossDomainIFrames && (window._fs_run_in_iframe = !0), n.recordOnlyThisIFrame && (window._fs_is_outer_script = !0), n.cookieDomain && (window._fs_cookie_domain = n.cookieDomain), n.debug === !0 && (n.script ? console.warn("Ignoring `debug = true` because `script` is set") : n.script = "edge.fullstory.com/s/fs-debug.js"), $C(n), r && No()("observe", {
    type: "start",
    callback: r
  }), n.devMode === !0) {
    var i = "FullStory was initialized in devMode and will stop recording";
    LC("FullStory Dev Mode", {
      message_str: i
    }), WC(), window._fs_dev_mode = !0, console.warn(i);
  }
}, qC = function(t, r) {
  return function() {
    if (window._fs_initialized) {
      r && console.warn(r);
      return;
    }
    t.apply(void 0, arguments), window._fs_initialized = !0;
  };
}, rv = qC(zC, "FullStory init has already been called once, additional invocations are ignored"), YC = function() {
  return !!window._fs_initialized;
};
const VC = Rr({
  fullStoryInit: () => {
  },
  isInitialized: () => !1,
  identify: () => {
  },
  getCurrentSessionURL: () => ""
}), GC = ({ children: e }) => {
  const [t] = Jo({
    profileId: "",
    userId: ""
  }), { enrolledMdn: r, email: n, userId: i } = t, { data: a } = Jt(), { fullstory: o } = a, s = (f, d, h) => {
    rv({
      orgId: f,
      devMode: d,
      debug: h
    });
  }, u = () => YC(), l = (f, d) => HC(f, d), c = (f) => u() ? UC(f) : "FullStory not yet initialized";
  return He(() => {
    const f = r ?? n ?? i;
    o && f && (rv(
      {
        orgId: o == null ? void 0 : o.orgId,
        devMode: o == null ? void 0 : o.devMode,
        debug: o == null ? void 0 : o.debug
      },
      ({ sessionUrl: d }) => {
        o != null && o.debug && console.log(`Started session: ${d}`);
      }
    ), u() && l(f, {
      timestamp: Date.now().toString(),
      dateUTC: (/* @__PURE__ */ new Date()).toUTCString()
    }));
  }, [t]), /* @__PURE__ */ S.jsx(
    VC.Provider,
    {
      value: { fullStoryInit: s, isInitialized: u, identify: l, getCurrentSessionURL: c },
      children: e
    }
  );
};
var lb = { exports: {} };
function KC(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var jc = { exports: {} }, nv;
function Pe() {
  return nv || (nv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(he, function() {
      var r = r || function(n, i) {
        var a;
        if (typeof window < "u" && window.crypto && (a = window.crypto), typeof self < "u" && self.crypto && (a = self.crypto), typeof globalThis < "u" && globalThis.crypto && (a = globalThis.crypto), !a && typeof window < "u" && window.msCrypto && (a = window.msCrypto), !a && typeof he < "u" && he.crypto && (a = he.crypto), !a && typeof KC == "function")
          try {
            a = I_;
          } catch {
          }
        var o = function() {
          if (a) {
            if (typeof a.getRandomValues == "function")
              try {
                return a.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof a.randomBytes == "function")
              try {
                return a.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || function() {
          function y() {
          }
          return function(g) {
            var E;
            return y.prototype = g, E = new y(), y.prototype = null, E;
          };
        }(), u = {}, l = u.lib = {}, c = l.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(y) {
              var g = s(this);
              return y && g.mixIn(y), (!g.hasOwnProperty("init") || this.init === g.init) && (g.init = function() {
                g.$super.init.apply(this, arguments);
              }), g.init.prototype = g, g.$super = this, g;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var y = this.extend();
              return y.init.apply(y, arguments), y;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(y) {
              for (var g in y)
                y.hasOwnProperty(g) && (this[g] = y[g]);
              y.hasOwnProperty("toString") && (this.toString = y.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), f = l.WordArray = c.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(y, g) {
            y = this.words = y || [], g != i ? this.sigBytes = g : this.sigBytes = y.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(y) {
            return (y || h).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(y) {
            var g = this.words, E = y.words, b = this.sigBytes, w = y.sigBytes;
            if (this.clamp(), b % 4)
              for (var _ = 0; _ < w; _++) {
                var A = E[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
                g[b + _ >>> 2] |= A << 24 - (b + _) % 4 * 8;
              }
            else
              for (var O = 0; O < w; O += 4)
                g[b + O >>> 2] = E[O >>> 2];
            return this.sigBytes += w, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var y = this.words, g = this.sigBytes;
            y[g >>> 2] &= 4294967295 << 32 - g % 4 * 8, y.length = n.ceil(g / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var y = c.clone.call(this);
            return y.words = this.words.slice(0), y;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(y) {
            for (var g = [], E = 0; E < y; E += 4)
              g.push(o());
            return new f.init(g, y);
          }
        }), d = u.enc = {}, h = d.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(y) {
            for (var g = y.words, E = y.sigBytes, b = [], w = 0; w < E; w++) {
              var _ = g[w >>> 2] >>> 24 - w % 4 * 8 & 255;
              b.push((_ >>> 4).toString(16)), b.push((_ & 15).toString(16));
            }
            return b.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(y) {
            for (var g = y.length, E = [], b = 0; b < g; b += 2)
              E[b >>> 3] |= parseInt(y.substr(b, 2), 16) << 24 - b % 8 * 4;
            return new f.init(E, g / 2);
          }
        }, p = d.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(y) {
            for (var g = y.words, E = y.sigBytes, b = [], w = 0; w < E; w++) {
              var _ = g[w >>> 2] >>> 24 - w % 4 * 8 & 255;
              b.push(String.fromCharCode(_));
            }
            return b.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(y) {
            for (var g = y.length, E = [], b = 0; b < g; b++)
              E[b >>> 2] |= (y.charCodeAt(b) & 255) << 24 - b % 4 * 8;
            return new f.init(E, g);
          }
        }, v = d.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(y) {
            try {
              return decodeURIComponent(escape(p.stringify(y)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(y) {
            return p.parse(unescape(encodeURIComponent(y)));
          }
        }, m = l.BufferedBlockAlgorithm = c.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new f.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(y) {
            typeof y == "string" && (y = v.parse(y)), this._data.concat(y), this._nDataBytes += y.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(y) {
            var g, E = this._data, b = E.words, w = E.sigBytes, _ = this.blockSize, A = _ * 4, O = w / A;
            y ? O = n.ceil(O) : O = n.max((O | 0) - this._minBufferSize, 0);
            var T = O * _, C = n.min(T * 4, w);
            if (T) {
              for (var $ = 0; $ < T; $ += _)
                this._doProcessBlock(b, $);
              g = b.splice(0, T), E.sigBytes -= C;
            }
            return new f.init(g, C);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var y = c.clone.call(this);
            return y._data = this._data.clone(), y;
          },
          _minBufferSize: 0
        });
        l.Hasher = m.extend({
          /**
           * Configuration options.
           */
          cfg: c.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(y) {
            this.cfg = this.cfg.extend(y), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            m.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(y) {
            return this._append(y), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(y) {
            y && this._append(y);
            var g = this._doFinalize();
            return g;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(y) {
            return function(g, E) {
              return new y.init(E).finalize(g);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(y) {
            return function(g, E) {
              return new x.HMAC.init(y, E).finalize(g);
            };
          }
        });
        var x = u.algo = {};
        return u;
      }(Math);
      return r;
    });
  }(jc)), jc.exports;
}
var Lc = { exports: {} }, iv;
function Cl() {
  return iv || (iv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.Base, s = a.WordArray, u = i.x64 = {};
        u.Word = o.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(l, c) {
            this.high = l, this.low = c;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), u.WordArray = o.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(l, c) {
            l = this.words = l || [], c != n ? this.sigBytes = c : this.sigBytes = l.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var l = this.words, c = l.length, f = [], d = 0; d < c; d++) {
              var h = l[d];
              f.push(h.high), f.push(h.low);
            }
            return s.create(f, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var l = o.clone.call(this), c = l.words = this.words.slice(0), f = c.length, d = 0; d < f; d++)
              c[d] = c[d].clone();
            return l;
          }
        });
      }(), r;
    });
  }(Lc)), Lc.exports;
}
var Uc = { exports: {} }, av;
function QC() {
  return av || (av = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var n = r, i = n.lib, a = i.WordArray, o = a.init, s = a.init = function(u) {
            if (u instanceof ArrayBuffer && (u = new Uint8Array(u)), (u instanceof Int8Array || typeof Uint8ClampedArray < "u" && u instanceof Uint8ClampedArray || u instanceof Int16Array || u instanceof Uint16Array || u instanceof Int32Array || u instanceof Uint32Array || u instanceof Float32Array || u instanceof Float64Array) && (u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength)), u instanceof Uint8Array) {
              for (var l = u.byteLength, c = [], f = 0; f < l; f++)
                c[f >>> 2] |= u[f] << 24 - f % 4 * 8;
              o.call(this, c, l);
            } else
              o.apply(this, arguments);
          };
          s.prototype = a;
        }
      }(), r.lib.WordArray;
    });
  }(Uc)), Uc.exports;
}
var Hc = { exports: {} }, ov;
function XC() {
  return ov || (ov = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.enc;
        o.Utf16 = o.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(u) {
            for (var l = u.words, c = u.sigBytes, f = [], d = 0; d < c; d += 2) {
              var h = l[d >>> 2] >>> 16 - d % 4 * 8 & 65535;
              f.push(String.fromCharCode(h));
            }
            return f.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(u) {
            for (var l = u.length, c = [], f = 0; f < l; f++)
              c[f >>> 1] |= u.charCodeAt(f) << 16 - f % 2 * 16;
            return a.create(c, l * 2);
          }
        }, o.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(u) {
            for (var l = u.words, c = u.sigBytes, f = [], d = 0; d < c; d += 2) {
              var h = s(l[d >>> 2] >>> 16 - d % 4 * 8 & 65535);
              f.push(String.fromCharCode(h));
            }
            return f.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(u) {
            for (var l = u.length, c = [], f = 0; f < l; f++)
              c[f >>> 1] |= s(u.charCodeAt(f) << 16 - f % 2 * 16);
            return a.create(c, l * 2);
          }
        };
        function s(u) {
          return u << 8 & 4278255360 | u >>> 8 & 16711935;
        }
      }(), r.enc.Utf16;
    });
  }(Hc)), Hc.exports;
}
var Wc = { exports: {} }, sv;
function ji() {
  return sv || (sv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.enc;
        o.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(u) {
            var l = u.words, c = u.sigBytes, f = this._map;
            u.clamp();
            for (var d = [], h = 0; h < c; h += 3)
              for (var p = l[h >>> 2] >>> 24 - h % 4 * 8 & 255, v = l[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, m = l[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, x = p << 16 | v << 8 | m, y = 0; y < 4 && h + y * 0.75 < c; y++)
                d.push(f.charAt(x >>> 6 * (3 - y) & 63));
            var g = f.charAt(64);
            if (g)
              for (; d.length % 4; )
                d.push(g);
            return d.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(u) {
            var l = u.length, c = this._map, f = this._reverseMap;
            if (!f) {
              f = this._reverseMap = [];
              for (var d = 0; d < c.length; d++)
                f[c.charCodeAt(d)] = d;
            }
            var h = c.charAt(64);
            if (h) {
              var p = u.indexOf(h);
              p !== -1 && (l = p);
            }
            return s(u, l, f);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function s(u, l, c) {
          for (var f = [], d = 0, h = 0; h < l; h++)
            if (h % 4) {
              var p = c[u.charCodeAt(h - 1)] << h % 4 * 2, v = c[u.charCodeAt(h)] >>> 6 - h % 4 * 2, m = p | v;
              f[d >>> 2] |= m << 24 - d % 4 * 8, d++;
            }
          return a.create(f, d);
        }
      }(), r.enc.Base64;
    });
  }(Wc)), Wc.exports;
}
var zc = { exports: {} }, uv;
function JC() {
  return uv || (uv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.enc;
        o.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(u, l) {
            l === void 0 && (l = !0);
            var c = u.words, f = u.sigBytes, d = l ? this._safe_map : this._map;
            u.clamp();
            for (var h = [], p = 0; p < f; p += 3)
              for (var v = c[p >>> 2] >>> 24 - p % 4 * 8 & 255, m = c[p + 1 >>> 2] >>> 24 - (p + 1) % 4 * 8 & 255, x = c[p + 2 >>> 2] >>> 24 - (p + 2) % 4 * 8 & 255, y = v << 16 | m << 8 | x, g = 0; g < 4 && p + g * 0.75 < f; g++)
                h.push(d.charAt(y >>> 6 * (3 - g) & 63));
            var E = d.charAt(64);
            if (E)
              for (; h.length % 4; )
                h.push(E);
            return h.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(u, l) {
            l === void 0 && (l = !0);
            var c = u.length, f = l ? this._safe_map : this._map, d = this._reverseMap;
            if (!d) {
              d = this._reverseMap = [];
              for (var h = 0; h < f.length; h++)
                d[f.charCodeAt(h)] = h;
            }
            var p = f.charAt(64);
            if (p) {
              var v = u.indexOf(p);
              v !== -1 && (c = v);
            }
            return s(u, c, d);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function s(u, l, c) {
          for (var f = [], d = 0, h = 0; h < l; h++)
            if (h % 4) {
              var p = c[u.charCodeAt(h - 1)] << h % 4 * 2, v = c[u.charCodeAt(h)] >>> 6 - h % 4 * 2, m = p | v;
              f[d >>> 2] |= m << 24 - d % 4 * 8, d++;
            }
          return a.create(f, d);
        }
      }(), r.enc.Base64url;
    });
  }(zc)), zc.exports;
}
var qc = { exports: {} }, lv;
function Li() {
  return lv || (lv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, u = i.algo, l = [];
        (function() {
          for (var v = 0; v < 64; v++)
            l[v] = n.abs(n.sin(v + 1)) * 4294967296 | 0;
        })();
        var c = u.MD5 = s.extend({
          _doReset: function() {
            this._hash = new o.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(v, m) {
            for (var x = 0; x < 16; x++) {
              var y = m + x, g = v[y];
              v[y] = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360;
            }
            var E = this._hash.words, b = v[m + 0], w = v[m + 1], _ = v[m + 2], A = v[m + 3], O = v[m + 4], T = v[m + 5], C = v[m + 6], $ = v[m + 7], P = v[m + 8], j = v[m + 9], W = v[m + 10], Y = v[m + 11], V = v[m + 12], ce = v[m + 13], de = v[m + 14], L = v[m + 15], D = E[0], N = E[1], B = E[2], F = E[3];
            D = f(D, N, B, F, b, 7, l[0]), F = f(F, D, N, B, w, 12, l[1]), B = f(B, F, D, N, _, 17, l[2]), N = f(N, B, F, D, A, 22, l[3]), D = f(D, N, B, F, O, 7, l[4]), F = f(F, D, N, B, T, 12, l[5]), B = f(B, F, D, N, C, 17, l[6]), N = f(N, B, F, D, $, 22, l[7]), D = f(D, N, B, F, P, 7, l[8]), F = f(F, D, N, B, j, 12, l[9]), B = f(B, F, D, N, W, 17, l[10]), N = f(N, B, F, D, Y, 22, l[11]), D = f(D, N, B, F, V, 7, l[12]), F = f(F, D, N, B, ce, 12, l[13]), B = f(B, F, D, N, de, 17, l[14]), N = f(N, B, F, D, L, 22, l[15]), D = d(D, N, B, F, w, 5, l[16]), F = d(F, D, N, B, C, 9, l[17]), B = d(B, F, D, N, Y, 14, l[18]), N = d(N, B, F, D, b, 20, l[19]), D = d(D, N, B, F, T, 5, l[20]), F = d(F, D, N, B, W, 9, l[21]), B = d(B, F, D, N, L, 14, l[22]), N = d(N, B, F, D, O, 20, l[23]), D = d(D, N, B, F, j, 5, l[24]), F = d(F, D, N, B, de, 9, l[25]), B = d(B, F, D, N, A, 14, l[26]), N = d(N, B, F, D, P, 20, l[27]), D = d(D, N, B, F, ce, 5, l[28]), F = d(F, D, N, B, _, 9, l[29]), B = d(B, F, D, N, $, 14, l[30]), N = d(N, B, F, D, V, 20, l[31]), D = h(D, N, B, F, T, 4, l[32]), F = h(F, D, N, B, P, 11, l[33]), B = h(B, F, D, N, Y, 16, l[34]), N = h(N, B, F, D, de, 23, l[35]), D = h(D, N, B, F, w, 4, l[36]), F = h(F, D, N, B, O, 11, l[37]), B = h(B, F, D, N, $, 16, l[38]), N = h(N, B, F, D, W, 23, l[39]), D = h(D, N, B, F, ce, 4, l[40]), F = h(F, D, N, B, b, 11, l[41]), B = h(B, F, D, N, A, 16, l[42]), N = h(N, B, F, D, C, 23, l[43]), D = h(D, N, B, F, j, 4, l[44]), F = h(F, D, N, B, V, 11, l[45]), B = h(B, F, D, N, L, 16, l[46]), N = h(N, B, F, D, _, 23, l[47]), D = p(D, N, B, F, b, 6, l[48]), F = p(F, D, N, B, $, 10, l[49]), B = p(B, F, D, N, de, 15, l[50]), N = p(N, B, F, D, T, 21, l[51]), D = p(D, N, B, F, V, 6, l[52]), F = p(F, D, N, B, A, 10, l[53]), B = p(B, F, D, N, W, 15, l[54]), N = p(N, B, F, D, w, 21, l[55]), D = p(D, N, B, F, P, 6, l[56]), F = p(F, D, N, B, L, 10, l[57]), B = p(B, F, D, N, C, 15, l[58]), N = p(N, B, F, D, ce, 21, l[59]), D = p(D, N, B, F, O, 6, l[60]), F = p(F, D, N, B, Y, 10, l[61]), B = p(B, F, D, N, _, 15, l[62]), N = p(N, B, F, D, j, 21, l[63]), E[0] = E[0] + D | 0, E[1] = E[1] + N | 0, E[2] = E[2] + B | 0, E[3] = E[3] + F | 0;
          },
          _doFinalize: function() {
            var v = this._data, m = v.words, x = this._nDataBytes * 8, y = v.sigBytes * 8;
            m[y >>> 5] |= 128 << 24 - y % 32;
            var g = n.floor(x / 4294967296), E = x;
            m[(y + 64 >>> 9 << 4) + 15] = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, m[(y + 64 >>> 9 << 4) + 14] = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360, v.sigBytes = (m.length + 1) * 4, this._process();
            for (var b = this._hash, w = b.words, _ = 0; _ < 4; _++) {
              var A = w[_];
              w[_] = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360;
            }
            return b;
          },
          clone: function() {
            var v = s.clone.call(this);
            return v._hash = this._hash.clone(), v;
          }
        });
        function f(v, m, x, y, g, E, b) {
          var w = v + (m & x | ~m & y) + g + b;
          return (w << E | w >>> 32 - E) + m;
        }
        function d(v, m, x, y, g, E, b) {
          var w = v + (m & y | x & ~y) + g + b;
          return (w << E | w >>> 32 - E) + m;
        }
        function h(v, m, x, y, g, E, b) {
          var w = v + (m ^ x ^ y) + g + b;
          return (w << E | w >>> 32 - E) + m;
        }
        function p(v, m, x, y, g, E, b) {
          var w = v + (x ^ (m | ~y)) + g + b;
          return (w << E | w >>> 32 - E) + m;
        }
        i.MD5 = s._createHelper(c), i.HmacMD5 = s._createHmacHelper(c);
      }(Math), r.MD5;
    });
  }(qc)), qc.exports;
}
var Yc = { exports: {} }, cv;
function cb() {
  return cv || (cv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = i.Hasher, s = n.algo, u = [], l = s.SHA1 = o.extend({
          _doReset: function() {
            this._hash = new a.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(c, f) {
            for (var d = this._hash.words, h = d[0], p = d[1], v = d[2], m = d[3], x = d[4], y = 0; y < 80; y++) {
              if (y < 16)
                u[y] = c[f + y] | 0;
              else {
                var g = u[y - 3] ^ u[y - 8] ^ u[y - 14] ^ u[y - 16];
                u[y] = g << 1 | g >>> 31;
              }
              var E = (h << 5 | h >>> 27) + x + u[y];
              y < 20 ? E += (p & v | ~p & m) + 1518500249 : y < 40 ? E += (p ^ v ^ m) + 1859775393 : y < 60 ? E += (p & v | p & m | v & m) - 1894007588 : E += (p ^ v ^ m) - 899497514, x = m, m = v, v = p << 30 | p >>> 2, p = h, h = E;
            }
            d[0] = d[0] + h | 0, d[1] = d[1] + p | 0, d[2] = d[2] + v | 0, d[3] = d[3] + m | 0, d[4] = d[4] + x | 0;
          },
          _doFinalize: function() {
            var c = this._data, f = c.words, d = this._nDataBytes * 8, h = c.sigBytes * 8;
            return f[h >>> 5] |= 128 << 24 - h % 32, f[(h + 64 >>> 9 << 4) + 14] = Math.floor(d / 4294967296), f[(h + 64 >>> 9 << 4) + 15] = d, c.sigBytes = f.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var c = o.clone.call(this);
            return c._hash = this._hash.clone(), c;
          }
        });
        n.SHA1 = o._createHelper(l), n.HmacSHA1 = o._createHmacHelper(l);
      }(), r.SHA1;
    });
  }(Yc)), Yc.exports;
}
var Vc = { exports: {} }, fv;
function j0() {
  return fv || (fv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, u = i.algo, l = [], c = [];
        (function() {
          function h(x) {
            for (var y = n.sqrt(x), g = 2; g <= y; g++)
              if (!(x % g))
                return !1;
            return !0;
          }
          function p(x) {
            return (x - (x | 0)) * 4294967296 | 0;
          }
          for (var v = 2, m = 0; m < 64; )
            h(v) && (m < 8 && (l[m] = p(n.pow(v, 1 / 2))), c[m] = p(n.pow(v, 1 / 3)), m++), v++;
        })();
        var f = [], d = u.SHA256 = s.extend({
          _doReset: function() {
            this._hash = new o.init(l.slice(0));
          },
          _doProcessBlock: function(h, p) {
            for (var v = this._hash.words, m = v[0], x = v[1], y = v[2], g = v[3], E = v[4], b = v[5], w = v[6], _ = v[7], A = 0; A < 64; A++) {
              if (A < 16)
                f[A] = h[p + A] | 0;
              else {
                var O = f[A - 15], T = (O << 25 | O >>> 7) ^ (O << 14 | O >>> 18) ^ O >>> 3, C = f[A - 2], $ = (C << 15 | C >>> 17) ^ (C << 13 | C >>> 19) ^ C >>> 10;
                f[A] = T + f[A - 7] + $ + f[A - 16];
              }
              var P = E & b ^ ~E & w, j = m & x ^ m & y ^ x & y, W = (m << 30 | m >>> 2) ^ (m << 19 | m >>> 13) ^ (m << 10 | m >>> 22), Y = (E << 26 | E >>> 6) ^ (E << 21 | E >>> 11) ^ (E << 7 | E >>> 25), V = _ + Y + P + c[A] + f[A], ce = W + j;
              _ = w, w = b, b = E, E = g + V | 0, g = y, y = x, x = m, m = V + ce | 0;
            }
            v[0] = v[0] + m | 0, v[1] = v[1] + x | 0, v[2] = v[2] + y | 0, v[3] = v[3] + g | 0, v[4] = v[4] + E | 0, v[5] = v[5] + b | 0, v[6] = v[6] + w | 0, v[7] = v[7] + _ | 0;
          },
          _doFinalize: function() {
            var h = this._data, p = h.words, v = this._nDataBytes * 8, m = h.sigBytes * 8;
            return p[m >>> 5] |= 128 << 24 - m % 32, p[(m + 64 >>> 9 << 4) + 14] = n.floor(v / 4294967296), p[(m + 64 >>> 9 << 4) + 15] = v, h.sigBytes = p.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var h = s.clone.call(this);
            return h._hash = this._hash.clone(), h;
          }
        });
        i.SHA256 = s._createHelper(d), i.HmacSHA256 = s._createHmacHelper(d);
      }(Math), r.SHA256;
    });
  }(Vc)), Vc.exports;
}
var Gc = { exports: {} }, dv;
function ZC() {
  return dv || (dv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), j0());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.algo, s = o.SHA256, u = o.SHA224 = s.extend({
          _doReset: function() {
            this._hash = new a.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var l = s._doFinalize.call(this);
            return l.sigBytes -= 4, l;
          }
        });
        n.SHA224 = s._createHelper(u), n.HmacSHA224 = s._createHmacHelper(u);
      }(), r.SHA224;
    });
  }(Gc)), Gc.exports;
}
var Kc = { exports: {} }, hv;
function fb() {
  return hv || (hv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Cl());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.Hasher, o = n.x64, s = o.Word, u = o.WordArray, l = n.algo;
        function c() {
          return s.create.apply(s, arguments);
        }
        var f = [
          c(1116352408, 3609767458),
          c(1899447441, 602891725),
          c(3049323471, 3964484399),
          c(3921009573, 2173295548),
          c(961987163, 4081628472),
          c(1508970993, 3053834265),
          c(2453635748, 2937671579),
          c(2870763221, 3664609560),
          c(3624381080, 2734883394),
          c(310598401, 1164996542),
          c(607225278, 1323610764),
          c(1426881987, 3590304994),
          c(1925078388, 4068182383),
          c(2162078206, 991336113),
          c(2614888103, 633803317),
          c(3248222580, 3479774868),
          c(3835390401, 2666613458),
          c(4022224774, 944711139),
          c(264347078, 2341262773),
          c(604807628, 2007800933),
          c(770255983, 1495990901),
          c(1249150122, 1856431235),
          c(1555081692, 3175218132),
          c(1996064986, 2198950837),
          c(2554220882, 3999719339),
          c(2821834349, 766784016),
          c(2952996808, 2566594879),
          c(3210313671, 3203337956),
          c(3336571891, 1034457026),
          c(3584528711, 2466948901),
          c(113926993, 3758326383),
          c(338241895, 168717936),
          c(666307205, 1188179964),
          c(773529912, 1546045734),
          c(1294757372, 1522805485),
          c(1396182291, 2643833823),
          c(1695183700, 2343527390),
          c(1986661051, 1014477480),
          c(2177026350, 1206759142),
          c(2456956037, 344077627),
          c(2730485921, 1290863460),
          c(2820302411, 3158454273),
          c(3259730800, 3505952657),
          c(3345764771, 106217008),
          c(3516065817, 3606008344),
          c(3600352804, 1432725776),
          c(4094571909, 1467031594),
          c(275423344, 851169720),
          c(430227734, 3100823752),
          c(506948616, 1363258195),
          c(659060556, 3750685593),
          c(883997877, 3785050280),
          c(958139571, 3318307427),
          c(1322822218, 3812723403),
          c(1537002063, 2003034995),
          c(1747873779, 3602036899),
          c(1955562222, 1575990012),
          c(2024104815, 1125592928),
          c(2227730452, 2716904306),
          c(2361852424, 442776044),
          c(2428436474, 593698344),
          c(2756734187, 3733110249),
          c(3204031479, 2999351573),
          c(3329325298, 3815920427),
          c(3391569614, 3928383900),
          c(3515267271, 566280711),
          c(3940187606, 3454069534),
          c(4118630271, 4000239992),
          c(116418474, 1914138554),
          c(174292421, 2731055270),
          c(289380356, 3203993006),
          c(460393269, 320620315),
          c(685471733, 587496836),
          c(852142971, 1086792851),
          c(1017036298, 365543100),
          c(1126000580, 2618297676),
          c(1288033470, 3409855158),
          c(1501505948, 4234509866),
          c(1607167915, 987167468),
          c(1816402316, 1246189591)
        ], d = [];
        (function() {
          for (var p = 0; p < 80; p++)
            d[p] = c();
        })();
        var h = l.SHA512 = a.extend({
          _doReset: function() {
            this._hash = new u.init([
              new s.init(1779033703, 4089235720),
              new s.init(3144134277, 2227873595),
              new s.init(1013904242, 4271175723),
              new s.init(2773480762, 1595750129),
              new s.init(1359893119, 2917565137),
              new s.init(2600822924, 725511199),
              new s.init(528734635, 4215389547),
              new s.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(p, v) {
            for (var m = this._hash.words, x = m[0], y = m[1], g = m[2], E = m[3], b = m[4], w = m[5], _ = m[6], A = m[7], O = x.high, T = x.low, C = y.high, $ = y.low, P = g.high, j = g.low, W = E.high, Y = E.low, V = b.high, ce = b.low, de = w.high, L = w.low, D = _.high, N = _.low, B = A.high, F = A.low, X = O, Z = T, ne = C, K = $, we = P, I = j, k = W, M = Y, H = V, ee = ce, xe = de, ye = L, be = D, ze = N, rt = B, Ft = F, bt = 0; bt < 80; bt++) {
              var R, Q, te = d[bt];
              if (bt < 16)
                Q = te.high = p[v + bt * 2] | 0, R = te.low = p[v + bt * 2 + 1] | 0;
              else {
                var fe = d[bt - 15], Ee = fe.high, ke = fe.low, Et = (Ee >>> 1 | ke << 31) ^ (Ee >>> 8 | ke << 24) ^ Ee >>> 7, Zt = (ke >>> 1 | Ee << 31) ^ (ke >>> 8 | Ee << 24) ^ (ke >>> 7 | Ee << 25), Ki = d[bt - 2], Hr = Ki.high, li = Ki.low, Oc = (Hr >>> 19 | li << 13) ^ (Hr << 3 | li >>> 29) ^ Hr >>> 6, Xa = (li >>> 19 | Hr << 13) ^ (li << 3 | Hr >>> 29) ^ (li >>> 6 | Hr << 26), Ds = d[bt - 7], GS = Ds.high, KS = Ds.low, Dp = d[bt - 16], QS = Dp.high, Fp = Dp.low;
                R = Zt + KS, Q = Et + GS + (R >>> 0 < Zt >>> 0 ? 1 : 0), R = R + Xa, Q = Q + Oc + (R >>> 0 < Xa >>> 0 ? 1 : 0), R = R + Fp, Q = Q + QS + (R >>> 0 < Fp >>> 0 ? 1 : 0), te.high = Q, te.low = R;
              }
              var XS = H & xe ^ ~H & be, Ip = ee & ye ^ ~ee & ze, JS = X & ne ^ X & we ^ ne & we, ZS = Z & K ^ Z & I ^ K & I, e_ = (X >>> 28 | Z << 4) ^ (X << 30 | Z >>> 2) ^ (X << 25 | Z >>> 7), kp = (Z >>> 28 | X << 4) ^ (Z << 30 | X >>> 2) ^ (Z << 25 | X >>> 7), t_ = (H >>> 14 | ee << 18) ^ (H >>> 18 | ee << 14) ^ (H << 23 | ee >>> 9), r_ = (ee >>> 14 | H << 18) ^ (ee >>> 18 | H << 14) ^ (ee << 23 | H >>> 9), Np = f[bt], n_ = Np.high, Pp = Np.low, er = Ft + r_, Fn = rt + t_ + (er >>> 0 < Ft >>> 0 ? 1 : 0), er = er + Ip, Fn = Fn + XS + (er >>> 0 < Ip >>> 0 ? 1 : 0), er = er + Pp, Fn = Fn + n_ + (er >>> 0 < Pp >>> 0 ? 1 : 0), er = er + R, Fn = Fn + Q + (er >>> 0 < R >>> 0 ? 1 : 0), $p = kp + ZS, i_ = e_ + JS + ($p >>> 0 < kp >>> 0 ? 1 : 0);
              rt = be, Ft = ze, be = xe, ze = ye, xe = H, ye = ee, ee = M + er | 0, H = k + Fn + (ee >>> 0 < M >>> 0 ? 1 : 0) | 0, k = we, M = I, we = ne, I = K, ne = X, K = Z, Z = er + $p | 0, X = Fn + i_ + (Z >>> 0 < er >>> 0 ? 1 : 0) | 0;
            }
            T = x.low = T + Z, x.high = O + X + (T >>> 0 < Z >>> 0 ? 1 : 0), $ = y.low = $ + K, y.high = C + ne + ($ >>> 0 < K >>> 0 ? 1 : 0), j = g.low = j + I, g.high = P + we + (j >>> 0 < I >>> 0 ? 1 : 0), Y = E.low = Y + M, E.high = W + k + (Y >>> 0 < M >>> 0 ? 1 : 0), ce = b.low = ce + ee, b.high = V + H + (ce >>> 0 < ee >>> 0 ? 1 : 0), L = w.low = L + ye, w.high = de + xe + (L >>> 0 < ye >>> 0 ? 1 : 0), N = _.low = N + ze, _.high = D + be + (N >>> 0 < ze >>> 0 ? 1 : 0), F = A.low = F + Ft, A.high = B + rt + (F >>> 0 < Ft >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var p = this._data, v = p.words, m = this._nDataBytes * 8, x = p.sigBytes * 8;
            v[x >>> 5] |= 128 << 24 - x % 32, v[(x + 128 >>> 10 << 5) + 30] = Math.floor(m / 4294967296), v[(x + 128 >>> 10 << 5) + 31] = m, p.sigBytes = v.length * 4, this._process();
            var y = this._hash.toX32();
            return y;
          },
          clone: function() {
            var p = a.clone.call(this);
            return p._hash = this._hash.clone(), p;
          },
          blockSize: 1024 / 32
        });
        n.SHA512 = a._createHelper(h), n.HmacSHA512 = a._createHmacHelper(h);
      }(), r.SHA512;
    });
  }(Kc)), Kc.exports;
}
var Qc = { exports: {} }, pv;
function e2() {
  return pv || (pv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Cl(), fb());
    })(he, function(r) {
      return function() {
        var n = r, i = n.x64, a = i.Word, o = i.WordArray, s = n.algo, u = s.SHA512, l = s.SHA384 = u.extend({
          _doReset: function() {
            this._hash = new o.init([
              new a.init(3418070365, 3238371032),
              new a.init(1654270250, 914150663),
              new a.init(2438529370, 812702999),
              new a.init(355462360, 4144912697),
              new a.init(1731405415, 4290775857),
              new a.init(2394180231, 1750603025),
              new a.init(3675008525, 1694076839),
              new a.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var c = u._doFinalize.call(this);
            return c.sigBytes -= 16, c;
          }
        });
        n.SHA384 = u._createHelper(l), n.HmacSHA384 = u._createHmacHelper(l);
      }(), r.SHA384;
    });
  }(Qc)), Qc.exports;
}
var Xc = { exports: {} }, vv;
function t2() {
  return vv || (vv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Cl());
    })(he, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, u = i.x64, l = u.Word, c = i.algo, f = [], d = [], h = [];
        (function() {
          for (var m = 1, x = 0, y = 0; y < 24; y++) {
            f[m + 5 * x] = (y + 1) * (y + 2) / 2 % 64;
            var g = x % 5, E = (2 * m + 3 * x) % 5;
            m = g, x = E;
          }
          for (var m = 0; m < 5; m++)
            for (var x = 0; x < 5; x++)
              d[m + 5 * x] = x + (2 * m + 3 * x) % 5 * 5;
          for (var b = 1, w = 0; w < 24; w++) {
            for (var _ = 0, A = 0, O = 0; O < 7; O++) {
              if (b & 1) {
                var T = (1 << O) - 1;
                T < 32 ? A ^= 1 << T : _ ^= 1 << T - 32;
              }
              b & 128 ? b = b << 1 ^ 113 : b <<= 1;
            }
            h[w] = l.create(_, A);
          }
        })();
        var p = [];
        (function() {
          for (var m = 0; m < 25; m++)
            p[m] = l.create();
        })();
        var v = c.SHA3 = s.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: s.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var m = this._state = [], x = 0; x < 25; x++)
              m[x] = new l.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(m, x) {
            for (var y = this._state, g = this.blockSize / 2, E = 0; E < g; E++) {
              var b = m[x + 2 * E], w = m[x + 2 * E + 1];
              b = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360;
              var _ = y[E];
              _.high ^= w, _.low ^= b;
            }
            for (var A = 0; A < 24; A++) {
              for (var O = 0; O < 5; O++) {
                for (var T = 0, C = 0, $ = 0; $ < 5; $++) {
                  var _ = y[O + 5 * $];
                  T ^= _.high, C ^= _.low;
                }
                var P = p[O];
                P.high = T, P.low = C;
              }
              for (var O = 0; O < 5; O++)
                for (var j = p[(O + 4) % 5], W = p[(O + 1) % 5], Y = W.high, V = W.low, T = j.high ^ (Y << 1 | V >>> 31), C = j.low ^ (V << 1 | Y >>> 31), $ = 0; $ < 5; $++) {
                  var _ = y[O + 5 * $];
                  _.high ^= T, _.low ^= C;
                }
              for (var ce = 1; ce < 25; ce++) {
                var T, C, _ = y[ce], de = _.high, L = _.low, D = f[ce];
                D < 32 ? (T = de << D | L >>> 32 - D, C = L << D | de >>> 32 - D) : (T = L << D - 32 | de >>> 64 - D, C = de << D - 32 | L >>> 64 - D);
                var N = p[d[ce]];
                N.high = T, N.low = C;
              }
              var B = p[0], F = y[0];
              B.high = F.high, B.low = F.low;
              for (var O = 0; O < 5; O++)
                for (var $ = 0; $ < 5; $++) {
                  var ce = O + 5 * $, _ = y[ce], X = p[ce], Z = p[(O + 1) % 5 + 5 * $], ne = p[(O + 2) % 5 + 5 * $];
                  _.high = X.high ^ ~Z.high & ne.high, _.low = X.low ^ ~Z.low & ne.low;
                }
              var _ = y[0], K = h[A];
              _.high ^= K.high, _.low ^= K.low;
            }
          },
          _doFinalize: function() {
            var m = this._data, x = m.words;
            this._nDataBytes * 8;
            var y = m.sigBytes * 8, g = this.blockSize * 32;
            x[y >>> 5] |= 1 << 24 - y % 32, x[(n.ceil((y + 1) / g) * g >>> 5) - 1] |= 128, m.sigBytes = x.length * 4, this._process();
            for (var E = this._state, b = this.cfg.outputLength / 8, w = b / 8, _ = [], A = 0; A < w; A++) {
              var O = E[A], T = O.high, C = O.low;
              T = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, C = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, _.push(C), _.push(T);
            }
            return new o.init(_, b);
          },
          clone: function() {
            for (var m = s.clone.call(this), x = m._state = this._state.slice(0), y = 0; y < 25; y++)
              x[y] = x[y].clone();
            return m;
          }
        });
        i.SHA3 = s._createHelper(v), i.HmacSHA3 = s._createHmacHelper(v);
      }(Math), r.SHA3;
    });
  }(Xc)), Xc.exports;
}
var Jc = { exports: {} }, mv;
function r2() {
  return mv || (mv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, u = i.algo, l = o.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), c = o.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), f = o.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), d = o.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), h = o.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), p = o.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), v = u.RIPEMD160 = s.extend({
          _doReset: function() {
            this._hash = o.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(w, _) {
            for (var A = 0; A < 16; A++) {
              var O = _ + A, T = w[O];
              w[O] = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360;
            }
            var C = this._hash.words, $ = h.words, P = p.words, j = l.words, W = c.words, Y = f.words, V = d.words, ce, de, L, D, N, B, F, X, Z, ne;
            B = ce = C[0], F = de = C[1], X = L = C[2], Z = D = C[3], ne = N = C[4];
            for (var K, A = 0; A < 80; A += 1)
              K = ce + w[_ + j[A]] | 0, A < 16 ? K += m(de, L, D) + $[0] : A < 32 ? K += x(de, L, D) + $[1] : A < 48 ? K += y(de, L, D) + $[2] : A < 64 ? K += g(de, L, D) + $[3] : K += E(de, L, D) + $[4], K = K | 0, K = b(K, Y[A]), K = K + N | 0, ce = N, N = D, D = b(L, 10), L = de, de = K, K = B + w[_ + W[A]] | 0, A < 16 ? K += E(F, X, Z) + P[0] : A < 32 ? K += g(F, X, Z) + P[1] : A < 48 ? K += y(F, X, Z) + P[2] : A < 64 ? K += x(F, X, Z) + P[3] : K += m(F, X, Z) + P[4], K = K | 0, K = b(K, V[A]), K = K + ne | 0, B = ne, ne = Z, Z = b(X, 10), X = F, F = K;
            K = C[1] + L + Z | 0, C[1] = C[2] + D + ne | 0, C[2] = C[3] + N + B | 0, C[3] = C[4] + ce + F | 0, C[4] = C[0] + de + X | 0, C[0] = K;
          },
          _doFinalize: function() {
            var w = this._data, _ = w.words, A = this._nDataBytes * 8, O = w.sigBytes * 8;
            _[O >>> 5] |= 128 << 24 - O % 32, _[(O + 64 >>> 9 << 4) + 14] = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, w.sigBytes = (_.length + 1) * 4, this._process();
            for (var T = this._hash, C = T.words, $ = 0; $ < 5; $++) {
              var P = C[$];
              C[$] = (P << 8 | P >>> 24) & 16711935 | (P << 24 | P >>> 8) & 4278255360;
            }
            return T;
          },
          clone: function() {
            var w = s.clone.call(this);
            return w._hash = this._hash.clone(), w;
          }
        });
        function m(w, _, A) {
          return w ^ _ ^ A;
        }
        function x(w, _, A) {
          return w & _ | ~w & A;
        }
        function y(w, _, A) {
          return (w | ~_) ^ A;
        }
        function g(w, _, A) {
          return w & A | _ & ~A;
        }
        function E(w, _, A) {
          return w ^ (_ | ~A);
        }
        function b(w, _) {
          return w << _ | w >>> 32 - _;
        }
        i.RIPEMD160 = s._createHelper(v), i.HmacRIPEMD160 = s._createHmacHelper(v);
      }(), r.RIPEMD160;
    });
  }(Jc)), Jc.exports;
}
var Zc = { exports: {} }, yv;
function L0() {
  return yv || (yv = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(Pe());
    })(he, function(r) {
      (function() {
        var n = r, i = n.lib, a = i.Base, o = n.enc, s = o.Utf8, u = n.algo;
        u.HMAC = a.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(l, c) {
            l = this._hasher = new l.init(), typeof c == "string" && (c = s.parse(c));
            var f = l.blockSize, d = f * 4;
            c.sigBytes > d && (c = l.finalize(c)), c.clamp();
            for (var h = this._oKey = c.clone(), p = this._iKey = c.clone(), v = h.words, m = p.words, x = 0; x < f; x++)
              v[x] ^= 1549556828, m[x] ^= 909522486;
            h.sigBytes = p.sigBytes = d, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var l = this._hasher;
            l.reset(), l.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(l) {
            return this._hasher.update(l), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(l) {
            var c = this._hasher, f = c.finalize(l);
            c.reset();
            var d = c.finalize(this._oKey.clone().concat(f));
            return d;
          }
        });
      })();
    });
  }(Zc)), Zc.exports;
}
var ef = { exports: {} }, gv;
function n2() {
  return gv || (gv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), j0(), L0());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.Base, o = i.WordArray, s = n.algo, u = s.SHA256, l = s.HMAC, c = s.PBKDF2 = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: u,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(f) {
            this.cfg = this.cfg.extend(f);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(f, d) {
            for (var h = this.cfg, p = l.create(h.hasher, f), v = o.create(), m = o.create([1]), x = v.words, y = m.words, g = h.keySize, E = h.iterations; x.length < g; ) {
              var b = p.update(d).finalize(m);
              p.reset();
              for (var w = b.words, _ = w.length, A = b, O = 1; O < E; O++) {
                A = p.finalize(A), p.reset();
                for (var T = A.words, C = 0; C < _; C++)
                  w[C] ^= T[C];
              }
              v.concat(b), y[0]++;
            }
            return v.sigBytes = g * 4, v;
          }
        });
        n.PBKDF2 = function(f, d, h) {
          return c.create(h).compute(f, d);
        };
      }(), r.PBKDF2;
    });
  }(ef)), ef.exports;
}
var tf = { exports: {} }, xv;
function ni() {
  return xv || (xv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), cb(), L0());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.Base, o = i.WordArray, s = n.algo, u = s.MD5, l = s.EvpKDF = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: u,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(c) {
            this.cfg = this.cfg.extend(c);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(c, f) {
            for (var d, h = this.cfg, p = h.hasher.create(), v = o.create(), m = v.words, x = h.keySize, y = h.iterations; m.length < x; ) {
              d && p.update(d), d = p.update(c).finalize(f), p.reset();
              for (var g = 1; g < y; g++)
                d = p.finalize(d), p.reset();
              v.concat(d);
            }
            return v.sigBytes = x * 4, v;
          }
        });
        n.EvpKDF = function(c, f, d) {
          return l.create(d).compute(c, f);
        };
      }(), r.EvpKDF;
    });
  }(tf)), tf.exports;
}
var rf = { exports: {} }, bv;
function Ot() {
  return bv || (bv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ni());
    })(he, function(r) {
      r.lib.Cipher || function(n) {
        var i = r, a = i.lib, o = a.Base, s = a.WordArray, u = a.BufferedBlockAlgorithm, l = i.enc;
        l.Utf8;
        var c = l.Base64, f = i.algo, d = f.EvpKDF, h = a.Cipher = u.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: o.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(T, C) {
            return this.create(this._ENC_XFORM_MODE, T, C);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(T, C) {
            return this.create(this._DEC_XFORM_MODE, T, C);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(T, C, $) {
            this.cfg = this.cfg.extend($), this._xformMode = T, this._key = C, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            u.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(T) {
            return this._append(T), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(T) {
            T && this._append(T);
            var C = this._doFinalize();
            return C;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: function() {
            function T(C) {
              return typeof C == "string" ? O : w;
            }
            return function(C) {
              return {
                encrypt: function($, P, j) {
                  return T(P).encrypt(C, $, P, j);
                },
                decrypt: function($, P, j) {
                  return T(P).decrypt(C, $, P, j);
                }
              };
            };
          }()
        });
        a.StreamCipher = h.extend({
          _doFinalize: function() {
            var T = this._process(!0);
            return T;
          },
          blockSize: 1
        });
        var p = i.mode = {}, v = a.BlockCipherMode = o.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(T, C) {
            return this.Encryptor.create(T, C);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(T, C) {
            return this.Decryptor.create(T, C);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(T, C) {
            this._cipher = T, this._iv = C;
          }
        }), m = p.CBC = function() {
          var T = v.extend();
          T.Encryptor = T.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function($, P) {
              var j = this._cipher, W = j.blockSize;
              C.call(this, $, P, W), j.encryptBlock($, P), this._prevBlock = $.slice(P, P + W);
            }
          }), T.Decryptor = T.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function($, P) {
              var j = this._cipher, W = j.blockSize, Y = $.slice(P, P + W);
              j.decryptBlock($, P), C.call(this, $, P, W), this._prevBlock = Y;
            }
          });
          function C($, P, j) {
            var W, Y = this._iv;
            Y ? (W = Y, this._iv = n) : W = this._prevBlock;
            for (var V = 0; V < j; V++)
              $[P + V] ^= W[V];
          }
          return T;
        }(), x = i.pad = {}, y = x.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(T, C) {
            for (var $ = C * 4, P = $ - T.sigBytes % $, j = P << 24 | P << 16 | P << 8 | P, W = [], Y = 0; Y < P; Y += 4)
              W.push(j);
            var V = s.create(W, P);
            T.concat(V);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(T) {
            var C = T.words[T.sigBytes - 1 >>> 2] & 255;
            T.sigBytes -= C;
          }
        };
        a.BlockCipher = h.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: h.cfg.extend({
            mode: m,
            padding: y
          }),
          reset: function() {
            var T;
            h.reset.call(this);
            var C = this.cfg, $ = C.iv, P = C.mode;
            this._xformMode == this._ENC_XFORM_MODE ? T = P.createEncryptor : (T = P.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == T ? this._mode.init(this, $ && $.words) : (this._mode = T.call(P, this, $ && $.words), this._mode.__creator = T);
          },
          _doProcessBlock: function(T, C) {
            this._mode.processBlock(T, C);
          },
          _doFinalize: function() {
            var T, C = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (C.pad(this._data, this.blockSize), T = this._process(!0)) : (T = this._process(!0), C.unpad(T)), T;
          },
          blockSize: 128 / 32
        });
        var g = a.CipherParams = o.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(T) {
            this.mixIn(T);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(T) {
            return (T || this.formatter).stringify(this);
          }
        }), E = i.format = {}, b = E.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(T) {
            var C, $ = T.ciphertext, P = T.salt;
            return P ? C = s.create([1398893684, 1701076831]).concat(P).concat($) : C = $, C.toString(c);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(T) {
            var C, $ = c.parse(T), P = $.words;
            return P[0] == 1398893684 && P[1] == 1701076831 && (C = s.create(P.slice(2, 4)), P.splice(0, 4), $.sigBytes -= 16), g.create({ ciphertext: $, salt: C });
          }
        }, w = a.SerializableCipher = o.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: o.extend({
            format: b
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(T, C, $, P) {
            P = this.cfg.extend(P);
            var j = T.createEncryptor($, P), W = j.finalize(C), Y = j.cfg;
            return g.create({
              ciphertext: W,
              key: $,
              iv: Y.iv,
              algorithm: T,
              mode: Y.mode,
              padding: Y.padding,
              blockSize: T.blockSize,
              formatter: P.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(T, C, $, P) {
            P = this.cfg.extend(P), C = this._parse(C, P.format);
            var j = T.createDecryptor($, P).finalize(C.ciphertext);
            return j;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(T, C) {
            return typeof T == "string" ? C.parse(T, this) : T;
          }
        }), _ = i.kdf = {}, A = _.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(T, C, $, P, j) {
            if (P || (P = s.random(64 / 8)), j)
              var W = d.create({ keySize: C + $, hasher: j }).compute(T, P);
            else
              var W = d.create({ keySize: C + $ }).compute(T, P);
            var Y = s.create(W.words.slice(C), $ * 4);
            return W.sigBytes = C * 4, g.create({ key: W, iv: Y, salt: P });
          }
        }, O = a.PasswordBasedCipher = w.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: w.cfg.extend({
            kdf: A
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(T, C, $, P) {
            P = this.cfg.extend(P);
            var j = P.kdf.execute($, T.keySize, T.ivSize, P.salt, P.hasher);
            P.iv = j.iv;
            var W = w.encrypt.call(this, T, C, j.key, P);
            return W.mixIn(j), W;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(T, C, $, P) {
            P = this.cfg.extend(P), C = this._parse(C, P.format);
            var j = P.kdf.execute($, T.keySize, T.ivSize, C.salt, P.hasher);
            P.iv = j.iv;
            var W = w.decrypt.call(this, T, C, j.key, P);
            return W;
          }
        });
      }();
    });
  }(rf)), rf.exports;
}
var nf = { exports: {} }, Ev;
function i2() {
  return Ev || (Ev = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.mode.CFB = function() {
        var n = r.lib.BlockCipherMode.extend();
        n.Encryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, u = s.blockSize;
            i.call(this, a, o, u, s), this._prevBlock = a.slice(o, o + u);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, u = s.blockSize, l = a.slice(o, o + u);
            i.call(this, a, o, u, s), this._prevBlock = l;
          }
        });
        function i(a, o, s, u) {
          var l, c = this._iv;
          c ? (l = c.slice(0), this._iv = void 0) : l = this._prevBlock, u.encryptBlock(l, 0);
          for (var f = 0; f < s; f++)
            a[o + f] ^= l[f];
        }
        return n;
      }(), r.mode.CFB;
    });
  }(nf)), nf.exports;
}
var af = { exports: {} }, wv;
function a2() {
  return wv || (wv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.mode.CTR = function() {
        var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, u = s.blockSize, l = this._iv, c = this._counter;
            l && (c = this._counter = l.slice(0), this._iv = void 0);
            var f = c.slice(0);
            s.encryptBlock(f, 0), c[u - 1] = c[u - 1] + 1 | 0;
            for (var d = 0; d < u; d++)
              a[o + d] ^= f[d];
          }
        });
        return n.Decryptor = i, n;
      }(), r.mode.CTR;
    });
  }(af)), af.exports;
}
var of = { exports: {} }, Sv;
function o2() {
  return Sv || (Sv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return r.mode.CTRGladman = function() {
        var n = r.lib.BlockCipherMode.extend();
        function i(s) {
          if ((s >> 24 & 255) === 255) {
            var u = s >> 16 & 255, l = s >> 8 & 255, c = s & 255;
            u === 255 ? (u = 0, l === 255 ? (l = 0, c === 255 ? c = 0 : ++c) : ++l) : ++u, s = 0, s += u << 16, s += l << 8, s += c;
          } else
            s += 1 << 24;
          return s;
        }
        function a(s) {
          return (s[0] = i(s[0])) === 0 && (s[1] = i(s[1])), s;
        }
        var o = n.Encryptor = n.extend({
          processBlock: function(s, u) {
            var l = this._cipher, c = l.blockSize, f = this._iv, d = this._counter;
            f && (d = this._counter = f.slice(0), this._iv = void 0), a(d);
            var h = d.slice(0);
            l.encryptBlock(h, 0);
            for (var p = 0; p < c; p++)
              s[u + p] ^= h[p];
          }
        });
        return n.Decryptor = o, n;
      }(), r.mode.CTRGladman;
    });
  }(of)), of.exports;
}
var sf = { exports: {} }, _v;
function s2() {
  return _v || (_v = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.mode.OFB = function() {
        var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, u = s.blockSize, l = this._iv, c = this._keystream;
            l && (c = this._keystream = l.slice(0), this._iv = void 0), s.encryptBlock(c, 0);
            for (var f = 0; f < u; f++)
              a[o + f] ^= c[f];
          }
        });
        return n.Decryptor = i, n;
      }(), r.mode.OFB;
    });
  }(sf)), sf.exports;
}
var uf = { exports: {} }, Tv;
function u2() {
  return Tv || (Tv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.mode.ECB = function() {
        var n = r.lib.BlockCipherMode.extend();
        return n.Encryptor = n.extend({
          processBlock: function(i, a) {
            this._cipher.encryptBlock(i, a);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(i, a) {
            this._cipher.decryptBlock(i, a);
          }
        }), n;
      }(), r.mode.ECB;
    });
  }(uf)), uf.exports;
}
var lf = { exports: {} }, Av;
function l2() {
  return Av || (Av = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.pad.AnsiX923 = {
        pad: function(n, i) {
          var a = n.sigBytes, o = i * 4, s = o - a % o, u = a + s - 1;
          n.clamp(), n.words[u >>> 2] |= s << 24 - u % 4 * 8, n.sigBytes += s;
        },
        unpad: function(n) {
          var i = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= i;
        }
      }, r.pad.Ansix923;
    });
  }(lf)), lf.exports;
}
var cf = { exports: {} }, Cv;
function c2() {
  return Cv || (Cv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.pad.Iso10126 = {
        pad: function(n, i) {
          var a = i * 4, o = a - n.sigBytes % a;
          n.concat(r.lib.WordArray.random(o - 1)).concat(r.lib.WordArray.create([o << 24], 1));
        },
        unpad: function(n) {
          var i = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= i;
        }
      }, r.pad.Iso10126;
    });
  }(cf)), cf.exports;
}
var ff = { exports: {} }, Ov;
function f2() {
  return Ov || (Ov = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.pad.Iso97971 = {
        pad: function(n, i) {
          n.concat(r.lib.WordArray.create([2147483648], 1)), r.pad.ZeroPadding.pad(n, i);
        },
        unpad: function(n) {
          r.pad.ZeroPadding.unpad(n), n.sigBytes--;
        }
      }, r.pad.Iso97971;
    });
  }(ff)), ff.exports;
}
var df = { exports: {} }, Dv;
function d2() {
  return Dv || (Dv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.pad.ZeroPadding = {
        pad: function(n, i) {
          var a = i * 4;
          n.clamp(), n.sigBytes += a - (n.sigBytes % a || a);
        },
        unpad: function(n) {
          for (var i = n.words, a = n.sigBytes - 1, a = n.sigBytes - 1; a >= 0; a--)
            if (i[a >>> 2] >>> 24 - a % 4 * 8 & 255) {
              n.sigBytes = a + 1;
              break;
            }
        }
      }, r.pad.ZeroPadding;
    });
  }(df)), df.exports;
}
var hf = { exports: {} }, Fv;
function h2() {
  return Fv || (Fv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return r.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, r.pad.NoPadding;
    });
  }(hf)), hf.exports;
}
var pf = { exports: {} }, Iv;
function p2() {
  return Iv || (Iv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), Ot());
    })(he, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.CipherParams, s = i.enc, u = s.Hex, l = i.format;
        l.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(c) {
            return c.ciphertext.toString(u);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(c) {
            var f = u.parse(c);
            return o.create({ ciphertext: f });
          }
        };
      }(), r.format.Hex;
    });
  }(pf)), pf.exports;
}
var vf = { exports: {} }, kv;
function v2() {
  return kv || (kv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ji(), Li(), ni(), Ot());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.BlockCipher, o = n.algo, s = [], u = [], l = [], c = [], f = [], d = [], h = [], p = [], v = [], m = [];
        (function() {
          for (var g = [], E = 0; E < 256; E++)
            E < 128 ? g[E] = E << 1 : g[E] = E << 1 ^ 283;
          for (var b = 0, w = 0, E = 0; E < 256; E++) {
            var _ = w ^ w << 1 ^ w << 2 ^ w << 3 ^ w << 4;
            _ = _ >>> 8 ^ _ & 255 ^ 99, s[b] = _, u[_] = b;
            var A = g[b], O = g[A], T = g[O], C = g[_] * 257 ^ _ * 16843008;
            l[b] = C << 24 | C >>> 8, c[b] = C << 16 | C >>> 16, f[b] = C << 8 | C >>> 24, d[b] = C;
            var C = T * 16843009 ^ O * 65537 ^ A * 257 ^ b * 16843008;
            h[_] = C << 24 | C >>> 8, p[_] = C << 16 | C >>> 16, v[_] = C << 8 | C >>> 24, m[_] = C, b ? (b = A ^ g[g[g[T ^ A]]], w ^= g[g[w]]) : b = w = 1;
          }
        })();
        var x = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], y = o.AES = a.extend({
          _doReset: function() {
            var g;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var E = this._keyPriorReset = this._key, b = E.words, w = E.sigBytes / 4, _ = this._nRounds = w + 6, A = (_ + 1) * 4, O = this._keySchedule = [], T = 0; T < A; T++)
                T < w ? O[T] = b[T] : (g = O[T - 1], T % w ? w > 6 && T % w == 4 && (g = s[g >>> 24] << 24 | s[g >>> 16 & 255] << 16 | s[g >>> 8 & 255] << 8 | s[g & 255]) : (g = g << 8 | g >>> 24, g = s[g >>> 24] << 24 | s[g >>> 16 & 255] << 16 | s[g >>> 8 & 255] << 8 | s[g & 255], g ^= x[T / w | 0] << 24), O[T] = O[T - w] ^ g);
              for (var C = this._invKeySchedule = [], $ = 0; $ < A; $++) {
                var T = A - $;
                if ($ % 4)
                  var g = O[T];
                else
                  var g = O[T - 4];
                $ < 4 || T <= 4 ? C[$] = g : C[$] = h[s[g >>> 24]] ^ p[s[g >>> 16 & 255]] ^ v[s[g >>> 8 & 255]] ^ m[s[g & 255]];
              }
            }
          },
          encryptBlock: function(g, E) {
            this._doCryptBlock(g, E, this._keySchedule, l, c, f, d, s);
          },
          decryptBlock: function(g, E) {
            var b = g[E + 1];
            g[E + 1] = g[E + 3], g[E + 3] = b, this._doCryptBlock(g, E, this._invKeySchedule, h, p, v, m, u);
            var b = g[E + 1];
            g[E + 1] = g[E + 3], g[E + 3] = b;
          },
          _doCryptBlock: function(g, E, b, w, _, A, O, T) {
            for (var C = this._nRounds, $ = g[E] ^ b[0], P = g[E + 1] ^ b[1], j = g[E + 2] ^ b[2], W = g[E + 3] ^ b[3], Y = 4, V = 1; V < C; V++) {
              var ce = w[$ >>> 24] ^ _[P >>> 16 & 255] ^ A[j >>> 8 & 255] ^ O[W & 255] ^ b[Y++], de = w[P >>> 24] ^ _[j >>> 16 & 255] ^ A[W >>> 8 & 255] ^ O[$ & 255] ^ b[Y++], L = w[j >>> 24] ^ _[W >>> 16 & 255] ^ A[$ >>> 8 & 255] ^ O[P & 255] ^ b[Y++], D = w[W >>> 24] ^ _[$ >>> 16 & 255] ^ A[P >>> 8 & 255] ^ O[j & 255] ^ b[Y++];
              $ = ce, P = de, j = L, W = D;
            }
            var ce = (T[$ >>> 24] << 24 | T[P >>> 16 & 255] << 16 | T[j >>> 8 & 255] << 8 | T[W & 255]) ^ b[Y++], de = (T[P >>> 24] << 24 | T[j >>> 16 & 255] << 16 | T[W >>> 8 & 255] << 8 | T[$ & 255]) ^ b[Y++], L = (T[j >>> 24] << 24 | T[W >>> 16 & 255] << 16 | T[$ >>> 8 & 255] << 8 | T[P & 255]) ^ b[Y++], D = (T[W >>> 24] << 24 | T[$ >>> 16 & 255] << 16 | T[P >>> 8 & 255] << 8 | T[j & 255]) ^ b[Y++];
            g[E] = ce, g[E + 1] = de, g[E + 2] = L, g[E + 3] = D;
          },
          keySize: 256 / 32
        });
        n.AES = a._createHelper(y);
      }(), r.AES;
    });
  }(vf)), vf.exports;
}
var mf = { exports: {} }, Nv;
function m2() {
  return Nv || (Nv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ji(), Li(), ni(), Ot());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = i.BlockCipher, s = n.algo, u = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], l = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], c = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], f = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], d = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], h = s.DES = o.extend({
          _doReset: function() {
            for (var x = this._key, y = x.words, g = [], E = 0; E < 56; E++) {
              var b = u[E] - 1;
              g[E] = y[b >>> 5] >>> 31 - b % 32 & 1;
            }
            for (var w = this._subKeys = [], _ = 0; _ < 16; _++) {
              for (var A = w[_] = [], O = c[_], E = 0; E < 24; E++)
                A[E / 6 | 0] |= g[(l[E] - 1 + O) % 28] << 31 - E % 6, A[4 + (E / 6 | 0)] |= g[28 + (l[E + 24] - 1 + O) % 28] << 31 - E % 6;
              A[0] = A[0] << 1 | A[0] >>> 31;
              for (var E = 1; E < 7; E++)
                A[E] = A[E] >>> (E - 1) * 4 + 3;
              A[7] = A[7] << 5 | A[7] >>> 27;
            }
            for (var T = this._invSubKeys = [], E = 0; E < 16; E++)
              T[E] = w[15 - E];
          },
          encryptBlock: function(x, y) {
            this._doCryptBlock(x, y, this._subKeys);
          },
          decryptBlock: function(x, y) {
            this._doCryptBlock(x, y, this._invSubKeys);
          },
          _doCryptBlock: function(x, y, g) {
            this._lBlock = x[y], this._rBlock = x[y + 1], p.call(this, 4, 252645135), p.call(this, 16, 65535), v.call(this, 2, 858993459), v.call(this, 8, 16711935), p.call(this, 1, 1431655765);
            for (var E = 0; E < 16; E++) {
              for (var b = g[E], w = this._lBlock, _ = this._rBlock, A = 0, O = 0; O < 8; O++)
                A |= f[O][((_ ^ b[O]) & d[O]) >>> 0];
              this._lBlock = _, this._rBlock = w ^ A;
            }
            var T = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = T, p.call(this, 1, 1431655765), v.call(this, 8, 16711935), v.call(this, 2, 858993459), p.call(this, 16, 65535), p.call(this, 4, 252645135), x[y] = this._lBlock, x[y + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function p(x, y) {
          var g = (this._lBlock >>> x ^ this._rBlock) & y;
          this._rBlock ^= g, this._lBlock ^= g << x;
        }
        function v(x, y) {
          var g = (this._rBlock >>> x ^ this._lBlock) & y;
          this._lBlock ^= g, this._rBlock ^= g << x;
        }
        n.DES = o._createHelper(h);
        var m = s.TripleDES = o.extend({
          _doReset: function() {
            var x = this._key, y = x.words;
            if (y.length !== 2 && y.length !== 4 && y.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var g = y.slice(0, 2), E = y.length < 4 ? y.slice(0, 2) : y.slice(2, 4), b = y.length < 6 ? y.slice(0, 2) : y.slice(4, 6);
            this._des1 = h.createEncryptor(a.create(g)), this._des2 = h.createEncryptor(a.create(E)), this._des3 = h.createEncryptor(a.create(b));
          },
          encryptBlock: function(x, y) {
            this._des1.encryptBlock(x, y), this._des2.decryptBlock(x, y), this._des3.encryptBlock(x, y);
          },
          decryptBlock: function(x, y) {
            this._des3.decryptBlock(x, y), this._des2.encryptBlock(x, y), this._des1.decryptBlock(x, y);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        n.TripleDES = o._createHelper(m);
      }(), r.TripleDES;
    });
  }(mf)), mf.exports;
}
var yf = { exports: {} }, Pv;
function y2() {
  return Pv || (Pv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ji(), Li(), ni(), Ot());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.StreamCipher, o = n.algo, s = o.RC4 = a.extend({
          _doReset: function() {
            for (var c = this._key, f = c.words, d = c.sigBytes, h = this._S = [], p = 0; p < 256; p++)
              h[p] = p;
            for (var p = 0, v = 0; p < 256; p++) {
              var m = p % d, x = f[m >>> 2] >>> 24 - m % 4 * 8 & 255;
              v = (v + h[p] + x) % 256;
              var y = h[p];
              h[p] = h[v], h[v] = y;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(c, f) {
            c[f] ^= u.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function u() {
          for (var c = this._S, f = this._i, d = this._j, h = 0, p = 0; p < 4; p++) {
            f = (f + 1) % 256, d = (d + c[f]) % 256;
            var v = c[f];
            c[f] = c[d], c[d] = v, h |= c[(c[f] + c[d]) % 256] << 24 - p * 8;
          }
          return this._i = f, this._j = d, h;
        }
        n.RC4 = a._createHelper(s);
        var l = o.RC4Drop = s.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: s.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            s._doReset.call(this);
            for (var c = this.cfg.drop; c > 0; c--)
              u.call(this);
          }
        });
        n.RC4Drop = a._createHelper(l);
      }(), r.RC4;
    });
  }(yf)), yf.exports;
}
var gf = { exports: {} }, $v;
function g2() {
  return $v || ($v = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ji(), Li(), ni(), Ot());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.StreamCipher, o = n.algo, s = [], u = [], l = [], c = o.Rabbit = a.extend({
          _doReset: function() {
            for (var d = this._key.words, h = this.cfg.iv, p = 0; p < 4; p++)
              d[p] = (d[p] << 8 | d[p] >>> 24) & 16711935 | (d[p] << 24 | d[p] >>> 8) & 4278255360;
            var v = this._X = [
              d[0],
              d[3] << 16 | d[2] >>> 16,
              d[1],
              d[0] << 16 | d[3] >>> 16,
              d[2],
              d[1] << 16 | d[0] >>> 16,
              d[3],
              d[2] << 16 | d[1] >>> 16
            ], m = this._C = [
              d[2] << 16 | d[2] >>> 16,
              d[0] & 4294901760 | d[1] & 65535,
              d[3] << 16 | d[3] >>> 16,
              d[1] & 4294901760 | d[2] & 65535,
              d[0] << 16 | d[0] >>> 16,
              d[2] & 4294901760 | d[3] & 65535,
              d[1] << 16 | d[1] >>> 16,
              d[3] & 4294901760 | d[0] & 65535
            ];
            this._b = 0;
            for (var p = 0; p < 4; p++)
              f.call(this);
            for (var p = 0; p < 8; p++)
              m[p] ^= v[p + 4 & 7];
            if (h) {
              var x = h.words, y = x[0], g = x[1], E = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360, b = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, w = E >>> 16 | b & 4294901760, _ = b << 16 | E & 65535;
              m[0] ^= E, m[1] ^= w, m[2] ^= b, m[3] ^= _, m[4] ^= E, m[5] ^= w, m[6] ^= b, m[7] ^= _;
              for (var p = 0; p < 4; p++)
                f.call(this);
            }
          },
          _doProcessBlock: function(d, h) {
            var p = this._X;
            f.call(this), s[0] = p[0] ^ p[5] >>> 16 ^ p[3] << 16, s[1] = p[2] ^ p[7] >>> 16 ^ p[5] << 16, s[2] = p[4] ^ p[1] >>> 16 ^ p[7] << 16, s[3] = p[6] ^ p[3] >>> 16 ^ p[1] << 16;
            for (var v = 0; v < 4; v++)
              s[v] = (s[v] << 8 | s[v] >>> 24) & 16711935 | (s[v] << 24 | s[v] >>> 8) & 4278255360, d[h + v] ^= s[v];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function f() {
          for (var d = this._X, h = this._C, p = 0; p < 8; p++)
            u[p] = h[p];
          h[0] = h[0] + 1295307597 + this._b | 0, h[1] = h[1] + 3545052371 + (h[0] >>> 0 < u[0] >>> 0 ? 1 : 0) | 0, h[2] = h[2] + 886263092 + (h[1] >>> 0 < u[1] >>> 0 ? 1 : 0) | 0, h[3] = h[3] + 1295307597 + (h[2] >>> 0 < u[2] >>> 0 ? 1 : 0) | 0, h[4] = h[4] + 3545052371 + (h[3] >>> 0 < u[3] >>> 0 ? 1 : 0) | 0, h[5] = h[5] + 886263092 + (h[4] >>> 0 < u[4] >>> 0 ? 1 : 0) | 0, h[6] = h[6] + 1295307597 + (h[5] >>> 0 < u[5] >>> 0 ? 1 : 0) | 0, h[7] = h[7] + 3545052371 + (h[6] >>> 0 < u[6] >>> 0 ? 1 : 0) | 0, this._b = h[7] >>> 0 < u[7] >>> 0 ? 1 : 0;
          for (var p = 0; p < 8; p++) {
            var v = d[p] + h[p], m = v & 65535, x = v >>> 16, y = ((m * m >>> 17) + m * x >>> 15) + x * x, g = ((v & 4294901760) * v | 0) + ((v & 65535) * v | 0);
            l[p] = y ^ g;
          }
          d[0] = l[0] + (l[7] << 16 | l[7] >>> 16) + (l[6] << 16 | l[6] >>> 16) | 0, d[1] = l[1] + (l[0] << 8 | l[0] >>> 24) + l[7] | 0, d[2] = l[2] + (l[1] << 16 | l[1] >>> 16) + (l[0] << 16 | l[0] >>> 16) | 0, d[3] = l[3] + (l[2] << 8 | l[2] >>> 24) + l[1] | 0, d[4] = l[4] + (l[3] << 16 | l[3] >>> 16) + (l[2] << 16 | l[2] >>> 16) | 0, d[5] = l[5] + (l[4] << 8 | l[4] >>> 24) + l[3] | 0, d[6] = l[6] + (l[5] << 16 | l[5] >>> 16) + (l[4] << 16 | l[4] >>> 16) | 0, d[7] = l[7] + (l[6] << 8 | l[6] >>> 24) + l[5] | 0;
        }
        n.Rabbit = a._createHelper(c);
      }(), r.Rabbit;
    });
  }(gf)), gf.exports;
}
var xf = { exports: {} }, Rv;
function x2() {
  return Rv || (Rv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ji(), Li(), ni(), Ot());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.StreamCipher, o = n.algo, s = [], u = [], l = [], c = o.RabbitLegacy = a.extend({
          _doReset: function() {
            var d = this._key.words, h = this.cfg.iv, p = this._X = [
              d[0],
              d[3] << 16 | d[2] >>> 16,
              d[1],
              d[0] << 16 | d[3] >>> 16,
              d[2],
              d[1] << 16 | d[0] >>> 16,
              d[3],
              d[2] << 16 | d[1] >>> 16
            ], v = this._C = [
              d[2] << 16 | d[2] >>> 16,
              d[0] & 4294901760 | d[1] & 65535,
              d[3] << 16 | d[3] >>> 16,
              d[1] & 4294901760 | d[2] & 65535,
              d[0] << 16 | d[0] >>> 16,
              d[2] & 4294901760 | d[3] & 65535,
              d[1] << 16 | d[1] >>> 16,
              d[3] & 4294901760 | d[0] & 65535
            ];
            this._b = 0;
            for (var m = 0; m < 4; m++)
              f.call(this);
            for (var m = 0; m < 8; m++)
              v[m] ^= p[m + 4 & 7];
            if (h) {
              var x = h.words, y = x[0], g = x[1], E = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360, b = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, w = E >>> 16 | b & 4294901760, _ = b << 16 | E & 65535;
              v[0] ^= E, v[1] ^= w, v[2] ^= b, v[3] ^= _, v[4] ^= E, v[5] ^= w, v[6] ^= b, v[7] ^= _;
              for (var m = 0; m < 4; m++)
                f.call(this);
            }
          },
          _doProcessBlock: function(d, h) {
            var p = this._X;
            f.call(this), s[0] = p[0] ^ p[5] >>> 16 ^ p[3] << 16, s[1] = p[2] ^ p[7] >>> 16 ^ p[5] << 16, s[2] = p[4] ^ p[1] >>> 16 ^ p[7] << 16, s[3] = p[6] ^ p[3] >>> 16 ^ p[1] << 16;
            for (var v = 0; v < 4; v++)
              s[v] = (s[v] << 8 | s[v] >>> 24) & 16711935 | (s[v] << 24 | s[v] >>> 8) & 4278255360, d[h + v] ^= s[v];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function f() {
          for (var d = this._X, h = this._C, p = 0; p < 8; p++)
            u[p] = h[p];
          h[0] = h[0] + 1295307597 + this._b | 0, h[1] = h[1] + 3545052371 + (h[0] >>> 0 < u[0] >>> 0 ? 1 : 0) | 0, h[2] = h[2] + 886263092 + (h[1] >>> 0 < u[1] >>> 0 ? 1 : 0) | 0, h[3] = h[3] + 1295307597 + (h[2] >>> 0 < u[2] >>> 0 ? 1 : 0) | 0, h[4] = h[4] + 3545052371 + (h[3] >>> 0 < u[3] >>> 0 ? 1 : 0) | 0, h[5] = h[5] + 886263092 + (h[4] >>> 0 < u[4] >>> 0 ? 1 : 0) | 0, h[6] = h[6] + 1295307597 + (h[5] >>> 0 < u[5] >>> 0 ? 1 : 0) | 0, h[7] = h[7] + 3545052371 + (h[6] >>> 0 < u[6] >>> 0 ? 1 : 0) | 0, this._b = h[7] >>> 0 < u[7] >>> 0 ? 1 : 0;
          for (var p = 0; p < 8; p++) {
            var v = d[p] + h[p], m = v & 65535, x = v >>> 16, y = ((m * m >>> 17) + m * x >>> 15) + x * x, g = ((v & 4294901760) * v | 0) + ((v & 65535) * v | 0);
            l[p] = y ^ g;
          }
          d[0] = l[0] + (l[7] << 16 | l[7] >>> 16) + (l[6] << 16 | l[6] >>> 16) | 0, d[1] = l[1] + (l[0] << 8 | l[0] >>> 24) + l[7] | 0, d[2] = l[2] + (l[1] << 16 | l[1] >>> 16) + (l[0] << 16 | l[0] >>> 16) | 0, d[3] = l[3] + (l[2] << 8 | l[2] >>> 24) + l[1] | 0, d[4] = l[4] + (l[3] << 16 | l[3] >>> 16) + (l[2] << 16 | l[2] >>> 16) | 0, d[5] = l[5] + (l[4] << 8 | l[4] >>> 24) + l[3] | 0, d[6] = l[6] + (l[5] << 16 | l[5] >>> 16) + (l[4] << 16 | l[4] >>> 16) | 0, d[7] = l[7] + (l[6] << 8 | l[6] >>> 24) + l[5] | 0;
        }
        n.RabbitLegacy = a._createHelper(c);
      }(), r.RabbitLegacy;
    });
  }(xf)), xf.exports;
}
var bf = { exports: {} }, Mv;
function b2() {
  return Mv || (Mv = 1, function(e, t) {
    (function(r, n, i) {
      e.exports = n(Pe(), ji(), Li(), ni(), Ot());
    })(he, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.BlockCipher, o = n.algo;
        const s = 16, u = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], l = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var c = {
          pbox: [],
          sbox: []
        };
        function f(m, x) {
          let y = x >> 24 & 255, g = x >> 16 & 255, E = x >> 8 & 255, b = x & 255, w = m.sbox[0][y] + m.sbox[1][g];
          return w = w ^ m.sbox[2][E], w = w + m.sbox[3][b], w;
        }
        function d(m, x, y) {
          let g = x, E = y, b;
          for (let w = 0; w < s; ++w)
            g = g ^ m.pbox[w], E = f(m, g) ^ E, b = g, g = E, E = b;
          return b = g, g = E, E = b, E = E ^ m.pbox[s], g = g ^ m.pbox[s + 1], { left: g, right: E };
        }
        function h(m, x, y) {
          let g = x, E = y, b;
          for (let w = s + 1; w > 1; --w)
            g = g ^ m.pbox[w], E = f(m, g) ^ E, b = g, g = E, E = b;
          return b = g, g = E, E = b, E = E ^ m.pbox[1], g = g ^ m.pbox[0], { left: g, right: E };
        }
        function p(m, x, y) {
          for (let _ = 0; _ < 4; _++) {
            m.sbox[_] = [];
            for (let A = 0; A < 256; A++)
              m.sbox[_][A] = l[_][A];
          }
          let g = 0;
          for (let _ = 0; _ < s + 2; _++)
            m.pbox[_] = u[_] ^ x[g], g++, g >= y && (g = 0);
          let E = 0, b = 0, w = 0;
          for (let _ = 0; _ < s + 2; _ += 2)
            w = d(m, E, b), E = w.left, b = w.right, m.pbox[_] = E, m.pbox[_ + 1] = b;
          for (let _ = 0; _ < 4; _++)
            for (let A = 0; A < 256; A += 2)
              w = d(m, E, b), E = w.left, b = w.right, m.sbox[_][A] = E, m.sbox[_][A + 1] = b;
          return !0;
        }
        var v = o.Blowfish = a.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var m = this._keyPriorReset = this._key, x = m.words, y = m.sigBytes / 4;
              p(c, x, y);
            }
          },
          encryptBlock: function(m, x) {
            var y = d(c, m[x], m[x + 1]);
            m[x] = y.left, m[x + 1] = y.right;
          },
          decryptBlock: function(m, x) {
            var y = h(c, m[x], m[x + 1]);
            m[x] = y.left, m[x + 1] = y.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        n.Blowfish = a._createHelper(v);
      }(), r.Blowfish;
    });
  }(bf)), bf.exports;
}
(function(e, t) {
  (function(r, n, i) {
    e.exports = n(Pe(), Cl(), QC(), XC(), ji(), JC(), Li(), cb(), j0(), ZC(), fb(), e2(), t2(), r2(), L0(), n2(), ni(), Ot(), i2(), a2(), o2(), s2(), u2(), l2(), c2(), f2(), d2(), h2(), p2(), v2(), m2(), y2(), g2(), x2(), b2());
  })(he, function(r) {
    return r;
  });
})(lb);
var es = lb.exports;
const E2 = /* @__PURE__ */ Nt(es);
var Dt = {}, jt = {}, lr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = Object.prototype.hasOwnProperty;
  e.has = function(f, d) {
    return t.call(f, d);
  };
  function r(f, d) {
    return f < d ? -1 : f === d ? 0 : 1;
  }
  e.defaultCompare = r;
  function n(f, d) {
    return f === d;
  }
  e.defaultEquals = n;
  function i(f) {
    return f === null ? "COLLECTION_NULL" : s(f) ? "COLLECTION_UNDEFINED" : u(f) ? "$s" + f : "$o" + f.toString();
  }
  e.defaultToString = i;
  function a(f, d) {
    if (d === void 0 && (d = ","), f === null)
      return "COLLECTION_NULL";
    if (s(f))
      return "COLLECTION_UNDEFINED";
    if (u(f))
      return f.toString();
    var h = "{", p = !0;
    for (var v in f)
      e.has(f, v) && (p ? p = !1 : h = h + d, h = h + v + ":" + f[v]);
    return h + "}";
  }
  e.makeString = a;
  function o(f) {
    return typeof f == "function";
  }
  e.isFunction = o;
  function s(f) {
    return typeof f > "u";
  }
  e.isUndefined = s;
  function u(f) {
    return Object.prototype.toString.call(f) === "[object String]";
  }
  e.isString = u;
  function l(f) {
    return s(f) || !o(f) ? function(d, h) {
      return d < h ? 1 : d === h ? 0 : -1;
    } : function(d, h) {
      return f(d, h) * -1;
    };
  }
  e.reverseCompareFunction = l;
  function c(f) {
    return function(d, h) {
      return f(d, h) === 0;
    };
  }
  e.compareToEquals = c;
})(lr);
Object.defineProperty(jt, "__esModule", { value: !0 });
var Ol = lr;
function U0(e, t, r) {
  for (var n = r || Ol.defaultEquals, i = e.length, a = 0; a < i; a++)
    if (n(e[a], t))
      return a;
  return -1;
}
jt.indexOf = U0;
function w2(e, t, r) {
  for (var n = r || Ol.defaultEquals, i = e.length, a = i - 1; a >= 0; a--)
    if (n(e[a], t))
      return a;
  return -1;
}
jt.lastIndexOf = w2;
function S2(e, t, r) {
  return U0(e, t, r) >= 0;
}
jt.contains = S2;
function _2(e, t, r) {
  var n = U0(e, t, r);
  return n < 0 ? !1 : (e.splice(n, 1), !0);
}
jt.remove = _2;
function T2(e, t, r) {
  for (var n = r || Ol.defaultEquals, i = e.length, a = 0, o = 0; o < i; o++)
    n(e[o], t) && a++;
  return a;
}
jt.frequency = T2;
function A2(e, t, r) {
  var n = r || Ol.defaultEquals;
  if (e.length !== t.length)
    return !1;
  for (var i = e.length, a = 0; a < i; a++)
    if (!n(e[a], t[a]))
      return !1;
  return !0;
}
jt.equals = A2;
function C2(e) {
  return e.concat();
}
jt.copy = C2;
function O2(e, t, r) {
  if (t < 0 || t >= e.length || r < 0 || r >= e.length)
    return !1;
  var n = e[t];
  return e[t] = e[r], e[r] = n, !0;
}
jt.swap = O2;
function D2(e) {
  return "[" + e.toString() + "]";
}
jt.toString = D2;
function F2(e, t) {
  for (var r = 0, n = e; r < n.length; r++) {
    var i = n[r];
    if (t(i) === !1)
      return;
  }
}
jt.forEach = F2;
var H0 = {}, ii = {};
Object.defineProperty(ii, "__esModule", { value: !0 });
var Wr = lr, I2 = (
  /** @class */
  function() {
    function e(t) {
      this.table = {}, this.nElements = 0, this.toStr = t || Wr.defaultToString;
    }
    return e.prototype.getValue = function(t) {
      var r = this.table["$" + this.toStr(t)];
      if (!Wr.isUndefined(r))
        return r.value;
    }, e.prototype.setValue = function(t, r) {
      if (!(Wr.isUndefined(t) || Wr.isUndefined(r))) {
        var n, i = "$" + this.toStr(t), a = this.table[i];
        return Wr.isUndefined(a) ? (this.nElements++, n = void 0) : n = a.value, this.table[i] = {
          key: t,
          value: r
        }, n;
      }
    }, e.prototype.remove = function(t) {
      var r = "$" + this.toStr(t), n = this.table[r];
      if (!Wr.isUndefined(n))
        return delete this.table[r], this.nElements--, n.value;
    }, e.prototype.keys = function() {
      var t = [];
      for (var r in this.table)
        if (Wr.has(this.table, r)) {
          var n = this.table[r];
          t.push(n.key);
        }
      return t;
    }, e.prototype.values = function() {
      var t = [];
      for (var r in this.table)
        if (Wr.has(this.table, r)) {
          var n = this.table[r];
          t.push(n.value);
        }
      return t;
    }, e.prototype.forEach = function(t) {
      for (var r in this.table)
        if (Wr.has(this.table, r)) {
          var n = this.table[r], i = t(n.key, n.value);
          if (i === !1)
            return;
        }
    }, e.prototype.containsKey = function(t) {
      return !Wr.isUndefined(this.getValue(t));
    }, e.prototype.clear = function() {
      this.table = {}, this.nElements = 0;
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.isEmpty = function() {
      return this.nElements <= 0;
    }, e.prototype.toString = function() {
      var t = "{";
      return this.forEach(function(r, n) {
        t += `
	` + r + " : " + n;
      }), t + `
}`;
    }, e;
  }()
);
ii.default = I2;
var Dl = {};
Object.defineProperty(Dl, "__esModule", { value: !0 });
var k2 = lr, N2 = jt, P2 = ii, $2 = (
  /** @class */
  function() {
    function e(t) {
      this.dictionary = new P2.default(t);
    }
    return e.prototype.contains = function(t) {
      return this.dictionary.containsKey(t);
    }, e.prototype.add = function(t) {
      return this.contains(t) || k2.isUndefined(t) ? !1 : (this.dictionary.setValue(t, t), !0);
    }, e.prototype.intersection = function(t) {
      var r = this;
      this.forEach(function(n) {
        return t.contains(n) || r.remove(n), !0;
      });
    }, e.prototype.union = function(t) {
      var r = this;
      t.forEach(function(n) {
        return r.add(n), !0;
      });
    }, e.prototype.difference = function(t) {
      var r = this;
      t.forEach(function(n) {
        return r.remove(n), !0;
      });
    }, e.prototype.isSubsetOf = function(t) {
      if (this.size() > t.size())
        return !1;
      var r = !0;
      return this.forEach(function(n) {
        return t.contains(n) ? !0 : (r = !1, !1);
      }), r;
    }, e.prototype.remove = function(t) {
      return this.contains(t) ? (this.dictionary.remove(t), !0) : !1;
    }, e.prototype.forEach = function(t) {
      this.dictionary.forEach(function(r, n) {
        return t(n);
      });
    }, e.prototype.toArray = function() {
      return this.dictionary.values();
    }, e.prototype.isEmpty = function() {
      return this.dictionary.isEmpty();
    }, e.prototype.size = function() {
      return this.dictionary.size();
    }, e.prototype.clear = function() {
      this.dictionary.clear();
    }, e.prototype.toString = function() {
      return N2.toString(this.toArray());
    }, e;
  }()
);
Dl.default = $2;
Object.defineProperty(H0, "__esModule", { value: !0 });
var Ef = lr, R2 = ii, M2 = Dl, B2 = (
  /** @class */
  function() {
    function e(t) {
      this.toStrF = t || Ef.defaultToString, this.dictionary = new R2.default(this.toStrF), this.nElements = 0;
    }
    return e.prototype.add = function(t, r) {
      if (r === void 0 && (r = 1), Ef.isUndefined(t) || r <= 0)
        return !1;
      if (this.contains(t))
        this.dictionary.getValue(t).copies += r;
      else {
        var n = {
          value: t,
          copies: r
        };
        this.dictionary.setValue(t, n);
      }
      return this.nElements += r, !0;
    }, e.prototype.count = function(t) {
      return this.contains(t) ? this.dictionary.getValue(t).copies : 0;
    }, e.prototype.contains = function(t) {
      return this.dictionary.containsKey(t);
    }, e.prototype.remove = function(t, r) {
      if (r === void 0 && (r = 1), Ef.isUndefined(t) || r <= 0)
        return !1;
      if (this.contains(t)) {
        var n = this.dictionary.getValue(t);
        return r > n.copies ? this.nElements -= n.copies : this.nElements -= r, n.copies -= r, n.copies <= 0 && this.dictionary.remove(t), !0;
      } else
        return !1;
    }, e.prototype.toArray = function() {
      for (var t = [], r = this.dictionary.values(), n = 0, i = r; n < i.length; n++)
        for (var a = i[n], o = a.value, s = a.copies, u = 0; u < s; u++)
          t.push(o);
      return t;
    }, e.prototype.toSet = function() {
      for (var t = new M2.default(this.toStrF), r = this.dictionary.values(), n = 0, i = r; n < i.length; n++) {
        var a = i[n], o = a.value;
        t.add(o);
      }
      return t;
    }, e.prototype.forEach = function(t) {
      this.dictionary.forEach(function(r, n) {
        for (var i = n.value, a = n.copies, o = 0; o < a; o++)
          if (t(i) === !1)
            return !1;
        return !0;
      });
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.isEmpty = function() {
      return this.nElements === 0;
    }, e.prototype.clear = function() {
      this.nElements = 0, this.dictionary.clear();
    }, e;
  }()
);
H0.default = B2;
var W0 = {}, Fl = {}, Il = {}, ts = {};
Object.defineProperty(ts, "__esModule", { value: !0 });
var ci = lr, j2 = jt, L2 = (
  /** @class */
  function() {
    function e() {
      this.firstNode = null, this.lastNode = null, this.nElements = 0;
    }
    return e.prototype.add = function(t, r) {
      if (ci.isUndefined(r) && (r = this.nElements), r < 0 || r > this.nElements || ci.isUndefined(t))
        return !1;
      var n = this.createNode(t);
      if (this.nElements === 0 || this.lastNode === null)
        this.firstNode = n, this.lastNode = n;
      else if (r === this.nElements)
        this.lastNode.next = n, this.lastNode = n;
      else if (r === 0)
        n.next = this.firstNode, this.firstNode = n;
      else {
        var i = this.nodeAtIndex(r - 1);
        if (i === null)
          return !1;
        n.next = i.next, i.next = n;
      }
      return this.nElements++, !0;
    }, e.prototype.first = function() {
      if (this.firstNode !== null)
        return this.firstNode.element;
    }, e.prototype.last = function() {
      if (this.lastNode !== null)
        return this.lastNode.element;
    }, e.prototype.elementAtIndex = function(t) {
      var r = this.nodeAtIndex(t);
      if (r !== null)
        return r.element;
    }, e.prototype.indexOf = function(t, r) {
      var n = r || ci.defaultEquals;
      if (ci.isUndefined(t))
        return -1;
      for (var i = this.firstNode, a = 0; i !== null; ) {
        if (n(i.element, t))
          return a;
        a++, i = i.next;
      }
      return -1;
    }, e.prototype.contains = function(t, r) {
      return this.indexOf(t, r) >= 0;
    }, e.prototype.remove = function(t, r) {
      var n = r || ci.defaultEquals;
      if (this.nElements < 1 || ci.isUndefined(t))
        return !1;
      for (var i = null, a = this.firstNode; a !== null; ) {
        if (n(a.element, t))
          return i === null ? (this.firstNode = a.next, a === this.lastNode && (this.lastNode = null)) : a === this.lastNode ? (this.lastNode = i, i.next = a.next, a.next = null) : (i.next = a.next, a.next = null), this.nElements--, !0;
        i = a, a = a.next;
      }
      return !1;
    }, e.prototype.clear = function() {
      this.firstNode = null, this.lastNode = null, this.nElements = 0;
    }, e.prototype.equals = function(t, r) {
      var n = r || ci.defaultEquals;
      return !(t instanceof e) || this.size() !== t.size() ? !1 : this.equalsAux(this.firstNode, t.firstNode, n);
    }, e.prototype.equalsAux = function(t, r, n) {
      for (; t !== null && r !== null; ) {
        if (!n(t.element, r.element))
          return !1;
        t = t.next, r = r.next;
      }
      return !0;
    }, e.prototype.removeElementAtIndex = function(t) {
      if (!(t < 0 || t >= this.nElements || this.firstNode === null || this.lastNode === null)) {
        var r;
        if (this.nElements === 1)
          r = this.firstNode.element, this.firstNode = null, this.lastNode = null;
        else {
          var n = this.nodeAtIndex(t - 1);
          n === null ? (r = this.firstNode.element, this.firstNode = this.firstNode.next) : n.next === this.lastNode && (r = this.lastNode.element, this.lastNode = n), n !== null && n.next !== null && (r = n.next.element, n.next = n.next.next);
        }
        return this.nElements--, r;
      }
    }, e.prototype.forEach = function(t) {
      for (var r = this.firstNode; r !== null && t(r.element) !== !1; )
        r = r.next;
    }, e.prototype.reverse = function() {
      for (var t = null, r = this.firstNode, n = null; r !== null; )
        n = r.next, r.next = t, t = r, r = n;
      n = this.firstNode, this.firstNode = this.lastNode, this.lastNode = n;
    }, e.prototype.toArray = function() {
      for (var t = [], r = this.firstNode; r !== null; )
        t.push(r.element), r = r.next;
      return t;
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.isEmpty = function() {
      return this.nElements <= 0;
    }, e.prototype.toString = function() {
      return j2.toString(this.toArray());
    }, e.prototype.nodeAtIndex = function(t) {
      if (t < 0 || t >= this.nElements)
        return null;
      if (t === this.nElements - 1)
        return this.lastNode;
      for (var r = this.firstNode, n = 0; n < t && r !== null; n++)
        r = r.next;
      return r;
    }, e.prototype.createNode = function(t) {
      return {
        element: t,
        next: null
      };
    }, e;
  }()
);
ts.default = L2;
Object.defineProperty(Il, "__esModule", { value: !0 });
var U2 = ts, H2 = (
  /** @class */
  function() {
    function e() {
      this.list = new U2.default();
    }
    return e.prototype.enqueue = function(t) {
      return this.list.add(t);
    }, e.prototype.add = function(t) {
      return this.list.add(t);
    }, e.prototype.dequeue = function() {
      if (this.list.size() !== 0) {
        var t = this.list.first();
        return this.list.removeElementAtIndex(0), t;
      }
    }, e.prototype.peek = function() {
      if (this.list.size() !== 0)
        return this.list.first();
    }, e.prototype.size = function() {
      return this.list.size();
    }, e.prototype.contains = function(t, r) {
      return this.list.contains(t, r);
    }, e.prototype.isEmpty = function() {
      return this.list.size() <= 0;
    }, e.prototype.clear = function() {
      this.list.clear();
    }, e.prototype.forEach = function(t) {
      this.list.forEach(t);
    }, e;
  }()
);
Il.default = H2;
Object.defineProperty(Fl, "__esModule", { value: !0 });
var wf = lr, W2 = Il, z2 = (
  /** @class */
  function() {
    function e(t) {
      this.root = null, this.compare = t || wf.defaultCompare, this.nElements = 0;
    }
    return e.prototype.add = function(t) {
      return wf.isUndefined(t) ? !1 : this.insertNode(this.createNode(t)) !== null ? (this.nElements++, !0) : !1;
    }, e.prototype.clear = function() {
      this.root = null, this.nElements = 0;
    }, e.prototype.isEmpty = function() {
      return this.nElements === 0;
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.contains = function(t) {
      return wf.isUndefined(t) ? !1 : this.searchNode(this.root, t) !== null;
    }, e.prototype.search = function(t) {
      var r = this.searchNode(this.root, t);
      if (r !== null)
        return r.element;
    }, e.prototype.remove = function(t) {
      var r = this.searchNode(this.root, t);
      return r === null ? !1 : (this.removeNode(r), this.nElements--, !0);
    }, e.prototype.inorderTraversal = function(t) {
      this.inorderTraversalAux(this.root, t, {
        stop: !1
      });
    }, e.prototype.preorderTraversal = function(t) {
      this.preorderTraversalAux(this.root, t, {
        stop: !1
      });
    }, e.prototype.postorderTraversal = function(t) {
      this.postorderTraversalAux(this.root, t, {
        stop: !1
      });
    }, e.prototype.levelTraversal = function(t) {
      this.levelTraversalAux(this.root, t);
    }, e.prototype.minimum = function() {
      if (!(this.isEmpty() || this.root === null))
        return this.minimumAux(this.root).element;
    }, e.prototype.maximum = function() {
      if (!(this.isEmpty() || this.root === null))
        return this.maximumAux(this.root).element;
    }, e.prototype.forEach = function(t) {
      this.inorderTraversal(t);
    }, e.prototype.toArray = function() {
      var t = [];
      return this.inorderTraversal(function(r) {
        return t.push(r), !0;
      }), t;
    }, e.prototype.height = function() {
      return this.heightAux(this.root);
    }, e.prototype.searchNode = function(t, r) {
      for (var n = 1; t !== null && n !== 0; )
        n = this.compare(r, t.element), n < 0 ? t = t.leftCh : n > 0 && (t = t.rightCh);
      return t;
    }, e.prototype.transplant = function(t, r) {
      t.parent === null ? this.root = r : t === t.parent.leftCh ? t.parent.leftCh = r : t.parent.rightCh = r, r !== null && (r.parent = t.parent);
    }, e.prototype.removeNode = function(t) {
      if (t.leftCh === null)
        this.transplant(t, t.rightCh);
      else if (t.rightCh === null)
        this.transplant(t, t.leftCh);
      else {
        var r = this.minimumAux(t.rightCh);
        r.parent !== t && (this.transplant(r, r.rightCh), r.rightCh = t.rightCh, r.rightCh.parent = r), this.transplant(t, r), r.leftCh = t.leftCh, r.leftCh.parent = r;
      }
    }, e.prototype.inorderTraversalAux = function(t, r, n) {
      t === null || n.stop || (this.inorderTraversalAux(t.leftCh, r, n), !n.stop && (n.stop = r(t.element) === !1, !n.stop && this.inorderTraversalAux(t.rightCh, r, n)));
    }, e.prototype.levelTraversalAux = function(t, r) {
      var n = new W2.default();
      for (t !== null && n.enqueue(t), t = n.dequeue() || null; t != null; ) {
        if (r(t.element) === !1)
          return;
        t.leftCh !== null && n.enqueue(t.leftCh), t.rightCh !== null && n.enqueue(t.rightCh), t = n.dequeue() || null;
      }
    }, e.prototype.preorderTraversalAux = function(t, r, n) {
      t === null || n.stop || (n.stop = r(t.element) === !1, !n.stop && (this.preorderTraversalAux(t.leftCh, r, n), !n.stop && this.preorderTraversalAux(t.rightCh, r, n)));
    }, e.prototype.postorderTraversalAux = function(t, r, n) {
      t === null || n.stop || (this.postorderTraversalAux(t.leftCh, r, n), !n.stop && (this.postorderTraversalAux(t.rightCh, r, n), !n.stop && (n.stop = r(t.element) === !1)));
    }, e.prototype.minimumAux = function(t) {
      for (; t != null && t.leftCh !== null; )
        t = t.leftCh;
      return t;
    }, e.prototype.maximumAux = function(t) {
      for (; t != null && t.rightCh !== null; )
        t = t.rightCh;
      return t;
    }, e.prototype.heightAux = function(t) {
      return t === null ? -1 : Math.max(this.heightAux(t.leftCh), this.heightAux(t.rightCh)) + 1;
    }, e.prototype.insertNode = function(t) {
      for (var r = null, n = this.root; n !== null; ) {
        var i = this.compare(t.element, n.element);
        if (i === 0)
          return null;
        i < 0 ? (r = n, n = n.leftCh) : (r = n, n = n.rightCh);
      }
      return t.parent = r, r === null ? this.root = t : this.compare(t.element, r.element) < 0 ? r.leftCh = t : r.rightCh = t, t;
    }, e.prototype.createNode = function(t) {
      return {
        element: t,
        leftCh: null,
        rightCh: null,
        parent: null
      };
    }, e;
  }()
);
Fl.default = z2;
var q2 = he && he.__extends || function() {
  var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r)
      r.hasOwnProperty(n) && (t[n] = r[n]);
  };
  return function(t, r) {
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(W0, "__esModule", { value: !0 });
var Y2 = Fl, V2 = (
  /** @class */
  function(e) {
    q2(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Y2.default)
);
W0.default = V2;
var kl = {};
Object.defineProperty(kl, "__esModule", { value: !0 });
var Sf = lr, Fs = jt, G2 = (
  /** @class */
  function() {
    function e(t) {
      this.data = [], this.compare = t || Sf.defaultCompare;
    }
    return e.prototype.leftChildIndex = function(t) {
      return 2 * t + 1;
    }, e.prototype.rightChildIndex = function(t) {
      return 2 * t + 2;
    }, e.prototype.parentIndex = function(t) {
      return Math.floor((t - 1) / 2);
    }, e.prototype.minIndex = function(t, r) {
      return r >= this.data.length ? t >= this.data.length ? -1 : t : this.compare(this.data[t], this.data[r]) <= 0 ? t : r;
    }, e.prototype.siftUp = function(t) {
      for (var r = this.parentIndex(t); t > 0 && this.compare(this.data[r], this.data[t]) > 0; )
        Fs.swap(this.data, r, t), t = r, r = this.parentIndex(t);
    }, e.prototype.siftDown = function(t) {
      for (var r = this.minIndex(this.leftChildIndex(t), this.rightChildIndex(t)); r >= 0 && this.compare(this.data[t], this.data[r]) > 0; )
        Fs.swap(this.data, r, t), t = r, r = this.minIndex(this.leftChildIndex(t), this.rightChildIndex(t));
    }, e.prototype.peek = function() {
      if (this.data.length > 0)
        return this.data[0];
    }, e.prototype.add = function(t) {
      return Sf.isUndefined(t) ? !1 : (this.data.push(t), this.siftUp(this.data.length - 1), !0);
    }, e.prototype.removeRoot = function() {
      if (this.data.length > 0) {
        var t = this.data[0];
        return this.data[0] = this.data[this.data.length - 1], this.data.splice(this.data.length - 1, 1), this.data.length > 0 && this.siftDown(0), t;
      }
    }, e.prototype.contains = function(t) {
      var r = Sf.compareToEquals(this.compare);
      return Fs.contains(this.data, t, r);
    }, e.prototype.size = function() {
      return this.data.length;
    }, e.prototype.isEmpty = function() {
      return this.data.length <= 0;
    }, e.prototype.clear = function() {
      this.data.length = 0;
    }, e.prototype.forEach = function(t) {
      Fs.forEach(this.data, t);
    }, e;
  }()
);
kl.default = G2;
var z0 = {}, K2 = he && he.__extends || function() {
  var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r)
      r.hasOwnProperty(n) && (t[n] = r[n]);
  };
  return function(t, r) {
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(z0, "__esModule", { value: !0 });
var Q2 = ii, Xi = lr, X2 = (
  /** @class */
  function() {
    function e(t, r) {
      this.key = t, this.value = r;
    }
    return e.prototype.unlink = function() {
      this.prev.next = this.next, this.next.prev = this.prev;
    }, e;
  }()
), Bv = (
  /** @class */
  function() {
    function e() {
      this.key = null, this.value = null;
    }
    return e.prototype.unlink = function() {
      this.prev.next = this.next, this.next.prev = this.prev;
    }, e;
  }()
);
function J2(e) {
  return !e.next;
}
var Z2 = (
  /** @class */
  function(e) {
    K2(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.head = new Bv(), n.tail = new Bv(), n.head.next = n.tail, n.tail.prev = n.head, n;
    }
    return t.prototype.appendToTail = function(r) {
      var n = this.tail.prev;
      n.next = r, r.prev = n, r.next = this.tail, this.tail.prev = r;
    }, t.prototype.getLinkedDictionaryPair = function(r) {
      if (!Xi.isUndefined(r)) {
        var n = "$" + this.toStr(r), i = this.table[n];
        return i;
      }
    }, t.prototype.getValue = function(r) {
      var n = this.getLinkedDictionaryPair(r);
      if (!Xi.isUndefined(n))
        return n.value;
    }, t.prototype.remove = function(r) {
      var n = this.getLinkedDictionaryPair(r);
      if (!Xi.isUndefined(n))
        return e.prototype.remove.call(this, r), n.unlink(), n.value;
    }, t.prototype.clear = function() {
      e.prototype.clear.call(this), this.head.next = this.tail, this.tail.prev = this.head;
    }, t.prototype.replace = function(r, n) {
      var i = "$" + this.toStr(n.key);
      n.next = r.next, n.prev = r.prev, this.remove(r.key), n.prev.next = n, n.next.prev = n, this.table[i] = n, ++this.nElements;
    }, t.prototype.setValue = function(r, n) {
      if (!(Xi.isUndefined(r) || Xi.isUndefined(n))) {
        var i = this.getLinkedDictionaryPair(r), a = new X2(r, n), o = "$" + this.toStr(r);
        if (Xi.isUndefined(i)) {
          this.appendToTail(a), this.table[o] = a, ++this.nElements;
          return;
        } else
          return this.replace(i, a), i.value;
      }
    }, t.prototype.keys = function() {
      var r = [];
      return this.forEach(function(n, i) {
        r.push(n);
      }), r;
    }, t.prototype.values = function() {
      var r = [];
      return this.forEach(function(n, i) {
        r.push(i);
      }), r;
    }, t.prototype.forEach = function(r) {
      for (var n = this.head.next; !J2(n); ) {
        var i = r(n.key, n.value);
        if (i === !1)
          return;
        n = n.next;
      }
    }, t;
  }(Q2.default)
);
z0.default = Z2;
var q0 = {};
Object.defineProperty(q0, "__esModule", { value: !0 });
var kn = lr, eO = ii, _f = jt, tO = (
  /** @class */
  function() {
    function e(t, r, n) {
      n === void 0 && (n = !1), this.dict = new eO.default(t), this.equalsF = r || kn.defaultEquals, this.allowDuplicate = n;
    }
    return e.prototype.getValue = function(t) {
      var r = this.dict.getValue(t);
      return kn.isUndefined(r) ? [] : _f.copy(r);
    }, e.prototype.setValue = function(t, r) {
      if (kn.isUndefined(t) || kn.isUndefined(r))
        return !1;
      var n = this.dict.getValue(t);
      return kn.isUndefined(n) ? (this.dict.setValue(t, [r]), !0) : !this.allowDuplicate && _f.contains(n, r, this.equalsF) ? !1 : (n.push(r), !0);
    }, e.prototype.remove = function(t, r) {
      if (kn.isUndefined(r)) {
        var n = this.dict.remove(t);
        return !kn.isUndefined(n);
      }
      var i = this.dict.getValue(t);
      return !kn.isUndefined(i) && _f.remove(i, r, this.equalsF) ? (i.length === 0 && this.dict.remove(t), !0) : !1;
    }, e.prototype.keys = function() {
      return this.dict.keys();
    }, e.prototype.values = function() {
      for (var t = this.dict.values(), r = [], n = 0, i = t; n < i.length; n++)
        for (var a = i[n], o = 0, s = a; o < s.length; o++) {
          var u = s[o];
          r.push(u);
        }
      return r;
    }, e.prototype.containsKey = function(t) {
      return this.dict.containsKey(t);
    }, e.prototype.clear = function() {
      this.dict.clear();
    }, e.prototype.size = function() {
      return this.dict.size();
    }, e.prototype.isEmpty = function() {
      return this.dict.isEmpty();
    }, e;
  }()
);
q0.default = tO;
var Nl = {}, rO = he && he.__extends || function() {
  var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r)
      r.hasOwnProperty(n) && (t[n] = r[n]);
  };
  return function(t, r) {
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Nl, "__esModule", { value: !0 });
var nO = ii, iO = lr, aO = (
  /** @class */
  function(e) {
    rO(t, e);
    function t(r, n) {
      var i = e.call(this, n) || this;
      return i.defaultFactoryFunction = r, i;
    }
    return t.prototype.setDefault = function(r, n) {
      var i = e.prototype.getValue.call(this, r);
      return iO.isUndefined(i) ? (this.setValue(r, n), n) : i;
    }, t.prototype.getValue = function(r) {
      return this.setDefault(r, this.defaultFactoryFunction());
    }, t;
  }(nO.default)
);
Nl.default = aO;
var Y0 = {};
Object.defineProperty(Y0, "__esModule", { value: !0 });
var oO = lr, sO = kl, uO = (
  /** @class */
  function() {
    function e(t) {
      this.heap = new sO.default(oO.reverseCompareFunction(t));
    }
    return e.prototype.enqueue = function(t) {
      return this.heap.add(t);
    }, e.prototype.add = function(t) {
      return this.heap.add(t);
    }, e.prototype.dequeue = function() {
      if (this.heap.size() !== 0) {
        var t = this.heap.peek();
        return this.heap.removeRoot(), t;
      }
    }, e.prototype.peek = function() {
      return this.heap.peek();
    }, e.prototype.contains = function(t) {
      return this.heap.contains(t);
    }, e.prototype.isEmpty = function() {
      return this.heap.isEmpty();
    }, e.prototype.size = function() {
      return this.heap.size();
    }, e.prototype.clear = function() {
      this.heap.clear();
    }, e.prototype.forEach = function(t) {
      this.heap.forEach(t);
    }, e;
  }()
);
Y0.default = uO;
var V0 = {};
Object.defineProperty(V0, "__esModule", { value: !0 });
var lO = ts, cO = (
  /** @class */
  function() {
    function e() {
      this.list = new lO.default();
    }
    return e.prototype.push = function(t) {
      return this.list.add(t, 0);
    }, e.prototype.add = function(t) {
      return this.list.add(t, 0);
    }, e.prototype.pop = function() {
      return this.list.removeElementAtIndex(0);
    }, e.prototype.peek = function() {
      return this.list.first();
    }, e.prototype.size = function() {
      return this.list.size();
    }, e.prototype.contains = function(t, r) {
      return this.list.contains(t, r);
    }, e.prototype.isEmpty = function() {
      return this.list.isEmpty();
    }, e.prototype.clear = function() {
      this.list.clear();
    }, e.prototype.forEach = function(t) {
      this.list.forEach(t);
    }, e;
  }()
);
V0.default = cO;
var G0 = {};
Object.defineProperty(G0, "__esModule", { value: !0 });
var vt;
(function(e) {
  e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER", e[e.INSIDE_AT_END = 2] = "INSIDE_AT_END", e[e.INSIDE_AT_START = 3] = "INSIDE_AT_START";
})(vt || (vt = {}));
var fO = (
  /** @class */
  function() {
    function e(t, r) {
      t === void 0 && (t = []), r === void 0 && (r = {}), this.rootIds = t, this.nodes = r, this.initRootIds(), this.initNodes();
    }
    return e.prototype.initRootIds = function() {
      for (var t = 0, r = this.rootIds; t < r.length; t++) {
        var n = r[t];
        this.createEmptyNodeIfNotExist(n);
      }
    }, e.prototype.initNodes = function() {
      for (var t in this.nodes)
        if (this.nodes.hasOwnProperty(t))
          for (var r = 0, n = this.nodes[t]; r < n.length; r++) {
            var i = n[r];
            this.createEmptyNodeIfNotExist(i);
          }
    }, e.prototype.createEmptyNodeIfNotExist = function(t) {
      this.nodes[t] || (this.nodes[t] = []);
    }, e.prototype.getRootIds = function() {
      var t = this.rootIds.slice();
      return t;
    }, e.prototype.getNodes = function() {
      var t = {};
      for (var r in this.nodes)
        this.nodes.hasOwnProperty(r) && (t[r] = this.nodes[r].slice());
      return t;
    }, e.prototype.getObject = function() {
      return {
        rootIds: this.getRootIds(),
        nodes: this.getNodes()
      };
    }, e.prototype.toObject = function() {
      return this.getObject();
    }, e.prototype.flatten = function() {
      for (var t = this, r = [], n = 0; n < this.rootIds.length; n++) {
        var i = this.rootIds[n];
        r.push({
          id: i,
          level: 0,
          hasParent: !1,
          childrenCount: 0
        }), l(i, this.nodes, r, 0);
      }
      for (var a = 0, o = r; a < o.length; a++) {
        var s = o[a];
        s.childrenCount = u(s.id);
      }
      return r;
      function u(c) {
        if (t.nodes[c]) {
          var f = t.nodes[c].length;
          return f;
        } else
          return 0;
      }
      function l(c, f, d, h) {
        if (h === void 0 && (h = 0), !(!c || !f || !d || !f[c])) {
          h++;
          for (var p = f[c], v = 0; v < p.length; v++) {
            var m = p[v];
            d.push({ id: m, level: h, hasParent: !0 }), l(m, f, d, h);
          }
          h--;
        }
      }
    }, e.prototype.moveIdBeforeId = function(t, r) {
      return this.moveId(t, r, vt.BEFORE);
    }, e.prototype.moveIdAfterId = function(t, r) {
      return this.moveId(t, r, vt.AFTER);
    }, e.prototype.moveIdIntoId = function(t, r, n) {
      return n === void 0 && (n = !0), n ? this.moveId(t, r, vt.INSIDE_AT_START) : this.moveId(t, r, vt.INSIDE_AT_END);
    }, e.prototype.swapRootIdWithRootId = function(t, r) {
      var n = this.findRootId(t), i = this.findRootId(r);
      this.swapRootPositionWithRootPosition(n, i);
    }, e.prototype.swapRootPositionWithRootPosition = function(t, r) {
      var n = this.rootIds[r];
      this.rootIds[r] = this.rootIds[t], this.rootIds[t] = n;
    }, e.prototype.deleteId = function(t) {
      this.rootDeleteId(t), this.nodeAndSubNodesDelete(t), this.nodeRefrencesDelete(t);
    }, e.prototype.insertIdBeforeId = function(t, r) {
      var n = this.findRootId(t);
      n > -1 && this.insertIdIntoRoot(r, n);
      for (var i in this.nodes)
        if (this.nodes.hasOwnProperty(i)) {
          var a = this.findNodeId(i, t);
          a > -1 && this.insertIdIntoNode(i, r, a);
        }
    }, e.prototype.insertIdAfterId = function(t, r) {
      var n = this.findRootId(t);
      n > -1 && this.insertIdIntoRoot(r, n + 1);
      for (var i in this.nodes)
        if (this.nodes.hasOwnProperty(i)) {
          var a = this.findNodeId(i, t);
          a > -1 && this.insertIdIntoNode(i, r, a + 1);
        }
    }, e.prototype.insertIdIntoId = function(t, r) {
      this.nodeInsertAtEnd(t, r), this.nodes[r] = [];
    }, e.prototype.insertIdIntoRoot = function(t, r) {
      if (r === void 0)
        this.rootInsertAtEnd(t);
      else if (r < 0) {
        var n = this.rootIds.length;
        this.rootIds.splice(r + n + 1, 0, t);
      } else
        this.rootIds.splice(r, 0, t);
      this.nodes[t] = this.nodes[t] || [];
    }, e.prototype.insertIdIntoNode = function(t, r, n) {
      if (this.nodes[t] = this.nodes[t] || [], this.nodes[r] = this.nodes[r] || [], n === void 0)
        this.nodeInsertAtEnd(t, r);
      else if (n < 0) {
        var i = this.nodes[t].length;
        this.nodes[t].splice(n + i + 1, 0, r);
      } else
        this.nodes[t].splice(n, 0, r);
    }, e.prototype.moveId = function(t, r, n) {
      var i = t, a = this.findRootId(i);
      this.nodes[r];
      for (var o in this.nodes)
        if (this.nodes.hasOwnProperty(o)) {
          this.findNodeId(o, r);
          break;
        }
      var s = r, u = this.findRootId(s);
      this.nodes[r];
      for (var o in this.nodes)
        if (this.nodes.hasOwnProperty(o)) {
          this.findNodeId(o, r);
          break;
        }
      if (a > -1)
        if (u > -1)
          switch (this.rootDelete(a), u > a && u--, n) {
            case vt.BEFORE:
              this.insertIdIntoRoot(i, u);
              break;
            case vt.AFTER:
              this.insertIdIntoRoot(i, u + 1);
              break;
            case vt.INSIDE_AT_START:
              this.nodeInsertAtStart(s, i);
              break;
            case vt.INSIDE_AT_END:
              this.nodeInsertAtEnd(s, i);
              break;
          }
        else {
          this.rootDelete(a);
          for (var o in this.nodes)
            if (this.nodes.hasOwnProperty(o)) {
              var l = this.findNodeId(o, s);
              if (l > -1) {
                switch (n) {
                  case vt.BEFORE:
                    this.insertIdIntoNode(o, i, l);
                    break;
                  case vt.AFTER:
                    this.insertIdIntoNode(o, i, l + 1);
                    break;
                  case vt.INSIDE_AT_START:
                    this.nodeInsertAtStart(s, i);
                    break;
                  case vt.INSIDE_AT_END:
                    this.nodeInsertAtEnd(s, i);
                    break;
                }
                break;
              }
            }
        }
      else if (u > -1) {
        for (var o in this.nodes)
          if (this.nodes.hasOwnProperty(o)) {
            var l = this.findNodeId(o, i);
            if (l > -1) {
              this.nodeDeleteAtIndex(o, l);
              break;
            }
          }
        switch (n) {
          case vt.BEFORE:
            this.insertIdIntoRoot(i, u);
            break;
          case vt.AFTER:
            this.insertIdIntoRoot(i, u + 1);
            break;
          case vt.INSIDE_AT_START:
            this.nodeInsertAtStart(s, i);
            break;
          case vt.INSIDE_AT_END:
            this.nodeInsertAtEnd(s, i);
            break;
        }
      } else {
        for (var o in this.nodes)
          if (this.nodes.hasOwnProperty(o)) {
            var l = this.findNodeId(o, i);
            if (l > -1) {
              this.nodeDeleteAtIndex(o, l);
              break;
            }
          }
        for (var o in this.nodes)
          if (this.nodes.hasOwnProperty(o)) {
            var l = this.findNodeId(o, s);
            if (l > -1) {
              switch (n) {
                case vt.BEFORE:
                  this.insertIdIntoNode(o, i, l);
                  break;
                case vt.AFTER:
                  this.insertIdIntoNode(o, i, l + 1);
                  break;
                case vt.INSIDE_AT_START:
                  this.nodeInsertAtStart(s, i);
                  break;
                case vt.INSIDE_AT_END:
                  this.nodeInsertAtEnd(s, i);
                  break;
              }
              break;
            }
          }
      }
    }, e.prototype.swapArrayElements = function(t, r, n) {
      var i = t[r];
      return t[r] = t[n], t[n] = i, t;
    }, e.prototype.rootDeleteId = function(t) {
      var r = this.findRootId(t);
      r > -1 && this.rootDelete(r);
    }, e.prototype.nodeAndSubNodesDelete = function(t) {
      for (var r = [], n = 0; n < this.nodes[t].length; n++) {
        var i = this.nodes[t][n];
        this.nodeAndSubNodesDelete(i), r.push(t);
      }
      this.nodeDelete(t);
      for (var n = 0; n < r.length; n++)
        this.nodeDelete(r[n]);
    }, e.prototype.nodeRefrencesDelete = function(t) {
      for (var r in this.nodes)
        if (this.nodes.hasOwnProperty(r))
          for (var n = 0; n < this.nodes[r].length; n++) {
            var i = this.nodes[r][n];
            i === t && this.nodeDeleteAtIndex(r, n);
          }
    }, e.prototype.nodeDelete = function(t) {
      delete this.nodes[t];
    }, e.prototype.findRootId = function(t) {
      return this.rootIds.indexOf(t);
    }, e.prototype.findNodeId = function(t, r) {
      return this.nodes[t].indexOf(r);
    }, e.prototype.findNode = function(t) {
      return this.nodes[t];
    }, e.prototype.nodeInsertAtStart = function(t, r) {
      this.nodes[t].unshift(r);
    }, e.prototype.nodeInsertAtEnd = function(t, r) {
      this.nodes[t].push(r);
    }, e.prototype.rootDelete = function(t) {
      this.rootIds.splice(t, 1);
    }, e.prototype.nodeDeleteAtIndex = function(t, r) {
      this.nodes[t].splice(r, 1);
    }, e.prototype.rootInsertAtStart = function(t) {
      this.rootIds.unshift(t);
    }, e.prototype.rootInsertAtEnd = function(t) {
      this.rootIds.push(t);
    }, e;
  }()
);
G0.default = fO;
Object.defineProperty(Dt, "__esModule", { value: !0 });
var dO = jt;
Dt.arrays = dO;
var hO = H0;
Dt.Bag = hO.default;
var pO = W0;
Dt.BSTree = pO.default;
var vO = Fl;
Dt.BSTreeKV = vO.default;
var mO = ii, Is = Dt.Dictionary = mO.default, yO = kl;
Dt.Heap = yO.default;
var gO = z0;
Dt.LinkedDictionary = gO.default;
var xO = ts;
Dt.LinkedList = xO.default;
var bO = q0;
Dt.MultiDictionary = bO.default;
var EO = Nl;
Dt.FactoryDictionary = EO.default;
var wO = Nl;
Dt.DefaultDictionary = wO.default;
var SO = Il;
Dt.Queue = SO.default;
var _O = Y0;
Dt.PriorityQueue = _O.default;
var TO = Dl;
Dt.Set = TO.default;
var AO = V0;
Dt.Stack = AO.default;
var CO = G0;
Dt.MultiRootTree = CO.default;
var OO = lr;
Dt.util = OO;
const K0 = ({ method: e = "GET", httpPath: t = "/", token: r }, n) => es.HmacSHA512(`${e}_${t}_${r}`, n).toString();
function Xne(e, t) {
  const r = Xe(), n = Ir(r);
  return wt.create({
    baseURL: t ?? `${{}.VITE_MYASURION_API_BASE_URL}${{}.VITE_MYASURION_API_BASE_PATH}` ?? {}.VITE_API_BASE_URL,
    headers: {
      "x-asurion-client": r,
      "x-asurion-cc": n.code
    },
    ...e
  });
}
new S0({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
});
var Be;
((e) => {
  class t {
    /**
     * Provide group/path id and module id. Name may be the same as the group/path id.
     * @param {string} id: Group/section id
     * @param {string} moduleId: Module Id
     * @param {string} name: Group/section name. Equivalent to group/section id
     * @param {StringManager} provider?: Internal StringManager dependency
     */
    constructor(k, M, H, ee) {
      /**
       * Group/Section Id
       */
      pe(this, "id");
      /**
       * Module Id
       */
      pe(this, "moduleId");
      /**
       * Group/section name. Equivalent to group/section id
       */
      pe(this, "name");
      /**
       * Internal StringManager
       */
      pe(this, "_provider");
      /**
       * Contains the map of strings for the specific group. Accepts string/path id with corresponding String
       */
      pe(this, "stringMap", new Is());
      this.id = k, this.moduleId = M, this._provider = ee, this.name = H;
    }
    /**
     * Gets string from a given string/path id
     * @param {string} id: String/path id
     * @returns {String | undefined} String | undefined
     */
    getString(k) {
      return this.stringMap.getValue(k);
    }
    get provider() {
      return this._provider;
    }
    /**
     * Adds a String to the string map
     * @param {Localization.String} theString Adds the String to the string map.
     */
    addString(k) {
      this.stringMap.setValue(k.id, k);
    }
    replaceString(k) {
      this.stringMap.remove(k.id), this.stringMap.setValue(k.id, k);
    }
    get strings() {
      const k = [];
      return this.stringMap.forEach((M, H) => {
        k.push({ key: M, value: H });
      }), k;
    }
  }
  e.Group = t;
  class r {
    /**
     * Provide the string/path id and internal id
     * @param {string} id String/path id
     * @param {string|null} internalId?: Unique internal id
     * @param {Group | null} parent?: Parent Group/Section of the String
     */
    constructor(k, M, H) {
      /**
       * Unique internal id for the string
       */
      pe(this, "_internalId");
      /**
       * The text content of the given String
       */
      pe(this, "_content");
      /**
       * String/path id
       */
      pe(this, "id");
      /**
       * The parent Group/Section of the String
       *
       */
      pe(this, "parent");
      /**
       * The usage for the string. Can be either static or dynamic
       */
      pe(this, "usage");
      pe(this, "inView");
      /**
       * The description for the string
       */
      pe(this, "description");
      /**
       * Internal update callbacks array
       */
      pe(this, "_callbacks", []);
      this.id = k, this.parent = H, this._internalId = M;
    }
    /**
     * Provides the group/section id of the string
     * @returns {string|undefined} Group/Section Id of the String
     */
    get sectionId() {
      var k;
      return (k = this.parent) == null ? void 0 : k.id;
    }
    get internalId() {
      return this._internalId;
    }
    set content(k) {
      this._content = k;
    }
    get content() {
      return this._content;
    }
    /**
     * Adds an update callback function to internal callbacks array
     * @param {UpdateCallback} callback: Update callback function
     */
    set onUpdateListener(k) {
      this._callbacks.push(k);
    }
  }
  e.String = r;
  class n {
    constructor(k, M, H, ee, xe, ye, be, ze) {
      pe(this, "_initialDefaultLoadedText");
      pe(this, "_script");
      pe(this, "_id");
      pe(this, "_sectionId");
      pe(this, "_moduleId");
      pe(this, "_languageCode");
      pe(this, "_partnerId");
      pe(this, "_status");
      pe(this, "_dynamicValues");
      this._initialDefaultLoadedText = k, this._script = M, this._id = H, this._sectionId = ee, this._moduleId = xe, this._languageCode = ye, this._partnerId = be, this._status = "initial", this._dynamicValues = ze;
    }
    replaceTextPlaceHolders(k, M) {
      return k.replace(
        /\{(\d+)\}/g,
        (H, ee) => typeof M[ee - 1] < "u" ? M[ee - 1] : `{${ee}}`
      );
    }
    get value() {
      return {
        defaultLoadedText: this._initialDefaultLoadedText,
        text: this.replaceTextPlaceHolders(this.script, this._dynamicValues ?? []),
        id: this._id,
        sectionId: this._sectionId,
        moduleId: this._moduleId,
        languageCode: this._languageCode,
        partnerId: this._partnerId
      };
    }
    set status(k) {
      this._status = k;
    }
    get status() {
      return this._status;
    }
    set script(k) {
      this._script = k;
    }
    get script() {
      return this._script;
    }
  }
  e.UserScript = n;
  class i {
    /**
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code. Should support en-US and zh-CN
     * @param {IDataLoader} loader: IDataLoader
     * @param {IDataPersister} persister: IDataPersister
     * @param {IDataCreator} creator: IDataCreator
     */
    constructor(k, M, H, ee, xe, ye) {
      /**
       * Internal partner id
       */
      pe(this, "_partnerId");
      /**
       * Internal module id
       */
      pe(this, "_moduleId");
      /**
       * Internal language code. Should support en-US and zh-CN
       */
      pe(this, "_languageCode");
      pe(this, "loader");
      pe(this, "persister");
      pe(this, "manipulator");
      /**
       * Internal listeners array of update callback functions
       */
      pe(this, "listeners", []);
      /**
       * Contains the map of groups/sections for the specific module.
       *
       * Accepts group/section id with corresponding Group array
       */
      pe(this, "_groupMap");
      pe(this, "_id");
      pe(this, "_initFetch");
      pe(this, "_completeFetch");
      pe(this, "_srcStrings");
      this.loader = ee, this.manipulator = ye, this.persister = xe, this._groupMap = new Is(), this._partnerId = k, this._moduleId = M, this._languageCode = H, this._id = (+/* @__PURE__ */ new Date()).toString(), this._initFetch = !1, this._completeFetch = !1;
    }
    /**
     * Adds an update callback function to internal listeners array
     * @param {UpdateCallback} callback: Update callback function
     */
    set onUpdateListener(k) {
      this.listeners.push(k);
    }
    async updateString(k) {
      return await this.persister.persistString(k);
    }
    async updateSection(k) {
      return await this.persister.persistStrings(k);
    }
    /**
     * Loads all sections.
     *
     * Creates a new group/section map. Loads sections from the data loader/store.
     * Checks the internal group map and assigns the sections to the created new section map.
     * Returns the new map with updates sections.
     *
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code
     * @returns {Dictionary<string, Group[]>} Dictionary<string, Group[]> - Group/Section Map
     */
    async loadAllSections(k, M, H, ee) {
      let xe, ye = new Is();
      try {
        const be = await this.loader.loadSections(
          k,
          M,
          H,
          ee
        );
        let ze;
        for (const rt of be)
          ze = rt.id, this._groupMap.containsKey(ze) || this._groupMap.setValue(ze, []), xe = this._groupMap.getValue(ze), xe && xe.findIndex((Ft) => Ft.id === ze) === -1 && xe.push(rt);
        ye = this._groupMap;
      } catch (be) {
        console.log(be);
      }
      return ye;
    }
    /**
     * Gets Group/Section from given id
     * @param {any} sectionId: Section/Group Id
     * @returns {Promise<Group | null>} Promise<Group | null>
     */
    async getGroup(k, M) {
      let H = [], ee = null;
      const xe = k;
      if (this._initFetch || (this._initFetch = !0, this._groupMap = await this.loadAllSections(
        this._partnerId,
        this._moduleId,
        this._languageCode,
        M
      ), this._completeFetch = !0), this._initFetch && this._completeFetch) {
        if (H = this._groupMap.getValue(xe), H === void 0)
          return ee;
        for (const ye of H)
          if (ye.id === k) {
            ee = ye;
            break;
          }
        return ee;
      } else
        return new Promise((ye, be) => {
          try {
            const ze = setInterval(() => {
              if (H = this._groupMap.getValue(xe), H && H !== void 0) {
                for (const rt of H)
                  if (rt.id === k) {
                    ee = rt;
                    break;
                  }
                ye(ee), clearInterval(ze);
              }
            }, 1500);
          } catch {
            be(null);
          }
        });
    }
    async createString(k, M, H, ee, xe, ye, be) {
      this.manipulator.createString(
        k,
        M,
        H,
        ee,
        xe,
        ye.profileId,
        be
      );
    }
    async updateStringEntry(k, M, H, ee, xe) {
      const { isUpdated: ye, body: be } = await this.manipulator.updateString(
        k,
        M,
        H,
        ee,
        xe.profileId
      );
      return ye && be && this._groupMap.forEach((ze, rt) => {
        const Ft = rt.map((bt) => (bt.strings.forEach(({ key: R, value: Q }) => {
          const te = be.text.find(
            (fe) => fe.internalId === Q.internalId
          );
          if (R && te) {
            const fe = new r(
              te.path,
              te.internalId
            );
            fe.content = te.text, fe.usage = te.usage, fe.description = te.description, bt.replaceString(fe);
          }
        }), bt));
        this._groupMap.setValue(ze, Ft);
      }), { isUpdated: ye, body: be };
    }
  }
  e.StringManager = i;
  class a {
    constructor(k, M, H) {
      /**
       * Internal partner id
       */
      pe(this, "_partnerId");
      /**
       * Internal module id
       */
      pe(this, "_moduleId");
      /**
       * Internal language code. Should support en-US and zh-CN
       */
      pe(this, "_languageCode");
      pe(this, "_scripts");
      pe(this, "subscribers");
      this._scripts = [], this._partnerId = k, this._moduleId = M, this._languageCode = H, this.subscribers = [];
    }
    getScript(k, M) {
      return this._scripts.find(
        (H) => H.value.id === k && H.value.languageCode === M
      );
    }
    createScript(k, M, H, ee, xe, ye, be) {
      const ze = new n(
        k,
        k,
        M,
        H,
        ee,
        xe,
        ye,
        be
      );
      return this._scripts.findIndex(
        (rt) => rt.value.id === M && rt.value.languageCode === xe
      ) === -1 && this._scripts.push(ze), ze;
    }
    updateScript(k, M, H, ee, xe) {
      const ye = this._scripts.findIndex(
        (be) => be.value.id === M && be.value.sectionId === H && be.value.languageCode === xe
      );
      ye > -1 && (this._scripts[ye].value.text = k, this._scripts[ye].script = k, this._scripts[ye].status = ee, this.subscribers.forEach((be) => {
        be(this._scripts);
      }));
    }
    get scripts() {
      return this._scripts;
    }
    subscribe(k) {
      return this.subscribers.push(k), () => {
        this.subscribers = this.subscribers.filter((M) => M !== k);
      };
    }
  }
  e.ScriptManager = a;
  class o {
    constructor() {
      pe(this, "_stringsMap");
      this._stringsMap = new Is();
    }
    addStringManager(k, M) {
      this._stringsMap.containsKey(k) || this._stringsMap.setValue(k, M);
    }
  }
  e.LanguageManager = o;
  class s {
    /**
     * Provide module Id to the parser
     * @param {any} moduleId: Module Id
     */
    constructor(k) {
      /**
       * Internal module id
       */
      pe(this, "_moduleId");
      this._moduleId = k;
    }
    /**
     * Parses section from provided data
     * @param {any} data:any
     * @returns {Group[]} Group[]
     */
    parseSections(k) {
      const M = [];
      let H;
      const ee = JSON.parse(JSON.stringify(k));
      for (const xe of ee) {
        H = new t(xe.id, this._moduleId, xe.id);
        for (const ye of xe.text) {
          const be = new r(
            ye.path,
            ye.internalId,
            H
          );
          be.content = ye.text, be.usage = ye.usage, be.description = ye.description, H.addString(be);
        }
        M.push(H);
      }
      return M;
    }
  }
  class u {
    /**
     * @param {any} baseUrl: Base URL of the Strings API. Should include the base path. e.g. {url}/api/v1
     * @param {any} hmacKey: HMAC Key used to generate headers
     */
    constructor(k, M, H, ee, xe, ye, be) {
      /**
       * Internal base url property
       */
      pe(this, "_baseUrl");
      /**
       * Internal hmac key property
       */
      pe(this, "_hmacKey");
      /**
       * Internal authorization property
       *
       * Used in string modification headers
       */
      pe(this, "_authorization");
      /**
       * Internal token property
       *
       * Used in string modification headers
       */
      pe(this, "_token");
      /**
       * Internal profileId property
       *
       * Used in string modification headers
       */
      pe(this, "_profileId");
      /**
       * Internal profileId property
       *
       * Used in string modification headers
       */
      pe(this, "_moduleId");
      pe(this, "_initializedCallback");
      pe(this, "_config", null);
      pe(this, "_isDevToolsEnabled");
      this._baseUrl = k, this._hmacKey = M, this._authorization = H, this._token = ee, this._profileId = xe, this._moduleId = ye, this._isDevToolsEnabled = be;
    }
    async initialize() {
      return !0;
    }
    get loader() {
      return this;
    }
    get persister() {
      return this;
    }
    /**
     * Generates GET Headers for getStrings API
     * @param {string} targetUrl: Target URL /api getStrings path
     * @param {string} hmacKey: HMAC Key
     */
    generateGetHeaders(k, M, H = "GET") {
      const ee = Xe(), xe = Ir(ee), ye = +/* @__PURE__ */ new Date(), be = es.SHA256(ye.toString()).toString();
      return {
        Authorization: K0(
          {
            httpPath: k,
            method: H,
            token: be || ""
          },
          M
        ),
        token: be,
        t: ye,
        "x-asurion-client": ee,
        "x-asurion-cc": xe.code
      };
    }
    /**
     * Loads Sections from getStrings (GET) API. Implemented from IDataLoader
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code. Should support en-US and zh-CN
     * @returns {Group[]} Group[] - Sections/Groups
     */
    async loadSections(k, M, H, ee) {
      const xe = `${this._baseUrl}/content/strings?moduleId=${M}&language=${H}&partnerId=${k}&preview=true`, ye = this.generateGetHeaders(
        "/api/v1/content/strings",
        this._hmacKey
      ), be = {
        method: "GET",
        url: xe,
        headers: ye
      }, ze = new s(M);
      if (ee && Array.isArray(ee == null ? void 0 : ee[H]))
        return ze.parseSections(ee == null ? void 0 : ee[H]);
      {
        const rt = await wt(be);
        return ze.parseSections(rt.data.body);
      }
    }
    async createString(k, M, H, ee, xe, ye) {
      ee = (H == null ? void 0 : H.toLowerCase()) === "global" ? "global" : ee;
      const be = +/* @__PURE__ */ new Date(), ze = Xe(), Ft = xa() ? ba() : Xe(), bt = Ir(ze), Q = {
        method: "POST",
        url: `${this._baseUrl}/content/strings?moduleId=${ee}`,
        headers: {
          authorization: xe.authorization,
          token: xe.token,
          t: be,
          id: ye,
          "x-asurion-client": ze,
          "x-asurion-cc": bt.code
        },
        data: JSON.stringify({
          moduleId: ee,
          sectionId: H,
          pathId: `${Ft}-${M}`,
          partnerId: Ft,
          value: k,
          usage: "static",
          autoPublish: "true"
        })
      };
      if (ee === "myAsurionAuth") {
        const te = this.generateGetHeaders(
          "/api/v1/content/strings",
          this._hmacKey,
          "POST"
        );
        Q.headers = te;
      }
      return await wt(Q), !0;
    }
    async updateString(k, M, H, ee, xe) {
      var Q;
      const ye = +/* @__PURE__ */ new Date(), be = Xe(), rt = xa() ? ba() : Xe(), Ft = Ir(be), R = {
        method: "PUT",
        url: `${this._baseUrl}/content/strings`,
        headers: {
          authorization: ee.authorization,
          token: ee.token,
          t: ye,
          id: xe,
          "x-asurion-client": be,
          "x-asurion-cc": Ft.code
        },
        data: JSON.stringify({
          entryId: M,
          value: k,
          language: H,
          partnerId: rt
        })
      };
      try {
        const te = await wt(R);
        if (te.data && ((Q = te.data) != null && Q.body))
          return {
            isUpdated: !0,
            body: te.data.body
          };
        throw "String update failed";
      } catch {
        return {
          isUpdated: !0,
          body: void 0
        };
      }
    }
    get config() {
      return this._config = {
        baseUrl: this._baseUrl,
        hmacKey: this._hmacKey,
        authorization: this._authorization,
        token: this._token,
        profileId: this._profileId,
        moduleId: this._moduleId
      }, this._config;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    persistString(k) {
      throw new Error("Method not implemented.");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    persistStrings(k) {
      throw new Error("Method not implemented.");
    }
    setInitCallback(k) {
      if (this._initializedCallback = k, this._moduleId === "myAsurionAuth") {
        if (this.config !== null && this.config.moduleId !== "")
          try {
            this._initializedCallback(this.config);
          } catch {
          }
      } else if (this.config !== null && this.config.moduleId !== "" && this.config.authorization !== "")
        try {
          this._initializedCallback(this.config);
        } catch {
        }
    }
    setConfig(k) {
      if (this._config = k, this._authorization === "" && (this._authorization = (k == null ? void 0 : k.authorization) || ""), this._baseUrl === "" && (this._baseUrl = (k == null ? void 0 : k.baseUrl) || ""), this._hmacKey === "" && (this._hmacKey = (k == null ? void 0 : k.hmacKey) || ""), this._moduleId === "" && (this._moduleId = (k == null ? void 0 : k.moduleId) || ""), this._profileId === "" && (this._profileId = (k == null ? void 0 : k.profileId) || ""), this._token === "" && (this._token = (k == null ? void 0 : k.token) || ""), this._isDevToolsEnabled = (k == null ? void 0 : k.isDevToolsEnabled) ?? !1, this._initializedCallback !== null)
        try {
          this._initializedCallback(this._config);
        } catch {
        }
    }
  }
  e.MyAsurionLocalizationStore = u;
  let l = null, c = null, f = null, d = null, h = null, p = null, v = null, m = null, x = null, y = null, g = null, E = null, b = null, w = null, _ = null, A = null, O = null, T = null;
  function C(I, k, M, H) {
    return l === null && (l = new i(
      I,
      k,
      M,
      H,
      H,
      H
    )), l;
  }
  e.getStringManager = C;
  function $(I, k, M, H) {
    return c === null && (c = new i(
      I,
      k,
      "zh-Hant-TW",
      H,
      H,
      H
    )), c;
  }
  e.getZhStringManager = $;
  function P(I, k, M, H) {
    return f === null && (f = new i(
      I,
      k,
      "th-TH",
      H,
      H,
      H
    )), f;
  }
  e.getThStringManager = P;
  function j(I, k, M, H) {
    return d === null && (d = new i(
      I,
      k,
      "ko-KR",
      H,
      H,
      H
    )), d;
  }
  e.getKoStringManager = j;
  function W(I, k, M, H) {
    return h === null && (h = new i(
      I,
      k,
      "ms-MY",
      H,
      H,
      H
    )), h;
  }
  e.getMyStringManager = W;
  function Y(I, k, M, H) {
    return p === null && (p = new i(
      I,
      k,
      M,
      H,
      H,
      H
    )), p;
  }
  e.getGlobalStringManager = Y;
  function V(I, k, M, H) {
    return v === null && (v = new i(
      I,
      k,
      "zh-Hant-TW",
      H,
      H,
      H
    )), v;
  }
  e.getZhGlobalStringManager = V;
  function ce(I, k, M, H) {
    return m === null && (m = new i(
      I,
      k,
      "th-TH",
      H,
      H,
      H
    )), m;
  }
  e.getThGlobalStringManager = ce;
  function de(I, k, M, H) {
    return x === null && (x = new i(
      I,
      k,
      "ko-KR",
      H,
      H,
      H
    )), x;
  }
  e.getKoGlobalStringManager = de;
  function L(I, k, M, H) {
    return y === null && (y = new i(
      I,
      k,
      "ms-MY",
      H,
      H,
      H
    )), y;
  }
  e.getMyGlobalStringManager = L;
  function D(I, k, M) {
    return k === "global" ? (E === null && (E = new a(I, k, M)), E) : (g === null && (g = new a(I, k, M)), g);
  }
  e.getScriptManager = D;
  function N(I, k, M, H, ee) {
    return T === null && (T = new o(), T.addStringManager("en-US", I), T.addStringManager("zh-Hant-TW", k), T.addStringManager("th-TH", M), T.addStringManager("ko-KR", H), T.addStringManager("ms-MY", ee)), T;
  }
  e.getLanguageManager = N;
  function B(I, k, M, H, ee) {
    return b === null && (b = new u(
      I.apiUrl,
      I.hmacKey,
      k.authorization,
      k.token,
      M,
      H,
      ee
    )), b;
  }
  e.getDataStore = B;
  function F(I, k, M, H, ee) {
    return w === null && (w = new u(
      I.apiUrl,
      I.hmacKey,
      k.authorization,
      k.token,
      M,
      H,
      ee
    )), w;
  }
  e.getZhDataStore = F;
  function X(I, k, M, H, ee) {
    return _ === null && (_ = new u(
      I.apiUrl,
      I.hmacKey,
      k.authorization,
      k.token,
      M,
      H,
      ee
    )), _;
  }
  e.getThDataStore = X;
  function Z(I, k, M, H, ee) {
    return A === null && (A = new u(
      I.apiUrl,
      I.hmacKey,
      k.authorization,
      k.token,
      M,
      H,
      ee
    )), A;
  }
  e.getKoDataStore = Z;
  function ne(I, k, M, H, ee) {
    return O === null && (O = new u(
      I.apiUrl,
      I.hmacKey,
      k.authorization,
      k.token,
      M,
      H,
      ee
    )), O;
  }
  e.getMyDataStore = ne;
  function K(I) {
    return I === "zh-Hant-TW" ? c : I === "th-TH" ? f : I === "ko-KR" ? d : I === "ms-MY" ? h : l;
  }
  e.getStringManagerInstance = K;
  function we(I) {
    b = B(
      I.apiEnv,
      I.authToken,
      I.profileId,
      I.moduleId,
      I.isDevToolsEnabled
    ), b.setConfig({
      baseUrl: I.apiEnv.apiUrl,
      hmacKey: I.apiEnv.hmacKey,
      authorization: I.authToken.authorization,
      token: I.authToken.token,
      profileId: I.profileId,
      moduleId: I.moduleId,
      partnerId: I.partnerId,
      isDevToolsEnabled: I.isDevToolsEnabled
    }), w = F(
      I.apiEnv,
      I.authToken,
      I.profileId,
      I.moduleId,
      I.isDevToolsEnabled
    ), w.setConfig({
      baseUrl: I.apiEnv.apiUrl,
      hmacKey: I.apiEnv.hmacKey,
      authorization: I.authToken.authorization,
      token: I.authToken.token,
      profileId: I.profileId,
      moduleId: I.moduleId,
      partnerId: I.partnerId,
      isDevToolsEnabled: I.isDevToolsEnabled
    }), _ = X(
      I.apiEnv,
      I.authToken,
      I.profileId,
      I.moduleId,
      I.isDevToolsEnabled
    ), _.setConfig({
      baseUrl: I.apiEnv.apiUrl,
      hmacKey: I.apiEnv.hmacKey,
      authorization: I.authToken.authorization,
      token: I.authToken.token,
      profileId: I.profileId,
      moduleId: I.moduleId,
      partnerId: I.partnerId,
      isDevToolsEnabled: I.isDevToolsEnabled
    }), A = Z(
      I.apiEnv,
      I.authToken,
      I.profileId,
      I.moduleId,
      I.isDevToolsEnabled
    ), A.setConfig({
      baseUrl: I.apiEnv.apiUrl,
      hmacKey: I.apiEnv.hmacKey,
      authorization: I.authToken.authorization,
      token: I.authToken.token,
      profileId: I.profileId,
      moduleId: I.moduleId,
      partnerId: I.partnerId,
      isDevToolsEnabled: I.isDevToolsEnabled
    }), O = ne(
      I.apiEnv,
      I.authToken,
      I.profileId,
      I.moduleId,
      I.isDevToolsEnabled
    ), O.setConfig({
      baseUrl: I.apiEnv.apiUrl,
      hmacKey: I.apiEnv.hmacKey,
      authorization: I.authToken.authorization,
      token: I.authToken.token,
      profileId: I.profileId,
      moduleId: I.moduleId,
      partnerId: I.partnerId,
      isDevToolsEnabled: I.isDevToolsEnabled
    }), l = C(
      I.partnerId,
      I.moduleId,
      "en-US",
      b
    ), c = $(
      I.partnerId,
      I.moduleId,
      "zh-Hant-TW",
      w
    ), f = P(
      I.partnerId,
      I.moduleId,
      "th-TH",
      _
    ), d = j(
      I.partnerId,
      I.moduleId,
      "ko-KR",
      _
    ), h = W(
      I.partnerId,
      I.moduleId,
      "ms-MY",
      O
    ), N(
      l,
      c,
      f,
      d,
      h
    );
  }
  e.initializeLocalization = we;
})(Be || (Be = {}));
const DO = () => {
  const e = window.location.search, r = new URLSearchParams(e).get("lang");
  if (["en-US", "zh-Hant-TW", "th-TH", "ko-KR", "ms-MY"].includes(r))
    return r;
}, db = Rr({
  language: "en-US",
  updateActiveLanguage: () => {
  },
  module: "myAsurionShared",
  isEnabled: !1,
  updateIsEnabled: () => {
  },
  apiEnv: { hmacKey: "", apiUrl: "" },
  isEditingMode: !1,
  updateIsEditingMode: () => {
  },
  isDevToolsOpen: !1,
  updateIsDevToolsOpen: () => {
  },
  isDevToolsEnabled: !1,
  updateIsDevToolsEnabled: () => {
  },
  isTranslationsLoading: !1,
  updateIsTranslationsLoading: () => {
  },
  isKeyShown: !1,
  setIsKeyShown: () => {
  },
  srcStrings: []
}), FO = ({
  children: e,
  moduleId: t,
  isEnabled: r = !1,
  apiEnv: n,
  srcStrings: i
}) => {
  const [a, o] = Oe(r), [s, u] = Oe(!1), [l, c] = Oe(!1), [f, d] = Oe(!1), [h, p] = Oe(!1), [v, m] = Oe(!1);
  if (!r)
    return /* @__PURE__ */ S.jsx(S.Fragment, { children: e });
  const [{ authorization: x, token: y, id: g }] = Fa({
    authorization: "",
    token: "",
    id: ""
  }), E = Xe(), b = xa();
  let w, _;
  w = DO(), _ = w || Y_(E);
  const [A, O] = M0(
    "al",
    _ ?? "en-US"
    // NOTE: set defaultLanguage as activeLanguage if value is configured
  ), [T, C] = fd(`srcStrings-${t}`, void 0), [$, P] = Oe(A ?? _ ?? "en-US");
  return He(() => {
    O($);
  }, [$]), He(() => {
    _ && !A && P(_);
  }, [_, A]), He(() => {
    g && Be.initializeLocalization({
      partnerId: b ? ba() : E,
      moduleId: t,
      apiEnv: n,
      authToken: { authorization: x, token: y },
      profileId: g,
      isDevToolsEnabled: f
    });
  }, [x, y, g, f]), He(() => {
    T || C(i);
  }, [i]), /* @__PURE__ */ S.jsx(
    db.Provider,
    {
      value: {
        language: $,
        updateActiveLanguage: P,
        module: t,
        isEnabled: a,
        updateIsEnabled: o,
        apiEnv: n,
        isEditingMode: s,
        updateIsEditingMode: u,
        isDevToolsOpen: l,
        updateIsDevToolsOpen: c,
        isDevToolsEnabled: f,
        updateIsDevToolsEnabled: d,
        isTranslationsLoading: h,
        updateIsTranslationsLoading: p,
        isKeyShown: v,
        setIsKeyShown: m,
        srcStrings: i
      },
      children: /* @__PURE__ */ S.jsx(Sx, { flexFlow: "row nowrap", children: /* @__PURE__ */ S.jsx(sa, { as: "div", id: "translation-ctx", w: "full", flex: "1", children: e }) })
    }
  );
};
function hb(e) {
  return (t) => typeof t === e;
}
var IO = hb("function"), kO = (e) => e === null, jv = (e) => Object.prototype.toString.call(e).slice(8, -1) === "RegExp", Lv = (e) => !NO(e) && !kO(e) && (IO(e) || typeof e == "object"), NO = hb("undefined");
function PO(e, t) {
  const { length: r } = e;
  if (r !== t.length)
    return !1;
  for (let n = r; n-- !== 0; )
    if (!Yt(e[n], t[n]))
      return !1;
  return !0;
}
function $O(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  const r = new DataView(e.buffer), n = new DataView(t.buffer);
  let i = e.byteLength;
  for (; i--; )
    if (r.getUint8(i) !== n.getUint8(i))
      return !1;
  return !0;
}
function RO(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const r of e.entries())
    if (!t.has(r[0]))
      return !1;
  for (const r of e.entries())
    if (!Yt(r[1], t.get(r[0])))
      return !1;
  return !0;
}
function MO(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const r of e.entries())
    if (!t.has(r[0]))
      return !1;
  return !0;
}
function Yt(e, t) {
  if (e === t)
    return !0;
  if (e && Lv(e) && t && Lv(t)) {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e) && Array.isArray(t))
      return PO(e, t);
    if (e instanceof Map && t instanceof Map)
      return RO(e, t);
    if (e instanceof Set && t instanceof Set)
      return MO(e, t);
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return $O(e, t);
    if (jv(e) && jv(t))
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const r = Object.keys(e), n = Object.keys(t);
    if (r.length !== n.length)
      return !1;
    for (let i = r.length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[i]))
        return !1;
    for (let i = r.length; i-- !== 0; ) {
      const a = r[i];
      if (!(a === "_owner" && e.$$typeof) && !Yt(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(e) && Number.isNaN(t) ? !0 : e === t;
}
var BO = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], jO = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function Pl(e) {
  const t = Object.prototype.toString.call(e).slice(8, -1);
  if (/HTML\w+Element/.test(t))
    return "HTMLElement";
  if (LO(t))
    return t;
}
function jr(e) {
  return (t) => Pl(t) === e;
}
function LO(e) {
  return BO.includes(e);
}
function Pa(e) {
  return (t) => typeof t === e;
}
function UO(e) {
  return jO.includes(e);
}
var HO = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
];
function ie(e) {
  if (e === null)
    return "null";
  switch (typeof e) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (ie.array(e))
    return "Array";
  if (ie.plainFunction(e))
    return "Function";
  const t = Pl(e);
  return t || "Object";
}
ie.array = Array.isArray;
ie.arrayOf = (e, t) => !ie.array(e) && !ie.function(t) ? !1 : e.every((r) => t(r));
ie.asyncGeneratorFunction = (e) => Pl(e) === "AsyncGeneratorFunction";
ie.asyncFunction = jr("AsyncFunction");
ie.bigint = Pa("bigint");
ie.boolean = (e) => e === !0 || e === !1;
ie.date = jr("Date");
ie.defined = (e) => !ie.undefined(e);
ie.domElement = (e) => ie.object(e) && !ie.plainObject(e) && e.nodeType === 1 && ie.string(e.nodeName) && HO.every((t) => t in e);
ie.empty = (e) => ie.string(e) && e.length === 0 || ie.array(e) && e.length === 0 || ie.object(e) && !ie.map(e) && !ie.set(e) && Object.keys(e).length === 0 || ie.set(e) && e.size === 0 || ie.map(e) && e.size === 0;
ie.error = jr("Error");
ie.function = Pa("function");
ie.generator = (e) => ie.iterable(e) && ie.function(e.next) && ie.function(e.throw);
ie.generatorFunction = jr("GeneratorFunction");
ie.instanceOf = (e, t) => !e || !t ? !1 : Object.getPrototypeOf(e) === t.prototype;
ie.iterable = (e) => !ie.nullOrUndefined(e) && ie.function(e[Symbol.iterator]);
ie.map = jr("Map");
ie.nan = (e) => Number.isNaN(e);
ie.null = (e) => e === null;
ie.nullOrUndefined = (e) => ie.null(e) || ie.undefined(e);
ie.number = (e) => Pa("number")(e) && !ie.nan(e);
ie.numericString = (e) => ie.string(e) && e.length > 0 && !Number.isNaN(Number(e));
ie.object = (e) => !ie.nullOrUndefined(e) && (ie.function(e) || typeof e == "object");
ie.oneOf = (e, t) => ie.array(e) ? e.indexOf(t) > -1 : !1;
ie.plainFunction = jr("Function");
ie.plainObject = (e) => {
  if (Pl(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.getPrototypeOf({});
};
ie.primitive = (e) => ie.null(e) || UO(typeof e);
ie.promise = jr("Promise");
ie.propertyOf = (e, t, r) => {
  if (!ie.object(e) || !t)
    return !1;
  const n = e[t];
  return ie.function(r) ? r(n) : ie.defined(n);
};
ie.regexp = jr("RegExp");
ie.set = jr("Set");
ie.string = Pa("string");
ie.symbol = Pa("symbol");
ie.undefined = Pa("undefined");
ie.weakMap = jr("WeakMap");
ie.weakSet = jr("WeakSet");
var oe = ie;
function WO(...e) {
  return e.every((t) => oe.string(t) || oe.array(t) || oe.plainObject(t));
}
function zO(e, t, r) {
  return pb(e, t) ? [e, t].every(oe.array) ? !e.some(qv(r)) && t.some(qv(r)) : [e, t].every(oe.plainObject) ? !Object.entries(e).some(zv(r)) && Object.entries(t).some(zv(r)) : t === r : !1;
}
function Uv(e, t, r) {
  const { actual: n, key: i, previous: a, type: o } = r, s = Zr(e, i), u = Zr(t, i);
  let l = [s, u].every(oe.number) && (o === "increased" ? s < u : s > u);
  return oe.undefined(n) || (l = l && u === n), oe.undefined(a) || (l = l && s === a), l;
}
function Hv(e, t, r) {
  const { key: n, type: i, value: a } = r, o = Zr(e, n), s = Zr(t, n), u = i === "added" ? o : s, l = i === "added" ? s : o;
  if (!oe.nullOrUndefined(a)) {
    if (oe.defined(u)) {
      if (oe.array(u) || oe.plainObject(u))
        return zO(u, l, a);
    } else
      return Yt(l, a);
    return !1;
  }
  return [o, s].every(oe.array) ? !l.every(Q0(u)) : [o, s].every(oe.plainObject) ? qO(Object.keys(u), Object.keys(l)) : ![o, s].every((c) => oe.primitive(c) && oe.defined(c)) && (i === "added" ? !oe.defined(o) && oe.defined(s) : oe.defined(o) && !oe.defined(s));
}
function Wv(e, t, { key: r } = {}) {
  let n = Zr(e, r), i = Zr(t, r);
  if (!pb(n, i))
    throw new TypeError("Inputs have different types");
  if (!WO(n, i))
    throw new TypeError("Inputs don't have length");
  return [n, i].every(oe.plainObject) && (n = Object.keys(n), i = Object.keys(i)), [n, i];
}
function zv(e) {
  return ([t, r]) => oe.array(e) ? Yt(e, r) || e.some((n) => Yt(n, r) || oe.array(r) && Q0(r)(n)) : oe.plainObject(e) && e[t] ? !!e[t] && Yt(e[t], r) : Yt(e, r);
}
function qO(e, t) {
  return t.some((r) => !e.includes(r));
}
function qv(e) {
  return (t) => oe.array(e) ? e.some((r) => Yt(r, t) || oe.array(t) && Q0(t)(r)) : Yt(e, t);
}
function eo(e, t) {
  return oe.array(e) ? e.some((r) => Yt(r, t)) : Yt(e, t);
}
function Q0(e) {
  return (t) => e.some((r) => Yt(r, t));
}
function pb(...e) {
  return e.every(oe.array) || e.every(oe.number) || e.every(oe.plainObject) || e.every(oe.string);
}
function Zr(e, t) {
  return oe.plainObject(e) || oe.array(e) ? oe.string(t) ? t.split(".").reduce((n, i) => n && n[i], e) : oe.number(t) ? e[t] : e : e;
}
function Du(e, t) {
  if ([e, t].some(oe.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![e, t].every((c) => oe.plainObject(c) || oe.array(c)))
    throw new Error("Expected plain objects or array");
  return { added: (c, f) => {
    try {
      return Hv(e, t, { key: c, type: "added", value: f });
    } catch {
      return !1;
    }
  }, changed: (c, f, d) => {
    try {
      const h = Zr(e, c), p = Zr(t, c), v = oe.defined(f), m = oe.defined(d);
      if (v || m) {
        const x = m ? eo(d, h) : !eo(f, h), y = eo(f, p);
        return x && y;
      }
      return [h, p].every(oe.array) || [h, p].every(oe.plainObject) ? !Yt(h, p) : h !== p;
    } catch {
      return !1;
    }
  }, changedFrom: (c, f, d) => {
    if (!oe.defined(c))
      return !1;
    try {
      const h = Zr(e, c), p = Zr(t, c), v = oe.defined(d);
      return eo(f, h) && (v ? eo(d, p) : !v);
    } catch {
      return !1;
    }
  }, decreased: (c, f, d) => {
    if (!oe.defined(c))
      return !1;
    try {
      return Uv(e, t, { key: c, actual: f, previous: d, type: "decreased" });
    } catch {
      return !1;
    }
  }, emptied: (c) => {
    try {
      const [f, d] = Wv(e, t, { key: c });
      return !!f.length && !d.length;
    } catch {
      return !1;
    }
  }, filled: (c) => {
    try {
      const [f, d] = Wv(e, t, { key: c });
      return !f.length && !!d.length;
    } catch {
      return !1;
    }
  }, increased: (c, f, d) => {
    if (!oe.defined(c))
      return !1;
    try {
      return Uv(e, t, { key: c, actual: f, previous: d, type: "increased" });
    } catch {
      return !1;
    }
  }, removed: (c, f) => {
    try {
      return Hv(e, t, { key: c, type: "removed", value: f });
    } catch {
      return !1;
    }
  } };
}
var YO = new Error("Element already at target scroll position"), VO = new Error("Scroll cancelled"), GO = Math.min, Yv = Date.now, KO = {
  left: Vv("scrollLeft"),
  top: Vv("scrollTop")
};
function Vv(e) {
  return function(r, n, i, a) {
    i = i || {}, typeof i == "function" && (a = i, i = {}), typeof a != "function" && (a = XO);
    var o = Yv(), s = r[e], u = i.ease || QO, l = isNaN(i.duration) ? 350 : +i.duration, c = !1;
    return s === n ? a(YO, r[e]) : requestAnimationFrame(d), f;
    function f() {
      c = !0;
    }
    function d(h) {
      if (c)
        return a(VO, r[e]);
      var p = Yv(), v = GO(1, (p - o) / l), m = u(v);
      r[e] = m * (n - s) + s, v < 1 ? requestAnimationFrame(d) : requestAnimationFrame(function() {
        a(null, r[e]);
      });
    }
  };
}
function QO(e) {
  return 0.5 * (1 - Math.cos(Math.PI * e));
}
function XO() {
}
const JO = /* @__PURE__ */ Nt(KO);
var vb = { exports: {} };
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.Scrollparent = r();
  })(he, function() {
    function t(n) {
      var i = getComputedStyle(n, null).getPropertyValue("overflow");
      return i.indexOf("scroll") > -1 || i.indexOf("auto") > -1;
    }
    function r(n) {
      if (n instanceof HTMLElement || n instanceof SVGElement) {
        for (var i = n.parentNode; i.parentNode; ) {
          if (t(i))
            return i;
          i = i.parentNode;
        }
        return document.scrollingElement || document.documentElement;
      }
    }
    return r;
  });
})(vb);
var ZO = vb.exports;
const mb = /* @__PURE__ */ Nt(ZO);
function eD(e) {
  return Object.keys(e);
}
function yb(e, ...t) {
  if (!oe.plainObject(e))
    throw new TypeError("Expected an object");
  const r = {};
  for (const n in e)
    ({}).hasOwnProperty.call(e, n) && (t.includes(n) || (r[n] = e[n]));
  return r;
}
function tD(e, ...t) {
  if (!oe.plainObject(e))
    throw new TypeError("Expected an object");
  if (!t.length)
    return e;
  const r = {};
  for (const n in e)
    ({}).hasOwnProperty.call(e, n) && t.includes(n) && (r[n] = e[n]);
  return r;
}
var rD = function(t) {
  return nD(t) && !iD(t);
};
function nD(e) {
  return !!e && typeof e == "object";
}
function iD(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || sD(e);
}
var aD = typeof Symbol == "function" && Symbol.for, oD = aD ? Symbol.for("react.element") : 60103;
function sD(e) {
  return e.$$typeof === oD;
}
function uD(e) {
  return Array.isArray(e) ? [] : {};
}
function Po(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? wa(uD(e), e, t) : e;
}
function lD(e, t, r) {
  return e.concat(t).map(function(n) {
    return Po(n, r);
  });
}
function cD(e, t) {
  if (!t.customMerge)
    return wa;
  var r = t.customMerge(e);
  return typeof r == "function" ? r : wa;
}
function fD(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Gv(e) {
  return Object.keys(e).concat(fD(e));
}
function gb(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function dD(e, t) {
  return gb(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function hD(e, t, r) {
  var n = {};
  return r.isMergeableObject(e) && Gv(e).forEach(function(i) {
    n[i] = Po(e[i], r);
  }), Gv(t).forEach(function(i) {
    dD(e, i) || (gb(e, i) && r.isMergeableObject(t[i]) ? n[i] = cD(i, r)(e[i], t[i], r) : n[i] = Po(t[i], r));
  }), n;
}
function wa(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || lD, r.isMergeableObject = r.isMergeableObject || rD, r.cloneUnlessOtherwiseSpecified = Po;
  var n = Array.isArray(t), i = Array.isArray(e), a = n === i;
  return a ? n ? r.arrayMerge(e, t, r) : hD(e, t, r) : Po(t, r);
}
wa.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, i) {
    return wa(n, i, r);
  }, {});
};
var pD = wa, vD = pD;
const Si = /* @__PURE__ */ Nt(vD);
var ks = { exports: {} }, Ns = { exports: {} }, qe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kv;
function mD() {
  if (Kv)
    return qe;
  Kv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function g(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case t:
          switch (b = b.type, b) {
            case u:
            case l:
            case n:
            case a:
            case i:
            case f:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case c:
                case p:
                case h:
                case o:
                  return b;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  function E(b) {
    return g(b) === l;
  }
  return qe.AsyncMode = u, qe.ConcurrentMode = l, qe.ContextConsumer = s, qe.ContextProvider = o, qe.Element = t, qe.ForwardRef = c, qe.Fragment = n, qe.Lazy = p, qe.Memo = h, qe.Portal = r, qe.Profiler = a, qe.StrictMode = i, qe.Suspense = f, qe.isAsyncMode = function(b) {
    return E(b) || g(b) === u;
  }, qe.isConcurrentMode = E, qe.isContextConsumer = function(b) {
    return g(b) === s;
  }, qe.isContextProvider = function(b) {
    return g(b) === o;
  }, qe.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, qe.isForwardRef = function(b) {
    return g(b) === c;
  }, qe.isFragment = function(b) {
    return g(b) === n;
  }, qe.isLazy = function(b) {
    return g(b) === p;
  }, qe.isMemo = function(b) {
    return g(b) === h;
  }, qe.isPortal = function(b) {
    return g(b) === r;
  }, qe.isProfiler = function(b) {
    return g(b) === a;
  }, qe.isStrictMode = function(b) {
    return g(b) === i;
  }, qe.isSuspense = function(b) {
    return g(b) === f;
  }, qe.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === l || b === a || b === i || b === f || b === d || typeof b == "object" && b !== null && (b.$$typeof === p || b.$$typeof === h || b.$$typeof === o || b.$$typeof === s || b.$$typeof === c || b.$$typeof === m || b.$$typeof === x || b.$$typeof === y || b.$$typeof === v);
  }, qe.typeOf = g, qe;
}
var Ye = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qv;
function yD() {
  return Qv || (Qv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function g(M) {
      return typeof M == "string" || typeof M == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      M === n || M === l || M === a || M === i || M === f || M === d || typeof M == "object" && M !== null && (M.$$typeof === p || M.$$typeof === h || M.$$typeof === o || M.$$typeof === s || M.$$typeof === c || M.$$typeof === m || M.$$typeof === x || M.$$typeof === y || M.$$typeof === v);
    }
    function E(M) {
      if (typeof M == "object" && M !== null) {
        var H = M.$$typeof;
        switch (H) {
          case t:
            var ee = M.type;
            switch (ee) {
              case u:
              case l:
              case n:
              case a:
              case i:
              case f:
                return ee;
              default:
                var xe = ee && ee.$$typeof;
                switch (xe) {
                  case s:
                  case c:
                  case p:
                  case h:
                  case o:
                    return xe;
                  default:
                    return H;
                }
            }
          case r:
            return H;
        }
      }
    }
    var b = u, w = l, _ = s, A = o, O = t, T = c, C = n, $ = p, P = h, j = r, W = a, Y = i, V = f, ce = !1;
    function de(M) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(M) || E(M) === u;
    }
    function L(M) {
      return E(M) === l;
    }
    function D(M) {
      return E(M) === s;
    }
    function N(M) {
      return E(M) === o;
    }
    function B(M) {
      return typeof M == "object" && M !== null && M.$$typeof === t;
    }
    function F(M) {
      return E(M) === c;
    }
    function X(M) {
      return E(M) === n;
    }
    function Z(M) {
      return E(M) === p;
    }
    function ne(M) {
      return E(M) === h;
    }
    function K(M) {
      return E(M) === r;
    }
    function we(M) {
      return E(M) === a;
    }
    function I(M) {
      return E(M) === i;
    }
    function k(M) {
      return E(M) === f;
    }
    Ye.AsyncMode = b, Ye.ConcurrentMode = w, Ye.ContextConsumer = _, Ye.ContextProvider = A, Ye.Element = O, Ye.ForwardRef = T, Ye.Fragment = C, Ye.Lazy = $, Ye.Memo = P, Ye.Portal = j, Ye.Profiler = W, Ye.StrictMode = Y, Ye.Suspense = V, Ye.isAsyncMode = de, Ye.isConcurrentMode = L, Ye.isContextConsumer = D, Ye.isContextProvider = N, Ye.isElement = B, Ye.isForwardRef = F, Ye.isFragment = X, Ye.isLazy = Z, Ye.isMemo = ne, Ye.isPortal = K, Ye.isProfiler = we, Ye.isStrictMode = I, Ye.isSuspense = k, Ye.isValidElementType = g, Ye.typeOf = E;
  }()), Ye;
}
var Xv;
function X0() {
  return Xv || (Xv = 1, process.env.NODE_ENV === "production" ? Ns.exports = mD() : Ns.exports = yD()), Ns.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Tf, Jv;
function gD() {
  if (Jv)
    return Tf;
  Jv = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        l[c] = c;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Tf = i() ? Object.assign : function(a, o) {
    for (var s, u = n(a), l, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (u[f] = s[f]);
      if (e) {
        l = e(s);
        for (var d = 0; d < l.length; d++)
          r.call(s, l[d]) && (u[l[d]] = s[l[d]]);
      }
    }
    return u;
  }, Tf;
}
var Af, Zv;
function J0() {
  if (Zv)
    return Af;
  Zv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Af = e, Af;
}
var Cf, em;
function xb() {
  return em || (em = 1, Cf = Function.call.bind(Object.prototype.hasOwnProperty)), Cf;
}
var Of, tm;
function xD() {
  if (tm)
    return Of;
  tm = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = J0(), r = {}, n = xb();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (n(a, c)) {
          var f;
          try {
            if (typeof a[c] != "function") {
              var d = Error(
                (u || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = a[c](o, c, u, s, null, t);
          } catch (p) {
            f = p;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Of = i, Of;
}
var Df, rm;
function bD() {
  if (rm)
    return Df;
  rm = 1;
  var e = X0(), t = gD(), r = J0(), n = xb(), i = xD(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Df = function(s, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(L) {
      var D = L && (l && L[l] || L[c]);
      if (typeof D == "function")
        return D;
    }
    var d = "<<anonymous>>", h = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: y(),
      arrayOf: g,
      element: E(),
      elementType: b(),
      instanceOf: w,
      node: T(),
      objectOf: A,
      oneOf: _,
      oneOfType: O,
      shape: $,
      exact: P
    };
    function p(L, D) {
      return L === D ? L !== 0 || 1 / L === 1 / D : L !== L && D !== D;
    }
    function v(L, D) {
      this.message = L, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function m(L) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, N = 0;
      function B(X, Z, ne, K, we, I, k) {
        if (K = K || d, I = I || ne, k !== r) {
          if (u) {
            var M = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw M.name = "Invariant Violation", M;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var H = K + ":" + ne;
            !D[H] && // Avoid spamming the console because they are often not actionable except for lib authors
            N < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + I + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[H] = !0, N++);
          }
        }
        return Z[ne] == null ? X ? Z[ne] === null ? new v("The " + we + " `" + I + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new v("The " + we + " `" + I + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : L(Z, ne, K, we, I);
      }
      var F = B.bind(null, !1);
      return F.isRequired = B.bind(null, !0), F;
    }
    function x(L) {
      function D(N, B, F, X, Z, ne) {
        var K = N[B], we = Y(K);
        if (we !== L) {
          var I = V(K);
          return new v(
            "Invalid " + X + " `" + Z + "` of type " + ("`" + I + "` supplied to `" + F + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return m(D);
    }
    function y() {
      return m(o);
    }
    function g(L) {
      function D(N, B, F, X, Z) {
        if (typeof L != "function")
          return new v("Property `" + Z + "` of component `" + F + "` has invalid PropType notation inside arrayOf.");
        var ne = N[B];
        if (!Array.isArray(ne)) {
          var K = Y(ne);
          return new v("Invalid " + X + " `" + Z + "` of type " + ("`" + K + "` supplied to `" + F + "`, expected an array."));
        }
        for (var we = 0; we < ne.length; we++) {
          var I = L(ne, we, F, X, Z + "[" + we + "]", r);
          if (I instanceof Error)
            return I;
        }
        return null;
      }
      return m(D);
    }
    function E() {
      function L(D, N, B, F, X) {
        var Z = D[N];
        if (!s(Z)) {
          var ne = Y(Z);
          return new v("Invalid " + F + " `" + X + "` of type " + ("`" + ne + "` supplied to `" + B + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(L);
    }
    function b() {
      function L(D, N, B, F, X) {
        var Z = D[N];
        if (!e.isValidElementType(Z)) {
          var ne = Y(Z);
          return new v("Invalid " + F + " `" + X + "` of type " + ("`" + ne + "` supplied to `" + B + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(L);
    }
    function w(L) {
      function D(N, B, F, X, Z) {
        if (!(N[B] instanceof L)) {
          var ne = L.name || d, K = de(N[B]);
          return new v("Invalid " + X + " `" + Z + "` of type " + ("`" + K + "` supplied to `" + F + "`, expected ") + ("instance of `" + ne + "`."));
        }
        return null;
      }
      return m(D);
    }
    function _(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function D(N, B, F, X, Z) {
        for (var ne = N[B], K = 0; K < L.length; K++)
          if (p(ne, L[K]))
            return null;
        var we = JSON.stringify(L, function(k, M) {
          var H = V(M);
          return H === "symbol" ? String(M) : M;
        });
        return new v("Invalid " + X + " `" + Z + "` of value `" + String(ne) + "` " + ("supplied to `" + F + "`, expected one of " + we + "."));
      }
      return m(D);
    }
    function A(L) {
      function D(N, B, F, X, Z) {
        if (typeof L != "function")
          return new v("Property `" + Z + "` of component `" + F + "` has invalid PropType notation inside objectOf.");
        var ne = N[B], K = Y(ne);
        if (K !== "object")
          return new v("Invalid " + X + " `" + Z + "` of type " + ("`" + K + "` supplied to `" + F + "`, expected an object."));
        for (var we in ne)
          if (n(ne, we)) {
            var I = L(ne, we, F, X, Z + "." + we, r);
            if (I instanceof Error)
              return I;
          }
        return null;
      }
      return m(D);
    }
    function O(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var D = 0; D < L.length; D++) {
        var N = L[D];
        if (typeof N != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(N) + " at index " + D + "."
          ), o;
      }
      function B(F, X, Z, ne, K) {
        for (var we = [], I = 0; I < L.length; I++) {
          var k = L[I], M = k(F, X, Z, ne, K, r);
          if (M == null)
            return null;
          M.data && n(M.data, "expectedType") && we.push(M.data.expectedType);
        }
        var H = we.length > 0 ? ", expected one of type [" + we.join(", ") + "]" : "";
        return new v("Invalid " + ne + " `" + K + "` supplied to " + ("`" + Z + "`" + H + "."));
      }
      return m(B);
    }
    function T() {
      function L(D, N, B, F, X) {
        return j(D[N]) ? null : new v("Invalid " + F + " `" + X + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
      }
      return m(L);
    }
    function C(L, D, N, B, F) {
      return new v(
        (L || "React class") + ": " + D + " type `" + N + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + F + "`."
      );
    }
    function $(L) {
      function D(N, B, F, X, Z) {
        var ne = N[B], K = Y(ne);
        if (K !== "object")
          return new v("Invalid " + X + " `" + Z + "` of type `" + K + "` " + ("supplied to `" + F + "`, expected `object`."));
        for (var we in L) {
          var I = L[we];
          if (typeof I != "function")
            return C(F, X, Z, we, V(I));
          var k = I(ne, we, F, X, Z + "." + we, r);
          if (k)
            return k;
        }
        return null;
      }
      return m(D);
    }
    function P(L) {
      function D(N, B, F, X, Z) {
        var ne = N[B], K = Y(ne);
        if (K !== "object")
          return new v("Invalid " + X + " `" + Z + "` of type `" + K + "` " + ("supplied to `" + F + "`, expected `object`."));
        var we = t({}, N[B], L);
        for (var I in we) {
          var k = L[I];
          if (n(L, I) && typeof k != "function")
            return C(F, X, Z, I, V(k));
          if (!k)
            return new v(
              "Invalid " + X + " `" + Z + "` key `" + I + "` supplied to `" + F + "`.\nBad object: " + JSON.stringify(N[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var M = k(ne, I, F, X, Z + "." + I, r);
          if (M)
            return M;
        }
        return null;
      }
      return m(D);
    }
    function j(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(j);
          if (L === null || s(L))
            return !0;
          var D = f(L);
          if (D) {
            var N = D.call(L), B;
            if (D !== L.entries) {
              for (; !(B = N.next()).done; )
                if (!j(B.value))
                  return !1;
            } else
              for (; !(B = N.next()).done; ) {
                var F = B.value;
                if (F && !j(F[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(L, D) {
      return L === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function Y(L) {
      var D = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : W(D, L) ? "symbol" : D;
    }
    function V(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var D = Y(L);
      if (D === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function ce(L) {
      var D = V(L);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function de(L) {
      return !L.constructor || !L.constructor.name ? d : L.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Df;
}
var Ff, nm;
function ED() {
  if (nm)
    return Ff;
  nm = 1;
  var e = J0();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Ff = function() {
    function n(o, s, u, l, c, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Ff;
}
var im;
function bb() {
  if (im)
    return ks.exports;
  if (im = 1, process.env.NODE_ENV !== "production") {
    var e = X0(), t = !0;
    ks.exports = bD()(e.isElement, t);
  } else
    ks.exports = ED()();
  return ks.exports;
}
var wD = bb();
const J = /* @__PURE__ */ Nt(wD);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var rs = typeof window < "u" && typeof document < "u" && typeof navigator < "u", SD = function() {
  for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
    if (rs && navigator.userAgent.indexOf(e[t]) >= 0)
      return 1;
  return 0;
}();
function _D(e) {
  var t = !1;
  return function() {
    t || (t = !0, window.Promise.resolve().then(function() {
      t = !1, e();
    }));
  };
}
function TD(e) {
  var t = !1;
  return function() {
    t || (t = !0, setTimeout(function() {
      t = !1, e();
    }, SD));
  };
}
var AD = rs && window.Promise, CD = AD ? _D : TD;
function Eb(e) {
  var t = {};
  return e && t.toString.call(e) === "[object Function]";
}
function Ui(e, t) {
  if (e.nodeType !== 1)
    return [];
  var r = e.ownerDocument.defaultView, n = r.getComputedStyle(e, null);
  return t ? n[t] : n;
}
function Z0(e) {
  return e.nodeName === "HTML" ? e : e.parentNode || e.host;
}
function ns(e) {
  if (!e)
    return document.body;
  switch (e.nodeName) {
    case "HTML":
    case "BODY":
      return e.ownerDocument.body;
    case "#document":
      return e.body;
  }
  var t = Ui(e), r = t.overflow, n = t.overflowX, i = t.overflowY;
  return /(auto|scroll|overlay)/.test(r + i + n) ? e : ns(Z0(e));
}
function wb(e) {
  return e && e.referenceNode ? e.referenceNode : e;
}
var am = rs && !!(window.MSInputMethodContext && document.documentMode), om = rs && /MSIE 10/.test(navigator.userAgent);
function $a(e) {
  return e === 11 ? am : e === 10 ? om : am || om;
}
function Sa(e) {
  if (!e)
    return document.documentElement;
  for (var t = $a(10) ? document.body : null, r = e.offsetParent || null; r === t && e.nextElementSibling; )
    r = (e = e.nextElementSibling).offsetParent;
  var n = r && r.nodeName;
  return !n || n === "BODY" || n === "HTML" ? e ? e.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(r.nodeName) !== -1 && Ui(r, "position") === "static" ? Sa(r) : r;
}
function OD(e) {
  var t = e.nodeName;
  return t === "BODY" ? !1 : t === "HTML" || Sa(e.firstElementChild) === e;
}
function xd(e) {
  return e.parentNode !== null ? xd(e.parentNode) : e;
}
function Fu(e, t) {
  if (!e || !e.nodeType || !t || !t.nodeType)
    return document.documentElement;
  var r = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, n = r ? e : t, i = r ? t : e, a = document.createRange();
  a.setStart(n, 0), a.setEnd(i, 0);
  var o = a.commonAncestorContainer;
  if (e !== o && t !== o || n.contains(i))
    return OD(o) ? o : Sa(o);
  var s = xd(e);
  return s.host ? Fu(s.host, t) : Fu(e, xd(t).host);
}
function _a(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", r = t === "top" ? "scrollTop" : "scrollLeft", n = e.nodeName;
  if (n === "BODY" || n === "HTML") {
    var i = e.ownerDocument.documentElement, a = e.ownerDocument.scrollingElement || i;
    return a[r];
  }
  return e[r];
}
function DD(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = _a(t, "top"), i = _a(t, "left"), a = r ? -1 : 1;
  return e.top += n * a, e.bottom += n * a, e.left += i * a, e.right += i * a, e;
}
function sm(e, t) {
  var r = t === "x" ? "Left" : "Top", n = r === "Left" ? "Right" : "Bottom";
  return parseFloat(e["border" + r + "Width"]) + parseFloat(e["border" + n + "Width"]);
}
function um(e, t, r, n) {
  return Math.max(t["offset" + e], t["scroll" + e], r["client" + e], r["offset" + e], r["scroll" + e], $a(10) ? parseInt(r["offset" + e]) + parseInt(n["margin" + (e === "Height" ? "Top" : "Left")]) + parseInt(n["margin" + (e === "Height" ? "Bottom" : "Right")]) : 0);
}
function Sb(e) {
  var t = e.body, r = e.documentElement, n = $a(10) && getComputedStyle(r);
  return {
    height: um("Height", t, r, n),
    width: um("Width", t, r, n)
  };
}
var FD = function(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, ID = function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var i = r[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}(), Ta = function(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}, vr = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
};
function Xn(e) {
  return vr({}, e, {
    right: e.left + e.width,
    bottom: e.top + e.height
  });
}
function bd(e) {
  var t = {};
  try {
    if ($a(10)) {
      t = e.getBoundingClientRect();
      var r = _a(e, "top"), n = _a(e, "left");
      t.top += r, t.left += n, t.bottom += r, t.right += n;
    } else
      t = e.getBoundingClientRect();
  } catch {
  }
  var i = {
    left: t.left,
    top: t.top,
    width: t.right - t.left,
    height: t.bottom - t.top
  }, a = e.nodeName === "HTML" ? Sb(e.ownerDocument) : {}, o = a.width || e.clientWidth || i.width, s = a.height || e.clientHeight || i.height, u = e.offsetWidth - o, l = e.offsetHeight - s;
  if (u || l) {
    var c = Ui(e);
    u -= sm(c, "x"), l -= sm(c, "y"), i.width -= u, i.height -= l;
  }
  return Xn(i);
}
function eh(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = $a(10), i = t.nodeName === "HTML", a = bd(e), o = bd(t), s = ns(e), u = Ui(t), l = parseFloat(u.borderTopWidth), c = parseFloat(u.borderLeftWidth);
  r && i && (o.top = Math.max(o.top, 0), o.left = Math.max(o.left, 0));
  var f = Xn({
    top: a.top - o.top - l,
    left: a.left - o.left - c,
    width: a.width,
    height: a.height
  });
  if (f.marginTop = 0, f.marginLeft = 0, !n && i) {
    var d = parseFloat(u.marginTop), h = parseFloat(u.marginLeft);
    f.top -= l - d, f.bottom -= l - d, f.left -= c - h, f.right -= c - h, f.marginTop = d, f.marginLeft = h;
  }
  return (n && !r ? t.contains(s) : t === s && s.nodeName !== "BODY") && (f = DD(f, t)), f;
}
function kD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = e.ownerDocument.documentElement, n = eh(e, r), i = Math.max(r.clientWidth, window.innerWidth || 0), a = Math.max(r.clientHeight, window.innerHeight || 0), o = t ? 0 : _a(r), s = t ? 0 : _a(r, "left"), u = {
    top: o - n.top + n.marginTop,
    left: s - n.left + n.marginLeft,
    width: i,
    height: a
  };
  return Xn(u);
}
function _b(e) {
  var t = e.nodeName;
  if (t === "BODY" || t === "HTML")
    return !1;
  if (Ui(e, "position") === "fixed")
    return !0;
  var r = Z0(e);
  return r ? _b(r) : !1;
}
function Tb(e) {
  if (!e || !e.parentElement || $a())
    return document.documentElement;
  for (var t = e.parentElement; t && Ui(t, "transform") === "none"; )
    t = t.parentElement;
  return t || document.documentElement;
}
function th(e, t, r, n) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, a = { top: 0, left: 0 }, o = i ? Tb(e) : Fu(e, wb(t));
  if (n === "viewport")
    a = kD(o, i);
  else {
    var s = void 0;
    n === "scrollParent" ? (s = ns(Z0(t)), s.nodeName === "BODY" && (s = e.ownerDocument.documentElement)) : n === "window" ? s = e.ownerDocument.documentElement : s = n;
    var u = eh(s, o, i);
    if (s.nodeName === "HTML" && !_b(o)) {
      var l = Sb(e.ownerDocument), c = l.height, f = l.width;
      a.top += u.top - u.marginTop, a.bottom = c + u.top, a.left += u.left - u.marginLeft, a.right = f + u.left;
    } else
      a = u;
  }
  r = r || 0;
  var d = typeof r == "number";
  return a.left += d ? r : r.left || 0, a.top += d ? r : r.top || 0, a.right -= d ? r : r.right || 0, a.bottom -= d ? r : r.bottom || 0, a;
}
function ND(e) {
  var t = e.width, r = e.height;
  return t * r;
}
function Ab(e, t, r, n, i) {
  var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (e.indexOf("auto") === -1)
    return e;
  var o = th(r, n, a, i), s = {
    top: {
      width: o.width,
      height: t.top - o.top
    },
    right: {
      width: o.right - t.right,
      height: o.height
    },
    bottom: {
      width: o.width,
      height: o.bottom - t.bottom
    },
    left: {
      width: t.left - o.left,
      height: o.height
    }
  }, u = Object.keys(s).map(function(d) {
    return vr({
      key: d
    }, s[d], {
      area: ND(s[d])
    });
  }).sort(function(d, h) {
    return h.area - d.area;
  }), l = u.filter(function(d) {
    var h = d.width, p = d.height;
    return h >= r.clientWidth && p >= r.clientHeight;
  }), c = l.length > 0 ? l[0].key : u[0].key, f = e.split("-")[1];
  return c + (f ? "-" + f : "");
}
function Cb(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, i = n ? Tb(t) : Fu(t, wb(r));
  return eh(r, i, n);
}
function Ob(e) {
  var t = e.ownerDocument.defaultView, r = t.getComputedStyle(e), n = parseFloat(r.marginTop || 0) + parseFloat(r.marginBottom || 0), i = parseFloat(r.marginLeft || 0) + parseFloat(r.marginRight || 0), a = {
    width: e.offsetWidth + i,
    height: e.offsetHeight + n
  };
  return a;
}
function Iu(e) {
  var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return e.replace(/left|right|bottom|top/g, function(r) {
    return t[r];
  });
}
function Db(e, t, r) {
  r = r.split("-")[0];
  var n = Ob(e), i = {
    width: n.width,
    height: n.height
  }, a = ["right", "left"].indexOf(r) !== -1, o = a ? "top" : "left", s = a ? "left" : "top", u = a ? "height" : "width", l = a ? "width" : "height";
  return i[o] = t[o] + t[u] / 2 - n[u] / 2, r === s ? i[s] = t[s] - n[l] : i[s] = t[Iu(s)], i;
}
function is(e, t) {
  return Array.prototype.find ? e.find(t) : e.filter(t)[0];
}
function PD(e, t, r) {
  if (Array.prototype.findIndex)
    return e.findIndex(function(i) {
      return i[t] === r;
    });
  var n = is(e, function(i) {
    return i[t] === r;
  });
  return e.indexOf(n);
}
function Fb(e, t, r) {
  var n = r === void 0 ? e : e.slice(0, PD(e, "name", r));
  return n.forEach(function(i) {
    i.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var a = i.function || i.fn;
    i.enabled && Eb(a) && (t.offsets.popper = Xn(t.offsets.popper), t.offsets.reference = Xn(t.offsets.reference), t = a(t, i));
  }), t;
}
function $D() {
  if (!this.state.isDestroyed) {
    var e = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    e.offsets.reference = Cb(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = Ab(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = Db(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = Fb(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
  }
}
function Ib(e, t) {
  return e.some(function(r) {
    var n = r.name, i = r.enabled;
    return i && n === t;
  });
}
function rh(e) {
  for (var t = [!1, "ms", "Webkit", "Moz", "O"], r = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < t.length; n++) {
    var i = t[n], a = i ? "" + i + r : e;
    if (typeof document.body.style[a] < "u")
      return a;
  }
  return null;
}
function RD() {
  return this.state.isDestroyed = !0, Ib(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[rh("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function kb(e) {
  var t = e.ownerDocument;
  return t ? t.defaultView : window;
}
function Nb(e, t, r, n) {
  var i = e.nodeName === "BODY", a = i ? e.ownerDocument.defaultView : e;
  a.addEventListener(t, r, { passive: !0 }), i || Nb(ns(a.parentNode), t, r, n), n.push(a);
}
function MD(e, t, r, n) {
  r.updateBound = n, kb(e).addEventListener("resize", r.updateBound, { passive: !0 });
  var i = ns(e);
  return Nb(i, "scroll", r.updateBound, r.scrollParents), r.scrollElement = i, r.eventsEnabled = !0, r;
}
function BD() {
  this.state.eventsEnabled || (this.state = MD(this.reference, this.options, this.state, this.scheduleUpdate));
}
function jD(e, t) {
  return kb(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(r) {
    r.removeEventListener("scroll", t.updateBound);
  }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t;
}
function LD() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = jD(this.reference, this.state));
}
function nh(e) {
  return e !== "" && !isNaN(parseFloat(e)) && isFinite(e);
}
function Ed(e, t) {
  Object.keys(t).forEach(function(r) {
    var n = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(r) !== -1 && nh(t[r]) && (n = "px"), e.style[r] = t[r] + n;
  });
}
function UD(e, t) {
  Object.keys(t).forEach(function(r) {
    var n = t[r];
    n !== !1 ? e.setAttribute(r, t[r]) : e.removeAttribute(r);
  });
}
function HD(e) {
  return Ed(e.instance.popper, e.styles), UD(e.instance.popper, e.attributes), e.arrowElement && Object.keys(e.arrowStyles).length && Ed(e.arrowElement, e.arrowStyles), e;
}
function WD(e, t, r, n, i) {
  var a = Cb(i, t, e, r.positionFixed), o = Ab(r.placement, a, t, e, r.modifiers.flip.boundariesElement, r.modifiers.flip.padding);
  return t.setAttribute("x-placement", o), Ed(t, { position: r.positionFixed ? "fixed" : "absolute" }), r;
}
function zD(e, t) {
  var r = e.offsets, n = r.popper, i = r.reference, a = Math.round, o = Math.floor, s = function(x) {
    return x;
  }, u = a(i.width), l = a(n.width), c = ["left", "right"].indexOf(e.placement) !== -1, f = e.placement.indexOf("-") !== -1, d = u % 2 === l % 2, h = u % 2 === 1 && l % 2 === 1, p = t ? c || f || d ? a : o : s, v = t ? a : s;
  return {
    left: p(h && !f && t ? n.left - 1 : n.left),
    top: v(n.top),
    bottom: v(n.bottom),
    right: p(n.right)
  };
}
var qD = rs && /Firefox/i.test(navigator.userAgent);
function YD(e, t) {
  var r = t.x, n = t.y, i = e.offsets.popper, a = is(e.instance.modifiers, function(g) {
    return g.name === "applyStyle";
  }).gpuAcceleration;
  a !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var o = a !== void 0 ? a : t.gpuAcceleration, s = Sa(e.instance.popper), u = bd(s), l = {
    position: i.position
  }, c = zD(e, window.devicePixelRatio < 2 || !qD), f = r === "bottom" ? "top" : "bottom", d = n === "right" ? "left" : "right", h = rh("transform"), p = void 0, v = void 0;
  if (f === "bottom" ? s.nodeName === "HTML" ? v = -s.clientHeight + c.bottom : v = -u.height + c.bottom : v = c.top, d === "right" ? s.nodeName === "HTML" ? p = -s.clientWidth + c.right : p = -u.width + c.right : p = c.left, o && h)
    l[h] = "translate3d(" + p + "px, " + v + "px, 0)", l[f] = 0, l[d] = 0, l.willChange = "transform";
  else {
    var m = f === "bottom" ? -1 : 1, x = d === "right" ? -1 : 1;
    l[f] = v * m, l[d] = p * x, l.willChange = f + ", " + d;
  }
  var y = {
    "x-placement": e.placement
  };
  return e.attributes = vr({}, y, e.attributes), e.styles = vr({}, l, e.styles), e.arrowStyles = vr({}, e.offsets.arrow, e.arrowStyles), e;
}
function Pb(e, t, r) {
  var n = is(e, function(s) {
    var u = s.name;
    return u === t;
  }), i = !!n && e.some(function(s) {
    return s.name === r && s.enabled && s.order < n.order;
  });
  if (!i) {
    var a = "`" + t + "`", o = "`" + r + "`";
    console.warn(o + " modifier is required by " + a + " modifier in order to work, be sure to include it before " + a + "!");
  }
  return i;
}
function VD(e, t) {
  var r;
  if (!Pb(e.instance.modifiers, "arrow", "keepTogether"))
    return e;
  var n = t.element;
  if (typeof n == "string") {
    if (n = e.instance.popper.querySelector(n), !n)
      return e;
  } else if (!e.instance.popper.contains(n))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
  var i = e.placement.split("-")[0], a = e.offsets, o = a.popper, s = a.reference, u = ["left", "right"].indexOf(i) !== -1, l = u ? "height" : "width", c = u ? "Top" : "Left", f = c.toLowerCase(), d = u ? "left" : "top", h = u ? "bottom" : "right", p = Ob(n)[l];
  s[h] - p < o[f] && (e.offsets.popper[f] -= o[f] - (s[h] - p)), s[f] + p > o[h] && (e.offsets.popper[f] += s[f] + p - o[h]), e.offsets.popper = Xn(e.offsets.popper);
  var v = s[f] + s[l] / 2 - p / 2, m = Ui(e.instance.popper), x = parseFloat(m["margin" + c]), y = parseFloat(m["border" + c + "Width"]), g = v - e.offsets.popper[f] - x - y;
  return g = Math.max(Math.min(o[l] - p, g), 0), e.arrowElement = n, e.offsets.arrow = (r = {}, Ta(r, f, Math.round(g)), Ta(r, d, ""), r), e;
}
function GD(e) {
  return e === "end" ? "start" : e === "start" ? "end" : e;
}
var $b = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], If = $b.slice(3);
function lm(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = If.indexOf(e), n = If.slice(r + 1).concat(If.slice(0, r));
  return t ? n.reverse() : n;
}
var kf = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function KD(e, t) {
  if (Ib(e.instance.modifiers, "inner") || e.flipped && e.placement === e.originalPlacement)
    return e;
  var r = th(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed), n = e.placement.split("-")[0], i = Iu(n), a = e.placement.split("-")[1] || "", o = [];
  switch (t.behavior) {
    case kf.FLIP:
      o = [n, i];
      break;
    case kf.CLOCKWISE:
      o = lm(n);
      break;
    case kf.COUNTERCLOCKWISE:
      o = lm(n, !0);
      break;
    default:
      o = t.behavior;
  }
  return o.forEach(function(s, u) {
    if (n !== s || o.length === u + 1)
      return e;
    n = e.placement.split("-")[0], i = Iu(n);
    var l = e.offsets.popper, c = e.offsets.reference, f = Math.floor, d = n === "left" && f(l.right) > f(c.left) || n === "right" && f(l.left) < f(c.right) || n === "top" && f(l.bottom) > f(c.top) || n === "bottom" && f(l.top) < f(c.bottom), h = f(l.left) < f(r.left), p = f(l.right) > f(r.right), v = f(l.top) < f(r.top), m = f(l.bottom) > f(r.bottom), x = n === "left" && h || n === "right" && p || n === "top" && v || n === "bottom" && m, y = ["top", "bottom"].indexOf(n) !== -1, g = !!t.flipVariations && (y && a === "start" && h || y && a === "end" && p || !y && a === "start" && v || !y && a === "end" && m), E = !!t.flipVariationsByContent && (y && a === "start" && p || y && a === "end" && h || !y && a === "start" && m || !y && a === "end" && v), b = g || E;
    (d || x || b) && (e.flipped = !0, (d || x) && (n = o[u + 1]), b && (a = GD(a)), e.placement = n + (a ? "-" + a : ""), e.offsets.popper = vr({}, e.offsets.popper, Db(e.instance.popper, e.offsets.reference, e.placement)), e = Fb(e.instance.modifiers, e, "flip"));
  }), e;
}
function QD(e) {
  var t = e.offsets, r = t.popper, n = t.reference, i = e.placement.split("-")[0], a = Math.floor, o = ["top", "bottom"].indexOf(i) !== -1, s = o ? "right" : "bottom", u = o ? "left" : "top", l = o ? "width" : "height";
  return r[s] < a(n[u]) && (e.offsets.popper[u] = a(n[u]) - r[l]), r[u] > a(n[s]) && (e.offsets.popper[u] = a(n[s])), e;
}
function XD(e, t, r, n) {
  var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), a = +i[1], o = i[2];
  if (!a)
    return e;
  if (o.indexOf("%") === 0) {
    var s = void 0;
    switch (o) {
      case "%p":
        s = r;
        break;
      case "%":
      case "%r":
      default:
        s = n;
    }
    var u = Xn(s);
    return u[t] / 100 * a;
  } else if (o === "vh" || o === "vw") {
    var l = void 0;
    return o === "vh" ? l = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : l = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), l / 100 * a;
  } else
    return a;
}
function JD(e, t, r, n) {
  var i = [0, 0], a = ["right", "left"].indexOf(n) !== -1, o = e.split(/(\+|\-)/).map(function(c) {
    return c.trim();
  }), s = o.indexOf(is(o, function(c) {
    return c.search(/,|\s/) !== -1;
  }));
  o[s] && o[s].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var u = /\s*,\s*|\s+/, l = s !== -1 ? [o.slice(0, s).concat([o[s].split(u)[0]]), [o[s].split(u)[1]].concat(o.slice(s + 1))] : [o];
  return l = l.map(function(c, f) {
    var d = (f === 1 ? !a : a) ? "height" : "width", h = !1;
    return c.reduce(function(p, v) {
      return p[p.length - 1] === "" && ["+", "-"].indexOf(v) !== -1 ? (p[p.length - 1] = v, h = !0, p) : h ? (p[p.length - 1] += v, h = !1, p) : p.concat(v);
    }, []).map(function(p) {
      return XD(p, d, t, r);
    });
  }), l.forEach(function(c, f) {
    c.forEach(function(d, h) {
      nh(d) && (i[f] += d * (c[h - 1] === "-" ? -1 : 1));
    });
  }), i;
}
function ZD(e, t) {
  var r = t.offset, n = e.placement, i = e.offsets, a = i.popper, o = i.reference, s = n.split("-")[0], u = void 0;
  return nh(+r) ? u = [+r, 0] : u = JD(r, a, o, s), s === "left" ? (a.top += u[0], a.left -= u[1]) : s === "right" ? (a.top += u[0], a.left += u[1]) : s === "top" ? (a.left += u[0], a.top -= u[1]) : s === "bottom" && (a.left += u[0], a.top += u[1]), e.popper = a, e;
}
function eF(e, t) {
  var r = t.boundariesElement || Sa(e.instance.popper);
  e.instance.reference === r && (r = Sa(r));
  var n = rh("transform"), i = e.instance.popper.style, a = i.top, o = i.left, s = i[n];
  i.top = "", i.left = "", i[n] = "";
  var u = th(e.instance.popper, e.instance.reference, t.padding, r, e.positionFixed);
  i.top = a, i.left = o, i[n] = s, t.boundaries = u;
  var l = t.priority, c = e.offsets.popper, f = {
    primary: function(h) {
      var p = c[h];
      return c[h] < u[h] && !t.escapeWithReference && (p = Math.max(c[h], u[h])), Ta({}, h, p);
    },
    secondary: function(h) {
      var p = h === "right" ? "left" : "top", v = c[p];
      return c[h] > u[h] && !t.escapeWithReference && (v = Math.min(c[p], u[h] - (h === "right" ? c.width : c.height))), Ta({}, p, v);
    }
  };
  return l.forEach(function(d) {
    var h = ["left", "top"].indexOf(d) !== -1 ? "primary" : "secondary";
    c = vr({}, c, f[h](d));
  }), e.offsets.popper = c, e;
}
function tF(e) {
  var t = e.placement, r = t.split("-")[0], n = t.split("-")[1];
  if (n) {
    var i = e.offsets, a = i.reference, o = i.popper, s = ["bottom", "top"].indexOf(r) !== -1, u = s ? "left" : "top", l = s ? "width" : "height", c = {
      start: Ta({}, u, a[u]),
      end: Ta({}, u, a[u] + a[l] - o[l])
    };
    e.offsets.popper = vr({}, o, c[n]);
  }
  return e;
}
function rF(e) {
  if (!Pb(e.instance.modifiers, "hide", "preventOverflow"))
    return e;
  var t = e.offsets.reference, r = is(e.instance.modifiers, function(n) {
    return n.name === "preventOverflow";
  }).boundaries;
  if (t.bottom < r.top || t.left > r.right || t.top > r.bottom || t.right < r.left) {
    if (e.hide === !0)
      return e;
    e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
  } else {
    if (e.hide === !1)
      return e;
    e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
  }
  return e;
}
function nF(e) {
  var t = e.placement, r = t.split("-")[0], n = e.offsets, i = n.popper, a = n.reference, o = ["left", "right"].indexOf(r) !== -1, s = ["top", "left"].indexOf(r) === -1;
  return i[o ? "left" : "top"] = a[r] - (s ? i[o ? "width" : "height"] : 0), e.placement = Iu(t), e.offsets.popper = Xn(i), e;
}
var iF = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: tF
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: ZD,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: eF,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: QD
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: VD,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: KD,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: nF
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: rF
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: YD,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: HD,
    /** @prop {Function} */
    onLoad: WD,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, aF = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: iF
}, $l = function() {
  function e(t, r) {
    var n = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    FD(this, e), this.scheduleUpdate = function() {
      return requestAnimationFrame(n.update);
    }, this.update = CD(this.update.bind(this)), this.options = vr({}, e.Defaults, i), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = t && t.jquery ? t[0] : t, this.popper = r && r.jquery ? r[0] : r, this.options.modifiers = {}, Object.keys(vr({}, e.Defaults.modifiers, i.modifiers)).forEach(function(o) {
      n.options.modifiers[o] = vr({}, e.Defaults.modifiers[o] || {}, i.modifiers ? i.modifiers[o] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(o) {
      return vr({
        name: o
      }, n.options.modifiers[o]);
    }).sort(function(o, s) {
      return o.order - s.order;
    }), this.modifiers.forEach(function(o) {
      o.enabled && Eb(o.onLoad) && o.onLoad(n.reference, n.popper, n.options, o, n.state);
    }), this.update();
    var a = this.options.eventsEnabled;
    a && this.enableEventListeners(), this.state.eventsEnabled = a;
  }
  return ID(e, [{
    key: "update",
    value: function() {
      return $D.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return RD.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return BD.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return LD.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), e;
}();
$l.Utils = (typeof window < "u" ? window : global).PopperUtils;
$l.placements = $b;
$l.Defaults = aF;
const cm = $l;
var oF = function(t) {
  return sF(t) && !uF(t);
};
function sF(e) {
  return !!e && typeof e == "object";
}
function uF(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || fF(e);
}
var lF = typeof Symbol == "function" && Symbol.for, cF = lF ? Symbol.for("react.element") : 60103;
function fF(e) {
  return e.$$typeof === cF;
}
function dF(e) {
  return Array.isArray(e) ? [] : {};
}
function $o(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Aa(dF(e), e, t) : e;
}
function hF(e, t, r) {
  return e.concat(t).map(function(n) {
    return $o(n, r);
  });
}
function pF(e, t) {
  if (!t.customMerge)
    return Aa;
  var r = t.customMerge(e);
  return typeof r == "function" ? r : Aa;
}
function vF(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function fm(e) {
  return Object.keys(e).concat(vF(e));
}
function Rb(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function mF(e, t) {
  return Rb(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function yF(e, t, r) {
  var n = {};
  return r.isMergeableObject(e) && fm(e).forEach(function(i) {
    n[i] = $o(e[i], r);
  }), fm(t).forEach(function(i) {
    mF(e, i) || (Rb(e, i) && r.isMergeableObject(t[i]) ? n[i] = pF(i, r)(e[i], t[i], r) : n[i] = $o(t[i], r));
  }), n;
}
function Aa(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || hF, r.isMergeableObject = r.isMergeableObject || oF, r.cloneUnlessOtherwiseSpecified = $o;
  var n = Array.isArray(t), i = Array.isArray(e), a = n === i;
  return a ? n ? r.arrayMerge(e, t, r) : yF(e, t, r) : $o(t, r);
}
Aa.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, i) {
    return Aa(n, i, r);
  }, {});
};
var gF = Aa, xF = gF;
const wd = /* @__PURE__ */ Nt(xF);
var bF = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
], EF = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], wF = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function Rl(e) {
  var t = Object.prototype.toString.call(e).slice(8, -1);
  if (/HTML\w+Element/.test(t))
    return "HTMLElement";
  if (SF(t))
    return t;
}
function Lr(e) {
  return function(t) {
    return Rl(t) === e;
  };
}
function SF(e) {
  return EF.includes(e);
}
function Ra(e) {
  return function(t) {
    return typeof t === e;
  };
}
function _F(e) {
  return wF.includes(e);
}
function z(e) {
  if (e === null)
    return "null";
  switch (typeof e) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (z.array(e))
    return "Array";
  if (z.plainFunction(e))
    return "Function";
  var t = Rl(e);
  return t || "Object";
}
z.array = Array.isArray;
z.arrayOf = function(e, t) {
  return !z.array(e) && !z.function(t) ? !1 : e.every(function(r) {
    return t(r);
  });
};
z.asyncGeneratorFunction = function(e) {
  return Rl(e) === "AsyncGeneratorFunction";
};
z.asyncFunction = Lr("AsyncFunction");
z.bigint = Ra("bigint");
z.boolean = function(e) {
  return e === !0 || e === !1;
};
z.date = Lr("Date");
z.defined = function(e) {
  return !z.undefined(e);
};
z.domElement = function(e) {
  return z.object(e) && !z.plainObject(e) && e.nodeType === 1 && z.string(e.nodeName) && bF.every(function(t) {
    return t in e;
  });
};
z.empty = function(e) {
  return z.string(e) && e.length === 0 || z.array(e) && e.length === 0 || z.object(e) && !z.map(e) && !z.set(e) && Object.keys(e).length === 0 || z.set(e) && e.size === 0 || z.map(e) && e.size === 0;
};
z.error = Lr("Error");
z.function = Ra("function");
z.generator = function(e) {
  return z.iterable(e) && z.function(e.next) && z.function(e.throw);
};
z.generatorFunction = Lr("GeneratorFunction");
z.instanceOf = function(e, t) {
  return !e || !t ? !1 : Object.getPrototypeOf(e) === t.prototype;
};
z.iterable = function(e) {
  return !z.nullOrUndefined(e) && z.function(e[Symbol.iterator]);
};
z.map = Lr("Map");
z.nan = function(e) {
  return Number.isNaN(e);
};
z.null = function(e) {
  return e === null;
};
z.nullOrUndefined = function(e) {
  return z.null(e) || z.undefined(e);
};
z.number = function(e) {
  return Ra("number")(e) && !z.nan(e);
};
z.numericString = function(e) {
  return z.string(e) && e.length > 0 && !Number.isNaN(Number(e));
};
z.object = function(e) {
  return !z.nullOrUndefined(e) && (z.function(e) || typeof e == "object");
};
z.oneOf = function(e, t) {
  return z.array(e) ? e.indexOf(t) > -1 : !1;
};
z.plainFunction = Lr("Function");
z.plainObject = function(e) {
  if (Rl(e) !== "Object")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.getPrototypeOf({});
};
z.primitive = function(e) {
  return z.null(e) || _F(typeof e);
};
z.promise = Lr("Promise");
z.propertyOf = function(e, t, r) {
  if (!z.object(e) || !t)
    return !1;
  var n = e[t];
  return z.function(r) ? r(n) : z.defined(n);
};
z.regexp = Lr("RegExp");
z.set = Lr("Set");
z.string = Ra("string");
z.symbol = Ra("symbol");
z.undefined = Ra("undefined");
z.weakMap = Lr("WeakMap");
z.weakSet = Lr("WeakSet");
function Mb(e) {
  return function(t) {
    return typeof t === e;
  };
}
var TF = Mb("function"), AF = function(e) {
  return e === null;
}, dm = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1) === "RegExp";
}, hm = function(e) {
  return !CF(e) && !AF(e) && (TF(e) || typeof e == "object");
}, CF = Mb("undefined"), Sd = globalThis && globalThis.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function OF(e, t) {
  var r = e.length;
  if (r !== t.length)
    return !1;
  for (var n = r; n-- !== 0; )
    if (!Qt(e[n], t[n]))
      return !1;
  return !0;
}
function DF(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  for (var r = new DataView(e.buffer), n = new DataView(t.buffer), i = e.byteLength; i--; )
    if (r.getUint8(i) !== n.getUint8(i))
      return !1;
  return !0;
}
function FF(e, t) {
  var r, n, i, a;
  if (e.size !== t.size)
    return !1;
  try {
    for (var o = Sd(e.entries()), s = o.next(); !s.done; s = o.next()) {
      var u = s.value;
      if (!t.has(u[0]))
        return !1;
    }
  } catch (f) {
    r = { error: f };
  } finally {
    try {
      s && !s.done && (n = o.return) && n.call(o);
    } finally {
      if (r)
        throw r.error;
    }
  }
  try {
    for (var l = Sd(e.entries()), c = l.next(); !c.done; c = l.next()) {
      var u = c.value;
      if (!Qt(u[1], t.get(u[0])))
        return !1;
    }
  } catch (f) {
    i = { error: f };
  } finally {
    try {
      c && !c.done && (a = l.return) && a.call(l);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return !0;
}
function IF(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = Sd(e.entries()), a = i.next(); !a.done; a = i.next()) {
      var o = a.value;
      if (!t.has(o[0]))
        return !1;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      a && !a.done && (n = i.return) && n.call(i);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return !0;
}
function Qt(e, t) {
  if (e === t)
    return !0;
  if (e && hm(e) && t && hm(t)) {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e) && Array.isArray(t))
      return OF(e, t);
    if (e instanceof Map && t instanceof Map)
      return FF(e, t);
    if (e instanceof Set && t instanceof Set)
      return IF(e, t);
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return DF(e, t);
    if (dm(e) && dm(t))
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    var r = Object.keys(e), n = Object.keys(t);
    if (r.length !== n.length)
      return !1;
    for (var i = r.length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[i]))
        return !1;
    for (var i = r.length; i-- !== 0; ) {
      var a = r[i];
      if (!(a === "_owner" && e.$$typeof) && !Qt(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(e) && Number.isNaN(t) ? !0 : e === t;
}
function kF() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.every(function(r) {
    return z.string(r) || z.array(r) || z.plainObject(r);
  });
}
function NF(e, t, r) {
  return Bb(e, t) ? [e, t].every(z.array) ? !e.some(gm(r)) && t.some(gm(r)) : [e, t].every(z.plainObject) ? !Object.entries(e).some(ym(r)) && Object.entries(t).some(ym(r)) : t === r : !1;
}
function pm(e, t, r) {
  var n = r.actual, i = r.key, a = r.previous, o = r.type, s = en(e, i), u = en(t, i), l = [s, u].every(z.number) && (o === "increased" ? s < u : s > u);
  return z.undefined(n) || (l = l && u === n), z.undefined(a) || (l = l && s === a), l;
}
function vm(e, t, r) {
  var n = r.key, i = r.type, a = r.value, o = en(e, n), s = en(t, n), u = i === "added" ? o : s, l = i === "added" ? s : o;
  if (!z.nullOrUndefined(a)) {
    if (z.defined(u)) {
      if (z.array(u) || z.plainObject(u))
        return NF(u, l, a);
    } else
      return Qt(l, a);
    return !1;
  }
  return [o, s].every(z.array) ? !l.every(ih(u)) : [o, s].every(z.plainObject) ? PF(Object.keys(u), Object.keys(l)) : ![o, s].every(function(c) {
    return z.primitive(c) && z.defined(c);
  }) && (i === "added" ? !z.defined(o) && z.defined(s) : z.defined(o) && !z.defined(s));
}
function mm(e, t, r) {
  var n = r === void 0 ? {} : r, i = n.key, a = en(e, i), o = en(t, i);
  if (!Bb(a, o))
    throw new TypeError("Inputs have different types");
  if (!kF(a, o))
    throw new TypeError("Inputs don't have length");
  return [a, o].every(z.plainObject) && (a = Object.keys(a), o = Object.keys(o)), [a, o];
}
function ym(e) {
  return function(t) {
    var r = t[0], n = t[1];
    return z.array(e) ? Qt(e, n) || e.some(function(i) {
      return Qt(i, n) || z.array(n) && ih(n)(i);
    }) : z.plainObject(e) && e[r] ? !!e[r] && Qt(e[r], n) : Qt(e, n);
  };
}
function PF(e, t) {
  return t.some(function(r) {
    return !e.includes(r);
  });
}
function gm(e) {
  return function(t) {
    return z.array(e) ? e.some(function(r) {
      return Qt(r, t) || z.array(t) && ih(t)(r);
    }) : Qt(e, t);
  };
}
function to(e, t) {
  return z.array(e) ? e.some(function(r) {
    return Qt(r, t);
  }) : Qt(e, t);
}
function ih(e) {
  return function(t) {
    return e.some(function(r) {
      return Qt(r, t);
    });
  };
}
function Bb() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.every(z.array) || e.every(z.number) || e.every(z.plainObject) || e.every(z.string);
}
function en(e, t) {
  if (z.plainObject(e) || z.array(e)) {
    if (z.string(t)) {
      var r = t.split(".");
      return r.reduce(function(n, i) {
        return n && n[i];
      }, e);
    }
    return z.number(t) ? e[t] : e;
  }
  return e;
}
function $F(e, t) {
  if ([e, t].some(z.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![e, t].every(function(f) {
    return z.plainObject(f) || z.array(f);
  }))
    throw new Error("Expected plain objects or array");
  var r = function(f, d) {
    try {
      return vm(e, t, { key: f, type: "added", value: d });
    } catch {
      return !1;
    }
  }, n = function(f, d, h) {
    try {
      var p = en(e, f), v = en(t, f), m = z.defined(d), x = z.defined(h);
      if (m || x) {
        var y = x ? to(h, p) : !to(d, p), g = to(d, v);
        return y && g;
      }
      return [p, v].every(z.array) || [p, v].every(z.plainObject) ? !Qt(p, v) : p !== v;
    } catch {
      return !1;
    }
  }, i = function(f, d, h) {
    if (!z.defined(f))
      return !1;
    try {
      var p = en(e, f), v = en(t, f), m = z.defined(h);
      return to(d, p) && (m ? to(h, v) : !m);
    } catch {
      return !1;
    }
  }, a = function(f, d) {
    return z.defined(f) ? (process.env.NODE_ENV === "development" && console.warn("`changedTo` is deprecated! Replace it with `change`"), n(f, d)) : !1;
  }, o = function(f, d, h) {
    if (!z.defined(f))
      return !1;
    try {
      return pm(e, t, { key: f, actual: d, previous: h, type: "decreased" });
    } catch {
      return !1;
    }
  }, s = function(f) {
    try {
      var d = mm(e, t, { key: f }), h = d[0], p = d[1];
      return !!h.length && !p.length;
    } catch {
      return !1;
    }
  }, u = function(f) {
    try {
      var d = mm(e, t, { key: f }), h = d[0], p = d[1];
      return !h.length && !!p.length;
    } catch {
      return !1;
    }
  }, l = function(f, d, h) {
    if (!z.defined(f))
      return !1;
    try {
      return pm(e, t, { key: f, actual: d, previous: h, type: "increased" });
    } catch {
      return !1;
    }
  }, c = function(f, d) {
    try {
      return vm(e, t, { key: f, type: "removed", value: d });
    } catch {
      return !1;
    }
  };
  return { added: r, changed: n, changedFrom: i, changedTo: a, decreased: o, emptied: s, filled: u, increased: l, removed: c };
}
function xm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ft(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xm(Object(r), !0).forEach(function(n) {
      Rt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function as(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lb(n.key), n);
  }
}
function os(e, t, r) {
  return t && bm(e.prototype, t), r && bm(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Rt(e, t, r) {
  return t = Lb(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ss(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && _d(e, t);
}
function ku(e) {
  return ku = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ku(e);
}
function _d(e, t) {
  return _d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, _d(e, t);
}
function RF() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function MF(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function jb(e, t) {
  if (e == null)
    return {};
  var r = MF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function vn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BF(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return vn(e);
}
function us(e) {
  var t = RF();
  return function() {
    var n = ku(e), i;
    if (t) {
      var a = ku(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return BF(this, i);
  };
}
function jF(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lb(e) {
  var t = jF(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var LF = { flip: { padding: 20 }, preventOverflow: { padding: 10 } }, UF = "The typeValidator argument must be a function with the signature function(props, propName, componentName).", HF = "The error message is optional, but must be a string if provided.";
function WF(e, t, r, n) {
  return typeof e == "boolean" ? e : typeof e == "function" ? e(t, r, n) : e ? !!e : !1;
}
function zF(e, t) {
  return Object.hasOwnProperty.call(e, t);
}
function qF(e, t, r, n) {
  return n ? new Error(n) : new Error("Required ".concat(e[t], " `").concat(t, "` was not specified in `").concat(r, "`."));
}
function YF(e, t) {
  if (typeof e != "function")
    throw new TypeError(UF);
  if (t && typeof t != "string")
    throw new TypeError(HF);
}
function Em(e, t, r) {
  return YF(e, r), function(n, i, a) {
    for (var o = arguments.length, s = new Array(o > 3 ? o - 3 : 0), u = 3; u < o; u++)
      s[u - 3] = arguments[u];
    return WF(t, n, i, a) ? zF(n, i) ? e.apply(void 0, [n, i, a].concat(s)) : qF(n, i, a, r) : e.apply(void 0, [n, i, a].concat(s));
  };
}
var $e = { INIT: "init", IDLE: "idle", OPENING: "opening", OPEN: "open", CLOSING: "closing", ERROR: "error" }, ro = eu.createPortal !== void 0;
function Kr() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Nf() {
  return "ontouchstart" in window && /Mobi/.test(navigator.userAgent);
}
function Ps(e) {
  var t = e.title, r = e.data, n = e.warn, i = n === void 0 ? !1 : n, a = e.debug, o = a === void 0 ? !1 : a, s = i ? console.warn || console.error : console.log;
  o && t && r && (console.groupCollapsed("%creact-floater: ".concat(t), "color: #9b00ff; font-weight: bold; font-size: 12px;"), Array.isArray(r) ? r.forEach(function(u) {
    z.plainObject(u) && u.key ? s.apply(console, [u.key, u.value]) : s.apply(console, [u]);
  }) : s.apply(console, [r]), console.groupEnd());
}
function VF(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  e.addEventListener(t, r, n);
}
function GF(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  e.removeEventListener(t, r, n);
}
function KF(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, i;
  i = function(o) {
    r(o), GF(e, t, i);
  }, VF(e, t, i, n);
}
function wm() {
}
var Ub = /* @__PURE__ */ function(e) {
  ss(r, e);
  var t = us(r);
  function r() {
    return as(this, r), t.apply(this, arguments);
  }
  return os(r, [{ key: "componentDidMount", value: function() {
    Kr() && (this.node || this.appendNode(), ro || this.renderPortal());
  } }, { key: "componentDidUpdate", value: function() {
    Kr() && (ro || this.renderPortal());
  } }, { key: "componentWillUnmount", value: function() {
    !Kr() || !this.node || (ro || eu.unmountComponentAtNode(this.node), this.node && this.node.parentNode === document.body && (document.body.removeChild(this.node), this.node = void 0));
  } }, { key: "appendNode", value: function() {
    var i = this.props, a = i.id, o = i.zIndex;
    this.node || (this.node = document.createElement("div"), a && (this.node.id = a), o && (this.node.style.zIndex = o), document.body.appendChild(this.node));
  } }, { key: "renderPortal", value: function() {
    if (!Kr())
      return null;
    var i = this.props, a = i.children, o = i.setRef;
    if (this.node || this.appendNode(), ro)
      return /* @__PURE__ */ eu.createPortal(a, this.node);
    var s = eu.unstable_renderSubtreeIntoContainer(this, a.length > 1 ? /* @__PURE__ */ me.createElement("div", null, a) : a[0], this.node);
    return o(s), null;
  } }, { key: "renderReact16", value: function() {
    var i = this.props, a = i.hasChildren, o = i.placement, s = i.target;
    return a ? this.renderPortal() : s || o === "center" ? this.renderPortal() : null;
  } }, { key: "render", value: function() {
    return ro ? this.renderReact16() : null;
  } }]), r;
}(me.Component);
Rt(Ub, "propTypes", { children: J.oneOfType([J.element, J.array]), hasChildren: J.bool, id: J.oneOfType([J.string, J.number]), placement: J.string, setRef: J.func.isRequired, target: J.oneOfType([J.object, J.string]), zIndex: J.number });
var Hb = /* @__PURE__ */ function(e) {
  ss(r, e);
  var t = us(r);
  function r() {
    return as(this, r), t.apply(this, arguments);
  }
  return os(r, [{ key: "parentStyle", get: function() {
    var i = this.props, a = i.placement, o = i.styles, s = o.arrow.length, u = { pointerEvents: "none", position: "absolute", width: "100%" };
    return a.startsWith("top") ? (u.bottom = 0, u.left = 0, u.right = 0, u.height = s) : a.startsWith("bottom") ? (u.left = 0, u.right = 0, u.top = 0, u.height = s) : a.startsWith("left") ? (u.right = 0, u.top = 0, u.bottom = 0) : a.startsWith("right") && (u.left = 0, u.top = 0), u;
  } }, { key: "render", value: function() {
    var i = this.props, a = i.placement, o = i.setArrowRef, s = i.styles, u = s.arrow, l = u.color, c = u.display, f = u.length, d = u.margin, h = u.position, p = u.spread, v = { display: c, position: h }, m, x = p, y = f;
    return a.startsWith("top") ? (m = "0,0 ".concat(x / 2, ",").concat(y, " ").concat(x, ",0"), v.bottom = 0, v.marginLeft = d, v.marginRight = d) : a.startsWith("bottom") ? (m = "".concat(x, ",").concat(y, " ").concat(x / 2, ",0 0,").concat(y), v.top = 0, v.marginLeft = d, v.marginRight = d) : a.startsWith("left") ? (y = p, x = f, m = "0,0 ".concat(x, ",").concat(y / 2, " 0,").concat(y), v.right = 0, v.marginTop = d, v.marginBottom = d) : a.startsWith("right") && (y = p, x = f, m = "".concat(x, ",").concat(y, " ").concat(x, ",0 0,").concat(y / 2), v.left = 0, v.marginTop = d, v.marginBottom = d), /* @__PURE__ */ me.createElement("div", { className: "__floater__arrow", style: this.parentStyle }, /* @__PURE__ */ me.createElement("span", { ref: o, style: v }, /* @__PURE__ */ me.createElement("svg", { width: x, height: y, version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ me.createElement("polygon", { points: m, fill: l }))));
  } }]), r;
}(me.Component);
Rt(Hb, "propTypes", { placement: J.string.isRequired, setArrowRef: J.func.isRequired, styles: J.object.isRequired });
var QF = ["color", "height", "width"];
function Wb(e) {
  var t = e.handleClick, r = e.styles, n = r.color, i = r.height, a = r.width, o = jb(r, QF);
  return /* @__PURE__ */ me.createElement("button", { "aria-label": "close", onClick: t, style: o, type: "button" }, /* @__PURE__ */ me.createElement("svg", { width: "".concat(a, "px"), height: "".concat(i, "px"), viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid" }, /* @__PURE__ */ me.createElement("g", null, /* @__PURE__ */ me.createElement("path", { d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z", fill: n }))));
}
Wb.propTypes = { handleClick: J.func.isRequired, styles: J.object.isRequired };
function zb(e) {
  var t = e.content, r = e.footer, n = e.handleClick, i = e.open, a = e.positionWrapper, o = e.showCloseButton, s = e.title, u = e.styles, l = { content: /* @__PURE__ */ me.isValidElement(t) ? t : /* @__PURE__ */ me.createElement("div", { className: "__floater__content", style: u.content }, t) };
  return s && (l.title = /* @__PURE__ */ me.isValidElement(s) ? s : /* @__PURE__ */ me.createElement("div", { className: "__floater__title", style: u.title }, s)), r && (l.footer = /* @__PURE__ */ me.isValidElement(r) ? r : /* @__PURE__ */ me.createElement("div", { className: "__floater__footer", style: u.footer }, r)), (o || a) && !z.boolean(i) && (l.close = /* @__PURE__ */ me.createElement(Wb, { styles: u.close, handleClick: n })), /* @__PURE__ */ me.createElement("div", { className: "__floater__container", style: u.container }, l.close, l.title, l.content, l.footer);
}
zb.propTypes = { content: J.node.isRequired, footer: J.node, handleClick: J.func.isRequired, open: J.bool, positionWrapper: J.bool.isRequired, showCloseButton: J.bool.isRequired, styles: J.object.isRequired, title: J.node };
var qb = /* @__PURE__ */ function(e) {
  ss(r, e);
  var t = us(r);
  function r() {
    return as(this, r), t.apply(this, arguments);
  }
  return os(r, [{ key: "style", get: function() {
    var i = this.props, a = i.disableAnimation, o = i.component, s = i.placement, u = i.hideArrow, l = i.status, c = i.styles, f = c.arrow.length, d = c.floater, h = c.floaterCentered, p = c.floaterClosing, v = c.floaterOpening, m = c.floaterWithAnimation, x = c.floaterWithComponent, y = {};
    return u || (s.startsWith("top") ? y.padding = "0 0 ".concat(f, "px") : s.startsWith("bottom") ? y.padding = "".concat(f, "px 0 0") : s.startsWith("left") ? y.padding = "0 ".concat(f, "px 0 0") : s.startsWith("right") && (y.padding = "0 0 0 ".concat(f, "px"))), [$e.OPENING, $e.OPEN].indexOf(l) !== -1 && (y = ft(ft({}, y), v)), l === $e.CLOSING && (y = ft(ft({}, y), p)), l === $e.OPEN && !a && (y = ft(ft({}, y), m)), s === "center" && (y = ft(ft({}, y), h)), o && (y = ft(ft({}, y), x)), ft(ft({}, d), y);
  } }, { key: "render", value: function() {
    var i = this.props, a = i.component, o = i.handleClick, s = i.hideArrow, u = i.setFloaterRef, l = i.status, c = {}, f = ["__floater"];
    return a ? /* @__PURE__ */ me.isValidElement(a) ? c.content = /* @__PURE__ */ me.cloneElement(a, { closeFn: o }) : c.content = a({ closeFn: o }) : c.content = /* @__PURE__ */ me.createElement(zb, this.props), l === $e.OPEN && f.push("__floater__open"), s || (c.arrow = /* @__PURE__ */ me.createElement(Hb, this.props)), /* @__PURE__ */ me.createElement("div", { ref: u, className: f.join(" "), style: this.style }, /* @__PURE__ */ me.createElement("div", { className: "__floater__body" }, c.content, c.arrow));
  } }]), r;
}(me.Component);
Rt(qb, "propTypes", { component: J.oneOfType([J.func, J.element]), content: J.node, disableAnimation: J.bool.isRequired, footer: J.node, handleClick: J.func.isRequired, hideArrow: J.bool.isRequired, open: J.bool, placement: J.string.isRequired, positionWrapper: J.bool.isRequired, setArrowRef: J.func.isRequired, setFloaterRef: J.func.isRequired, showCloseButton: J.bool, status: J.string.isRequired, styles: J.object.isRequired, title: J.node });
var Yb = /* @__PURE__ */ function(e) {
  ss(r, e);
  var t = us(r);
  function r() {
    return as(this, r), t.apply(this, arguments);
  }
  return os(r, [{ key: "render", value: function() {
    var i = this.props, a = i.children, o = i.handleClick, s = i.handleMouseEnter, u = i.handleMouseLeave, l = i.setChildRef, c = i.setWrapperRef, f = i.style, d = i.styles, h;
    if (a)
      if (me.Children.count(a) === 1)
        if (!/* @__PURE__ */ me.isValidElement(a))
          h = /* @__PURE__ */ me.createElement("span", null, a);
        else {
          var p = z.function(a.type) ? "innerRef" : "ref";
          h = /* @__PURE__ */ me.cloneElement(me.Children.only(a), Rt({}, p, l));
        }
      else
        h = a;
    return h ? /* @__PURE__ */ me.createElement("span", { ref: c, style: ft(ft({}, d), f), onClick: o, onMouseEnter: s, onMouseLeave: u }, h) : null;
  } }]), r;
}(me.Component);
Rt(Yb, "propTypes", { children: J.node, handleClick: J.func.isRequired, handleMouseEnter: J.func.isRequired, handleMouseLeave: J.func.isRequired, setChildRef: J.func.isRequired, setWrapperRef: J.func.isRequired, style: J.object, styles: J.object.isRequired });
var XF = { zIndex: 100 };
function JF(e) {
  var t = wd(XF, e.options || {});
  return { wrapper: { cursor: "help", display: "inline-flex", flexDirection: "column", zIndex: t.zIndex }, wrapperPosition: { left: -1e3, position: "absolute", top: -1e3, visibility: "hidden" }, floater: { display: "inline-block", filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))", maxWidth: 300, opacity: 0, position: "relative", transition: "opacity 0.3s", visibility: "hidden", zIndex: t.zIndex }, floaterOpening: { opacity: 1, visibility: "visible" }, floaterWithAnimation: { opacity: 1, transition: "opacity 0.3s, transform 0.2s", visibility: "visible" }, floaterWithComponent: { maxWidth: "100%" }, floaterClosing: { opacity: 0, visibility: "visible" }, floaterCentered: { left: "50%", position: "fixed", top: "50%", transform: "translate(-50%, -50%)" }, container: { backgroundColor: "#fff", color: "#666", minHeight: 60, minWidth: 200, padding: 20, position: "relative", zIndex: 10 }, title: { borderBottom: "1px solid #555", color: "#555", fontSize: 18, marginBottom: 5, paddingBottom: 6, paddingRight: 18 }, content: { fontSize: 15 }, close: { backgroundColor: "transparent", border: 0, borderRadius: 0, color: "#555", fontSize: 0, height: 15, outline: "none", padding: 10, position: "absolute", right: 0, top: 0, width: 15, WebkitAppearance: "none" }, footer: { borderTop: "1px solid #ccc", fontSize: 13, marginTop: 10, paddingTop: 5 }, arrow: { color: "#fff", display: "inline-flex", length: 16, margin: 8, position: "absolute", spread: 32 }, options: t };
}
var ZF = ["arrow", "flip", "offset"], eI = ["position", "top", "right", "bottom", "left"], ah = /* @__PURE__ */ function(e) {
  ss(r, e);
  var t = us(r);
  function r(n) {
    var i;
    return as(this, r), i = t.call(this, n), Rt(vn(i), "setArrowRef", function(a) {
      i.arrowRef = a;
    }), Rt(vn(i), "setChildRef", function(a) {
      i.childRef = a;
    }), Rt(vn(i), "setFloaterRef", function(a) {
      i.floaterRef = a;
    }), Rt(vn(i), "setWrapperRef", function(a) {
      i.wrapperRef = a;
    }), Rt(vn(i), "handleTransitionEnd", function() {
      var a = i.state.status, o = i.props.callback;
      i.wrapperPopper && i.wrapperPopper.instance.update(), i.setState({ status: a === $e.OPENING ? $e.OPEN : $e.IDLE }, function() {
        var s = i.state.status;
        o(s === $e.OPEN ? "open" : "close", i.props);
      });
    }), Rt(vn(i), "handleClick", function() {
      var a = i.props, o = a.event, s = a.open;
      if (!z.boolean(s)) {
        var u = i.state, l = u.positionWrapper, c = u.status;
        (i.event === "click" || i.event === "hover" && l) && (Ps({ title: "click", data: [{ event: o, status: c === $e.OPEN ? "closing" : "opening" }], debug: i.debug }), i.toggle());
      }
    }), Rt(vn(i), "handleMouseEnter", function() {
      var a = i.props, o = a.event, s = a.open;
      if (!(z.boolean(s) || Nf())) {
        var u = i.state.status;
        i.event === "hover" && u === $e.IDLE && (Ps({ title: "mouseEnter", data: [{ key: "originalEvent", value: o }], debug: i.debug }), clearTimeout(i.eventDelayTimeout), i.toggle());
      }
    }), Rt(vn(i), "handleMouseLeave", function() {
      var a = i.props, o = a.event, s = a.eventDelay, u = a.open;
      if (!(z.boolean(u) || Nf())) {
        var l = i.state, c = l.status, f = l.positionWrapper;
        i.event === "hover" && (Ps({ title: "mouseLeave", data: [{ key: "originalEvent", value: o }], debug: i.debug }), s ? [$e.OPENING, $e.OPEN].indexOf(c) !== -1 && !f && !i.eventDelayTimeout && (i.eventDelayTimeout = setTimeout(function() {
          delete i.eventDelayTimeout, i.toggle();
        }, s * 1e3)) : i.toggle($e.IDLE));
      }
    }), i.state = { currentPlacement: n.placement, needsUpdate: !1, positionWrapper: n.wrapperOptions.position && !!n.target, status: $e.INIT, statusWrapper: $e.INIT }, i._isMounted = !1, i.hasMounted = !1, Kr() && window.addEventListener("load", function() {
      i.popper && i.popper.instance.update(), i.wrapperPopper && i.wrapperPopper.instance.update();
    }), i;
  }
  return os(r, [{ key: "componentDidMount", value: function() {
    if (Kr()) {
      var i = this.state.positionWrapper, a = this.props, o = a.children, s = a.open, u = a.target;
      this._isMounted = !0, Ps({ title: "init", data: { hasChildren: !!o, hasTarget: !!u, isControlled: z.boolean(s), positionWrapper: i, target: this.target, floater: this.floaterRef }, debug: this.debug }), this.hasMounted || (this.initPopper(), this.hasMounted = !0), !o && u && z.boolean(s);
    }
  } }, { key: "componentDidUpdate", value: function(i, a) {
    if (Kr()) {
      var o = this.props, s = o.autoOpen, u = o.open, l = o.target, c = o.wrapperOptions, f = $F(a, this.state), d = f.changedFrom, h = f.changed;
      if (i.open !== u) {
        var p;
        z.boolean(u) && (p = u ? $e.OPENING : $e.CLOSING), this.toggle(p);
      }
      (i.wrapperOptions.position !== c.position || i.target !== l) && this.changeWrapperPosition(this.props), h("status", $e.IDLE) && u ? this.toggle($e.OPEN) : d("status", $e.INIT, $e.IDLE) && s && this.toggle($e.OPEN), this.popper && h("status", $e.OPENING) && this.popper.instance.update(), this.floaterRef && (h("status", $e.OPENING) || h("status", $e.CLOSING)) && KF(this.floaterRef, "transitionend", this.handleTransitionEnd), h("needsUpdate", !0) && this.rebuildPopper();
    }
  } }, { key: "componentWillUnmount", value: function() {
    Kr() && (this._isMounted = !1, this.popper && this.popper.instance.destroy(), this.wrapperPopper && this.wrapperPopper.instance.destroy());
  } }, { key: "initPopper", value: function() {
    var i = this, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.target, o = this.state.positionWrapper, s = this.props, u = s.disableFlip, l = s.getPopper, c = s.hideArrow, f = s.offset, d = s.placement, h = s.wrapperOptions, p = d === "top" || d === "bottom" ? "flip" : ["right", "bottom-end", "top-end", "left", "top-start", "bottom-start"];
    if (d === "center")
      this.setState({ status: $e.IDLE });
    else if (a && this.floaterRef) {
      var v = this.options, m = v.arrow, x = v.flip, y = v.offset, g = jb(v, ZF);
      new cm(a, this.floaterRef, { placement: d, modifiers: ft({ arrow: ft({ enabled: !c, element: this.arrowRef }, m), flip: ft({ enabled: !u, behavior: p }, x), offset: ft({ offset: "0, ".concat(f, "px") }, y) }, g), onCreate: function(w) {
        var _;
        if (i.popper = w, !((_ = i.floaterRef) !== null && _ !== void 0 && _.isConnected)) {
          i.setState({ needsUpdate: !0 });
          return;
        }
        l(w, "floater"), i._isMounted && i.setState({ currentPlacement: w.placement, status: $e.IDLE }), d !== w.placement && setTimeout(function() {
          w.instance.update();
        }, 1);
      }, onUpdate: function(w) {
        i.popper = w;
        var _ = i.state.currentPlacement;
        i._isMounted && w.placement !== _ && i.setState({ currentPlacement: w.placement });
      } });
    }
    if (o) {
      var E = z.undefined(h.offset) ? 0 : h.offset;
      new cm(this.target, this.wrapperRef, { placement: h.placement || d, modifiers: { arrow: { enabled: !1 }, offset: { offset: "0, ".concat(E, "px") }, flip: { enabled: !1 } }, onCreate: function(w) {
        i.wrapperPopper = w, i._isMounted && i.setState({ statusWrapper: $e.IDLE }), l(w, "wrapper"), d !== w.placement && setTimeout(function() {
          w.instance.update();
        }, 1);
      } });
    }
  } }, { key: "rebuildPopper", value: function() {
    var i = this;
    this.floaterRefInterval = setInterval(function() {
      var a;
      (a = i.floaterRef) !== null && a !== void 0 && a.isConnected && (clearInterval(i.floaterRefInterval), i.setState({ needsUpdate: !1 }), i.initPopper());
    }, 50);
  } }, { key: "changeWrapperPosition", value: function(i) {
    var a = i.target, o = i.wrapperOptions;
    this.setState({ positionWrapper: o.position && !!a });
  } }, { key: "toggle", value: function(i) {
    var a = this.state.status, o = a === $e.OPEN ? $e.CLOSING : $e.OPENING;
    z.undefined(i) || (o = i), this.setState({ status: o });
  } }, { key: "debug", get: function() {
    var i = this.props.debug;
    return i || Kr() && "ReactFloaterDebug" in window && !!window.ReactFloaterDebug;
  } }, { key: "event", get: function() {
    var i = this.props, a = i.disableHoverToClick, o = i.event;
    return o === "hover" && Nf() && !a ? "click" : o;
  } }, { key: "options", get: function() {
    var i = this.props.options;
    return wd(LF, i || {});
  } }, { key: "styles", get: function() {
    var i = this, a = this.state, o = a.status, s = a.positionWrapper, u = a.statusWrapper, l = this.props.styles, c = wd(JF(l), l);
    if (s) {
      var f;
      [$e.IDLE].indexOf(o) === -1 || [$e.IDLE].indexOf(u) === -1 ? f = c.wrapperPosition : f = this.wrapperPopper.styles, c.wrapper = ft(ft({}, c.wrapper), f);
    }
    if (this.target) {
      var d = window.getComputedStyle(this.target);
      this.wrapperStyles ? c.wrapper = ft(ft({}, c.wrapper), this.wrapperStyles) : ["relative", "static"].indexOf(d.position) === -1 && (this.wrapperStyles = {}, s || (eI.forEach(function(h) {
        i.wrapperStyles[h] = d[h];
      }), c.wrapper = ft(ft({}, c.wrapper), this.wrapperStyles), this.target.style.position = "relative", this.target.style.top = "auto", this.target.style.right = "auto", this.target.style.bottom = "auto", this.target.style.left = "auto"));
    }
    return c;
  } }, { key: "target", get: function() {
    if (!Kr())
      return null;
    var i = this.props.target;
    return i ? z.domElement(i) ? i : document.querySelector(i) : this.childRef || this.wrapperRef;
  } }, { key: "render", value: function() {
    var i = this.state, a = i.currentPlacement, o = i.positionWrapper, s = i.status, u = this.props, l = u.children, c = u.component, f = u.content, d = u.disableAnimation, h = u.footer, p = u.hideArrow, v = u.id, m = u.open, x = u.showCloseButton, y = u.style, g = u.target, E = u.title, b = /* @__PURE__ */ me.createElement(Yb, { handleClick: this.handleClick, handleMouseEnter: this.handleMouseEnter, handleMouseLeave: this.handleMouseLeave, setChildRef: this.setChildRef, setWrapperRef: this.setWrapperRef, style: y, styles: this.styles.wrapper }, l), w = {};
    return o ? w.wrapperInPortal = b : w.wrapperAsChildren = b, /* @__PURE__ */ me.createElement("span", null, /* @__PURE__ */ me.createElement(Ub, { hasChildren: !!l, id: v, placement: a, setRef: this.setFloaterRef, target: g, zIndex: this.styles.options.zIndex }, /* @__PURE__ */ me.createElement(qb, { component: c, content: f, disableAnimation: d, footer: h, handleClick: this.handleClick, hideArrow: p || a === "center", open: m, placement: a, positionWrapper: o, setArrowRef: this.setArrowRef, setFloaterRef: this.setFloaterRef, showCloseButton: x, status: s, styles: this.styles, title: E }), w.wrapperInPortal), w.wrapperAsChildren);
  } }]), r;
}(me.Component);
Rt(ah, "propTypes", { autoOpen: J.bool, callback: J.func, children: J.node, component: Em(J.oneOfType([J.func, J.element]), function(e) {
  return !e.content;
}), content: Em(J.node, function(e) {
  return !e.component;
}), debug: J.bool, disableAnimation: J.bool, disableFlip: J.bool, disableHoverToClick: J.bool, event: J.oneOf(["hover", "click"]), eventDelay: J.number, footer: J.node, getPopper: J.func, hideArrow: J.bool, id: J.oneOfType([J.string, J.number]), offset: J.number, open: J.bool, options: J.object, placement: J.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto", "center"]), showCloseButton: J.bool, style: J.object, styles: J.object, target: J.oneOfType([J.object, J.string]), title: J.node, wrapperOptions: J.shape({ offset: J.number, placement: J.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto"]), position: J.bool }) });
Rt(ah, "defaultProps", { autoOpen: !1, callback: wm, debug: !1, disableAnimation: !1, disableFlip: !1, disableHoverToClick: !1, event: "click", eventDelay: 0.4, getPopper: wm, hideArrow: !1, offset: 15, placement: "bottom", showCloseButton: !1, styles: {}, target: null, wrapperOptions: { position: !1 } });
var tI = function(e) {
  return Object.prototype.hasOwnProperty.call(e, "props");
}, rI = function(e, t) {
  return e + Ro(t);
}, Ro = function(e) {
  return e === null || typeof e == "boolean" || typeof e > "u" ? "" : typeof e == "number" ? e.toString() : typeof e == "string" ? e : Array.isArray(e) ? e.reduce(rI, "") : tI(e) && Object.prototype.hasOwnProperty.call(e.props, "children") ? Ro(e.props.children) : "";
};
Ro.default = Ro;
var nI = Ro;
const iI = /* @__PURE__ */ Nt(nI);
var aI = Object.defineProperty, oI = (e, t, r) => t in e ? aI(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, le = (e, t, r) => (oI(e, typeof t != "symbol" ? t + "" : t, r), r), Ve = {
  INIT: "init",
  START: "start",
  STOP: "stop",
  RESET: "reset",
  PREV: "prev",
  NEXT: "next",
  GO: "go",
  CLOSE: "close",
  SKIP: "skip",
  UPDATE: "update"
}, Or = {
  TOUR_START: "tour:start",
  STEP_BEFORE: "step:before",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  STEP_AFTER: "step:after",
  TOUR_END: "tour:end",
  TOUR_STATUS: "tour:status",
  TARGET_NOT_FOUND: "error:target_not_found",
  ERROR: "error"
}, _e = {
  INIT: "init",
  READY: "ready",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  COMPLETE: "complete",
  ERROR: "error"
}, Ne = {
  IDLE: "idle",
  READY: "ready",
  WAITING: "waiting",
  RUNNING: "running",
  PAUSED: "paused",
  SKIPPED: "skipped",
  FINISHED: "finished",
  ERROR: "error"
};
function jn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Vb(e) {
  return e ? e.getBoundingClientRect() : null;
}
function sI() {
  const { body: e, documentElement: t } = document;
  return !e || !t ? 0 : Math.max(
    e.scrollHeight,
    e.offsetHeight,
    t.clientHeight,
    t.scrollHeight,
    t.offsetHeight
  );
}
function zn(e) {
  return typeof e == "string" ? document.querySelector(e) : e;
}
function uI(e) {
  return !e || e.nodeType !== 1 ? null : getComputedStyle(e);
}
function Ml(e, t, r) {
  if (!e)
    return _i();
  const n = mb(e);
  if (n) {
    if (n.isSameNode(_i()))
      return r ? document : _i();
    if (!(n.scrollHeight > n.offsetHeight) && !t)
      return n.style.overflow = "initial", _i();
  }
  return n;
}
function ls(e, t) {
  if (!e)
    return !1;
  const r = Ml(e, t);
  return r ? !r.isSameNode(_i()) : !1;
}
function lI(e) {
  return e.offsetParent !== document.body;
}
function Mo(e, t = "fixed") {
  if (!e || !(e instanceof HTMLElement))
    return !1;
  const { nodeName: r } = e, n = uI(e);
  return r === "BODY" || r === "HTML" ? !1 : n && n.position === t ? !0 : e.parentNode ? Mo(e.parentNode, t) : !1;
}
function cI(e) {
  var t;
  if (!e)
    return !1;
  let r = e;
  for (; r && r !== document.body; ) {
    if (r instanceof HTMLElement) {
      const { display: n, visibility: i } = getComputedStyle(r);
      if (n === "none" || i === "hidden")
        return !1;
    }
    r = (t = r.parentElement) != null ? t : null;
  }
  return !0;
}
function fI(e, t, r) {
  var n;
  const i = Vb(e), a = Ml(e, r), o = ls(e, r);
  let s = 0, u = (n = i == null ? void 0 : i.top) != null ? n : 0;
  return a instanceof HTMLElement && (s = a.scrollTop, !o && !Mo(e) && (u += s), a.isSameNode(_i()) || (u += _i().scrollTop)), Math.floor(u - t);
}
function dI(e, t, r) {
  var n;
  if (!e)
    return 0;
  const { offsetTop: i = 0, scrollTop: a = 0 } = (n = mb(e)) != null ? n : {};
  let o = e.getBoundingClientRect().top + a;
  i && (ls(e, r) || lI(e)) && (o -= i);
  const s = Math.floor(o - t);
  return s < 0 ? 0 : s;
}
function _i() {
  var e;
  return (e = document.scrollingElement) != null ? e : document.documentElement;
}
function hI(e, t) {
  const { duration: r, element: n } = t;
  return new Promise((i, a) => {
    const { scrollTop: o } = n, s = e > o ? e - o : o - e;
    JO.top(n, e, { duration: s < 100 ? 50 : r }, (u) => u && u.message !== "Element already at target scroll position" ? a(u) : i());
  });
}
var no = NT !== void 0;
function Gb(e = navigator.userAgent) {
  let t = e;
  return typeof window > "u" ? t = "node" : document.documentMode ? t = "ie" : /Edge/.test(e) ? t = "edge" : window.opera || e.includes(" OPR/") ? t = "opera" : typeof window.InstallTrigger < "u" ? t = "firefox" : window.chrome ? t = "chrome" : /(Version\/([\d._]+).*Safari|CriOS|FxiOS| Mobile\/)/.test(e) && (t = "safari"), t;
}
function Ln(e) {
  const t = [], r = (n) => {
    if (typeof n == "string" || typeof n == "number")
      t.push(n);
    else if (Array.isArray(n))
      n.forEach((i) => r(i));
    else if (lx(n)) {
      const { children: i } = n.props;
      Array.isArray(i) ? i.forEach((a) => r(a)) : r(i);
    }
  };
  return r(e), t.join(" ").trim();
}
function pI(e, t) {
  return !oe.plainObject(e) || !oe.array(t) ? !1 : Object.keys(e).every((r) => t.includes(r));
}
function vI(e) {
  const t = /^#?([\da-f])([\da-f])([\da-f])$/i, r = e.replace(t, (i, a, o, s) => a + a + o + o + s + s), n = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(r);
  return n ? [parseInt(n[1], 16), parseInt(n[2], 16), parseInt(n[3], 16)] : [];
}
function Sm(e) {
  return e.disableBeacon || e.placement === "center";
}
function _m() {
  return !["chrome", "safari", "firefox", "opera"].includes(Gb());
}
function Jn({ data: e, debug: t = !1, title: r, warn: n = !1 }) {
  const i = n ? console.warn || console.error : console.log;
  t && (r && e ? (console.groupCollapsed(
    `%creact-joyride: ${r}`,
    "color: #ff0044; font-weight: bold; font-size: 12px;"
  ), Array.isArray(e) ? e.forEach((a) => {
    oe.plainObject(a) && a.key ? i.apply(console, [a.key, a.value]) : i.apply(console, [a]);
  }) : i.apply(console, [e]), console.groupEnd()) : console.error("Missing title or data props"));
}
function mI(e) {
  const { isFirstStep: t, lifecycle: r, previousLifecycle: n, scrollToFirstStep: i, step: a, target: o } = e;
  return !a.disableScrolling && (!t || i || r === _e.TOOLTIP) && a.placement !== "center" && (!a.isFixed || !Mo(o)) && // fixed steps don't need to scroll
  n !== r && [_e.BEACON, _e.TOOLTIP].includes(r);
}
var yI = {
  options: {
    preventOverflow: {
      boundariesElement: "scrollParent"
    }
  },
  wrapperOptions: {
    offset: -18,
    position: !0
  }
}, Kb = {
  back: "Back",
  close: "Close",
  last: "Last",
  next: "Next",
  open: "Open the dialog",
  skip: "Skip"
}, gI = {
  event: "click",
  placement: "bottom",
  offset: 10,
  disableBeacon: !1,
  disableCloseOnEsc: !1,
  disableOverlay: !1,
  disableOverlayClose: !1,
  disableScrollParentFix: !1,
  disableScrolling: !1,
  hideBackButton: !1,
  hideCloseButton: !1,
  hideFooter: !1,
  isFixed: !1,
  locale: Kb,
  showProgress: !1,
  showSkipButton: !1,
  spotlightClicks: !1,
  spotlightPadding: 10
}, xI = {
  continuous: !1,
  debug: !1,
  disableCloseOnEsc: !1,
  disableOverlay: !1,
  disableOverlayClose: !1,
  disableScrolling: !1,
  disableScrollParentFix: !1,
  getHelpers: void 0,
  hideBackButton: !1,
  run: !0,
  scrollOffset: 20,
  scrollDuration: 300,
  scrollToFirstStep: !1,
  showSkipButton: !1,
  showProgress: !1,
  spotlightClicks: !1,
  spotlightPadding: 10,
  steps: []
}, bI = {
  arrowColor: "#fff",
  backgroundColor: "#fff",
  beaconSize: 36,
  overlayColor: "rgba(0, 0, 0, 0.5)",
  primaryColor: "#f04",
  spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
  textColor: "#333",
  width: 380,
  zIndex: 100
}, io = {
  backgroundColor: "transparent",
  border: 0,
  borderRadius: 0,
  color: "#555",
  cursor: "pointer",
  fontSize: 16,
  lineHeight: 1,
  padding: 8,
  WebkitAppearance: "none"
}, Tm = {
  borderRadius: 4,
  position: "absolute"
};
function EI(e, t) {
  var r, n, i, a;
  const { floaterProps: o, styles: s } = e, u = Si(s ?? {}, (r = t == null ? void 0 : t.styles) != null ? r : {}), l = Si(bI, u.options || {});
  let { width: c } = l;
  window.innerWidth > 480 && (c = 380), "width" in l && (c = typeof l.width == "number" && window.innerWidth < l.width ? window.innerWidth - 30 : l.width);
  const f = {
    bottom: 0,
    left: 0,
    overflow: "hidden",
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: l.zIndex
  }, d = {
    beacon: {
      ...io,
      display: "inline-block",
      height: l.beaconSize,
      position: "relative",
      width: l.beaconSize,
      zIndex: l.zIndex
    },
    beaconInner: {
      animation: "joyride-beacon-inner 1.2s infinite ease-in-out",
      backgroundColor: l.primaryColor,
      borderRadius: "50%",
      display: "block",
      height: "50%",
      left: "50%",
      opacity: 0.7,
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "50%"
    },
    beaconOuter: {
      animation: "joyride-beacon-outer 1.2s infinite ease-in-out",
      backgroundColor: `rgba(${vI(l.primaryColor).join(",")}, 0.2)`,
      border: `2px solid ${l.primaryColor}`,
      borderRadius: "50%",
      boxSizing: "border-box",
      display: "block",
      height: "100%",
      left: 0,
      opacity: 0.9,
      position: "absolute",
      top: 0,
      transformOrigin: "center",
      width: "100%"
    },
    tooltip: {
      backgroundColor: l.backgroundColor,
      borderRadius: 5,
      boxSizing: "border-box",
      color: l.textColor,
      fontSize: 16,
      maxWidth: "100%",
      padding: 15,
      position: "relative",
      width: c
    },
    tooltipContainer: {
      lineHeight: 1.4,
      textAlign: "center"
    },
    tooltipTitle: {
      fontSize: 18,
      margin: 0
    },
    tooltipContent: {
      padding: "20px 10px"
    },
    tooltipFooter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 15
    },
    tooltipFooterSpacer: {
      flex: 1
    },
    buttonNext: {
      ...io,
      backgroundColor: l.primaryColor,
      borderRadius: 4,
      color: "#fff"
    },
    buttonBack: {
      ...io,
      color: l.primaryColor,
      marginLeft: "auto",
      marginRight: 5
    },
    buttonClose: {
      ...io,
      color: l.textColor,
      height: 14,
      padding: 15,
      position: "absolute",
      right: 0,
      top: 0,
      width: 14
    },
    buttonSkip: {
      ...io,
      color: l.textColor,
      fontSize: 14
    },
    overlay: {
      ...f,
      backgroundColor: l.overlayColor,
      mixBlendMode: "hard-light"
    },
    overlayLegacy: {
      ...f
    },
    overlayLegacyCenter: {
      ...f,
      backgroundColor: l.overlayColor
    },
    spotlight: {
      ...Tm,
      backgroundColor: "gray"
    },
    spotlightLegacy: {
      ...Tm,
      boxShadow: `0 0 0 9999px ${l.overlayColor}, ${l.spotlightShadow}`
    },
    floaterStyles: {
      arrow: {
        color: (a = (i = (n = o == null ? void 0 : o.styles) == null ? void 0 : n.arrow) == null ? void 0 : i.color) != null ? a : l.arrowColor
      },
      options: {
        zIndex: l.zIndex + 100
      }
    },
    options: l
  };
  return Si(d, u);
}
function wI(e) {
  return tD(
    e,
    "beaconComponent",
    "disableCloseOnEsc",
    "disableOverlay",
    "disableOverlayClose",
    "disableScrolling",
    "disableScrollParentFix",
    "floaterProps",
    "hideBackButton",
    "hideCloseButton",
    "locale",
    "showProgress",
    "showSkipButton",
    "spotlightClicks",
    "spotlightPadding",
    "styles",
    "tooltipComponent"
  );
}
function ao(e, t) {
  var r, n, i, a, o, s;
  const u = e ?? {}, l = Si.all([gI, wI(t), u], {
    isMergeableObject: oe.plainObject
  }), c = EI(t, l), f = ls(
    zn(l.target),
    l.disableScrollParentFix
  ), d = Si.all([
    yI,
    (r = t.floaterProps) != null ? r : {},
    (n = l.floaterProps) != null ? n : {}
  ]);
  return d.offset = l.offset, d.styles = Si((i = d.styles) != null ? i : {}, c.floaterStyles), d.offset += (o = (a = t.spotlightPadding) != null ? a : l.spotlightPadding) != null ? o : 0, l.placementBeacon && d.wrapperOptions && (d.wrapperOptions.placement = l.placementBeacon), f && d.options.preventOverflow && (d.options.preventOverflow.boundariesElement = "window"), {
    ...l,
    locale: Si.all([Kb, (s = t.locale) != null ? s : {}, l.locale || {}]),
    floaterProps: d,
    styles: yb(c, "floaterStyles")
  };
}
function Qb(e, t = !1) {
  return oe.plainObject(e) ? e.target ? !0 : (Jn({
    title: "validateStep",
    data: "target is missing from the step",
    warn: !0,
    debug: t
  }), !1) : (Jn({
    title: "validateStep",
    data: "step must be an object",
    warn: !0,
    debug: t
  }), !1);
}
function Am(e, t = !1) {
  return oe.array(e) ? e.every((r) => Qb(r, t)) : (Jn({
    title: "validateSteps",
    data: "steps must be an array",
    warn: !0,
    debug: t
  }), !1);
}
var Xb = {
  action: "init",
  controlled: !1,
  index: 0,
  lifecycle: _e.INIT,
  origin: null,
  size: 0,
  status: Ne.IDLE
}, Cm = eD(yb(Xb, "controlled", "size")), SI = class {
  constructor(e) {
    le(this, "beaconPopper"), le(this, "tooltipPopper"), le(this, "data", /* @__PURE__ */ new Map()), le(this, "listener"), le(this, "store", /* @__PURE__ */ new Map()), le(this, "addListener", (i) => {
      this.listener = i;
    }), le(this, "setSteps", (i) => {
      const { size: a, status: o } = this.getState(), s = {
        size: i.length,
        status: o
      };
      this.data.set("steps", i), o === Ne.WAITING && !a && i.length && (s.status = Ne.RUNNING), this.setState(s);
    }), le(this, "getPopper", (i) => i === "beacon" ? this.beaconPopper : this.tooltipPopper), le(this, "setPopper", (i, a) => {
      i === "beacon" ? this.beaconPopper = a : this.tooltipPopper = a;
    }), le(this, "cleanupPoppers", () => {
      this.beaconPopper = null, this.tooltipPopper = null;
    }), le(this, "close", (i = null) => {
      const { index: a, status: o } = this.getState();
      o === Ne.RUNNING && this.setState({
        ...this.getNextState({ action: Ve.CLOSE, index: a + 1, origin: i })
      });
    }), le(this, "go", (i) => {
      const { controlled: a, status: o } = this.getState();
      if (a || o !== Ne.RUNNING)
        return;
      const s = this.getSteps()[i];
      this.setState({
        ...this.getNextState({ action: Ve.GO, index: i }),
        status: s ? o : Ne.FINISHED
      });
    }), le(this, "info", () => this.getState()), le(this, "next", () => {
      const { index: i, status: a } = this.getState();
      a === Ne.RUNNING && this.setState(this.getNextState({ action: Ve.NEXT, index: i + 1 }));
    }), le(this, "open", () => {
      const { status: i } = this.getState();
      i === Ne.RUNNING && this.setState({
        ...this.getNextState({ action: Ve.UPDATE, lifecycle: _e.TOOLTIP })
      });
    }), le(this, "prev", () => {
      const { index: i, status: a } = this.getState();
      a === Ne.RUNNING && this.setState({
        ...this.getNextState({ action: Ve.PREV, index: i - 1 })
      });
    }), le(this, "reset", (i = !1) => {
      const { controlled: a } = this.getState();
      a || this.setState({
        ...this.getNextState({ action: Ve.RESET, index: 0 }),
        status: i ? Ne.RUNNING : Ne.READY
      });
    }), le(this, "skip", () => {
      const { status: i } = this.getState();
      i === Ne.RUNNING && this.setState({
        action: Ve.SKIP,
        lifecycle: _e.INIT,
        status: Ne.SKIPPED
      });
    }), le(this, "start", (i) => {
      const { index: a, size: o } = this.getState();
      this.setState({
        ...this.getNextState(
          {
            action: Ve.START,
            index: oe.number(i) ? i : a
          },
          !0
        ),
        status: o ? Ne.RUNNING : Ne.WAITING
      });
    }), le(this, "stop", (i = !1) => {
      const { index: a, status: o } = this.getState();
      [Ne.FINISHED, Ne.SKIPPED].includes(o) || this.setState({
        ...this.getNextState({ action: Ve.STOP, index: a + (i ? 1 : 0) }),
        status: Ne.PAUSED
      });
    }), le(this, "update", (i) => {
      var a, o;
      if (!pI(i, Cm))
        throw new Error(`State is not valid. Valid keys: ${Cm.join(", ")}`);
      this.setState({
        ...this.getNextState(
          {
            ...this.getState(),
            ...i,
            action: (a = i.action) != null ? a : Ve.UPDATE,
            origin: (o = i.origin) != null ? o : null
          },
          !0
        )
      });
    });
    const { continuous: t = !1, stepIndex: r, steps: n = [] } = e ?? {};
    this.setState(
      {
        action: Ve.INIT,
        controlled: oe.number(r),
        continuous: t,
        index: oe.number(r) ? r : 0,
        lifecycle: _e.INIT,
        origin: null,
        status: n.length ? Ne.READY : Ne.IDLE
      },
      !0
    ), this.beaconPopper = null, this.tooltipPopper = null, this.listener = null, this.setSteps(n);
  }
  getState() {
    return this.store.size ? {
      action: this.store.get("action") || "",
      controlled: this.store.get("controlled") || !1,
      index: parseInt(this.store.get("index"), 10),
      lifecycle: this.store.get("lifecycle") || "",
      origin: this.store.get("origin") || null,
      size: this.store.get("size") || 0,
      status: this.store.get("status") || ""
    } : { ...Xb };
  }
  getNextState(e, t = !1) {
    var r, n, i, a, o;
    const { action: s, controlled: u, index: l, size: c, status: f } = this.getState(), d = oe.number(e.index) ? e.index : l, h = u && !t ? l : Math.min(Math.max(d, 0), c);
    return {
      action: (r = e.action) != null ? r : s,
      controlled: u,
      index: h,
      lifecycle: (n = e.lifecycle) != null ? n : _e.INIT,
      origin: (i = e.origin) != null ? i : null,
      size: (a = e.size) != null ? a : c,
      status: h === c ? Ne.FINISHED : (o = e.status) != null ? o : f
    };
  }
  getSteps() {
    const e = this.data.get("steps");
    return Array.isArray(e) ? e : [];
  }
  hasUpdatedState(e) {
    const t = JSON.stringify(e), r = JSON.stringify(this.getState());
    return t !== r;
  }
  setState(e, t = !1) {
    const r = this.getState(), {
      action: n,
      index: i,
      lifecycle: a,
      origin: o = null,
      size: s,
      status: u
    } = {
      ...r,
      ...e
    };
    this.store.set("action", n), this.store.set("index", i), this.store.set("lifecycle", a), this.store.set("origin", o), this.store.set("size", s), this.store.set("status", u), t && (this.store.set("controlled", e.controlled), this.store.set("continuous", e.continuous)), this.listener && this.hasUpdatedState(r) && this.listener(this.getState());
  }
  getHelpers() {
    return {
      close: this.close,
      go: this.go,
      info: this.info,
      next: this.next,
      open: this.open,
      prev: this.prev,
      reset: this.reset,
      skip: this.skip
    };
  }
};
function _I(e) {
  return new SI(e);
}
var TI = class {
  constructor(e, t) {
    if (le(this, "element"), le(this, "options"), le(this, "canBeTabbed", (r) => {
      const { tabIndex: n } = r;
      return n === null || n < 0 ? !1 : this.canHaveFocus(r);
    }), le(this, "canHaveFocus", (r) => {
      const n = /input|select|textarea|button|object/, i = r.nodeName.toLowerCase();
      return (n.test(i) && !r.getAttribute("disabled") || i === "a" && !!r.getAttribute("href")) && this.isVisible(r);
    }), le(this, "findValidTabElements", () => [].slice.call(this.element.querySelectorAll("*"), 0).filter(this.canBeTabbed)), le(this, "handleKeyDown", (r) => {
      const { code: n = "Tab" } = this.options;
      r.code === n && this.interceptTab(r);
    }), le(this, "interceptTab", (r) => {
      r.preventDefault();
      const n = this.findValidTabElements(), { shiftKey: i } = r;
      if (!n.length)
        return;
      let a = document.activeElement ? n.indexOf(document.activeElement) : 0;
      a === -1 || !i && a + 1 === n.length ? a = 0 : i && a === 0 ? a = n.length - 1 : a += i ? -1 : 1, n[a].focus();
    }), le(this, "isHidden", (r) => {
      const n = r.offsetWidth <= 0 && r.offsetHeight <= 0, i = window.getComputedStyle(r);
      return n && !r.innerHTML ? !0 : n && i.getPropertyValue("overflow") !== "visible" || i.getPropertyValue("display") === "none";
    }), le(this, "isVisible", (r) => {
      let n = r;
      for (; n; )
        if (n instanceof HTMLElement) {
          if (n === document.body)
            break;
          if (this.isHidden(n))
            return !1;
          n = n.parentNode;
        }
      return !0;
    }), le(this, "removeScope", () => {
      window.removeEventListener("keydown", this.handleKeyDown);
    }), le(this, "checkFocus", (r) => {
      document.activeElement !== r && (r.focus(), window.requestAnimationFrame(() => this.checkFocus(r)));
    }), le(this, "setFocus", () => {
      const { selector: r } = this.options;
      if (!r)
        return;
      const n = this.element.querySelector(r);
      n && window.requestAnimationFrame(() => this.checkFocus(n));
    }), !(e instanceof HTMLElement))
      throw new TypeError("Invalid parameter: element must be an HTMLElement");
    this.element = e, this.options = t, window.addEventListener("keydown", this.handleKeyDown, !1), this.setFocus();
  }
}, AI = class extends Fe.Component {
  constructor(e) {
    if (super(e), le(this, "beacon", null), le(this, "setBeaconRef", (i) => {
      this.beacon = i;
    }), e.beaconComponent)
      return;
    const t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.id = "joyride-beacon-animation", e.nonce && r.setAttribute("nonce", e.nonce);
    const n = `
        @keyframes joyride-beacon-inner {
          20% {
            opacity: 0.9;
          }
        
          90% {
            opacity: 0.7;
          }
        }
        
        @keyframes joyride-beacon-outer {
          0% {
            transform: scale(1);
          }
        
          45% {
            opacity: 0.7;
            transform: scale(0.75);
          }
        
          100% {
            opacity: 0.9;
            transform: scale(1);
          }
        }
      `;
    r.appendChild(document.createTextNode(n)), t.appendChild(r);
  }
  componentDidMount() {
    const { shouldFocus: e } = this.props;
    process.env.NODE_ENV !== "production" && (oe.domElement(this.beacon) || console.warn("beacon is not a valid DOM element")), setTimeout(() => {
      oe.domElement(this.beacon) && e && this.beacon.focus();
    }, 0);
  }
  componentWillUnmount() {
    const e = document.getElementById("joyride-beacon-animation");
    e != null && e.parentNode && e.parentNode.removeChild(e);
  }
  render() {
    const {
      beaconComponent: e,
      continuous: t,
      index: r,
      isLastStep: n,
      locale: i,
      onClickOrHover: a,
      size: o,
      step: s,
      styles: u
    } = this.props, l = oe.string(i.open) ? i.open : iI(i.open), c = {
      "aria-label": l,
      onClick: a,
      onMouseEnter: a,
      ref: this.setBeaconRef,
      title: l
    };
    let f;
    if (e) {
      const d = e;
      f = /* @__PURE__ */ Fe.createElement(
        d,
        {
          continuous: t,
          index: r,
          isLastStep: n,
          size: o,
          step: s,
          ...c
        }
      );
    } else
      f = /* @__PURE__ */ Fe.createElement(
        "button",
        {
          key: "JoyrideBeacon",
          className: "react-joyride__beacon",
          "data-test-id": "button-beacon",
          style: u.beacon,
          type: "button",
          ...c
        },
        /* @__PURE__ */ Fe.createElement("span", { style: u.beaconInner }),
        /* @__PURE__ */ Fe.createElement("span", { style: u.beaconOuter })
      );
    return f;
  }
};
function CI({ styles: e }) {
  return /* @__PURE__ */ Fe.createElement(
    "div",
    {
      key: "JoyrideSpotlight",
      className: "react-joyride__spotlight",
      "data-test-id": "spotlight",
      style: e
    }
  );
}
var OI = CI, DI = class extends Fe.Component {
  constructor() {
    super(...arguments), le(this, "isActive", !1), le(this, "resizeTimeout"), le(this, "scrollTimeout"), le(this, "scrollParent"), le(this, "state", {
      isScrolling: !1,
      mouseOverSpotlight: !1,
      showSpotlight: !0
    }), le(this, "handleMouseMove", (e) => {
      const { mouseOverSpotlight: t } = this.state, { height: r, left: n, position: i, top: a, width: o } = this.spotlightStyles, s = i === "fixed" ? e.clientY : e.pageY, u = i === "fixed" ? e.clientX : e.pageX, l = s >= a && s <= a + r, f = u >= n && u <= n + o && l;
      f !== t && this.updateState({ mouseOverSpotlight: f });
    }), le(this, "handleScroll", () => {
      const { target: e } = this.props, t = zn(e);
      if (this.scrollParent !== document) {
        const { isScrolling: r } = this.state;
        r || this.updateState({ isScrolling: !0, showSpotlight: !1 }), clearTimeout(this.scrollTimeout), this.scrollTimeout = window.setTimeout(() => {
          this.updateState({ isScrolling: !1, showSpotlight: !0 });
        }, 50);
      } else
        Mo(t, "sticky") && this.updateState({});
    }), le(this, "handleResize", () => {
      clearTimeout(this.resizeTimeout), this.resizeTimeout = window.setTimeout(() => {
        this.isActive && this.forceUpdate();
      }, 100);
    });
  }
  componentDidMount() {
    const { debug: e, disableScrolling: t, disableScrollParentFix: r = !1, target: n } = this.props, i = zn(n);
    this.scrollParent = Ml(i ?? document.body, r, !0), this.isActive = !0, process.env.NODE_ENV !== "production" && !t && ls(i, !0) && Jn({
      title: "step has a custom scroll parent and can cause trouble with scrolling",
      data: [{ key: "parent", value: this.scrollParent }],
      debug: e
    }), window.addEventListener("resize", this.handleResize);
  }
  componentDidUpdate(e) {
    var t;
    const { lifecycle: r, spotlightClicks: n } = this.props, { changed: i } = Du(e, this.props);
    i("lifecycle", _e.TOOLTIP) && ((t = this.scrollParent) == null || t.addEventListener("scroll", this.handleScroll, { passive: !0 }), setTimeout(() => {
      const { isScrolling: a } = this.state;
      a || this.updateState({ showSpotlight: !0 });
    }, 100)), (i("spotlightClicks") || i("disableOverlay") || i("lifecycle")) && (n && r === _e.TOOLTIP ? window.addEventListener("mousemove", this.handleMouseMove, !1) : r !== _e.TOOLTIP && window.removeEventListener("mousemove", this.handleMouseMove));
  }
  componentWillUnmount() {
    var e;
    this.isActive = !1, window.removeEventListener("mousemove", this.handleMouseMove), window.removeEventListener("resize", this.handleResize), clearTimeout(this.resizeTimeout), clearTimeout(this.scrollTimeout), (e = this.scrollParent) == null || e.removeEventListener("scroll", this.handleScroll);
  }
  get spotlightStyles() {
    var e, t, r;
    const { showSpotlight: n } = this.state, {
      disableScrollParentFix: i = !1,
      spotlightClicks: a,
      spotlightPadding: o = 0,
      styles: s,
      target: u
    } = this.props, l = zn(u), c = Vb(l), f = Mo(l), d = fI(l, o, i);
    return {
      ..._m() ? s.spotlightLegacy : s.spotlight,
      height: Math.round(((e = c == null ? void 0 : c.height) != null ? e : 0) + o * 2),
      left: Math.round(((t = c == null ? void 0 : c.left) != null ? t : 0) - o),
      opacity: n ? 1 : 0,
      pointerEvents: a ? "none" : "auto",
      position: f ? "fixed" : "absolute",
      top: d,
      transition: "opacity 0.2s",
      width: Math.round(((r = c == null ? void 0 : c.width) != null ? r : 0) + o * 2)
    };
  }
  updateState(e) {
    this.isActive && this.setState((t) => ({ ...t, ...e }));
  }
  render() {
    const { mouseOverSpotlight: e, showSpotlight: t } = this.state, { disableOverlay: r, disableOverlayClose: n, lifecycle: i, onClickOverlay: a, placement: o, styles: s } = this.props;
    if (r || i !== _e.TOOLTIP)
      return null;
    let u = s.overlay;
    _m() && (u = o === "center" ? s.overlayLegacyCenter : s.overlayLegacy);
    const l = {
      cursor: n ? "default" : "pointer",
      height: sI(),
      pointerEvents: e ? "none" : "auto",
      ...u
    };
    let c = o !== "center" && t && /* @__PURE__ */ Fe.createElement(OI, { styles: this.spotlightStyles });
    if (Gb() === "safari") {
      const { mixBlendMode: f, zIndex: d, ...h } = l;
      c = /* @__PURE__ */ Fe.createElement("div", { style: { ...h } }, c), delete l.backgroundColor;
    }
    return /* @__PURE__ */ Fe.createElement(
      "div",
      {
        className: "react-joyride__overlay",
        "data-test-id": "overlay",
        onClick: a,
        role: "presentation",
        style: l
      },
      c
    );
  }
}, FI = class extends Fe.Component {
  constructor() {
    super(...arguments), le(this, "node", null);
  }
  componentDidMount() {
    const { id: e } = this.props;
    jn() && (this.node = document.createElement("div"), this.node.id = e, document.body.appendChild(this.node), no || this.renderReact15());
  }
  componentDidUpdate() {
    jn() && (no || this.renderReact15());
  }
  componentWillUnmount() {
    !jn() || !this.node || (no || Pc.unmountComponentAtNode(this.node), this.node.parentNode === document.body && (document.body.removeChild(this.node), this.node = null));
  }
  renderReact15() {
    if (!jn())
      return;
    const { children: e } = this.props;
    this.node && Pc.unstable_renderSubtreeIntoContainer(this, e, this.node);
  }
  renderReact16() {
    if (!jn() || !no)
      return null;
    const { children: e } = this.props;
    return this.node ? Pc.createPortal(e, this.node) : null;
  }
  render() {
    return no ? this.renderReact16() : null;
  }
};
function II({ styles: e, ...t }) {
  const { color: r, height: n, width: i, ...a } = e;
  return /* @__PURE__ */ me.createElement("button", { style: a, type: "button", ...t }, /* @__PURE__ */ me.createElement(
    "svg",
    {
      height: typeof n == "number" ? `${n}px` : n,
      preserveAspectRatio: "xMidYMid",
      version: "1.1",
      viewBox: "0 0 18 18",
      width: typeof i == "number" ? `${i}px` : i,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ me.createElement("g", null, /* @__PURE__ */ me.createElement(
      "path",
      {
        d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
        fill: r
      }
    ))
  ));
}
var kI = II;
function NI(e) {
  const {
    backProps: t,
    closeProps: r,
    continuous: n,
    index: i,
    isLastStep: a,
    primaryProps: o,
    size: s,
    skipProps: u,
    step: l,
    tooltipProps: c
  } = e, {
    content: f,
    hideBackButton: d,
    hideCloseButton: h,
    hideFooter: p,
    locale: v,
    showProgress: m,
    showSkipButton: x,
    styles: y,
    title: g
  } = l, { back: E, close: b, last: w, next: _, skip: A } = v, O = {
    primary: b
  };
  return n && (O.primary = a ? w : _, m && (O.primary = /* @__PURE__ */ Fe.createElement("span", null, O.primary, " (", i + 1, "/", s, ")"))), x && !a && (O.skip = /* @__PURE__ */ Fe.createElement(
    "button",
    {
      "aria-live": "off",
      "data-test-id": "button-skip",
      style: y.buttonSkip,
      type: "button",
      ...u
    },
    A
  )), !d && i > 0 && (O.back = /* @__PURE__ */ Fe.createElement("button", { "data-test-id": "button-back", style: y.buttonBack, type: "button", ...t }, E)), O.close = !h && /* @__PURE__ */ Fe.createElement(kI, { "data-test-id": "button-close", styles: y.buttonClose, ...r }), /* @__PURE__ */ Fe.createElement(
    "div",
    {
      key: "JoyrideTooltip",
      "aria-label": Ln(g) || Ln(f),
      className: "react-joyride__tooltip",
      style: y.tooltip,
      ...c
    },
    /* @__PURE__ */ Fe.createElement("div", { style: y.tooltipContainer }, g && /* @__PURE__ */ Fe.createElement("h1", { "aria-label": Ln(g), style: y.tooltipTitle }, g), /* @__PURE__ */ Fe.createElement("div", { style: y.tooltipContent }, f)),
    !p && /* @__PURE__ */ Fe.createElement("div", { style: y.tooltipFooter }, /* @__PURE__ */ Fe.createElement("div", { style: y.tooltipFooterSpacer }, O.skip), O.back, /* @__PURE__ */ Fe.createElement(
      "button",
      {
        "data-test-id": "button-primary",
        style: y.buttonNext,
        type: "button",
        ...o
      },
      O.primary
    )),
    O.close
  );
}
var PI = NI, $I = class extends Fe.Component {
  constructor() {
    super(...arguments), le(this, "handleClickBack", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.prev();
    }), le(this, "handleClickClose", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.close("button_close");
    }), le(this, "handleClickPrimary", (e) => {
      e.preventDefault();
      const { continuous: t, helpers: r } = this.props;
      if (!t) {
        r.close("button_primary");
        return;
      }
      r.next();
    }), le(this, "handleClickSkip", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.skip();
    }), le(this, "getElementsProps", () => {
      const { continuous: e, isLastStep: t, setTooltipRef: r, step: n } = this.props, i = Ln(n.locale.back), a = Ln(n.locale.close), o = Ln(n.locale.last), s = Ln(n.locale.next), u = Ln(n.locale.skip);
      let l = e ? s : a;
      return t && (l = o), {
        backProps: {
          "aria-label": i,
          "data-action": "back",
          onClick: this.handleClickBack,
          role: "button",
          title: i
        },
        closeProps: {
          "aria-label": a,
          "data-action": "close",
          onClick: this.handleClickClose,
          role: "button",
          title: a
        },
        primaryProps: {
          "aria-label": l,
          "data-action": "primary",
          onClick: this.handleClickPrimary,
          role: "button",
          title: l
        },
        skipProps: {
          "aria-label": u,
          "data-action": "skip",
          onClick: this.handleClickSkip,
          role: "button",
          title: u
        },
        tooltipProps: {
          "aria-modal": !0,
          ref: r,
          role: "alertdialog"
        }
      };
    });
  }
  render() {
    const { continuous: e, index: t, isLastStep: r, setTooltipRef: n, size: i, step: a } = this.props, { beaconComponent: o, tooltipComponent: s, ...u } = a;
    let l;
    if (s) {
      const c = {
        ...this.getElementsProps(),
        continuous: e,
        index: t,
        isLastStep: r,
        size: i,
        step: u,
        setTooltipRef: n
      }, f = s;
      l = /* @__PURE__ */ Fe.createElement(f, { ...c });
    } else
      l = /* @__PURE__ */ Fe.createElement(
        PI,
        {
          ...this.getElementsProps(),
          continuous: e,
          index: t,
          isLastStep: r,
          size: i,
          step: a
        }
      );
    return l;
  }
}, RI = class extends Fe.Component {
  constructor() {
    super(...arguments), le(this, "scope", null), le(this, "tooltip", null), le(this, "handleClickHoverBeacon", (e) => {
      const { step: t, store: r } = this.props;
      e.type === "mouseenter" && t.event !== "hover" || r.update({ lifecycle: _e.TOOLTIP });
    }), le(this, "handleClickOverlay", () => {
      const { helpers: e, step: t } = this.props;
      t.disableOverlayClose || e.close("overlay");
    }), le(this, "setTooltipRef", (e) => {
      this.tooltip = e;
    }), le(this, "setPopper", (e, t) => {
      var r;
      const { action: n, lifecycle: i, step: a, store: o } = this.props;
      t === "wrapper" ? o.setPopper("beacon", e) : o.setPopper("tooltip", e), o.getPopper("beacon") && o.getPopper("tooltip") && i === _e.INIT && o.update({
        action: n,
        lifecycle: _e.READY
      }), (r = a.floaterProps) != null && r.getPopper && a.floaterProps.getPopper(e, t);
    }), le(this, "renderTooltip", (e) => {
      const { continuous: t, helpers: r, index: n, size: i, step: a } = this.props;
      return /* @__PURE__ */ Fe.createElement(
        $I,
        {
          continuous: t,
          helpers: r,
          index: n,
          isLastStep: n + 1 === i,
          setTooltipRef: this.setTooltipRef,
          size: i,
          step: a,
          ...e
        }
      );
    });
  }
  componentDidMount() {
    const { debug: e, index: t } = this.props;
    Jn({
      title: `step:${t}`,
      data: [{ key: "props", value: this.props }],
      debug: e
    });
  }
  componentDidUpdate(e) {
    var t;
    const {
      action: r,
      callback: n,
      continuous: i,
      controlled: a,
      debug: o,
      helpers: s,
      index: u,
      lifecycle: l,
      status: c,
      step: f,
      store: d
    } = this.props, { changed: h, changedFrom: p } = Du(e, this.props), v = s.info(), m = i && r !== Ve.CLOSE && (u > 0 || r === Ve.PREV), x = h("action") || h("index") || h("lifecycle") || h("status"), y = p("lifecycle", [_e.TOOLTIP, _e.INIT], _e.INIT), g = h("action", [
      Ve.NEXT,
      Ve.PREV,
      Ve.SKIP,
      Ve.CLOSE
    ]), E = a && u === e.index;
    if (g && (y || E) && n({
      ...v,
      index: e.index,
      lifecycle: _e.COMPLETE,
      step: e.step,
      type: Or.STEP_AFTER
    }), f.placement === "center" && c === Ne.RUNNING && h("index") && r !== Ve.START && l === _e.INIT && d.update({ lifecycle: _e.READY }), x) {
      const b = zn(f.target), w = !!b;
      w && cI(b) ? (p("status", Ne.READY, Ne.RUNNING) || p("lifecycle", _e.INIT, _e.READY)) && n({
        ...v,
        step: f,
        type: Or.STEP_BEFORE
      }) : (console.warn(w ? "Target not visible" : "Target not mounted", f), n({
        ...v,
        type: Or.TARGET_NOT_FOUND,
        step: f
      }), a || d.update({ index: u + (r === Ve.PREV ? -1 : 1) }));
    }
    p("lifecycle", _e.INIT, _e.READY) && d.update({
      lifecycle: Sm(f) || m ? _e.TOOLTIP : _e.BEACON
    }), h("index") && Jn({
      title: `step:${l}`,
      data: [{ key: "props", value: this.props }],
      debug: o
    }), h("lifecycle", _e.BEACON) && n({
      ...v,
      step: f,
      type: Or.BEACON
    }), h("lifecycle", _e.TOOLTIP) && (n({
      ...v,
      step: f,
      type: Or.TOOLTIP
    }), this.tooltip && (this.scope = new TI(this.tooltip, { selector: "[data-action=primary]" }), this.scope.setFocus())), p("lifecycle", [_e.TOOLTIP, _e.INIT], _e.INIT) && ((t = this.scope) == null || t.removeScope(), d.cleanupPoppers());
  }
  componentWillUnmount() {
    var e;
    (e = this.scope) == null || e.removeScope();
  }
  get open() {
    const { lifecycle: e, step: t } = this.props;
    return Sm(t) || e === _e.TOOLTIP;
  }
  render() {
    const { continuous: e, debug: t, index: r, lifecycle: n, nonce: i, shouldScroll: a, size: o, step: s } = this.props, u = zn(s.target);
    return !Qb(s) || !oe.domElement(u) ? null : /* @__PURE__ */ Fe.createElement("div", { key: `JoyrideStep-${r}`, className: "react-joyride__step" }, /* @__PURE__ */ Fe.createElement(FI, { id: "react-joyride-portal" }, /* @__PURE__ */ Fe.createElement(
      DI,
      {
        ...s,
        debug: t,
        lifecycle: n,
        onClickOverlay: this.handleClickOverlay
      }
    )), /* @__PURE__ */ Fe.createElement(
      ah,
      {
        ...s.floaterProps,
        component: this.renderTooltip,
        debug: t,
        getPopper: this.setPopper,
        id: `react-joyride-step-${r}`,
        open: this.open,
        placement: s.placement,
        target: s.target
      },
      /* @__PURE__ */ Fe.createElement(
        AI,
        {
          beaconComponent: s.beaconComponent,
          continuous: e,
          index: r,
          isLastStep: r + 1 === o,
          locale: s.locale,
          nonce: i,
          onClickOrHover: this.handleClickHoverBeacon,
          shouldFocus: a,
          size: o,
          step: s,
          styles: s.styles
        }
      )
    ));
  }
}, Jb = class extends Fe.Component {
  constructor(e) {
    super(e), le(this, "helpers"), le(this, "store"), le(this, "callback", (o) => {
      const { callback: s } = this.props;
      oe.function(s) && s(o);
    }), le(this, "handleKeyboard", (o) => {
      const { index: s, lifecycle: u } = this.state, { steps: l } = this.props, c = l[s];
      u === _e.TOOLTIP && o.code === "Escape" && c && !c.disableCloseOnEsc && this.store.close("keyboard");
    }), le(this, "syncState", (o) => {
      this.setState(o);
    });
    const { debug: t, getHelpers: r, run: n, stepIndex: i } = e;
    this.store = _I({
      ...e,
      controlled: n && oe.number(i)
    }), this.helpers = this.store.getHelpers();
    const { addListener: a } = this.store;
    Jn({
      title: "init",
      data: [
        { key: "props", value: this.props },
        { key: "state", value: this.state }
      ],
      debug: t
    }), a(this.syncState), r && r(this.helpers), this.state = this.store.getState();
  }
  componentDidMount() {
    if (!jn())
      return;
    const { debug: e, disableCloseOnEsc: t, run: r, steps: n } = this.props, { start: i } = this.store;
    Am(n, e) && r && i(), t || document.body.addEventListener("keydown", this.handleKeyboard, { passive: !0 });
  }
  componentDidUpdate(e, t) {
    if (!jn())
      return;
    const { action: r, controlled: n, index: i, lifecycle: a, status: o } = this.state, { debug: s, run: u, stepIndex: l, steps: c } = this.props, { stepIndex: f, steps: d } = e, { reset: h, setSteps: p, start: v, stop: m, update: x } = this.store, { changed: y } = Du(e, this.props), { changed: g, changedFrom: E } = Du(t, this.state), b = ao(c[i], this.props), w = !Yt(d, c), _ = oe.number(l) && y("stepIndex"), A = zn(b.target);
    if (w && (Am(c, s) ? p(c) : console.warn("Steps are not valid", c)), y("run") && (u ? v(l) : m()), _) {
      let C = oe.number(f) && f < l ? Ve.NEXT : Ve.PREV;
      r === Ve.STOP && (C = Ve.START), [Ne.FINISHED, Ne.SKIPPED].includes(o) || x({
        action: r === Ve.CLOSE ? Ve.CLOSE : C,
        index: l,
        lifecycle: _e.INIT
      });
    }
    !n && o === Ne.RUNNING && i === 0 && !A && (this.store.update({ index: i + 1 }), this.callback({
      ...this.state,
      type: Or.TARGET_NOT_FOUND,
      step: b
    }));
    const O = {
      ...this.state,
      index: i,
      step: b
    };
    if (g("action", [
      Ve.NEXT,
      Ve.PREV,
      Ve.SKIP,
      Ve.CLOSE
    ]) && g("status", Ne.PAUSED)) {
      const C = ao(c[t.index], this.props);
      this.callback({
        ...O,
        index: t.index,
        lifecycle: _e.COMPLETE,
        step: C,
        type: Or.STEP_AFTER
      });
    }
    if (g("status", [Ne.FINISHED, Ne.SKIPPED])) {
      const C = ao(c[t.index], this.props);
      n || this.callback({
        ...O,
        index: t.index,
        lifecycle: _e.COMPLETE,
        step: C,
        type: Or.STEP_AFTER
      }), this.callback({
        ...O,
        type: Or.TOUR_END,
        // Return the last step when the tour is finished
        step: C,
        index: t.index
      }), h();
    } else
      E("status", [Ne.IDLE, Ne.READY], Ne.RUNNING) ? this.callback({
        ...O,
        type: Or.TOUR_START
      }) : (g("status") || g("action", Ve.RESET)) && this.callback({
        ...O,
        type: Or.TOUR_STATUS
      });
    this.scrollToStep(t), b.placement === "center" && o === Ne.RUNNING && a === _e.INIT && this.store.update({ lifecycle: _e.READY });
  }
  componentWillUnmount() {
    const { disableCloseOnEsc: e } = this.props;
    e || document.body.removeEventListener("keydown", this.handleKeyboard);
  }
  scrollToStep(e) {
    const { index: t, lifecycle: r, status: n } = this.state, {
      debug: i,
      disableScrollParentFix: a = !1,
      scrollDuration: o,
      scrollOffset: s = 20,
      scrollToFirstStep: u = !1,
      steps: l
    } = this.props, c = ao(l[t], this.props), f = zn(c.target), d = mI({
      isFirstStep: t === 0,
      lifecycle: r,
      previousLifecycle: e.lifecycle,
      scrollToFirstStep: u,
      step: c,
      target: f
    });
    if (n === Ne.RUNNING && d) {
      const h = ls(f, a), p = Ml(f, a);
      let v = Math.floor(dI(f, s, a)) || 0;
      Jn({
        title: "scrollToStep",
        data: [
          { key: "index", value: t },
          { key: "lifecycle", value: r },
          { key: "status", value: n }
        ],
        debug: i
      });
      const m = this.store.getPopper("beacon"), x = this.store.getPopper("tooltip");
      if (r === _e.BEACON && m) {
        const { offsets: y, placement: g } = m;
        !["bottom"].includes(g) && !h && (v = Math.floor(y.popper.top - s));
      } else if (r === _e.TOOLTIP && x) {
        const { flipped: y, offsets: g, placement: E } = x;
        ["top", "right", "left"].includes(E) && !y && !h ? v = Math.floor(g.popper.top - s) : v -= c.spotlightPadding;
      }
      v = v >= 0 ? v : 0, n === Ne.RUNNING && hI(v, { element: p, duration: o }).then(
        () => {
          setTimeout(() => {
            var y;
            (y = this.store.getPopper("tooltip")) == null || y.instance.update();
          }, 10);
        }
      );
    }
  }
  render() {
    if (!jn())
      return null;
    const { index: e, status: t } = this.state, {
      continuous: r = !1,
      debug: n = !1,
      nonce: i,
      scrollToFirstStep: a = !1,
      steps: o
    } = this.props;
    let s;
    if (t === Ne.RUNNING && o[e]) {
      const u = ao(o[e], this.props);
      s = /* @__PURE__ */ Fe.createElement(
        RI,
        {
          ...this.state,
          callback: this.callback,
          continuous: r,
          debug: n,
          helpers: this.helpers,
          nonce: i,
          shouldScroll: !u.disableScrolling && (e !== 0 || a),
          step: u,
          store: this.store
        }
      );
    }
    return /* @__PURE__ */ Fe.createElement("div", { className: "react-joyride" }, s);
  }
};
le(Jb, "defaultProps", xI);
var MI = Jb;
const BI = Rr({
  steps: [],
  updateSteps: () => {
  }
}), jI = 3600 * 1e3, LI = "obrtts", UI = ({ steps: e, children: t, onBoardingProps: r, onBoardingComponent: n }) => {
  var p, v;
  const { isFeatureOn: i, feature: a } = bx("onboarding"), [{ run: o, steps: s }, u] = Oe({
    run: !1,
    steps: e ?? []
  }), [l, c] = Oe(!1), { data: f } = Jt(), [d, h] = M0(
    LI,
    ""
  );
  return He(() => {
    try {
      !d || Date.now() - +d > (a != null && a.expiryMs ? +(a == null ? void 0 : a.expiryMs) : jI) ? (u({ run: !0, steps: e ?? [] }), h(Date.now().toString()), c(!0)) : (c(!1), u({ run: !1, steps: e ?? [] }));
    } catch (m) {
      console.error(m), u({ run: !1, steps: e ?? [] }), h(Date.now().toString()), c(!1);
    }
  }, []), /* @__PURE__ */ S.jsx(BI.Provider, { value: { steps: s, updateSteps: u }, children: /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    l && i ? n || /* @__PURE__ */ S.jsx(
      MI,
      {
        run: o,
        continuous: !0,
        styles: {
          options: {
            zIndex: 999999,
            primaryColor: (v = (p = f == null ? void 0 : f.theme) == null ? void 0 : p.colors) == null ? void 0 : v.primary
          }
        },
        ...r,
        steps: s ?? (r == null ? void 0 : r.steps) ?? e
      }
    ) : null,
    t
  ] }) });
}, Jne = new S0({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
}), HI = Q_(({ colorScheme: e }) => e === "brand" ? {
  bg: "brand.black",
  border: "none",
  color: "white",
  px: 5,
  py: 3,
  borderRadius: "lg",
  fontWeight: "bold",
  lineHeight: "base",
  minH: 12,
  _hover: {
    bg: "brand.neutral.deeper",
    _disabled: {
      bg: "brand.neutral.bright"
    }
  },
  _disabled: {
    // bg: 'brand.neutral.bright',
    bg: "#E6E6EB",
    // color: 'brand.neutral.deep',
    color: "#A5AAAF",
    borderColor: "brand.neutral.deep",
    opacity: 1
  }
} : {}), WI = K_({
  variants: { solid: HI },
  defaultProps: {
    colorScheme: "brand"
  }
}), { definePartsStyle: Zb, defineMultiStyleConfig: zI } = x_(
  PT.keys
), qI = Zb({
  field: {
    paddingX: "12px",
    paddingY: "17.5px",
    height: {
      md: "56px"
    },
    _placeholder: {
      color(e) {
        return e.colors.brand.neutral.deeper;
      }
    }
  }
}), YI = Zb({
  field: {
    borderColor(e) {
      return e.colors.brand.neutral.deep;
    },
    _hover: {
      borderColor(e) {
        return e.colors.brand.neutral.deeper;
      }
    }
  }
}), VI = {
  ...zI({
    baseStyle: qI,
    variants: {
      outline: YI
    }
  }),
  defaultProps: {
    focusBorderColor: "brand.black"
  }
}, GI = {
  initialColorMode: "light",
  useSystemColorMode: !1
}, KI = {
  global: {
    html: {
      // height: '100%',
      scrollBehavior: "smooth",
      colorScheme: "only light !important",
      overscrollBehavior: "none",
      WebkitTapHighlightColor: "rgba(255, 255, 255, 0)"
    },
    body: {
      bg: "#FFFFFF",
      overscrollBehavior: "none",
      color: "primaryText"
    },
    ":root": {
      colorScheme: "only light !important"
    }
  }
}, Ji = Xe(), Nn = dx({
  config: GI,
  styles: KI,
  fonts: {
    heading: Ji === "maxis" ? "Maxis, sans-serif" : Ji === "starhub" ? "Lato, sans-serif" : Ji === "jbhifi" ? "Apercu Pro" : "sans-serif",
    // TODO: Replace font conditions
    body: Ji === "maxis" ? "Maxis, sans-serif" : Ji === "starhub" ? "Lato, sans-serif" : Ji === "jbhifi" ? "Apercu Pro" : "sans-serif"
  },
  semanticTokens: {
    colors: {
      "chakra-body-text": {
        _light: "#000000"
      },
      brand: {
        valid: "#008662",
        invalid: "#DB1B1B"
      }
    }
  },
  colors: {
    primary: { 500: "#8223D2" },
    onPrimary: { 500: "#8223D2" },
    // Change to scale instead?
    brand: {
      border: "#D5D6DA",
      black: "#000000",
      tertiary: "#333333",
      secondary: "#6E767D",
      bg: "#F0F0F5",
      neutral: {
        deep: "#A5AAAF",
        deeper: "#6E767D",
        bright: "#E6E6EB",
        brightest: "#F0F0F5"
      }
    }
  },
  components: {
    Input: VI,
    Button: WI,
    Container: {
      baseStyle: {
        maxW: "container.sm"
      }
    },
    Code: {
      baseStyle: {
        padding: "16px",
        fontSize: "xs"
      }
    },
    Heading: {
      variants: {
        storyTitle: {
          color: "primary.500",
          fontSize: "3xl",
          fontWeight: 700
        }
      }
    },
    Text: {
      defaultProps: {
        color: "primaryText"
      },
      variants: {
        storyField: {
          fontSize: "large",
          color: "primary.500",
          textAlign: "left"
        }
      }
    }
  },
  breakpoints: {
    base: "0em",
    // 0px
    xsm: "23.4375em",
    // 375px
    sm: "30em",
    // ~480px. em is a relative unit and is dependant on the font-size.
    md: "48em",
    // ~768px
    lg: "62em",
    // ~992px
    xl: "80em",
    // ~1280px
    "2xl": "96em"
    // ~1536px
  }
}), QI = ({
  children: e,
  themeOverride: t = {}
}) => {
  const { data: r, isLoading: n } = Jt(), i = Vn(() => {
    var l, c;
    const { colors: a, baseComponents: o } = (r == null ? void 0 : r.theme) || {}, s = Object.fromEntries(
      Object.entries(o || {}).map(([f, d]) => {
        var h, p;
        return [
          f,
          {
            baseStyle: {
              ...((p = (h = Nn == null ? void 0 : Nn.components) == null ? void 0 : h[f]) == null ? void 0 : p.baseStyle) || {},
              ...d
            }
          }
        ];
      })
    ), u = {
      ...Nn.components,
      ...s
    };
    return dx({
      ...Nn,
      colors: {
        ...Nn.colors,
        primary: Lp(((l = t == null ? void 0 : t.color) == null ? void 0 : l.primary) || (a == null ? void 0 : a.primary)),
        onPrimary: Lp(
          ((c = t == null ? void 0 : t.color) == null ? void 0 : c.onPrimary) || (a == null ? void 0 : a.onPrimary)
        ),
        primaryText: a == null ? void 0 : a.bodyTextColor
      },
      semanticTokens: {
        ...Nn.semanticTokens,
        colors: {
          ...Nn.semanticTokens.colors,
          ...r.theme.colors.bodyTextColor ? {
            "chakra-body-text": {
              _light: r.theme.colors.bodyTextColor || "#000000"
            }
          } : {}
        }
      },
      components: u
    });
  }, [r]);
  return /* @__PURE__ */ S.jsx(b_, { theme: i, children: n && (r == null ? void 0 : r.local) === "true" ? /* @__PURE__ */ S.jsx(Wt, { h: "100vh", children: /* @__PURE__ */ S.jsx(Io, { size: "lg" }) }) : e });
}, XI = "configStart", JI = "configData", ZI = 36e5, e4 = [
  { code: "EN", locale: "en-US", name: "English" },
  { code: "CN", locale: "zh-Hant-TW", name: "Chinese" },
  { code: "TH", locale: "th-TH", name: "Thai" },
  { code: "KO", locale: "ko-KR", name: "Korean" },
  { code: "MY", locale: "ms-MY", name: "Bahasa" }
], gi = {
  local: "true",
  partner: "myasurion",
  program: "myasurion",
  features: {},
  urls: {
    profile: "profile"
  },
  languagesAvailable: [{ code: "EN", locale: "en-US", name: "English" }],
  languages: [
    {
      code: "EN",
      name: "English"
    },
    {
      code: "CN",
      name: "Chinese"
    },
    {
      code: "TH",
      name: "Thai"
    },
    {
      code: "KO",
      name: "Korean"
    },
    {
      code: "MY",
      name: "Bahasa"
    }
  ],
  mainMenu: [
    {
      name: "Tech care preferences",
      code: "techcare",
      url: "profile/techcare"
    },
    {
      name: "Notifications",
      code: "notifications",
      url: "profile/notifications"
    },
    {
      name: "Share feedback",
      code: "feedback",
      url: "profile/feedback"
    }
  ],
  theme: {
    logo: "/images/carriers/asurion/asurion-logo.svg",
    header: {
      logo: "/images/carriers/asurion/asurion.svg",
      bg: "white"
    },
    notification: {
      discount: "/images/carriers/asurion/discount.svg",
      exclusives: "/images/carriers/asurion/exclusives.svg",
      newstuff: "/images/carriers/asurion/new-stuff.svg",
      order: "/images/carriers/asurion/order.svg"
    },
    colors: {
      primary: "#8223D2",
      onPrimary: "#8223D2",
      accent: "#8223D2",
      bannerGradient: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5"
    },
    components: {
      profileBanner: {
        bg: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5"
      },
      serviceRequestBtn: {
        w: "full",
        minW: "287px",
        p: "12px 20px",
        colorScheme: "primary",
        variant: "solid"
      },
      chat: {
        headerBg: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5",
        headerColor: "white",
        btnTxtColor: "#09411D",
        chatIcon: "/images/carriers/asurion/expert-default-mid.png",
        sendIcon: "/images/carriers/asurion/chat-send.svg",
        agentIcon: "/images/carriers/asurion/agent-chat-icon.svg",
        thankYouIcon: "/images/carriers/asurion/chat-thankyou.svg"
      }
    }
  }
}, e1 = Rr({
  data: gi,
  isLoading: !1,
  refetchConfig: async () => ({}),
  updateConfig: () => {
  },
  saveConfig: () => {
  },
  conf: { hmacKey: "", url: "", baseApi: "" },
  isInit: !1
});
Rr({
  config: gi
});
const t4 = async ({
  url: e,
  hmacKey: t = ""
}) => {
  const r = Xe(), n = Ir(r), i = +/* @__PURE__ */ new Date(), a = k_(i), o = N_(e), s = P_(
    {
      httpPath: o,
      token: a
    },
    t
  );
  return await (await fetch(e || `/configs/${r}.json`, {
    headers: {
      "x-api-key": "some-key",
      "x-asurion-client": r,
      "x-asurion-cc": n.code,
      token: a,
      t: i,
      // TODO: is it okay if this is a string to avoid type error?
      authorization: s
    }
  })).json();
}, r4 = async ({
  url: e,
  authToken: t,
  dataConfig: r
}) => {
  const n = Xe(), i = Ir(n), a = +/* @__PURE__ */ new Date(), s = await (await fetch(e ? `${e}/config` : "/config", {
    method: "POST",
    headers: {
      "x-api-key": "some-key",
      "x-asurion-client": n,
      "x-asurion-cc": i.code,
      token: t.token,
      t: a,
      // TODO: is it okay if this is a string to avoid type error?
      authorization: t.authorization,
      id: t.id
    },
    body: JSON.stringify({
      configurationName: `config-${n}`,
      content: r
    })
  })).json();
  return console.log("Config is fetching from remote", s), s;
}, n4 = ({
  queryClient: e,
  // TODO: no need to pass queryClient, we can use useQueryClient instead.
  url: t,
  headers: r,
  hmacKey: n,
  baseApi: i
}) => {
  const a = Xe(), [o, s] = fd(XI, 0), [u, l] = fd(
    JI,
    void 0
  ), [c, f] = Oe(!1), d = Vn(() => !u || (u == null ? void 0 : u.partner) !== a ? !0 : Date.now() - o > ZI, [o]), { isFetching: h, refetch: p } = ol({
    queryKey: ["config", a],
    queryFn: () => t4({ url: t, headers: r, hmacKey: n }),
    enabled: !!a && d,
    onSuccess: (x) => {
      s(Date.now()), x != null && x.body ? l(x == null ? void 0 : x.body) : (e.setQueryData(["config", t], gi), l(gi));
    },
    onError: () => {
      console.error(
        `Cannot fetch config for carrier ${a}. Using default configuration instead.`
      ), e.setQueryData(["config", t], gi), s(Date.now()), l(gi);
    },
    onSettled: () => {
      f(!0);
    }
  }), v = Me(
    (x) => {
      l(x), s(Date.now());
    },
    [l]
  ), { mutate: m } = s_({
    mutationFn: r4,
    onSuccess: () => {
      console.log("saved config");
    }
  });
  return {
    data: u ?? gi,
    isLoading: t && d ? h : !1,
    refetchConfig: p,
    updateConfig: v,
    saveConfig: m,
    conf: { hmacKey: n, url: t, baseApi: i },
    isInit: c
  };
}, i4 = ({ env: e, children: t }) => {
  const r = e.apiBaseUrl, i = gx() ? W_() : Xe(), a = r ? `${r}/config?configurationName=config-${i}` : void 0, o = n4({
    url: a,
    queryClient: t1,
    hmacKey: e.hmacKey || "",
    baseApi: r
  });
  return /* @__PURE__ */ S.jsx(e1.Provider, { value: { module: e == null ? void 0 : e.moduleId, ...o }, children: /* @__PURE__ */ S.jsx(QI, { children: t }) });
}, t1 = new S0({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
});
$_();
const Zne = ({
  env: e,
  children: t,
  config: r,
  onBoardingSteps: n,
  onBoardingProps: i,
  srcStrings: a
}) => {
  var u;
  const o = e == null ? void 0 : e.baseUrl, s = (u = Xe()) == null ? void 0 : u.toLowerCase();
  return /* @__PURE__ */ S.jsx(u_, { client: t1, children: /* @__PURE__ */ S.jsx(p_, { basename: o, children: /* @__PURE__ */ S.jsx(i4, { env: e, children: /* @__PURE__ */ S.jsx(
    tr,
    {
      fallback: s === "starhub" || s === "celcom" ? /* @__PURE__ */ S.jsx(FC, {}) : /* @__PURE__ */ S.jsx(DC, {}),
      children: /* @__PURE__ */ S.jsx(q_, { config: r, children: /* @__PURE__ */ S.jsx(UT, { config: r, children: /* @__PURE__ */ S.jsx(
        SC,
        {
          apiKey: e == null ? void 0 : e.apiKey,
          apiBaseUrl: e == null ? void 0 : e.apiBaseUrl,
          children: /* @__PURE__ */ S.jsx(GC, { children: /* @__PURE__ */ S.jsx(
            FO,
            {
              moduleId: (e == null ? void 0 : e.moduleId) || "myAsurionShared",
              isEnabled: (e == null ? void 0 : e.enableTranslations) ?? !1,
              apiEnv: {
                hmacKey: e.hmacKey,
                apiUrl: e.apiBaseUrl
              },
              srcStrings: a,
              children: /* @__PURE__ */ S.jsx(
                IC,
                {
                  config: r,
                  baseApiConfig: {
                    baseEndpoint: e.apiBaseUrl,
                    apiKey: e == null ? void 0 : e.apiKey,
                    hmacKey: e == null ? void 0 : e.hmacKey
                  },
                  children: /* @__PURE__ */ S.jsx(X_, { config: r, children: /* @__PURE__ */ S.jsx(
                    UI,
                    {
                      steps: n ?? [],
                      onBoardingProps: i,
                      children: t
                    }
                  ) })
                }
              )
            }
          ) })
        }
      ) }) })
    }
  ) }) }) });
}, Ma = /* @__PURE__ */ new Map();
Ma.set("myAsurionPortal", "/portal");
Ma.set("myAsurionSRSwap", "/swap");
Ma.set("myAsurionAuth", "/login");
Ma.set("myAsurionProfile", "/profile");
Ma.set("myAsurionArticle", "/articles");
const a4 = (e) => Ma.get(e), Jt = () => {
  const e = sn(e1);
  if (e === void 0)
    throw new Error("useConfig must be used within a ConfigProvider");
  const t = ll();
  function r(n) {
    var a;
    let i;
    try {
      i = Object.fromEntries(
        (a = Object.entries(n)) == null ? void 0 : a.map(([o, s]) => {
          const u = t === "repair" ? a4(e.module ?? "myAsurionPortal") : "";
          return typeof s == "object" && s !== null ? Array.isArray(s) ? [
            o,
            s.map((l) => (typeof l == "string" && l.startsWith("/images/") && u + l, l))
          ] : [o, r(s)] : typeof s == "string" && s.startsWith("/images/") ? [o, u + s] : [o, s];
        })
      );
    } catch {
      i = n;
    }
    return i;
  }
  return {
    ...e,
    data: r(e.data)
  };
};
var Om;
((e) => {
  let t = null;
  class r {
    constructor(i) {
      pe(this, "_config");
      pe(this, "_app");
      pe(this, "_remoteConfig");
      pe(this, "_isActivated", !1);
      this._config = i, this._app = this._initialize(i), this._remoteConfig = R_(this._app), this._remoteConfig.settings.minimumFetchIntervalMillis = 3e3, this._remoteConfig.defaultConfig = {}, Ja(this._remoteConfig);
    }
    async fetchAndActivate(i) {
      await Ja(i), this._isActivated = !0;
    }
    _initialize(i) {
      return M_(i ?? this._config);
    }
    getValue(i) {
      return this._isActivated === !1 && Ja(this._remoteConfig), B_(this._remoteConfig, i);
    }
    async fetchValue(i) {
      return await Ja(this._remoteConfig), this.getValue(i);
    }
    async fetchAll() {
      return await Ja(this._remoteConfig), j_(this._remoteConfig);
    }
  }
  e.MARemoteConfig = r, e.initializeRemoteConfig = (n) => {
    t || (t = new r(n));
  }, e.getConfigValue = (n) => {
    if (t)
      return t.getValue(n);
  }, e.fetchValue = (n) => {
    if (t)
      return t.fetchValue(n);
  }, e.fetchAll = () => {
    if (t)
      return t.fetchAll();
  };
})(Om || (Om = {}));
const o4 = "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGhlaWdodD0iMWVtIiB3aWR0aD0iMWVtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yNTcuNyA3NTJjMiAwIDQtLjIgNi0uNUw0MzEuOSA3MjJjMi0uNCAzLjktMS4zIDUuMy0yLjhsNDIzLjktNDIzLjlhOS45NiA5Ljk2IDAgMCAwIDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAgMCA5LjQgMjkuOGM2LjYgNi40IDE0LjkgOS45IDIzLjggOS45em02Ny40LTE3NC40TDY4Ny44IDIxNWw3My4zIDczLjMtMzYyLjcgMzYyLjYtODguOSAxNS43IDE1LjYtODl6TTg4MCA4MzZIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzNmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtMzZjMC0xNy43LTE0LjMtMzItMzItMzJ6Ij48L3BhdGg+PC9zdmc+", s4 = ({ handleSave: e, handleCancel: t }) => {
  const { isEditing: r, getSubmitButtonProps: n, getCancelButtonProps: i } = E_();
  return r ? /* @__PURE__ */ S.jsxs(
    w_,
    {
      justifyContent: "end",
      size: "xs",
      w: "max-content",
      spacing: "0.5",
      mt: 0,
      flex: "1",
      borderRadius: "5px",
      variant: "teal",
      py: "2",
      children: [
        /* @__PURE__ */ S.jsx(
          wu,
          {
            "aria-label": "Check icon",
            icon: /* @__PURE__ */ S.jsx(m_, {}),
            size: "xs",
            variant: "outline",
            colorScheme: "teal",
            ...n({ onClick: e })
          }
        ),
        /* @__PURE__ */ S.jsx(
          wu,
          {
            "aria-label": "Close icon",
            icon: /* @__PURE__ */ S.jsx(cx, { boxSize: 2 }),
            size: "xs",
            variant: "outline",
            colorScheme: "teal",
            ...i({ onClick: t })
          }
        )
      ]
    }
  ) : null;
}, Td = (e = null) => {
  if (e && e !== null) {
    const [t, r] = e.split("/");
    return [t, r];
  } else
    return [null, null];
}, oh = async (e, t, r, n, i, a, o, s, u, l, c, f) => {
  const [d, h] = Td(t);
  let p = "";
  if (d !== null && h !== null && c && c.length > 0)
    for (let v = 0; v < c.length; v++) {
      const m = await u4(
        e,
        t,
        d,
        r,
        // groupId?.toLowerCase() === 'global' ? 'global' : module,
        c[v],
        i,
        a,
        { ...o, profileId: a.id ?? o.profileId },
        s,
        u,
        l,
        f
      );
      c[v] === n && (p = m);
    }
  return dr(p, l ?? []);
}, u4 = async (e, t, r, n, i, a, o, s, u, l, c, f) => {
  var x;
  let d, h, p;
  i === "zh-Hant-TW" ? p = Be.getZhStringManager(
    u,
    n,
    i,
    Be.getDataStore(
      a,
      o,
      s.profileId,
      n,
      l
    )
  ) : i === "th-TH" ? p = Be.getThStringManager(
    u,
    n,
    i,
    Be.getDataStore(
      a,
      o,
      s.profileId,
      n,
      l
    )
  ) : i === "ko-KR" ? p = Be.getKoStringManager(
    u,
    n,
    i,
    Be.getDataStore(
      a,
      o,
      s.profileId,
      n,
      l
    )
  ) : i === "ms-MY" ? p = Be.getMyStringManager(
    u,
    n,
    i,
    Be.getDataStore(
      a,
      o,
      s.profileId,
      n,
      l
    )
  ) : p = Be.getStringManager(
    u,
    n,
    i,
    Be.getDataStore(
      a,
      o,
      s.profileId,
      n,
      l
    )
  );
  const v = Be.getScriptManager(
    u,
    (r == null ? void 0 : r.toLowerCase()) === "global" ? "global" : n,
    i
  );
  h = v.getScript(t, i), h || (h = v.createScript(
    e,
    t,
    r,
    (r == null ? void 0 : r.toLowerCase()) === "global" ? "global" : n,
    i,
    u,
    c
  ));
  const m = await p.getGroup(r, f);
  return m === null ? d = null : d = m.getString(`${u}-${t}`), (d === null || !d) && (i === "en-US" && (!f || ((x = f[i]) == null ? void 0 : x.length) < 1) && await p.createString(
    e,
    t,
    r,
    n,
    o,
    s,
    u
  ), d = new Be.String(t, null, m), d.content = e || "", d.onUpdateListener = l4, m && m.addString(d)), (d == null ? void 0 : d.content) || e;
}, l4 = (e, t) => {
  let r;
  switch (e) {
    case "string.updated":
      r = t[0];
      break;
    default:
      r = "(loading)";
      break;
  }
  return r;
}, c4 = (e) => {
  let t;
  switch (e) {
    case "initial":
      t = "#eaf3ff";
      break;
    case "modified":
      t = "#FEEBC8";
      break;
    case "changed":
      t = "#ceecff";
      break;
    case "failed":
      t = "#FFB6C1";
      break;
    default:
      t = hx("gray.100", "gray.600");
      break;
  }
  return t;
}, dr = (e, t) => !t || t.length === 0 ? e : e == null ? void 0 : e.replace(
  /\{(\d+)\}/g,
  (r, n) => typeof t[n - 1] < "u" ? t[n - 1] : `{${n}}`
), _t = ({
  text: e,
  translationKey: t,
  dynamicValues: r = [],
  isFull: n = !1,
  module: i
}) => {
  var D;
  const [a, o] = Oe(dr(e, r)), [s, u] = Oe(""), [l, c] = Oe("initial"), [f, d] = Oe(e), [h, p] = Oe(!1), v = S_(), { data: m } = Jt(), { languagesAvailable: x } = m, [y] = Fa({
    authorization: "",
    token: "",
    id: ""
  }), [g] = Jo({
    profileId: "",
    userId: ""
  }), {
    isEnabled: E,
    language: b,
    module: w,
    apiEnv: _,
    isEditingMode: A,
    isDevToolsOpen: O,
    isDevToolsEnabled: T,
    // isTranslationsLoading,
    // updateIsTranslationsLoading,
    isKeyShown: C,
    srcStrings: $
  } = Bl(), j = xa() ? ba() : Xe(), { isFeatureOn: W } = bx("showSkeleton"), Y = (N) => {
    N.key == "Enter" && V();
  }, V = async () => {
    const [N, B] = Td(t);
    try {
      if (N === null && B === null)
        throw "No section id or string id provided";
      let F;
      b === "zh-Hant-TW" ? F = Be.getZhStringManager(
        j,
        i ?? w,
        b,
        Be.getDataStore(
          _,
          y,
          y.id ?? g.profileId,
          i ?? w,
          T
        )
      ) : b === "th-TH" ? F = Be.getThStringManager(
        j,
        i ?? w,
        b,
        Be.getDataStore(
          _,
          y,
          y.id ?? g.profileId,
          i ?? w,
          T
        )
      ) : b === "ko-KR" ? F = Be.getKoStringManager(
        j,
        i ?? w,
        b,
        Be.getDataStore(
          _,
          y,
          y.id ?? g.profileId,
          i ?? w,
          T
        )
      ) : b === "ms-MY" ? F = Be.getMyStringManager(
        j,
        i ?? w,
        b,
        Be.getDataStore(
          _,
          y,
          y.id ?? g.profileId,
          i ?? w,
          T
        )
      ) : F = Be.getStringManager(
        j,
        i ?? w,
        b,
        Be.getDataStore(
          _,
          y,
          y.id ?? g.profileId,
          i ?? w,
          T
        )
      );
      const X = Be.getScriptManager(
        j,
        i ?? w,
        b
      );
      if (F === null)
        throw "No manager instance";
      const Z = await F.getGroup(N), ne = Z == null ? void 0 : Z.getString(`${j}-${t}`);
      if (ne == null || !ne.internalId)
        throw "No string instance";
      if (c("modified"), a !== s) {
        const { isUpdated: K } = await F.updateStringEntry(
          a,
          ne.internalId,
          b,
          y,
          { profileId: y.id }
        );
        if (K)
          c("changed"), X.updateScript(
            a,
            t,
            N,
            "changed",
            b
          ), d(a), v({
            title: "Text saved successfully!",
            description: `${a} is successfully requested for change to locale ${b}`,
            status: "success",
            duration: 1500,
            isClosable: !0
          });
        else
          throw X.updateScript(
            a,
            t,
            N,
            "failed",
            b
          ), "Failed update";
      } else
        c("initial");
    } catch (F) {
      c("failed"), v({
        title: "Error in saving entry",
        description: "Something went wrong" + F,
        status: "error",
        duration: 2e3,
        isClosable: !0
      });
    }
  }, ce = () => {
    c("initial"), o(dr(s, r));
  }, de = Vn(
    () => {
      var N;
      return (N = Be.getScriptManager(j, i ?? w, b).getScript(
        t,
        b
      )) == null ? void 0 : N.script;
    },
    [
      (D = Be.getScriptManager(j, i ?? w, b).getScript(
        t,
        b
      )) == null ? void 0 : D.script
    ]
  );
  if (He(() => {
    E && (o(dr(e, r)), p(!1), (async () => {
      var K, we;
      const B = await oh(
        e,
        t,
        i ?? w,
        b,
        _,
        y,
        g,
        j,
        T,
        r,
        x.map((I) => I == null ? void 0 : I.locale),
        $ || void 0
      ), F = Be.getScriptManager(
        j,
        i ?? w,
        b
      ), [X, Z] = Td(t);
      Z !== null && X !== null && F.updateScript(
        B,
        t,
        X,
        "initial",
        b
      );
      const ne = dr(B, r);
      o(ne), u(dr(B, r)), F.getScript(t, b) && (o(
        dr(
          ((K = F.getScript(t, b)) == null ? void 0 : K.script) ?? dr(B, r),
          r
        )
      ), u(
        dr(
          ((we = F.getScript(t, b)) == null ? void 0 : we.script) ?? dr(B, r),
          r
        )
      )), p(!0);
    })());
  }, [
    b,
    E,
    T,
    t,
    JSON.stringify(r),
    JSON.stringify(x)
  ]), He(() => {
    var B;
    const N = ((B = Be.getScriptManager(j, i ?? w, b).getScript(
      t,
      b
    )) == null ? void 0 : B.script) ?? a;
    o(dr(N, r)), d(N);
  }, [de, f, O, b, JSON.stringify(r)]), !E)
    return /* @__PURE__ */ S.jsx(S.Fragment, { children: e });
  if (E && !A)
    return /* @__PURE__ */ S.jsx(
      Dc,
      {
        "aria-description": t,
        label: t,
        isDisabled: !T,
        children: W ? /* @__PURE__ */ S.jsx(
          A0,
          {
            isLoaded: h,
            width: "max-content",
            height: "max-content",
            display: "inline",
            children: /* @__PURE__ */ S.jsx("span", { "aria-description": t, children: C ? t : a })
          }
        ) : /* @__PURE__ */ S.jsx("span", { "aria-description": t, children: C ? t : a })
      }
    );
  const L = (N) => {
    o(N);
  };
  return /* @__PURE__ */ S.jsxs(
    __,
    {
      defaultValue: e,
      value: a,
      onChange: L,
      isPreviewFocusable: !0,
      selectAllOnFocus: !1,
      id: "editable",
      display: "flex",
      flexFlow: "row nowrap",
      "aria-description": `editable-${t}`,
      children: [
        /* @__PURE__ */ S.jsx(
          Dc,
          {
            label: `Translation Key: ${t}. Click to edit`,
            shouldWrapChildren: !0,
            children: /* @__PURE__ */ S.jsx(
              T_,
              {
                px: 1,
                py: 2,
                position: "relative",
                paddingRight: "25px",
                cursor: "text",
                minHeight: "32px",
                background: c4(l),
                _hover: {
                  background: hx("gray.200", "gray.700"),
                  color: "black"
                },
                _after: {
                  content: '""',
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  width: "13px",
                  height: "13px",
                  backgroundImage: `url("${o4}")`,
                  backgroundSize: "cover"
                },
                w: "full"
              }
            )
          }
        ),
        /* @__PURE__ */ S.jsx(Dc, { label: "Input here your proposed translation changes", children: /* @__PURE__ */ S.jsxs(
          Ni,
          {
            justifyContent: "center",
            alignItems: "center",
            height: "max-content",
            w: n ? "full" : "unset",
            children: [
              /* @__PURE__ */ S.jsx(
                sl,
                {
                  py: 1,
                  px: 1,
                  as: A_,
                  value: a,
                  onKeyDown: Y,
                  w: n ? "full" : "unset"
                }
              ),
              /* @__PURE__ */ S.jsx(s4, { handleSave: V, handleCancel: ce })
            ]
          }
        ) })
      ]
    }
  );
}, eie = (e, t, r = "en-US", n = []) => (async () => {
  const a = Be.getDataStore(
    { hmacKey: "", apiUrl: "" },
    { authorization: "", token: "" },
    "",
    "",
    !1
  ), s = xa() ? ba() : Xe();
  return new Promise((l) => {
    a.setInitCallback(async (c) => {
      await ((T) => new Promise((C) => setTimeout(C, T)))(100);
      const {
        authorization: d,
        baseUrl: h,
        hmacKey: p,
        moduleId: v,
        profileId: m,
        token: x,
        isDevToolsEnabled: y
      } = c, g = sessionStorage.getItem("al"), E = localStorage.getItem(`srcStrings-${v}`);
      let b;
      try {
        b = JSON.parse((E == null ? void 0 : E[r]) ?? "[]") ?? void 0;
      } catch {
        b = void 0;
      }
      const w = localStorage == null ? void 0 : localStorage.getItem("configData");
      let _;
      if (w) {
        const T = JSON == null ? void 0 : JSON.parse(w);
        _ = T == null ? void 0 : T.languagesAvailable;
      }
      const A = typeof g == "string" && (JSON.parse(g) === "en-US" || JSON.parse(g) === "zh-Hant-TW" || JSON.parse(g) === "th-TH" || JSON.parse(g) === "ko-KR" || JSON.parse(g) === "ms-MY") ? JSON.parse(g) ?? r : r, O = await oh(
        t,
        e,
        v,
        A,
        { hmacKey: p, baseUrl: h },
        { authorization: d, token: x },
        { profileId: m },
        s,
        // { hmacKey, baseUrl },
        // { authorization, token },
        // { profileId }
        y,
        n,
        _ == null ? void 0 : _.map((T) => T == null ? void 0 : T.locale),
        b
      );
      l(dr(O, n));
    });
  });
})(), f4 = (e, t) => !t || t.length === 0 ? e : e == null ? void 0 : e.replace(
  /\{(\d+)\}/g,
  (r, n) => typeof t[n - 1] < "u" ? t[n - 1] : `{${n}}`
), Bl = () => {
  const e = sn(db);
  if (e === void 0)
    throw new Error("useTextScript must be used within a TextScriptProvider");
  const { data: t } = Jt(), { languagesAvailable: r } = t, {
    language: n,
    updateActiveLanguage: i,
    module: a,
    isEnabled: o,
    updateIsEnabled: s,
    apiEnv: u,
    isEditingMode: l,
    updateIsEditingMode: c,
    isDevToolsOpen: f,
    updateIsDevToolsOpen: d,
    isDevToolsEnabled: h,
    updateIsDevToolsEnabled: p,
    isTranslationsLoading: v,
    updateIsTranslationsLoading: m,
    isKeyShown: x,
    setIsKeyShown: y,
    srcStrings: g
  } = e;
  return {
    language: n,
    updateActiveLanguage: i,
    module: a,
    isEnabled: o,
    updateIsEnabled: s,
    apiEnv: u,
    isEditingMode: l,
    updateIsEditingMode: c,
    isDevToolsOpen: f,
    updateIsDevToolsOpen: d,
    isDevToolsEnabled: h,
    updateIsDevToolsEnabled: p,
    isTranslationsLoading: v,
    updateIsTranslationsLoading: m,
    getTextScript: (b, w, _ = "en-US", A = []) => (async () => {
      const T = Be.getDataStore(
        { hmacKey: "", apiUrl: "" },
        { authorization: "", token: "" },
        "",
        "",
        !1
      ), $ = xa() ? ba() : Xe();
      return new Promise((j) => {
        T.setInitCallback(async (W) => {
          const Y = _, {
            authorization: V,
            baseUrl: ce,
            hmacKey: de,
            moduleId: L,
            profileId: D,
            token: N,
            isDevToolsEnabled: B
          } = W, X = await oh(
            w,
            b,
            L,
            Y,
            { hmacKey: de, baseUrl: ce },
            { authorization: V, token: N },
            { profileId: D },
            $,
            // { hmacKey, baseUrl },
            // { authorization, token },
            // { profileId }
            B,
            A,
            r == null ? void 0 : r.map((Z) => Z == null ? void 0 : Z.locale),
            g || void 0
          );
          j(f4(X, A));
        });
      });
    })(),
    isKeyShown: x,
    setIsKeyShown: y,
    srcStrings: g
  };
}, d4 = Rr({
  entries: [],
  updateEntry: async () => {
  },
  updateLocaleLanguage: () => {
  },
  localeLanguage: "en-US",
  getTextEntry: () => ({ textEntry: "", entryId: "" }),
  localModule: void 0,
  setLocalModule: () => {
  },
  isTranslationsActive: !1,
  setIsTranslationsActive: () => {
  },
  translationAPI: { api: null, authorization: "", token: "" }
}), Pf = () => {
  const e = sn(d4);
  if (e === void 0)
    throw new Error("useLocalization must be used within a TranslationProvider");
  const {
    entries: t,
    localeLanguage: r,
    updateLocaleLanguage: n,
    getTextEntry: i,
    updateEntry: a,
    setLocalModule: o,
    isTranslationsActive: s,
    setIsTranslationsActive: u,
    translationAPI: l
  } = e;
  return {
    entries: t,
    localeLanguage: r,
    updateLocaleLanguage: n,
    getTextEntry: i,
    updateEntry: a,
    setLocalModule: o,
    isTranslationsActive: s,
    setIsTranslationsActive: u,
    translationAPI: l
  };
}, h4 = () => {
  const e = qr(!1);
  return [() => {
    if (typeof document > "u")
      return;
    const n = document.documentElement, { body: i } = document;
    if (!i || !i.style || e.current)
      return;
    const a = window.innerWidth - n.clientWidth, o = parseInt(window.getComputedStyle(i).getPropertyValue("padding-right")) || 0;
    n.style.position = "relative", i.style.position = "relative", n.style.overflow = "hidden", i.style.overflow = "hidden", i.style.paddingRight = `${o + a}px`, e.current = !0;
  }, () => {
    if (typeof document > "u")
      return;
    const n = document.documentElement, { body: i } = document;
    !i || !i.style || !e.current || (n.style.position = "", n.style.overflow = "", i.style.position = "", i.style.overflow = "", i.style.paddingRight = "", e.current = !1);
  }];
}, p4 = (e = "", t = "", r = "", n = "", i) => {
  const [a, o] = Oe(null), [s, u] = Oe(!0);
  return He(() => {
    async function l() {
      try {
        if (e) {
          const c = await FT(
            e,
            t,
            r,
            n,
            i
          );
          c && o(c);
        } else {
          o(null);
          return;
        }
      } catch (c) {
        console.error("Error fetching Contentful image:", c);
      } finally {
        u(!1);
      }
    }
    l();
  }, [e, t, r, n]), { imageUrl: a, isLoading: s };
}, r1 = (e) => e && e["nonRetryable"], $s = new cl("retryUtil");
async function v4(e, t, r, n) {
  if (typeof e != "function")
    throw Error("functionToRetry must be a function");
  return new Promise(async (i, a) => {
    let o = 0, s = !1, u, l = () => {
    }, c;
    for (n && n.then(() => {
      s = !0, clearTimeout(u), l();
    }); !s; ) {
      o++, $s.debug(`${e.name} attempt #${o} with this vars: ${JSON.stringify(t)}`);
      try {
        i(await e(...t));
        return;
      } catch (f) {
        if (c = f, $s.debug(`error on ${e.name}`, f), r1(f)) {
          $s.debug(`${e.name} non retryable error`, f), a(f);
          return;
        }
        const d = r(o, t, f);
        if ($s.debug(`${e.name} retrying in ${d} ms`), d === !1 || s) {
          a(f);
          return;
        } else
          await new Promise((h) => {
            l = h, u = setTimeout(l, d);
          });
      }
    }
    a(c);
  });
}
let Rs;
const m4 = new Uint8Array(16);
function y4() {
  if (!Rs && (Rs = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Rs))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Rs(m4);
}
const It = [];
for (let e = 0; e < 256; ++e)
  It.push((e + 256).toString(16).slice(1));
function g4(e, t = 0) {
  return It[e[t + 0]] + It[e[t + 1]] + It[e[t + 2]] + It[e[t + 3]] + "-" + It[e[t + 4]] + It[e[t + 5]] + "-" + It[e[t + 6]] + It[e[t + 7]] + "-" + It[e[t + 8]] + It[e[t + 9]] + "-" + It[e[t + 10]] + It[e[t + 11]] + It[e[t + 12]] + It[e[t + 13]] + It[e[t + 14]] + It[e[t + 15]];
}
const x4 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Dm = {
  randomUUID: x4
};
function n1(e, t, r) {
  if (Dm.randomUUID && !t && !e)
    return Dm.randomUUID();
  e = e || {};
  const n = e.random || (e.rng || y4)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    r = r || 0;
    for (let i = 0; i < 16; ++i)
      t[r + i] = n[i];
    return t;
  }
  return g4(n);
}
function kt(e) {
  return typeof e == "function";
}
function b4(e) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, r = e(t);
  return r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r;
}
var $f = b4(function(e) {
  return function(r) {
    e(this), this.message = r ? r.length + ` errors occurred during unsubscription:
` + r.map(function(n, i) {
      return i + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = r;
  };
});
function Fm(e, t) {
  if (e) {
    var r = e.indexOf(t);
    0 <= r && e.splice(r, 1);
  }
}
var sh = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, r, n, i, a;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var s = ud(o), u = s.next(); !u.done; u = s.next()) {
              var l = u.value;
              l.remove(this);
            }
          } catch (v) {
            t = { error: v };
          } finally {
            try {
              u && !u.done && (r = s.return) && r.call(s);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          o.remove(this);
      var c = this.initialTeardown;
      if (kt(c))
        try {
          c();
        } catch (v) {
          a = v instanceof $f ? v.errors : [v];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var d = ud(f), h = d.next(); !h.done; h = d.next()) {
            var p = h.value;
            try {
              Im(p);
            } catch (v) {
              a = a ?? [], v instanceof $f ? a = Su(Su([], _u(a)), _u(v.errors)) : a.push(v);
            }
          }
        } catch (v) {
          n = { error: v };
        } finally {
          try {
            h && !h.done && (i = d.return) && i.call(d);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      if (a)
        throw new $f(a);
    }
  }, e.prototype.add = function(t) {
    var r;
    if (t && t !== this)
      if (this.closed)
        Im(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (r = this._finalizers) !== null && r !== void 0 ? r : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var r = this._parentage;
    return r === t || Array.isArray(r) && r.includes(t);
  }, e.prototype._addParent = function(t) {
    var r = this._parentage;
    this._parentage = Array.isArray(r) ? (r.push(t), r) : r ? [r, t] : t;
  }, e.prototype._removeParent = function(t) {
    var r = this._parentage;
    r === t ? this._parentage = null : Array.isArray(r) && Fm(r, t);
  }, e.prototype.remove = function(t) {
    var r = this._finalizers;
    r && Fm(r, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}();
sh.EMPTY;
function i1(e) {
  return e instanceof sh || e && "closed" in e && kt(e.remove) && kt(e.add) && kt(e.unsubscribe);
}
function Im(e) {
  kt(e) ? e() : e.unsubscribe();
}
var a1 = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, Ad = {
  setTimeout: function(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    var i = Ad.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, Su([e, t], _u(r))) : setTimeout.apply(void 0, Su([e, t], _u(r)));
  },
  clearTimeout: function(e) {
    var t = Ad.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function o1(e) {
  Ad.setTimeout(function() {
    throw e;
  });
}
function km() {
}
function E4(e) {
  e();
}
var uh = function(e) {
  D0(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n.isStopped = !1, r ? (n.destination = r, i1(r) && r.add(n)) : n.destination = T4, n;
  }
  return t.create = function(r, n, i) {
    return new Cd(r, n, i);
  }, t.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, t.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(r) {
    this.destination.next(r);
  }, t.prototype._error = function(r) {
    try {
      this.destination.error(r);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(sh), w4 = Function.prototype.bind;
function Rf(e, t) {
  return w4.call(e, t);
}
var S4 = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var r = this.partialObserver;
    if (r.next)
      try {
        r.next(t);
      } catch (n) {
        Ms(n);
      }
  }, e.prototype.error = function(t) {
    var r = this.partialObserver;
    if (r.error)
      try {
        r.error(t);
      } catch (n) {
        Ms(n);
      }
    else
      Ms(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (r) {
        Ms(r);
      }
  }, e;
}(), Cd = function(e) {
  D0(t, e);
  function t(r, n, i) {
    var a = e.call(this) || this, o;
    if (kt(r) || !r)
      o = {
        next: r ?? void 0,
        error: n ?? void 0,
        complete: i ?? void 0
      };
    else {
      var s;
      a && a1.useDeprecatedNextContext ? (s = Object.create(r), s.unsubscribe = function() {
        return a.unsubscribe();
      }, o = {
        next: r.next && Rf(r.next, s),
        error: r.error && Rf(r.error, s),
        complete: r.complete && Rf(r.complete, s)
      }) : o = r;
    }
    return a.destination = new S4(o), a;
  }
  return t;
}(uh);
function Ms(e) {
  o1(e);
}
function _4(e) {
  throw e;
}
var T4 = {
  closed: !0,
  next: km,
  error: _4,
  complete: km
}, lh = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function A4(e) {
  return e;
}
function C4(e) {
  return e.length === 0 ? A4 : e.length === 1 ? e[0] : function(r) {
    return e.reduce(function(n, i) {
      return i(n);
    }, r);
  };
}
var Xt = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var r = new e();
    return r.source = this, r.operator = t, r;
  }, e.prototype.subscribe = function(t, r, n) {
    var i = this, a = D4(t) ? t : new Cd(t, r, n);
    return E4(function() {
      var o = i, s = o.operator, u = o.source;
      a.add(s ? s.call(a, u) : u ? i._subscribe(a) : i._trySubscribe(a));
    }), a;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (r) {
      t.error(r);
    }
  }, e.prototype.forEach = function(t, r) {
    var n = this;
    return r = Nm(r), new r(function(i, a) {
      var o = new Cd({
        next: function(s) {
          try {
            t(s);
          } catch (u) {
            a(u), o.unsubscribe();
          }
        },
        error: a,
        complete: i
      });
      n.subscribe(o);
    });
  }, e.prototype._subscribe = function(t) {
    var r;
    return (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t);
  }, e.prototype[lh] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return C4(t)(this);
  }, e.prototype.toPromise = function(t) {
    var r = this;
    return t = Nm(t), new t(function(n, i) {
      var a;
      r.subscribe(function(o) {
        return a = o;
      }, function(o) {
        return i(o);
      }, function() {
        return n(a);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Nm(e) {
  var t;
  return (t = e ?? a1.Promise) !== null && t !== void 0 ? t : Promise;
}
function O4(e) {
  return e && kt(e.next) && kt(e.error) && kt(e.complete);
}
function D4(e) {
  return e && e instanceof uh || O4(e) && i1(e);
}
function F4(e) {
  return kt(e == null ? void 0 : e.lift);
}
function cs(e) {
  return function(t) {
    if (F4(t))
      return t.lift(function(r) {
        try {
          return e(r, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function jl(e, t, r, n, i) {
  return new I4(e, t, r, n, i);
}
var I4 = function(e) {
  D0(t, e);
  function t(r, n, i, a, o, s) {
    var u = e.call(this, r) || this;
    return u.onFinalize = o, u.shouldUnsubscribe = s, u._next = n ? function(l) {
      try {
        n(l);
      } catch (c) {
        r.error(c);
      }
    } : e.prototype._next, u._error = a ? function(l) {
      try {
        a(l);
      } catch (c) {
        r.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, u._complete = i ? function() {
      try {
        i();
      } catch (l) {
        r.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, u;
  }
  return t.prototype.unsubscribe = function() {
    var r;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      e.prototype.unsubscribe.call(this), !n && ((r = this.onFinalize) === null || r === void 0 || r.call(this));
    }
  }, t;
}(uh), s1 = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function u1(e) {
  return kt(e == null ? void 0 : e.then);
}
function l1(e) {
  return kt(e[lh]);
}
function c1(e) {
  return Symbol.asyncIterator && kt(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function f1(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function k4() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var d1 = k4();
function h1(e) {
  return kt(e == null ? void 0 : e[d1]);
}
function p1(e) {
  return J_(this, arguments, function() {
    var r, n, i, a;
    return _x(this, function(o) {
      switch (o.label) {
        case 0:
          r = e.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, Nc(r.read())];
        case 3:
          return n = o.sent(), i = n.value, a = n.done, a ? [4, Nc(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, Nc(i)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return r.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function v1(e) {
  return kt(e == null ? void 0 : e.getReader);
}
function Ll(e) {
  if (e instanceof Xt)
    return e;
  if (e != null) {
    if (l1(e))
      return N4(e);
    if (s1(e))
      return P4(e);
    if (u1(e))
      return $4(e);
    if (c1(e))
      return m1(e);
    if (h1(e))
      return R4(e);
    if (v1(e))
      return M4(e);
  }
  throw f1(e);
}
function N4(e) {
  return new Xt(function(t) {
    var r = e[lh]();
    if (kt(r.subscribe))
      return r.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function P4(e) {
  return new Xt(function(t) {
    for (var r = 0; r < e.length && !t.closed; r++)
      t.next(e[r]);
    t.complete();
  });
}
function $4(e) {
  return new Xt(function(t) {
    e.then(function(r) {
      t.closed || (t.next(r), t.complete());
    }, function(r) {
      return t.error(r);
    }).then(null, o1);
  });
}
function R4(e) {
  return new Xt(function(t) {
    var r, n;
    try {
      for (var i = ud(e), a = i.next(); !a.done; a = i.next()) {
        var o = a.value;
        if (t.next(o), t.closed)
          return;
      }
    } catch (s) {
      r = { error: s };
    } finally {
      try {
        a && !a.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
    t.complete();
  });
}
function m1(e) {
  return new Xt(function(t) {
    B4(e, t).catch(function(r) {
      return t.error(r);
    });
  });
}
function M4(e) {
  return m1(p1(e));
}
function B4(e, t) {
  var r, n, i, a;
  return Z_(this, void 0, void 0, function() {
    var o, s;
    return _x(this, function(u) {
      switch (u.label) {
        case 0:
          u.trys.push([0, 5, 6, 11]), r = eT(e), u.label = 1;
        case 1:
          return [4, r.next()];
        case 2:
          if (n = u.sent(), !!n.done)
            return [3, 4];
          if (o = n.value, t.next(o), t.closed)
            return [2];
          u.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return s = u.sent(), i = { error: s }, [3, 11];
        case 6:
          return u.trys.push([6, , 9, 10]), n && !n.done && (a = r.return) ? [4, a.call(r)] : [3, 8];
        case 7:
          u.sent(), u.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Di(e, t, r, n, i) {
  n === void 0 && (n = 0), i === void 0 && (i = !1);
  var a = t.schedule(function() {
    r(), i ? e.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (e.add(a), !i)
    return a;
}
function y1(e, t) {
  return t === void 0 && (t = 0), cs(function(r, n) {
    r.subscribe(jl(n, function(i) {
      return Di(n, e, function() {
        return n.next(i);
      }, t);
    }, function() {
      return Di(n, e, function() {
        return n.complete();
      }, t);
    }, function(i) {
      return Di(n, e, function() {
        return n.error(i);
      }, t);
    }));
  });
}
function g1(e, t) {
  return t === void 0 && (t = 0), cs(function(r, n) {
    n.add(e.schedule(function() {
      return r.subscribe(n);
    }, t));
  });
}
function j4(e, t) {
  return Ll(e).pipe(g1(t), y1(t));
}
function L4(e, t) {
  return Ll(e).pipe(g1(t), y1(t));
}
function U4(e, t) {
  return new Xt(function(r) {
    var n = 0;
    return t.schedule(function() {
      n === e.length ? r.complete() : (r.next(e[n++]), r.closed || this.schedule());
    });
  });
}
function H4(e, t) {
  return new Xt(function(r) {
    var n;
    return Di(r, t, function() {
      n = e[d1](), Di(r, t, function() {
        var i, a, o;
        try {
          i = n.next(), a = i.value, o = i.done;
        } catch (s) {
          r.error(s);
          return;
        }
        o ? r.complete() : r.next(a);
      }, 0, !0);
    }), function() {
      return kt(n == null ? void 0 : n.return) && n.return();
    };
  });
}
function x1(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new Xt(function(r) {
    Di(r, t, function() {
      var n = e[Symbol.asyncIterator]();
      Di(r, t, function() {
        n.next().then(function(i) {
          i.done ? r.complete() : r.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function W4(e, t) {
  return x1(p1(e), t);
}
function z4(e, t) {
  if (e != null) {
    if (l1(e))
      return j4(e, t);
    if (s1(e))
      return U4(e, t);
    if (u1(e))
      return L4(e, t);
    if (c1(e))
      return x1(e, t);
    if (h1(e))
      return H4(e, t);
    if (v1(e))
      return W4(e, t);
  }
  throw f1(e);
}
function q4(e, t) {
  return t ? z4(e, t) : Ll(e);
}
function ch(e, t) {
  return cs(function(r, n) {
    var i = 0;
    r.subscribe(jl(n, function(a) {
      n.next(e.call(t, a, i++));
    }));
  });
}
function Y4(e, t) {
  return cs(function(r, n) {
    var i = 0;
    r.subscribe(jl(n, function(a) {
      return e.call(t, a, i++) && n.next(a);
    }));
  });
}
function b1(e) {
  return cs(function(t, r) {
    var n = null, i = !1, a;
    n = t.subscribe(jl(r, void 0, void 0, function(o) {
      a = Ll(e(o, b1(e)(t))), n ? (n.unsubscribe(), n = null, a.subscribe(r)) : i = !0;
    })), i && (n.unsubscribe(), n = null, a.subscribe(r));
  });
}
const V4 = () => {
  if (typeof self > "u")
    return !1;
  const e = self;
  return typeof e.WorkerGlobalScope < "u" && self instanceof e.WorkerGlobalScope;
};
class ha {
  networkMonitor(t) {
    const r = V4() ? self : typeof window < "u" && window;
    return r ? new Xt((n) => {
      n.next({ online: r.navigator.onLine });
      const i = () => {
        n.next({ online: !0 });
      }, a = () => {
        n.next({ online: !1 });
      };
      return r.addEventListener("online", i), r.addEventListener("offline", a), ha._observers.push(n), () => {
        r.removeEventListener("online", i), r.removeEventListener("offline", a), ha._observers = ha._observers.filter((o) => o !== n);
      };
    }) : q4([{ online: !0 }]);
  }
  // expose observers to simulate offline mode for integration testing
  static _observerOverride(t) {
    for (const r of this._observers) {
      if (r.closed) {
        this._observers = this._observers.filter((n) => n !== r);
        continue;
      }
      r != null && r.next && r.next(t);
    }
  }
}
ha._observers = [];
const Od = (e) => tT(Ia, e), G4 = n1, E1 = (e) => Object.keys(e).map((t) => t.toLowerCase()).sort().join(";"), K4 = "X-Amz-Date", Q4 = "X-Amz-Security-Token", X4 = "authorization", J4 = "host", Z4 = K4.toLowerCase(), e8 = Q4.toLowerCase(), w1 = "aws4_request", S1 = "AWS4-HMAC-SHA256", t8 = "AWS4", r8 = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855", n8 = "UNSIGNED-PAYLOAD", i8 = (e, t, r) => `${e}/${t}/${r}/${w1}`, a8 = (e) => {
  const t = e.toISOString().replace(/[:-]|\.\d{3}/g, "");
  return {
    longDate: t,
    shortDate: t.slice(0, 8)
  };
}, o8 = ({ credentials: e, signingDate: t = /* @__PURE__ */ new Date(), signingRegion: r, signingService: n, uriEscapePath: i = !0 }) => {
  const { accessKeyId: a, secretAccessKey: o, sessionToken: s } = e, { longDate: u, shortDate: l } = a8(t), c = i8(l, r, n);
  return {
    accessKeyId: a,
    credentialScope: c,
    longDate: u,
    secretAccessKey: o,
    sessionToken: s,
    shortDate: l,
    signingRegion: r,
    signingService: n,
    uriEscapePath: i
  };
}, yo = (e, t) => {
  const r = new nT(e ?? void 0);
  return r.update(t), r.digestSync();
}, Dd = (e, t) => {
  const r = yo(e, t);
  return rT(r);
}, s8 = (e) => Object.entries(e).map(([t, r]) => ({
  key: t.toLowerCase(),
  value: (r == null ? void 0 : r.trim().replace(/\s+/g, " ")) ?? ""
})).sort((t, r) => t.key < r.key ? -1 : 1).map((t) => `${t.key}:${t.value}
`).join(""), u8 = (e) => Array.from(e).sort(([t, r], [n, i]) => t === n ? r < i ? -1 : 1 : t < n ? -1 : 1).map(([t, r]) => `${Pm(t)}=${Pm(r)}`).join("&"), Pm = (e) => encodeURIComponent(e).replace(/[!'()*]/g, l8), l8 = (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`, c8 = (e, t = !0) => e ? t ? encodeURIComponent(e).replace(/%2F/g, "/") : e : "/", f8 = (e) => e == null ? r8 : d8(e) ? Dd(null, e) : n8, d8 = (e) => typeof e == "string" || ArrayBuffer.isView(e) || h8(e), h8 = (e) => typeof ArrayBuffer == "function" && e instanceof ArrayBuffer || Object.prototype.toString.call(e) === "[object ArrayBuffer]", p8 = ({ body: e, headers: t, method: r, url: n }, i = !0) => [
  r,
  c8(n.pathname, i),
  u8(n.searchParams),
  s8(t),
  E1(t),
  f8(e)
].join(`
`), v8 = (e, t, r, n) => {
  const i = `${t8}${e}`, a = yo(i, t), o = yo(a, r), s = yo(o, n);
  return yo(s, w1);
}, m8 = (e, t, r) => [S1, e, t, r].join(`
`), y8 = (e, { credentialScope: t, longDate: r, secretAccessKey: n, shortDate: i, signingRegion: a, signingService: o, uriEscapePath: s }) => {
  const u = p8(e, s), l = Dd(null, u), c = m8(r, t, l);
  return Dd(v8(n, i, a, o), c);
}, _1 = (e, t) => {
  const r = o8(t), { accessKeyId: n, credentialScope: i, longDate: a, sessionToken: o } = r, s = { ...e.headers };
  s[J4] = e.url.host, s[Z4] = a, o && (s[e8] = o);
  const u = { ...e, headers: s }, l = y8(u, r), c = `Credential=${n}/${i}`, f = `SignedHeaders=${E1(s)}`, d = `Signature=${l}`;
  return s[X4] = `${S1} ${c}, ${f}, ${d}`, u;
}, T1 = (e) => new Date(Date.now() + e), g8 = 5 * 60 * 1e3, x8 = (e, t) => Math.abs(T1(t).getTime() - e) >= g8, b8 = (e, t) => x8(e, t) ? e - Date.now() : t, E8 = ({ credentials: e, region: t, service: r, uriEscapePath: n = !0 }) => {
  let i;
  return (a) => async function(s) {
    i = i ?? 0;
    const u = {
      credentials: typeof e == "function" ? await e() : e,
      signingDate: T1(i),
      signingRegion: t,
      signingService: r,
      uriEscapePath: n
    }, l = await _1(s, u), c = await a(l), f = w8(c);
    return f && (i = b8(Date.parse(f), i)), c;
  };
}, w8 = ({ headers: e } = {}) => (e == null ? void 0 : e.date) ?? (e == null ? void 0 : e.Date) ?? (e == null ? void 0 : e["x-amz-date"]), S8 = iT(sT, [
  aT,
  oT,
  E8
]);
class _8 extends Error {
  constructor() {
    super(...arguments), this.nonRetryable = !0;
  }
}
const T8 = (e, t, r = uT, n) => v4(e, t, lT(r), n);
class Nu extends Tx {
  /**
   * The unwrapped HTTP response causing the given API error.
   */
  get response() {
    return this._response ? A8(this._response) : void 0;
  }
  constructor(t) {
    super(t), this.constructor = Nu, Object.setPrototypeOf(this, Nu.prototype), t.response && (this._response = t.response);
  }
}
const A8 = (e) => ({
  ...e,
  headers: { ...e.headers }
});
function Zn(e, t) {
  const { message: r, recoverySuggestion: n } = fT[t];
  if (!e)
    throw new cT({ name: t, message: r, recoverySuggestion: n });
}
async function C8(e) {
  var s;
  const t = (s = Ia.getConfig().Auth) == null ? void 0 : s.Cognito;
  fl(t);
  const { username: r, password: n, options: i } = e, a = {
    loginId: r,
    authFlowType: "CUSTOM_WITHOUT_SRP"
  }, o = i == null ? void 0 : i.clientMetadata;
  Zn(!!r, Kn.EmptySignInUsername), Zn(!n, Kn.CustomAuthSignInPassword);
  try {
    const { ChallengeName: u, ChallengeParameters: l, AuthenticationResult: c, Session: f } = await Ax(dT, [r, o, t, Ea], r, Ea), d = dl(r);
    return hl({
      signInSession: f,
      username: d,
      challengeName: u,
      signInDetails: a
    }), c ? (Qn(), await pl({
      username: d,
      ...c,
      NewDeviceMetadata: await vl(t.userPoolId, c.NewDeviceMetadata, c.AccessToken),
      signInDetails: a
    }), await ml(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : yl({
      challengeName: u,
      challengeParameters: l
    });
  } catch (u) {
    Qn(), gl(u);
    const l = xl(u.name);
    if (l)
      return l;
    throw u;
  }
}
async function O8(e) {
  var s;
  const { username: t, password: r, options: n } = e, i = {
    loginId: t,
    authFlowType: "CUSTOM_WITH_SRP"
  }, a = (s = Ia.getConfig().Auth) == null ? void 0 : s.Cognito;
  fl(a);
  const o = n == null ? void 0 : n.clientMetadata;
  Zn(!!t, Kn.EmptySignInUsername), Zn(!!r, Kn.EmptySignInPassword);
  try {
    const { ChallengeName: u, ChallengeParameters: l, AuthenticationResult: c, Session: f } = await hT(t, r, o, a, Ea), d = dl(t);
    return hl({
      signInSession: f,
      username: d,
      challengeName: u,
      signInDetails: i
    }), c ? (await pl({
      username: d,
      ...c,
      NewDeviceMetadata: await vl(a.userPoolId, c.NewDeviceMetadata, c.AccessToken),
      signInDetails: i
    }), Qn(), await ml(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : yl({
      challengeName: u,
      challengeParameters: l
    });
  } catch (u) {
    Qn(), gl(u);
    const l = xl(u.name);
    if (l)
      return l;
    throw u;
  }
}
async function $m(e) {
  var o, s;
  const { username: t, password: r } = e, n = (o = Ia.getConfig().Auth) == null ? void 0 : o.Cognito, i = {
    loginId: t,
    authFlowType: "USER_SRP_AUTH"
  };
  fl(n);
  const a = (s = e.options) == null ? void 0 : s.clientMetadata;
  Zn(!!t, Kn.EmptySignInUsername), Zn(!!r, Kn.EmptySignInPassword);
  try {
    const { ChallengeName: u, ChallengeParameters: l, AuthenticationResult: c, Session: f } = await pT(t, r, a, n, Ea), d = dl(t);
    return hl({
      signInSession: f,
      username: d,
      challengeName: u,
      signInDetails: i
    }), c ? (Qn(), await pl({
      username: d,
      ...c,
      NewDeviceMetadata: await vl(n.userPoolId, c.NewDeviceMetadata, c.AccessToken),
      signInDetails: i
    }), await ml(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : yl({
      challengeName: u,
      challengeParameters: l
    });
  } catch (u) {
    Qn(), gl(u);
    const l = xl(u.name);
    if (l)
      return l;
    throw u;
  }
}
async function D8(e) {
  var s;
  const { username: t, password: r, options: n } = e, i = (s = Ia.getConfig().Auth) == null ? void 0 : s.Cognito, a = {
    loginId: t,
    authFlowType: "USER_PASSWORD_AUTH"
  };
  fl(i);
  const o = n == null ? void 0 : n.clientMetadata;
  Zn(!!t, Kn.EmptySignInUsername), Zn(!!r, Kn.EmptySignInPassword);
  try {
    const { ChallengeName: u, ChallengeParameters: l, AuthenticationResult: c, Session: f } = await Ax(vT, [t, r, o, i, Ea], t, Ea), d = dl(t);
    return hl({
      signInSession: f,
      username: d,
      challengeName: u,
      signInDetails: a
    }), c ? (await pl({
      ...c,
      username: d,
      NewDeviceMetadata: await vl(i.userPoolId, c.NewDeviceMetadata, c.AccessToken),
      signInDetails: a
    }), Qn(), await ml(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : yl({
      challengeName: u,
      challengeParameters: l
    });
  } catch (u) {
    Qn(), gl(u);
    const l = xl(u.name);
    if (l)
      return l;
    throw u;
  }
}
async function F8(e) {
  var r;
  const t = (r = e.options) == null ? void 0 : r.authFlowType;
  switch (await mT(), t) {
    case "USER_SRP_AUTH":
      return $m(e);
    case "USER_PASSWORD_AUTH":
      return D8(e);
    case "CUSTOM_WITHOUT_SRP":
      return C8(e);
    case "CUSTOM_WITH_SRP":
      return O8(e);
    default:
      return $m(e);
  }
}
const I8 = (e, t, r) => {
  const n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + r * 60 * 60 * 1e3);
  const i = "expires=" + n.toUTCString();
  document.cookie = `${e}=${t};${i};path=/`;
}, k8 = (e) => {
  const t = e + "=", r = document.cookie.split(";");
  for (let n = 0; n < r.length; n++) {
    let i = r[n];
    for (; i.charAt(0) === " "; )
      i = i.substring(1, i.length);
    if (i.indexOf(t) === 0)
      return i.substring(t.length, i.length);
  }
  return null;
}, N8 = (e) => {
  document.cookie = `${e}=; Max-Age=-99999999;`;
};
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var A1;
function re() {
  return A1.apply(null, arguments);
}
function P8(e) {
  A1 = e;
}
function Pr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Fi(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function je(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function fh(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (je(e, t))
      return !1;
  return !0;
}
function Gt(e) {
  return e === void 0;
}
function _n(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function fs(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function C1(e, t) {
  var r = [], n, i = e.length;
  for (n = 0; n < i; ++n)
    r.push(t(e[n], n));
  return r;
}
function Un(e, t) {
  for (var r in t)
    je(t, r) && (e[r] = t[r]);
  return je(t, "toString") && (e.toString = t.toString), je(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function un(e, t, r, n) {
  return X1(e, t, r, n, !0).utc();
}
function $8() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Te(e) {
  return e._pf == null && (e._pf = $8()), e._pf;
}
var Fd;
Array.prototype.some ? Fd = Array.prototype.some : Fd = function(e) {
  var t = Object(this), r = t.length >>> 0, n;
  for (n = 0; n < r; n++)
    if (n in t && e.call(this, t[n], n, t))
      return !0;
  return !1;
};
function dh(e) {
  if (e._isValid == null) {
    var t = Te(e), r = Fd.call(t.parsedDateParts, function(i) {
      return i != null;
    }), n = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r);
    if (e._strict && (n = n && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = n;
    else
      return n;
  }
  return e._isValid;
}
function Ul(e) {
  var t = un(NaN);
  return e != null ? Un(Te(t), e) : Te(t).userInvalidated = !0, t;
}
var Rm = re.momentProperties = [], Mf = !1;
function hh(e, t) {
  var r, n, i, a = Rm.length;
  if (Gt(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Gt(t._i) || (e._i = t._i), Gt(t._f) || (e._f = t._f), Gt(t._l) || (e._l = t._l), Gt(t._strict) || (e._strict = t._strict), Gt(t._tzm) || (e._tzm = t._tzm), Gt(t._isUTC) || (e._isUTC = t._isUTC), Gt(t._offset) || (e._offset = t._offset), Gt(t._pf) || (e._pf = Te(t)), Gt(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      n = Rm[r], i = t[n], Gt(i) || (e[n] = i);
  return e;
}
function ds(e) {
  hh(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Mf === !1 && (Mf = !0, re.updateOffset(this), Mf = !1);
}
function $r(e) {
  return e instanceof ds || e != null && e._isAMomentObject != null;
}
function O1(e) {
  re.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function mr(e, t) {
  var r = !0;
  return Un(function() {
    if (re.deprecationHandler != null && re.deprecationHandler(null, e), r) {
      var n = [], i, a, o, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (i = "", typeof arguments[a] == "object") {
          i += `
[` + a + "] ";
          for (o in arguments[0])
            je(arguments[0], o) && (i += o + ": " + arguments[0][o] + ", ");
          i = i.slice(0, -2);
        } else
          i = arguments[a];
        n.push(i);
      }
      O1(
        e + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Mm = {};
function D1(e, t) {
  re.deprecationHandler != null && re.deprecationHandler(e, t), Mm[e] || (O1(t), Mm[e] = !0);
}
re.suppressDeprecationWarnings = !1;
re.deprecationHandler = null;
function ln(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function R8(e) {
  var t, r;
  for (r in e)
    je(e, r) && (t = e[r], ln(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Id(e, t) {
  var r = Un({}, e), n;
  for (n in t)
    je(t, n) && (Fi(e[n]) && Fi(t[n]) ? (r[n] = {}, Un(r[n], e[n]), Un(r[n], t[n])) : t[n] != null ? r[n] = t[n] : delete r[n]);
  for (n in e)
    je(e, n) && !je(t, n) && Fi(e[n]) && (r[n] = Un({}, r[n]));
  return r;
}
function ph(e) {
  e != null && this.set(e);
}
var kd;
Object.keys ? kd = Object.keys : kd = function(e) {
  var t, r = [];
  for (t in e)
    je(e, t) && r.push(t);
  return r;
};
var M8 = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function B8(e, t, r) {
  var n = this._calendar[e] || this._calendar.sameElse;
  return ln(n) ? n.call(t, r) : n;
}
function an(e, t, r) {
  var n = "" + Math.abs(e), i = t - n.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + n;
}
var vh = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Bs = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Bf = {}, pa = {};
function ve(e, t, r, n) {
  var i = n;
  typeof n == "string" && (i = function() {
    return this[n]();
  }), e && (pa[e] = i), t && (pa[t[0]] = function() {
    return an(i.apply(this, arguments), t[1], t[2]);
  }), r && (pa[r] = function() {
    return this.localeData().ordinal(
      i.apply(this, arguments),
      e
    );
  });
}
function j8(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function L8(e) {
  var t = e.match(vh), r, n;
  for (r = 0, n = t.length; r < n; r++)
    pa[t[r]] ? t[r] = pa[t[r]] : t[r] = j8(t[r]);
  return function(i) {
    var a = "", o;
    for (o = 0; o < n; o++)
      a += ln(t[o]) ? t[o].call(i, e) : t[o];
    return a;
  };
}
function iu(e, t) {
  return e.isValid() ? (t = F1(t, e.localeData()), Bf[t] = Bf[t] || L8(t), Bf[t](e)) : e.localeData().invalidDate();
}
function F1(e, t) {
  var r = 5;
  function n(i) {
    return t.longDateFormat(i) || i;
  }
  for (Bs.lastIndex = 0; r >= 0 && Bs.test(e); )
    e = e.replace(
      Bs,
      n
    ), Bs.lastIndex = 0, r -= 1;
  return e;
}
var U8 = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function H8(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(vh).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[e]);
}
var W8 = "Invalid date";
function z8() {
  return this._invalidDate;
}
var q8 = "%d", Y8 = /\d{1,2}/;
function V8(e) {
  return this._ordinal.replace("%d", e);
}
var G8 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function K8(e, t, r, n) {
  var i = this._relativeTime[r];
  return ln(i) ? i(e, t, r, n) : i.replace(/%d/i, e);
}
function Q8(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return ln(r) ? r(t) : r.replace(/%s/i, t);
}
var _o = {};
function Lt(e, t) {
  var r = e.toLowerCase();
  _o[r] = _o[r + "s"] = _o[t] = e;
}
function yr(e) {
  return typeof e == "string" ? _o[e] || _o[e.toLowerCase()] : void 0;
}
function mh(e) {
  var t = {}, r, n;
  for (n in e)
    je(e, n) && (r = yr(n), r && (t[r] = e[n]));
  return t;
}
var I1 = {};
function Ut(e, t) {
  I1[e] = t;
}
function X8(e) {
  var t = [], r;
  for (r in e)
    je(e, r) && t.push({ unit: r, priority: I1[r] });
  return t.sort(function(n, i) {
    return n.priority - i.priority;
  }), t;
}
function Hl(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function hr(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function Ie(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = hr(t)), r;
}
function Ba(e, t) {
  return function(r) {
    return r != null ? (k1(this, e, r), re.updateOffset(this, t), this) : Pu(this, e);
  };
}
function Pu(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function k1(e, t, r) {
  e.isValid() && !isNaN(r) && (t === "FullYear" && Hl(e.year()) && e.month() === 1 && e.date() === 29 ? (r = Ie(r), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    r,
    e.month(),
    Gl(r, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](r));
}
function J8(e) {
  return e = yr(e), ln(this[e]) ? this[e]() : this;
}
function Z8(e, t) {
  if (typeof e == "object") {
    e = mh(e);
    var r = X8(e), n, i = r.length;
    for (n = 0; n < i; n++)
      this[r[n].unit](e[r[n].unit]);
  } else if (e = yr(e), ln(this[e]))
    return this[e](t);
  return this;
}
var N1 = /\d/, cr = /\d\d/, P1 = /\d{3}/, yh = /\d{4}/, Wl = /[+-]?\d{6}/, lt = /\d\d?/, $1 = /\d\d\d\d?/, R1 = /\d\d\d\d\d\d?/, zl = /\d{1,3}/, gh = /\d{1,4}/, ql = /[+-]?\d{1,6}/, ja = /\d+/, Yl = /[+-]?\d+/, ek = /Z|[+-]\d\d:?\d\d/gi, Vl = /Z|[+-]\d\d(?::?\d\d)?/gi, tk = /[+-]?\d+(\.\d{1,3})?/, hs = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, $u;
$u = {};
function ae(e, t, r) {
  $u[e] = ln(t) ? t : function(n, i) {
    return n && r ? r : t;
  };
}
function rk(e, t) {
  return je($u, e) ? $u[e](t._strict, t._locale) : new RegExp(nk(e));
}
function nk(e) {
  return ir(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, n, i, a) {
        return r || n || i || a;
      }
    )
  );
}
function ir(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Nd = {};
function Je(e, t) {
  var r, n = t, i;
  for (typeof e == "string" && (e = [e]), _n(t) && (n = function(a, o) {
    o[t] = Ie(a);
  }), i = e.length, r = 0; r < i; r++)
    Nd[e[r]] = n;
}
function ps(e, t) {
  Je(e, function(r, n, i, a) {
    i._w = i._w || {}, t(r, i._w, i, a);
  });
}
function ik(e, t, r) {
  t != null && je(Nd, e) && Nd[e](t, r._a, r, e);
}
var Bt = 0, gn = 1, Jr = 2, Tt = 3, Fr = 4, xn = 5, Ti = 6, ak = 7, ok = 8;
function sk(e, t) {
  return (e % t + t) % t;
}
var gt;
Array.prototype.indexOf ? gt = Array.prototype.indexOf : gt = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Gl(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = sk(t, 12);
  return e += (t - r) / 12, r === 1 ? Hl(e) ? 29 : 28 : 31 - r % 7 % 2;
}
ve("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
ve("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
ve("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Lt("month", "M");
Ut("month", 8);
ae("M", lt);
ae("MM", lt, cr);
ae("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
ae("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
Je(["M", "MM"], function(e, t) {
  t[gn] = Ie(e) - 1;
});
Je(["MMM", "MMMM"], function(e, t, r, n) {
  var i = r._locale.monthsParse(e, n, r._strict);
  i != null ? t[gn] = i : Te(r).invalidMonth = e;
});
var uk = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), M1 = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), B1 = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, lk = hs, ck = hs;
function fk(e, t) {
  return e ? Pr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || B1).test(t) ? "format" : "standalone"][e.month()] : Pr(this._months) ? this._months : this._months.standalone;
}
function dk(e, t) {
  return e ? Pr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[B1.test(t) ? "format" : "standalone"][e.month()] : Pr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function hk(e, t, r) {
  var n, i, a, o = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      a = un([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (i = gt.call(this._shortMonthsParse, o), i !== -1 ? i : null) : (i = gt.call(this._longMonthsParse, o), i !== -1 ? i : null) : t === "MMM" ? (i = gt.call(this._shortMonthsParse, o), i !== -1 ? i : (i = gt.call(this._longMonthsParse, o), i !== -1 ? i : null)) : (i = gt.call(this._longMonthsParse, o), i !== -1 ? i : (i = gt.call(this._shortMonthsParse, o), i !== -1 ? i : null));
}
function pk(e, t, r) {
  var n, i, a;
  if (this._monthsParseExact)
    return hk.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (i = un([2e3, n]), r && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(i, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(i, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[n] && (a = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[n] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[n].test(e))
      return n;
    if (r && t === "MMM" && this._shortMonthsParse[n].test(e))
      return n;
    if (!r && this._monthsParse[n].test(e))
      return n;
  }
}
function j1(e, t) {
  var r;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = Ie(t);
    else if (t = e.localeData().monthsParse(t), !_n(t))
      return e;
  }
  return r = Math.min(e.date(), Gl(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, r), e;
}
function L1(e) {
  return e != null ? (j1(this, e), re.updateOffset(this, !0), this) : Pu(this, "Month");
}
function vk() {
  return Gl(this.year(), this.month());
}
function mk(e) {
  return this._monthsParseExact ? (je(this, "_monthsRegex") || U1.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (je(this, "_monthsShortRegex") || (this._monthsShortRegex = lk), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function yk(e) {
  return this._monthsParseExact ? (je(this, "_monthsRegex") || U1.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (je(this, "_monthsRegex") || (this._monthsRegex = ck), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function U1() {
  function e(o, s) {
    return s.length - o.length;
  }
  var t = [], r = [], n = [], i, a;
  for (i = 0; i < 12; i++)
    a = un([2e3, i]), t.push(this.monthsShort(a, "")), r.push(this.months(a, "")), n.push(this.months(a, "")), n.push(this.monthsShort(a, ""));
  for (t.sort(e), r.sort(e), n.sort(e), i = 0; i < 12; i++)
    t[i] = ir(t[i]), r[i] = ir(r[i]);
  for (i = 0; i < 24; i++)
    n[i] = ir(n[i]);
  this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
ve("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? an(e, 4) : "+" + e;
});
ve(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
ve(0, ["YYYY", 4], 0, "year");
ve(0, ["YYYYY", 5], 0, "year");
ve(0, ["YYYYYY", 6, !0], 0, "year");
Lt("year", "y");
Ut("year", 1);
ae("Y", Yl);
ae("YY", lt, cr);
ae("YYYY", gh, yh);
ae("YYYYY", ql, Wl);
ae("YYYYYY", ql, Wl);
Je(["YYYYY", "YYYYYY"], Bt);
Je("YYYY", function(e, t) {
  t[Bt] = e.length === 2 ? re.parseTwoDigitYear(e) : Ie(e);
});
Je("YY", function(e, t) {
  t[Bt] = re.parseTwoDigitYear(e);
});
Je("Y", function(e, t) {
  t[Bt] = parseInt(e, 10);
});
function To(e) {
  return Hl(e) ? 366 : 365;
}
re.parseTwoDigitYear = function(e) {
  return Ie(e) + (Ie(e) > 68 ? 1900 : 2e3);
};
var H1 = Ba("FullYear", !0);
function gk() {
  return Hl(this.year());
}
function xk(e, t, r, n, i, a, o) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, n, i, a, o), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, n, i, a, o), s;
}
function Bo(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Ru(e, t, r) {
  var n = 7 + t - r, i = (7 + Bo(e, 0, n).getUTCDay() - t) % 7;
  return -i + n - 1;
}
function W1(e, t, r, n, i) {
  var a = (7 + r - n) % 7, o = Ru(e, n, i), s = 1 + 7 * (t - 1) + a + o, u, l;
  return s <= 0 ? (u = e - 1, l = To(u) + s) : s > To(e) ? (u = e + 1, l = s - To(e)) : (u = e, l = s), {
    year: u,
    dayOfYear: l
  };
}
function jo(e, t, r) {
  var n = Ru(e.year(), t, r), i = Math.floor((e.dayOfYear() - n - 1) / 7) + 1, a, o;
  return i < 1 ? (o = e.year() - 1, a = i + wn(o, t, r)) : i > wn(e.year(), t, r) ? (a = i - wn(e.year(), t, r), o = e.year() + 1) : (o = e.year(), a = i), {
    week: a,
    year: o
  };
}
function wn(e, t, r) {
  var n = Ru(e, t, r), i = Ru(e + 1, t, r);
  return (To(e) - n + i) / 7;
}
ve("w", ["ww", 2], "wo", "week");
ve("W", ["WW", 2], "Wo", "isoWeek");
Lt("week", "w");
Lt("isoWeek", "W");
Ut("week", 5);
Ut("isoWeek", 5);
ae("w", lt);
ae("ww", lt, cr);
ae("W", lt);
ae("WW", lt, cr);
ps(
  ["w", "ww", "W", "WW"],
  function(e, t, r, n) {
    t[n.substr(0, 1)] = Ie(e);
  }
);
function bk(e) {
  return jo(e, this._week.dow, this._week.doy).week;
}
var Ek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function wk() {
  return this._week.dow;
}
function Sk() {
  return this._week.doy;
}
function _k(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Tk(e) {
  var t = jo(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
ve("d", 0, "do", "day");
ve("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
ve("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
ve("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
ve("e", 0, 0, "weekday");
ve("E", 0, 0, "isoWeekday");
Lt("day", "d");
Lt("weekday", "e");
Lt("isoWeekday", "E");
Ut("day", 11);
Ut("weekday", 11);
Ut("isoWeekday", 11);
ae("d", lt);
ae("e", lt);
ae("E", lt);
ae("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
ae("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
ae("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
ps(["dd", "ddd", "dddd"], function(e, t, r, n) {
  var i = r._locale.weekdaysParse(e, n, r._strict);
  i != null ? t.d = i : Te(r).invalidWeekday = e;
});
ps(["d", "e", "E"], function(e, t, r, n) {
  t[n] = Ie(e);
});
function Ak(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Ck(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function xh(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Ok = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), z1 = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Dk = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Fk = hs, Ik = hs, kk = hs;
function Nk(e, t) {
  var r = Pr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? xh(r, this._week.dow) : e ? r[e.day()] : r;
}
function Pk(e) {
  return e === !0 ? xh(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function $k(e) {
  return e === !0 ? xh(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Rk(e, t, r) {
  var n, i, a, o = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      a = un([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (i = gt.call(this._weekdaysParse, o), i !== -1 ? i : null) : t === "ddd" ? (i = gt.call(this._shortWeekdaysParse, o), i !== -1 ? i : null) : (i = gt.call(this._minWeekdaysParse, o), i !== -1 ? i : null) : t === "dddd" ? (i = gt.call(this._weekdaysParse, o), i !== -1 || (i = gt.call(this._shortWeekdaysParse, o), i !== -1) ? i : (i = gt.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : t === "ddd" ? (i = gt.call(this._shortWeekdaysParse, o), i !== -1 || (i = gt.call(this._weekdaysParse, o), i !== -1) ? i : (i = gt.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : (i = gt.call(this._minWeekdaysParse, o), i !== -1 || (i = gt.call(this._weekdaysParse, o), i !== -1) ? i : (i = gt.call(this._shortWeekdaysParse, o), i !== -1 ? i : null));
}
function Mk(e, t, r) {
  var n, i, a;
  if (this._weekdaysParseExact)
    return Rk.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (i = un([2e3, 1]).day(n), r && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (a = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[n] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[n].test(e))
      return n;
    if (r && t === "ddd" && this._shortWeekdaysParse[n].test(e))
      return n;
    if (r && t === "dd" && this._minWeekdaysParse[n].test(e))
      return n;
    if (!r && this._weekdaysParse[n].test(e))
      return n;
  }
}
function Bk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Ak(e, this.localeData()), this.add(e - t, "d")) : t;
}
function jk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Lk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Ck(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Uk(e) {
  return this._weekdaysParseExact ? (je(this, "_weekdaysRegex") || bh.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (je(this, "_weekdaysRegex") || (this._weekdaysRegex = Fk), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Hk(e) {
  return this._weekdaysParseExact ? (je(this, "_weekdaysRegex") || bh.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (je(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ik), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Wk(e) {
  return this._weekdaysParseExact ? (je(this, "_weekdaysRegex") || bh.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (je(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = kk), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function bh() {
  function e(c, f) {
    return f.length - c.length;
  }
  var t = [], r = [], n = [], i = [], a, o, s, u, l;
  for (a = 0; a < 7; a++)
    o = un([2e3, 1]).day(a), s = ir(this.weekdaysMin(o, "")), u = ir(this.weekdaysShort(o, "")), l = ir(this.weekdays(o, "")), t.push(s), r.push(u), n.push(l), i.push(s), i.push(u), i.push(l);
  t.sort(e), r.sort(e), n.sort(e), i.sort(e), this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Eh() {
  return this.hours() % 12 || 12;
}
function zk() {
  return this.hours() || 24;
}
ve("H", ["HH", 2], 0, "hour");
ve("h", ["hh", 2], 0, Eh);
ve("k", ["kk", 2], 0, zk);
ve("hmm", 0, 0, function() {
  return "" + Eh.apply(this) + an(this.minutes(), 2);
});
ve("hmmss", 0, 0, function() {
  return "" + Eh.apply(this) + an(this.minutes(), 2) + an(this.seconds(), 2);
});
ve("Hmm", 0, 0, function() {
  return "" + this.hours() + an(this.minutes(), 2);
});
ve("Hmmss", 0, 0, function() {
  return "" + this.hours() + an(this.minutes(), 2) + an(this.seconds(), 2);
});
function q1(e, t) {
  ve(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
q1("a", !0);
q1("A", !1);
Lt("hour", "h");
Ut("hour", 13);
function Y1(e, t) {
  return t._meridiemParse;
}
ae("a", Y1);
ae("A", Y1);
ae("H", lt);
ae("h", lt);
ae("k", lt);
ae("HH", lt, cr);
ae("hh", lt, cr);
ae("kk", lt, cr);
ae("hmm", $1);
ae("hmmss", R1);
ae("Hmm", $1);
ae("Hmmss", R1);
Je(["H", "HH"], Tt);
Je(["k", "kk"], function(e, t, r) {
  var n = Ie(e);
  t[Tt] = n === 24 ? 0 : n;
});
Je(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
Je(["h", "hh"], function(e, t, r) {
  t[Tt] = Ie(e), Te(r).bigHour = !0;
});
Je("hmm", function(e, t, r) {
  var n = e.length - 2;
  t[Tt] = Ie(e.substr(0, n)), t[Fr] = Ie(e.substr(n)), Te(r).bigHour = !0;
});
Je("hmmss", function(e, t, r) {
  var n = e.length - 4, i = e.length - 2;
  t[Tt] = Ie(e.substr(0, n)), t[Fr] = Ie(e.substr(n, 2)), t[xn] = Ie(e.substr(i)), Te(r).bigHour = !0;
});
Je("Hmm", function(e, t, r) {
  var n = e.length - 2;
  t[Tt] = Ie(e.substr(0, n)), t[Fr] = Ie(e.substr(n));
});
Je("Hmmss", function(e, t, r) {
  var n = e.length - 4, i = e.length - 2;
  t[Tt] = Ie(e.substr(0, n)), t[Fr] = Ie(e.substr(n, 2)), t[xn] = Ie(e.substr(i));
});
function qk(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Yk = /[ap]\.?m?\.?/i, Vk = Ba("Hours", !0);
function Gk(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var V1 = {
  calendar: M8,
  longDateFormat: U8,
  invalidDate: W8,
  ordinal: q8,
  dayOfMonthOrdinalParse: Y8,
  relativeTime: G8,
  months: uk,
  monthsShort: M1,
  week: Ek,
  weekdays: Ok,
  weekdaysMin: Dk,
  weekdaysShort: z1,
  meridiemParse: Yk
}, ct = {}, oo = {}, Lo;
function Kk(e, t) {
  var r, n = Math.min(e.length, t.length);
  for (r = 0; r < n; r += 1)
    if (e[r] !== t[r])
      return r;
  return n;
}
function Bm(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Qk(e) {
  for (var t = 0, r, n, i, a; t < e.length; ) {
    for (a = Bm(e[t]).split("-"), r = a.length, n = Bm(e[t + 1]), n = n ? n.split("-") : null; r > 0; ) {
      if (i = Kl(a.slice(0, r).join("-")), i)
        return i;
      if (n && n.length >= r && Kk(a, n) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Lo;
}
function Xk(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Kl(e) {
  var t = null, r;
  if (ct[e] === void 0 && typeof module < "u" && module && module.exports && Xk(e))
    try {
      t = Lo._abbr, r = require, r("./locale/" + e), qn(t);
    } catch {
      ct[e] = null;
    }
  return ct[e];
}
function qn(e, t) {
  var r;
  return e && (Gt(t) ? r = An(e) : r = wh(e, t), r ? Lo = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Lo._abbr;
}
function wh(e, t) {
  if (t !== null) {
    var r, n = V1;
    if (t.abbr = e, ct[e] != null)
      D1(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = ct[e]._config;
    else if (t.parentLocale != null)
      if (ct[t.parentLocale] != null)
        n = ct[t.parentLocale]._config;
      else if (r = Kl(t.parentLocale), r != null)
        n = r._config;
      else
        return oo[t.parentLocale] || (oo[t.parentLocale] = []), oo[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return ct[e] = new ph(Id(n, t)), oo[e] && oo[e].forEach(function(i) {
      wh(i.name, i.config);
    }), qn(e), ct[e];
  } else
    return delete ct[e], null;
}
function Jk(e, t) {
  if (t != null) {
    var r, n, i = V1;
    ct[e] != null && ct[e].parentLocale != null ? ct[e].set(Id(ct[e]._config, t)) : (n = Kl(e), n != null && (i = n._config), t = Id(i, t), n == null && (t.abbr = e), r = new ph(t), r.parentLocale = ct[e], ct[e] = r), qn(e);
  } else
    ct[e] != null && (ct[e].parentLocale != null ? (ct[e] = ct[e].parentLocale, e === qn() && qn(e)) : ct[e] != null && delete ct[e]);
  return ct[e];
}
function An(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Lo;
  if (!Pr(e)) {
    if (t = Kl(e), t)
      return t;
    e = [e];
  }
  return Qk(e);
}
function Zk() {
  return kd(ct);
}
function Sh(e) {
  var t, r = e._a;
  return r && Te(e).overflow === -2 && (t = r[gn] < 0 || r[gn] > 11 ? gn : r[Jr] < 1 || r[Jr] > Gl(r[Bt], r[gn]) ? Jr : r[Tt] < 0 || r[Tt] > 24 || r[Tt] === 24 && (r[Fr] !== 0 || r[xn] !== 0 || r[Ti] !== 0) ? Tt : r[Fr] < 0 || r[Fr] > 59 ? Fr : r[xn] < 0 || r[xn] > 59 ? xn : r[Ti] < 0 || r[Ti] > 999 ? Ti : -1, Te(e)._overflowDayOfYear && (t < Bt || t > Jr) && (t = Jr), Te(e)._overflowWeeks && t === -1 && (t = ak), Te(e)._overflowWeekday && t === -1 && (t = ok), Te(e).overflow = t), e;
}
var eN = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tN = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, rN = /Z|[+-]\d\d(?::?\d\d)?/, js = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], jf = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], nN = /^\/?Date\((-?\d+)/i, iN = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, aN = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function G1(e) {
  var t, r, n = e._i, i = eN.exec(n) || tN.exec(n), a, o, s, u, l = js.length, c = jf.length;
  if (i) {
    for (Te(e).iso = !0, t = 0, r = l; t < r; t++)
      if (js[t][1].exec(i[1])) {
        o = js[t][0], a = js[t][2] !== !1;
        break;
      }
    if (o == null) {
      e._isValid = !1;
      return;
    }
    if (i[3]) {
      for (t = 0, r = c; t < r; t++)
        if (jf[t][1].exec(i[3])) {
          s = (i[2] || " ") + jf[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (i[4])
      if (rN.exec(i[4]))
        u = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = o + (s || "") + (u || ""), Th(e);
  } else
    e._isValid = !1;
}
function oN(e, t, r, n, i, a) {
  var o = [
    sN(e),
    M1.indexOf(t),
    parseInt(r, 10),
    parseInt(n, 10),
    parseInt(i, 10)
  ];
  return a && o.push(parseInt(a, 10)), o;
}
function sN(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function uN(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function lN(e, t, r) {
  if (e) {
    var n = z1.indexOf(e), i = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (n !== i)
      return Te(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function cN(e, t, r) {
  if (e)
    return aN[e];
  if (t)
    return 0;
  var n = parseInt(r, 10), i = n % 100, a = (n - i) / 100;
  return a * 60 + i;
}
function K1(e) {
  var t = iN.exec(uN(e._i)), r;
  if (t) {
    if (r = oN(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !lN(t[1], r, e))
      return;
    e._a = r, e._tzm = cN(t[8], t[9], t[10]), e._d = Bo.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Te(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function fN(e) {
  var t = nN.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (G1(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (K1(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : re.createFromInputFallback(e);
}
re.createFromInputFallback = mr(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function aa(e, t, r) {
  return e ?? t ?? r;
}
function dN(e) {
  var t = new Date(re.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function _h(e) {
  var t, r, n = [], i, a, o;
  if (!e._d) {
    for (i = dN(e), e._w && e._a[Jr] == null && e._a[gn] == null && hN(e), e._dayOfYear != null && (o = aa(e._a[Bt], i[Bt]), (e._dayOfYear > To(o) || e._dayOfYear === 0) && (Te(e)._overflowDayOfYear = !0), r = Bo(o, 0, e._dayOfYear), e._a[gn] = r.getUTCMonth(), e._a[Jr] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = n[t] = i[t];
    for (; t < 7; t++)
      e._a[t] = n[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Tt] === 24 && e._a[Fr] === 0 && e._a[xn] === 0 && e._a[Ti] === 0 && (e._nextDay = !0, e._a[Tt] = 0), e._d = (e._useUTC ? Bo : xk).apply(
      null,
      n
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Tt] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (Te(e).weekdayMismatch = !0);
  }
}
function hN(e) {
  var t, r, n, i, a, o, s, u, l;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, o = 4, r = aa(
    t.GG,
    e._a[Bt],
    jo(ut(), 1, 4).year
  ), n = aa(t.W, 1), i = aa(t.E, 1), (i < 1 || i > 7) && (u = !0)) : (a = e._locale._week.dow, o = e._locale._week.doy, l = jo(ut(), a, o), r = aa(t.gg, e._a[Bt], l.year), n = aa(t.w, l.week), t.d != null ? (i = t.d, (i < 0 || i > 6) && (u = !0)) : t.e != null ? (i = t.e + a, (t.e < 0 || t.e > 6) && (u = !0)) : i = a), n < 1 || n > wn(r, a, o) ? Te(e)._overflowWeeks = !0 : u != null ? Te(e)._overflowWeekday = !0 : (s = W1(r, n, i, a, o), e._a[Bt] = s.year, e._dayOfYear = s.dayOfYear);
}
re.ISO_8601 = function() {
};
re.RFC_2822 = function() {
};
function Th(e) {
  if (e._f === re.ISO_8601) {
    G1(e);
    return;
  }
  if (e._f === re.RFC_2822) {
    K1(e);
    return;
  }
  e._a = [], Te(e).empty = !0;
  var t = "" + e._i, r, n, i, a, o, s = t.length, u = 0, l, c;
  for (i = F1(e._f, e._locale).match(vh) || [], c = i.length, r = 0; r < c; r++)
    a = i[r], n = (t.match(rk(a, e)) || [])[0], n && (o = t.substr(0, t.indexOf(n)), o.length > 0 && Te(e).unusedInput.push(o), t = t.slice(
      t.indexOf(n) + n.length
    ), u += n.length), pa[a] ? (n ? Te(e).empty = !1 : Te(e).unusedTokens.push(a), ik(a, n, e)) : e._strict && !n && Te(e).unusedTokens.push(a);
  Te(e).charsLeftOver = s - u, t.length > 0 && Te(e).unusedInput.push(t), e._a[Tt] <= 12 && Te(e).bigHour === !0 && e._a[Tt] > 0 && (Te(e).bigHour = void 0), Te(e).parsedDateParts = e._a.slice(0), Te(e).meridiem = e._meridiem, e._a[Tt] = pN(
    e._locale,
    e._a[Tt],
    e._meridiem
  ), l = Te(e).era, l !== null && (e._a[Bt] = e._locale.erasConvertYear(l, e._a[Bt])), _h(e), Sh(e);
}
function pN(e, t, r) {
  var n;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (n = e.isPM(r), n && t < 12 && (t += 12), !n && t === 12 && (t = 0)), t);
}
function vN(e) {
  var t, r, n, i, a, o, s = !1, u = e._f.length;
  if (u === 0) {
    Te(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < u; i++)
    a = 0, o = !1, t = hh({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[i], Th(t), dh(t) && (o = !0), a += Te(t).charsLeftOver, a += Te(t).unusedTokens.length * 10, Te(t).score = a, s ? a < n && (n = a, r = t) : (n == null || a < n || o) && (n = a, r = t, o && (s = !0));
  Un(e, r || t);
}
function mN(e) {
  if (!e._d) {
    var t = mh(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = C1(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), _h(e);
  }
}
function yN(e) {
  var t = new ds(Sh(Q1(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Q1(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || An(e._l), t === null || r === void 0 && t === "" ? Ul({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), $r(t) ? new ds(Sh(t)) : (fs(t) ? e._d = t : Pr(r) ? vN(e) : r ? Th(e) : gN(e), dh(e) || (e._d = null), e));
}
function gN(e) {
  var t = e._i;
  Gt(t) ? e._d = new Date(re.now()) : fs(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? fN(e) : Pr(t) ? (e._a = C1(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), _h(e)) : Fi(t) ? mN(e) : _n(t) ? e._d = new Date(t) : re.createFromInputFallback(e);
}
function X1(e, t, r, n, i) {
  var a = {};
  return (t === !0 || t === !1) && (n = t, t = void 0), (r === !0 || r === !1) && (n = r, r = void 0), (Fi(e) && fh(e) || Pr(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = i, a._l = r, a._i = e, a._f = t, a._strict = n, yN(a);
}
function ut(e, t, r, n) {
  return X1(e, t, r, n, !1);
}
var xN = mr(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = ut.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Ul();
  }
), bN = mr(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = ut.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Ul();
  }
);
function J1(e, t) {
  var r, n;
  if (t.length === 1 && Pr(t[0]) && (t = t[0]), !t.length)
    return ut();
  for (r = t[0], n = 1; n < t.length; ++n)
    (!t[n].isValid() || t[n][e](r)) && (r = t[n]);
  return r;
}
function EN() {
  var e = [].slice.call(arguments, 0);
  return J1("isBefore", e);
}
function wN() {
  var e = [].slice.call(arguments, 0);
  return J1("isAfter", e);
}
var SN = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, so = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function _N(e) {
  var t, r = !1, n, i = so.length;
  for (t in e)
    if (je(e, t) && !(gt.call(so, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (n = 0; n < i; ++n)
    if (e[so[n]]) {
      if (r)
        return !1;
      parseFloat(e[so[n]]) !== Ie(e[so[n]]) && (r = !0);
    }
  return !0;
}
function TN() {
  return this._isValid;
}
function AN() {
  return Ur(NaN);
}
function Ql(e) {
  var t = mh(e), r = t.year || 0, n = t.quarter || 0, i = t.month || 0, a = t.week || t.isoWeek || 0, o = t.day || 0, s = t.hour || 0, u = t.minute || 0, l = t.second || 0, c = t.millisecond || 0;
  this._isValid = _N(t), this._milliseconds = +c + l * 1e3 + // 1000
  u * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +o + a * 7, this._months = +i + n * 3 + r * 12, this._data = {}, this._locale = An(), this._bubble();
}
function au(e) {
  return e instanceof Ql;
}
function Pd(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function CN(e, t, r) {
  var n = Math.min(e.length, t.length), i = Math.abs(e.length - t.length), a = 0, o;
  for (o = 0; o < n; o++)
    (r && e[o] !== t[o] || !r && Ie(e[o]) !== Ie(t[o])) && a++;
  return a + i;
}
function Z1(e, t) {
  ve(e, 0, 0, function() {
    var r = this.utcOffset(), n = "+";
    return r < 0 && (r = -r, n = "-"), n + an(~~(r / 60), 2) + t + an(~~r % 60, 2);
  });
}
Z1("Z", ":");
Z1("ZZ", "");
ae("Z", Vl);
ae("ZZ", Vl);
Je(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = Ah(Vl, e);
});
var ON = /([\+\-]|\d\d)/gi;
function Ah(e, t) {
  var r = (t || "").match(e), n, i, a;
  return r === null ? null : (n = r[r.length - 1] || [], i = (n + "").match(ON) || ["-", 0, 0], a = +(i[1] * 60) + Ie(i[2]), a === 0 ? 0 : i[0] === "+" ? a : -a);
}
function Ch(e, t) {
  var r, n;
  return t._isUTC ? (r = t.clone(), n = ($r(e) || fs(e) ? e.valueOf() : ut(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + n), re.updateOffset(r, !1), r) : ut(e).local();
}
function $d(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
re.updateOffset = function() {
};
function DN(e, t, r) {
  var n = this._offset || 0, i;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Ah(Vl, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (i = $d(this)), this._offset = e, this._isUTC = !0, i != null && this.add(i, "m"), n !== e && (!t || this._changeInProgress ? rE(
      this,
      Ur(e - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, re.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : $d(this);
}
function FN(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function IN(e) {
  return this.utcOffset(0, e);
}
function kN(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract($d(this), "m")), this;
}
function NN() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Ah(ek, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function PN(e) {
  return this.isValid() ? (e = e ? ut(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function $N() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function RN() {
  if (!Gt(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return hh(e, this), e = Q1(e), e._a ? (t = e._isUTC ? un(e._a) : ut(e._a), this._isDSTShifted = this.isValid() && CN(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function MN() {
  return this.isValid() ? !this._isUTC : !1;
}
function BN() {
  return this.isValid() ? this._isUTC : !1;
}
function eE() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var jN = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, LN = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Ur(e, t) {
  var r = e, n = null, i, a, o;
  return au(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : _n(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (n = jN.exec(e)) ? (i = n[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: Ie(n[Jr]) * i,
    h: Ie(n[Tt]) * i,
    m: Ie(n[Fr]) * i,
    s: Ie(n[xn]) * i,
    ms: Ie(Pd(n[Ti] * 1e3)) * i
    // the millisecond decimal point is included in the match
  }) : (n = LN.exec(e)) ? (i = n[1] === "-" ? -1 : 1, r = {
    y: fi(n[2], i),
    M: fi(n[3], i),
    w: fi(n[4], i),
    d: fi(n[5], i),
    h: fi(n[6], i),
    m: fi(n[7], i),
    s: fi(n[8], i)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (o = UN(
    ut(r.from),
    ut(r.to)
  ), r = {}, r.ms = o.milliseconds, r.M = o.months), a = new Ql(r), au(e) && je(e, "_locale") && (a._locale = e._locale), au(e) && je(e, "_isValid") && (a._isValid = e._isValid), a;
}
Ur.fn = Ql.prototype;
Ur.invalid = AN;
function fi(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function jm(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function UN(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = Ch(t, e), e.isBefore(t) ? r = jm(e, t) : (r = jm(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function tE(e, t) {
  return function(r, n) {
    var i, a;
    return n !== null && !isNaN(+n) && (D1(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = n, n = a), i = Ur(r, n), rE(this, i, e), this;
  };
}
function rE(e, t, r, n) {
  var i = t._milliseconds, a = Pd(t._days), o = Pd(t._months);
  e.isValid() && (n = n ?? !0, o && j1(e, Pu(e, "Month") + o * r), a && k1(e, "Date", Pu(e, "Date") + a * r), i && e._d.setTime(e._d.valueOf() + i * r), n && re.updateOffset(e, a || o));
}
var HN = tE(1, "add"), WN = tE(-1, "subtract");
function nE(e) {
  return typeof e == "string" || e instanceof String;
}
function zN(e) {
  return $r(e) || fs(e) || nE(e) || _n(e) || YN(e) || qN(e) || e === null || e === void 0;
}
function qN(e) {
  var t = Fi(e) && !fh(e), r = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, a, o = n.length;
  for (i = 0; i < o; i += 1)
    a = n[i], r = r || je(e, a);
  return t && r;
}
function YN(e) {
  var t = Pr(e), r = !1;
  return t && (r = e.filter(function(n) {
    return !_n(n) && nE(e);
  }).length === 0), t && r;
}
function VN(e) {
  var t = Fi(e) && !fh(e), r = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, a;
  for (i = 0; i < n.length; i += 1)
    a = n[i], r = r || je(e, a);
  return t && r;
}
function GN(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function KN(e, t) {
  arguments.length === 1 && (arguments[0] ? zN(arguments[0]) ? (e = arguments[0], t = void 0) : VN(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || ut(), n = Ch(r, this).startOf("day"), i = re.calendarFormat(this, n) || "sameElse", a = t && (ln(t[i]) ? t[i].call(this, r) : t[i]);
  return this.format(
    a || this.localeData().calendar(i, this, ut(r))
  );
}
function QN() {
  return new ds(this);
}
function XN(e, t) {
  var r = $r(e) ? e : ut(e);
  return this.isValid() && r.isValid() ? (t = yr(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function JN(e, t) {
  var r = $r(e) ? e : ut(e);
  return this.isValid() && r.isValid() ? (t = yr(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function ZN(e, t, r, n) {
  var i = $r(e) ? e : ut(e), a = $r(t) ? t : ut(t);
  return this.isValid() && i.isValid() && a.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(i, r) : !this.isBefore(i, r)) && (n[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function eP(e, t) {
  var r = $r(e) ? e : ut(e), n;
  return this.isValid() && r.isValid() ? (t = yr(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf())) : !1;
}
function tP(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function rP(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function nP(e, t, r) {
  var n, i, a;
  if (!this.isValid())
    return NaN;
  if (n = Ch(e, this), !n.isValid())
    return NaN;
  switch (i = (n.utcOffset() - this.utcOffset()) * 6e4, t = yr(t), t) {
    case "year":
      a = ou(this, n) / 12;
      break;
    case "month":
      a = ou(this, n);
      break;
    case "quarter":
      a = ou(this, n) / 3;
      break;
    case "second":
      a = (this - n) / 1e3;
      break;
    case "minute":
      a = (this - n) / 6e4;
      break;
    case "hour":
      a = (this - n) / 36e5;
      break;
    case "day":
      a = (this - n - i) / 864e5;
      break;
    case "week":
      a = (this - n - i) / 6048e5;
      break;
    default:
      a = this - n;
  }
  return r ? a : hr(a);
}
function ou(e, t) {
  if (e.date() < t.date())
    return -ou(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), n = e.clone().add(r, "months"), i, a;
  return t - n < 0 ? (i = e.clone().add(r - 1, "months"), a = (t - n) / (n - i)) : (i = e.clone().add(r + 1, "months"), a = (t - n) / (i - n)), -(r + a) || 0;
}
re.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
re.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function iP() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function aP(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? iu(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ln(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", iu(r, "Z")) : iu(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function oP() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, n, i, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + n + i + a);
}
function sP(e) {
  e || (e = this.isUtc() ? re.defaultFormatUtc : re.defaultFormat);
  var t = iu(this, e);
  return this.localeData().postformat(t);
}
function uP(e, t) {
  return this.isValid() && ($r(e) && e.isValid() || ut(e).isValid()) ? Ur({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function lP(e) {
  return this.from(ut(), e);
}
function cP(e, t) {
  return this.isValid() && ($r(e) && e.isValid() || ut(e).isValid()) ? Ur({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function fP(e) {
  return this.to(ut(), e);
}
function iE(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = An(e), t != null && (this._locale = t), this);
}
var aE = mr(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function oE() {
  return this._locale;
}
var Mu = 1e3, va = 60 * Mu, Bu = 60 * va, sE = (365 * 400 + 97) * 24 * Bu;
function ma(e, t) {
  return (e % t + t) % t;
}
function uE(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - sE : new Date(e, t, r).valueOf();
}
function lE(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - sE : Date.UTC(e, t, r);
}
function dP(e) {
  var t, r;
  if (e = yr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? lE : uE, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= ma(
        t + (this._isUTC ? 0 : this.utcOffset() * va),
        Bu
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= ma(t, va);
      break;
    case "second":
      t = this._d.valueOf(), t -= ma(t, Mu);
      break;
  }
  return this._d.setTime(t), re.updateOffset(this, !0), this;
}
function hP(e) {
  var t, r;
  if (e = yr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? lE : uE, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Bu - ma(
        t + (this._isUTC ? 0 : this.utcOffset() * va),
        Bu
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += va - ma(t, va) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Mu - ma(t, Mu) - 1;
      break;
  }
  return this._d.setTime(t), re.updateOffset(this, !0), this;
}
function pP() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function vP() {
  return Math.floor(this.valueOf() / 1e3);
}
function mP() {
  return new Date(this.valueOf());
}
function yP() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function gP() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function xP() {
  return this.isValid() ? this.toISOString() : null;
}
function bP() {
  return dh(this);
}
function EP() {
  return Un({}, Te(this));
}
function wP() {
  return Te(this).overflow;
}
function SP() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
ve("N", 0, 0, "eraAbbr");
ve("NN", 0, 0, "eraAbbr");
ve("NNN", 0, 0, "eraAbbr");
ve("NNNN", 0, 0, "eraName");
ve("NNNNN", 0, 0, "eraNarrow");
ve("y", ["y", 1], "yo", "eraYear");
ve("y", ["yy", 2], 0, "eraYear");
ve("y", ["yyy", 3], 0, "eraYear");
ve("y", ["yyyy", 4], 0, "eraYear");
ae("N", Oh);
ae("NN", Oh);
ae("NNN", Oh);
ae("NNNN", PP);
ae("NNNNN", $P);
Je(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, n) {
    var i = r._locale.erasParse(e, n, r._strict);
    i ? Te(r).era = i : Te(r).invalidEra = e;
  }
);
ae("y", ja);
ae("yy", ja);
ae("yyy", ja);
ae("yyyy", ja);
ae("yo", RP);
Je(["y", "yy", "yyy", "yyyy"], Bt);
Je(["yo"], function(e, t, r, n) {
  var i;
  r._locale._eraYearOrdinalRegex && (i = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[Bt] = r._locale.eraYearOrdinalParse(e, i) : t[Bt] = parseInt(e, 10);
});
function _P(e, t) {
  var r, n, i, a = this._eras || An("en")._eras;
  for (r = 0, n = a.length; r < n; ++r) {
    switch (typeof a[r].since) {
      case "string":
        i = re(a[r].since).startOf("day"), a[r].since = i.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        i = re(a[r].until).startOf("day").valueOf(), a[r].until = i.valueOf();
        break;
    }
  }
  return a;
}
function TP(e, t, r) {
  var n, i, a = this.eras(), o, s, u;
  for (e = e.toUpperCase(), n = 0, i = a.length; n < i; ++n)
    if (o = a[n].name.toUpperCase(), s = a[n].abbr.toUpperCase(), u = a[n].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[n];
          break;
        case "NNNN":
          if (o === e)
            return a[n];
          break;
        case "NNNNN":
          if (u === e)
            return a[n];
          break;
      }
    else if ([o, s, u].indexOf(e) >= 0)
      return a[n];
}
function AP(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? re(e.since).year() : re(e.since).year() + (t - e.offset) * r;
}
function CP() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].name;
  return "";
}
function OP() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].narrow;
  return "";
}
function DP() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].abbr;
  return "";
}
function FP() {
  var e, t, r, n, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = i[e].since <= i[e].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), i[e].since <= n && n <= i[e].until || i[e].until <= n && n <= i[e].since)
      return (this.year() - re(i[e].since).year()) * r + i[e].offset;
  return this.year();
}
function IP(e) {
  return je(this, "_erasNameRegex") || Dh.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function kP(e) {
  return je(this, "_erasAbbrRegex") || Dh.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function NP(e) {
  return je(this, "_erasNarrowRegex") || Dh.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Oh(e, t) {
  return t.erasAbbrRegex(e);
}
function PP(e, t) {
  return t.erasNameRegex(e);
}
function $P(e, t) {
  return t.erasNarrowRegex(e);
}
function RP(e, t) {
  return t._eraYearOrdinalRegex || ja;
}
function Dh() {
  var e = [], t = [], r = [], n = [], i, a, o = this.eras();
  for (i = 0, a = o.length; i < a; ++i)
    t.push(ir(o[i].name)), e.push(ir(o[i].abbr)), r.push(ir(o[i].narrow)), n.push(ir(o[i].name)), n.push(ir(o[i].abbr)), n.push(ir(o[i].narrow));
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
ve(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
ve(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Xl(e, t) {
  ve(0, [e, e.length], 0, t);
}
Xl("gggg", "weekYear");
Xl("ggggg", "weekYear");
Xl("GGGG", "isoWeekYear");
Xl("GGGGG", "isoWeekYear");
Lt("weekYear", "gg");
Lt("isoWeekYear", "GG");
Ut("weekYear", 1);
Ut("isoWeekYear", 1);
ae("G", Yl);
ae("g", Yl);
ae("GG", lt, cr);
ae("gg", lt, cr);
ae("GGGG", gh, yh);
ae("gggg", gh, yh);
ae("GGGGG", ql, Wl);
ae("ggggg", ql, Wl);
ps(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, n) {
    t[n.substr(0, 2)] = Ie(e);
  }
);
ps(["gg", "GG"], function(e, t, r, n) {
  t[n] = re.parseTwoDigitYear(e);
});
function MP(e) {
  return cE.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function BP(e) {
  return cE.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function jP() {
  return wn(this.year(), 1, 4);
}
function LP() {
  return wn(this.isoWeekYear(), 1, 4);
}
function UP() {
  var e = this.localeData()._week;
  return wn(this.year(), e.dow, e.doy);
}
function HP() {
  var e = this.localeData()._week;
  return wn(this.weekYear(), e.dow, e.doy);
}
function cE(e, t, r, n, i) {
  var a;
  return e == null ? jo(this, n, i).year : (a = wn(e, n, i), t > a && (t = a), WP.call(this, e, t, r, n, i));
}
function WP(e, t, r, n, i) {
  var a = W1(e, t, r, n, i), o = Bo(a.year, 0, a.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
ve("Q", 0, "Qo", "quarter");
Lt("quarter", "Q");
Ut("quarter", 7);
ae("Q", N1);
Je("Q", function(e, t) {
  t[gn] = (Ie(e) - 1) * 3;
});
function zP(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
ve("D", ["DD", 2], "Do", "date");
Lt("date", "D");
Ut("date", 9);
ae("D", lt);
ae("DD", lt, cr);
ae("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
Je(["D", "DD"], Jr);
Je("Do", function(e, t) {
  t[Jr] = Ie(e.match(lt)[0]);
});
var fE = Ba("Date", !0);
ve("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Lt("dayOfYear", "DDD");
Ut("dayOfYear", 4);
ae("DDD", zl);
ae("DDDD", P1);
Je(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = Ie(e);
});
function qP(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
ve("m", ["mm", 2], 0, "minute");
Lt("minute", "m");
Ut("minute", 14);
ae("m", lt);
ae("mm", lt, cr);
Je(["m", "mm"], Fr);
var YP = Ba("Minutes", !1);
ve("s", ["ss", 2], 0, "second");
Lt("second", "s");
Ut("second", 15);
ae("s", lt);
ae("ss", lt, cr);
Je(["s", "ss"], xn);
var VP = Ba("Seconds", !1);
ve("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
ve(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
ve(0, ["SSS", 3], 0, "millisecond");
ve(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
ve(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
ve(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
ve(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
ve(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
ve(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Lt("millisecond", "ms");
Ut("millisecond", 16);
ae("S", zl, N1);
ae("SS", zl, cr);
ae("SSS", zl, P1);
var Hn, dE;
for (Hn = "SSSS"; Hn.length <= 9; Hn += "S")
  ae(Hn, ja);
function GP(e, t) {
  t[Ti] = Ie(("0." + e) * 1e3);
}
for (Hn = "S"; Hn.length <= 9; Hn += "S")
  Je(Hn, GP);
dE = Ba("Milliseconds", !1);
ve("z", 0, 0, "zoneAbbr");
ve("zz", 0, 0, "zoneName");
function KP() {
  return this._isUTC ? "UTC" : "";
}
function QP() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var G = ds.prototype;
G.add = HN;
G.calendar = KN;
G.clone = QN;
G.diff = nP;
G.endOf = hP;
G.format = sP;
G.from = uP;
G.fromNow = lP;
G.to = cP;
G.toNow = fP;
G.get = J8;
G.invalidAt = wP;
G.isAfter = XN;
G.isBefore = JN;
G.isBetween = ZN;
G.isSame = eP;
G.isSameOrAfter = tP;
G.isSameOrBefore = rP;
G.isValid = bP;
G.lang = aE;
G.locale = iE;
G.localeData = oE;
G.max = bN;
G.min = xN;
G.parsingFlags = EP;
G.set = Z8;
G.startOf = dP;
G.subtract = WN;
G.toArray = yP;
G.toObject = gP;
G.toDate = mP;
G.toISOString = aP;
G.inspect = oP;
typeof Symbol < "u" && Symbol.for != null && (G[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
G.toJSON = xP;
G.toString = iP;
G.unix = vP;
G.valueOf = pP;
G.creationData = SP;
G.eraName = CP;
G.eraNarrow = OP;
G.eraAbbr = DP;
G.eraYear = FP;
G.year = H1;
G.isLeapYear = gk;
G.weekYear = MP;
G.isoWeekYear = BP;
G.quarter = G.quarters = zP;
G.month = L1;
G.daysInMonth = vk;
G.week = G.weeks = _k;
G.isoWeek = G.isoWeeks = Tk;
G.weeksInYear = UP;
G.weeksInWeekYear = HP;
G.isoWeeksInYear = jP;
G.isoWeeksInISOWeekYear = LP;
G.date = fE;
G.day = G.days = Bk;
G.weekday = jk;
G.isoWeekday = Lk;
G.dayOfYear = qP;
G.hour = G.hours = Vk;
G.minute = G.minutes = YP;
G.second = G.seconds = VP;
G.millisecond = G.milliseconds = dE;
G.utcOffset = DN;
G.utc = IN;
G.local = kN;
G.parseZone = NN;
G.hasAlignedHourOffset = PN;
G.isDST = $N;
G.isLocal = MN;
G.isUtcOffset = BN;
G.isUtc = eE;
G.isUTC = eE;
G.zoneAbbr = KP;
G.zoneName = QP;
G.dates = mr(
  "dates accessor is deprecated. Use date instead.",
  fE
);
G.months = mr(
  "months accessor is deprecated. Use month instead",
  L1
);
G.years = mr(
  "years accessor is deprecated. Use year instead",
  H1
);
G.zone = mr(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  FN
);
G.isDSTShifted = mr(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  RN
);
function XP(e) {
  return ut(e * 1e3);
}
function JP() {
  return ut.apply(null, arguments).parseZone();
}
function hE(e) {
  return e;
}
var Le = ph.prototype;
Le.calendar = B8;
Le.longDateFormat = H8;
Le.invalidDate = z8;
Le.ordinal = V8;
Le.preparse = hE;
Le.postformat = hE;
Le.relativeTime = K8;
Le.pastFuture = Q8;
Le.set = R8;
Le.eras = _P;
Le.erasParse = TP;
Le.erasConvertYear = AP;
Le.erasAbbrRegex = kP;
Le.erasNameRegex = IP;
Le.erasNarrowRegex = NP;
Le.months = fk;
Le.monthsShort = dk;
Le.monthsParse = pk;
Le.monthsRegex = yk;
Le.monthsShortRegex = mk;
Le.week = bk;
Le.firstDayOfYear = Sk;
Le.firstDayOfWeek = wk;
Le.weekdays = Nk;
Le.weekdaysMin = $k;
Le.weekdaysShort = Pk;
Le.weekdaysParse = Mk;
Le.weekdaysRegex = Uk;
Le.weekdaysShortRegex = Hk;
Le.weekdaysMinRegex = Wk;
Le.isPM = qk;
Le.meridiem = Gk;
function ju(e, t, r, n) {
  var i = An(), a = un().set(n, t);
  return i[r](a, e);
}
function pE(e, t, r) {
  if (_n(e) && (t = e, e = void 0), e = e || "", t != null)
    return ju(e, t, r, "month");
  var n, i = [];
  for (n = 0; n < 12; n++)
    i[n] = ju(e, n, r, "month");
  return i;
}
function Fh(e, t, r, n) {
  typeof e == "boolean" ? (_n(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, _n(t) && (r = t, t = void 0), t = t || "");
  var i = An(), a = e ? i._week.dow : 0, o, s = [];
  if (r != null)
    return ju(t, (r + a) % 7, n, "day");
  for (o = 0; o < 7; o++)
    s[o] = ju(t, (o + a) % 7, n, "day");
  return s;
}
function ZP(e, t) {
  return pE(e, t, "months");
}
function e3(e, t) {
  return pE(e, t, "monthsShort");
}
function t3(e, t, r) {
  return Fh(e, t, r, "weekdays");
}
function r3(e, t, r) {
  return Fh(e, t, r, "weekdaysShort");
}
function n3(e, t, r) {
  return Fh(e, t, r, "weekdaysMin");
}
qn("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = Ie(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
re.lang = mr(
  "moment.lang is deprecated. Use moment.locale instead.",
  qn
);
re.langData = mr(
  "moment.langData is deprecated. Use moment.localeData instead.",
  An
);
var hn = Math.abs;
function i3() {
  var e = this._data;
  return this._milliseconds = hn(this._milliseconds), this._days = hn(this._days), this._months = hn(this._months), e.milliseconds = hn(e.milliseconds), e.seconds = hn(e.seconds), e.minutes = hn(e.minutes), e.hours = hn(e.hours), e.months = hn(e.months), e.years = hn(e.years), this;
}
function vE(e, t, r, n) {
  var i = Ur(t, r);
  return e._milliseconds += n * i._milliseconds, e._days += n * i._days, e._months += n * i._months, e._bubble();
}
function a3(e, t) {
  return vE(this, e, t, 1);
}
function o3(e, t) {
  return vE(this, e, t, -1);
}
function Lm(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function s3() {
  var e = this._milliseconds, t = this._days, r = this._months, n = this._data, i, a, o, s, u;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Lm(Rd(r) + t) * 864e5, t = 0, r = 0), n.milliseconds = e % 1e3, i = hr(e / 1e3), n.seconds = i % 60, a = hr(i / 60), n.minutes = a % 60, o = hr(a / 60), n.hours = o % 24, t += hr(o / 24), u = hr(mE(t)), r += u, t -= Lm(Rd(u)), s = hr(r / 12), r %= 12, n.days = t, n.months = r, n.years = s, this;
}
function mE(e) {
  return e * 4800 / 146097;
}
function Rd(e) {
  return e * 146097 / 4800;
}
function u3(e) {
  if (!this.isValid())
    return NaN;
  var t, r, n = this._milliseconds;
  if (e = yr(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + n / 864e5, r = this._months + mE(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Rd(this._months)), e) {
      case "week":
        return t / 7 + n / 6048e5;
      case "day":
        return t + n / 864e5;
      case "hour":
        return t * 24 + n / 36e5;
      case "minute":
        return t * 1440 + n / 6e4;
      case "second":
        return t * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + n;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function l3() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + Ie(this._months / 12) * 31536e6 : NaN;
}
function Cn(e) {
  return function() {
    return this.as(e);
  };
}
var c3 = Cn("ms"), f3 = Cn("s"), d3 = Cn("m"), h3 = Cn("h"), p3 = Cn("d"), v3 = Cn("w"), m3 = Cn("M"), y3 = Cn("Q"), g3 = Cn("y");
function x3() {
  return Ur(this);
}
function b3(e) {
  return e = yr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Hi(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var E3 = Hi("milliseconds"), w3 = Hi("seconds"), S3 = Hi("minutes"), _3 = Hi("hours"), T3 = Hi("days"), A3 = Hi("months"), C3 = Hi("years");
function O3() {
  return hr(this.days() / 7);
}
var mn = Math.round, ua = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function D3(e, t, r, n, i) {
  return i.relativeTime(t || 1, !!r, e, n);
}
function F3(e, t, r, n) {
  var i = Ur(e).abs(), a = mn(i.as("s")), o = mn(i.as("m")), s = mn(i.as("h")), u = mn(i.as("d")), l = mn(i.as("M")), c = mn(i.as("w")), f = mn(i.as("y")), d = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || o <= 1 && ["m"] || o < r.m && ["mm", o] || s <= 1 && ["h"] || s < r.h && ["hh", s] || u <= 1 && ["d"] || u < r.d && ["dd", u];
  return r.w != null && (d = d || c <= 1 && ["w"] || c < r.w && ["ww", c]), d = d || l <= 1 && ["M"] || l < r.M && ["MM", l] || f <= 1 && ["y"] || ["yy", f], d[2] = t, d[3] = +e > 0, d[4] = n, D3.apply(null, d);
}
function I3(e) {
  return e === void 0 ? mn : typeof e == "function" ? (mn = e, !0) : !1;
}
function k3(e, t) {
  return ua[e] === void 0 ? !1 : t === void 0 ? ua[e] : (ua[e] = t, e === "s" && (ua.ss = t - 1), !0);
}
function N3(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, n = ua, i, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (n = Object.assign({}, ua, t), t.s != null && t.ss == null && (n.ss = t.s - 1)), i = this.localeData(), a = F3(this, !r, n, i), r && (a = i.pastFuture(+this, a)), i.postformat(a);
}
var Lf = Math.abs;
function Zi(e) {
  return (e > 0) - (e < 0) || +e;
}
function Jl() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Lf(this._milliseconds) / 1e3, t = Lf(this._days), r = Lf(this._months), n, i, a, o, s = this.asSeconds(), u, l, c, f;
  return s ? (n = hr(e / 60), i = hr(n / 60), e %= 60, n %= 60, a = hr(r / 12), r %= 12, o = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", u = s < 0 ? "-" : "", l = Zi(this._months) !== Zi(s) ? "-" : "", c = Zi(this._days) !== Zi(s) ? "-" : "", f = Zi(this._milliseconds) !== Zi(s) ? "-" : "", u + "P" + (a ? l + a + "Y" : "") + (r ? l + r + "M" : "") + (t ? c + t + "D" : "") + (i || n || e ? "T" : "") + (i ? f + i + "H" : "") + (n ? f + n + "M" : "") + (e ? f + o + "S" : "")) : "P0D";
}
var Re = Ql.prototype;
Re.isValid = TN;
Re.abs = i3;
Re.add = a3;
Re.subtract = o3;
Re.as = u3;
Re.asMilliseconds = c3;
Re.asSeconds = f3;
Re.asMinutes = d3;
Re.asHours = h3;
Re.asDays = p3;
Re.asWeeks = v3;
Re.asMonths = m3;
Re.asQuarters = y3;
Re.asYears = g3;
Re.valueOf = l3;
Re._bubble = s3;
Re.clone = x3;
Re.get = b3;
Re.milliseconds = E3;
Re.seconds = w3;
Re.minutes = S3;
Re.hours = _3;
Re.days = T3;
Re.weeks = O3;
Re.months = A3;
Re.years = C3;
Re.humanize = N3;
Re.toISOString = Jl;
Re.toString = Jl;
Re.toJSON = Jl;
Re.locale = iE;
Re.localeData = oE;
Re.toIsoString = mr(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Jl
);
Re.lang = aE;
ve("X", 0, 0, "unix");
ve("x", 0, 0, "valueOf");
ae("x", Yl);
ae("X", tk);
Je("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
Je("x", function(e, t, r) {
  r._d = new Date(Ie(e));
});
//! moment.js
re.version = "2.29.4";
P8(ut);
re.fn = G;
re.min = EN;
re.max = wN;
re.now = SN;
re.utc = un;
re.unix = XP;
re.months = ZP;
re.isDate = fs;
re.locale = qn;
re.invalid = Ul;
re.duration = Ur;
re.isMoment = $r;
re.weekdays = t3;
re.parseZone = JP;
re.localeData = An;
re.isDuration = au;
re.monthsShort = e3;
re.weekdaysMin = n3;
re.defineLocale = wh;
re.updateLocale = Jk;
re.locales = Zk;
re.weekdaysShort = r3;
re.normalizeUnits = yr;
re.relativeTimeRounding = I3;
re.relativeTimeThreshold = k3;
re.calendarFormat = GN;
re.prototype = G;
re.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function su(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? su = function(r) {
    return typeof r;
  } : su = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, su(e);
}
function P3(e) {
  return su(e) == "object" && e !== null;
}
var yE = typeof Symbol == "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";
function Md(e, t) {
  for (var r = /\r\n|[\n\r]/g, n = 1, i = t + 1, a; (a = r.exec(e.body)) && a.index < t; )
    n += 1, i = t + 1 - (a.index + a[0].length);
  return {
    line: n,
    column: i
  };
}
function $3(e) {
  return gE(e.source, Md(e.source, e.start));
}
function gE(e, t) {
  var r = e.locationOffset.column - 1, n = uu(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, u = t.column + s, l = "".concat(e.name, ":").concat(o, ":").concat(u, `
`), c = n.split(/\r\n|[\n\r]/g), f = c[i];
  if (f.length > 120) {
    for (var d = Math.floor(u / 80), h = u % 80, p = [], v = 0; v < f.length; v += 80)
      p.push(f.slice(v, v + 80));
    return l + Um([["".concat(o), p[0]]].concat(p.slice(1, d + 1).map(function(m) {
      return ["", m];
    }), [[" ", uu(h - 1) + "^"], ["", p[d + 1]]]));
  }
  return l + Um([
    // Lines specified like this: ["prefix", "string"],
    ["".concat(o - 1), c[i - 1]],
    ["".concat(o), f],
    ["", uu(u - 1) + "^"],
    ["".concat(o + 1), c[i + 1]]
  ]);
}
function Um(e) {
  var t = e.filter(function(n) {
    n[0];
    var i = n[1];
    return i !== void 0;
  }), r = Math.max.apply(Math, t.map(function(n) {
    var i = n[0];
    return i.length;
  }));
  return t.map(function(n) {
    var i = n[0], a = n[1];
    return R3(r, i) + (a ? " | " + a : " |");
  }).join(`
`);
}
function uu(e) {
  return Array(e + 1).join(" ");
}
function R3(e, t) {
  return uu(e - t.length) + t;
}
function lu(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lu = function(r) {
    return typeof r;
  } : lu = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, lu(e);
}
function Hm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function M3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hm(Object(r), !0).forEach(function(n) {
      B3(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function B3(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function j3(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function L3(e, t, r) {
  return t && Wm(e.prototype, t), r && Wm(e, r), e;
}
function U3(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Uo(e, t);
}
function H3(e) {
  var t = bE();
  return function() {
    var n = Ho(e), i;
    if (t) {
      var a = Ho(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return xE(this, i);
  };
}
function xE(e, t) {
  return t && (lu(t) === "object" || typeof t == "function") ? t : go(e);
}
function go(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bd(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Bd = function(n) {
    if (n === null || !W3(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, i);
    }
    function i() {
      return cu(n, arguments, Ho(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Uo(i, n);
  }, Bd(e);
}
function cu(e, t, r) {
  return bE() ? cu = Reflect.construct : cu = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var u = Function.bind.apply(i, s), l = new u();
    return o && Uo(l, o.prototype), l;
  }, cu.apply(null, arguments);
}
function bE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function W3(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Uo(e, t) {
  return Uo = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, Uo(e, t);
}
function Ho(e) {
  return Ho = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ho(e);
}
var Ao = /* @__PURE__ */ function(e) {
  U3(r, e);
  var t = H3(r);
  function r(n, i, a, o, s, u, l) {
    var c, f, d, h;
    j3(this, r), h = t.call(this, n), h.name = "GraphQLError", h.originalError = u ?? void 0, h.nodes = zm(Array.isArray(i) ? i : i ? [i] : void 0);
    for (var p = [], v = 0, m = (x = h.nodes) !== null && x !== void 0 ? x : []; v < m.length; v++) {
      var x, y = m[v], g = y.loc;
      g != null && p.push(g);
    }
    p = zm(p), h.source = a ?? ((c = p) === null || c === void 0 ? void 0 : c[0].source), h.positions = o ?? ((f = p) === null || f === void 0 ? void 0 : f.map(function(b) {
      return b.start;
    })), h.locations = o && a ? o.map(function(b) {
      return Md(a, b);
    }) : (d = p) === null || d === void 0 ? void 0 : d.map(function(b) {
      return Md(b.source, b.start);
    }), h.path = s ?? void 0;
    var E = u == null ? void 0 : u.extensions;
    return l == null && P3(E) ? h.extensions = M3({}, E) : h.extensions = l ?? {}, Object.defineProperties(go(h), {
      message: {
        enumerable: !0
      },
      locations: {
        enumerable: h.locations != null
      },
      path: {
        enumerable: h.path != null
      },
      extensions: {
        enumerable: h.extensions != null && Object.keys(h.extensions).length > 0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? (Object.defineProperty(go(h), "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }), xE(h)) : (Error.captureStackTrace ? Error.captureStackTrace(go(h), r) : Object.defineProperty(go(h), "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    }), h);
  }
  return L3(r, [{
    key: "toString",
    value: function() {
      return z3(this);
    }
    // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  }, {
    key: yE,
    get: function() {
      return "Object";
    }
  }]), r;
}(/* @__PURE__ */ Bd(Error));
function zm(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function z3(e) {
  var t = e.message;
  if (e.nodes)
    for (var r = 0, n = e.nodes; r < n.length; r++) {
      var i = n[r];
      i.loc && (t += `

` + $3(i.loc));
    }
  else if (e.source && e.locations)
    for (var a = 0, o = e.locations; a < o.length; a++) {
      var s = o[a];
      t += `

` + gE(e.source, s);
    }
  return t;
}
function or(e, t, r) {
  return new Ao("Syntax Error: ".concat(r), void 0, e, [t]);
}
var ge = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function q3(e, t) {
  var r = !!e;
  if (!r)
    throw new Error(t ?? "Unexpected invariant triggered.");
}
var Y3 = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
const jd = Y3;
function EE(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || q3(0), e.prototype.inspect = t, jd && (e.prototype[jd] = t);
}
var wE = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.start = r.start, this.end = n.end, this.startToken = r, this.endToken = n, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
}();
EE(wE);
var yt = /* @__PURE__ */ function() {
  function e(r, n, i, a, o, s, u) {
    this.kind = r, this.start = n, this.end = i, this.line = a, this.column = o, this.value = u, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
}();
EE(yt);
function qm(e) {
  return e != null && typeof e.kind == "string";
}
var q = Object.freeze({
  SOF: "<SOF>",
  EOF: "<EOF>",
  BANG: "!",
  DOLLAR: "$",
  AMP: "&",
  PAREN_L: "(",
  PAREN_R: ")",
  SPREAD: "...",
  COLON: ":",
  EQUALS: "=",
  AT: "@",
  BRACKET_L: "[",
  BRACKET_R: "]",
  BRACE_L: "{",
  PIPE: "|",
  BRACE_R: "}",
  NAME: "Name",
  INT: "Int",
  FLOAT: "Float",
  STRING: "String",
  BLOCK_STRING: "BlockString",
  COMMENT: "Comment"
});
function fu(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fu = function(r) {
    return typeof r;
  } : fu = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, fu(e);
}
var V3 = 10, SE = 2;
function Ih(e) {
  return Zl(e, []);
}
function Zl(e, t) {
  switch (fu(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : G3(e, t);
    default:
      return String(e);
  }
}
function G3(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var r = [].concat(t, [e]), n = X3(e);
  if (n !== void 0) {
    var i = n.call(e);
    if (i !== e)
      return typeof i == "string" ? i : Zl(i, r);
  } else if (Array.isArray(e))
    return Q3(e, r);
  return K3(e, r);
}
function K3(e, t) {
  var r = Object.keys(e);
  if (r.length === 0)
    return "{}";
  if (t.length > SE)
    return "[" + J3(e) + "]";
  var n = r.map(function(i) {
    var a = Zl(e[i], t);
    return i + ": " + a;
  });
  return "{ " + n.join(", ") + " }";
}
function Q3(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > SE)
    return "[Array]";
  for (var r = Math.min(V3, e.length), n = e.length - r, i = [], a = 0; a < r; ++a)
    i.push(Zl(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items")), "[" + i.join(", ") + "]";
}
function X3(e) {
  var t = e[String(jd)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function J3(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
function Uf(e, t) {
  var r = !!e;
  if (!r)
    throw new Error(t);
}
function du(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? du = function(r) {
    return typeof r;
  } : du = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, du(e);
}
const Z3 = process.env.NODE_ENV === "production" ? (
  // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
  // eslint-disable-next-line no-shadow
  function(t, r) {
    return t instanceof r;
  }
) : (
  // eslint-disable-next-line no-shadow
  function(t, r) {
    if (t instanceof r)
      return !0;
    if (du(t) === "object" && t !== null) {
      var n, i = r.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === a) {
        var o = Ih(t);
        throw new Error("Cannot use ".concat(i, ' "').concat(o, `" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`));
      }
    }
    return !1;
  }
);
function Ym(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function e6(e, t, r) {
  return t && Ym(e.prototype, t), r && Ym(e, r), e;
}
var _E = /* @__PURE__ */ function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof t == "string" || Uf(0, "Body must be a string. Received: ".concat(Ih(t), ".")), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || Uf(0, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || Uf(0, "column in locationOffset is 1-indexed and must be positive.");
  }
  return e6(e, [{
    key: yE,
    get: function() {
      return "Source";
    }
  }]), e;
}();
function t6(e) {
  return Z3(e, _E);
}
var r6 = Object.freeze({
  // Request Definitions
  QUERY: "QUERY",
  MUTATION: "MUTATION",
  SUBSCRIPTION: "SUBSCRIPTION",
  FIELD: "FIELD",
  FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
  FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
  INLINE_FRAGMENT: "INLINE_FRAGMENT",
  VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
  // Type System Definitions
  SCHEMA: "SCHEMA",
  SCALAR: "SCALAR",
  OBJECT: "OBJECT",
  FIELD_DEFINITION: "FIELD_DEFINITION",
  ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
  INTERFACE: "INTERFACE",
  UNION: "UNION",
  ENUM: "ENUM",
  ENUM_VALUE: "ENUM_VALUE",
  INPUT_OBJECT: "INPUT_OBJECT",
  INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});
function n6(e) {
  var t = e.split(/\r\n|[\n\r]/g), r = i6(e);
  if (r !== 0)
    for (var n = 1; n < t.length; n++)
      t[n] = t[n].slice(r);
  for (var i = 0; i < t.length && Vm(t[i]); )
    ++i;
  for (var a = t.length; a > i && Vm(t[a - 1]); )
    --a;
  return t.slice(i, a).join(`
`);
}
function Vm(e) {
  for (var t = 0; t < e.length; ++t)
    if (e[t] !== " " && e[t] !== "	")
      return !1;
  return !0;
}
function i6(e) {
  for (var t, r = !0, n = !0, i = 0, a = null, o = 0; o < e.length; ++o)
    switch (e.charCodeAt(o)) {
      case 13:
        e.charCodeAt(o + 1) === 10 && ++o;
      case 10:
        r = !1, n = !0, i = 0;
        break;
      case 9:
      case 32:
        ++i;
        break;
      default:
        n && !r && (a === null || i < a) && (a = i), n = !1;
    }
  return (t = a) !== null && t !== void 0 ? t : 0;
}
function a6(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", a = e[e.length - 1] === '"', o = e[e.length - 1] === "\\", s = !n || a || o || r, u = "";
  return s && !(n && i) && (u += `
` + t), u += t ? e.replace(/\n/g, `
` + t) : e, s && (u += `
`), '"""' + u.replace(/"""/g, '\\"""') + '"""';
}
var o6 = /* @__PURE__ */ function() {
  function e(r) {
    var n = new yt(q.SOF, 0, 0, 0, 0, null);
    this.source = r, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  var t = e.prototype;
  return t.advance = function() {
    this.lastToken = this.token;
    var n = this.token = this.lookahead();
    return n;
  }, t.lookahead = function() {
    var n = this.token;
    if (n.kind !== q.EOF)
      do {
        var i;
        n = (i = n.next) !== null && i !== void 0 ? i : n.next = u6(this, n);
      } while (n.kind === q.COMMENT);
    return n;
  }, e;
}();
function s6(e) {
  return e === q.BANG || e === q.DOLLAR || e === q.AMP || e === q.PAREN_L || e === q.PAREN_R || e === q.SPREAD || e === q.COLON || e === q.EQUALS || e === q.AT || e === q.BRACKET_L || e === q.BRACKET_R || e === q.BRACE_L || e === q.PIPE || e === q.BRACE_R;
}
function $i(e) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(e) ? q.EOF : (
      // Trust JSON for ASCII.
      e < 127 ? JSON.stringify(String.fromCharCode(e)) : (
        // Otherwise print the escaped form.
        '"\\u'.concat(("00" + e.toString(16).toUpperCase()).slice(-4), '"')
      )
    )
  );
}
function u6(e, t) {
  for (var r = e.source, n = r.body, i = n.length, a = t.end; a < i; ) {
    var o = n.charCodeAt(a), s = e.line, u = 1 + a - e.lineStart;
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++a;
        continue;
      case 10:
        ++a, ++e.line, e.lineStart = a;
        continue;
      case 13:
        n.charCodeAt(a + 1) === 10 ? a += 2 : ++a, ++e.line, e.lineStart = a;
        continue;
      case 33:
        return new yt(q.BANG, a, a + 1, s, u, t);
      case 35:
        return c6(r, a, s, u, t);
      case 36:
        return new yt(q.DOLLAR, a, a + 1, s, u, t);
      case 38:
        return new yt(q.AMP, a, a + 1, s, u, t);
      case 40:
        return new yt(q.PAREN_L, a, a + 1, s, u, t);
      case 41:
        return new yt(q.PAREN_R, a, a + 1, s, u, t);
      case 46:
        if (n.charCodeAt(a + 1) === 46 && n.charCodeAt(a + 2) === 46)
          return new yt(q.SPREAD, a, a + 3, s, u, t);
        break;
      case 58:
        return new yt(q.COLON, a, a + 1, s, u, t);
      case 61:
        return new yt(q.EQUALS, a, a + 1, s, u, t);
      case 64:
        return new yt(q.AT, a, a + 1, s, u, t);
      case 91:
        return new yt(q.BRACKET_L, a, a + 1, s, u, t);
      case 93:
        return new yt(q.BRACKET_R, a, a + 1, s, u, t);
      case 123:
        return new yt(q.BRACE_L, a, a + 1, s, u, t);
      case 124:
        return new yt(q.PIPE, a, a + 1, s, u, t);
      case 125:
        return new yt(q.BRACE_R, a, a + 1, s, u, t);
      case 34:
        return n.charCodeAt(a + 1) === 34 && n.charCodeAt(a + 2) === 34 ? h6(r, a, s, u, t, e) : d6(r, a, s, u, t);
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
        return f6(r, a, o, s, u, t);
      case 65:
      case 66:
      case 67:
      case 68:
      case 69:
      case 70:
      case 71:
      case 72:
      case 73:
      case 74:
      case 75:
      case 76:
      case 77:
      case 78:
      case 79:
      case 80:
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 95:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
      case 106:
      case 107:
      case 108:
      case 109:
      case 110:
      case 111:
      case 112:
      case 113:
      case 114:
      case 115:
      case 116:
      case 117:
      case 118:
      case 119:
      case 120:
      case 121:
      case 122:
        return v6(r, a, s, u, t);
    }
    throw or(r, a, l6(o));
  }
  var l = e.line, c = 1 + a - e.lineStart;
  return new yt(q.EOF, i, i, l, c, t);
}
function l6(e) {
  return e < 32 && e !== 9 && e !== 10 && e !== 13 ? "Cannot contain the invalid character ".concat($i(e), ".") : e === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : "Cannot parse the unexpected character ".concat($i(e), ".");
}
function c6(e, t, r, n, i) {
  var a = e.body, o, s = t;
  do
    o = a.charCodeAt(++s);
  while (!isNaN(o) && // SourceCharacter but not LineTerminator
  (o > 31 || o === 9));
  return new yt(q.COMMENT, t, s, r, n, i, a.slice(t + 1, s));
}
function f6(e, t, r, n, i, a) {
  var o = e.body, s = r, u = t, l = !1;
  if (s === 45 && (s = o.charCodeAt(++u)), s === 48) {
    if (s = o.charCodeAt(++u), s >= 48 && s <= 57)
      throw or(e, u, "Invalid number, unexpected digit after 0: ".concat($i(s), "."));
  } else
    u = Hf(e, u, s), s = o.charCodeAt(u);
  if (s === 46 && (l = !0, s = o.charCodeAt(++u), u = Hf(e, u, s), s = o.charCodeAt(u)), (s === 69 || s === 101) && (l = !0, s = o.charCodeAt(++u), (s === 43 || s === 45) && (s = o.charCodeAt(++u)), u = Hf(e, u, s), s = o.charCodeAt(u)), s === 46 || m6(s))
    throw or(e, u, "Invalid number, expected digit but got: ".concat($i(s), "."));
  return new yt(l ? q.FLOAT : q.INT, t, u, n, i, a, o.slice(t, u));
}
function Hf(e, t, r) {
  var n = e.body, i = t, a = r;
  if (a >= 48 && a <= 57) {
    do
      a = n.charCodeAt(++i);
    while (a >= 48 && a <= 57);
    return i;
  }
  throw or(e, i, "Invalid number, expected digit but got: ".concat($i(a), "."));
}
function d6(e, t, r, n, i) {
  for (var a = e.body, o = t + 1, s = o, u = 0, l = ""; o < a.length && !isNaN(u = a.charCodeAt(o)) && // not LineTerminator
  u !== 10 && u !== 13; ) {
    if (u === 34)
      return l += a.slice(s, o), new yt(q.STRING, t, o + 1, r, n, i, l);
    if (u < 32 && u !== 9)
      throw or(e, o, "Invalid character within String: ".concat($i(u), "."));
    if (++o, u === 92) {
      switch (l += a.slice(s, o - 1), u = a.charCodeAt(o), u) {
        case 34:
          l += '"';
          break;
        case 47:
          l += "/";
          break;
        case 92:
          l += "\\";
          break;
        case 98:
          l += "\b";
          break;
        case 102:
          l += "\f";
          break;
        case 110:
          l += `
`;
          break;
        case 114:
          l += "\r";
          break;
        case 116:
          l += "	";
          break;
        case 117: {
          var c = p6(a.charCodeAt(o + 1), a.charCodeAt(o + 2), a.charCodeAt(o + 3), a.charCodeAt(o + 4));
          if (c < 0) {
            var f = a.slice(o + 1, o + 5);
            throw or(e, o, "Invalid character escape sequence: \\u".concat(f, "."));
          }
          l += String.fromCharCode(c), o += 4;
          break;
        }
        default:
          throw or(e, o, "Invalid character escape sequence: \\".concat(String.fromCharCode(u), "."));
      }
      ++o, s = o;
    }
  }
  throw or(e, o, "Unterminated string.");
}
function h6(e, t, r, n, i, a) {
  for (var o = e.body, s = t + 3, u = s, l = 0, c = ""; s < o.length && !isNaN(l = o.charCodeAt(s)); ) {
    if (l === 34 && o.charCodeAt(s + 1) === 34 && o.charCodeAt(s + 2) === 34)
      return c += o.slice(u, s), new yt(q.BLOCK_STRING, t, s + 3, r, n, i, n6(c));
    if (l < 32 && l !== 9 && l !== 10 && l !== 13)
      throw or(e, s, "Invalid character within String: ".concat($i(l), "."));
    l === 10 ? (++s, ++a.line, a.lineStart = s) : l === 13 ? (o.charCodeAt(s + 1) === 10 ? s += 2 : ++s, ++a.line, a.lineStart = s) : /* Escape Triple-Quote (\""") */ l === 92 && o.charCodeAt(s + 1) === 34 && o.charCodeAt(s + 2) === 34 && o.charCodeAt(s + 3) === 34 ? (c += o.slice(u, s) + '"""', s += 4, u = s) : ++s;
  }
  throw or(e, s, "Unterminated string.");
}
function p6(e, t, r, n) {
  return Ls(e) << 12 | Ls(t) << 8 | Ls(r) << 4 | Ls(n);
}
function Ls(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function v6(e, t, r, n, i) {
  for (var a = e.body, o = a.length, s = t + 1, u = 0; s !== o && !isNaN(u = a.charCodeAt(s)) && (u === 95 || // _
  u >= 48 && u <= 57 || // 0-9
  u >= 65 && u <= 90 || // A-Z
  u >= 97 && u <= 122); )
    ++s;
  return new yt(q.NAME, t, s, r, n, i, a.slice(t, s));
}
function m6(e) {
  return e === 95 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function Wf(e, t) {
  var r = new y6(e, t);
  return r.parseDocument();
}
var y6 = /* @__PURE__ */ function() {
  function e(r, n) {
    var i = t6(r) ? r : new _E(r);
    this._lexer = new o6(i), this._options = n;
  }
  var t = e.prototype;
  return t.parseName = function() {
    var n = this.expectToken(q.NAME);
    return {
      kind: ge.NAME,
      value: n.value,
      loc: this.loc(n)
    };
  }, t.parseDocument = function() {
    var n = this._lexer.token;
    return {
      kind: ge.DOCUMENT,
      definitions: this.many(q.SOF, this.parseDefinition, q.EOF),
      loc: this.loc(n)
    };
  }, t.parseDefinition = function() {
    if (this.peek(q.NAME))
      switch (this._lexer.token.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "schema":
        case "scalar":
        case "type":
        case "interface":
        case "union":
        case "enum":
        case "input":
        case "directive":
          return this.parseTypeSystemDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    else {
      if (this.peek(q.BRACE_L))
        return this.parseOperationDefinition();
      if (this.peekDescription())
        return this.parseTypeSystemDefinition();
    }
    throw this.unexpected();
  }, t.parseOperationDefinition = function() {
    var n = this._lexer.token;
    if (this.peek(q.BRACE_L))
      return {
        kind: ge.OPERATION_DEFINITION,
        operation: "query",
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(n)
      };
    var i = this.parseOperationType(), a;
    return this.peek(q.NAME) && (a = this.parseName()), {
      kind: ge.OPERATION_DEFINITION,
      operation: i,
      name: a,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(n)
    };
  }, t.parseOperationType = function() {
    var n = this.expectToken(q.NAME);
    switch (n.value) {
      case "query":
        return "query";
      case "mutation":
        return "mutation";
      case "subscription":
        return "subscription";
    }
    throw this.unexpected(n);
  }, t.parseVariableDefinitions = function() {
    return this.optionalMany(q.PAREN_L, this.parseVariableDefinition, q.PAREN_R);
  }, t.parseVariableDefinition = function() {
    var n = this._lexer.token;
    return {
      kind: ge.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(q.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(q.EQUALS) ? this.parseValueLiteral(!0) : void 0,
      directives: this.parseDirectives(!0),
      loc: this.loc(n)
    };
  }, t.parseVariable = function() {
    var n = this._lexer.token;
    return this.expectToken(q.DOLLAR), {
      kind: ge.VARIABLE,
      name: this.parseName(),
      loc: this.loc(n)
    };
  }, t.parseSelectionSet = function() {
    var n = this._lexer.token;
    return {
      kind: ge.SELECTION_SET,
      selections: this.many(q.BRACE_L, this.parseSelection, q.BRACE_R),
      loc: this.loc(n)
    };
  }, t.parseSelection = function() {
    return this.peek(q.SPREAD) ? this.parseFragment() : this.parseField();
  }, t.parseField = function() {
    var n = this._lexer.token, i = this.parseName(), a, o;
    return this.expectOptionalToken(q.COLON) ? (a = i, o = this.parseName()) : o = i, {
      kind: ge.FIELD,
      alias: a,
      name: o,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(q.BRACE_L) ? this.parseSelectionSet() : void 0,
      loc: this.loc(n)
    };
  }, t.parseArguments = function(n) {
    var i = n ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(q.PAREN_L, i, q.PAREN_R);
  }, t.parseArgument = function() {
    var n = this._lexer.token, i = this.parseName();
    return this.expectToken(q.COLON), {
      kind: ge.ARGUMENT,
      name: i,
      value: this.parseValueLiteral(!1),
      loc: this.loc(n)
    };
  }, t.parseConstArgument = function() {
    var n = this._lexer.token;
    return {
      kind: ge.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(q.COLON), this.parseValueLiteral(!0)),
      loc: this.loc(n)
    };
  }, t.parseFragment = function() {
    var n = this._lexer.token;
    this.expectToken(q.SPREAD);
    var i = this.expectOptionalKeyword("on");
    return !i && this.peek(q.NAME) ? {
      kind: ge.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1),
      loc: this.loc(n)
    } : {
      kind: ge.INLINE_FRAGMENT,
      typeCondition: i ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(n)
    };
  }, t.parseFragmentDefinition = function() {
    var n, i = this._lexer.token;
    return this.expectKeyword("fragment"), ((n = this._options) === null || n === void 0 ? void 0 : n.experimentalFragmentVariables) === !0 ? {
      kind: ge.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(i)
    } : {
      kind: ge.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(i)
    };
  }, t.parseFragmentName = function() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }, t.parseValueLiteral = function(n) {
    var i = this._lexer.token;
    switch (i.kind) {
      case q.BRACKET_L:
        return this.parseList(n);
      case q.BRACE_L:
        return this.parseObject(n);
      case q.INT:
        return this._lexer.advance(), {
          kind: ge.INT,
          value: i.value,
          loc: this.loc(i)
        };
      case q.FLOAT:
        return this._lexer.advance(), {
          kind: ge.FLOAT,
          value: i.value,
          loc: this.loc(i)
        };
      case q.STRING:
      case q.BLOCK_STRING:
        return this.parseStringLiteral();
      case q.NAME:
        switch (this._lexer.advance(), i.value) {
          case "true":
            return {
              kind: ge.BOOLEAN,
              value: !0,
              loc: this.loc(i)
            };
          case "false":
            return {
              kind: ge.BOOLEAN,
              value: !1,
              loc: this.loc(i)
            };
          case "null":
            return {
              kind: ge.NULL,
              loc: this.loc(i)
            };
          default:
            return {
              kind: ge.ENUM,
              value: i.value,
              loc: this.loc(i)
            };
        }
      case q.DOLLAR:
        if (!n)
          return this.parseVariable();
        break;
    }
    throw this.unexpected();
  }, t.parseStringLiteral = function() {
    var n = this._lexer.token;
    return this._lexer.advance(), {
      kind: ge.STRING,
      value: n.value,
      block: n.kind === q.BLOCK_STRING,
      loc: this.loc(n)
    };
  }, t.parseList = function(n) {
    var i = this, a = this._lexer.token, o = function() {
      return i.parseValueLiteral(n);
    };
    return {
      kind: ge.LIST,
      values: this.any(q.BRACKET_L, o, q.BRACKET_R),
      loc: this.loc(a)
    };
  }, t.parseObject = function(n) {
    var i = this, a = this._lexer.token, o = function() {
      return i.parseObjectField(n);
    };
    return {
      kind: ge.OBJECT,
      fields: this.any(q.BRACE_L, o, q.BRACE_R),
      loc: this.loc(a)
    };
  }, t.parseObjectField = function(n) {
    var i = this._lexer.token, a = this.parseName();
    return this.expectToken(q.COLON), {
      kind: ge.OBJECT_FIELD,
      name: a,
      value: this.parseValueLiteral(n),
      loc: this.loc(i)
    };
  }, t.parseDirectives = function(n) {
    for (var i = []; this.peek(q.AT); )
      i.push(this.parseDirective(n));
    return i;
  }, t.parseDirective = function(n) {
    var i = this._lexer.token;
    return this.expectToken(q.AT), {
      kind: ge.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(n),
      loc: this.loc(i)
    };
  }, t.parseTypeReference = function() {
    var n = this._lexer.token, i;
    return this.expectOptionalToken(q.BRACKET_L) ? (i = this.parseTypeReference(), this.expectToken(q.BRACKET_R), i = {
      kind: ge.LIST_TYPE,
      type: i,
      loc: this.loc(n)
    }) : i = this.parseNamedType(), this.expectOptionalToken(q.BANG) ? {
      kind: ge.NON_NULL_TYPE,
      type: i,
      loc: this.loc(n)
    } : i;
  }, t.parseNamedType = function() {
    var n = this._lexer.token;
    return {
      kind: ge.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(n)
    };
  }, t.parseTypeSystemDefinition = function() {
    var n = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === q.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
    throw this.unexpected(n);
  }, t.peekDescription = function() {
    return this.peek(q.STRING) || this.peek(q.BLOCK_STRING);
  }, t.parseDescription = function() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }, t.parseSchemaDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("schema");
    var a = this.parseDirectives(!0), o = this.many(q.BRACE_L, this.parseOperationTypeDefinition, q.BRACE_R);
    return {
      kind: ge.SCHEMA_DEFINITION,
      description: i,
      directives: a,
      operationTypes: o,
      loc: this.loc(n)
    };
  }, t.parseOperationTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseOperationType();
    this.expectToken(q.COLON);
    var a = this.parseNamedType();
    return {
      kind: ge.OPERATION_TYPE_DEFINITION,
      operation: i,
      type: a,
      loc: this.loc(n)
    };
  }, t.parseScalarTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("scalar");
    var a = this.parseName(), o = this.parseDirectives(!0);
    return {
      kind: ge.SCALAR_TYPE_DEFINITION,
      description: i,
      name: a,
      directives: o,
      loc: this.loc(n)
    };
  }, t.parseObjectTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("type");
    var a = this.parseName(), o = this.parseImplementsInterfaces(), s = this.parseDirectives(!0), u = this.parseFieldsDefinition();
    return {
      kind: ge.OBJECT_TYPE_DEFINITION,
      description: i,
      name: a,
      interfaces: o,
      directives: s,
      fields: u,
      loc: this.loc(n)
    };
  }, t.parseImplementsInterfaces = function() {
    var n;
    if (!this.expectOptionalKeyword("implements"))
      return [];
    if (((n = this._options) === null || n === void 0 ? void 0 : n.allowLegacySDLImplementsInterfaces) === !0) {
      var i = [];
      this.expectOptionalToken(q.AMP);
      do
        i.push(this.parseNamedType());
      while (this.expectOptionalToken(q.AMP) || this.peek(q.NAME));
      return i;
    }
    return this.delimitedMany(q.AMP, this.parseNamedType);
  }, t.parseFieldsDefinition = function() {
    var n;
    return ((n = this._options) === null || n === void 0 ? void 0 : n.allowLegacySDLEmptyFields) === !0 && this.peek(q.BRACE_L) && this._lexer.lookahead().kind === q.BRACE_R ? (this._lexer.advance(), this._lexer.advance(), []) : this.optionalMany(q.BRACE_L, this.parseFieldDefinition, q.BRACE_R);
  }, t.parseFieldDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription(), a = this.parseName(), o = this.parseArgumentDefs();
    this.expectToken(q.COLON);
    var s = this.parseTypeReference(), u = this.parseDirectives(!0);
    return {
      kind: ge.FIELD_DEFINITION,
      description: i,
      name: a,
      arguments: o,
      type: s,
      directives: u,
      loc: this.loc(n)
    };
  }, t.parseArgumentDefs = function() {
    return this.optionalMany(q.PAREN_L, this.parseInputValueDef, q.PAREN_R);
  }, t.parseInputValueDef = function() {
    var n = this._lexer.token, i = this.parseDescription(), a = this.parseName();
    this.expectToken(q.COLON);
    var o = this.parseTypeReference(), s;
    this.expectOptionalToken(q.EQUALS) && (s = this.parseValueLiteral(!0));
    var u = this.parseDirectives(!0);
    return {
      kind: ge.INPUT_VALUE_DEFINITION,
      description: i,
      name: a,
      type: o,
      defaultValue: s,
      directives: u,
      loc: this.loc(n)
    };
  }, t.parseInterfaceTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("interface");
    var a = this.parseName(), o = this.parseImplementsInterfaces(), s = this.parseDirectives(!0), u = this.parseFieldsDefinition();
    return {
      kind: ge.INTERFACE_TYPE_DEFINITION,
      description: i,
      name: a,
      interfaces: o,
      directives: s,
      fields: u,
      loc: this.loc(n)
    };
  }, t.parseUnionTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("union");
    var a = this.parseName(), o = this.parseDirectives(!0), s = this.parseUnionMemberTypes();
    return {
      kind: ge.UNION_TYPE_DEFINITION,
      description: i,
      name: a,
      directives: o,
      types: s,
      loc: this.loc(n)
    };
  }, t.parseUnionMemberTypes = function() {
    return this.expectOptionalToken(q.EQUALS) ? this.delimitedMany(q.PIPE, this.parseNamedType) : [];
  }, t.parseEnumTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("enum");
    var a = this.parseName(), o = this.parseDirectives(!0), s = this.parseEnumValuesDefinition();
    return {
      kind: ge.ENUM_TYPE_DEFINITION,
      description: i,
      name: a,
      directives: o,
      values: s,
      loc: this.loc(n)
    };
  }, t.parseEnumValuesDefinition = function() {
    return this.optionalMany(q.BRACE_L, this.parseEnumValueDefinition, q.BRACE_R);
  }, t.parseEnumValueDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription(), a = this.parseName(), o = this.parseDirectives(!0);
    return {
      kind: ge.ENUM_VALUE_DEFINITION,
      description: i,
      name: a,
      directives: o,
      loc: this.loc(n)
    };
  }, t.parseInputObjectTypeDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("input");
    var a = this.parseName(), o = this.parseDirectives(!0), s = this.parseInputFieldsDefinition();
    return {
      kind: ge.INPUT_OBJECT_TYPE_DEFINITION,
      description: i,
      name: a,
      directives: o,
      fields: s,
      loc: this.loc(n)
    };
  }, t.parseInputFieldsDefinition = function() {
    return this.optionalMany(q.BRACE_L, this.parseInputValueDef, q.BRACE_R);
  }, t.parseTypeSystemExtension = function() {
    var n = this._lexer.lookahead();
    if (n.kind === q.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(n);
  }, t.parseSchemaExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    var i = this.parseDirectives(!0), a = this.optionalMany(q.BRACE_L, this.parseOperationTypeDefinition, q.BRACE_R);
    if (i.length === 0 && a.length === 0)
      throw this.unexpected();
    return {
      kind: ge.SCHEMA_EXTENSION,
      directives: i,
      operationTypes: a,
      loc: this.loc(n)
    };
  }, t.parseScalarTypeExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    var i = this.parseName(), a = this.parseDirectives(!0);
    if (a.length === 0)
      throw this.unexpected();
    return {
      kind: ge.SCALAR_TYPE_EXTENSION,
      name: i,
      directives: a,
      loc: this.loc(n)
    };
  }, t.parseObjectTypeExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    var i = this.parseName(), a = this.parseImplementsInterfaces(), o = this.parseDirectives(!0), s = this.parseFieldsDefinition();
    if (a.length === 0 && o.length === 0 && s.length === 0)
      throw this.unexpected();
    return {
      kind: ge.OBJECT_TYPE_EXTENSION,
      name: i,
      interfaces: a,
      directives: o,
      fields: s,
      loc: this.loc(n)
    };
  }, t.parseInterfaceTypeExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    var i = this.parseName(), a = this.parseImplementsInterfaces(), o = this.parseDirectives(!0), s = this.parseFieldsDefinition();
    if (a.length === 0 && o.length === 0 && s.length === 0)
      throw this.unexpected();
    return {
      kind: ge.INTERFACE_TYPE_EXTENSION,
      name: i,
      interfaces: a,
      directives: o,
      fields: s,
      loc: this.loc(n)
    };
  }, t.parseUnionTypeExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    var i = this.parseName(), a = this.parseDirectives(!0), o = this.parseUnionMemberTypes();
    if (a.length === 0 && o.length === 0)
      throw this.unexpected();
    return {
      kind: ge.UNION_TYPE_EXTENSION,
      name: i,
      directives: a,
      types: o,
      loc: this.loc(n)
    };
  }, t.parseEnumTypeExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    var i = this.parseName(), a = this.parseDirectives(!0), o = this.parseEnumValuesDefinition();
    if (a.length === 0 && o.length === 0)
      throw this.unexpected();
    return {
      kind: ge.ENUM_TYPE_EXTENSION,
      name: i,
      directives: a,
      values: o,
      loc: this.loc(n)
    };
  }, t.parseInputObjectTypeExtension = function() {
    var n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    var i = this.parseName(), a = this.parseDirectives(!0), o = this.parseInputFieldsDefinition();
    if (a.length === 0 && o.length === 0)
      throw this.unexpected();
    return {
      kind: ge.INPUT_OBJECT_TYPE_EXTENSION,
      name: i,
      directives: a,
      fields: o,
      loc: this.loc(n)
    };
  }, t.parseDirectiveDefinition = function() {
    var n = this._lexer.token, i = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(q.AT);
    var a = this.parseName(), o = this.parseArgumentDefs(), s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    var u = this.parseDirectiveLocations();
    return {
      kind: ge.DIRECTIVE_DEFINITION,
      description: i,
      name: a,
      arguments: o,
      repeatable: s,
      locations: u,
      loc: this.loc(n)
    };
  }, t.parseDirectiveLocations = function() {
    return this.delimitedMany(q.PIPE, this.parseDirectiveLocation);
  }, t.parseDirectiveLocation = function() {
    var n = this._lexer.token, i = this.parseName();
    if (r6[i.value] !== void 0)
      return i;
    throw this.unexpected(n);
  }, t.loc = function(n) {
    var i;
    if (((i = this._options) === null || i === void 0 ? void 0 : i.noLocation) !== !0)
      return new wE(n, this._lexer.lastToken, this._lexer.source);
  }, t.peek = function(n) {
    return this._lexer.token.kind === n;
  }, t.expectToken = function(n) {
    var i = this._lexer.token;
    if (i.kind === n)
      return this._lexer.advance(), i;
    throw or(this._lexer.source, i.start, "Expected ".concat(TE(n), ", found ").concat(zf(i), "."));
  }, t.expectOptionalToken = function(n) {
    var i = this._lexer.token;
    if (i.kind === n)
      return this._lexer.advance(), i;
  }, t.expectKeyword = function(n) {
    var i = this._lexer.token;
    if (i.kind === q.NAME && i.value === n)
      this._lexer.advance();
    else
      throw or(this._lexer.source, i.start, 'Expected "'.concat(n, '", found ').concat(zf(i), "."));
  }, t.expectOptionalKeyword = function(n) {
    var i = this._lexer.token;
    return i.kind === q.NAME && i.value === n ? (this._lexer.advance(), !0) : !1;
  }, t.unexpected = function(n) {
    var i = n ?? this._lexer.token;
    return or(this._lexer.source, i.start, "Unexpected ".concat(zf(i), "."));
  }, t.any = function(n, i, a) {
    this.expectToken(n);
    for (var o = []; !this.expectOptionalToken(a); )
      o.push(i.call(this));
    return o;
  }, t.optionalMany = function(n, i, a) {
    if (this.expectOptionalToken(n)) {
      var o = [];
      do
        o.push(i.call(this));
      while (!this.expectOptionalToken(a));
      return o;
    }
    return [];
  }, t.many = function(n, i, a) {
    this.expectToken(n);
    var o = [];
    do
      o.push(i.call(this));
    while (!this.expectOptionalToken(a));
    return o;
  }, t.delimitedMany = function(n, i) {
    this.expectOptionalToken(n);
    var a = [];
    do
      a.push(i.call(this));
    while (this.expectOptionalToken(n));
    return a;
  }, e;
}();
function zf(e) {
  var t = e.value;
  return TE(e.kind) + (t != null ? ' "'.concat(t, '"') : "");
}
function TE(e) {
  return s6(e) ? '"'.concat(e, '"') : e;
}
var g6 = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, x6 = Object.freeze({});
function b6(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : g6, n = void 0, i = Array.isArray(e), a = [e], o = -1, s = [], u = void 0, l = void 0, c = void 0, f = [], d = [], h = e;
  do {
    o++;
    var p = o === a.length, v = p && s.length !== 0;
    if (p) {
      if (l = d.length === 0 ? void 0 : f[f.length - 1], u = c, c = d.pop(), v) {
        if (i)
          u = u.slice();
        else {
          for (var m = {}, x = 0, y = Object.keys(u); x < y.length; x++) {
            var g = y[x];
            m[g] = u[g];
          }
          u = m;
        }
        for (var E = 0, b = 0; b < s.length; b++) {
          var w = s[b][0], _ = s[b][1];
          i && (w -= E), i && _ === null ? (u.splice(w, 1), E++) : u[w] = _;
        }
      }
      o = n.index, a = n.keys, s = n.edits, i = n.inArray, n = n.prev;
    } else {
      if (l = c ? i ? o : a[o] : void 0, u = c ? c[l] : h, u == null)
        continue;
      c && f.push(l);
    }
    var A = void 0;
    if (!Array.isArray(u)) {
      if (!qm(u))
        throw new Error("Invalid AST Node: ".concat(Ih(u), "."));
      var O = E6(t, u.kind, p);
      if (O) {
        if (A = O.call(t, u, l, c, f, d), A === x6)
          break;
        if (A === !1) {
          if (!p) {
            f.pop();
            continue;
          }
        } else if (A !== void 0 && (s.push([l, A]), !p))
          if (qm(A))
            u = A;
          else {
            f.pop();
            continue;
          }
      }
    }
    if (A === void 0 && v && s.push([l, u]), p)
      f.pop();
    else {
      var T;
      n = {
        inArray: i,
        index: o,
        keys: a,
        edits: s,
        prev: n
      }, i = Array.isArray(u), a = i ? u : (T = r[u.kind]) !== null && T !== void 0 ? T : [], o = -1, s = [], c && d.push(c), c = u;
    }
  } while (n !== void 0);
  return s.length !== 0 && (h = s[s.length - 1][1]), h;
}
function E6(e, t, r) {
  var n = e[t];
  if (n) {
    if (!r && typeof n == "function")
      return n;
    var i = r ? n.leave : n.enter;
    if (typeof i == "function")
      return i;
  } else {
    var a = r ? e.leave : e.enter;
    if (a) {
      if (typeof a == "function")
        return a;
      var o = a[t];
      if (typeof o == "function")
        return o;
    }
  }
}
function uo(e) {
  return b6(e, {
    leave: S6
  });
}
var w6 = 80, S6 = {
  Name: function(t) {
    return t.value;
  },
  Variable: function(t) {
    return "$" + t.name;
  },
  // Document
  Document: function(t) {
    return se(t.definitions, `

`) + `
`;
  },
  OperationDefinition: function(t) {
    var r = t.operation, n = t.name, i = dt("(", se(t.variableDefinitions, ", "), ")"), a = se(t.directives, " "), o = t.selectionSet;
    return !n && !a && !i && r === "query" ? o : se([r, se([n, i]), a, o], " ");
  },
  VariableDefinition: function(t) {
    var r = t.variable, n = t.type, i = t.defaultValue, a = t.directives;
    return r + ": " + n + dt(" = ", i) + dt(" ", se(a, " "));
  },
  SelectionSet: function(t) {
    var r = t.selections;
    return br(r);
  },
  Field: function(t) {
    var r = t.alias, n = t.name, i = t.arguments, a = t.directives, o = t.selectionSet, s = dt("", r, ": ") + n, u = s + dt("(", se(i, ", "), ")");
    return u.length > w6 && (u = s + dt(`(
`, hu(se(i, `
`)), `
)`)), se([u, se(a, " "), o], " ");
  },
  Argument: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Fragments
  FragmentSpread: function(t) {
    var r = t.name, n = t.directives;
    return "..." + r + dt(" ", se(n, " "));
  },
  InlineFragment: function(t) {
    var r = t.typeCondition, n = t.directives, i = t.selectionSet;
    return se(["...", dt("on ", r), se(n, " "), i], " ");
  },
  FragmentDefinition: function(t) {
    var r = t.name, n = t.typeCondition, i = t.variableDefinitions, a = t.directives, o = t.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(r).concat(dt("(", se(i, ", "), ")"), " ") + "on ".concat(n, " ").concat(dt("", se(a, " "), " ")) + o
    );
  },
  // Value
  IntValue: function(t) {
    var r = t.value;
    return r;
  },
  FloatValue: function(t) {
    var r = t.value;
    return r;
  },
  StringValue: function(t, r) {
    var n = t.value, i = t.block;
    return i ? a6(n, r === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(t) {
    var r = t.value;
    return r ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(t) {
    var r = t.value;
    return r;
  },
  ListValue: function(t) {
    var r = t.values;
    return "[" + se(r, ", ") + "]";
  },
  ObjectValue: function(t) {
    var r = t.fields;
    return "{" + se(r, ", ") + "}";
  },
  ObjectField: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Directive
  Directive: function(t) {
    var r = t.name, n = t.arguments;
    return "@" + r + dt("(", se(n, ", "), ")");
  },
  // Type
  NamedType: function(t) {
    var r = t.name;
    return r;
  },
  ListType: function(t) {
    var r = t.type;
    return "[" + r + "]";
  },
  NonNullType: function(t) {
    var r = t.type;
    return r + "!";
  },
  // Type System Definitions
  SchemaDefinition: xr(function(e) {
    var t = e.directives, r = e.operationTypes;
    return se(["schema", se(t, " "), br(r)], " ");
  }),
  OperationTypeDefinition: function(t) {
    var r = t.operation, n = t.type;
    return r + ": " + n;
  },
  ScalarTypeDefinition: xr(function(e) {
    var t = e.name, r = e.directives;
    return se(["scalar", t, se(r, " ")], " ");
  }),
  ObjectTypeDefinition: xr(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return se(["type", t, dt("implements ", se(r, " & ")), se(n, " "), br(i)], " ");
  }),
  FieldDefinition: xr(function(e) {
    var t = e.name, r = e.arguments, n = e.type, i = e.directives;
    return t + (Gm(r) ? dt(`(
`, hu(se(r, `
`)), `
)`) : dt("(", se(r, ", "), ")")) + ": " + n + dt(" ", se(i, " "));
  }),
  InputValueDefinition: xr(function(e) {
    var t = e.name, r = e.type, n = e.defaultValue, i = e.directives;
    return se([t + ": " + r, dt("= ", n), se(i, " ")], " ");
  }),
  InterfaceTypeDefinition: xr(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return se(["interface", t, dt("implements ", se(r, " & ")), se(n, " "), br(i)], " ");
  }),
  UnionTypeDefinition: xr(function(e) {
    var t = e.name, r = e.directives, n = e.types;
    return se(["union", t, se(r, " "), n && n.length !== 0 ? "= " + se(n, " | ") : ""], " ");
  }),
  EnumTypeDefinition: xr(function(e) {
    var t = e.name, r = e.directives, n = e.values;
    return se(["enum", t, se(r, " "), br(n)], " ");
  }),
  EnumValueDefinition: xr(function(e) {
    var t = e.name, r = e.directives;
    return se([t, se(r, " ")], " ");
  }),
  InputObjectTypeDefinition: xr(function(e) {
    var t = e.name, r = e.directives, n = e.fields;
    return se(["input", t, se(r, " "), br(n)], " ");
  }),
  DirectiveDefinition: xr(function(e) {
    var t = e.name, r = e.arguments, n = e.repeatable, i = e.locations;
    return "directive @" + t + (Gm(r) ? dt(`(
`, hu(se(r, `
`)), `
)`) : dt("(", se(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + se(i, " | ");
  }),
  SchemaExtension: function(t) {
    var r = t.directives, n = t.operationTypes;
    return se(["extend schema", se(r, " "), br(n)], " ");
  },
  ScalarTypeExtension: function(t) {
    var r = t.name, n = t.directives;
    return se(["extend scalar", r, se(n, " ")], " ");
  },
  ObjectTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, a = t.fields;
    return se(["extend type", r, dt("implements ", se(n, " & ")), se(i, " "), br(a)], " ");
  },
  InterfaceTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, a = t.fields;
    return se(["extend interface", r, dt("implements ", se(n, " & ")), se(i, " "), br(a)], " ");
  },
  UnionTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.types;
    return se(["extend union", r, se(n, " "), i && i.length !== 0 ? "= " + se(i, " | ") : ""], " ");
  },
  EnumTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.values;
    return se(["extend enum", r, se(n, " "), br(i)], " ");
  },
  InputObjectTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.fields;
    return se(["extend input", r, se(n, " "), br(i)], " ");
  }
};
function xr(e) {
  return function(t) {
    return se([t.description, e(t)], `
`);
  };
}
function se(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e == null ? void 0 : e.filter(function(n) {
    return n;
  }).join(r)) !== null && t !== void 0 ? t : "";
}
function br(e) {
  return dt(`{
`, hu(se(e, `
`)), `
}`);
}
function dt(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + r : "";
}
function hu(e) {
  return dt("  ", e.replace(/\n/g, `
  `));
}
function _6(e) {
  return e.indexOf(`
`) !== -1;
}
function Gm(e) {
  return e != null && e.some(_6);
}
class Wo extends Nu {
  constructor(t) {
    super(t), this.constructor = Wo, Object.setPrototypeOf(this, Wo.prototype);
  }
}
class zo extends Wo {
  constructor(t = {}) {
    super({
      name: "CanceledError",
      message: "Request is canceled by user",
      ...t
    }), this.constructor = zo, Object.setPrototypeOf(this, zo.prototype);
  }
}
const T6 = (e) => !!e && e instanceof zo;
var Ld;
(function(e) {
  e.InvalidApiName = "InvalidApiName";
})(Ld || (Ld = {}));
Ld.InvalidApiName + "";
const AE = async (e) => {
  var r;
  if (!e)
    return;
  const t = await yT(A6(e));
  if (t) {
    const n = await ((r = e.body) == null ? void 0 : r.text());
    return C6(t, {
      statusCode: e.statusCode,
      headers: e.headers,
      body: n
    });
  }
}, A6 = (e) => {
  let t;
  const r = new Proxy(e.body, {
    get(i, a, o) {
      return a === "json" ? async () => {
        t || (t = i.text());
        try {
          return JSON.parse(await t);
        } catch {
          return {};
        }
      } : a === "text" ? async () => (t || (t = i.text()), t) : Reflect.get(i, a, o);
    }
  });
  return new Proxy(e, {
    get(i, a, o) {
      return a === "body" ? r : Reflect.get(i, a, o);
    }
  });
}, C6 = (e, t) => {
  const r = new Wo({
    name: e == null ? void 0 : e.name,
    message: e.message,
    underlyingError: e,
    response: t
  });
  return Object.assign(r, { $metadata: e.$metadata });
}, Ud = new cl("RestApis");
function O6(e, t) {
  const r = (u) => !!t, n = new AbortController(), i = n.signal, a = t == null ? void 0 : t.signal;
  let o;
  const s = async () => {
    try {
      const u = await (r(e) ? e() : e(i));
      if (u.statusCode >= 300)
        throw await AE(u);
      return u;
    } catch (u) {
      const l = a ?? i, c = o ?? l.reason;
      if (u.name === "AbortError" || (l == null ? void 0 : l.aborted) === !0) {
        const f = new zo({
          ...c && { message: c },
          underlyingError: u,
          recoverySuggestion: "The API request was explicitly canceled. If this is not intended, validate if you called the `cancel()` function on the API request erroneously."
        });
        throw Ud.debug(u), f;
      }
      throw Ud.debug(u), u;
    }
  };
  if (r())
    return s();
  {
    const u = (l) => {
      i.aborted !== !0 && (n.abort(l), l && i.reason !== l && (o = l));
    };
    return { response: s(), cancel: u };
  }
}
const Km = "execute-api", D6 = "us-east-1", F6 = /^.+\.([a-z0-9-]+)\.([a-z0-9-]+)\.amazonaws\.com/, I6 = (e, t) => {
  var s, u, l;
  const { service: r = Km, region: n = D6 } = ((l = (u = (s = t == null ? void 0 : t.amplify.getConfig()) == null ? void 0 : s.API) == null ? void 0 : u.REST) == null ? void 0 : l[t == null ? void 0 : t.apiName]) ?? {}, { hostname: i } = e, [, a, o] = F6.exec(i) ?? [];
  return a === Km ? {
    service: a,
    region: o ?? n
  } : a === "appsync-api" ? {
    service: "appsync",
    region: o ?? n
  } : {
    service: r,
    region: n
  };
}, k6 = (e, t) => {
  const r = {};
  for (const n in e)
    r[n.toLowerCase()] = e[n];
  return t && (r["content-type"] = "application/json; charset=UTF-8", t instanceof FormData && delete r["content-type"]), r;
}, N6 = async (e, t, r) => {
  const { url: n, method: i, headers: a, body: o, withCredentials: s, abortSignal: u } = t, l = o ? o instanceof FormData ? o : JSON.stringify(o ?? "") : void 0, c = k6(a, o), f = {
    url: n,
    headers: c,
    method: i,
    body: l
  }, d = {
    retryDecider: xT(AE),
    computeDelay: bT,
    withCrossDomainCredentials: s,
    abortSignal: u
  }, h = P6(f, r);
  let p;
  const v = await $6(e);
  if (h && v) {
    const m = I6(n), x = (r == null ? void 0 : r.service) ?? m.service, y = (r == null ? void 0 : r.region) ?? m.region;
    p = await S8(f, {
      ...d,
      credentials: v,
      region: y,
      service: x
    });
  } else
    p = await gT(f, {
      ...d
    });
  return {
    statusCode: p.statusCode,
    headers: p.headers,
    body: p.body
  };
}, P6 = ({ headers: e }, t) => !e.authorization && !e["x-api-key"] && !!t, $6 = async (e) => {
  try {
    const { credentials: t } = await e.Auth.fetchAuthSession();
    if (t)
      return t;
  } catch {
    Ud.debug("No credentials available, the request will be unsigned.");
  }
  return null;
}, kh = /* @__PURE__ */ new WeakMap(), R6 = (e, { url: t, options: r, abortController: n }) => {
  const i = n ?? new AbortController(), o = O6(async () => N6(e, {
    url: t,
    method: "POST",
    ...r,
    abortSignal: i.signal
  }, r == null ? void 0 : r.signingServiceInfo), i).finally(() => {
    kh.delete(o);
  });
  return o;
}, M6 = (e, t) => {
  const r = kh.get(e);
  return r ? (r.abort(t), t && r.signal.reason !== t && (r.signal.reason = t), !0) : !1;
}, B6 = (e, t) => {
  kh.set(e, t);
};
var _r;
(function(e) {
  e.CONNECTION_CLOSED = "Connection closed", e.CONNECTION_FAILED = "Connection failed", e.REALTIME_SUBSCRIPTION_INIT_ERROR = "AppSync Realtime subscription init error", e.SUBSCRIPTION_ACK = "Subscription ack", e.TIMEOUT_DISCONNECT = "Timeout disconnect";
})(_r || (_r = {}));
var At;
(function(e) {
  e.Connected = "Connected", e.ConnectedPendingNetwork = "ConnectedPendingNetwork", e.ConnectionDisrupted = "ConnectionDisrupted", e.ConnectionDisruptedPendingNetwork = "ConnectionDisruptedPendingNetwork", e.Connecting = "Connecting", e.ConnectedPendingDisconnect = "ConnectedPendingDisconnect", e.Disconnected = "Disconnected", e.ConnectedPendingKeepAlive = "ConnectedPendingKeepAlive";
})(At || (At = {}));
const j6 = 5e3, L6 = [400, 401, 403], U6 = "ConnectionStateChange";
var Tr;
(function(e) {
  e.GQL_CONNECTION_INIT = "connection_init", e.GQL_CONNECTION_ERROR = "connection_error", e.GQL_CONNECTION_ACK = "connection_ack", e.GQL_START = "start", e.GQL_START_ACK = "start_ack", e.GQL_DATA = "data", e.GQL_CONNECTION_KEEP_ALIVE = "ka", e.GQL_STOP = "stop", e.GQL_COMPLETE = "complete", e.GQL_ERROR = "error";
})(Tr || (Tr = {}));
var Bn;
(function(e) {
  e[e.PENDING = 0] = "PENDING", e[e.CONNECTED = 1] = "CONNECTED", e[e.FAILED = 2] = "FAILED";
})(Bn || (Bn = {}));
var rr;
(function(e) {
  e[e.CLOSED = 0] = "CLOSED", e[e.READY = 1] = "READY", e[e.CONNECTING = 2] = "CONNECTING";
})(rr || (rr = {}));
const H6 = {
  accept: "application/json, text/javascript",
  "content-encoding": "amz-1.0",
  "content-type": "application/json; charset=UTF-8"
}, Qm = 15e3, W6 = 15e3, Xm = 5 * 60 * 1e3, z6 = 65 * 1e3, q6 = 5 * 1e3, Y6 = 60 * 1e3, Jm = () => new ha().networkMonitor(), $t = {
  KEEP_ALIVE_MISSED: { keepAliveState: "unhealthy" },
  KEEP_ALIVE: { keepAliveState: "healthy" },
  CONNECTION_ESTABLISHED: { connectionState: "connected" },
  CONNECTION_FAILED: {
    intendedConnectionState: "disconnected",
    connectionState: "disconnected"
  },
  CLOSING_CONNECTION: { intendedConnectionState: "disconnected" },
  OPENING_CONNECTION: {
    intendedConnectionState: "connected",
    connectionState: "connecting"
  },
  CLOSED: { connectionState: "disconnected" },
  ONLINE: { networkState: "connected" },
  OFFLINE: { networkState: "disconnected" }
};
class V6 {
  constructor() {
    this._networkMonitoringSubscription = void 0, this._linkedConnectionState = {
      networkState: "connected",
      connectionState: "disconnected",
      intendedConnectionState: "disconnected",
      keepAliveState: "healthy"
    }, this._initialNetworkStateSubscription = Jm().subscribe(({ online: t }) => {
      var r;
      this.record(t ? $t.ONLINE : $t.OFFLINE), (r = this._initialNetworkStateSubscription) == null || r.unsubscribe();
    }), this._linkedConnectionStateObservable = new Xt((t) => {
      t.next(this._linkedConnectionState), this._linkedConnectionStateObserver = t;
    });
  }
  /**
   * Turn network state monitoring on if it isn't on already
   */
  enableNetworkMonitoring() {
    var t;
    (t = this._initialNetworkStateSubscription) == null || t.unsubscribe(), this._networkMonitoringSubscription === void 0 && (this._networkMonitoringSubscription = Jm().subscribe(({ online: r }) => {
      this.record(r ? $t.ONLINE : $t.OFFLINE);
    }));
  }
  /**
   * Turn network state monitoring off if it isn't off already
   */
  disableNetworkMonitoring() {
    var t;
    (t = this._networkMonitoringSubscription) == null || t.unsubscribe(), this._networkMonitoringSubscription = void 0;
  }
  /**
   * Get the observable that allows us to monitor the connection state
   *
   * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
   */
  get connectionStateObservable() {
    let t;
    return this._linkedConnectionStateObservable.pipe(ch((r) => this.connectionStatesTranslator(r))).pipe(Y4((r) => {
      const n = r !== t;
      return t = r, n;
    }));
  }
  /*
   * Updates local connection state and emits the full state to the observer.
   */
  record(t) {
    var n;
    t.intendedConnectionState === "connected" ? this.enableNetworkMonitoring() : t.intendedConnectionState === "disconnected" && this.disableNetworkMonitoring();
    const r = {
      ...this._linkedConnectionState,
      ...t
    };
    this._linkedConnectionState = { ...r }, (n = this._linkedConnectionStateObserver) == null || n.next(this._linkedConnectionState);
  }
  /*
   * Translate the ConnectionState structure into a specific ConnectionState string literal union
   */
  connectionStatesTranslator({ connectionState: t, networkState: r, intendedConnectionState: n, keepAliveState: i }) {
    return t === "connected" && r === "disconnected" ? At.ConnectedPendingNetwork : t === "connected" && n === "disconnected" ? At.ConnectedPendingDisconnect : t === "disconnected" && n === "connected" && r === "disconnected" ? At.ConnectionDisruptedPendingNetwork : t === "disconnected" && n === "connected" ? At.ConnectionDisrupted : t === "connected" && i === "unhealthy" ? At.ConnectedPendingKeepAlive : t === "connecting" ? At.Connecting : t === "disconnected" ? At.Disconnected : At.Connected;
  }
}
var Ca;
(function(e) {
  e.START_RECONNECT = "START_RECONNECT", e.HALT_RECONNECT = "HALT_RECONNECT";
})(Ca || (Ca = {}));
class G6 {
  constructor() {
    this.reconnectObservers = [];
  }
  /**
   * Add reconnect observer to the list of observers to alert on reconnect
   */
  addObserver(t) {
    this.reconnectObservers.push(t);
  }
  /**
   * Given a reconnect event, start the appropriate behavior
   */
  record(t) {
    t === Ca.START_RECONNECT && this.reconnectSetTimeoutId === void 0 && this.reconnectIntervalId === void 0 && (this.reconnectSetTimeoutId = setTimeout(() => {
      this._triggerReconnect(), this.reconnectIntervalId = setInterval(() => {
        this._triggerReconnect();
      }, Y6);
    }, q6)), t === Ca.HALT_RECONNECT && (this.reconnectIntervalId && (clearInterval(this.reconnectIntervalId), this.reconnectIntervalId = void 0), this.reconnectSetTimeoutId && (clearTimeout(this.reconnectSetTimeoutId), this.reconnectSetTimeoutId = void 0));
  }
  /**
   * Complete all reconnect observers
   */
  close() {
    this.reconnectObservers.forEach((t) => {
      var r;
      (r = t.complete) == null || r.call(t);
    });
  }
  _triggerReconnect() {
    this.reconnectObservers.forEach((t) => {
      var r;
      (r = t.next) == null || r.call(t);
    });
  }
}
const nt = new cl("AWSAppSyncRealTimeProvider"), Zm = (e) => {
  Ox.dispatch("api", e, "PubSub", wT);
}, K6 = /^https:\/\/\w{26}\.appsync-api\.\w{2}(?:(?:-\w{2,})+)-\d\.amazonaws.com(?:\.cn)?\/graphql$/i, Q6 = "/realtime";
class X6 {
  constructor() {
    this.socketStatus = rr.CLOSED, this.keepAliveTimeout = Xm, this.subscriptionObserverMap = /* @__PURE__ */ new Map(), this.promiseArray = [], this.connectionStateMonitor = new V6(), this.reconnectionMonitor = new G6(), this.connectionStateMonitorSubscription = this.connectionStateMonitor.connectionStateObservable.subscribe((t) => {
      Zm({
        event: U6,
        data: {
          provider: this,
          connectionState: t
        },
        message: `Connection state is ${t}`
      }), this.connectionState = t, t === At.ConnectionDisrupted && this.reconnectionMonitor.record(Ca.START_RECONNECT), [
        At.Connected,
        At.ConnectedPendingDisconnect,
        At.ConnectedPendingKeepAlive,
        At.ConnectedPendingNetwork,
        At.ConnectionDisruptedPendingNetwork,
        At.Disconnected
      ].includes(t) && this.reconnectionMonitor.record(Ca.HALT_RECONNECT);
    });
  }
  /**
   * Mark the socket closed and release all active listeners
   */
  close() {
    this.socketStatus = rr.CLOSED, this.connectionStateMonitor.record($t.CONNECTION_FAILED), this.connectionStateMonitorSubscription.unsubscribe(), this.reconnectionMonitor.close();
  }
  getNewWebSocket(t, r) {
    return new WebSocket(t, r);
  }
  getProviderName() {
    return "AWSAppSyncRealTimeProvider";
  }
  // Check if url matches standard domain pattern
  isCustomDomain(t) {
    return t.match(K6) === null;
  }
  subscribe(t, r) {
    const { appSyncGraphqlEndpoint: n, region: i, query: a, variables: o, authenticationType: s, additionalHeaders: u, apiKey: l, authToken: c, libraryConfigHeaders: f } = t || {};
    return new Xt((d) => {
      if (!t || !n)
        d.error({
          errors: [
            {
              ...new Ao("Subscribe only available for AWS AppSync endpoint")
            }
          ]
        }), d.complete();
      else {
        let h = !1;
        const p = G4(), v = () => {
          h || (h = !0, this._startSubscriptionWithAWSAppSyncRealTime({
            options: {
              query: a,
              variables: o,
              region: i,
              authenticationType: s,
              appSyncGraphqlEndpoint: n,
              additionalHeaders: u,
              apiKey: l,
              authToken: c,
              libraryConfigHeaders: f
            },
            observer: d,
            subscriptionId: p,
            customUserAgentDetails: r
          }).catch((y) => {
            nt.debug(`${_r.REALTIME_SUBSCRIPTION_INIT_ERROR}: ${y}`), this.connectionStateMonitor.record($t.CLOSED);
          }).finally(() => {
            h = !1;
          }));
        }, m = new Xt((x) => {
          this.reconnectionMonitor.addObserver(x);
        }).subscribe(() => {
          v();
        });
        return v(), async () => {
          m == null || m.unsubscribe();
          try {
            await this._waitForSubscriptionToBeConnected(p);
            const { subscriptionState: x } = this.subscriptionObserverMap.get(p) || {};
            if (!x)
              return;
            if (x === Bn.CONNECTED)
              this._sendUnsubscriptionMessage(p);
            else
              throw new Error("Subscription never connected");
          } catch (x) {
            nt.debug(`Error while unsubscribing ${x}`);
          } finally {
            this._removeSubscriptionObserver(p);
          }
        };
      }
    });
  }
  async _startSubscriptionWithAWSAppSyncRealTime({ options: t, observer: r, subscriptionId: n, customUserAgentDetails: i }) {
    const { appSyncGraphqlEndpoint: a, authenticationType: o, query: s, variables: u, apiKey: l, region: c, libraryConfigHeaders: f = () => ({}), additionalHeaders: d = {}, authToken: h } = t;
    let p = {};
    typeof d == "function" ? p = await d({
      url: a || "",
      queryString: s || ""
    }) : p = d, h && (p = {
      ...p,
      Authorization: h
    });
    const v = Bn.PENDING, m = {
      query: s,
      variables: u
    };
    this.subscriptionObserverMap.set(n, {
      observer: r,
      query: s ?? "",
      variables: u ?? {},
      subscriptionState: v,
      startAckTimeoutId: void 0
    });
    const x = JSON.stringify(m), y = {
      ...await this._awsRealTimeHeaderBasedAuth({
        apiKey: l,
        appSyncGraphqlEndpoint: a,
        authenticationType: o,
        payload: x,
        canonicalUri: "",
        region: c,
        additionalCustomHeaders: p
      }),
      ...await f(),
      ...p,
      [ET]: Cx(i)
    }, g = {
      id: n,
      payload: {
        data: x,
        extensions: {
          authorization: {
            ...y
          }
        }
      },
      type: Tr.GQL_START
    }, E = JSON.stringify(g);
    try {
      this.connectionStateMonitor.record($t.OPENING_CONNECTION), await this._initializeWebSocketConnection({
        apiKey: l,
        appSyncGraphqlEndpoint: a,
        authenticationType: o,
        region: c,
        additionalCustomHeaders: p
      });
    } catch (_) {
      this._logStartSubscriptionError(n, r, _);
      return;
    }
    const { subscriptionFailedCallback: b, subscriptionReadyCallback: w } = this.subscriptionObserverMap.get(n) ?? {};
    this.subscriptionObserverMap.set(n, {
      observer: r,
      subscriptionState: v,
      query: s ?? "",
      variables: u ?? {},
      subscriptionReadyCallback: w,
      subscriptionFailedCallback: b,
      startAckTimeoutId: setTimeout(() => {
        this._timeoutStartSubscriptionAck(n);
      }, W6)
    }), this.awsRealTimeSocket && this.awsRealTimeSocket.send(E);
  }
  // Log logic for start subscription failures
  _logStartSubscriptionError(t, r, n) {
    nt.debug({ err: n });
    const i = String(n.message ?? "");
    if (this.connectionStateMonitor.record($t.CLOSED), this.connectionState !== At.ConnectionDisruptedPendingNetwork) {
      r1(n) ? r.error({
        errors: [
          {
            ...new Ao(`${_r.CONNECTION_FAILED}: ${i}`)
          }
        ]
      }) : nt.debug(`${_r.CONNECTION_FAILED}: ${i}`);
      const { subscriptionFailedCallback: a } = this.subscriptionObserverMap.get(t) || {};
      typeof a == "function" && a();
    }
  }
  // Waiting that subscription has been connected before trying to unsubscribe
  async _waitForSubscriptionToBeConnected(t) {
    const r = this.subscriptionObserverMap.get(t);
    if (r) {
      const { subscriptionState: n } = r;
      if (n === Bn.PENDING)
        return new Promise((i, a) => {
          const { observer: o, subscriptionState: s, variables: u, query: l } = r;
          this.subscriptionObserverMap.set(t, {
            observer: o,
            subscriptionState: s,
            variables: u,
            query: l,
            subscriptionReadyCallback: i,
            subscriptionFailedCallback: a
          });
        });
    }
  }
  _sendUnsubscriptionMessage(t) {
    try {
      if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === rr.READY) {
        const r = {
          id: t,
          type: Tr.GQL_STOP
        }, n = JSON.stringify(r);
        this.awsRealTimeSocket.send(n);
      }
    } catch (r) {
      nt.debug({ err: r });
    }
  }
  _removeSubscriptionObserver(t) {
    this.subscriptionObserverMap.delete(t), setTimeout(this._closeSocketIfRequired.bind(this), 1e3);
  }
  _closeSocketIfRequired() {
    if (!(this.subscriptionObserverMap.size > 0)) {
      if (!this.awsRealTimeSocket) {
        this.socketStatus = rr.CLOSED;
        return;
      }
      if (this.connectionStateMonitor.record($t.CLOSING_CONNECTION), this.awsRealTimeSocket.bufferedAmount > 0)
        setTimeout(this._closeSocketIfRequired.bind(this), 1e3);
      else {
        nt.debug("closing WebSocket..."), this.keepAliveTimeoutId && clearTimeout(this.keepAliveTimeoutId), this.keepAliveAlertTimeoutId && clearTimeout(this.keepAliveAlertTimeoutId);
        const t = this.awsRealTimeSocket;
        t.onclose = null, t.onerror = null, t.close(1e3), this.awsRealTimeSocket = void 0, this.socketStatus = rr.CLOSED, this.connectionStateMonitor.record($t.CLOSED);
      }
    }
  }
  _handleIncomingSubscriptionMessage(t) {
    if (typeof t.data != "string")
      return;
    nt.debug(`subscription message from AWS AppSync RealTime: ${t.data}`);
    const { id: r = "", payload: n, type: i } = JSON.parse(String(t.data)), { observer: a = null, query: o = "", variables: s = {}, startAckTimeoutId: u, subscriptionReadyCallback: l, subscriptionFailedCallback: c } = this.subscriptionObserverMap.get(r) || {};
    if (nt.debug({ id: r, observer: a, query: o, variables: s }), i === Tr.GQL_DATA && n && n.data) {
      a ? a.next(n) : nt.debug(`observer not found for id: ${r}`);
      return;
    }
    if (i === Tr.GQL_START_ACK) {
      nt.debug(`subscription ready for ${JSON.stringify({ query: o, variables: s })}`), typeof l == "function" && l(), u && clearTimeout(u), Zm({
        event: _r.SUBSCRIPTION_ACK,
        data: { query: o, variables: s },
        message: "Connection established for subscription"
      });
      const f = Bn.CONNECTED;
      a && this.subscriptionObserverMap.set(r, {
        observer: a,
        query: o,
        variables: s,
        startAckTimeoutId: void 0,
        subscriptionState: f,
        subscriptionReadyCallback: l,
        subscriptionFailedCallback: c
      }), this.connectionStateMonitor.record($t.CONNECTION_ESTABLISHED);
      return;
    }
    if (i === Tr.GQL_CONNECTION_KEEP_ALIVE) {
      this.keepAliveTimeoutId && clearTimeout(this.keepAliveTimeoutId), this.keepAliveAlertTimeoutId && clearTimeout(this.keepAliveAlertTimeoutId), this.keepAliveTimeoutId = setTimeout(() => {
        this._errorDisconnect(_r.TIMEOUT_DISCONNECT);
      }, this.keepAliveTimeout), this.keepAliveAlertTimeoutId = setTimeout(() => {
        this.connectionStateMonitor.record($t.KEEP_ALIVE_MISSED);
      }, z6), this.connectionStateMonitor.record($t.KEEP_ALIVE);
      return;
    }
    if (i === Tr.GQL_ERROR) {
      const f = Bn.FAILED;
      a && (this.subscriptionObserverMap.set(r, {
        observer: a,
        query: o,
        variables: s,
        startAckTimeoutId: u,
        subscriptionReadyCallback: l,
        subscriptionFailedCallback: c,
        subscriptionState: f
      }), nt.debug(`${_r.CONNECTION_FAILED}: ${JSON.stringify(n)}`), a.error({
        errors: [
          {
            ...new Ao(`${_r.CONNECTION_FAILED}: ${JSON.stringify(n)}`)
          }
        ]
      }), u && clearTimeout(u), typeof c == "function" && c());
    }
  }
  _errorDisconnect(t) {
    nt.debug(`Disconnect error: ${t}`), this.awsRealTimeSocket && (this.connectionStateMonitor.record($t.CLOSED), this.awsRealTimeSocket.close()), this.socketStatus = rr.CLOSED;
  }
  _timeoutStartSubscriptionAck(t) {
    const r = this.subscriptionObserverMap.get(t);
    if (r) {
      const { observer: n, query: i, variables: a } = r;
      if (!n)
        return;
      this.subscriptionObserverMap.set(t, {
        observer: n,
        query: i,
        variables: a,
        subscriptionState: Bn.FAILED
      }), this.connectionStateMonitor.record($t.CLOSED), nt.debug("timeoutStartSubscription", JSON.stringify({ query: i, variables: a }));
    }
  }
  _initializeWebSocketConnection({ appSyncGraphqlEndpoint: t, authenticationType: r, apiKey: n, region: i, additionalCustomHeaders: a }) {
    if (this.socketStatus !== rr.READY)
      return new Promise(async (o, s) => {
        if (this.promiseArray.push({ res: o, rej: s }), this.socketStatus === rr.CLOSED)
          try {
            this.socketStatus = rr.CONNECTING;
            const u = "{}", l = await this._awsRealTimeHeaderBasedAuth({
              authenticationType: r,
              payload: u,
              canonicalUri: "/connect",
              apiKey: n,
              appSyncGraphqlEndpoint: t,
              region: i,
              additionalCustomHeaders: a
            }), c = l ? JSON.stringify(l) : "", f = jp.convert(c), d = jp.convert(u);
            let h = t ?? "";
            this.isCustomDomain(h) ? h = h.concat(Q6) : h = h.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
            const p = "wss://";
            h = h.replace("https://", p).replace("http://", p);
            const v = `${h}?header=${f}&payload=${d}`;
            await this._initializeRetryableHandshake(v), this.promiseArray.forEach(({ res: m }) => {
              nt.debug("Notifying connection successful"), m();
            }), this.socketStatus = rr.READY, this.promiseArray = [];
          } catch (u) {
            nt.debug("Connection exited with", u), this.promiseArray.forEach(({ rej: l }) => {
              l(u);
            }), this.promiseArray = [], this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.awsRealTimeSocket.close(3001), this.awsRealTimeSocket = void 0, this.socketStatus = rr.CLOSED;
          }
      });
  }
  async _initializeRetryableHandshake(t) {
    nt.debug("Initializaling retryable Handshake"), await T8(this._initializeHandshake.bind(this), [t], j6);
  }
  async _initializeHandshake(t) {
    nt.debug(`Initializing handshake ${t}`);
    try {
      await (() => new Promise((r, n) => {
        const i = this.getNewWebSocket(t, "graphql-ws");
        i.onerror = () => {
          nt.debug("WebSocket connection error");
        }, i.onclose = () => {
          n(new Error("Connection handshake error"));
        }, i.onopen = () => {
          this.awsRealTimeSocket = i, r();
        };
      }))(), await (() => new Promise((r, n) => {
        if (this.awsRealTimeSocket) {
          let i = !1;
          this.awsRealTimeSocket.onerror = (s) => {
            nt.debug(`WebSocket error ${JSON.stringify(s)}`);
          }, this.awsRealTimeSocket.onclose = (s) => {
            nt.debug(`WebSocket closed ${s.reason}`), n(new Error(JSON.stringify(s)));
          }, this.awsRealTimeSocket.onmessage = (s) => {
            if (typeof s.data != "string")
              return;
            nt.debug(`subscription message from AWS AppSyncRealTime: ${s.data} `);
            const u = JSON.parse(s.data), { type: l, payload: { connectionTimeoutMs: c = Xm } = {} } = u;
            if (l === Tr.GQL_CONNECTION_ACK) {
              i = !0, this.awsRealTimeSocket && (this.keepAliveTimeout = c, this.awsRealTimeSocket.onmessage = this._handleIncomingSubscriptionMessage.bind(this), this.awsRealTimeSocket.onerror = (f) => {
                nt.debug(f), this._errorDisconnect(_r.CONNECTION_CLOSED);
              }, this.awsRealTimeSocket.onclose = (f) => {
                nt.debug(`WebSocket closed ${f.reason}`), this._errorDisconnect(_r.CONNECTION_CLOSED);
              }), r("Cool, connected to AWS AppSyncRealTime");
              return;
            }
            if (l === Tr.GQL_CONNECTION_ERROR) {
              const { payload: { errors: [{ errorType: f = "", errorCode: d = 0 } = {}] = [] } = {} } = u;
              n({ errorType: f, errorCode: d });
            }
          };
          const a = {
            type: Tr.GQL_CONNECTION_INIT
          };
          this.awsRealTimeSocket.send(JSON.stringify(a));
          const o = (s) => {
            s || (this.connectionStateMonitor.record($t.CONNECTION_FAILED), n(new Error(`Connection timeout: ack from AWSAppSyncRealTime was not received after ${Qm} ms`)));
          };
          setTimeout(() => {
            o(i);
          }, Qm);
        }
      }))();
    } catch (r) {
      const { errorType: n, errorCode: i } = r;
      throw L6.includes(i) ? new _8(n) : n ? new Error(n) : r;
    }
  }
  async _awsRealTimeHeaderBasedAuth({ apiKey: t, authenticationType: r, payload: n, canonicalUri: i, appSyncGraphqlEndpoint: a, region: o, additionalCustomHeaders: s }) {
    const u = {
      apiKey: this._awsRealTimeApiKeyHeader.bind(this),
      iam: this._awsRealTimeIAMHeader.bind(this),
      oidc: this._awsAuthTokenHeader.bind(this),
      userPool: this._awsAuthTokenHeader.bind(this),
      lambda: this._customAuthHeader,
      none: this._customAuthHeader
    };
    if (!r || !u[r]) {
      nt.debug(`Authentication type ${r} not supported`);
      return;
    } else {
      const l = u[r], c = a ? new Tu(a).host : void 0;
      nt.debug(`Authenticating with ${JSON.stringify(r)}`);
      let f;
      return r === "apiKey" && (f = t), await l({
        payload: n,
        canonicalUri: i,
        appSyncGraphqlEndpoint: a,
        apiKey: f,
        region: o,
        host: c,
        additionalCustomHeaders: s
      });
    }
  }
  async _awsAuthTokenHeader({ host: t }) {
    var n, i;
    const r = await Od();
    return {
      Authorization: (i = (n = r == null ? void 0 : r.tokens) == null ? void 0 : n.accessToken) == null ? void 0 : i.toString(),
      host: t
    };
  }
  async _awsRealTimeApiKeyHeader({ apiKey: t, host: r }) {
    const i = (/* @__PURE__ */ new Date()).toISOString().replace(/[:-]|\.\d{3}/g, "");
    return {
      host: r,
      "x-amz-date": i,
      "x-api-key": t
    };
  }
  async _awsRealTimeIAMHeader({ payload: t, canonicalUri: r, appSyncGraphqlEndpoint: n, region: i }) {
    const a = {
      region: i,
      service: "appsync"
    }, o = (await Od()).credentials, s = {
      url: `${n}${r}`,
      data: t,
      method: "POST",
      headers: { ...H6 }
    };
    return _1({
      headers: s.headers,
      method: s.method,
      url: new Tu(s.url),
      body: s.data
    }, {
      // TODO: What do we need to do to remove these !'s?
      credentials: o,
      signingRegion: a.region,
      signingService: a.service
    }).headers;
  }
  _customAuthHeader({ host: t, additionalCustomHeaders: r }) {
    if (!(r != null && r.Authorization))
      throw new Error("No auth token specified");
    return {
      Authorization: r.Authorization,
      host: t
    };
  }
}
class Qr extends Tx {
  constructor(t) {
    super(t), this.constructor = Qr, Object.setPrototypeOf(this, Qr.prototype);
  }
}
var ya;
(function(e) {
  e.NoAuthSession = "NoAuthSession", e.NoRegion = "NoRegion", e.NoCustomEndpoint = "NoCustomEndpoint";
})(ya || (ya = {}));
const J6 = {
  [ya.NoAuthSession]: {
    message: "Auth session should not be empty."
  },
  // TODO: re-enable when working in all test environments:
  // [APIValidationErrorCode.NoEndpoint]: {
  // 	message: 'Missing endpoint',
  // },
  [ya.NoRegion]: {
    message: "Missing region."
  },
  [ya.NoCustomEndpoint]: {
    message: "Custom endpoint region is present without custom endpoint."
  }
};
function Z6(e, t) {
  const { message: r, recoverySuggestion: n } = J6[t];
  if (!e)
    throw new Qr({ name: t, message: r, recoverySuggestion: n });
}
const e$ = new cl("GraphQLAPI resolveConfig"), qf = (e) => {
  var u, l;
  const t = e.getConfig();
  (u = t.API) != null && u.GraphQL || e$.warn("The API configuration is missing. This is likely due to Amplify.configure() not being called prior to generateClient().");
  const { apiKey: r, customEndpoint: n, customEndpointRegion: i, defaultAuthMode: a, endpoint: o, region: s } = ((l = t.API) == null ? void 0 : l.GraphQL) ?? {};
  return Z6(!(!n && i), ya.NoCustomEndpoint), {
    apiKey: r,
    customEndpoint: n,
    customEndpointRegion: i,
    defaultAuthMode: a,
    endpoint: o,
    region: s
  };
}, ey = (e) => {
  var n, i, a, o, s, u;
  const t = (a = (i = (n = e.libraryOptions) == null ? void 0 : n.API) == null ? void 0 : i.GraphQL) == null ? void 0 : a.headers, r = (u = (s = (o = e.libraryOptions) == null ? void 0 : o.API) == null ? void 0 : s.GraphQL) == null ? void 0 : u.withCredentials;
  return { headers: t, withCredentials: r };
};
function ty(e) {
  return e.errors && Array.isArray(e.errors) && e.errors.forEach((t) => {
    t$(t) && (t.message = "Unauthorized", t.recoverySuggestion = `If you're calling an Amplify-generated API, make sure to set the "authMode" in generateClient({ authMode: '...' }) to the backend authorization rule's auth provider ('apiKey', 'userPool', 'iam', 'oidc', 'lambda')`);
  }), e;
}
function t$(e) {
  var t, r, n, i;
  return !!((r = (t = e == null ? void 0 : e.originalError) == null ? void 0 : t.name) != null && r.startsWith("UnauthorizedException") || (n = e.message) != null && n.startsWith("Connection failed:") && ((i = e.message) != null && i.includes("Permission denied")));
}
var Ri;
(function(e) {
  e.NO_API_KEY = "No api-key configured", e.NO_CURRENT_USER = "No current user", e.NO_CREDENTIALS = "No credentials", e.NO_FEDERATED_JWT = "No federated jwt", e.NO_AUTH_TOKEN = "No auth token specified";
})(Ri || (Ri = {}));
const CE = Symbol("amplify"), OE = Symbol("authMode"), DE = Symbol("authToken"), FE = Symbol("headers");
function Nh(e) {
  const t = e;
  return {
    amplify: t[CE],
    authMode: t[OE],
    authToken: t[DE],
    headers: t[FE]
  };
}
const r$ = {
  name: "NoApiKey",
  // ideal: No API key configured.
  message: Ri.NO_API_KEY,
  recoverySuggestion: 'The API request was made with `authMode: "apiKey"` but no API Key was passed into `Amplify.configure()`. Review if your API key is passed into the `Amplify.configure()` function.'
}, n$ = {
  name: "NoCredentials",
  // ideal: No auth credentials available.
  message: Ri.NO_CREDENTIALS,
  recoverySuggestion: 'The API request was made with `authMode: "iam"` but no authentication credentials are available.\n\nIf you intended to make a request using an authenticated role, review if your user is signed in before making the request.\n\nIf you intend to make a request using an unauthenticated role or also known as "guest access", verify if "Auth.Cognito.allowGuestAccess" is set to "true" in the `Amplify.configure()` function.'
}, i$ = {
  name: "NoValidAuthTokens",
  // ideal: No valid JWT auth token provided to make the API request..
  message: Ri.NO_FEDERATED_JWT,
  recoverySuggestion: "If you intended to make an authenticated API request, review if the current user is signed in."
}, a$ = {
  name: "NoSignedUser",
  // ideal: Couldn't retrieve authentication credentials to make the API request.
  message: Ri.NO_CURRENT_USER,
  recoverySuggestion: "Review the underlying exception field for more details. If you intended to make an authenticated API request, review if the current user is signed in."
}, o$ = {
  name: "NoAuthorizationHeader",
  // ideal: Authorization header not specified.
  message: Ri.NO_AUTH_TOKEN,
  recoverySuggestion: 'The API request was made with `authMode: "lambda"` but no `authToken` is set. Review if a valid authToken is passed into the request options or in the `Amplify.configure()` function.'
}, s$ = {
  name: "NoEndpoint",
  message: "No GraphQL endpoint configured in `Amplify.configure()`.",
  recoverySuggestion: "Review if the GraphQL API endpoint is set in the `Amplify.configure()` function."
}, ry = (e) => ({
  data: {},
  errors: [new Ao(e.message, null, null, null, null, e)]
});
function u$(e) {
  if (!e)
    return !1;
  const t = e;
  return Array.isArray(t.errors) && t.errors.length > 0;
}
const l$ = "x-amz-user-agent", c$ = (e) => typeof e != "function";
class IE {
  constructor() {
    this.appSyncRealTime = new X6(), this._api = {
      post: R6,
      cancelREST: M6,
      isCancelErrorREST: T6,
      updateRequestToBeCancellable: B6
    };
  }
  getModuleName() {
    return "InternalGraphQLAPI";
  }
  async _headerBasedAuth(t, r, n = {}) {
    var o;
    const { apiKey: i } = qf(t);
    let a = {};
    switch (r) {
      case "apiKey":
        if (!i)
          throw new Qr(r$);
        a = {
          "X-Api-Key": i
        };
        break;
      case "iam": {
        if ((await t.Auth.fetchAuthSession()).credentials === void 0)
          throw new Qr(n$);
        break;
      }
      case "oidc":
      case "userPool": {
        let s;
        try {
          s = (o = (await t.Auth.fetchAuthSession()).tokens) == null ? void 0 : o.accessToken.toString();
        } catch (u) {
          throw new Qr({
            ...a$,
            underlyingError: u
          });
        }
        if (!s)
          throw new Qr(i$);
        a = {
          Authorization: s
        };
        break;
      }
      case "lambda":
        if (typeof n == "object" && !n.Authorization)
          throw new Qr(o$);
        a = {
          Authorization: n.Authorization
        };
        break;
    }
    return a;
  }
  /**
   * to get the operation type
   * @param operation
   */
  getGraphqlOperationType(t) {
    const n = Wf(t).definitions, [{ operation: i }] = n;
    return i;
  }
  /**
   * Executes a GraphQL operation
   *
   * @param options - GraphQL Options
   * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
   * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
   */
  graphql(t, { query: r, variables: n = {}, authMode: i, authToken: a }, o, s) {
    const u = Wf(typeof r == "string" ? r : uo(r)), [l = {}] = u.definitions.filter((d) => d.kind === "OperationDefinition"), { operation: c } = l, f = o || {};
    switch (c) {
      case "query":
      case "mutation": {
        const d = new AbortController();
        let h;
        return c$(t) ? h = this._graphql(t, { query: u, variables: n, authMode: i }, f, d, s, a) : h = t(async (v) => await this._graphql(v, { query: u, variables: n, authMode: i }, f, d, s, a)), this._api.updateRequestToBeCancellable(h, d), h;
      }
      case "subscription":
        return this._graphqlSubscribe(t, { query: u, variables: n, authMode: i }, f, s, a);
      default:
        throw new Error(`invalid operation type: ${c}`);
    }
  }
  async _graphql(t, { query: r, variables: n, authMode: i }, a = {}, o, s, u) {
    const { region: l, endpoint: c, customEndpoint: f, customEndpointRegion: d, defaultAuthMode: h } = qf(t), p = i || h || "iam", v = p === "identityPool" ? "iam" : p, { headers: m, withCredentials: x } = ey(t);
    let y;
    if (typeof a == "function") {
      const A = {
        method: "POST",
        url: new Tu(f || c || "").toString(),
        queryString: uo(r)
      };
      y = await a(A);
    } else
      y = a;
    u && (y = {
      ...y,
      Authorization: u
    });
    const g = {
      ...!f && await this._headerBasedAuth(t, v, y),
      /**
       * Custom endpoint headers.
       * If there is both a custom endpoint and custom region present, we get the headers.
       * If there is a custom endpoint but no region, we return an empty object.
       * If neither are present, we return an empty object.
       */
      ...f && (d ? await this._headerBasedAuth(t, v, y) : {}) || {},
      // Custom headers included in Amplify configuration options:
      ...m && await m({
        query: uo(r),
        variables: n
      }),
      // Custom headers from individual requests or API client configuration:
      ...y,
      // User agent headers:
      ...!f && {
        [l$]: Cx(s)
      }
    }, E = {
      query: uo(r),
      variables: n || null
    };
    let b;
    f && !d || v !== "oidc" && v !== "userPool" && v !== "iam" && v !== "lambda" ? b = void 0 : b = {
      service: d ? "execute-api" : "appsync",
      region: d || l
    };
    const w = f || c;
    if (!w)
      throw ry(new Qr(s$));
    let _;
    try {
      const { body: A } = await this._api.post(t, {
        url: new Tu(w),
        options: {
          headers: g,
          body: E,
          signingServiceInfo: b,
          withCredentials: x
        },
        abortController: o
      });
      _ = await A.json();
    } catch (A) {
      if (this.isCancelError(A))
        throw A;
      _ = ry(A);
    }
    if (u$(_))
      throw ty(_);
    return _;
  }
  /**
   * Checks to see if an error thrown is from an api request cancellation
   * @param {any} error - Any error
   * @return {boolean} - A boolean indicating if the error was from an api request cancellation
   */
  isCancelError(t) {
    return this._api.isCancelErrorREST(t);
  }
  /**
   * Cancels an inflight request. Only applicable for graphql queries and mutations
   * @param {any} request - request to cancel
   * @returns - A boolean indicating if the request was cancelled
   */
  cancel(t, r) {
    return this._api.cancelREST(t, r);
  }
  _graphqlSubscribe(t, { query: r, variables: n, authMode: i }, a = {}, o, s) {
    const u = qf(t), l = i || (u == null ? void 0 : u.defaultAuthMode) || "iam", c = l === "identityPool" ? "iam" : l, { headers: f } = ey(t);
    return this.appSyncRealTime.subscribe({
      query: uo(r),
      variables: n,
      appSyncGraphqlEndpoint: u == null ? void 0 : u.endpoint,
      region: u == null ? void 0 : u.region,
      authenticationType: c,
      apiKey: u == null ? void 0 : u.apiKey,
      additionalHeaders: a,
      authToken: s,
      libraryConfigHeaders: f
    }, o).pipe(b1((d) => {
      throw d.errors ? ty(d) : d;
    }));
  }
}
new IE();
class f$ extends IE {
  getModuleName() {
    return "GraphQLAPI";
  }
  /**
   * Executes a GraphQL operation
   *
   * @param options - GraphQL Options
   * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
   * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
   */
  graphql(t, r, n) {
    return super.graphql(t, r, n, {
      category: ST.API,
      action: _T.GraphQl
    });
  }
  /**
   * Checks to see if an error thrown is from an api request cancellation
   * @param error - Any error
   * @returns A boolean indicating if the error was from an api request cancellation
   */
  isCancelError(t) {
    return super.isCancelError(t);
  }
  /**
   * Cancels an inflight request. Only applicable for graphql queries and mutations
   * @param {any} request - request to cancel
   * @returns A boolean indicating if the request was cancelled
   */
  cancel(t, r) {
    return super.cancel(t, r);
  }
}
const Ph = new f$();
function d$(e, t) {
  const r = Nh(this);
  return e.authMode = e.authMode || r.authMode, e.authToken = e.authToken || r.authToken, Ph.graphql(
    // TODO: move V6Client back into this package?
    r.amplify,
    e,
    t
  );
}
function h$(e, t) {
  return Ph.cancel(e, t);
}
function p$(e) {
  return Ph.isCancelError(e);
}
function $h(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e.attributes || [])
    if (v$(r))
      for (const n of r.properties.rules)
        n.allow === "owner" ? t.add(n.ownerField || "owner") : n.allow === "groups" && n.groupsField !== void 0 && t.add(n.groupsField);
  return Array.from(t);
}
function v$(e) {
  var t, r;
  return (e == null ? void 0 : e.type) === "auth" && typeof (e == null ? void 0 : e.properties) == "object" && Array.isArray((t = e == null ? void 0 : e.properties) == null ? void 0 : t.rules) ? ((r = e == null ? void 0 : e.properties) == null ? void 0 : r.rules).every((n) => !!n.allow) : !1;
}
function pu(e) {
  return `${e[0].toUpperCase()}${e.slice(1)}`;
}
const la = {
  HAS_ONE: "HAS_ONE",
  HAS_MANY: "HAS_MANY",
  BELONGS_TO: "BELONGS_TO"
}, ny = {
  ID: "ID",
  String: "String",
  AWSDate: "String",
  AWSTime: "String",
  AWSDateTime: "String",
  AWSTimestamp: "Int",
  AWSEmail: "String",
  AWSPhone: "String",
  AWSURL: "String",
  AWSIPAddress: "String",
  AWSJSON: "String",
  Boolean: "Boolean",
  Int: "Int",
  Float: "Float"
}, Lu = (e) => e.length === 1 ? e[0] : e.reduce((t, r, n) => n === 0 ? r : t + pu(r), ""), ei = (e, t, r) => {
  var i;
  if (!r)
    return null;
  const n = {};
  for (const [a, o] of Object.entries(r)) {
    const s = t ? (i = e.models[t]) == null ? void 0 : i.fields[a] : void 0, u = { fieldDef: s, value: o };
    m$(u) ? n[a] = u.value.items.map((l) => ei(e, u.fieldDef.type.model, l)) : y$(s) ? n[a] = ei(e, s.type.model, o) : n[a] = o;
  }
  return n;
};
function m$(e) {
  var t, r;
  return typeof ((t = e.fieldDef) == null ? void 0 : t.type) == "object" && "model" in e.fieldDef.type && typeof e.fieldDef.type.model == "string" && e.fieldDef.isArray && Array.isArray((r = e.value) == null ? void 0 : r.items);
}
function y$(e) {
  return typeof (e == null ? void 0 : e.type) == "object" && "model" in e.type && typeof e.type.model == "string";
}
function Tn(e, t, r, n, i, a, o = !1) {
  const s = n.models[t], u = s.fields, l = Object.entries(u).filter(([c, f]) => {
    var d;
    return ((d = f == null ? void 0 : f.type) == null ? void 0 : d.model) !== void 0;
  }).map(([c]) => c);
  return r.map((c) => {
    var d, h;
    const f = {};
    for (const p of l) {
      const v = u[p], x = (v == null ? void 0 : v.type).model, y = n.models[x], g = y.primaryKeyInfo.primaryKeyFieldName, E = y.primaryKeyInfo.sortKeyFieldNames, b = (d = v.association) == null ? void 0 : d.connectionType;
      let w = [];
      v.association && "associatedWith" in v.association && (w = v.association.associatedWith);
      const _ = [];
      switch (v.association && "targetNames" in v.association && _.push(...v.association.targetNames), b) {
        case la.BELONGS_TO: {
          const A = E.reduce(
            // TODO(Eslint): is this implementation correct?
            // eslint-disable-next-line array-callback-return
            (O, T) => {
              if (c[T])
                return O[T] = c[T];
            },
            {}
          );
          o ? f[p] = (O, T) => c[_[0]] ? e.models[x].get(O, {
            [g]: c[_[0]],
            ...A
          }, {
            authMode: (T == null ? void 0 : T.authMode) || i,
            authToken: (T == null ? void 0 : T.authToken) || a
          }) : { data: null } : f[p] = (O) => c[_[0]] ? e.models[x].get({
            [g]: c[_[0]],
            ...A
          }, {
            authMode: (O == null ? void 0 : O.authMode) || i,
            authToken: (O == null ? void 0 : O.authToken) || a
          }) : { data: null };
          break;
        }
        case la.HAS_ONE:
        case la.HAS_MANY: {
          const A = b === la.HAS_ONE ? (j) => ({
            data: (j == null ? void 0 : j.data.shift()) || null,
            errors: j.errors,
            extensions: j.extensions
          }) : (j) => j, O = s.primaryKeyInfo.primaryKeyFieldName, T = s.primaryKeyInfo.sortKeyFieldNames, C = y.fields[w[0]];
          if (C.type.model) {
            let j = [];
            C.association && "targetNames" in C.association && (j = (h = C.association) == null ? void 0 : h.targetNames);
            const W = j.map((Y, V) => V === 0 ? { [Y]: { eq: c[O] } } : { [Y]: { eq: c[T[V - 1]] } });
            o ? f[p] = (Y, V) => c[O] ? e.models[x].list(Y, {
              filter: { and: W },
              limit: V == null ? void 0 : V.limit,
              nextToken: V == null ? void 0 : V.nextToken,
              authMode: (V == null ? void 0 : V.authMode) || i,
              authToken: (V == null ? void 0 : V.authToken) || a
            }).then(A) : [] : f[p] = (Y) => c[O] ? e.models[x].list({
              filter: { and: W },
              limit: Y == null ? void 0 : Y.limit,
              nextToken: Y == null ? void 0 : Y.nextToken,
              authMode: (Y == null ? void 0 : Y.authMode) || i,
              authToken: (Y == null ? void 0 : Y.authToken) || a
            }).then(A) : [];
            break;
          }
          const P = w.map((j, W) => W === 0 ? { [j]: { eq: c[O] } } : { [j]: { eq: c[T[W - 1]] } });
          o ? f[p] = (j, W) => c[O] ? e.models[x].list(j, {
            filter: { and: P },
            limit: W == null ? void 0 : W.limit,
            nextToken: W == null ? void 0 : W.nextToken,
            authMode: (W == null ? void 0 : W.authMode) || i,
            authToken: (W == null ? void 0 : W.authToken) || a
          }).then(A) : [] : f[p] = (j) => c[O] ? e.models[x].list({
            filter: { and: P },
            limit: j == null ? void 0 : j.limit,
            nextToken: j == null ? void 0 : j.nextToken,
            authMode: (j == null ? void 0 : j.authMode) || i,
            authToken: (j == null ? void 0 : j.authToken) || a
          }).then(A) : [];
          break;
        }
      }
    }
    return { ...c, ...f };
  });
}
const kE = {
  CREATE: { operationPrefix: "create", usePlural: !1 },
  READ: { operationPrefix: "get", usePlural: !1 },
  UPDATE: { operationPrefix: "update", usePlural: !1 },
  DELETE: { operationPrefix: "delete", usePlural: !1 },
  LIST: { operationPrefix: "list", usePlural: !0 },
  INDEX_QUERY: { operationPrefix: "", usePlural: !1 },
  ONCREATE: { operationPrefix: "onCreate", usePlural: !1 },
  ONUPDATE: { operationPrefix: "onUpdate", usePlural: !1 },
  ONDELETE: { operationPrefix: "onDelete", usePlural: !1 },
  OBSERVE_QUERY: { operationPrefix: "observeQuery", usePlural: !1 }
}, Hd = "*", ec = (e, t) => {
  const { fields: r } = e, n = Object.values(r).map(({ type: i, name: a }) => {
    if (typeof i.enum == "string")
      return [a, Oa];
    if (typeof i.nonModel == "string")
      return [
        a,
        ec(t.nonModels[i.nonModel], t)
      ];
    if (typeof i == "string")
      return [a, Oa];
  }).filter((i) => i !== void 0);
  return Object.fromEntries(n);
}, g$ = (e, t) => {
  const { fields: r } = e, n = Object.values(r).map(({ type: a, name: o }) => {
    if (typeof a.enum == "string" || typeof a == "string")
      return [o, Oa];
    if (typeof a.nonModel == "string")
      return [
        o,
        ec(t.nonModels[a.nonModel], t)
      ];
  }).filter((a) => a !== void 0), i = $h(e).map((a) => [
    a,
    Oa
  ]);
  return Object.fromEntries(n.concat(i));
};
function x$(e) {
  const { fields: t } = e, r = Object.values(t).map(({ type: i, name: a }) => {
    if (typeof i == "string")
      return a;
    if (typeof i == "object") {
      if (typeof (i == null ? void 0 : i.enum) == "string")
        return a;
      if (typeof (i == null ? void 0 : i.nonModel) == "string")
        return `${a}.${Hd}`;
    }
  }).filter(Boolean), n = $h(e);
  return Array.from(new Set(r.concat(n)));
}
const Oa = "";
function b$(e, t, r) {
  const n = (i, a) => {
    var m, x, y, g, E, b;
    const [o, ...s] = i.split("."), u = s[0], l = e.models[a] ?? e.nonModels[a], c = l == null ? void 0 : l.fields, f = (x = (m = c == null ? void 0 : c[o]) == null ? void 0 : m.type) == null ? void 0 : x.model, d = e.models[f], h = (g = (y = c == null ? void 0 : c[o]) == null ? void 0 : y.type) == null ? void 0 : g.nonModel, p = e.nonModels[h], v = d ? "model" : p ? "nonModel" : "field";
    if (v === "nonModel") {
      let w = {};
      if (!u)
        throw Error(`${o} must declare a wildcard (*) or a field of custom type ${h}`);
      return u === Hd ? w = {
        [o]: ec(p, e)
      } : w = {
        [o]: n(s.join("."), h)
      }, w;
    } else if (v === "model") {
      let w = {};
      if (!u)
        throw Error(`${o} must declare a wildcard (*) or a field of model ${f}`);
      if (u === Hd) {
        const _ = e.models[f];
        w = {
          [o]: g$(_, e)
        };
      } else
        w = {
          [o]: n(s.join("."), f)
        };
      return (E = c[o]) != null && E.isArray && (w = {
        [o]: {
          items: w[o]
        }
      }), w;
    } else {
      const w = c == null ? void 0 : c[o], _ = e.nonModels[a], A = (b = _ == null ? void 0 : _.fields) == null ? void 0 : b[o];
      if (_) {
        if (!A)
          throw Error(`${o} is not a field of custom type ${a}`);
      } else {
        const O = $h(l).includes(o);
        if (!w && !O)
          throw Error(`${o} is not a field of model ${a}`);
      }
      return { [o]: Oa };
    }
  };
  return r.reduce((i, a) => NE(n(a, t), i), {});
}
function Uu(e) {
  const t = [];
  return Object.entries(e).forEach(([r, n]) => {
    n === Oa ? t.push(r) : typeof n == "object" && n !== null && (n != null && n.items ? t.push(r, "{", "items", "{", Uu(n.items), "}", "}") : t.push(r, "{", Uu(n), "}"));
  }), t.join(" ");
}
function NE(e, t) {
  const r = (n) => n && typeof n == "object";
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (Object.prototype.hasOwnProperty.call(t, n) && r(t[n]) ? NE(e[n], t[n]) : t[n] = e[n]);
  return t;
}
function PE(e, t, r) {
  const n = e.models[t], i = b$(e, t, r ?? x$(n));
  return Uu(i);
}
function tc(e, t, r, n, i) {
  var $, P;
  const a = e.models[t], { name: o, pluralName: s, fields: u, primaryKeyInfo: { isCustomPrimaryKey: l, primaryKeyFieldName: c, sortKeyFieldNames: f }, attributes: d } = a, h = o.charAt(0).toUpperCase() + o.slice(1), p = s.charAt(0).toUpperCase() + s.slice(1), { operationPrefix: v, usePlural: m } = kE[r], { selectionSet: x } = n || {};
  let y, g;
  if (v)
    y = `${v}${m ? p : h}`;
  else if (i) {
    const { queryField: j, pk: W, sk: Y = [] } = i;
    y = j;
    let V = {};
    if (Y.length === 1) {
      const [ce] = Y, de = typeof u[ce].type == "string" ? u[ce].type : "String", L = ny[de];
      V = {
        [ce]: `Model${L}KeyConditionInput`
      };
    } else if (Y.length > 1) {
      const ce = Lu(Y), de = (P = ($ = d == null ? void 0 : d.find((L) => {
        var D;
        return ((D = L == null ? void 0 : L.properties) == null ? void 0 : D.queryField) === j;
      })) == null ? void 0 : $.properties) == null ? void 0 : P.name;
      V = {
        [ce]: `Model${pu(t)}${pu(de)}CompositeKeyConditionInput`
      };
    }
    g = {
      [W]: `${Object.prototype.hasOwnProperty.call(u[W].type, "enum") ? u[W].type.enum : u[W].type}!`,
      ...V
    };
  } else
    throw new Error("Error generating GraphQL Document - invalid operation name");
  let E, b, w;
  const _ = PE(e, t, x), A = {
    [c]: `${u[c].type}!`
  }, O = {}, T = (j) => {
    if (f.length === 0)
      return {};
    if (j === "get")
      return f.reduce((W, Y) => {
        const V = u[Y].type;
        return j === "get" && (W[Y] = `${V}!`), W;
      }, {});
    if (f.length === 1) {
      const [W] = f, Y = typeof u[W].type == "string" ? u[W].type : "String", V = ny[Y];
      return {
        [W]: `Model${V}KeyConditionInput`
      };
    } else
      return {
        [Lu(f)]: `Model${pu(t)}PrimaryCompositeKeyConditionInput`
      };
  };
  switch (l && (Object.assign(A, T("get")), Object.assign(O, {
    // PK is only included in list query field args in the generated GQL
    // when explicitly specifying PK with .identifier(['fieldName']) or @primaryKey in the schema definition
    [c]: `${u[c].type}`,
    // PK is always a nullable arg for list (no `!` after the type)
    sortDirection: "ModelSortDirection"
  }, T("list"))), r) {
    case "CREATE":
    case "UPDATE":
    case "DELETE":
      w ?? (w = {
        input: `${v.charAt(0).toLocaleUpperCase() + v.slice(1)}${h}Input!`
      }), E ?? (E = "mutation");
    case "READ":
      w ?? (w = A), b ?? (b = _);
    case "LIST":
      w ?? (w = {
        ...O,
        // eslint doesn't like the ts-ignore, because it thinks it's unnecessary.
        // But TS doesn't like the `filter: ...` because it think it will always be
        // overwritten. (it won't be.) so, we need to ignore the TS error and then
        // ignore the eslint error on the ts-ignore.
        // eslint-disable-next-line
        // @ts-ignore
        filter: `Model${h}FilterInput`,
        limit: "Int",
        nextToken: "String"
      }), E ?? (E = "query"), b ?? (b = `items { ${_} } nextToken __typename`);
    case "INDEX_QUERY":
      w ?? (w = {
        ...g,
        filter: `Model${h}FilterInput`,
        sortDirection: "ModelSortDirection",
        limit: "Int",
        nextToken: "String"
      }), E ?? (E = "query"), b ?? (b = `items { ${_} } nextToken __typename`);
    case "ONCREATE":
    case "ONUPDATE":
    case "ONDELETE":
      w ?? (w = {
        filter: `ModelSubscription${h}FilterInput`
      }), E ?? (E = "subscription"), b ?? (b = _);
      break;
    case "OBSERVE_QUERY":
    default:
      throw new Error("Internal error: Attempted to generate graphql document for observeQuery. Please report this error.");
  }
  return `${E}${w ? `(${Object.entries(w).map(([j, W]) => `$${j}: ${W}`)})` : ""} { ${y}${w ? `(${Object.keys(w).map((j) => `${j}: $${j}`)})` : ""} { ${b} } }`;
}
function rc(e, t, r, n, i) {
  const { fields: a, primaryKeyInfo: { isCustomPrimaryKey: o, primaryKeyFieldName: s, sortKeyFieldNames: u } } = e, l = (u == null ? void 0 : u.length) && Lu(u);
  let c = {};
  switch (t) {
    case "CREATE":
      c = {
        input: r ? iy(r, e, n) : {}
      };
      break;
    case "UPDATE":
      c = {
        input: r ? Object.fromEntries(Object.entries(iy(r, e, n)).filter(([f]) => {
          const { isReadOnly: d } = a[f];
          return !d;
        })) : {}
      };
      break;
    case "READ":
    case "DELETE":
      r && (c = o ? [s, ...u].reduce((f, d) => (f[d] = r[d], f), {}) : { [s]: r[s] }), t === "DELETE" && (c = { input: c });
      break;
    case "LIST":
      r != null && r.filter && (c.filter = r.filter), r != null && r.sortDirection && (c.sortDirection = r.sortDirection), r && r[s] && (c[s] = r[s]), l && r && r[l] && (c[l] = r[l]), r != null && r.nextToken && (c.nextToken = r.nextToken), r != null && r.limit && (c.limit = r.limit);
      break;
    case "INDEX_QUERY": {
      const { pk: f, sk: d = [] } = i, h = (d == null ? void 0 : d.length) && Lu(d);
      c[f] = r[f], h && r && r[h] && (c[h] = r[h]), r != null && r.filter && (c.filter = r.filter), r != null && r.sortDirection && (c.sortDirection = r.sortDirection), r != null && r.nextToken && (c.nextToken = r.nextToken), r != null && r.limit && (c.limit = r.limit);
      break;
    }
    case "ONCREATE":
    case "ONUPDATE":
    case "ONDELETE":
      r != null && r.filter && (c = { filter: r.filter });
      break;
    case "OBSERVE_QUERY":
      throw new Error("Internal error: Attempted to build variables for observeQuery. Please report this error.");
    default: {
      const f = t;
      throw new Error(`Unhandled operation case: ${f}`);
    }
  }
  return c;
}
function iy(e, t, r) {
  const { fields: n } = t, i = {};
  return Object.entries(e).forEach(([a, o]) => {
    var l, c;
    const s = (l = n[a]) == null ? void 0 : l.type, u = s == null ? void 0 : s.model;
    if (u) {
      const f = (c = n[a]) == null ? void 0 : c.association, h = r.models[u].primaryKeyInfo;
      if ((f == null ? void 0 : f.connectionType) === la.HAS_ONE) {
        const p = f;
        p.targetNames.forEach((v, m) => {
          const x = p.associatedWith[m];
          i[v] = o[x];
        });
      }
      (f == null ? void 0 : f.connectionType) === la.BELONGS_TO && f.targetNames.forEach((v, m) => {
        if (m === 0) {
          const x = h.primaryKeyFieldName;
          i[v] = o[x];
        } else {
          const x = h.sortKeyFieldNames[m - 1];
          i[v] = o[x];
        }
      });
    } else
      i[a] = o;
  }), i;
}
function La(e, t, r = {}) {
  const n = t(e);
  return {
    authMode: r.authMode || n.authMode,
    authToken: r.authToken || n.authToken
  };
}
function Ua(e, t, r) {
  let n = t(e).headers || {};
  return r && (n = r), n;
}
function Wd(e) {
  if (e != null && e.errors)
    return {
      ...e,
      data: []
    };
  throw e;
}
function Hu(e) {
  if (e.errors)
    return {
      ...e,
      data: null
    };
  throw e;
}
const E$ = (e) => {
  var t;
  return typeof ((t = e == null ? void 0 : e.token) == null ? void 0 : t.value) == "symbol";
};
function w$(e, t, r, n, i, a) {
  const o = n.arguments !== void 0;
  return (...u) => {
    const l = u[u.length - 1];
    let c, f;
    if (i)
      if (E$(u[0]))
        c = u[0];
      else
        throw new Error(`Invalid first argument passed to ${n.name}. Expected contextSpec`);
    return o && (i ? f = u[1] : f = u[0]), r === "subscription" ? T$(
      // subscriptions are only enabled on the clientside
      e,
      t,
      n,
      a,
      f,
      l
    ) : _$(e, t, r, n, a, f, l, c);
  };
}
function ca(e, t) {
  return typeof e[t] == "string";
}
function S$(e) {
  const t = e.isRequired ? "!" : "";
  return e.type instanceof Object && "enum" in e.type ? e.type.enum + t : e.type + t;
}
function $E(e) {
  if (e.arguments === void 0)
    return "";
  const t = Object.entries(e.arguments).map(([r, n]) => {
    const i = S$(n), a = n.isArray ? `[${i}]${n.isArrayNullable ? "" : "!"}` : i;
    return `$${r}: ${a}`;
  }).join(", ");
  return t.length > 0 ? `(${t})` : "";
}
function RE(e) {
  if (e.arguments === void 0)
    return "";
  const t = Object.keys(e.arguments).map((r) => `${r}: $${r}`).join(", ");
  return t.length > 0 ? `(${t})` : "";
}
function ME(e, t) {
  if (ca(t, "type") || ca(t.type, "enum"))
    return "";
  if (ca(t.type, "nonModel")) {
    const r = e.nonModels[t.type.nonModel];
    return `{${Uu(ec(r, e))}}`;
  } else
    return ca(t.type, "model") ? `{${PE(e, t.type.model)}}` : "";
}
function BE(e, t = {}) {
  const r = {};
  if (e.arguments === void 0)
    return r;
  for (const n of Object.values(e.arguments))
    if (typeof t[n.name] < "u")
      r[n.name] = t[n.name];
    else if (n.isRequired)
      throw new Error(`${e.name} requires arguments '${n.name}'`);
  return r;
}
async function _$(e, t, r, n, i, a, o, s) {
  const { name: u } = n, l = La(e, i, o), c = Ua(e, i, o == null ? void 0 : o.headers), f = $E(n), d = RE(n), h = ME(t, n), p = ca(n.type, "model") ? n.type.model : void 0, v = `
    ${r.toLocaleLowerCase()}${f} {
      ${u}${d} ${h}
    }
  `, m = BE(n, a);
  try {
    const { data: x, extensions: y } = s ? await e.graphql(s, {
      ...l,
      query: v,
      variables: m
    }, c) : await e.graphql({
      ...l,
      query: v,
      variables: m
    }, c);
    if (x) {
      const [g] = Object.keys(x), E = Array.isArray(x[g]), b = E ? x[g].filter((_) => _) : x[g], w = p ? Tn(e, p, E ? b : [b], t, l.authMode, l.authToken, !!s) : b;
      return {
        data: !E && Array.isArray(w) ? w.shift() : w,
        extensions: y
      };
    } else
      return { data: null, extensions: y };
  } catch (x) {
    const { data: y, errors: g } = x;
    if (y && Object.keys(y).length !== 0 && g) {
      const [E] = Object.keys(y), b = Array.isArray(y[E]), w = b ? y[E].filter((_) => _) : y[E];
      if (w) {
        const _ = p ? Tn(e, p, b ? w : [w], t, l.authMode, l.authToken, !!s) : w;
        return {
          data: !b && Array.isArray(_) ? _.shift() : _,
          errors: g
        };
      } else
        return Hu(x);
    } else
      return Hu(x);
  }
}
function T$(e, t, r, n, i, a) {
  const o = "subscription", { name: s } = r, u = La(e, n, a), l = Ua(e, n, a == null ? void 0 : a.headers), c = $E(r), f = RE(r), d = ME(t, r), h = ca(r.type, "model") ? r.type.model : void 0, p = `
    ${o.toLocaleLowerCase()}${c} {
      ${s}${f} ${d}
    }
  `, v = BE(r, i);
  return e.graphql({
    ...u,
    query: p,
    variables: v
  }, l).pipe(ch((x) => {
    const [y] = Object.keys(x.data), g = x.data[y], [E] = h ? Tn(e, h, [g], t, u.authMode, u.authToken) : [g];
    return E;
  }));
}
const A$ = {
  queries: "query",
  mutations: "mutation",
  subscriptions: "subscription"
};
function Rh(e, t, r, n) {
  if (!t)
    return {};
  const i = t.modelIntrospection;
  if (!i)
    return {};
  const a = i[r];
  if (!a)
    return {};
  const o = {}, s = n(e).amplify === null;
  for (const u of Object.values(a))
    o[u.name] = w$(e, i, A$[r], u, s, n);
  return o;
}
function C$(e, t, r) {
  return Rh(e, t, "mutations", r);
}
function O$(e, t, r) {
  return Rh(e, t, "queries", r);
}
function D$(e, t, r) {
  return Rh(e, t, "subscriptions", r);
}
const F$ = (e) => {
  const t = e.modelIntrospection;
  if (!t)
    return {};
  const r = {};
  for (const [n, i] of Object.entries(t.enums))
    r[i.name] = {
      values: () => i.values
    };
  return r;
};
function I$(e, t, r, n, i = !1) {
  return i ? async (s, u) => ay(e, t, r, n, u, s) : async (s) => ay(e, t, r, n, s);
}
async function ay(e, t, r, n, i, a) {
  var c, f, d, h;
  const { name: o } = r, s = tc(t, o, "LIST", i), u = rc(r, "LIST", i, t), l = La(e, n, i);
  try {
    const p = Ua(e, n, i == null ? void 0 : i.headers), { data: v, extensions: m } = a ? await e.graphql(a, {
      ...l,
      query: s,
      variables: u
    }, p) : await e.graphql({
      ...l,
      query: s,
      variables: u
    }, p);
    if (v !== void 0) {
      const [x] = Object.keys(v);
      if (v[x].items) {
        const y = v[x].items.map((g) => ei(t, o, g));
        return i != null && i.selectionSet ? {
          data: y,
          nextToken: v[x].nextToken,
          extensions: m
        } : {
          data: Tn(e, o, y, t, l.authMode, l.authToken, !!a),
          nextToken: v[x].nextToken,
          extensions: m
        };
      }
      return {
        data: v[x],
        nextToken: v[x].nextToken,
        extensions: m
      };
    }
  } catch (p) {
    const { data: v, errors: m } = p;
    if (v != null && Object.keys(v).length !== 0 && m) {
      const [x] = Object.keys(v);
      if ((c = v[x]) != null && c.items) {
        const y = v[x].items.map((g) => ei(t, o, g));
        return y ? i != null && i.selectionSet ? {
          data: y,
          nextToken: (f = v[x]) == null ? void 0 : f.nextToken,
          errors: m
        } : {
          data: Tn(e, o, y, t, l.authMode, l.authToken, !!a),
          nextToken: (d = v[x]) == null ? void 0 : d.nextToken,
          errors: m
        } : {
          data: v[x],
          nextToken: (h = v[x]) == null ? void 0 : h.nextToken,
          errors: m
        };
      } else
        return Wd(p);
    } else
      return Wd(p);
  }
}
function k$(e, t, r, n, i, a = !1) {
  return a ? async (u, l, c) => oy(e, t, r, n, i, {
    ...l,
    ...c
  }, u) : async (u, l) => oy(e, t, r, n, i, {
    ...u,
    ...l
  });
}
function N$(e, t, r, n, i) {
  const { data: a, extensions: o } = r, [s] = Object.keys(a);
  if (a[s].items) {
    const u = a[s].items.map((l) => ei(e, t, l));
    return {
      data: n ? u : i(u),
      nextToken: a[s].nextToken,
      extensions: o
    };
  }
  return {
    data: a[s],
    nextToken: a[s].nextToken,
    extensions: o
  };
}
async function oy(e, t, r, n, i, a, o) {
  var d, h, p, v;
  const { name: s } = r, u = tc(t, s, "INDEX_QUERY", a, n), l = rc(r, "INDEX_QUERY", a, t, n), c = La(e, i, a), f = (m) => Tn(e, s, m, t, c.authMode, c.authToken, !!o);
  try {
    const m = Ua(e, i, a == null ? void 0 : a.headers), y = [{
      ...c,
      query: u,
      variables: l
    }, m];
    o !== void 0 && y.unshift(o);
    const g = await e.graphql(...y);
    if (g.data !== void 0)
      return N$(t, s, g, a == null ? void 0 : a.selectionSet, f);
  } catch (m) {
    const { data: x, errors: y } = m;
    if (x !== void 0 && Object.keys(x).length !== 0 && y) {
      const [g] = Object.keys(x);
      if ((d = x[g]) != null && d.items) {
        const E = (h = x[g]) == null ? void 0 : h.items.map((b) => ei(t, s, b));
        if (E)
          return {
            data: a != null && a.selectionSet ? E : f(E),
            nextToken: (p = x[g]) == null ? void 0 : p.nextToken
          };
      }
      return {
        data: x[g],
        nextToken: (v = x[g]) == null ? void 0 : v.nextToken
      };
    } else
      return Wd(m);
  }
}
function P$(e, t, r, n, i, a = !1) {
  return a ? async (u, l, c) => sy(e, t, r, l, c, n, i, u) : async (u, l) => sy(e, t, r, u, l, n, i);
}
async function sy(e, t, r, n, i, a, o, s) {
  const { name: u } = r, l = tc(t, u, a, i), c = rc(r, a, n, t), f = La(e, o, i);
  try {
    const d = Ua(e, o, i == null ? void 0 : i.headers), { data: h, extensions: p } = s ? await e.graphql(s, {
      ...f,
      query: l,
      variables: c
    }, d) : await e.graphql({
      ...f,
      query: l,
      variables: c
    }, d);
    if (h) {
      const [v] = Object.keys(h), m = ei(t, u, h[v]);
      if (m === null)
        return { data: null, extensions: p };
      if (i != null && i.selectionSet)
        return { data: m, extensions: p };
      {
        const [x] = Tn(e, u, [m], t, f.authMode, f.authToken, !!s);
        return { data: x, extensions: p };
      }
    } else
      return { data: null, extensions: p };
  } catch (d) {
    const { data: h, errors: p } = d;
    if (h && Object.keys(h).length !== 0 && p) {
      const [v] = Object.keys(h), m = ei(t, u, h[v]);
      if (m) {
        if (i != null && i.selectionSet)
          return { data: m, errors: p };
        {
          const [x] = Tn(e, u, [m], t, f.authMode, f.authToken, !!s);
          return { data: x, errors: p };
        }
      } else
        return Hu(d);
    } else
      return Hu(d);
  }
}
function $$(e, t, r, n, i) {
  const { name: a } = r;
  return (s) => {
    const u = tc(t, a, n, s), l = rc(r, n, s, t), c = La(e, i, s), f = Ua(e, i, s == null ? void 0 : s.headers);
    return e.graphql({
      ...c,
      query: u,
      variables: l
    }, f).pipe(ch((h) => {
      const [p] = Object.keys(h.data), v = h.data[p], [m] = Tn(e, a, [v], t, c.authMode, c.authToken);
      return m;
    }));
  };
}
function R$(e) {
  const { primaryKeyFieldName: t, sortKeyFieldNames: r } = e.primaryKeyInfo;
  return [t, ...r];
}
function M$(e, t, r) {
  const n = Object.fromEntries(r.map((i) => [i, e[i]]));
  for (let i = 0; i < t.length; i++)
    if (Object.keys(n).every((a) => n[a] === t[i][a]))
      return i;
  return -1;
}
function B$(e, t) {
  const { name: r } = t;
  return (i) => new Xt((a) => {
    const o = [], s = [];
    let u = (...p) => s.push(...p);
    const l = e[r].onCreate(i).subscribe({
      next(p) {
        u({ item: p, type: "create" });
      },
      error(p) {
        a.error({ type: "onCreate", error: p });
      }
    }), c = e[r].onUpdate(i).subscribe({
      next(p) {
        u({ item: p, type: "update" });
      },
      error(p) {
        a.error({ type: "onUpdate", error: p });
      }
    }), f = e[r].onDelete(i).subscribe({
      next(p) {
        u({ item: p, type: "delete" });
      },
      error(p) {
        a.error({ type: "onDelete", error: p });
      }
    });
    function d(p) {
      for (const v of p) {
        const m = M$(v.item, o, h);
        switch (v.type) {
          case "create":
            m < 0 && o.push(v.item);
            break;
          case "update":
            m >= 0 && (o[m] = v.item);
            break;
          case "delete":
            m >= 0 && o.splice(m, 1);
            break;
          default:
            console.error("Unrecognized message in observeQuery.", v);
        }
      }
      a.next({
        items: o,
        isSynced: !0
      });
    }
    const h = R$(t);
    return (async () => {
      let p = !0, v = null;
      for (; !a.closed && (p || v); ) {
        p = !1;
        const { data: m, errors: x, nextToken: y } = await e[r].list({ ...i, nextToken: v });
        v = y, o.push(...m);
        const g = s.length === 0 && v == null;
        if (a.next({
          items: o,
          isSynced: g
        }), Array.isArray(x))
          for (const E of x)
            a.error(E);
      }
      s.length > 0 && d(s), u = (...m) => (d(m), o.length);
    })(), () => {
      l.unsubscribe(), c.unsubscribe(), f.unsubscribe();
    };
  });
}
const j$ = (e) => {
  var t, r, n;
  return e.type === "key" && // presence of `name` property distinguishes GSI from primary index
  ((t = e.properties) == null ? void 0 : t.name) && ((r = e.properties) == null ? void 0 : r.queryField) && ((n = e.properties) == null ? void 0 : n.fields.length) > 0;
}, L$ = (e) => {
  var r;
  return ((r = e.attributes) == null ? void 0 : r.filter(j$).map((n) => {
    const i = n.properties.queryField, [a, ...o] = n.properties.fields;
    return {
      queryField: i,
      pk: a,
      sk: o
    };
  })) || [];
};
function U$(e, t, r) {
  const n = {}, i = t.modelIntrospection;
  if (!i)
    return {};
  const a = ["ONCREATE", "ONUPDATE", "ONDELETE"];
  for (const o of Object.values(i.models)) {
    const { name: s } = o;
    n[s] = {}, Object.entries(kE).forEach(([l, { operationPrefix: c }]) => {
      const f = l;
      f === "LIST" ? n[s][c] = I$(e, i, o, r) : a.includes(f) ? n[s][c] = $$(e, i, o, f, r) : f === "OBSERVE_QUERY" ? n[s][c] = B$(n, o) : n[s][c] = P$(e, i, o, f, r);
    });
    const u = L$(o);
    for (const l of u)
      n[s][l.queryField] = k$(e, i, o, l, r);
  }
  return n;
}
function jE(e, t, r) {
  return e.models = U$(e, t, r), e.enums = F$(t), e.queries = O$(e, t, r), e.mutations = C$(e, t, r), e.subscriptions = D$(e, t, r), e;
}
function LE(e) {
  return e !== void 0;
}
function H$(e) {
  return e.event === "configure";
}
function W$(e) {
  var n;
  const t = {
    [CE]: e.amplify,
    [OE]: e.authMode,
    [DE]: e.authToken,
    [FE]: e.headers,
    graphql: d$,
    cancel: h$,
    isCancelError: p$,
    models: lo,
    enums: lo,
    queries: lo,
    mutations: lo,
    subscriptions: lo
  }, r = (n = e.amplify.getConfig().API) == null ? void 0 : n.GraphQL;
  return LE(r) ? jE(t, r, Nh) : z$(t), t;
}
const z$ = (e) => {
  Ox.listen("core", (t) => {
    var n;
    if (!H$(t.payload))
      return;
    const r = (n = t.payload.data.API) == null ? void 0 : n.GraphQL;
    LE(r) && jE(e, r, Nh);
  });
}, lo = new Proxy({}, {
  get() {
    throw new Error("Client could not be generated. This is likely due to `Amplify.configure()` not being called prior to `generateClient()` or because the configuration passed to `Amplify.configure()` is missing GraphQL provider configuration.");
  }
});
function q$(e = {}) {
  return W$({
    ...e,
    amplify: Ia
  });
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Y$ = Object.assign || function(t) {
  for (var r, n = 1, i = arguments.length; n < i; n++) {
    r = arguments[n];
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
  }
  return t;
}, V$ = [
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)$/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/]
], G$ = [
  "Windows Phone",
  "Android",
  "CentOS",
  { name: "Chrome OS", pattern: "CrOS" },
  "Debian",
  "Fedora",
  "FreeBSD",
  "Gentoo",
  "Haiku",
  "Kubuntu",
  "Linux Mint",
  "OpenBSD",
  "Red Hat",
  "SuSE",
  "Ubuntu",
  "Xubuntu",
  "Cygwin",
  "Symbian OS",
  "hpwOS",
  "webOS ",
  "webOS",
  "Tablet OS",
  "Tizen",
  "Linux",
  "Mac OS X",
  "Macintosh",
  "Mac",
  "Windows 98;",
  "Windows "
], K$ = {
  "10.0": "10",
  "6.4": "10 Technical Preview",
  "6.3": "8.1",
  "6.2": "8",
  "6.1": "Server 2008 R2 / 7",
  "6.0": "Server 2008 / Vista",
  "5.2": "Server 2003 / XP 64-bit",
  "5.1": "XP",
  "5.01": "2000 SP1",
  "5.0": "2000",
  "4.0": "NT",
  "4.90": "ME"
}, Q$ = new RegExp([
  "(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|",
  "compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|",
  "midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)",
  "\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|",
  "wap|windows ce|xda|xiino"
].join(""), "i"), X$ = new RegExp([
  "1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|",
  "ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|",
  "avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|",
  "cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|",
  "ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|",
  "g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|",
  "hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|",
  "i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|",
  "kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])",
  "|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|",
  "mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|",
  "n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|",
  "op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|",
  "po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|",
  "raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|",
  "se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|k\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|",
  "so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|",
  "tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|",
  "veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|",
  "w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-"
].join(""), "i"), J$ = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.navigator = r, this.process = n, this.userAgent = t || (this.navigator ? r.userAgent || r.vendor : "");
    }
    return e.prototype.detect = function() {
      if (this.process && !this.userAgent) {
        var t = this.process.version.slice(1).split(".").slice(0, 3), r = Array.prototype.slice.call(t, 1).join("") || "0";
        return {
          name: "node",
          version: t.join("."),
          versionNumber: parseFloat(t[0] + "." + r),
          mobile: !1,
          os: this.process.platform
        };
      }
      return this.userAgent || this.handleMissingError(), Y$({}, this.checkBrowser(), this.checkMobile(), this.checkOs());
    }, e.prototype.checkBrowser = function() {
      var t = this;
      return V$.filter(function(r) {
        return r[1].test(t.userAgent);
      }).map(function(r) {
        var n = r[1].exec(t.userAgent), i = n && n[1].split(/[._]/).slice(0, 3), a = Array.prototype.slice.call(i, 1).join("") || "0";
        return i && i.length < 3 && Array.prototype.push.apply(i, i.length === 1 ? [0, 0] : [0]), {
          name: String(r[0]),
          version: i.join("."),
          versionNumber: +(i[0] + "." + a)
        };
      }).shift();
    }, e.prototype.checkMobile = function() {
      var t = this.userAgent.substr(0, 4), r = Q$.test(this.userAgent) || X$.test(t);
      return { mobile: r };
    }, e.prototype.checkOs = function() {
      var t = this;
      return G$.map(function(r) {
        var n = r.name || r, i = t.getOsPattern(r);
        return {
          name: n,
          pattern: i,
          value: RegExp("\\b" + i.replace(/([ -])(?!$)/g, "$1?") + "(?:x?[\\d._]+|[ \\w.]*)", "i").exec(t.userAgent)
        };
      }).filter(function(r) {
        return r.value;
      }).map(function(r) {
        var n = r.value[0] || "", i;
        return r.pattern && r.name && /^Win/i.test(n) && !/^Windows Phone /i.test(n) && (i = K$[n.replace(/[^\d.]/g, "")]) && (n = "Windows " + i), r.pattern && r.name && (n = n.replace(RegExp(r.pattern, "i"), r.name)), n = n.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0].trim(), n = /^(?:webOS|i(?:OS|P))/.test(n) ? n : n.charAt(0).toUpperCase() + n.slice(1), { os: n };
      }).shift();
    }, e.prototype.getOsPattern = function(t) {
      var r = t;
      return (typeof t == "string" ? t : void 0) || r.pattern || r.name;
    }, e.prototype.handleMissingError = function() {
      throw new Error(`Please give user-agent.
> browser(navigator.userAgent or res.headers['user-agent']).`);
    }, e;
  }()
);
function vs(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
var Dr = vs(function(e) {
  var t = e.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t);
}), nn = vs(function(e) {
  var t = e.exports = { version: "2.5.7" };
  typeof __e == "number" && (__e = t);
});
nn.version;
var Wn = function(e) {
  return typeof e == "object" ? e !== null : typeof e == "function";
}, uy = function(e) {
  if (!Wn(e))
    throw TypeError(e + " is not an object!");
  return e;
}, nc = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, Mh = !nc(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), zd = Dr.document, Z$ = Wn(zd) && Wn(zd.createElement), eR = function(e) {
  return Z$ ? zd.createElement(e) : {};
}, tR = !Mh && !nc(function() {
  return Object.defineProperty(eR("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), rR = function(e, t) {
  if (!Wn(e))
    return e;
  var r, n;
  if (t && typeof (r = e.toString) == "function" && !Wn(n = r.call(e)) || typeof (r = e.valueOf) == "function" && !Wn(n = r.call(e)) || !t && typeof (r = e.toString) == "function" && !Wn(n = r.call(e)))
    return n;
  throw TypeError("Can't convert object to primitive value");
}, nR = Object.defineProperty, iR = Mh ? Object.defineProperty : function(t, r, n) {
  if (uy(t), r = rR(r, !0), uy(n), tR)
    try {
      return nR(t, r, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw TypeError("Accessors not supported!");
  return "value" in n && (t[r] = n.value), t;
}, aR = {
  f: iR
}, oR = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, xo = Mh ? function(e, t, r) {
  return aR.f(e, t, oR(1, r));
} : function(e, t, r) {
  return e[t] = r, e;
}, sR = {}.hasOwnProperty, ly = function(e, t) {
  return sR.call(e, t);
}, uR = 0, lR = Math.random(), UE = function(e) {
  return "Symbol(".concat(e === void 0 ? "" : e, ")_", (++uR + lR).toString(36));
}, cR = vs(function(e) {
  var t = UE("src"), r = "toString", n = Function[r], i = ("" + n).split(r);
  nn.inspectSource = function(a) {
    return n.call(a);
  }, (e.exports = function(a, o, s, u) {
    var l = typeof s == "function";
    l && (ly(s, "name") || xo(s, "name", o)), a[o] !== s && (l && (ly(s, t) || xo(s, t, a[o] ? "" + a[o] : i.join(String(o)))), a === Dr ? a[o] = s : u ? a[o] ? a[o] = s : xo(a, o, s) : (delete a[o], xo(a, o, s)));
  })(Function.prototype, r, function() {
    return typeof this == "function" && this[t] || n.call(this);
  });
}), fR = function(e) {
  if (typeof e != "function")
    throw TypeError(e + " is not a function!");
  return e;
}, qd = function(e, t, r) {
  if (fR(e), t === void 0)
    return e;
  switch (r) {
    case 1:
      return function(n) {
        return e.call(t, n);
      };
    case 2:
      return function(n, i) {
        return e.call(t, n, i);
      };
    case 3:
      return function(n, i, a) {
        return e.call(t, n, i, a);
      };
  }
  return function() {
    return e.apply(t, arguments);
  };
}, Yf = "prototype", qt = function(e, t, r) {
  var n = e & qt.F, i = e & qt.G, a = e & qt.S, o = e & qt.P, s = e & qt.B, u = i ? Dr : a ? Dr[t] || (Dr[t] = {}) : (Dr[t] || {})[Yf], l = i ? nn : nn[t] || (nn[t] = {}), c = l[Yf] || (l[Yf] = {}), f, d, h, p;
  i && (r = t);
  for (f in r)
    d = !n && u && u[f] !== void 0, h = (d ? u : r)[f], p = s && d ? qd(h, Dr) : o && typeof h == "function" ? qd(Function.call, h) : h, u && cR(u, f, h, e & qt.U), l[f] != h && xo(l, f, p), o && c[f] != h && (c[f] = h);
};
Dr.core = nn;
qt.F = 1;
qt.G = 2;
qt.S = 4;
qt.P = 8;
qt.B = 16;
qt.W = 32;
qt.U = 64;
qt.R = 128;
var Sn = qt, dR = {}.toString, HE = function(e) {
  return dR.call(e).slice(8, -1);
}, hR = Object("z").propertyIsEnumerable(0) ? Object : function(e) {
  return HE(e) == "String" ? e.split("") : Object(e);
}, WE = function(e) {
  if (e == null)
    throw TypeError("Can't call method on  " + e);
  return e;
}, pR = function(e) {
  return Object(WE(e));
}, vR = Math.ceil, mR = Math.floor, yR = function(e) {
  return isNaN(e = +e) ? 0 : (e > 0 ? mR : vR)(e);
}, gR = Math.min, xR = function(e) {
  return e > 0 ? gR(yR(e), 9007199254740991) : 0;
}, cy = Array.isArray || function(t) {
  return HE(t) == "Array";
}, bR = vs(function(e) {
  var t = "__core-js_shared__", r = Dr[t] || (Dr[t] = {});
  (e.exports = function(n, i) {
    return r[n] || (r[n] = i !== void 0 ? i : {});
  })("versions", []).push({
    version: nn.version,
    mode: "global",
    copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
  });
}), ER = vs(function(e) {
  var t = bR("wks"), r = Dr.Symbol, n = typeof r == "function", i = e.exports = function(a) {
    return t[a] || (t[a] = n && r[a] || (n ? r : UE)("Symbol." + a));
  };
  i.store = t;
}), wR = ER("species"), SR = function(e) {
  var t;
  return cy(e) && (t = e.constructor, typeof t == "function" && (t === Array || cy(t.prototype)) && (t = void 0), Wn(t) && (t = t[wR], t === null && (t = void 0))), t === void 0 ? Array : t;
}, _R = function(e, t) {
  return new (SR(e))(t);
}, zE = function(e, t) {
  var r = e == 1, n = e == 2, i = e == 3, a = e == 4, o = e == 6, s = e == 5 || o, u = t || _R;
  return function(l, c, f) {
    for (var d = pR(l), h = hR(d), p = qd(c, f, 3), v = xR(h.length), m = 0, x = r ? u(l, v) : n ? u(l, 0) : void 0, y, g; v > m; m++)
      if ((s || m in h) && (y = h[m], g = p(y, m, d), e)) {
        if (r)
          x[m] = g;
        else if (g)
          switch (e) {
            case 3:
              return !0;
            case 5:
              return y;
            case 6:
              return m;
            case 2:
              x.push(y);
          }
        else if (a)
          return !1;
      }
    return o ? -1 : i || a ? a : x;
  };
}, qE = function(e, t) {
  return !!e && nc(function() {
    t ? e.call(null, function() {
    }, 1) : e.call(null);
  });
}, TR = zE(2);
Sn(Sn.P + Sn.F * !qE([].filter, !0), "Array", {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function(t) {
    return TR(this, t, arguments[1]);
  }
});
nn.Array.filter;
var AR = zE(1);
Sn(Sn.P + Sn.F * !qE([].map, !0), "Array", {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function(t) {
    return AR(this, t, arguments[1]);
  }
});
nn.Array.map;
var Yd = `	
\v\f\r   ᠎             　\u2028\u2029\uFEFF`, Wu = "[" + Yd + "]", fy = "​", CR = RegExp("^" + Wu + Wu + "*"), OR = RegExp(Wu + Wu + "*$"), YE = function(e, t, r) {
  var n = {}, i = nc(function() {
    return !!Yd[e]() || fy[e]() != fy;
  }), a = n[e] = i ? t(DR) : Yd[e];
  r && (n[r] = a), Sn(Sn.P + Sn.F * i, "String", n);
}, DR = YE.trim = function(e, t) {
  return e = String(WE(e)), t & 1 && (e = e.replace(CR, "")), t & 2 && (e = e.replace(OR, "")), e;
}, FR = YE;
FR("trim", function(e) {
  return function() {
    return e(this, 3);
  };
});
nn.String.trim;
var IR = typeof window < "u" ? window.navigator : void 0, kR = typeof process < "u" ? process : void 0;
function VE(e) {
  var t = new J$(e, IR, kR);
  return t.detect();
}
const NR = `
    subscription onCreateConversation($requestId: ID!) {
        onCreateConversation(requestId: $requestId) {
            conversationId
            agentCognitoId
            requestId
            visitorId
            createdAt
            endTimestamp
        }
    }
`, PR = `
    subscription onUpdateChatRequest($requestId: ID!) {
        onUpdateChatRequest(requestId: $requestId) {
            requestId
            requestStatus
            endTimestamp
            isTransferred
            transferredRequestId
            wrapUpCode
        }
    }
`, $R = `
    subscription onCreateMessage($conversationId: ID!) {
        onCreateMessage(conversationId: $conversationId) {
            messageId
            visitorId
            conversationId
            messageType
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
        }
    }
`, RR = `
    subscription onAgentTyping($conversationId: ID!) {
        onAgentTyping(conversationId: $conversationId) {
            conversationId
            agentTyping
        }
    }
`, MR = `
    mutation createMessage($input: CreateMessageInput!) {
        createMessage(input: $input) {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
            sourceMsgId
            translated
            sourceLang
            targetLang
        }
    }
`, BR = `
    mutation updateEncryptedChatRequest($input: UpdateChatRequestInput!) {
        updateEncryptedChatRequest(input: $input) {
            requestId
            requestStatus
            speedToAnswer
            wrapUpCode
            endTimestamp
            expertName
            userEmail
            isTransferred
            transferredRequestId
            averageResponseTime
            engagementDuration
            violationCount
            chatAcceptTimeStamp
            expertId
            averageUserResponseTime
        }
    }
`, jR = `
    mutation createChatAudit($input: CreateChatAudit!) {
        createChatAudit(input: $input) {
            visitorId
            createdAt
            auditLog
            chatAuditId
            expertName
            requestId
        }
    }
`, LR = `
  query getMessages {
    getMessages(visitorId: "{visitorId}", conversationId: "{conversationId}") {
    messageId
    visitorId
    conversationId
    messageType
    messageStatus
    interactionType
    sender
    source
    content
    isSent
    recipient
    isActive
    createdAt
    sourceMsgId
    translated
    sourceLang
    targetLang
    agentResponseTime
    userResponseTime
    }
  }
`, tie = `
    subscription onCreateConversation {
        onCreateConversation(requestId: "{1}") {
            conversationId
            agentCognitoId
            requestId
            visitorId
            createdAt
            endTimestamp
        }
    }`, rie = `
    subscription onUpdateChatRequest {
        onUpdateChatRequest(requestId: "{1}") {
            requestId
            requestStatus
            endTimestamp
            isTransferred
            transferredRequestId
            wrapUpCode
        }
    }
`, nie = `
    subscription onCreateMessage {
        onCreateMessage(conversationId: "{1}") {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
        }
    }
`, iie = `
    subscription onAgentTyping {
        onAgentTyping(conversationId: "{1}") {
            conversationId
            agentTyping
        }
    }
`, UR = ({
  domain: e = "",
  httpMethod: t = "GET",
  path: r = "/",
  timestamp: n = Date.now(),
  apiClientKey: i = "",
  payload: a = ""
}) => {
  const s = `${e}${t}${r}${n}${((u) => Array.from(u).reverse().join(""))(i)}${a ? JSON.stringify(a) : ""}`;
  return E2.HmacSHA256(s, i).toString();
}, ur = {
  execute: async (e, t, r, n, i, a = !0) => {
    const o = {}, s = `${t}${r}`;
    if (a) {
      const u = Date.now(), l = i != null && i.data ? JSON.stringify(i.data) : "";
      o.headers = {
        "x-client-key": n.chat.apiKey,
        "x-asurion-product": n.chat.productName,
        "x-nvu-authorization": UR({
          domain: window.location.origin,
          httpMethod: e,
          timestamp: u,
          path: r,
          apiClientKey: n.chat.apiKey,
          payload: l
        }),
        "x-nvu-client": n.chat.clientName,
        "x-nvu-program": n.chat.program,
        "x-nvu-channel": "chat",
        "x-request-ts": u
      };
    }
    switch (e.toUpperCase()) {
      case "GET":
        return await wt.get(s, o);
      case "POST":
        return await wt.post(s, i == null ? void 0 : i.data, o);
      case "PUT":
        return await wt.put(s, i == null ? void 0 : i.data, o);
      case "DELETE":
        return await wt.delete(s, o);
      default:
        return await wt.get(s, o);
    }
  }
}, HR = {
  getApi: async (e, t) => {
    const r = Xe(), n = Ir(r);
    return wt.create({
      baseURL: t ?? `${{}.VITE_MYASURION_API_BASE_URL}${{}.VITE_MYASURION_API_BASE_PATH}` ?? {}.VITE_API_BASE_URL,
      headers: {
        "x-asurion-client": r,
        "x-asurion-cc": n.code
      },
      ...e
    });
  }
}, aie = async (e) => {
  var t;
  try {
    const r = (t = e.chat) != null && t.isSRBuild ? `${e.chat.baseEndpoint}` : `${e.chat.baseEndpoint}/${e.chat.environment}`, n = "/api/v1/nvu/worker/stats", { data: i } = await ur.execute("GET", r, n, e);
    return i;
  } catch (r) {
    console.error("Failed to get available workers", r);
  }
}, oie = async ({
  requestId: e,
  transferRequestId: t,
  chatConfig: r,
  action: n
}) => {
  var i;
  try {
    const a = (i = r.chat) != null && i.isSRBuild ? `${r.chat.baseEndpoint}` : `${r.chat.baseEndpoint}/${r.chat.environment}`, o = "/api/v1/nvu/chat/session", { data: s } = await ur.execute("PUT", a, o, r, {
      data: {
        transferRequestId: t,
        requestId: e,
        action: n
      }
    });
    return s;
  } catch (a) {
    return console.error("Failed to transfer chat session", a), { status: "failed", requestId: "", taskSid: "" };
  }
}, sie = async ({
  requestId: e,
  chatConfig: t,
  action: r
}) => {
  var n;
  try {
    const i = (n = t.chat) != null && n.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, a = "/api/v1/nvu/chat/session", { data: o } = await ur.execute("PUT", i, a, t, {
      data: {
        requestId: e,
        action: r
      }
    });
    return o;
  } catch (i) {
    return console.error("Failed to transfer chat session", i), { status: "failed", requestId: "", taskSid: "" };
  }
}, uie = async ({
  requestId: e,
  chatConfig: t
}) => {
  var r;
  try {
    const n = (r = t.chat) != null && r.isSRBuild ? `${t.chat.baseEndpoint}` : `${t.chat.baseEndpoint}/${t.chat.environment}`, a = `/api/v1/nvu/chat/session/stats${e ? `/${e}` : ""}`, { data: o } = await ur.execute("GET", n, a, t);
    return o;
  } catch (n) {
    console.error("Failed to retrieve chat stats", n);
    return;
  }
}, lie = async (e) => {
  var t;
  try {
    const r = (t = e.chat) != null && t.isSRBuild ? `${e.chat.baseEndpoint}` : `${e.chat.baseEndpoint}/${e.chat.environment}`, n = "/api/v1/nvu/chat/schedule", { data: i } = await ur.execute("GET", r, n, e);
    return i;
  } catch (r) {
    return console.error("Failed to get chat schedule", r), { isServiceable: !1 };
  }
}, cie = async (e, t, r) => {
  var n;
  try {
    const i = (n = e.chat) != null && n.isSRBuild ? `${e.chat.baseEndpoint}` : `${e.chat.baseEndpoint}/${e.chat.environment}`, a = "/api/v1/nvu/chat/task", o = {
      data: {
        request_id: (r == null ? void 0 : r.requestId) ?? e.userInfo.requestId,
        mdn: (r == null ? void 0 : r.mdn) ?? e.userInfo.mdn,
        visitorId: (r == null ? void 0 : r.visitorId) ?? e.userInfo.visitorId,
        userName: "User",
        source: "Web",
        carrier: e.chat.clientName,
        programName: e.chat.program,
        chatReason: "Technical Support",
        selectedLanguage: t === "zh-Hant-TW" ? "zh-TW" : t,
        browserAgent: JSON.stringify(VE()),
        // ipAddress: ipAddress,
        // for retailer specific like sinya..
        ...e.chat.retailerName && { retailerName: e.chat.retailerName }
      }
    }, { data: s } = await ur.execute("POST", i, a, e, o);
    return s;
  } catch (i) {
    console.error("Failed to create task", i);
  }
}, fie = async (e, t, r, n, i) => {
  var a;
  try {
    const o = (a = e.chat) != null && a.isSRBuild ? `${e.chat.baseEndpoint}` : `${e.chat.baseEndpoint}/${e.chat.environment}`, s = "/api/v1/nvu/chat/session", u = {
      data: {
        request_id: (i == null ? void 0 : i.requestId) ?? e.userInfo.requestId,
        mdn: (i == null ? void 0 : i.mdn) ?? e.userInfo.mdn,
        visitorId: (i == null ? void 0 : i.visitorId) ?? e.userInfo.visitorId,
        userName: "User",
        source: "Web",
        carrier: e.chat.clientName,
        programName: e.chat.program,
        chatReason: r ?? "Technical Support",
        ...n && { requestType: n },
        selectedLanguage: t === "zh-Hant-TW" ? "zh-TW" : t,
        browserAgent: JSON.stringify(VE()),
        // ipAddress: ipAddress,
        initiatedFrom: "Chatbot",
        ...gx() && { storeCode: z_() }
        // specific for PCHOME, SINYA & Yahoo
      }
    }, { data: l } = await ur.execute("POST", o, s, e, u);
    return l;
  } catch (o) {
    console.error("Failed to initialize chat session", o);
  }
}, die = async (e, t) => {
  var r;
  try {
    const n = `/api/v1/nvu/chat/session/task/${t}`, i = (r = e.chat) != null && r.isSRBuild ? `${e.chat.baseEndpoint}` : `${e.chat.baseEndpoint}/${e.chat.environment}`, a = {
      data: {}
    }, { data: o } = await ur.execute("POST", i, n, e, a);
    return o;
  } catch (n) {
    console.error("Failed to create task", n);
  }
}, hie = async (e, t, r) => {
  var n;
  try {
    const i = (n = r.chat) != null && n.isSRBuild ? `${r.chat.baseEndpoint}` : `${r.chat.baseEndpoint}/${r.chat.environment}`, a = `/api/v1/nvu/chat/task/${e}`, o = {
      data: {
        visitorId: r.userInfo.visitorId,
        action: t
        // region: 'sea'
      }
    }, { data: s } = await ur.execute("PUT", i, a, r, o);
    return s;
  } catch (i) {
    console.error(`Failed to ${t} task`, i);
  }
}, pie = async (e, t, r) => {
  var n, i;
  try {
    const a = ((n = t.chatBot) == null ? void 0 : n.path) ?? "/chatbot/api/v3/message", o = {
      data: {
        carrier: t.chat.clientName.toLowerCase(),
        conversation_id: "12345678",
        message: e,
        content: "true",
        ...r || {}
      }
    }, { data: s } = await ur.execute(
      "POST",
      `${(i = t.chatBot) == null ? void 0 : i.baseUrl}`,
      a,
      t,
      o,
      !1
    );
    return s;
  } catch (a) {
    console.error("Failed to get chatbot response", a);
  }
}, WR = async (e, t) => {
  try {
    const r = +/* @__PURE__ */ new Date(), i = await (await HR.getApi({}, t == null ? void 0 : t.baseEndpoint)).get("/cognito/user", {
      method: "GET",
      headers: {
        authorization: e.authorization,
        token: e.token,
        t: r,
        id: e.id,
        "x-api-key": t == null ? void 0 : t.apiKey
      }
    }), { data: a } = i;
    return a.body;
  } catch (r) {
    console.error("Failed to get chatbot response", r);
  }
}, vie = async (e, t) => {
  try {
    const r = `${e == null ? void 0 : e.baseEndpoint}/auth/send-inquiry`, n = Xe(), i = Ir(n), a = +/* @__PURE__ */ new Date(), o = es.SHA256(a.toString()).toString(), u = {
      Authorization: K0(
        {
          method: "POST",
          httpPath: "/api/v1/auth/send-inquiry",
          token: o || ""
        },
        (e == null ? void 0 : e.hmacKey) ?? {}.VITE_MYASURION_API_AUTH_HMAC_KEY
      ),
      token: o,
      t: a,
      "x-asurion-client": n,
      "x-asurion-cc": i.code
    };
    await wt({
      method: "POST",
      url: r,
      headers: u,
      data: t
    });
  } catch (r) {
    console.error("Failed to create callback workqueue", r);
  }
}, Pn = q$({ authMode: "userPool" }), mie = {
  subscribeToNewConversation: (e) => Pn.graphql({
    query: NR,
    variables: { requestId: e }
  }),
  subscribeToEndChat: (e) => Pn.graphql({
    query: PR,
    variables: { requestId: e }
  }),
  subscribeToNewMessages: (e) => Pn.graphql({
    query: $R,
    variables: { conversationId: e }
  }),
  subscribeToAgentTyping: (e) => Pn.graphql({
    query: RR,
    variables: { conversationId: e }
  }),
  createChatMessage: (e) => Pn.graphql({
    query: MR,
    variables: { input: e }
  }),
  createChatAudit: (e) => Pn.graphql({
    query: jR,
    variables: { input: e }
  }),
  getChatMessages: (e, t) => {
    const r = LR.replace("{visitorId}", e).replace(
      "{conversationId}",
      t
    );
    return Pn.graphql({
      query: r,
      variables: { visitorId: e, conversationId: t }
    });
  },
  updateChatRequest: (e) => Pn.graphql({
    query: BR,
    variables: { input: e }
  })
}, yie = async (e, t, r) => {
  try {
    const n = `${e == null ? void 0 : e.baseEndpoint}/online/serviceFee`, i = Xe(), a = Ir(i), o = {
      agreementId: t,
      data: r
    }, s = yx(), u = {
      token: s.token,
      "x-api-key": e == null ? void 0 : e.apiKey,
      "x-asurion-client": i,
      "x-asurion-cc": a.code,
      authorization: s.authorization,
      id: s.userId
    }, l = {
      method: "POST",
      url: n,
      headers: u,
      data: o
    }, { data: c } = await wt(l);
    if (c.statusCode === 400)
      throw new Error();
    return c.body;
  } catch (n) {
    return console.error("Failed to fetch online service fees", n), [];
  }
}, gie = async (e, t) => {
  var r;
  try {
    const n = `${(r = e.chatBot) == null ? void 0 : r.genInqEndpoint}`, i = `/general-inquiry/chats/${t}`, a = {
      "x-partner": e.chat.clientName,
      "x-program": e.chat.program
    }, o = {
      method: "GET",
      url: n + i,
      headers: a
    }, { data: s } = await wt(o);
    if (s.statusCode === 400)
      throw new Error();
    return s;
  } catch (n) {
    return console.error("Failed to fetch authentication token", n), [];
  }
}, xie = async (e, t, r, n, i) => {
  var l;
  const a = `${(l = e.chatBot) == null ? void 0 : l.genInqEndpoint}`, o = `/general-inquiry/chats/${r}/${n}`, s = {
    "x-partner": e.chat.clientName,
    "x-program": e.chat.program,
    "x-api-authtoken": t
  }, u = {
    method: "POST",
    url: a + o,
    headers: s,
    data: i,
    timeout: 25e3
  };
  try {
    const { data: c } = await wt(u);
    if (c.statusCode === 400)
      throw new Error();
    return c;
  } catch (c) {
    console.error("Failed to fetch message inquiry, retrying once", c);
    try {
      const { data: f } = await wt(u);
      if (f.statusCode === 400)
        throw new Error();
      return f;
    } catch (f) {
      return console.error("Failed to fetch message inquiry", f), [];
    }
  }
}, bie = async (e, t, r, n, i) => {
  var a;
  try {
    const o = `${(a = e.chatBot) == null ? void 0 : a.genInqEndpoint}`, s = `/general-inquiry/chats/${r}/${n}/feedback`, u = {
      "x-partner": e.chat.clientName,
      "x-program": e.chat.program,
      "x-api-authtoken": t
    }, l = {
      method: "POST",
      url: o + s,
      headers: u,
      data: i
    }, { data: c } = await wt(l);
    if (c.statusCode === 400)
      throw new Error();
    return c;
  } catch (o) {
    return console.error("Failed to submit message feedback", o), [];
  }
}, Eie = async (e) => {
  var t, r, n, i, a, o, s;
  try {
    const u = ((t = e == null ? void 0 : e.chatSurvey) == null ? void 0 : t.baseEndpoint) ?? "", l = ((r = e == null ? void 0 : e.chatSurvey) == null ? void 0 : r.surveyEndpoint) ?? "", c = {
      GetSurveyQuestions: {
        SurveyType: (n = e == null ? void 0 : e.chatSurvey) == null ? void 0 : n.surveyType,
        ClientId: (i = e == null ? void 0 : e.chatSurvey) == null ? void 0 : i.surveyClientId,
        TriggerPoint: ((a = e == null ? void 0 : e.chatSurvey) == null ? void 0 : a.surveyTriggerPoint) ?? "SR_Creation",
        Language: "en-US",
        ServiceRequestId: "",
        SessionId: ""
      }
    }, f = {
      data: c
    };
    if (!u) {
      const p = {
        "x-api-key": (o = e == null ? void 0 : e.chatSurvey) == null ? void 0 : o.surveyApiKey
      }, v = {
        method: "POST",
        url: (s = e == null ? void 0 : e.chatSurvey) == null ? void 0 : s.surveyEndpoint,
        headers: p,
        data: c
      }, { data: m } = await wt(v);
      return (m == null ? void 0 : m.GetSurveyQuestionsResponse) !== void 0 ? (m == null ? void 0 : m.GetSurveyQuestionsResponse).SurveyQuestions : m == null ? void 0 : m.SurveyQuestions;
    }
    const { data: d } = await ur.execute(
      "POST",
      u,
      l,
      e,
      f
    );
    return (d == null ? void 0 : d.GetSurveyQuestionsResponse) !== void 0 ? (d == null ? void 0 : d.GetSurveyQuestionsResponse).SurveyQuestions : d == null ? void 0 : d.SurveyQuestions;
  } catch (u) {
    return console.error("Failed to fetch chat NPS survey", u), [];
  }
}, wie = async (e, t) => {
  var r, n, i;
  try {
    const a = ((r = e == null ? void 0 : e.chatSurvey) == null ? void 0 : r.baseEndpoint) ?? "", o = ((n = e == null ? void 0 : e.chatSurvey) == null ? void 0 : n.surveySubmitEndpoint) ?? "", s = {
      data: {
        ...t
      }
    };
    if (typeof o == "string" && !a) {
      const u = {
        "x-api-key": (i = e == null ? void 0 : e.chatSurvey) == null ? void 0 : i.surveyApiKey
      };
      await wt({
        method: "POST",
        url: o,
        headers: u,
        data: t
      });
    } else
      typeof o == "string" && a ? await ur.execute(
        "POST",
        a,
        o,
        e,
        s
      ) : o instanceof Array && o.forEach(async (u) => {
        var l;
        try {
          if (u.endpoint)
            await ur.execute(
              "POST",
              u.endpoint,
              u.path,
              e,
              s
            );
          else {
            const c = {
              "x-api-key": (l = e == null ? void 0 : e.chatSurvey) == null ? void 0 : l.surveyApiKey
            }, f = {
              method: "POST",
              url: u.path,
              headers: c,
              data: t
            };
            await wt(f);
          }
        } catch (c) {
          console.error("Failed to submit chat NPS survey", { ...u }, c);
        }
      });
  } catch (a) {
    console.error("Failed to submit chat NPS survey", a);
    return;
  }
}, Sie = (e, t = 1e3) => setTimeout(() => e(), t), _ie = (e) => typeof e > "u" || e === "null" ? !0 : typeof e == "function" ? !1 : Array.isArray(e) ? e.length === 0 : typeof e == "string" && e.trim().length === 0 ? !0 : !e || Object.keys(e).length === 0, Tie = (e, t, r) => {
  const n = new Intl.DateTimeFormat("en-US", {
    timeStyle: "long",
    hour12: !1,
    timeZone: r
  }).format(/* @__PURE__ */ new Date()), i = "HH:mm:ss", a = re(+e, i), o = re(+t, i);
  return re(n, i).isBetween(a, o);
}, Aie = (e, t) => {
  const r = "hA", n = re(e, "hh:mm:ss").format(r), i = re(t, "hh:mm:ss").format(r);
  return `${n} - ${i}`;
}, co = () => n1().toString().replace(/-/g, "").toUpperCase(), zR = () => {
  const { chatConfig: e, baseApiConfig: t } = Bh(), [r] = Fa({
    authorization: "",
    token: "",
    id: ""
  });
  return {
    configure: async () => {
      if (!e)
        return;
      const o = {
        API: {
          GraphQL: {
            endpoint: (e == null ? void 0 : e.appSyncGraphQL.endpoint) || "",
            region: (e == null ? void 0 : e.appSyncGraphQL.region) || "",
            defaultAuthMode: (e == null ? void 0 : e.appSyncGraphQL.authType) || "userPool"
          }
        },
        Auth: {
          Cognito: {
            userPoolId: (e == null ? void 0 : e.amplifyConfig.cognitoUserPoolId) || "",
            userPoolClientId: (e == null ? void 0 : e.amplifyConfig.cognitoUserPoolWebClientId) || "",
            region: (e == null ? void 0 : e.amplifyConfig.cognitoRegion) || ""
          }
        }
      };
      TT.configure(o), AT.setKeyValueStorage(CT);
      const s = Xe(), u = Ir(s);
      try {
        const l = k8("cognitoUserSession");
        if (!l)
          throw new Error("no stored appsync data");
        if (!!!(await OT()).username)
          throw new Error("not signed in");
        return JSON.parse(l);
      } catch {
        const { username: c, token: f, appsyncData: d } = await WR(r, t);
        await ld(), await F8({
          username: c,
          password: f,
          options: {
            clientMetadata: {
              "x-asurion-client": s,
              "x-asurion-cc": u.code,
              authorization: r.authorization,
              token: r.token,
              id: r.id,
              "x-api-key": (t == null ? void 0 : t.apiKey) ?? ""
            }
          }
        });
        const h = JSON.stringify(d);
        return I8("cognitoUserSession", h, 3), d;
      }
    },
    logout: async () => await ld(),
    isAuthenticated: async () => {
      try {
        return await Od(), !0;
      } catch {
        return !1;
      }
    }
  };
}, dy = [
  "Oops! Something went wrong. Let's give it another shot, shall we?",
  "We hit a bump in the digital highway. Ready to try that login again?",
  "Looks like our spaceship hit a meteor. Hit that login button and we'll soar again!"
], qR = ({}) => {
  const [, e] = Jo({ profileId: "", userId: "" }), [, t] = Fa({}), [r, n] = Oe(
    Math.floor(Math.random() * dy.length)
  ), i = (a = "") => {
    console.log("doLogout", a), localStorage.clear();
    const o = sessionStorage.getItem("p");
    sessionStorage.clear(), sessionStorage.setItem("p", o ?? ""), e({ profileId: "", userId: "" }), t({});
  };
  return /* @__PURE__ */ S.jsxs(Cr, { flexDirection: "column", textAlign: "center", className: "chatbot-node", alignItems: "center", justifyContent: "center", h: "full", children: [
    /* @__PURE__ */ S.jsx(Ct, { mb: "30px", px: "20px", children: /* @__PURE__ */ S.jsx(
      _t,
      {
        text: dy[r],
        translationKey: `ReloginMessages/${r}`
      }
    ) }),
    /* @__PURE__ */ S.jsx(
      ri,
      {
        colorScheme: "primary",
        my: 2,
        onClick: () => {
          i("Relogin");
        },
        children: /* @__PURE__ */ S.jsx(
          _t,
          {
            text: "Try logging in again",
            translationKey: "ReloginMessages/TryLoggingInAgain"
          }
        )
      }
    )
  ] });
}, YR = Mr(() => import("./MyAsurionChat-d0f48bd7.js")), VR = Mr(() => import("./CelcomChat-25db9539.js")), GR = Mr(() => import("./MaxisChat-366dca65.js")), KR = Mr(() => import("./CHTHomeChat-d13da0ab.js")), QR = Mr(() => import("./StarhubChat-b6aff9b1.js")), XR = Mr(() => import("./SynnexChat-3e3f5452.js")), JR = Mr(() => import("./THDigitalChat-12c128d9.js")), ZR = Mr(
  () => import("./twopenmarketslwChat-0fce9f70.js")
), eM = Mr(
  () => import("./Ty3cChat-421f5003.js")
), hy = Mr(() => import("./JbhifiChat-0bccc56e.js")), tM = Mr(() => import("./M1Chat-0d1a9f8c.js")), Cie = ({
  onClose: e,
  onMinimize: t,
  styleProps: r,
  isLoggedIn: n,
  quickQuestion: i,
  isChatOpen: a,
  isChatMinimized: o,
  setHasChatsPending: s,
  customLoader: u = /* @__PURE__ */ S.jsx(Io, {})
}) => {
  const { chatConfig: l } = Bh(), { configure: c } = zR(), [f, d] = Oe(!1), [h, p] = Oe(!1), v = Xe(), m = ["starhub"].includes(v), [x, y] = Jo({
    profileId: "",
    userId: "",
    requestId: "",
    visitorId: ""
  }), [g] = Fa({
    authorization: "",
    token: "",
    id: ""
  }), E = async () => {
    N8("cognitoUserSession"), await ld(), e();
  }, { isLoading: b } = ol({
    queryKey: ["chat"],
    queryFn: c,
    cacheTime: 0,
    enabled: !!l && !!g.token,
    onSuccess: (O) => {
      y({
        ...x,
        requestId: O ? O.requestId : "",
        visitorId: O ? O.visitorId : ""
      });
    },
    onError: () => {
      p(!0), y({
        ...x,
        requestId: "",
        visitorId: ""
      });
    },
    onSettled: () => {
      d(!0);
    }
  }), w = (O) => O != null && O.firstName || O != null && O.enrolledMdn ? {
    name: O.firstName ?? "User",
    mdn: O.enrolledMdn ?? "000000000",
    visitorId: O.visitorId ?? co(),
    requestId: O.requestId ?? co()
  } : {
    name: "Visitor",
    mdn: co(),
    // create generic number for chatbot
    visitorId: co(),
    // same with mdn..
    requestId: co()
  }, _ = () => {
    if (l && f)
      return { userInfo: w(x), ...l };
  }, A = Vn(() => {
    var O;
    if (f) {
      const T = _();
      if (T) {
        const C = ((O = T.chat.chatClient) == null ? void 0 : O.toUpperCase()) || T.chat.clientName.toUpperCase();
        return {
          STARHUB: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            QR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              quickQuestion: i,
              isChatOpen: a,
              customLoader: u
            }
          ) }),
          STARHUB4: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            hy,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              isChatOpen: a,
              quickQuestion: i,
              customLoader: u,
              isChatMinimized: o,
              setHasChatsPending: s
            }
          ) }),
          CELCOM: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { children: u }), children: /* @__PURE__ */ S.jsx(
            VR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              quickQuestion: i,
              isChatOpen: a,
              customLoader: u
            }
          ) }),
          THDIGITAL: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            JR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n
            }
          ) }),
          SYNNEX: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            XR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              quickQuestion: i,
              isChatOpen: a
            }
          ) }),
          MAXIS: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            GR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n
            }
          ) }),
          CHT_HOME: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            KR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              quickQuestion: i,
              isChatOpen: a
            }
          ) }),
          JBHIFI: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            hy,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              isChatOpen: a,
              quickQuestion: i,
              customLoader: u,
              isChatMinimized: o,
              setHasChatsPending: s
            }
          ) }),
          TWOPENMARKET_SLW: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            ZR,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              quickQuestion: i
            }
          ) }),
          M1: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
            tM,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              isChatOpen: a,
              quickQuestion: i,
              customLoader: u,
              isChatMinimized: o,
              setHasChatsPending: s
            }
          ) }),
          TY3C: /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { children: u }), children: /* @__PURE__ */ S.jsx(
            eM,
            {
              config: T,
              onClose: E,
              onMinimize: t,
              isLoggedIn: n,
              quickQuestion: i,
              isChatOpen: a,
              customLoader: u
            }
          ) })
        }[C] ?? /* @__PURE__ */ S.jsx(tr, { fallback: /* @__PURE__ */ S.jsx(Wt, { h: "full", children: u }), children: /* @__PURE__ */ S.jsx(
          YR,
          {
            config: T,
            onClose: E,
            isLoggedIn: n
          }
        ) });
      }
    }
  }, [b, f, a, o]);
  return h ? /* @__PURE__ */ S.jsx(qR, {}) : /* @__PURE__ */ S.jsx(Sx, { flexFlow: "column nowrap", align: "center", w: "full", h: "full", ...r, children: b ? /* @__PURE__ */ S.jsx(Wt, { h: "full", children: m ? u : /* @__PURE__ */ S.jsx(Io, {}) }) : A });
}, Bh = () => {
  const e = sn(ub);
  if (e === void 0)
    throw new Error("useChatConfig must be used within a ChatProvider");
  return {
    chatConfig: e.chatConfig,
    firebaseConfig: e.firebaseConfig,
    baseApiConfig: e.baseApiConfig
  };
}, Us = (e) => e4.find(
  (t) => t.locale === e || t.name === e || t.code === e
) ?? {
  code: "EN",
  locale: "en-US",
  name: "English"
}, rM = (e, t) => {
  try {
    return decodeURIComponent(escape(e));
  } catch {
    return t;
  }
}, nM = ({
  onSelect: e = (n) => {
    console.log("Selected language", n);
  },
  boxProps: t,
  linkProps: r
}) => {
  const { data: n } = Jt(), { languages: i, languagesAvailable: a, theme: o } = n, { components: s } = o, { languageSelector: u } = s, [l, c] = Oe({
    ...(a || i)[0]
  }), {
    updateActiveLanguage: f,
    language: d,
    isTranslationsLoading: h
  } = Bl(), p = u && u.link && u.link.color || "black", [v] = M0("al", "");
  return He(() => {
    c(Us(v) ?? Us(d));
  }, []), He(() => {
    c(Us(d));
  }, [d]), !a && !i || (a == null ? void 0 : a.length) < 2 ? null : /* @__PURE__ */ S.jsx(
    Ix,
    {
      alignItems: "center",
      maxW: "180px",
      id: "myasurion-language-selector",
      gap: 0,
      spacing: 0,
      ...t,
      children: (a || i) && (a || i).map((m, x) => /* @__PURE__ */ S.jsx(
        sa,
        {
          maxW: "40px",
          borderRight: x < (a || i).length - 1 ? "1px solid #fff" : "none",
          children: /* @__PURE__ */ S.jsx(A0, { isLoaded: !h, children: /* @__PURE__ */ S.jsx(
            ri,
            {
              fontSize: "md",
              fontWeight: 400,
              color: p,
              variant: "link",
              w: "25px",
              h: "20px",
              textAlign: "center",
              textDecoration: l.code === m.code ? "underline" : "none",
              _hover: {
                color: p,
                textDecoration: "underline"
              },
              _selected: {
                color: p
              },
              onClick: () => {
                c({ ...m, index: x }), e({ ...m, index: x }), f(
                  Us(m.code).locale ?? "en-US"
                );
              },
              ...r,
              children: m != null && m.displayCode ? rM(m.displayCode, m.code) : m.code
            }
          ) })
        },
        `lang-${m.code}-${x}`
      ))
    }
  );
}, jh = ({ children: e }) => /* @__PURE__ */ S.jsx(px, { above: "md", children: e }), Vd = ({ children: e }) => /* @__PURE__ */ S.jsx(px, { below: "md", children: e }), py = ({ onToggle: e }) => {
  const { data: t } = Jt(), { theme: r } = t, { components: n } = r, { languageSelector: i } = n, { headerIsOpen: a } = Px(), o = i && i.link && i.link.color || "#000";
  return /* @__PURE__ */ S.jsx(S.Fragment, { children: /* @__PURE__ */ S.jsx(
    ri,
    {
      id: "myasurion-menubutton",
      as: wu,
      minW: "24px",
      w: "26px",
      p: 0,
      "aria-label": "profile",
      icon: a ? /* @__PURE__ */ S.jsx(cx, { fill: o ?? "#000", color: o ?? "#000" }) : /* @__PURE__ */ S.jsx(IT, { fill: o ?? "#000" }),
      variant: "outline",
      border: "none",
      bg: "none",
      _hover: {
        bg: "none"
      },
      _selected: {
        bg: "none"
      },
      _active: {
        bg: "none"
      },
      onClick: () => e()
    }
  ) });
}, iM = (e) => {
  const { data: t } = Jt(), { theme: r } = t, { colors: n } = r, { primary: i } = n;
  return /* @__PURE__ */ S.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e, children: [
    /* @__PURE__ */ S.jsx(
      "path",
      {
        fill: i || "#8223D2",
        d: "M7 22h11c1.103 0 2-.897 2-2V4c0-1.102-.897-2-2-2H7c-1.103 0-2 .898-2 2v3h2V4h11v16H7v-3H5v3c0 1.103.897 2 2 2Z"
      }
    ),
    /* @__PURE__ */ S.jsx(
      "path",
      {
        fill: i || "#8223D2",
        d: "m10.293 8.708 1.414-1.416 4.707 4.699-4.706 4.715-1.416-1.412L12.582 13H4v-2h8.59l-2.297-2.292Z"
      }
    )
  ] });
}, aM = ({
  label: e,
  iconSrc: t,
  onSignOut: r,
  ...n
}) => {
  const [, i] = Jo({}), [, a] = Fa({}), { data: o } = Jt(), { theme: s } = o, { colors: u } = s, { accent: l } = u;
  return /* @__PURE__ */ S.jsxs(
    ri,
    {
      id: "myasurion-signout-link",
      w: "full",
      minW: "287px",
      p: "12px 20px",
      colorScheme: "primary",
      color: l,
      textDecoration: "underline",
      variant: "link",
      onClick: () => {
        localStorage.clear();
        const c = sessionStorage.getItem("p"), f = sessionStorage.getItem("al");
        sessionStorage.clear(), sessionStorage.setItem("p", c ?? ""), sessionStorage.setItem("al", f ?? ""), i({}), a({}), r && r();
      },
      ...n,
      children: [
        /* @__PURE__ */ S.jsx(jh, { children: /* @__PURE__ */ S.jsx(Ce, { mr: "8px", children: /* @__PURE__ */ S.jsx(iM, {}) }) }),
        e || /* @__PURE__ */ S.jsx(_t, { text: "Sign out", translationKey: "Global/Signout" })
      ]
    }
  );
}, oM = ({
  firstname: e,
  lastname: t,
  accountType: r = "main account",
  signOutProps: n,
  serviceRequestButtonProps: i,
  skipUrlClick: a,
  ...o
}) => {
  const { data: s } = Jt(), { urls: u, mainMenu: l } = s, { theme: c } = s, { serviceRequestBtn: f } = (c == null ? void 0 : c.components) || {}, d = Xe(), h = v_(), p = (m) => {
    a && m && h(`/${m}`);
  }, v = (m) => m.split("/").pop();
  return /* @__PURE__ */ S.jsxs(
    Ce,
    {
      id: "myasurion-menu-display",
      zIndex: 999998,
      pos: "fixed",
      top: 0,
      left: 0,
      bg: "#fff",
      w: "full",
      h: "100dvh",
      m: 0,
      p: 0,
      border: "none",
      ...o,
      children: [
        /* @__PURE__ */ S.jsxs(
          Oi,
          {
            gap: 0,
            spacing: 0,
            w: "full",
            alignItems: "baseline",
            id: "myasurion-menu-display-stack",
            children: [
              /* @__PURE__ */ S.jsx(Ce, { w: "full", px: "16px", py: "24px", borderBottom: "1px solid #F0F0F5", children: /* @__PURE__ */ S.jsxs(Ni, { gap: 6, children: [
                /* @__PURE__ */ S.jsx(Ce, { children: /* @__PURE__ */ S.jsx(
                  kT,
                  {
                    firstname: e,
                    lastname: t,
                    carrier: d
                  }
                ) }),
                /* @__PURE__ */ S.jsx(Ce, { children: /* @__PURE__ */ S.jsxs(Oi, { alignItems: "baseline", children: [
                  /* @__PURE__ */ S.jsx(
                    Ct,
                    {
                      fontSize: "xs",
                      fontWeight: 900,
                      lineHeight: "136%",
                      textTransform: "uppercase",
                      children: /* @__PURE__ */ S.jsx(
                        _t,
                        {
                          text: r,
                          translationKey: `MenuDisplay/${r}`
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ S.jsx(
                    Js,
                    {
                      textTransform: "capitalize",
                      fontSize: "2xl",
                      lineHeight: "132%",
                      href: a ? "#" : `${kc((u == null ? void 0 : u.profile) || "")}`,
                      onClick: (m) => {
                        a && (m.preventDefault(), p(u == null ? void 0 : u.profile));
                      },
                      _hover: { textDecoration: "none", cursor: "pointer" },
                      children: d === "cht_home" ? `${t} ${e}` : `${e} ${t}`
                    }
                  )
                ] }) }),
                /* @__PURE__ */ S.jsx(sd, {}),
                /* @__PURE__ */ S.jsx(Ce, { children: /* @__PURE__ */ S.jsx(
                  Js,
                  {
                    href: `${kc((u == null ? void 0 : u.profile) || "")}`,
                    _hover: { textDecoration: "none", cursor: "pointer" },
                    children: /* @__PURE__ */ S.jsx(Rp, { w: "24px", h: "24px", color: "#000" })
                  }
                ) })
              ] }) }),
              l && l.map((m, x) => {
                const y = kc(m.url);
                return /* @__PURE__ */ S.jsx(Ce, { w: "full", px: "16px", py: "24px", children: /* @__PURE__ */ S.jsx(Ni, { children: /* @__PURE__ */ S.jsx(
                  Js,
                  {
                    fontSize: "2xl",
                    fontWeight: 300,
                    lineHeight: "132%",
                    href: a ? "#" : y,
                    onClick: (g) => {
                      a && (g.preventDefault(), p(v(y)));
                    },
                    w: "100%",
                    _hover: { textDecoration: "none", cursor: "pointer" },
                    children: /* @__PURE__ */ S.jsxs(T0, { direction: "row", gap: 0, children: [
                      /* @__PURE__ */ S.jsx(Ce, { children: m.name }),
                      /* @__PURE__ */ S.jsx(sd, {}),
                      /* @__PURE__ */ S.jsx(Ce, { children: /* @__PURE__ */ S.jsx(
                        Rp,
                        {
                          w: "24px",
                          h: "24px",
                          color: "#000"
                        }
                      ) })
                    ] })
                  }
                ) }) }, `menu-${m.code}-${x}`);
              })
            ]
          }
        ),
        /* @__PURE__ */ S.jsx(
          Ce,
          {
            id: "header-signout-section",
            position: "fixed",
            bottom: 0,
            w: "full",
            bg: "#FFFFFF",
            boxShadow: " 0px -4px 8px 0px rgba(0, 0, 0, 0.04)",
            children: /* @__PURE__ */ S.jsxs(Oi, { alignItems: "baseline", w: "full", gap: 6, p: "24px 16px", children: [
              i && i.enabled && /* @__PURE__ */ S.jsx(
                ri,
                {
                  ...f,
                  ...i == null ? void 0 : i.styleProps,
                  onClick: () => {
                    i != null && i.onClick && i.onClick();
                  },
                  children: (i == null ? void 0 : i.label) || "File a service request"
                }
              ),
              /* @__PURE__ */ S.jsx(
                aM,
                {
                  label: (n == null ? void 0 : n.label) && n.label,
                  onSignOut: () => {
                    n != null && n.onSignOut && n.onSignOut();
                  },
                  margin: "0 auto",
                  ...n == null ? void 0 : n.styleProps
                }
              )
            ] })
          }
        )
      ]
    }
  );
}, sM = (e) => {
  var t, r;
  return /* @__PURE__ */ S.jsxs(Ce, { position: "relative", p: "4px", children: [
    /* @__PURE__ */ S.jsxs(
      y_,
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        ...e,
        children: [
          /* @__PURE__ */ S.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0 12.279V15H18V12.279L17.316 12.052C15.931 11.589 15 10.298 15 8.838V6C15 2.691 12.309 0 9 0C5.691 0 3 2.691 3 6V8.838C3 10.298 2.069 11.589 0.684 12.052L0 12.279ZM14.966 13H3.035C4.255 11.998 5 10.486 5 8.838V6C5 3.794 6.794 2 9 2C11.206 2 13 3.794 13 6V8.838C13 10.486 13.745 11.998 14.966 13Z",
              fill: ((t = e == null ? void 0 : e.fill) == null ? void 0 : t.toString()) ?? "black"
            }
          ),
          /* @__PURE__ */ S.jsx(
            "path",
            {
              d: "M8.9997 18C7.5237 18 6.24769 17.19 5.55469 16H12.4447C11.7517 17.19 10.4757 18 8.9997 18Z",
              fill: ((r = e == null ? void 0 : e.fill) == null ? void 0 : r.toString()) ?? "black"
            }
          )
        ]
      }
    ),
    (e == null ? void 0 : e.promptcount) > 0 && /* @__PURE__ */ S.jsx(
      Zs,
      {
        position: "absolute",
        top: "0",
        right: "0",
        minBlockSize: "14px",
        minInlineSize: "14px",
        minW: "14px",
        minH: "14px",
        padding: e.promptcount > 100 ? "4px" : "unset",
        verticalAlign: "middle",
        background: "#DB1B1B",
        children: /* @__PURE__ */ S.jsx(
          Ct,
          {
            fontWeight: 700,
            size: e.promptcount > 100 ? "7px" : "8px",
            lineHeight: "normal",
            fontSize: e.promptcount > 100 ? "7px" : "8px",
            textAlign: "center",
            color: "white",
            children: e.promptcount
          }
        )
      }
    )
  ] });
}, uM = ({
  onToggle: e,
  isLoading: t,
  promptCount: r
}) => {
  const { data: n } = Jt(), { theme: i } = n, { components: a } = i, { languageSelector: o } = a, s = o && o.link && o.link.color || "#fff";
  return /* @__PURE__ */ S.jsx(S.Fragment, { children: /* @__PURE__ */ S.jsx(
    ri,
    {
      id: "myasurion-menubutton",
      as: wu,
      minW: "24px",
      w: "26px",
      p: 0,
      "aria-label": "profile",
      icon: /* @__PURE__ */ S.jsx(A0, { isLoaded: !t, p: t ? "2px" : "0", children: /* @__PURE__ */ S.jsx(
        sM,
        {
          fill: s ?? "#fff",
          promptcount: r ?? 0
        }
      ) }),
      variant: "outline",
      border: "none",
      bg: "none",
      _hover: {
        bg: "none"
      },
      _selected: {
        bg: "none"
      },
      _active: {
        bg: "none"
      },
      onClick: () => e(),
      h: "min-content"
    }
  ) });
};
function zu(e) {
  "@babel/helpers - typeof";
  return zu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zu(e);
}
function Vt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function lM(e) {
  return Vt(1, arguments), e instanceof Date || zu(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function cn(e) {
  Vt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || zu(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function cM(e) {
  if (Vt(1, arguments), !lM(e) && typeof e != "number")
    return !1;
  var t = cn(e);
  return !isNaN(Number(t));
}
function Mi(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function fM(e, t) {
  Vt(2, arguments);
  var r = cn(e).getTime(), n = Mi(t);
  return new Date(r + n);
}
function dM(e, t) {
  Vt(2, arguments);
  var r = Mi(t);
  return fM(e, -r);
}
var hM = 864e5;
function pM(e) {
  Vt(1, arguments);
  var t = cn(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / hM) + 1;
}
function qu(e) {
  Vt(1, arguments);
  var t = 1, r = cn(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function GE(e) {
  Vt(1, arguments);
  var t = cn(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = qu(n), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = qu(a);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function vM(e) {
  Vt(1, arguments);
  var t = GE(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = qu(r);
  return n;
}
var mM = 6048e5;
function yM(e) {
  Vt(1, arguments);
  var t = cn(e), r = qu(t).getTime() - vM(t).getTime();
  return Math.round(r / mM) + 1;
}
var gM = {};
function ic() {
  return gM;
}
function Yu(e, t) {
  var r, n, i, a, o, s, u, l;
  Vt(1, arguments);
  var c = ic(), f = Mi((r = (n = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : c.weekStartsOn) !== null && n !== void 0 ? n : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = cn(e), h = d.getUTCDay(), p = (h < f ? 7 : 0) + h - f;
  return d.setUTCDate(d.getUTCDate() - p), d.setUTCHours(0, 0, 0, 0), d;
}
function KE(e, t) {
  var r, n, i, a, o, s, u, l;
  Vt(1, arguments);
  var c = cn(e), f = c.getUTCFullYear(), d = ic(), h = Mi((r = (n = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(f + 1, 0, h), p.setUTCHours(0, 0, 0, 0);
  var v = Yu(p, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(f, 0, h), m.setUTCHours(0, 0, 0, 0);
  var x = Yu(m, t);
  return c.getTime() >= v.getTime() ? f + 1 : c.getTime() >= x.getTime() ? f : f - 1;
}
function xM(e, t) {
  var r, n, i, a, o, s, u, l;
  Vt(1, arguments);
  var c = ic(), f = Mi((r = (n = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), d = KE(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d, 0, f), h.setUTCHours(0, 0, 0, 0);
  var p = Yu(h, t);
  return p;
}
var bM = 6048e5;
function EM(e, t) {
  Vt(1, arguments);
  var r = cn(e), n = Yu(r, t).getTime() - xM(r, t).getTime();
  return Math.round(n / bM) + 1;
}
function Qe(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var wM = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
    return Qe(r === "yy" ? i % 100 : i, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : Qe(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return Qe(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return Qe(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return Qe(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return Qe(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return Qe(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, n - 3));
    return Qe(a, r.length);
  }
};
const $n = wM;
var ea = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, SM = {
  // Era
  G: function(t, r, n) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return $n.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, i) {
    var a = KE(t, i), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      var s = o % 100;
      return Qe(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : Qe(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = GE(t);
    return Qe(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return Qe(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(i);
      case "QQ":
        return Qe(i, 2);
      case "Qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(i);
      case "qq":
        return Qe(i, 2);
      case "qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return $n.M(t, r);
      case "Mo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(i + 1);
      case "LL":
        return Qe(i + 1, 2);
      case "Lo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, i) {
    var a = EM(t, i);
    return r === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : Qe(a, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var i = yM(t);
    return r === "Io" ? n.ordinalNumber(i, {
      unit: "week"
    }) : Qe(i, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : $n.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var i = pM(t);
    return r === "Do" ? n.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : Qe(i, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var i = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return Qe(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return Qe(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (r) {
      case "i":
        return String(a);
      case "ii":
        return Qe(a, r.length);
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = ea.noon : i === 0 ? a = ea.midnight : a = i / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = ea.evening : i >= 12 ? a = ea.afternoon : i >= 4 ? a = ea.morning : a = ea.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return $n.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : $n.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var i = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : Qe(i, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), r === "ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : Qe(i, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : $n.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : $n.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return $n.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return my(o);
      case "XXXX":
      case "XX":
        return pi(o);
      case "XXXXX":
      case "XXX":
      default:
        return pi(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      case "x":
        return my(o);
      case "xxxx":
      case "xx":
        return pi(o);
      case "xxxxx":
      case "xxx":
      default:
        return pi(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + vy(o, ":");
      case "OOOO":
      default:
        return "GMT" + pi(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + vy(o, ":");
      case "zzzz":
      default:
        return "GMT" + pi(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return Qe(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTime();
    return Qe(o, r.length);
  }
};
function vy(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), a = n % 60;
  if (a === 0)
    return r + String(i);
  var o = t || "";
  return r + String(i) + o + Qe(a, 2);
}
function my(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + Qe(Math.abs(e) / 60, 2);
  }
  return pi(e, t);
}
function pi(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), a = Qe(Math.floor(i / 60), 2), o = Qe(i % 60, 2);
  return n + a + r + o;
}
const _M = SM;
var yy = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, QE = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, TM = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], i = n[1], a = n[2];
  if (!a)
    return yy(t, r);
  var o;
  switch (i) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", yy(i, r)).replace("{{time}}", QE(a, r));
}, AM = {
  p: QE,
  P: TM
};
const CM = AM;
function OM(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var DM = ["D", "DD"], FM = ["YY", "YYYY"];
function IM(e) {
  return DM.indexOf(e) !== -1;
}
function kM(e) {
  return FM.indexOf(e) !== -1;
}
function gy(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var NM = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, PM = function(t, r, n) {
  var i, a = NM[t];
  return typeof a == "string" ? i = a : r === 1 ? i = a.one : i = a.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
const $M = PM;
function Vf(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var RM = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, MM = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, BM = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, jM = {
  date: Vf({
    formats: RM,
    defaultWidth: "full"
  }),
  time: Vf({
    formats: MM,
    defaultWidth: "full"
  }),
  dateTime: Vf({
    formats: BM,
    defaultWidth: "full"
  })
};
const LM = jM;
var UM = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, HM = function(t, r, n, i) {
  return UM[t];
};
const WM = HM;
function fo(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, u = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[u] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[l];
  };
}
var zM = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, qM = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, YM = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, VM = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, GM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, KM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, QM = function(t, r) {
  var n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, XM = {
  ordinalNumber: QM,
  era: fo({
    values: zM,
    defaultWidth: "wide"
  }),
  quarter: fo({
    values: qM,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: fo({
    values: YM,
    defaultWidth: "wide"
  }),
  day: fo({
    values: VM,
    defaultWidth: "wide"
  }),
  dayPeriod: fo({
    values: GM,
    defaultWidth: "wide",
    formattingValues: KM,
    defaultFormattingWidth: "wide"
  })
};
const JM = XM;
function ho(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? eB(s, function(f) {
      return f.test(o);
    }) : ZM(s, function(f) {
      return f.test(o);
    }), l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = r.valueCallback ? r.valueCallback(l) : l;
    var c = t.slice(o.length);
    return {
      value: l,
      rest: c
    };
  };
}
function ZM(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function eB(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function tB(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var i = n[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var rB = /^(\d+)(th|st|nd|rd)?/i, nB = /\d+/i, iB = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, aB = {
  any: [/^b/i, /^(a|c)/i]
}, oB = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, sB = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, uB = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, lB = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, cB = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, fB = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, dB = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, hB = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, pB = {
  ordinalNumber: tB({
    matchPattern: rB,
    parsePattern: nB,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ho({
    matchPatterns: iB,
    defaultMatchWidth: "wide",
    parsePatterns: aB,
    defaultParseWidth: "any"
  }),
  quarter: ho({
    matchPatterns: oB,
    defaultMatchWidth: "wide",
    parsePatterns: sB,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ho({
    matchPatterns: uB,
    defaultMatchWidth: "wide",
    parsePatterns: lB,
    defaultParseWidth: "any"
  }),
  day: ho({
    matchPatterns: cB,
    defaultMatchWidth: "wide",
    parsePatterns: fB,
    defaultParseWidth: "any"
  }),
  dayPeriod: ho({
    matchPatterns: dB,
    defaultMatchWidth: "any",
    parsePatterns: hB,
    defaultParseWidth: "any"
  })
};
const vB = pB;
var mB = {
  code: "en-US",
  formatDistance: $M,
  formatLong: LM,
  formatRelative: WM,
  localize: JM,
  match: vB,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const yB = mB;
var gB = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, xB = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, bB = /^'([^]*?)'?$/, EB = /''/g, wB = /[a-zA-Z]/;
function SB(e, t, r) {
  var n, i, a, o, s, u, l, c, f, d, h, p, v, m, x, y, g, E;
  Vt(2, arguments);
  var b = String(t), w = ic(), _ = (n = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : w.locale) !== null && n !== void 0 ? n : yB, A = Mi((a = (o = (s = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (l = r.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = w.locale) === null || f === void 0 || (d = f.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(A >= 1 && A <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = Mi((h = (p = (v = (m = r == null ? void 0 : r.weekStartsOn) !== null && m !== void 0 ? m : r == null || (x = r.locale) === null || x === void 0 || (y = x.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && v !== void 0 ? v : w.weekStartsOn) !== null && p !== void 0 ? p : (g = w.locale) === null || g === void 0 || (E = g.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!_.localize)
    throw new RangeError("locale must contain localize property");
  if (!_.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var T = cn(e);
  if (!cM(T))
    throw new RangeError("Invalid time value");
  var C = OM(T), $ = dM(T, C), P = {
    firstWeekContainsDate: A,
    weekStartsOn: O,
    locale: _,
    _originalDate: T
  }, j = b.match(xB).map(function(W) {
    var Y = W[0];
    if (Y === "p" || Y === "P") {
      var V = CM[Y];
      return V(W, _.formatLong);
    }
    return W;
  }).join("").match(gB).map(function(W) {
    if (W === "''")
      return "'";
    var Y = W[0];
    if (Y === "'")
      return _B(W);
    var V = _M[Y];
    if (V)
      return !(r != null && r.useAdditionalWeekYearTokens) && kM(W) && gy(W, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && IM(W) && gy(W, t, String(e)), V($, W, _.localize, P);
    if (Y.match(wB))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
    return W;
  }).join("");
  return j;
}
function _B(e) {
  var t = e.match(bB);
  return t ? t[1].replace(EB, "'") : e;
}
const TB = ({
  notificationsCount: e,
  notifications: t,
  ...r
}) => {
  var s;
  const { data: n } = Jt(), { theme: i } = n, { colors: a } = i, { language: o } = Bl();
  return /* @__PURE__ */ S.jsx(
    Ce,
    {
      id: "myasurion-notifications-display",
      zIndex: 999998,
      pos: "fixed",
      top: 0,
      left: 0,
      bg: "#fff",
      w: "full",
      h: "100dvh",
      m: 0,
      p: 0,
      border: "none",
      color: "black",
      overflowY: "auto",
      ...r,
      children: /* @__PURE__ */ S.jsxs(
        Oi,
        {
          gap: 0,
          spacing: 0,
          w: "full",
          alignItems: "baseline",
          id: "myasurion-notifications-display-stack",
          maxW: { base: "initial", lg: "768px", xl: "992px", "2xl": "1280px" },
          mx: "auto",
          pt: { md: 8 },
          children: [
            /* @__PURE__ */ S.jsx(Ce, { w: "full", px: "16px", py: "16px", children: /* @__PURE__ */ S.jsxs(Ni, { gap: 6, children: [
              /* @__PURE__ */ S.jsx(Ce, { children: /* @__PURE__ */ S.jsxs(Oi, { alignItems: "baseline", gap: 1, children: [
                /* @__PURE__ */ S.jsx(
                  Ct,
                  {
                    fontSize: "2xl",
                    fontWeight: 400,
                    lineHeight: "132%",
                    fontStyle: "normal",
                    children: /* @__PURE__ */ S.jsx(
                      _t,
                      {
                        translationKey: "Global/Notifications",
                        text: "notifications"
                      }
                    )
                  }
                ),
                t && Array.isArray(t) && /* @__PURE__ */ S.jsxs(
                  Ct,
                  {
                    fontSize: "md",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "124%",
                    color: "#6E767D",
                    children: [
                      o === "th-TH" ? "ล่าสุดวันที่" : "Last",
                      " ",
                      new Date(
                        (s = t[0]) == null ? void 0 : s.NotificationDate
                      ).toLocaleString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric"
                      })
                    ]
                  }
                )
              ] }) }),
              /* @__PURE__ */ S.jsx(sd, {})
            ] }) }),
            t && Array.isArray(t) && (t == null ? void 0 : t.map((u, l) => /* @__PURE__ */ S.jsx(Ce, { w: "full", px: "16px", children: /* @__PURE__ */ S.jsxs(
              Cr,
              {
                alignSelf: "stretch",
                padding: "12px 0px 20px",
                direction: "column",
                borderBottom: "1px solid #D5D6DA",
                gap: "8px",
                children: [
                  /* @__PURE__ */ S.jsx(
                    Ct,
                    {
                      fontSize: "18px",
                      fontWeight: 700,
                      lineHeight: "132%",
                      color: (u == null ? void 0 : u.IsResolved) === "N" ? a.primary : "black",
                      children: o === "th-TH" ? (u == null ? void 0 : u.ServiceRequestEventDescTl) ?? (u == null ? void 0 : u.ServiceRequestEventDesc) : u == null ? void 0 : u.ServiceRequestEventDesc
                    }
                  ),
                  /* @__PURE__ */ S.jsx(
                    Ct,
                    {
                      fontSize: "md",
                      fontWeight: (u == null ? void 0 : u.IsResolved) === "N" ? 700 : 400,
                      lineHeight: "124%",
                      fontStyle: "normal",
                      children: o === "th-TH" ? u == null ? void 0 : u.NotificationBodyTL : u == null ? void 0 : u.NotificationBody
                    }
                  ),
                  /* @__PURE__ */ S.jsx(
                    Ct,
                    {
                      fontSize: "sm",
                      fontStyle: "normal",
                      lineHeight: "136%",
                      fontWeight: 400,
                      color: "#6E767D",
                      children: SB(new Date(u == null ? void 0 : u.EventDate), "d MMMM yyyy h:mm aaa")
                    }
                  )
                ]
              }
            ) }, `notifs-${u == null ? void 0 : u.AgreementId}-${l}`))),
            (!t || !Array.isArray(t) || (t == null ? void 0 : t.length) === 0) && /* @__PURE__ */ S.jsx(Ce, { w: "full", px: "16px", children: /* @__PURE__ */ S.jsx(
              Cr,
              {
                alignSelf: "stretch",
                padding: "12px 0px 20px",
                direction: "column",
                gap: "8px",
                children: /* @__PURE__ */ S.jsx(
                  Ct,
                  {
                    fontSize: "18px",
                    fontWeight: 700,
                    lineHeight: "132%",
                    color: a.primary,
                    children: "No Pending Notifications"
                  }
                )
              }
            ) })
          ]
        }
      )
    }
  );
}, XE = ({
  account: e,
  children: t,
  headerMenu: r,
  authenticated: n,
  showBack: i,
  showBackText: a,
  onToggleMenu: o,
  onToggleNotifications: s,
  onClickBack: u,
  languageSelectorProps: l,
  signOutProps: c,
  serviceRequestButtonProps: f,
  onClickLanding: d,
  skipUrlClick: h,
  ...p
}) => {
  var F, X, Z;
  const [v, m] = h4(), [x, y] = Oe(void 0), { data: g } = Jt(), { theme: E } = g, { header: b, favicon: w } = E, { updateHeaderIsOpen: _, headerIsOpen: A, updateNoficationsIsOpen: O, notificationsIsOpen: T } = Px(), C = LT("notifications"), { notifications: $, isNotificationsLoading: P, promptCount: j } = _C(), { chatConfig: W, firebaseConfig: Y } = Bh(), V = {
    spaceIdRef: W == null ? void 0 : W.contentful.space,
    accessTokenRef: W == null ? void 0 : W.contentful.token,
    environmentRef: W == null ? void 0 : W.contentful.env,
    firebaseConfig: Y
  }, { imageUrl: ce, isLoading: de } = p4(
    b.logoSlug,
    V == null ? void 0 : V.spaceIdRef,
    V == null ? void 0 : V.accessTokenRef,
    V == null ? void 0 : V.environmentRef,
    V == null ? void 0 : V.firebaseConfig
  ), L = Me(
    (ne) => {
      _(ne !== void 0 ? ne : (K) => (o && o(!K), !K)), O(!1), window.scrollTo(0, 0);
    },
    [A]
  ), D = Me(
    (ne) => {
      O(ne !== void 0 ? ne : (K) => (s && s(!K), !K)), _(!1), window.scrollTo(0, 0);
    },
    [T]
  ), N = Me(() => {
    O(!1), window.location.href = "/profile";
  }, []), B = Me((ne) => {
    l != null && l.onSelect && (l == null || l.onSelect(ne));
  }, []);
  return w && ((F = document.getElementById("favicon")) == null || F.setAttribute("href", w)), He(() => {
    de || y(ce ?? void 0);
  }, [de, ce]), He(() => {
    A || T ? v() : m();
  }, [A, T]), /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      sa,
      {
        id: "myasurion-header",
        pos: "fixed",
        h: "56px",
        top: 0,
        left: 0,
        w: "full",
        p: "10px 16px",
        bg: b.bg || "white",
        zIndex: 999999,
        boxShadow: "0px 4px 8px 0px #00000014, 0px 1px 0px 0px #00000029 inset",
        ...p,
        children: i ? /* @__PURE__ */ S.jsx(sa, { alignItems: "end", w: "full", p: "8px 16px 4px 16px", children: /* @__PURE__ */ S.jsx(
          ri,
          {
            variant: "link",
            colorScheme: "black",
            onClick: () => {
              u && u();
            },
            leftIcon: /* @__PURE__ */ S.jsx(g_, {}),
            children: /* @__PURE__ */ S.jsx(Ct, { children: a || "Back" })
          }
        ) }) : /* @__PURE__ */ S.jsxs(sa, { alignItems: "end", w: "full", children: [
          t && t,
          !t && /* @__PURE__ */ S.jsxs(Ni, { h: "36px", justifyContent: "space-between", children: [
            /* @__PURE__ */ S.jsx(sa, { children: /* @__PURE__ */ S.jsx(
              Js,
              {
                href: ((X = Xe()) == null ? void 0 : X.toLowerCase()) === "starhub" || ((Z = Xe()) == null ? void 0 : Z.toLowerCase()) === "celcom" ? "#" : L_(),
                onClick: () => d && d(),
                _hover: { textDecoration: "none", cursor: "pointer" },
                children: de ? /* @__PURE__ */ S.jsx(Io, {}) : /* @__PURE__ */ S.jsx(
                  ul,
                  {
                    src: x ?? b.logo,
                    alt: "header logo",
                    maxH: b.maxHeight ?? "36px"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ S.jsxs(Ni, { gap: 4, children: [
              /* @__PURE__ */ S.jsx(
                nM,
                {
                  boxProps: l == null ? void 0 : l.boxProps,
                  linkProps: l == null ? void 0 : l.linkProps,
                  onSelect: B
                }
              ),
              n && r ? r : /* @__PURE__ */ S.jsx(S.Fragment, {}),
              n && C && /* @__PURE__ */ S.jsx(
                uM,
                {
                  onToggle: D,
                  isLoading: P,
                  promptCount: j
                }
              ),
              n && !r ? /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                /* @__PURE__ */ S.jsx(Vd, { children: /* @__PURE__ */ S.jsx(py, { onToggle: L }) }),
                /* @__PURE__ */ S.jsx(jh, { children: /* @__PURE__ */ S.jsx(py, { onToggle: N }) })
              ] }) : /* @__PURE__ */ S.jsx(S.Fragment, {})
            ] })
          ] })
        ] })
      }
    ),
    A && /* @__PURE__ */ S.jsx(
      oM,
      {
        pt: "50px",
        firstname: (e == null ? void 0 : e.firstName) || "",
        lastname: (e == null ? void 0 : e.lastName) || "",
        signOutProps: {
          label: (c == null ? void 0 : c.label) && c.label,
          onSignOut: () => {
            L(!1), c != null && c.onSignOut && (c == null || c.onSignOut());
          }
        },
        serviceRequestButtonProps: {
          enabled: f && f.enabled || !1,
          label: (f == null ? void 0 : f.label) && f.label,
          onClick: () => {
            L(!1), f != null && f.onClick && (f == null || f.onClick());
          }
        },
        skipUrlClick: h
      }
    ),
    C && T && /* @__PURE__ */ S.jsx(
      TB,
      {
        pt: "50px",
        notifications: $,
        isLoading: P
      }
    )
  ] });
}, AB = "/images/carriers/asurion/expert-group.png", Xr = {
  title: "Need help?",
  heading: "Hey 👋 I’m Anna, your Tech specialist.",
  subheading: "Our team is here to help!",
  searchTitle: "You might be searching for this...",
  keywords: ["Like for Like", "Service request fee", "Storage Capacity", "Wipe my Phone"]
}, Oie = ({
  title: e = Xr.title,
  heading: t,
  subheading: r,
  searchTitle: n,
  keywords: i = Xr.keywords,
  images: a,
  doAnimate: o = !1,
  expertGroupImage: s,
  ...u
}) => /* @__PURE__ */ S.jsx(
  Ce,
  {
    id: "myasurion-customer-support-footer",
    w: "100%",
    h: { base: "409", md: "190px" },
    m: "0",
    minW: "320px",
    p: 0,
    bg: "#F0F0F5",
    zIndex: 15,
    ...u,
    children: /* @__PURE__ */ S.jsxs(
      Ce,
      {
        id: "footer-container",
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "flex-start",
        w: "100%",
        children: [
          /* @__PURE__ */ S.jsx(
            DB,
            {
              title: e,
              heading: t,
              subheading: r,
              searchTitle: n,
              keywords: i,
              images: a,
              doAnimate: o,
              expertGroupImage: s,
              ...u
            }
          ),
          /* @__PURE__ */ S.jsx(
            OB,
            {
              title: e,
              heading: t,
              subheading: r,
              searchTitle: n,
              keywords: i,
              images: a,
              doAnimate: o,
              expertGroupImage: s,
              ...u
            }
          )
        ]
      }
    )
  }
), CB = C_`
    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
`, OB = ({
  heading: e,
  subheading: t,
  images: r,
  onSendQuestion: n
}) => {
  const [i, a] = Oe(""), [o] = kx("al", ""), s = "CustomerSupportFooter", u = "Global";
  Xe();
  const l = (f) => {
    f.code === "Enter" && i.trim().length > 0 && (n == null || n(i), a(""));
  }, c = () => {
    i && (n == null || n(i), a(""));
  };
  return /* @__PURE__ */ S.jsx(jh, { children: /* @__PURE__ */ S.jsx(Wt, { w: "full", children: /* @__PURE__ */ S.jsxs(
    Ni,
    {
      h: "full",
      maxW: "800px",
      w: "full",
      justifyContent: "center",
      gap: "20px",
      mt: "47px",
      children: [
        /* @__PURE__ */ S.jsx(Ce, { w: "96px", h: "96px", display: "flex", alignItems: "center", children: r == null ? void 0 : r.map((f, d) => f.view === "desktop" ? /* @__PURE__ */ S.jsx(
          ul,
          {
            src: f.url,
            alt: "expert img",
            w: "96px",
            h: "96px"
          },
          `img-desktop-footer-${d}`
        ) : /* @__PURE__ */ S.jsx(S.Fragment, {})) }),
        /* @__PURE__ */ S.jsxs(Ce, { w: "300px", children: [
          /* @__PURE__ */ S.jsx(Ct, { fontWeight: 400, fontSize: "2xl", color: "black", m: 0, children: /* @__PURE__ */ S.jsx(
            _t,
            {
              text: e || Xr.heading,
              translationKey: `${u}/${s}_heading`
            }
          ) }),
          /* @__PURE__ */ S.jsx(Ct, { fontWeight: 700, fontSize: "lg", color: "black", m: 0, children: /* @__PURE__ */ S.jsx(
            _t,
            {
              text: t || Xr.subheading,
              translationKey: `${u}/${s}_subheading`
            }
          ) })
        ] }),
        /* @__PURE__ */ S.jsx(Ce, { w: "430px", children: /* @__PURE__ */ S.jsxs(C0, { children: [
          /* @__PURE__ */ S.jsx(
            sl,
            {
              className: "onboarding__chat",
              placeholder: (
                // hardcode this for now hopefully just now
                o === "zh-Hant-TW" ? "我想知道…" : o === "th-TH" ? "พิมพ์ข้อความ" : "I need help with..."
              ),
              outline: "2px solid transparent",
              w: "100%",
              h: "56px",
              "outline-offset": "2px",
              pos: "relative",
              appearance: "none",
              backgroundColor: "#fff",
              border: "1px solid #000",
              color: "rgb(26, 32, 44)",
              cursor: "text",
              boxSizing: "border-box",
              padding: "0 40px 0 16px",
              borderRadius: "6px",
              fontSize: "16px",
              value: i,
              onChange: ({ target: f }) => a(f.value),
              onKeyDown: l
            }
          ),
          /* @__PURE__ */ S.jsx(vx, { cursor: "pointer", w: "40px", h: "40px", zIndex: "2", children: /* @__PURE__ */ S.jsx(
            fx,
            {
              stroke: "black",
              fill: "black",
              color: "black",
              onClick: c
            }
          ) })
        ] }) })
      ]
    }
  ) }) });
}, DB = ({
  title: e = Xr.title,
  heading: t,
  subheading: r,
  searchTitle: n,
  keywords: i = Xr.keywords,
  images: a,
  doAnimate: o = !1,
  expertGroupImage: s,
  onSendQuestion: u,
  onClickKeyword: l
}) => {
  const [c, f] = Oe(""), d = HT("portal", "stnFooterKeywords"), h = "CustomerSupportFooter", p = "Global", { language: v } = Bl(), m = (E) => {
    E.code === "Enter" && c.trim().length > 0 && (u == null || u(c), f(""));
  }, x = () => {
    c && (u == null || u(c), f(""));
  }, y = ll(), g = Xe();
  return /* @__PURE__ */ S.jsx(Vd, { children: /* @__PURE__ */ S.jsxs(
    Cr,
    {
      id: "experts-chat-container",
      padding: "24px 16px",
      flexFlow: "column nowrap",
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "stretch",
      background: "#F0F0F5",
      children: [
        /* @__PURE__ */ S.jsx(
          Cr,
          {
            id: "footer-title",
            alignItems: "flex-start",
            gap: "8px",
            alignSelf: "stretch",
            height: "32px",
            children: /* @__PURE__ */ S.jsx(mx, { as: "h2", fontSize: "2xl", fontWeight: "normal", lineHeight: "8", m: 0, children: /* @__PURE__ */ S.jsx(Ct, { color: "black", m: 0, children: /* @__PURE__ */ S.jsx(
              _t,
              {
                text: e || Xr.title || "Need help?",
                translationKey: `${p}/${h}_title`
              }
            ) }) })
          }
        ),
        /* @__PURE__ */ S.jsxs(
          Cr,
          {
            id: "footer-expert-search",
            flexFlow: "column nowrap",
            alignItems: "center",
            gap: "16px",
            alignSelf: "stretch",
            children: [
              /* @__PURE__ */ S.jsxs(
                Ce,
                {
                  id: "footer-expert-search-expert-container",
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                  children: [
                    /* @__PURE__ */ S.jsx(
                      Ce,
                      {
                        id: "expert-images",
                        display: "flex",
                        flexFlow: "column nowrap",
                        alignItems: "center",
                        alignSelf: "stretch",
                        children: /* @__PURE__ */ S.jsx(
                          Ce,
                          {
                            id: "expert-images-content",
                            display: "flex",
                            padding: "0px 16px",
                            flexFlow: "column nowrap",
                            alignItems: "flex-start",
                            gap: "16px",
                            children: /* @__PURE__ */ S.jsx(Vd, { children: /* @__PURE__ */ S.jsx(Ce, { id: "expert-images-group", children: /* @__PURE__ */ S.jsx(
                              Cr,
                              {
                                flexFlow: "row nowrap",
                                position: "relative",
                                gap: "42px",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "96px",
                                children: a && !s ? a.map((E) => {
                                  if (E.view === "mobile")
                                    return /* @__PURE__ */ S.jsx(
                                      FB,
                                      {
                                        img: E.url,
                                        position: E.position,
                                        doAnimate: o
                                      },
                                      E.position
                                    );
                                }) : /* @__PURE__ */ S.jsx(
                                  ul,
                                  {
                                    src: s ?? `${y === "repair" ? "/portal" : ""}${AB}`,
                                    alt: "expert group"
                                  }
                                )
                              }
                            ) }) })
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ S.jsxs(Cr, { flexFlow: "column", children: [
                      /* @__PURE__ */ S.jsx(
                        Ct,
                        {
                          align: "center",
                          fontWeight: "light",
                          fontSize: "lg",
                          color: "black",
                          m: 0,
                          children: /* @__PURE__ */ S.jsx(
                            _t,
                            {
                              text: t || Xr.heading,
                              translationKey: `${p}/${h}_heading`
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ S.jsx(
                        Ct,
                        {
                          align: "center",
                          fontWeight: "bold",
                          fontSize: "lg",
                          color: "black",
                          m: 0,
                          children: /* @__PURE__ */ S.jsx(
                            _t,
                            {
                              text: r || Xr.subheading,
                              translationKey: `${p}/${h}_subheading`
                            }
                          )
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ S.jsxs(C0, { children: [
                /* @__PURE__ */ S.jsx(
                  sl,
                  {
                    className: "onboarding__chat",
                    placeholder: (
                      // hardcode this for now hopefully just now
                      v === "zh-Hant-TW" ? "我想知道…" : v === "th-TH" ? "พิมพ์ข้อความ" : "I need help with..."
                    ),
                    outline: "2px solid transparent",
                    w: "100%",
                    "outline-offset": "2px",
                    pos: "relative",
                    appearance: "none",
                    backgroundColor: "#fff",
                    borderColor: "inherit",
                    border: "2px solid #A5AAAF",
                    color: "rgb(26, 32, 44)",
                    cursor: "text",
                    boxSizing: "border-box",
                    padding: "0 40px 0 16px",
                    height: "40px",
                    borderRadius: "6px",
                    fontSize: "16px",
                    value: c,
                    onChange: ({ target: E }) => f(E.value),
                    onKeyDown: m
                  }
                ),
                /* @__PURE__ */ S.jsx(vx, { w: "40px", h: "40px", zIndex: "2", cursor: "pointer", children: /* @__PURE__ */ S.jsx(
                  fx,
                  {
                    stroke: "black",
                    fill: "black",
                    color: "black",
                    onClick: x
                  }
                ) })
              ] }),
              !d && /* @__PURE__ */ S.jsxs(
                Ce,
                {
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                  children: [
                    g !== "starhub" && /* @__PURE__ */ S.jsx(
                      Cr,
                      {
                        id: "keywords-title",
                        alignItems: "flex-start",
                        alignSelf: "stretch",
                        children: /* @__PURE__ */ S.jsx(
                          Ct,
                          {
                            color: "#111111",
                            fontSize: "md",
                            fontWeight: "bold",
                            lineHeight: "124%",
                            children: /* @__PURE__ */ S.jsx(
                              _t,
                              {
                                text: n || Xr.searchTitle,
                                translationKey: `${p}/${h}_searchTitle`
                              }
                            )
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ S.jsx(Cr, { id: "keywords", flexFlow: "row wrap", gap: "16px", children: i.map((E) => /* @__PURE__ */ S.jsx(
                      Ct,
                      {
                        fontSize: "md",
                        fontWeight: "normal",
                        textDecorationLine: "underline",
                        lineHeight: "124%",
                        textAlign: "center",
                        cursor: "pointer",
                        m: 0,
                        color: "#000",
                        onClick: () => l == null ? void 0 : l(E),
                        children: /* @__PURE__ */ S.jsx(
                          _t,
                          {
                            text: E,
                            translationKey: `${p}/${h}_keyword-${E}`
                          }
                        )
                      },
                      E
                    )) })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, FB = ({
  img: e,
  position: t,
  doAnimate: r
}) => /* @__PURE__ */ S.jsx(
  Cr,
  {
    width: t === "middle" ? "96px" : "64px",
    height: t === "middle" ? "96px" : "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    position: t === "middle" ? "absolute" : "initial",
    zIndex: t === "middle" ? 2 : 1,
    borderRadius: "50%",
    children: /* @__PURE__ */ S.jsxs(Ce, { pos: "relative", children: [
      t === "middle" && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        r && /* @__PURE__ */ S.jsx(
          Ce,
          {
            border: "3px solid #008662",
            h: "25px",
            w: "25px",
            pos: "absolute",
            borderRadius: "30px",
            left: "8px",
            top: "0px",
            opacity: "0.0",
            animation: `${CB} 1s ease-out infinite`,
            as: DT.div,
            zIndex: "2"
          }
        ),
        /* @__PURE__ */ S.jsx(
          Zs,
          {
            backgroundColor: "#008662",
            pos: "absolute",
            size: "15px",
            top: "5px",
            left: "13px",
            zIndex: "2"
          }
        )
      ] }),
      /* @__PURE__ */ S.jsxs(Zs, { size: t === "middle" ? "96px" : "64px", pos: "relative", children: [
        /* @__PURE__ */ S.jsx(
          ul,
          {
            src: e,
            alt: "expert img",
            borderRadius: "64px",
            width: t === "middle" ? "96px" : "64px",
            height: t === "middle" ? "96px" : "64px",
            flexShrink: "0"
          }
        ),
        t === "middle" && /* @__PURE__ */ S.jsx(
          Zs,
          {
            size: "88px",
            pos: "absolute",
            "aria-roledescription": "circular border for middle expert",
            border: "4px solid white",
            zIndex: "1"
          }
        )
      ] })
    ] })
  }
);
var JE = { exports: {} }, xt = JE.exports = {}, Yr, Vr;
function Gd() {
  throw new Error("setTimeout has not been defined");
}
function Kd() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Yr = setTimeout : Yr = Gd;
  } catch {
    Yr = Gd;
  }
  try {
    typeof clearTimeout == "function" ? Vr = clearTimeout : Vr = Kd;
  } catch {
    Vr = Kd;
  }
})();
function ZE(e) {
  if (Yr === setTimeout)
    return setTimeout(e, 0);
  if ((Yr === Gd || !Yr) && setTimeout)
    return Yr = setTimeout, setTimeout(e, 0);
  try {
    return Yr(e, 0);
  } catch {
    try {
      return Yr.call(null, e, 0);
    } catch {
      return Yr.call(this, e, 0);
    }
  }
}
function IB(e) {
  if (Vr === clearTimeout)
    return clearTimeout(e);
  if ((Vr === Kd || !Vr) && clearTimeout)
    return Vr = clearTimeout, clearTimeout(e);
  try {
    return Vr(e);
  } catch {
    try {
      return Vr.call(null, e);
    } catch {
      return Vr.call(this, e);
    }
  }
}
var bn = [], ga = !1, Ai, vu = -1;
function kB() {
  !ga || !Ai || (ga = !1, Ai.length ? bn = Ai.concat(bn) : vu = -1, bn.length && ew());
}
function ew() {
  if (!ga) {
    var e = ZE(kB);
    ga = !0;
    for (var t = bn.length; t; ) {
      for (Ai = bn, bn = []; ++vu < t; )
        Ai && Ai[vu].run();
      vu = -1, t = bn.length;
    }
    Ai = null, ga = !1, IB(e);
  }
}
xt.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      t[r - 1] = arguments[r];
  bn.push(new tw(e, t)), bn.length === 1 && !ga && ZE(ew);
};
function tw(e, t) {
  this.fun = e, this.array = t;
}
tw.prototype.run = function() {
  this.fun.apply(null, this.array);
};
xt.title = "browser";
xt.browser = !0;
xt.env = {};
xt.argv = [];
xt.version = "";
xt.versions = {};
function On() {
}
xt.on = On;
xt.addListener = On;
xt.once = On;
xt.off = On;
xt.removeListener = On;
xt.removeAllListeners = On;
xt.emit = On;
xt.prependListener = On;
xt.prependOnceListener = On;
xt.listeners = function(e) {
  return [];
};
xt.binding = function(e) {
  throw new Error("process.binding is not supported");
};
xt.cwd = function() {
  return "/";
};
xt.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
xt.umask = function() {
  return 0;
};
var NB = JE.exports;
const Die = async (e, t, r) => {
  var n;
  try {
    const i = +/* @__PURE__ */ new Date(), a = es.SHA256(i.toString()).toString(), o = await e.get(
      `/content/strings?moduleId=${r}&language=${t}`,
      {
        headers: {
          Authorization: K0(
            {
              httpPath: "/api/v1/content/strings",
              method: "GET",
              token: a
            },
            ((n = NB.env) == null ? void 0 : n.hmacKey) ?? {}.VITE_MYASURION_API_AUTH_HMAC_KEY
          ),
          token: a,
          t: i
        }
      }
    ), { data: s } = o;
    return s;
  } catch (i) {
    return console.log(i), null;
  }
}, Fie = async (e, t, r, n, i) => {
  try {
    const a = +/* @__PURE__ */ new Date(), o = await e.put(
      "/content/strings",
      JSON.stringify({
        entryId: r,
        value: n,
        language: i
      }),
      {
        method: "PUT",
        headers: {
          authorization: t.authorization,
          token: t.token,
          t: a
        }
      }
    ), { data: s } = o;
    return s;
  } catch (a) {
    throw console.log(a), a;
  }
}, PB = async (e, t, r, n, i, a) => {
  try {
    const o = +/* @__PURE__ */ new Date();
    if (!t.authorization && !t.token)
      throw "No headers to create";
    const s = await e.post(
      "/content/strings",
      JSON.stringify({
        moduleId: a || module,
        sectionId: i,
        pathId: r,
        value: n,
        usage: "static",
        autoPublish: "true"
      }),
      {
        method: "POST",
        headers: {
          authorization: t.authorization,
          token: t.token,
          t: o
        }
      }
    ), { data: u } = s;
    return console.log("create..."), u;
  } catch (o) {
    console.log(o);
  }
}, rw = Rr({
  translationComponents: [],
  registerComponent: () => {
  },
  unregisterComponent: () => {
  }
}), Iie = ({ children: e }) => {
  const [t, r] = Oe([]), { translationAPI: n } = Pf(), { entries: i } = Pf(), a = async (u, l, c) => {
    var f;
    try {
      if (!n.api)
        throw "No api found for translation";
      if (!i)
        throw "No entries for translation";
      const d = i;
      if (!d || d.length === 0)
        throw "No fetched string data found";
      const h = (f = d.find((p) => p.id === c.section)) == null ? void 0 : f.text.findIndex((p) => p.path === c.path);
      (h === void 0 || h && h < 0) && PB(
        n.api,
        { authorization: n.authorization, token: n.token },
        c.path,
        l,
        c.section,
        c.module
      ), r((p) => {
        let v = 0;
        const m = p.find((y, g) => (v = g, y.meta.path === c.path));
        if (m) {
          const y = [...p];
          return y[v] = { ...m, text: l, s: "active" }, y;
        }
        const x = p.reduce((y, g) => g.i > y ? g.i : y, 0);
        return [
          ...p,
          {
            FC: u,
            text: l,
            meta: c,
            i: x !== void 0 ? x + 1 : 0,
            s: "active"
          }
        ];
      });
    } catch (d) {
      console.log(d);
    }
  }, { localeLanguage: o } = Pf(), s = (u, l) => {
    r(
      (c) => c.map((f) => f.meta.path === l ? { ...f, s: "inactive" } : f)
    );
  };
  return He(() => {
    r((u) => u);
  }, [o]), /* @__PURE__ */ S.jsx(
    rw.Provider,
    {
      value: { translationComponents: t, registerComponent: a, unregisterComponent: s },
      children: e
    }
  );
}, kie = () => sn(rw);
var nw = { exports: {} }, $B = [
  {
    value: "#B0171F",
    name: "indian red"
  },
  {
    value: "#DC143C",
    css: !0,
    name: "crimson"
  },
  {
    value: "#FFB6C1",
    css: !0,
    name: "lightpink"
  },
  {
    value: "#FFAEB9",
    name: "lightpink 1"
  },
  {
    value: "#EEA2AD",
    name: "lightpink 2"
  },
  {
    value: "#CD8C95",
    name: "lightpink 3"
  },
  {
    value: "#8B5F65",
    name: "lightpink 4"
  },
  {
    value: "#FFC0CB",
    css: !0,
    name: "pink"
  },
  {
    value: "#FFB5C5",
    name: "pink 1"
  },
  {
    value: "#EEA9B8",
    name: "pink 2"
  },
  {
    value: "#CD919E",
    name: "pink 3"
  },
  {
    value: "#8B636C",
    name: "pink 4"
  },
  {
    value: "#DB7093",
    css: !0,
    name: "palevioletred"
  },
  {
    value: "#FF82AB",
    name: "palevioletred 1"
  },
  {
    value: "#EE799F",
    name: "palevioletred 2"
  },
  {
    value: "#CD6889",
    name: "palevioletred 3"
  },
  {
    value: "#8B475D",
    name: "palevioletred 4"
  },
  {
    value: "#FFF0F5",
    name: "lavenderblush 1"
  },
  {
    value: "#FFF0F5",
    css: !0,
    name: "lavenderblush"
  },
  {
    value: "#EEE0E5",
    name: "lavenderblush 2"
  },
  {
    value: "#CDC1C5",
    name: "lavenderblush 3"
  },
  {
    value: "#8B8386",
    name: "lavenderblush 4"
  },
  {
    value: "#FF3E96",
    name: "violetred 1"
  },
  {
    value: "#EE3A8C",
    name: "violetred 2"
  },
  {
    value: "#CD3278",
    name: "violetred 3"
  },
  {
    value: "#8B2252",
    name: "violetred 4"
  },
  {
    value: "#FF69B4",
    css: !0,
    name: "hotpink"
  },
  {
    value: "#FF6EB4",
    name: "hotpink 1"
  },
  {
    value: "#EE6AA7",
    name: "hotpink 2"
  },
  {
    value: "#CD6090",
    name: "hotpink 3"
  },
  {
    value: "#8B3A62",
    name: "hotpink 4"
  },
  {
    value: "#872657",
    name: "raspberry"
  },
  {
    value: "#FF1493",
    name: "deeppink 1"
  },
  {
    value: "#FF1493",
    css: !0,
    name: "deeppink"
  },
  {
    value: "#EE1289",
    name: "deeppink 2"
  },
  {
    value: "#CD1076",
    name: "deeppink 3"
  },
  {
    value: "#8B0A50",
    name: "deeppink 4"
  },
  {
    value: "#FF34B3",
    name: "maroon 1"
  },
  {
    value: "#EE30A7",
    name: "maroon 2"
  },
  {
    value: "#CD2990",
    name: "maroon 3"
  },
  {
    value: "#8B1C62",
    name: "maroon 4"
  },
  {
    value: "#C71585",
    css: !0,
    name: "mediumvioletred"
  },
  {
    value: "#D02090",
    name: "violetred"
  },
  {
    value: "#DA70D6",
    css: !0,
    name: "orchid"
  },
  {
    value: "#FF83FA",
    name: "orchid 1"
  },
  {
    value: "#EE7AE9",
    name: "orchid 2"
  },
  {
    value: "#CD69C9",
    name: "orchid 3"
  },
  {
    value: "#8B4789",
    name: "orchid 4"
  },
  {
    value: "#D8BFD8",
    css: !0,
    name: "thistle"
  },
  {
    value: "#FFE1FF",
    name: "thistle 1"
  },
  {
    value: "#EED2EE",
    name: "thistle 2"
  },
  {
    value: "#CDB5CD",
    name: "thistle 3"
  },
  {
    value: "#8B7B8B",
    name: "thistle 4"
  },
  {
    value: "#FFBBFF",
    name: "plum 1"
  },
  {
    value: "#EEAEEE",
    name: "plum 2"
  },
  {
    value: "#CD96CD",
    name: "plum 3"
  },
  {
    value: "#8B668B",
    name: "plum 4"
  },
  {
    value: "#DDA0DD",
    css: !0,
    name: "plum"
  },
  {
    value: "#EE82EE",
    css: !0,
    name: "violet"
  },
  {
    value: "#FF00FF",
    vga: !0,
    name: "magenta"
  },
  {
    value: "#FF00FF",
    vga: !0,
    css: !0,
    name: "fuchsia"
  },
  {
    value: "#EE00EE",
    name: "magenta 2"
  },
  {
    value: "#CD00CD",
    name: "magenta 3"
  },
  {
    value: "#8B008B",
    name: "magenta 4"
  },
  {
    value: "#8B008B",
    css: !0,
    name: "darkmagenta"
  },
  {
    value: "#800080",
    vga: !0,
    css: !0,
    name: "purple"
  },
  {
    value: "#BA55D3",
    css: !0,
    name: "mediumorchid"
  },
  {
    value: "#E066FF",
    name: "mediumorchid 1"
  },
  {
    value: "#D15FEE",
    name: "mediumorchid 2"
  },
  {
    value: "#B452CD",
    name: "mediumorchid 3"
  },
  {
    value: "#7A378B",
    name: "mediumorchid 4"
  },
  {
    value: "#9400D3",
    css: !0,
    name: "darkviolet"
  },
  {
    value: "#9932CC",
    css: !0,
    name: "darkorchid"
  },
  {
    value: "#BF3EFF",
    name: "darkorchid 1"
  },
  {
    value: "#B23AEE",
    name: "darkorchid 2"
  },
  {
    value: "#9A32CD",
    name: "darkorchid 3"
  },
  {
    value: "#68228B",
    name: "darkorchid 4"
  },
  {
    value: "#4B0082",
    css: !0,
    name: "indigo"
  },
  {
    value: "#8A2BE2",
    css: !0,
    name: "blueviolet"
  },
  {
    value: "#9B30FF",
    name: "purple 1"
  },
  {
    value: "#912CEE",
    name: "purple 2"
  },
  {
    value: "#7D26CD",
    name: "purple 3"
  },
  {
    value: "#551A8B",
    name: "purple 4"
  },
  {
    value: "#9370DB",
    css: !0,
    name: "mediumpurple"
  },
  {
    value: "#AB82FF",
    name: "mediumpurple 1"
  },
  {
    value: "#9F79EE",
    name: "mediumpurple 2"
  },
  {
    value: "#8968CD",
    name: "mediumpurple 3"
  },
  {
    value: "#5D478B",
    name: "mediumpurple 4"
  },
  {
    value: "#483D8B",
    css: !0,
    name: "darkslateblue"
  },
  {
    value: "#8470FF",
    name: "lightslateblue"
  },
  {
    value: "#7B68EE",
    css: !0,
    name: "mediumslateblue"
  },
  {
    value: "#6A5ACD",
    css: !0,
    name: "slateblue"
  },
  {
    value: "#836FFF",
    name: "slateblue 1"
  },
  {
    value: "#7A67EE",
    name: "slateblue 2"
  },
  {
    value: "#6959CD",
    name: "slateblue 3"
  },
  {
    value: "#473C8B",
    name: "slateblue 4"
  },
  {
    value: "#F8F8FF",
    css: !0,
    name: "ghostwhite"
  },
  {
    value: "#E6E6FA",
    css: !0,
    name: "lavender"
  },
  {
    value: "#0000FF",
    vga: !0,
    css: !0,
    name: "blue"
  },
  {
    value: "#0000EE",
    name: "blue 2"
  },
  {
    value: "#0000CD",
    name: "blue 3"
  },
  {
    value: "#0000CD",
    css: !0,
    name: "mediumblue"
  },
  {
    value: "#00008B",
    name: "blue 4"
  },
  {
    value: "#00008B",
    css: !0,
    name: "darkblue"
  },
  {
    value: "#000080",
    vga: !0,
    css: !0,
    name: "navy"
  },
  {
    value: "#191970",
    css: !0,
    name: "midnightblue"
  },
  {
    value: "#3D59AB",
    name: "cobalt"
  },
  {
    value: "#4169E1",
    css: !0,
    name: "royalblue"
  },
  {
    value: "#4876FF",
    name: "royalblue 1"
  },
  {
    value: "#436EEE",
    name: "royalblue 2"
  },
  {
    value: "#3A5FCD",
    name: "royalblue 3"
  },
  {
    value: "#27408B",
    name: "royalblue 4"
  },
  {
    value: "#6495ED",
    css: !0,
    name: "cornflowerblue"
  },
  {
    value: "#B0C4DE",
    css: !0,
    name: "lightsteelblue"
  },
  {
    value: "#CAE1FF",
    name: "lightsteelblue 1"
  },
  {
    value: "#BCD2EE",
    name: "lightsteelblue 2"
  },
  {
    value: "#A2B5CD",
    name: "lightsteelblue 3"
  },
  {
    value: "#6E7B8B",
    name: "lightsteelblue 4"
  },
  {
    value: "#778899",
    css: !0,
    name: "lightslategray"
  },
  {
    value: "#708090",
    css: !0,
    name: "slategray"
  },
  {
    value: "#C6E2FF",
    name: "slategray 1"
  },
  {
    value: "#B9D3EE",
    name: "slategray 2"
  },
  {
    value: "#9FB6CD",
    name: "slategray 3"
  },
  {
    value: "#6C7B8B",
    name: "slategray 4"
  },
  {
    value: "#1E90FF",
    name: "dodgerblue 1"
  },
  {
    value: "#1E90FF",
    css: !0,
    name: "dodgerblue"
  },
  {
    value: "#1C86EE",
    name: "dodgerblue 2"
  },
  {
    value: "#1874CD",
    name: "dodgerblue 3"
  },
  {
    value: "#104E8B",
    name: "dodgerblue 4"
  },
  {
    value: "#F0F8FF",
    css: !0,
    name: "aliceblue"
  },
  {
    value: "#4682B4",
    css: !0,
    name: "steelblue"
  },
  {
    value: "#63B8FF",
    name: "steelblue 1"
  },
  {
    value: "#5CACEE",
    name: "steelblue 2"
  },
  {
    value: "#4F94CD",
    name: "steelblue 3"
  },
  {
    value: "#36648B",
    name: "steelblue 4"
  },
  {
    value: "#87CEFA",
    css: !0,
    name: "lightskyblue"
  },
  {
    value: "#B0E2FF",
    name: "lightskyblue 1"
  },
  {
    value: "#A4D3EE",
    name: "lightskyblue 2"
  },
  {
    value: "#8DB6CD",
    name: "lightskyblue 3"
  },
  {
    value: "#607B8B",
    name: "lightskyblue 4"
  },
  {
    value: "#87CEFF",
    name: "skyblue 1"
  },
  {
    value: "#7EC0EE",
    name: "skyblue 2"
  },
  {
    value: "#6CA6CD",
    name: "skyblue 3"
  },
  {
    value: "#4A708B",
    name: "skyblue 4"
  },
  {
    value: "#87CEEB",
    css: !0,
    name: "skyblue"
  },
  {
    value: "#00BFFF",
    name: "deepskyblue 1"
  },
  {
    value: "#00BFFF",
    css: !0,
    name: "deepskyblue"
  },
  {
    value: "#00B2EE",
    name: "deepskyblue 2"
  },
  {
    value: "#009ACD",
    name: "deepskyblue 3"
  },
  {
    value: "#00688B",
    name: "deepskyblue 4"
  },
  {
    value: "#33A1C9",
    name: "peacock"
  },
  {
    value: "#ADD8E6",
    css: !0,
    name: "lightblue"
  },
  {
    value: "#BFEFFF",
    name: "lightblue 1"
  },
  {
    value: "#B2DFEE",
    name: "lightblue 2"
  },
  {
    value: "#9AC0CD",
    name: "lightblue 3"
  },
  {
    value: "#68838B",
    name: "lightblue 4"
  },
  {
    value: "#B0E0E6",
    css: !0,
    name: "powderblue"
  },
  {
    value: "#98F5FF",
    name: "cadetblue 1"
  },
  {
    value: "#8EE5EE",
    name: "cadetblue 2"
  },
  {
    value: "#7AC5CD",
    name: "cadetblue 3"
  },
  {
    value: "#53868B",
    name: "cadetblue 4"
  },
  {
    value: "#00F5FF",
    name: "turquoise 1"
  },
  {
    value: "#00E5EE",
    name: "turquoise 2"
  },
  {
    value: "#00C5CD",
    name: "turquoise 3"
  },
  {
    value: "#00868B",
    name: "turquoise 4"
  },
  {
    value: "#5F9EA0",
    css: !0,
    name: "cadetblue"
  },
  {
    value: "#00CED1",
    css: !0,
    name: "darkturquoise"
  },
  {
    value: "#F0FFFF",
    name: "azure 1"
  },
  {
    value: "#F0FFFF",
    css: !0,
    name: "azure"
  },
  {
    value: "#E0EEEE",
    name: "azure 2"
  },
  {
    value: "#C1CDCD",
    name: "azure 3"
  },
  {
    value: "#838B8B",
    name: "azure 4"
  },
  {
    value: "#E0FFFF",
    name: "lightcyan 1"
  },
  {
    value: "#E0FFFF",
    css: !0,
    name: "lightcyan"
  },
  {
    value: "#D1EEEE",
    name: "lightcyan 2"
  },
  {
    value: "#B4CDCD",
    name: "lightcyan 3"
  },
  {
    value: "#7A8B8B",
    name: "lightcyan 4"
  },
  {
    value: "#BBFFFF",
    name: "paleturquoise 1"
  },
  {
    value: "#AEEEEE",
    name: "paleturquoise 2"
  },
  {
    value: "#AEEEEE",
    css: !0,
    name: "paleturquoise"
  },
  {
    value: "#96CDCD",
    name: "paleturquoise 3"
  },
  {
    value: "#668B8B",
    name: "paleturquoise 4"
  },
  {
    value: "#2F4F4F",
    css: !0,
    name: "darkslategray"
  },
  {
    value: "#97FFFF",
    name: "darkslategray 1"
  },
  {
    value: "#8DEEEE",
    name: "darkslategray 2"
  },
  {
    value: "#79CDCD",
    name: "darkslategray 3"
  },
  {
    value: "#528B8B",
    name: "darkslategray 4"
  },
  {
    value: "#00FFFF",
    name: "cyan"
  },
  {
    value: "#00FFFF",
    css: !0,
    name: "aqua"
  },
  {
    value: "#00EEEE",
    name: "cyan 2"
  },
  {
    value: "#00CDCD",
    name: "cyan 3"
  },
  {
    value: "#008B8B",
    name: "cyan 4"
  },
  {
    value: "#008B8B",
    css: !0,
    name: "darkcyan"
  },
  {
    value: "#008080",
    vga: !0,
    css: !0,
    name: "teal"
  },
  {
    value: "#48D1CC",
    css: !0,
    name: "mediumturquoise"
  },
  {
    value: "#20B2AA",
    css: !0,
    name: "lightseagreen"
  },
  {
    value: "#03A89E",
    name: "manganeseblue"
  },
  {
    value: "#40E0D0",
    css: !0,
    name: "turquoise"
  },
  {
    value: "#808A87",
    name: "coldgrey"
  },
  {
    value: "#00C78C",
    name: "turquoiseblue"
  },
  {
    value: "#7FFFD4",
    name: "aquamarine 1"
  },
  {
    value: "#7FFFD4",
    css: !0,
    name: "aquamarine"
  },
  {
    value: "#76EEC6",
    name: "aquamarine 2"
  },
  {
    value: "#66CDAA",
    name: "aquamarine 3"
  },
  {
    value: "#66CDAA",
    css: !0,
    name: "mediumaquamarine"
  },
  {
    value: "#458B74",
    name: "aquamarine 4"
  },
  {
    value: "#00FA9A",
    css: !0,
    name: "mediumspringgreen"
  },
  {
    value: "#F5FFFA",
    css: !0,
    name: "mintcream"
  },
  {
    value: "#00FF7F",
    css: !0,
    name: "springgreen"
  },
  {
    value: "#00EE76",
    name: "springgreen 1"
  },
  {
    value: "#00CD66",
    name: "springgreen 2"
  },
  {
    value: "#008B45",
    name: "springgreen 3"
  },
  {
    value: "#3CB371",
    css: !0,
    name: "mediumseagreen"
  },
  {
    value: "#54FF9F",
    name: "seagreen 1"
  },
  {
    value: "#4EEE94",
    name: "seagreen 2"
  },
  {
    value: "#43CD80",
    name: "seagreen 3"
  },
  {
    value: "#2E8B57",
    name: "seagreen 4"
  },
  {
    value: "#2E8B57",
    css: !0,
    name: "seagreen"
  },
  {
    value: "#00C957",
    name: "emeraldgreen"
  },
  {
    value: "#BDFCC9",
    name: "mint"
  },
  {
    value: "#3D9140",
    name: "cobaltgreen"
  },
  {
    value: "#F0FFF0",
    name: "honeydew 1"
  },
  {
    value: "#F0FFF0",
    css: !0,
    name: "honeydew"
  },
  {
    value: "#E0EEE0",
    name: "honeydew 2"
  },
  {
    value: "#C1CDC1",
    name: "honeydew 3"
  },
  {
    value: "#838B83",
    name: "honeydew 4"
  },
  {
    value: "#8FBC8F",
    css: !0,
    name: "darkseagreen"
  },
  {
    value: "#C1FFC1",
    name: "darkseagreen 1"
  },
  {
    value: "#B4EEB4",
    name: "darkseagreen 2"
  },
  {
    value: "#9BCD9B",
    name: "darkseagreen 3"
  },
  {
    value: "#698B69",
    name: "darkseagreen 4"
  },
  {
    value: "#98FB98",
    css: !0,
    name: "palegreen"
  },
  {
    value: "#9AFF9A",
    name: "palegreen 1"
  },
  {
    value: "#90EE90",
    name: "palegreen 2"
  },
  {
    value: "#90EE90",
    css: !0,
    name: "lightgreen"
  },
  {
    value: "#7CCD7C",
    name: "palegreen 3"
  },
  {
    value: "#548B54",
    name: "palegreen 4"
  },
  {
    value: "#32CD32",
    css: !0,
    name: "limegreen"
  },
  {
    value: "#228B22",
    css: !0,
    name: "forestgreen"
  },
  {
    value: "#00FF00",
    vga: !0,
    name: "green 1"
  },
  {
    value: "#00FF00",
    vga: !0,
    css: !0,
    name: "lime"
  },
  {
    value: "#00EE00",
    name: "green 2"
  },
  {
    value: "#00CD00",
    name: "green 3"
  },
  {
    value: "#008B00",
    name: "green 4"
  },
  {
    value: "#008000",
    vga: !0,
    css: !0,
    name: "green"
  },
  {
    value: "#006400",
    css: !0,
    name: "darkgreen"
  },
  {
    value: "#308014",
    name: "sapgreen"
  },
  {
    value: "#7CFC00",
    css: !0,
    name: "lawngreen"
  },
  {
    value: "#7FFF00",
    name: "chartreuse 1"
  },
  {
    value: "#7FFF00",
    css: !0,
    name: "chartreuse"
  },
  {
    value: "#76EE00",
    name: "chartreuse 2"
  },
  {
    value: "#66CD00",
    name: "chartreuse 3"
  },
  {
    value: "#458B00",
    name: "chartreuse 4"
  },
  {
    value: "#ADFF2F",
    css: !0,
    name: "greenyellow"
  },
  {
    value: "#CAFF70",
    name: "darkolivegreen 1"
  },
  {
    value: "#BCEE68",
    name: "darkolivegreen 2"
  },
  {
    value: "#A2CD5A",
    name: "darkolivegreen 3"
  },
  {
    value: "#6E8B3D",
    name: "darkolivegreen 4"
  },
  {
    value: "#556B2F",
    css: !0,
    name: "darkolivegreen"
  },
  {
    value: "#6B8E23",
    css: !0,
    name: "olivedrab"
  },
  {
    value: "#C0FF3E",
    name: "olivedrab 1"
  },
  {
    value: "#B3EE3A",
    name: "olivedrab 2"
  },
  {
    value: "#9ACD32",
    name: "olivedrab 3"
  },
  {
    value: "#9ACD32",
    css: !0,
    name: "yellowgreen"
  },
  {
    value: "#698B22",
    name: "olivedrab 4"
  },
  {
    value: "#FFFFF0",
    name: "ivory 1"
  },
  {
    value: "#FFFFF0",
    css: !0,
    name: "ivory"
  },
  {
    value: "#EEEEE0",
    name: "ivory 2"
  },
  {
    value: "#CDCDC1",
    name: "ivory 3"
  },
  {
    value: "#8B8B83",
    name: "ivory 4"
  },
  {
    value: "#F5F5DC",
    css: !0,
    name: "beige"
  },
  {
    value: "#FFFFE0",
    name: "lightyellow 1"
  },
  {
    value: "#FFFFE0",
    css: !0,
    name: "lightyellow"
  },
  {
    value: "#EEEED1",
    name: "lightyellow 2"
  },
  {
    value: "#CDCDB4",
    name: "lightyellow 3"
  },
  {
    value: "#8B8B7A",
    name: "lightyellow 4"
  },
  {
    value: "#FAFAD2",
    css: !0,
    name: "lightgoldenrodyellow"
  },
  {
    value: "#FFFF00",
    vga: !0,
    name: "yellow 1"
  },
  {
    value: "#FFFF00",
    vga: !0,
    css: !0,
    name: "yellow"
  },
  {
    value: "#EEEE00",
    name: "yellow 2"
  },
  {
    value: "#CDCD00",
    name: "yellow 3"
  },
  {
    value: "#8B8B00",
    name: "yellow 4"
  },
  {
    value: "#808069",
    name: "warmgrey"
  },
  {
    value: "#808000",
    vga: !0,
    css: !0,
    name: "olive"
  },
  {
    value: "#BDB76B",
    css: !0,
    name: "darkkhaki"
  },
  {
    value: "#FFF68F",
    name: "khaki 1"
  },
  {
    value: "#EEE685",
    name: "khaki 2"
  },
  {
    value: "#CDC673",
    name: "khaki 3"
  },
  {
    value: "#8B864E",
    name: "khaki 4"
  },
  {
    value: "#F0E68C",
    css: !0,
    name: "khaki"
  },
  {
    value: "#EEE8AA",
    css: !0,
    name: "palegoldenrod"
  },
  {
    value: "#FFFACD",
    name: "lemonchiffon 1"
  },
  {
    value: "#FFFACD",
    css: !0,
    name: "lemonchiffon"
  },
  {
    value: "#EEE9BF",
    name: "lemonchiffon 2"
  },
  {
    value: "#CDC9A5",
    name: "lemonchiffon 3"
  },
  {
    value: "#8B8970",
    name: "lemonchiffon 4"
  },
  {
    value: "#FFEC8B",
    name: "lightgoldenrod 1"
  },
  {
    value: "#EEDC82",
    name: "lightgoldenrod 2"
  },
  {
    value: "#CDBE70",
    name: "lightgoldenrod 3"
  },
  {
    value: "#8B814C",
    name: "lightgoldenrod 4"
  },
  {
    value: "#E3CF57",
    name: "banana"
  },
  {
    value: "#FFD700",
    name: "gold 1"
  },
  {
    value: "#FFD700",
    css: !0,
    name: "gold"
  },
  {
    value: "#EEC900",
    name: "gold 2"
  },
  {
    value: "#CDAD00",
    name: "gold 3"
  },
  {
    value: "#8B7500",
    name: "gold 4"
  },
  {
    value: "#FFF8DC",
    name: "cornsilk 1"
  },
  {
    value: "#FFF8DC",
    css: !0,
    name: "cornsilk"
  },
  {
    value: "#EEE8CD",
    name: "cornsilk 2"
  },
  {
    value: "#CDC8B1",
    name: "cornsilk 3"
  },
  {
    value: "#8B8878",
    name: "cornsilk 4"
  },
  {
    value: "#DAA520",
    css: !0,
    name: "goldenrod"
  },
  {
    value: "#FFC125",
    name: "goldenrod 1"
  },
  {
    value: "#EEB422",
    name: "goldenrod 2"
  },
  {
    value: "#CD9B1D",
    name: "goldenrod 3"
  },
  {
    value: "#8B6914",
    name: "goldenrod 4"
  },
  {
    value: "#B8860B",
    css: !0,
    name: "darkgoldenrod"
  },
  {
    value: "#FFB90F",
    name: "darkgoldenrod 1"
  },
  {
    value: "#EEAD0E",
    name: "darkgoldenrod 2"
  },
  {
    value: "#CD950C",
    name: "darkgoldenrod 3"
  },
  {
    value: "#8B6508",
    name: "darkgoldenrod 4"
  },
  {
    value: "#FFA500",
    name: "orange 1"
  },
  {
    value: "#FF8000",
    css: !0,
    name: "orange"
  },
  {
    value: "#EE9A00",
    name: "orange 2"
  },
  {
    value: "#CD8500",
    name: "orange 3"
  },
  {
    value: "#8B5A00",
    name: "orange 4"
  },
  {
    value: "#FFFAF0",
    css: !0,
    name: "floralwhite"
  },
  {
    value: "#FDF5E6",
    css: !0,
    name: "oldlace"
  },
  {
    value: "#F5DEB3",
    css: !0,
    name: "wheat"
  },
  {
    value: "#FFE7BA",
    name: "wheat 1"
  },
  {
    value: "#EED8AE",
    name: "wheat 2"
  },
  {
    value: "#CDBA96",
    name: "wheat 3"
  },
  {
    value: "#8B7E66",
    name: "wheat 4"
  },
  {
    value: "#FFE4B5",
    css: !0,
    name: "moccasin"
  },
  {
    value: "#FFEFD5",
    css: !0,
    name: "papayawhip"
  },
  {
    value: "#FFEBCD",
    css: !0,
    name: "blanchedalmond"
  },
  {
    value: "#FFDEAD",
    name: "navajowhite 1"
  },
  {
    value: "#FFDEAD",
    css: !0,
    name: "navajowhite"
  },
  {
    value: "#EECFA1",
    name: "navajowhite 2"
  },
  {
    value: "#CDB38B",
    name: "navajowhite 3"
  },
  {
    value: "#8B795E",
    name: "navajowhite 4"
  },
  {
    value: "#FCE6C9",
    name: "eggshell"
  },
  {
    value: "#D2B48C",
    css: !0,
    name: "tan"
  },
  {
    value: "#9C661F",
    name: "brick"
  },
  {
    value: "#FF9912",
    name: "cadmiumyellow"
  },
  {
    value: "#FAEBD7",
    css: !0,
    name: "antiquewhite"
  },
  {
    value: "#FFEFDB",
    name: "antiquewhite 1"
  },
  {
    value: "#EEDFCC",
    name: "antiquewhite 2"
  },
  {
    value: "#CDC0B0",
    name: "antiquewhite 3"
  },
  {
    value: "#8B8378",
    name: "antiquewhite 4"
  },
  {
    value: "#DEB887",
    css: !0,
    name: "burlywood"
  },
  {
    value: "#FFD39B",
    name: "burlywood 1"
  },
  {
    value: "#EEC591",
    name: "burlywood 2"
  },
  {
    value: "#CDAA7D",
    name: "burlywood 3"
  },
  {
    value: "#8B7355",
    name: "burlywood 4"
  },
  {
    value: "#FFE4C4",
    name: "bisque 1"
  },
  {
    value: "#FFE4C4",
    css: !0,
    name: "bisque"
  },
  {
    value: "#EED5B7",
    name: "bisque 2"
  },
  {
    value: "#CDB79E",
    name: "bisque 3"
  },
  {
    value: "#8B7D6B",
    name: "bisque 4"
  },
  {
    value: "#E3A869",
    name: "melon"
  },
  {
    value: "#ED9121",
    name: "carrot"
  },
  {
    value: "#FF8C00",
    css: !0,
    name: "darkorange"
  },
  {
    value: "#FF7F00",
    name: "darkorange 1"
  },
  {
    value: "#EE7600",
    name: "darkorange 2"
  },
  {
    value: "#CD6600",
    name: "darkorange 3"
  },
  {
    value: "#8B4500",
    name: "darkorange 4"
  },
  {
    value: "#FFA54F",
    name: "tan 1"
  },
  {
    value: "#EE9A49",
    name: "tan 2"
  },
  {
    value: "#CD853F",
    name: "tan 3"
  },
  {
    value: "#CD853F",
    css: !0,
    name: "peru"
  },
  {
    value: "#8B5A2B",
    name: "tan 4"
  },
  {
    value: "#FAF0E6",
    css: !0,
    name: "linen"
  },
  {
    value: "#FFDAB9",
    name: "peachpuff 1"
  },
  {
    value: "#FFDAB9",
    css: !0,
    name: "peachpuff"
  },
  {
    value: "#EECBAD",
    name: "peachpuff 2"
  },
  {
    value: "#CDAF95",
    name: "peachpuff 3"
  },
  {
    value: "#8B7765",
    name: "peachpuff 4"
  },
  {
    value: "#FFF5EE",
    name: "seashell 1"
  },
  {
    value: "#FFF5EE",
    css: !0,
    name: "seashell"
  },
  {
    value: "#EEE5DE",
    name: "seashell 2"
  },
  {
    value: "#CDC5BF",
    name: "seashell 3"
  },
  {
    value: "#8B8682",
    name: "seashell 4"
  },
  {
    value: "#F4A460",
    css: !0,
    name: "sandybrown"
  },
  {
    value: "#C76114",
    name: "rawsienna"
  },
  {
    value: "#D2691E",
    css: !0,
    name: "chocolate"
  },
  {
    value: "#FF7F24",
    name: "chocolate 1"
  },
  {
    value: "#EE7621",
    name: "chocolate 2"
  },
  {
    value: "#CD661D",
    name: "chocolate 3"
  },
  {
    value: "#8B4513",
    name: "chocolate 4"
  },
  {
    value: "#8B4513",
    css: !0,
    name: "saddlebrown"
  },
  {
    value: "#292421",
    name: "ivoryblack"
  },
  {
    value: "#FF7D40",
    name: "flesh"
  },
  {
    value: "#FF6103",
    name: "cadmiumorange"
  },
  {
    value: "#8A360F",
    name: "burntsienna"
  },
  {
    value: "#A0522D",
    css: !0,
    name: "sienna"
  },
  {
    value: "#FF8247",
    name: "sienna 1"
  },
  {
    value: "#EE7942",
    name: "sienna 2"
  },
  {
    value: "#CD6839",
    name: "sienna 3"
  },
  {
    value: "#8B4726",
    name: "sienna 4"
  },
  {
    value: "#FFA07A",
    name: "lightsalmon 1"
  },
  {
    value: "#FFA07A",
    css: !0,
    name: "lightsalmon"
  },
  {
    value: "#EE9572",
    name: "lightsalmon 2"
  },
  {
    value: "#CD8162",
    name: "lightsalmon 3"
  },
  {
    value: "#8B5742",
    name: "lightsalmon 4"
  },
  {
    value: "#FF7F50",
    css: !0,
    name: "coral"
  },
  {
    value: "#FF4500",
    name: "orangered 1"
  },
  {
    value: "#FF4500",
    css: !0,
    name: "orangered"
  },
  {
    value: "#EE4000",
    name: "orangered 2"
  },
  {
    value: "#CD3700",
    name: "orangered 3"
  },
  {
    value: "#8B2500",
    name: "orangered 4"
  },
  {
    value: "#5E2612",
    name: "sepia"
  },
  {
    value: "#E9967A",
    css: !0,
    name: "darksalmon"
  },
  {
    value: "#FF8C69",
    name: "salmon 1"
  },
  {
    value: "#EE8262",
    name: "salmon 2"
  },
  {
    value: "#CD7054",
    name: "salmon 3"
  },
  {
    value: "#8B4C39",
    name: "salmon 4"
  },
  {
    value: "#FF7256",
    name: "coral 1"
  },
  {
    value: "#EE6A50",
    name: "coral 2"
  },
  {
    value: "#CD5B45",
    name: "coral 3"
  },
  {
    value: "#8B3E2F",
    name: "coral 4"
  },
  {
    value: "#8A3324",
    name: "burntumber"
  },
  {
    value: "#FF6347",
    name: "tomato 1"
  },
  {
    value: "#FF6347",
    css: !0,
    name: "tomato"
  },
  {
    value: "#EE5C42",
    name: "tomato 2"
  },
  {
    value: "#CD4F39",
    name: "tomato 3"
  },
  {
    value: "#8B3626",
    name: "tomato 4"
  },
  {
    value: "#FA8072",
    css: !0,
    name: "salmon"
  },
  {
    value: "#FFE4E1",
    name: "mistyrose 1"
  },
  {
    value: "#FFE4E1",
    css: !0,
    name: "mistyrose"
  },
  {
    value: "#EED5D2",
    name: "mistyrose 2"
  },
  {
    value: "#CDB7B5",
    name: "mistyrose 3"
  },
  {
    value: "#8B7D7B",
    name: "mistyrose 4"
  },
  {
    value: "#FFFAFA",
    name: "snow 1"
  },
  {
    value: "#FFFAFA",
    css: !0,
    name: "snow"
  },
  {
    value: "#EEE9E9",
    name: "snow 2"
  },
  {
    value: "#CDC9C9",
    name: "snow 3"
  },
  {
    value: "#8B8989",
    name: "snow 4"
  },
  {
    value: "#BC8F8F",
    css: !0,
    name: "rosybrown"
  },
  {
    value: "#FFC1C1",
    name: "rosybrown 1"
  },
  {
    value: "#EEB4B4",
    name: "rosybrown 2"
  },
  {
    value: "#CD9B9B",
    name: "rosybrown 3"
  },
  {
    value: "#8B6969",
    name: "rosybrown 4"
  },
  {
    value: "#F08080",
    css: !0,
    name: "lightcoral"
  },
  {
    value: "#CD5C5C",
    css: !0,
    name: "indianred"
  },
  {
    value: "#FF6A6A",
    name: "indianred 1"
  },
  {
    value: "#EE6363",
    name: "indianred 2"
  },
  {
    value: "#8B3A3A",
    name: "indianred 4"
  },
  {
    value: "#CD5555",
    name: "indianred 3"
  },
  {
    value: "#A52A2A",
    css: !0,
    name: "brown"
  },
  {
    value: "#FF4040",
    name: "brown 1"
  },
  {
    value: "#EE3B3B",
    name: "brown 2"
  },
  {
    value: "#CD3333",
    name: "brown 3"
  },
  {
    value: "#8B2323",
    name: "brown 4"
  },
  {
    value: "#B22222",
    css: !0,
    name: "firebrick"
  },
  {
    value: "#FF3030",
    name: "firebrick 1"
  },
  {
    value: "#EE2C2C",
    name: "firebrick 2"
  },
  {
    value: "#CD2626",
    name: "firebrick 3"
  },
  {
    value: "#8B1A1A",
    name: "firebrick 4"
  },
  {
    value: "#FF0000",
    vga: !0,
    name: "red 1"
  },
  {
    value: "#FF0000",
    vga: !0,
    css: !0,
    name: "red"
  },
  {
    value: "#EE0000",
    name: "red 2"
  },
  {
    value: "#CD0000",
    name: "red 3"
  },
  {
    value: "#8B0000",
    name: "red 4"
  },
  {
    value: "#8B0000",
    css: !0,
    name: "darkred"
  },
  {
    value: "#800000",
    vga: !0,
    css: !0,
    name: "maroon"
  },
  {
    value: "#8E388E",
    name: "sgi beet"
  },
  {
    value: "#7171C6",
    name: "sgi slateblue"
  },
  {
    value: "#7D9EC0",
    name: "sgi lightblue"
  },
  {
    value: "#388E8E",
    name: "sgi teal"
  },
  {
    value: "#71C671",
    name: "sgi chartreuse"
  },
  {
    value: "#8E8E38",
    name: "sgi olivedrab"
  },
  {
    value: "#C5C1AA",
    name: "sgi brightgray"
  },
  {
    value: "#C67171",
    name: "sgi salmon"
  },
  {
    value: "#555555",
    name: "sgi darkgray"
  },
  {
    value: "#1E1E1E",
    name: "sgi gray 12"
  },
  {
    value: "#282828",
    name: "sgi gray 16"
  },
  {
    value: "#515151",
    name: "sgi gray 32"
  },
  {
    value: "#5B5B5B",
    name: "sgi gray 36"
  },
  {
    value: "#848484",
    name: "sgi gray 52"
  },
  {
    value: "#8E8E8E",
    name: "sgi gray 56"
  },
  {
    value: "#AAAAAA",
    name: "sgi lightgray"
  },
  {
    value: "#B7B7B7",
    name: "sgi gray 72"
  },
  {
    value: "#C1C1C1",
    name: "sgi gray 76"
  },
  {
    value: "#EAEAEA",
    name: "sgi gray 92"
  },
  {
    value: "#F4F4F4",
    name: "sgi gray 96"
  },
  {
    value: "#FFFFFF",
    vga: !0,
    css: !0,
    name: "white"
  },
  {
    value: "#F5F5F5",
    name: "white smoke"
  },
  {
    value: "#F5F5F5",
    name: "gray 96"
  },
  {
    value: "#DCDCDC",
    css: !0,
    name: "gainsboro"
  },
  {
    value: "#D3D3D3",
    css: !0,
    name: "lightgrey"
  },
  {
    value: "#C0C0C0",
    vga: !0,
    css: !0,
    name: "silver"
  },
  {
    value: "#A9A9A9",
    css: !0,
    name: "darkgray"
  },
  {
    value: "#808080",
    vga: !0,
    css: !0,
    name: "gray"
  },
  {
    value: "#696969",
    css: !0,
    name: "dimgray"
  },
  {
    value: "#696969",
    name: "gray 42"
  },
  {
    value: "#000000",
    vga: !0,
    css: !0,
    name: "black"
  },
  {
    value: "#FCFCFC",
    name: "gray 99"
  },
  {
    value: "#FAFAFA",
    name: "gray 98"
  },
  {
    value: "#F7F7F7",
    name: "gray 97"
  },
  {
    value: "#F2F2F2",
    name: "gray 95"
  },
  {
    value: "#F0F0F0",
    name: "gray 94"
  },
  {
    value: "#EDEDED",
    name: "gray 93"
  },
  {
    value: "#EBEBEB",
    name: "gray 92"
  },
  {
    value: "#E8E8E8",
    name: "gray 91"
  },
  {
    value: "#E5E5E5",
    name: "gray 90"
  },
  {
    value: "#E3E3E3",
    name: "gray 89"
  },
  {
    value: "#E0E0E0",
    name: "gray 88"
  },
  {
    value: "#DEDEDE",
    name: "gray 87"
  },
  {
    value: "#DBDBDB",
    name: "gray 86"
  },
  {
    value: "#D9D9D9",
    name: "gray 85"
  },
  {
    value: "#D6D6D6",
    name: "gray 84"
  },
  {
    value: "#D4D4D4",
    name: "gray 83"
  },
  {
    value: "#D1D1D1",
    name: "gray 82"
  },
  {
    value: "#CFCFCF",
    name: "gray 81"
  },
  {
    value: "#CCCCCC",
    name: "gray 80"
  },
  {
    value: "#C9C9C9",
    name: "gray 79"
  },
  {
    value: "#C7C7C7",
    name: "gray 78"
  },
  {
    value: "#C4C4C4",
    name: "gray 77"
  },
  {
    value: "#C2C2C2",
    name: "gray 76"
  },
  {
    value: "#BFBFBF",
    name: "gray 75"
  },
  {
    value: "#BDBDBD",
    name: "gray 74"
  },
  {
    value: "#BABABA",
    name: "gray 73"
  },
  {
    value: "#B8B8B8",
    name: "gray 72"
  },
  {
    value: "#B5B5B5",
    name: "gray 71"
  },
  {
    value: "#B3B3B3",
    name: "gray 70"
  },
  {
    value: "#B0B0B0",
    name: "gray 69"
  },
  {
    value: "#ADADAD",
    name: "gray 68"
  },
  {
    value: "#ABABAB",
    name: "gray 67"
  },
  {
    value: "#A8A8A8",
    name: "gray 66"
  },
  {
    value: "#A6A6A6",
    name: "gray 65"
  },
  {
    value: "#A3A3A3",
    name: "gray 64"
  },
  {
    value: "#A1A1A1",
    name: "gray 63"
  },
  {
    value: "#9E9E9E",
    name: "gray 62"
  },
  {
    value: "#9C9C9C",
    name: "gray 61"
  },
  {
    value: "#999999",
    name: "gray 60"
  },
  {
    value: "#969696",
    name: "gray 59"
  },
  {
    value: "#949494",
    name: "gray 58"
  },
  {
    value: "#919191",
    name: "gray 57"
  },
  {
    value: "#8F8F8F",
    name: "gray 56"
  },
  {
    value: "#8C8C8C",
    name: "gray 55"
  },
  {
    value: "#8A8A8A",
    name: "gray 54"
  },
  {
    value: "#878787",
    name: "gray 53"
  },
  {
    value: "#858585",
    name: "gray 52"
  },
  {
    value: "#828282",
    name: "gray 51"
  },
  {
    value: "#7F7F7F",
    name: "gray 50"
  },
  {
    value: "#7D7D7D",
    name: "gray 49"
  },
  {
    value: "#7A7A7A",
    name: "gray 48"
  },
  {
    value: "#787878",
    name: "gray 47"
  },
  {
    value: "#757575",
    name: "gray 46"
  },
  {
    value: "#737373",
    name: "gray 45"
  },
  {
    value: "#707070",
    name: "gray 44"
  },
  {
    value: "#6E6E6E",
    name: "gray 43"
  },
  {
    value: "#666666",
    name: "gray 40"
  },
  {
    value: "#636363",
    name: "gray 39"
  },
  {
    value: "#616161",
    name: "gray 38"
  },
  {
    value: "#5E5E5E",
    name: "gray 37"
  },
  {
    value: "#5C5C5C",
    name: "gray 36"
  },
  {
    value: "#595959",
    name: "gray 35"
  },
  {
    value: "#575757",
    name: "gray 34"
  },
  {
    value: "#545454",
    name: "gray 33"
  },
  {
    value: "#525252",
    name: "gray 32"
  },
  {
    value: "#4F4F4F",
    name: "gray 31"
  },
  {
    value: "#4D4D4D",
    name: "gray 30"
  },
  {
    value: "#4A4A4A",
    name: "gray 29"
  },
  {
    value: "#474747",
    name: "gray 28"
  },
  {
    value: "#454545",
    name: "gray 27"
  },
  {
    value: "#424242",
    name: "gray 26"
  },
  {
    value: "#404040",
    name: "gray 25"
  },
  {
    value: "#3D3D3D",
    name: "gray 24"
  },
  {
    value: "#3B3B3B",
    name: "gray 23"
  },
  {
    value: "#383838",
    name: "gray 22"
  },
  {
    value: "#363636",
    name: "gray 21"
  },
  {
    value: "#333333",
    name: "gray 20"
  },
  {
    value: "#303030",
    name: "gray 19"
  },
  {
    value: "#2E2E2E",
    name: "gray 18"
  },
  {
    value: "#2B2B2B",
    name: "gray 17"
  },
  {
    value: "#292929",
    name: "gray 16"
  },
  {
    value: "#262626",
    name: "gray 15"
  },
  {
    value: "#242424",
    name: "gray 14"
  },
  {
    value: "#212121",
    name: "gray 13"
  },
  {
    value: "#1F1F1F",
    name: "gray 12"
  },
  {
    value: "#1C1C1C",
    name: "gray 11"
  },
  {
    value: "#1A1A1A",
    name: "gray 10"
  },
  {
    value: "#171717",
    name: "gray 9"
  },
  {
    value: "#141414",
    name: "gray 8"
  },
  {
    value: "#121212",
    name: "gray 7"
  },
  {
    value: "#0F0F0F",
    name: "gray 6"
  },
  {
    value: "#0D0D0D",
    name: "gray 5"
  },
  {
    value: "#0A0A0A",
    name: "gray 4"
  },
  {
    value: "#080808",
    name: "gray 3"
  },
  {
    value: "#050505",
    name: "gray 2"
  },
  {
    value: "#030303",
    name: "gray 1"
  },
  {
    value: "#F5F5F5",
    css: !0,
    name: "whitesmoke"
  }
];
(function(e) {
  var t = $B, r = t.filter(function(i) {
    return !!i.css;
  }), n = t.filter(function(i) {
    return !!i.vga;
  });
  e.exports = function(i) {
    var a = e.exports.get(i);
    return a && a.value;
  }, e.exports.get = function(i) {
    return i = i || "", i = i.trim().toLowerCase(), t.filter(function(a) {
      return a.name.toLowerCase() === i;
    }).pop();
  }, e.exports.all = e.exports.get.all = function() {
    return t;
  }, e.exports.get.css = function(i) {
    return i ? (i = i || "", i = i.trim().toLowerCase(), r.filter(function(a) {
      return a.name.toLowerCase() === i;
    }).pop()) : r;
  }, e.exports.get.vga = function(i) {
    return i ? (i = i || "", i = i.trim().toLowerCase(), n.filter(function(a) {
      return a.name.toLowerCase() === i;
    }).pop()) : n;
  };
})(nw);
var RB = nw.exports;
const Nie = /* @__PURE__ */ Nt(RB);
var MB = {}, ac = {}, Lh = {}, Gf = {}, xy;
function BB() {
  return xy || (xy = 1, function(e) {
    (function(t, r) {
      r(e, me, bb());
    })(he, function(t, r, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.setHasSupportToCaptureOption = p;
      var i = o(r), a = o(n);
      function o(y) {
        return y && y.__esModule ? y : {
          default: y
        };
      }
      var s = Object.assign || function(y) {
        for (var g = 1; g < arguments.length; g++) {
          var E = arguments[g];
          for (var b in E)
            Object.prototype.hasOwnProperty.call(E, b) && (y[b] = E[b]);
        }
        return y;
      };
      function u(y, g) {
        var E = {};
        for (var b in y)
          g.indexOf(b) >= 0 || Object.prototype.hasOwnProperty.call(y, b) && (E[b] = y[b]);
        return E;
      }
      function l(y, g) {
        if (!(y instanceof g))
          throw new TypeError("Cannot call a class as a function");
      }
      var c = function() {
        function y(g, E) {
          for (var b = 0; b < E.length; b++) {
            var w = E[b];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(g, w.key, w);
          }
        }
        return function(g, E, b) {
          return E && y(g.prototype, E), b && y(g, b), g;
        };
      }();
      function f(y, g) {
        if (!y)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return g && (typeof g == "object" || typeof g == "function") ? g : y;
      }
      function d(y, g) {
        if (typeof g != "function" && g !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof g);
        y.prototype = Object.create(g && g.prototype, {
          constructor: {
            value: y,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(y, g) : y.__proto__ = g);
      }
      var h = !1;
      function p(y) {
        h = y;
      }
      try {
        addEventListener("test", null, Object.defineProperty({}, "capture", { get: function() {
          p(!0);
        } }));
      } catch {
      }
      function v() {
        var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { capture: !0 };
        return h ? y : y.capture;
      }
      function m(y) {
        if ("touches" in y) {
          var g = y.touches[0], E = g.pageX, b = g.pageY;
          return { x: E, y: b };
        }
        var w = y.screenX, _ = y.screenY;
        return { x: w, y: _ };
      }
      var x = function(y) {
        d(g, y);
        function g() {
          var E;
          l(this, g);
          for (var b = arguments.length, w = Array(b), _ = 0; _ < b; _++)
            w[_] = arguments[_];
          var A = f(this, (E = g.__proto__ || Object.getPrototypeOf(g)).call.apply(E, [this].concat(w)));
          return A._handleSwipeStart = A._handleSwipeStart.bind(A), A._handleSwipeMove = A._handleSwipeMove.bind(A), A._handleSwipeEnd = A._handleSwipeEnd.bind(A), A._onMouseDown = A._onMouseDown.bind(A), A._onMouseMove = A._onMouseMove.bind(A), A._onMouseUp = A._onMouseUp.bind(A), A._setSwiperRef = A._setSwiperRef.bind(A), A;
        }
        return c(g, [{
          key: "componentDidMount",
          value: function() {
            this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, v({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, v({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "_onMouseDown",
          value: function(b) {
            this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(b));
          }
        }, {
          key: "_onMouseMove",
          value: function(b) {
            this.mouseDown && this._handleSwipeMove(b);
          }
        }, {
          key: "_onMouseUp",
          value: function(b) {
            this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(b);
          }
        }, {
          key: "_handleSwipeStart",
          value: function(b) {
            var w = m(b), _ = w.x, A = w.y;
            this.moveStart = { x: _, y: A }, this.props.onSwipeStart(b);
          }
        }, {
          key: "_handleSwipeMove",
          value: function(b) {
            if (this.moveStart) {
              var w = m(b), _ = w.x, A = w.y, O = _ - this.moveStart.x, T = A - this.moveStart.y;
              this.moving = !0;
              var C = this.props.onSwipeMove({
                x: O,
                y: T
              }, b);
              C && b.cancelable && b.preventDefault(), this.movePosition = { deltaX: O, deltaY: T };
            }
          }
        }, {
          key: "_handleSwipeEnd",
          value: function(b) {
            this.props.onSwipeEnd(b);
            var w = this.props.tolerance;
            this.moving && this.movePosition && (this.movePosition.deltaX < -w ? this.props.onSwipeLeft(1, b) : this.movePosition.deltaX > w && this.props.onSwipeRight(1, b), this.movePosition.deltaY < -w ? this.props.onSwipeUp(1, b) : this.movePosition.deltaY > w && this.props.onSwipeDown(1, b)), this.moveStart = null, this.moving = !1, this.movePosition = null;
          }
        }, {
          key: "_setSwiperRef",
          value: function(b) {
            this.swiper = b, this.props.innerRef(b);
          }
        }, {
          key: "render",
          value: function() {
            var b = this.props;
            b.tagName;
            var w = b.className, _ = b.style, A = b.children;
            b.allowMouseEvents, b.onSwipeUp, b.onSwipeDown, b.onSwipeLeft, b.onSwipeRight, b.onSwipeStart, b.onSwipeMove, b.onSwipeEnd, b.innerRef, b.tolerance;
            var O = u(b, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]);
            return i.default.createElement(
              this.props.tagName,
              s({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: w,
                style: _
              }, O),
              A
            );
          }
        }]), g;
      }(r.Component);
      x.displayName = "ReactSwipe", x.propTypes = {
        tagName: a.default.string,
        className: a.default.string,
        style: a.default.object,
        children: a.default.node,
        allowMouseEvents: a.default.bool,
        onSwipeUp: a.default.func,
        onSwipeDown: a.default.func,
        onSwipeLeft: a.default.func,
        onSwipeRight: a.default.func,
        onSwipeStart: a.default.func,
        onSwipeMove: a.default.func,
        onSwipeEnd: a.default.func,
        innerRef: a.default.func,
        tolerance: a.default.number.isRequired
      }, x.defaultProps = {
        tagName: "div",
        allowMouseEvents: !1,
        onSwipeUp: function() {
        },
        onSwipeDown: function() {
        },
        onSwipeLeft: function() {
        },
        onSwipeRight: function() {
        },
        onSwipeStart: function() {
        },
        onSwipeMove: function() {
        },
        onSwipeEnd: function() {
        },
        innerRef: function() {
        },
        tolerance: 0
      }, t.default = x;
    });
  }(Gf)), Gf;
}
(function(e) {
  (function(t, r) {
    r(e, BB());
  })(he, function(t, r) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = i(r);
    function i(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    t.default = n.default;
  });
})(Lh);
var ms = {}, iw = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        if (a) {
          var o = typeof a;
          if (o === "string" || o === "number")
            n.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var s = r.apply(null, a);
              s && n.push(s);
            }
          } else if (o === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              n.push(a.toString());
              continue;
            }
            for (var u in a)
              t.call(a, u) && a[u] && n.push(u);
          }
        }
      }
      return n.join(" ");
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(iw);
var jB = iw.exports;
Object.defineProperty(ms, "__esModule", {
  value: !0
});
ms.default = void 0;
var Rn = LB(jB);
function LB(e) {
  return e && e.__esModule ? e : { default: e };
}
function UB(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var HB = {
  ROOT: function(t) {
    return (0, Rn.default)(UB({
      "carousel-root": !0
    }, t || "", !!t));
  },
  CAROUSEL: function(t) {
    return (0, Rn.default)({
      carousel: !0,
      "carousel-slider": t
    });
  },
  WRAPPER: function(t, r) {
    return (0, Rn.default)({
      "thumbs-wrapper": !t,
      "slider-wrapper": t,
      "axis-horizontal": r === "horizontal",
      "axis-vertical": r !== "horizontal"
    });
  },
  SLIDER: function(t, r) {
    return (0, Rn.default)({
      thumbs: !t,
      slider: t,
      animated: !r
    });
  },
  ITEM: function(t, r, n) {
    return (0, Rn.default)({
      thumb: !t,
      slide: t,
      selected: r,
      previous: n
    });
  },
  ARROW_PREV: function(t) {
    return (0, Rn.default)({
      "control-arrow control-prev": !0,
      "control-disabled": t
    });
  },
  ARROW_NEXT: function(t) {
    return (0, Rn.default)({
      "control-arrow control-next": !0,
      "control-disabled": t
    });
  },
  DOT: function(t) {
    return (0, Rn.default)({
      dot: !0,
      selected: t
    });
  }
};
ms.default = HB;
var ys = {}, oc = {};
Object.defineProperty(oc, "__esModule", {
  value: !0
});
oc.outerWidth = void 0;
var WB = function(t) {
  var r = t.offsetWidth, n = getComputedStyle(t);
  return r += parseInt(n.marginLeft) + parseInt(n.marginRight), r;
};
oc.outerWidth = WB;
var Ha = {};
Object.defineProperty(Ha, "__esModule", {
  value: !0
});
Ha.default = void 0;
var zB = function(t, r, n) {
  var i = t === 0 ? t : t + r, a = n === "horizontal" ? [i, 0, 0] : [0, i, 0], o = "translate3d", s = "(" + a.join(",") + ")";
  return o + s;
};
Ha.default = zB;
var gs = {};
Object.defineProperty(gs, "__esModule", {
  value: !0
});
gs.default = void 0;
var qB = function() {
  return window;
};
gs.default = qB;
Object.defineProperty(ys, "__esModule", {
  value: !0
});
ys.default = void 0;
var Er = GB(me), di = sc(ms), YB = oc, by = sc(Ha), VB = sc(Lh), Hs = sc(gs);
function sc(e) {
  return e && e.__esModule ? e : { default: e };
}
function aw() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return aw = function() {
    return e;
  }, e;
}
function GB(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || Co(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = aw();
  if (t && t.has(e))
    return t.get(e);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var a = n ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, i, a) : r[i] = e[i];
    }
  return r.default = e, t && t.set(e, r), r;
}
function Co(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Co = function(r) {
    return typeof r;
  } : Co = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Co(e);
}
function Qd() {
  return Qd = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qd.apply(this, arguments);
}
function KB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ey(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function QB(e, t, r) {
  return t && Ey(e.prototype, t), r && Ey(e, r), e;
}
function XB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Xd(e, t);
}
function Xd(e, t) {
  return Xd = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, Xd(e, t);
}
function JB(e) {
  var t = e5();
  return function() {
    var n = Vu(e), i;
    if (t) {
      var a = Vu(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ZB(this, i);
  };
}
function ZB(e, t) {
  return t && (Co(t) === "object" || typeof t == "function") ? t : Ht(e);
}
function Ht(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function e5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vu(e) {
  return Vu = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Vu(e);
}
function Pt(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var t5 = function(t) {
  return t.hasOwnProperty("key");
}, Uh = /* @__PURE__ */ function(e) {
  XB(r, e);
  var t = JB(r);
  function r(n) {
    var i;
    return KB(this, r), i = t.call(this, n), Pt(Ht(i), "itemsWrapperRef", void 0), Pt(Ht(i), "itemsListRef", void 0), Pt(Ht(i), "thumbsRef", void 0), Pt(Ht(i), "setItemsWrapperRef", function(a) {
      i.itemsWrapperRef = a;
    }), Pt(Ht(i), "setItemsListRef", function(a) {
      i.itemsListRef = a;
    }), Pt(Ht(i), "setThumbsRef", function(a, o) {
      i.thumbsRef || (i.thumbsRef = []), i.thumbsRef[o] = a;
    }), Pt(Ht(i), "updateSizes", function() {
      if (!(!i.props.children || !i.itemsWrapperRef || !i.thumbsRef)) {
        var a = Er.Children.count(i.props.children), o = i.itemsWrapperRef.clientWidth, s = i.props.thumbWidth ? i.props.thumbWidth : (0, YB.outerWidth)(i.thumbsRef[0]), u = Math.floor(o / s), l = u < a, c = l ? a - u : 0;
        i.setState(function(f, d) {
          return {
            itemSize: s,
            visibleItems: u,
            firstItem: l ? i.getFirstItem(d.selectedItem) : 0,
            lastPosition: c,
            showArrows: l
          };
        });
      }
    }), Pt(Ht(i), "handleClickItem", function(a, o, s) {
      if (!t5(s) || s.key === "Enter") {
        var u = i.props.onSelectItem;
        typeof u == "function" && u(a, o);
      }
    }), Pt(Ht(i), "onSwipeStart", function() {
      i.setState({
        swiping: !0
      });
    }), Pt(Ht(i), "onSwipeEnd", function() {
      i.setState({
        swiping: !1
      });
    }), Pt(Ht(i), "onSwipeMove", function(a) {
      var o = a.x;
      if (!i.state.itemSize || !i.itemsWrapperRef || !i.state.visibleItems)
        return !1;
      var s = 0, u = Er.Children.count(i.props.children), l = -(i.state.firstItem * 100) / i.state.visibleItems, c = Math.max(u - i.state.visibleItems, 0), f = -c * 100 / i.state.visibleItems;
      l === s && o > 0 && (o = 0), l === f && o < 0 && (o = 0);
      var d = i.itemsWrapperRef.clientWidth, h = l + 100 / (d / o);
      return i.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(p) {
        i.itemsListRef.style[p] = (0, by.default)(h, "%", i.props.axis);
      }), !0;
    }), Pt(Ht(i), "slideRight", function(a) {
      i.moveTo(i.state.firstItem - (typeof a == "number" ? a : 1));
    }), Pt(Ht(i), "slideLeft", function(a) {
      i.moveTo(i.state.firstItem + (typeof a == "number" ? a : 1));
    }), Pt(Ht(i), "moveTo", function(a) {
      a = a < 0 ? 0 : a, a = a >= i.state.lastPosition ? i.state.lastPosition : a, i.setState({
        firstItem: a
      });
    }), i.state = {
      selectedItem: n.selectedItem,
      swiping: !1,
      showArrows: !1,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    }, i;
  }
  return QB(r, [{
    key: "componentDidMount",
    value: function() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      this.props.selectedItem !== this.state.selectedItem && this.setState({
        selectedItem: this.props.selectedItem,
        firstItem: this.getFirstItem(this.props.selectedItem)
      }), this.props.children !== i.children && this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function() {
      (0, Hs.default)().addEventListener("resize", this.updateSizes), (0, Hs.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function() {
      (0, Hs.default)().removeEventListener("resize", this.updateSizes), (0, Hs.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function(i) {
      var a = i;
      return i >= this.state.lastPosition && (a = this.state.lastPosition), i < this.state.firstItem + this.state.visibleItems && (a = this.state.firstItem), i < this.state.firstItem && (a = i), a;
    }
  }, {
    key: "renderItems",
    value: function() {
      var i = this;
      return this.props.children.map(function(a, o) {
        var s = di.default.ITEM(!1, o === i.state.selectedItem), u = {
          key: o,
          ref: function(c) {
            return i.setThumbsRef(c, o);
          },
          className: s,
          onClick: i.handleClickItem.bind(i, o, i.props.children[o]),
          onKeyDown: i.handleClickItem.bind(i, o, i.props.children[o]),
          "aria-label": "".concat(i.props.labels.item, " ").concat(o + 1),
          style: {
            width: i.props.thumbWidth
          }
        };
        return /* @__PURE__ */ Er.default.createElement("li", Qd({}, u, {
          role: "button",
          tabIndex: 0
        }), a);
      });
    }
  }, {
    key: "render",
    value: function() {
      var i = this;
      if (!this.props.children)
        return null;
      var a = Er.Children.count(this.props.children) > 1, o = this.state.showArrows && this.state.firstItem > 0, s = this.state.showArrows && this.state.firstItem < this.state.lastPosition, u = {}, l = -this.state.firstItem * (this.state.itemSize || 0), c = (0, by.default)(l, "px", this.props.axis), f = this.props.transitionTime + "ms";
      return u = {
        WebkitTransform: c,
        MozTransform: c,
        MsTransform: c,
        OTransform: c,
        transform: c,
        msTransform: c,
        WebkitTransitionDuration: f,
        MozTransitionDuration: f,
        MsTransitionDuration: f,
        OTransitionDuration: f,
        transitionDuration: f,
        msTransitionDuration: f
      }, /* @__PURE__ */ Er.default.createElement("div", {
        className: di.default.CAROUSEL(!1)
      }, /* @__PURE__ */ Er.default.createElement("div", {
        className: di.default.WRAPPER(!1),
        ref: this.setItemsWrapperRef
      }, /* @__PURE__ */ Er.default.createElement("button", {
        type: "button",
        className: di.default.ARROW_PREV(!o),
        onClick: function() {
          return i.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), a ? /* @__PURE__ */ Er.default.createElement(VB.default, {
        tagName: "ul",
        className: di.default.SLIDER(!1, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: u,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /* @__PURE__ */ Er.default.createElement("ul", {
        className: di.default.SLIDER(!1, this.state.swiping),
        ref: function(h) {
          return i.setItemsListRef(h);
        },
        style: u
      }, this.renderItems()), /* @__PURE__ */ Er.default.createElement("button", {
        type: "button",
        className: di.default.ARROW_NEXT(!s),
        onClick: function() {
          return i.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]), r;
}(Er.Component);
ys.default = Uh;
Pt(Uh, "displayName", "Thumbs");
Pt(Uh, "defaultProps", {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var uc = {};
Object.defineProperty(uc, "__esModule", {
  value: !0
});
uc.default = void 0;
var r5 = function() {
  return document;
};
uc.default = r5;
var ar = {};
Object.defineProperty(ar, "__esModule", {
  value: !0
});
ar.setPosition = ar.getPosition = ar.isKeyboardEvent = ar.defaultStatusFormatter = ar.noop = void 0;
var n5 = me, i5 = a5(Ha);
function a5(e) {
  return e && e.__esModule ? e : { default: e };
}
var o5 = function() {
};
ar.noop = o5;
var s5 = function(t, r) {
  return "".concat(t, " of ").concat(r);
};
ar.defaultStatusFormatter = s5;
var u5 = function(t) {
  return t ? t.hasOwnProperty("key") : !1;
};
ar.isKeyboardEvent = u5;
var l5 = function(t, r) {
  if (r.infiniteLoop && ++t, t === 0)
    return 0;
  var n = n5.Children.count(r.children);
  if (r.centerMode && r.axis === "horizontal") {
    var i = -t * r.centerSlidePercentage, a = n - 1;
    return t && (t !== a || r.infiniteLoop) ? i += (100 - r.centerSlidePercentage) / 2 : t === a && (i += 100 - r.centerSlidePercentage), i;
  }
  return -t * 100;
};
ar.getPosition = l5;
var c5 = function(t, r) {
  var n = {};
  return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(i) {
    n[i] = (0, i5.default)(t, "%", r);
  }), n;
};
ar.setPosition = c5;
var tn = {};
Object.defineProperty(tn, "__esModule", {
  value: !0
});
tn.fadeAnimationHandler = tn.slideStopSwipingHandler = tn.slideSwipeAnimationHandler = tn.slideAnimationHandler = void 0;
var ow = me, f5 = d5(Ha), rn = ar;
function d5(e) {
  return e && e.__esModule ? e : { default: e };
}
function wy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wy(Object(r), !0).forEach(function(n) {
      h5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function h5(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var p5 = function(t, r) {
  var n = {}, i = r.selectedItem, a = i, o = ow.Children.count(t.children) - 1, s = t.infiniteLoop && (i < 0 || i > o);
  if (s)
    return a < 0 ? t.centerMode && t.centerSlidePercentage && t.axis === "horizontal" ? n.itemListStyle = (0, rn.setPosition)(-(o + 2) * t.centerSlidePercentage - (100 - t.centerSlidePercentage) / 2, t.axis) : n.itemListStyle = (0, rn.setPosition)(-(o + 2) * 100, t.axis) : a > o && (n.itemListStyle = (0, rn.setPosition)(0, t.axis)), n;
  var u = (0, rn.getPosition)(i, t), l = (0, f5.default)(u, "%", t.axis), c = t.transitionTime + "ms";
  return n.itemListStyle = {
    WebkitTransform: l,
    msTransform: l,
    OTransform: l,
    transform: l
  }, r.swiping || (n.itemListStyle = xi(xi({}, n.itemListStyle), {}, {
    WebkitTransitionDuration: c,
    MozTransitionDuration: c,
    OTransitionDuration: c,
    transitionDuration: c,
    msTransitionDuration: c
  })), n;
};
tn.slideAnimationHandler = p5;
var v5 = function(t, r, n, i) {
  var a = {}, o = r.axis === "horizontal", s = ow.Children.count(r.children), u = 0, l = (0, rn.getPosition)(n.selectedItem, r), c = r.infiniteLoop ? (0, rn.getPosition)(s - 1, r) - 100 : (0, rn.getPosition)(s - 1, r), f = o ? t.x : t.y, d = f;
  l === u && f > 0 && (d = 0), l === c && f < 0 && (d = 0);
  var h = l + 100 / (n.itemSize / d), p = Math.abs(f) > r.swipeScrollTolerance;
  return r.infiniteLoop && p && (n.selectedItem === 0 && h > -100 ? h -= s * 100 : n.selectedItem === s - 1 && h < -s * 100 && (h += s * 100)), (!r.preventMovementUntilSwipeScrollTolerance || p || n.swipeMovementStarted) && (n.swipeMovementStarted || i({
    swipeMovementStarted: !0
  }), a.itemListStyle = (0, rn.setPosition)(h, r.axis)), p && !n.cancelClick && i({
    cancelClick: !0
  }), a;
};
tn.slideSwipeAnimationHandler = v5;
var m5 = function(t, r) {
  var n = (0, rn.getPosition)(r.selectedItem, t), i = (0, rn.setPosition)(n, t.axis);
  return {
    itemListStyle: i
  };
};
tn.slideStopSwipingHandler = m5;
var y5 = function(t, r) {
  var n = t.transitionTime + "ms", i = "ease-in-out", a = {
    position: "absolute",
    display: "block",
    zIndex: -2,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: i,
    msTransitionTimingFunction: i,
    MozTransitionTimingFunction: i,
    WebkitTransitionTimingFunction: i,
    OTransitionTimingFunction: i
  };
  return r.swiping || (a = xi(xi({}, a), {}, {
    WebkitTransitionDuration: n,
    MozTransitionDuration: n,
    OTransitionDuration: n,
    transitionDuration: n,
    msTransitionDuration: n
  })), {
    slideStyle: a,
    selectedStyle: xi(xi({}, a), {}, {
      opacity: 1,
      position: "relative"
    }),
    prevStyle: xi({}, a)
  };
};
tn.fadeAnimationHandler = y5;
Object.defineProperty(ac, "__esModule", {
  value: !0
});
ac.default = void 0;
var Ge = b5(me), g5 = xs(Lh), yn = xs(ms), x5 = xs(ys), Ws = xs(uc), zs = xs(gs), bo = ar, Gu = tn;
function xs(e) {
  return e && e.__esModule ? e : { default: e };
}
function sw() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return sw = function() {
    return e;
  }, e;
}
function b5(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || Oo(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = sw();
  if (t && t.has(e))
    return t.get(e);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var a = n ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, i, a) : r[i] = e[i];
    }
  return r.default = e, t && t.set(e, r), r;
}
function Oo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Oo = function(r) {
    return typeof r;
  } : Oo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Oo(e);
}
function Jd() {
  return Jd = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jd.apply(this, arguments);
}
function Sy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sy(Object(r), !0).forEach(function(n) {
      Ae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E5(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _y(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function w5(e, t, r) {
  return t && _y(e.prototype, t), r && _y(e, r), e;
}
function S5(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Zd(e, t);
}
function Zd(e, t) {
  return Zd = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, Zd(e, t);
}
function _5(e) {
  var t = A5();
  return function() {
    var n = Ku(e), i;
    if (t) {
      var a = Ku(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return T5(this, i);
  };
}
function T5(e, t) {
  return t && (Oo(t) === "object" || typeof t == "function") ? t : De(e);
}
function De(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function A5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ku(e) {
  return Ku = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ku(e);
}
function Ae(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var Hh = /* @__PURE__ */ function(e) {
  S5(r, e);
  var t = _5(r);
  function r(n) {
    var i;
    E5(this, r), i = t.call(this, n), Ae(De(i), "thumbsRef", void 0), Ae(De(i), "carouselWrapperRef", void 0), Ae(De(i), "listRef", void 0), Ae(De(i), "itemsRef", void 0), Ae(De(i), "timer", void 0), Ae(De(i), "animationHandler", void 0), Ae(De(i), "setThumbsRef", function(o) {
      i.thumbsRef = o;
    }), Ae(De(i), "setCarouselWrapperRef", function(o) {
      i.carouselWrapperRef = o;
    }), Ae(De(i), "setListRef", function(o) {
      i.listRef = o;
    }), Ae(De(i), "setItemsRef", function(o, s) {
      i.itemsRef || (i.itemsRef = []), i.itemsRef[s] = o;
    }), Ae(De(i), "autoPlay", function() {
      Ge.Children.count(i.props.children) <= 1 || (i.clearAutoPlay(), i.props.autoPlay && (i.timer = setTimeout(function() {
        i.increment();
      }, i.props.interval)));
    }), Ae(De(i), "clearAutoPlay", function() {
      i.timer && clearTimeout(i.timer);
    }), Ae(De(i), "resetAutoPlay", function() {
      i.clearAutoPlay(), i.autoPlay();
    }), Ae(De(i), "stopOnHover", function() {
      i.setState({
        isMouseEntered: !0
      }, i.clearAutoPlay);
    }), Ae(De(i), "startOnLeave", function() {
      i.setState({
        isMouseEntered: !1
      }, i.autoPlay);
    }), Ae(De(i), "isFocusWithinTheCarousel", function() {
      return i.carouselWrapperRef ? !!((0, Ws.default)().activeElement === i.carouselWrapperRef || i.carouselWrapperRef.contains((0, Ws.default)().activeElement)) : !1;
    }), Ae(De(i), "navigateWithKeyboard", function(o) {
      if (i.isFocusWithinTheCarousel()) {
        var s = i.props.axis, u = s === "horizontal", l = {
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          ArrowLeft: 37
        }, c = u ? l.ArrowRight : l.ArrowDown, f = u ? l.ArrowLeft : l.ArrowUp;
        c === o.keyCode ? i.increment() : f === o.keyCode && i.decrement();
      }
    }), Ae(De(i), "updateSizes", function() {
      if (!(!i.state.initialized || !i.itemsRef || i.itemsRef.length === 0)) {
        var o = i.props.axis === "horizontal", s = i.itemsRef[0];
        if (s) {
          var u = o ? s.clientWidth : s.clientHeight;
          i.setState({
            itemSize: u
          }), i.thumbsRef && i.thumbsRef.updateSizes();
        }
      }
    }), Ae(De(i), "setMountState", function() {
      i.setState({
        hasMount: !0
      }), i.updateSizes();
    }), Ae(De(i), "handleClickItem", function(o, s) {
      if (Ge.Children.count(i.props.children) !== 0) {
        if (i.state.cancelClick) {
          i.setState({
            cancelClick: !1
          });
          return;
        }
        i.props.onClickItem(o, s), o !== i.state.selectedItem && i.setState({
          selectedItem: o
        });
      }
    }), Ae(De(i), "handleOnChange", function(o, s) {
      Ge.Children.count(i.props.children) <= 1 || i.props.onChange(o, s);
    }), Ae(De(i), "handleClickThumb", function(o, s) {
      i.props.onClickThumb(o, s), i.moveTo(o);
    }), Ae(De(i), "onSwipeStart", function(o) {
      i.setState({
        swiping: !0
      }), i.props.onSwipeStart(o);
    }), Ae(De(i), "onSwipeEnd", function(o) {
      i.setState({
        swiping: !1,
        cancelClick: !1,
        swipeMovementStarted: !1
      }), i.props.onSwipeEnd(o), i.clearAutoPlay(), i.state.autoPlay && i.autoPlay();
    }), Ae(De(i), "onSwipeMove", function(o, s) {
      i.props.onSwipeMove(s);
      var u = i.props.swipeAnimationHandler(o, i.props, i.state, i.setState.bind(De(i)));
      return i.setState(wr({}, u)), !!Object.keys(u).length;
    }), Ae(De(i), "decrement", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      i.moveTo(i.state.selectedItem - (typeof o == "number" ? o : 1));
    }), Ae(De(i), "increment", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      i.moveTo(i.state.selectedItem + (typeof o == "number" ? o : 1));
    }), Ae(De(i), "moveTo", function(o) {
      if (typeof o == "number") {
        var s = Ge.Children.count(i.props.children) - 1;
        o < 0 && (o = i.props.infiniteLoop ? s : 0), o > s && (o = i.props.infiniteLoop ? 0 : s), i.selectItem({
          // if it's not a slider, we don't need to set position here
          selectedItem: o
        }), i.state.autoPlay && i.state.isMouseEntered === !1 && i.resetAutoPlay();
      }
    }), Ae(De(i), "onClickNext", function() {
      i.increment(1);
    }), Ae(De(i), "onClickPrev", function() {
      i.decrement(1);
    }), Ae(De(i), "onSwipeForward", function() {
      i.increment(1), i.props.emulateTouch && i.setState({
        cancelClick: !0
      });
    }), Ae(De(i), "onSwipeBackwards", function() {
      i.decrement(1), i.props.emulateTouch && i.setState({
        cancelClick: !0
      });
    }), Ae(De(i), "changeItem", function(o) {
      return function(s) {
        (!(0, bo.isKeyboardEvent)(s) || s.key === "Enter") && i.moveTo(o);
      };
    }), Ae(De(i), "selectItem", function(o) {
      i.setState(wr({
        previousItem: i.state.selectedItem
      }, o), function() {
        i.setState(i.animationHandler(i.props, i.state));
      }), i.handleOnChange(o.selectedItem, Ge.Children.toArray(i.props.children)[o.selectedItem]);
    }), Ae(De(i), "getInitialImage", function() {
      var o = i.props.selectedItem, s = i.itemsRef && i.itemsRef[o], u = s && s.getElementsByTagName("img") || [];
      return u[0];
    }), Ae(De(i), "getVariableItemHeight", function(o) {
      var s = i.itemsRef && i.itemsRef[o];
      if (i.state.hasMount && s && s.children.length) {
        var u = s.children[0].getElementsByTagName("img") || [];
        if (u.length > 0) {
          var l = u[0];
          if (!l.complete) {
            var c = function h() {
              i.forceUpdate(), l.removeEventListener("load", h);
            };
            l.addEventListener("load", c);
          }
        }
        var f = u[0] || s.children[0], d = f.clientHeight;
        return d > 0 ? d : null;
      }
      return null;
    });
    var a = {
      initialized: !1,
      previousItem: n.selectedItem,
      selectedItem: n.selectedItem,
      hasMount: !1,
      isMouseEntered: !1,
      autoPlay: n.autoPlay,
      swiping: !1,
      swipeMovementStarted: !1,
      cancelClick: !1,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    return i.animationHandler = typeof n.animationHandler == "function" && n.animationHandler || n.animationHandler === "fade" && Gu.fadeAnimationHandler || Gu.slideAnimationHandler, i.state = wr(wr({}, a), i.animationHandler(n, a)), i;
  }
  return w5(r, [{
    key: "componentDidMount",
    value: function() {
      this.props.children && this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i, a) {
      !i.children && this.props.children && !this.state.initialized && this.setupCarousel(), !i.autoFocus && this.props.autoFocus && this.forceFocus(), a.swiping && !this.state.swiping && this.setState(wr({}, this.props.stopSwipingHandler(this.props, this.state))), (i.selectedItem !== this.props.selectedItem || i.centerMode !== this.props.centerMode) && (this.updateSizes(), this.moveTo(this.props.selectedItem)), i.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
        autoPlay: this.props.autoPlay
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function() {
      var i = this;
      this.bindEvents(), this.state.autoPlay && Ge.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
        initialized: !0
      }, function() {
        var a = i.getInitialImage();
        a && !a.complete ? a.addEventListener("load", i.setMountState) : i.setMountState();
      });
    }
  }, {
    key: "destroyCarousel",
    value: function() {
      this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
    }
  }, {
    key: "setupAutoPlay",
    value: function() {
      this.autoPlay();
      var i = this.carouselWrapperRef;
      this.props.stopOnHover && i && (i.addEventListener("mouseenter", this.stopOnHover), i.addEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "destroyAutoPlay",
    value: function() {
      this.clearAutoPlay();
      var i = this.carouselWrapperRef;
      this.props.stopOnHover && i && (i.removeEventListener("mouseenter", this.stopOnHover), i.removeEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "bindEvents",
    value: function() {
      (0, zs.default)().addEventListener("resize", this.updateSizes), (0, zs.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, Ws.default)().addEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "unbindEvents",
    value: function() {
      (0, zs.default)().removeEventListener("resize", this.updateSizes), (0, zs.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      var i = this.getInitialImage();
      i && i.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, Ws.default)().removeEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "forceFocus",
    value: function() {
      var i;
      (i = this.carouselWrapperRef) === null || i === void 0 || i.focus();
    }
  }, {
    key: "renderItems",
    value: function(i) {
      var a = this;
      return this.props.children ? Ge.Children.map(this.props.children, function(o, s) {
        var u = s === a.state.selectedItem, l = s === a.state.previousItem, c = u && a.state.selectedStyle || l && a.state.prevStyle || a.state.slideStyle || {};
        a.props.centerMode && a.props.axis === "horizontal" && (c = wr(wr({}, c), {}, {
          minWidth: a.props.centerSlidePercentage + "%"
        })), a.state.swiping && a.state.swipeMovementStarted && (c = wr(wr({}, c), {}, {
          pointerEvents: "none"
        }));
        var f = {
          ref: function(h) {
            return a.setItemsRef(h, s);
          },
          key: "itemKey" + s + (i ? "clone" : ""),
          className: yn.default.ITEM(!0, s === a.state.selectedItem, s === a.state.previousItem),
          onClick: a.handleClickItem.bind(a, s, o),
          style: c
        };
        return /* @__PURE__ */ Ge.default.createElement("li", f, a.props.renderItem(o, {
          isSelected: s === a.state.selectedItem,
          isPrevious: s === a.state.previousItem
        }));
      }) : [];
    }
  }, {
    key: "renderControls",
    value: function() {
      var i = this, a = this.props, o = a.showIndicators, s = a.labels, u = a.renderIndicator, l = a.children;
      return o ? /* @__PURE__ */ Ge.default.createElement("ul", {
        className: "control-dots"
      }, Ge.Children.map(l, function(c, f) {
        return u && u(i.changeItem(f), f === i.state.selectedItem, f, s.item);
      })) : null;
    }
  }, {
    key: "renderStatus",
    value: function() {
      return this.props.showStatus ? /* @__PURE__ */ Ge.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, Ge.Children.count(this.props.children))) : null;
    }
  }, {
    key: "renderThumbs",
    value: function() {
      return !this.props.showThumbs || !this.props.children || Ge.Children.count(this.props.children) === 0 ? null : /* @__PURE__ */ Ge.default.createElement(x5.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var i = this;
      if (!this.props.children || Ge.Children.count(this.props.children) === 0)
        return null;
      var a = this.props.swipeable && Ge.Children.count(this.props.children) > 1, o = this.props.axis === "horizontal", s = this.props.showArrows && Ge.Children.count(this.props.children) > 1, u = s && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1, l = s && (this.state.selectedItem < Ge.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1, c = this.renderItems(!0), f = c.shift(), d = c.pop(), h = {
        className: yn.default.SLIDER(!0, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      }, p = {};
      if (o) {
        if (h.onSwipeLeft = this.onSwipeForward, h.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
          var v = this.getVariableItemHeight(this.state.selectedItem);
          p.height = v || "auto";
        }
      } else
        h.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward, h.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards, h.style = wr(wr({}, h.style), {}, {
          height: this.state.itemSize
        }), p.height = this.state.itemSize;
      return /* @__PURE__ */ Ge.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: yn.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : void 0
      }, /* @__PURE__ */ Ge.default.createElement("div", {
        className: yn.default.CAROUSEL(!0),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, u, this.props.labels.leftArrow), /* @__PURE__ */ Ge.default.createElement("div", {
        className: yn.default.WRAPPER(!0, this.props.axis),
        style: p
      }, a ? /* @__PURE__ */ Ge.default.createElement(g5.default, Jd({
        tagName: "ul",
        innerRef: this.setListRef
      }, h, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && d, this.renderItems(), this.props.infiniteLoop && f) : /* @__PURE__ */ Ge.default.createElement("ul", {
        className: yn.default.SLIDER(!0, this.state.swiping),
        ref: function(x) {
          return i.setListRef(x);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && d, this.renderItems(), this.props.infiniteLoop && f)), this.props.renderArrowNext(this.onClickNext, l, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]), r;
}(Ge.default.Component);
ac.default = Hh;
Ae(Hh, "displayName", "Carousel");
Ae(Hh, "defaultProps", {
  ariaLabel: void 0,
  axis: "horizontal",
  centerSlidePercentage: 80,
  interval: 3e3,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onClickItem: bo.noop,
  onClickThumb: bo.noop,
  onChange: bo.noop,
  onSwipeStart: function() {
  },
  onSwipeEnd: function() {
  },
  onSwipeMove: function() {
    return !1;
  },
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: function(t, r, n) {
    return /* @__PURE__ */ Ge.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: yn.default.ARROW_PREV(!r),
      onClick: t
    });
  },
  renderArrowNext: function(t, r, n) {
    return /* @__PURE__ */ Ge.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: yn.default.ARROW_NEXT(!r),
      onClick: t
    });
  },
  renderIndicator: function(t, r, n, i) {
    return /* @__PURE__ */ Ge.default.createElement("li", {
      className: yn.default.DOT(r),
      onClick: t,
      onKeyDown: t,
      value: n,
      key: n,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(i, " ").concat(n + 1)
    });
  },
  renderItem: function(t) {
    return t;
  },
  renderThumbs: function(t) {
    var r = Ge.Children.map(t, function(n) {
      var i = n;
      if (n.type !== "img" && (i = Ge.Children.toArray(n.props.children).find(function(a) {
        return a.type === "img";
      })), !!i)
        return i;
    });
    return r.filter(function(n) {
      return n;
    }).length === 0 ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : r;
  },
  statusFormatter: bo.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !0,
  showThumbs: !0,
  stopOnHover: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 350,
  verticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  swipeAnimationHandler: Gu.slideSwipeAnimationHandler,
  stopSwipingHandler: Gu.slideStopSwipingHandler
});
var C5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Carousel", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "CarouselProps", {
    enumerable: !0,
    get: function() {
      return r.CarouselProps;
    }
  }), Object.defineProperty(e, "Thumbs", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  });
  var t = i(ac), r = C5, n = i(ys);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
})(MB);
const O5 = /constructor/i.test(window.HTMLElement) || function(e) {
  return e.toString() === "[object SafariRemoteNotification]";
}(
  !window.safari || window.safari.pushNotification
), uw = !!document.documentMode, D5 = !uw && !!window.StyleMedia, lw = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime), F5 = lw && navigator.userAgent.indexOf("Edg") != -1, I5 = {
  isSafari: O5,
  isIE: uw,
  isEdge: D5,
  isChrome: lw,
  isEdgeChromium: F5
}, k5 = () => {
  let e = window.navigator.userAgent, t = window.navigator.platform || navigator.userAgentData.platform, r = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"], n = ["Win32", "Win64", "Windows", "WinCE"], i = ["iPhone", "iPad", "iPod"], a = "";
  return r.indexOf(t) !== -1 ? a = "MACOS" : i.indexOf(t) !== -1 ? a = "IOS" : n.indexOf(t) !== -1 ? a = "WINDOWS" : /Android/.test(e) ? a = "ANDROID" : !a && /Linux/.test(t) && (a = "LINUX"), a;
}, Pie = () => {
  const e = k5();
  return console.log("OS:", e), ["MACOS"].includes(e) && !I5.isSafari ? "video/webm" : ["MACOS", "IOS"].includes(e) ? "video/mp4" : "video/webm";
};
(function() {
  typeof window > "u" || (navigator.mediaDevices === void 0 && (navigator.mediaDevices = {}), navigator.mediaDevices.getUserMedia === void 0 && (navigator.mediaDevices.getUserMedia = function(t) {
    const r = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    return r ? new Promise(function(n, i) {
      r.call(navigator, t, n, i);
    }) : (console.log("getUserMedia is not implemented in this browser"), Promise.reject(new Error("getUserMedia is not implemented in this browser")));
  }));
})();
function $ie() {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ue = function() {
  return ue = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, ue.apply(this, arguments);
};
function Wh(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function pt(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ke(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}
function ht(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, a; n < i; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Ze;
(function(e) {
  e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
})(Ze || (Ze = {}));
var Qu;
(function(e) {
  e.Parent = "#_parent", e.Internal = "#_internal";
})(Qu || (Qu = {}));
var Ty = Ze.Start, cw = Ze.Stop, lc = Ze.Raise, zh = Ze.Send, N5 = Ze.Cancel, P5 = Ze.NullEvent, qh = Ze.Assign;
Ze.After;
Ze.DoneState;
var $5 = Ze.Log, R5 = Ze.Init, e0 = Ze.Invoke;
Ze.ErrorExecution;
var Rie = Ze.ErrorPlatform, Mie = Ze.ErrorCustom, M5 = Ze.Update, B5 = Ze.Choose, j5 = Ze.Pure, fw = ".", Ay = {}, t0 = "xstate.guard", L5 = "", pr = process.env.NODE_ENV === "production", qs;
function Yh(e, t, r) {
  r === void 0 && (r = fw);
  var n = Do(e, r), i = Do(t, r);
  return Ue(i) ? Ue(n) ? i === n : !1 : Ue(n) ? n in i : Object.keys(n).every(function(a) {
    return a in i ? Yh(n[a], i[a]) : !1;
  });
}
function dw(e) {
  try {
    return Ue(e) || typeof e == "number" ? "".concat(e) : e.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function r0(e, t) {
  try {
    return bs(e) ? e : e.toString().split(t);
  } catch {
    throw new Error("'".concat(e, "' is not a valid state path."));
  }
}
function U5(e) {
  return typeof e == "object" && "value" in e && "context" in e && "event" in e && "_event" in e;
}
function Do(e, t) {
  if (U5(e))
    return e.value;
  if (bs(e))
    return Xu(e);
  if (typeof e != "string")
    return e;
  var r = r0(e, t);
  return Xu(r);
}
function Xu(e) {
  if (e.length === 1)
    return e[0];
  for (var t = {}, r = t, n = 0; n < e.length - 1; n++)
    n === e.length - 2 ? r[e[n]] = e[n + 1] : (r[e[n]] = {}, r = r[e[n]]);
  return t;
}
function Eo(e, t) {
  for (var r = {}, n = Object.keys(e), i = 0; i < n.length; i++) {
    var a = n[i];
    r[a] = t(e[a], a, e, i);
  }
  return r;
}
function Cy(e, t, r) {
  var n, i, a = {};
  try {
    for (var o = pt(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
      var u = s.value, l = e[u];
      r(l) && (a[u] = t(l, u, e));
    }
  } catch (c) {
    n = {
      error: c
    };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return a;
}
var H5 = function(e) {
  return function(t) {
    var r, n, i = t;
    try {
      for (var a = pt(e), o = a.next(); !o.done; o = a.next()) {
        var s = o.value;
        i = i[s];
      }
    } catch (u) {
      r = {
        error: u
      };
    } finally {
      try {
        o && !o.done && (n = a.return) && n.call(a);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return i;
  };
};
function W5(e, t) {
  return function(r) {
    var n, i, a = r;
    try {
      for (var o = pt(e), s = o.next(); !s.done; s = o.next()) {
        var u = s.value;
        a = a[t][u];
      }
    } catch (l) {
      n = {
        error: l
      };
    } finally {
      try {
        s && !s.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return a;
  };
}
function mu(e) {
  if (!e)
    return [[]];
  if (Ue(e))
    return [[e]];
  var t = mt(Object.keys(e).map(function(r) {
    var n = e[r];
    return typeof n != "string" && (!n || !Object.keys(n).length) ? [[r]] : mu(e[r]).map(function(i) {
      return [r].concat(i);
    });
  }));
  return t;
}
function mt(e) {
  var t;
  return (t = []).concat.apply(t, ht([], Ke(e), !1));
}
function hw(e) {
  return bs(e) ? e : [e];
}
function Ar(e) {
  return e === void 0 ? [] : hw(e);
}
function pw(e, t, r) {
  var n, i;
  if (st(e))
    return e(t, r.data);
  var a = {};
  try {
    for (var o = pt(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
      var u = s.value, l = e[u];
      st(l) ? a[u] = l(t, r.data) : a[u] = l;
    }
  } catch (c) {
    n = {
      error: c
    };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return a;
}
function z5(e) {
  return /^(done|error)\./.test(e);
}
function Bie(e) {
  return !!(e instanceof Promise || e !== null && (st(e) || typeof e == "object") && st(e.then));
}
function jie(e) {
  return e !== null && typeof e == "object" && "transition" in e && typeof e.transition == "function";
}
function q5(e, t) {
  var r, n, i = Ke([[], []], 2), a = i[0], o = i[1];
  try {
    for (var s = pt(e), u = s.next(); !u.done; u = s.next()) {
      var l = u.value;
      t(l) ? a.push(l) : o.push(l);
    }
  } catch (c) {
    r = {
      error: c
    };
  } finally {
    try {
      u && !u.done && (n = s.return) && n.call(s);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return [a, o];
}
function vw(e, t) {
  return Eo(e.states, function(r, n) {
    if (r) {
      var i = (Ue(t) ? void 0 : t[n]) || (r ? r.current : void 0);
      if (i)
        return {
          current: i,
          states: vw(r, i)
        };
    }
  });
}
function Y5(e, t) {
  return {
    current: t,
    states: vw(e, t)
  };
}
function Oy(e, t, r, n) {
  pr || En(!!e, "Attempting to update undefined context");
  var i = e && r.reduce(function(a, o) {
    var s, u, l = o.assignment, c = {
      state: n,
      action: o,
      _event: t
    }, f = {};
    if (st(l))
      f = l(a, t.data, c);
    else
      try {
        for (var d = pt(Object.keys(l)), h = d.next(); !h.done; h = d.next()) {
          var p = h.value, v = l[p];
          f[p] = st(v) ? v(a, t.data, c) : v;
        }
      } catch (m) {
        s = {
          error: m
        };
      } finally {
        try {
          h && !h.done && (u = d.return) && u.call(d);
        } finally {
          if (s)
            throw s.error;
        }
      }
    return Object.assign({}, a, f);
  }, e);
  return i;
}
var En = function() {
};
pr || (En = function(e, t) {
  var r = e instanceof Error ? e : void 0;
  if (!(!r && e) && console !== void 0) {
    var n = ["Warning: ".concat(t)];
    r && n.push(r), console.warn.apply(console, n);
  }
});
function bs(e) {
  return Array.isArray(e);
}
function st(e) {
  return typeof e == "function";
}
function Ue(e) {
  return typeof e == "string";
}
function mw(e, t) {
  if (e)
    return Ue(e) ? {
      type: t0,
      name: e,
      predicate: t ? t[e] : void 0
    } : st(e) ? {
      type: t0,
      name: e.name,
      predicate: e
    } : e;
}
function Lie(e) {
  try {
    return "subscribe" in e && st(e.subscribe);
  } catch {
    return !1;
  }
}
var Vh = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
qs = {}, qs[Vh] = function() {
  return this;
}, qs[Symbol.observable] = function() {
  return this;
};
function qo(e) {
  return !!e && "__xstatenode" in e;
}
function Uie(e) {
  return !!e && typeof e.send == "function";
}
function Gh(e, t) {
  return Ue(e) || typeof e == "number" ? ue({
    type: e
  }, t) : e;
}
function Yo(e, t) {
  if (!Ue(e) && "$$type" in e && e.$$type === "scxml")
    return e;
  var r = Gh(e);
  return ue({
    name: r.type,
    data: r,
    $$type: "scxml",
    type: "external"
  }, t);
}
function ta(e, t) {
  var r = hw(t).map(function(n) {
    return typeof n > "u" || typeof n == "string" || qo(n) ? {
      target: n,
      event: e
    } : ue(ue({}, n), {
      event: e
    });
  });
  return r;
}
function V5(e) {
  if (!(e === void 0 || e === L5))
    return Ar(e);
}
function Hie(e, t, r) {
  if (!pr) {
    var n = e.stack ? " Stacktrace was '".concat(e.stack, "'") : "";
    if (e === t)
      console.error("Missing onError handler for invocation '".concat(r, "', error was '").concat(e, "'.").concat(n));
    else {
      var i = t.stack ? " Stacktrace was '".concat(t.stack, "'") : "";
      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(r, "'. ") + "Original error: '".concat(e, "'. ").concat(n, " Current error is '").concat(t, "'.").concat(i));
    }
  }
}
function yw(e, t, r, n, i) {
  var a = e.options.guards, o = {
    state: i,
    cond: t,
    _event: n
  };
  if (t.type === t0)
    return ((a == null ? void 0 : a[t.name]) || t.predicate)(r, n.data, o);
  var s = a == null ? void 0 : a[t.type];
  if (!s)
    throw new Error("Guard '".concat(t.type, "' is not implemented on machine '").concat(e.id, "'."));
  return s(r, n.data, o);
}
function G5(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function Wie(e, t, r) {
  var n = function() {
  }, i = typeof e == "object", a = i ? e : null;
  return {
    next: ((i ? e.next : e) || n).bind(a),
    error: ((i ? e.error : t) || n).bind(a),
    complete: ((i ? e.complete : r) || n).bind(a)
  };
}
function Ys(e, t) {
  return "".concat(e, ":invocation[").concat(t, "]");
}
function Dy(e) {
  return (e.type === lc || e.type === zh && e.to === Qu.Internal) && typeof e.delay != "number";
}
var n0 = /* @__PURE__ */ Yo({
  type: R5
});
function Fy(e, t) {
  return t && t[e] || void 0;
}
function Vo(e, t) {
  var r;
  if (Ue(e) || typeof e == "number") {
    var n = Fy(e, t);
    st(n) ? r = {
      type: e,
      exec: n
    } : n ? r = n : r = {
      type: e,
      exec: void 0
    };
  } else if (st(e))
    r = {
      // Convert action to string if unnamed
      type: e.name || e.toString(),
      exec: e
    };
  else {
    var n = Fy(e.type, t);
    if (st(n))
      r = ue(ue({}, e), {
        exec: n
      });
    else if (n) {
      var i = n.type || e.type;
      r = ue(ue(ue({}, n), e), {
        type: i
      });
    } else
      r = e;
  }
  return r;
}
var bi = function(e, t) {
  if (!e)
    return [];
  var r = bs(e) ? e : [e];
  return r.map(function(n) {
    return Vo(n, t);
  });
};
function Kh(e) {
  var t = Vo(e);
  return ue(ue({
    id: Ue(e) ? e : t.id
  }, t), {
    type: t.type
  });
}
function K5(e, t) {
  return {
    type: lc,
    event: typeof e == "function" ? e : Gh(e),
    delay: t ? t.delay : void 0,
    id: t == null ? void 0 : t.id
  };
}
function Q5(e, t, r, n) {
  var i = {
    _event: r
  }, a = Yo(st(e.event) ? e.event(t, r.data, i) : e.event), o;
  if (Ue(e.delay)) {
    var s = n && n[e.delay];
    o = st(s) ? s(t, r.data, i) : s;
  } else
    o = st(e.delay) ? e.delay(t, r.data, i) : e.delay;
  return ue(ue({}, e), {
    type: lc,
    _event: a,
    delay: o
  });
}
function X5(e, t) {
  return {
    to: t ? t.to : void 0,
    type: zh,
    event: st(e) ? e : Gh(e),
    delay: t ? t.delay : void 0,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: t && t.id !== void 0 ? t.id : st(e) ? e.name : dw(e)
  };
}
function J5(e, t, r, n) {
  var i = {
    _event: r
  }, a = Yo(st(e.event) ? e.event(t, r.data, i) : e.event), o;
  if (Ue(e.delay)) {
    var s = n && n[e.delay];
    o = st(s) ? s(t, r.data, i) : s;
  } else
    o = st(e.delay) ? e.delay(t, r.data, i) : e.delay;
  var u = st(e.to) ? e.to(t, r.data, i) : e.to;
  return ue(ue({}, e), {
    to: u,
    _event: a,
    event: a.data,
    delay: o
  });
}
var Z5 = function(e, t, r) {
  return ue(ue({}, e), {
    value: Ue(e.expr) ? e.expr : e.expr(t, r.data, {
      _event: r
    })
  });
}, e9 = function(e) {
  return {
    type: N5,
    sendId: e
  };
};
function t9(e) {
  var t = Kh(e);
  return {
    type: Ze.Start,
    activity: t,
    exec: void 0
  };
}
function r9(e) {
  var t = st(e) ? e : Kh(e);
  return {
    type: Ze.Stop,
    activity: t,
    exec: void 0
  };
}
function n9(e, t, r) {
  var n = st(e.activity) ? e.activity(t, r.data) : e.activity, i = typeof n == "string" ? {
    id: n
  } : n, a = {
    type: Ze.Stop,
    activity: i
  };
  return a;
}
var i9 = function(e) {
  return {
    type: qh,
    assignment: e
  };
};
function a9(e, t) {
  var r = t ? "#".concat(t) : "";
  return "".concat(Ze.After, "(").concat(e, ")").concat(r);
}
function Vs(e, t) {
  var r = "".concat(Ze.DoneState, ".").concat(e), n = {
    type: r,
    data: t
  };
  return n.toString = function() {
    return r;
  }, n;
}
function o9(e, t) {
  var r = "".concat(Ze.DoneInvoke, ".").concat(e), n = {
    type: r,
    data: t
  };
  return n.toString = function() {
    return r;
  }, n;
}
function s9(e, t) {
  var r = "".concat(Ze.ErrorPlatform, ".").concat(e), n = {
    type: r,
    data: t
  };
  return n.toString = function() {
    return r;
  }, n;
}
var u9 = function(e) {
  var t, r, n = [];
  try {
    for (var i = pt(e), a = i.next(); !a.done; a = i.next())
      for (var o = a.value, s = 0; s < o.actions.length; ) {
        if (o.actions[s].type === qh) {
          n.push(o.actions[s]), o.actions.splice(s, 1);
          continue;
        }
        s++;
      }
  } catch (u) {
    t = {
      error: u
    };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return n;
};
function i0(e, t, r, n, i, a, o) {
  o === void 0 && (o = !1);
  var s = o ? [] : u9(i), u = s.length ? Oy(r, n, s, t) : r, l = o ? [r] : void 0, c = [];
  function f(p, v) {
    var m;
    switch (v.type) {
      case lc: {
        var x = Q5(v, u, n, e.options.delays);
        return a && typeof x.delay == "number" && a(x, u, n), x;
      }
      case zh:
        var y = J5(v, u, n, e.options.delays);
        if (!pr) {
          var g = v.delay;
          En(
            !Ue(g) || typeof y.delay == "number",
            // tslint:disable-next-line:max-line-length
            "No delay reference for delay expression '".concat(g, "' was found on machine '").concat(e.id, "'")
          );
        }
        return a && y.to !== Qu.Internal && (p === "entry" ? c.push(y) : a(y, u, n)), y;
      case $5: {
        var E = Z5(v, u, n);
        return a == null || a(E, u, n), E;
      }
      case B5: {
        var b = v, w = (m = b.conds.find(function(V) {
          var ce = mw(V.cond, e.options.guards);
          return !ce || yw(e, ce, u, n, a ? void 0 : t);
        })) === null || m === void 0 ? void 0 : m.actions;
        if (!w)
          return [];
        var _ = Ke(i0(e, t, u, n, [{
          type: p,
          actions: bi(Ar(w), e.options.actions)
        }], a, o), 2), A = _[0], O = _[1];
        return u = O, l == null || l.push(u), A;
      }
      case j5: {
        var w = v.get(u, n.data);
        if (!w)
          return [];
        var T = Ke(i0(e, t, u, n, [{
          type: p,
          actions: bi(Ar(w), e.options.actions)
        }], a, o), 2), C = T[0], $ = T[1];
        return u = $, l == null || l.push(u), C;
      }
      case cw: {
        var E = n9(v, u, n);
        return a == null || a(E, r, n), E;
      }
      case qh: {
        u = Oy(u, n, [v], a ? void 0 : t), l == null || l.push(u);
        break;
      }
      default:
        var P = Vo(v, e.options.actions), j = P.exec;
        if (a)
          a(P, u, n);
        else if (j && l) {
          var W = l.length - 1, Y = ue(ue({}, P), {
            exec: function(V) {
              for (var ce = [], de = 1; de < arguments.length; de++)
                ce[de - 1] = arguments[de];
              j.apply(void 0, ht([l[W]], Ke(ce), !1));
            }
          });
          P = Y;
        }
        return P;
    }
  }
  function d(p) {
    var v, m, x = [];
    try {
      for (var y = pt(p.actions), g = y.next(); !g.done; g = y.next()) {
        var E = g.value, b = f(p.type, E);
        b && (x = x.concat(b));
      }
    } catch (w) {
      v = {
        error: w
      };
    } finally {
      try {
        g && !g.done && (m = y.return) && m.call(y);
      } finally {
        if (v)
          throw v.error;
      }
    }
    return c.forEach(function(w) {
      a(w, u, n);
    }), c.length = 0, x;
  }
  var h = mt(i.map(d));
  return [h, u];
}
var Iy = [], l9 = function(e, t) {
  Iy.push(e);
  var r = t(e);
  return Iy.pop(), r;
};
function gw(e) {
  var t;
  return t = {
    id: e,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: e
      };
    }
  }, t[Vh] = function() {
    return this;
  }, t;
}
function c9(e, t, r, n) {
  var i, a = G5(e.src), o = (i = t == null ? void 0 : t.options.services) === null || i === void 0 ? void 0 : i[a.type], s = e.data ? pw(e.data, r, n) : void 0, u = o ? f9(o, e.id, s) : gw(e.id);
  return u.meta = e, u;
}
function f9(e, t, r) {
  var n = gw(t);
  if (n.deferred = !0, qo(e)) {
    var i = n.state = l9(void 0, function() {
      return (r ? e.withContext(r) : e).initialState;
    });
    n.getSnapshot = function() {
      return i;
    };
  }
  return n;
}
function d9(e) {
  try {
    return typeof e.send == "function";
  } catch {
    return !1;
  }
}
function zie(e) {
  return d9(e) && "id" in e;
}
function qie(e) {
  var t;
  return ue((t = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, t[Vh] = function() {
    return this;
  }, t), e);
}
var Ju = function(e) {
  return e.type === "atomic" || e.type === "final";
};
function xw(e) {
  return Object.keys(e.states).map(function(t) {
    return e.states[t];
  });
}
function Go(e) {
  return xw(e).filter(function(t) {
    return t.type !== "history";
  });
}
function bw(e) {
  var t = [e];
  return Ju(e) ? t : t.concat(mt(Go(e).map(bw)));
}
function wo(e, t) {
  var r, n, i, a, o, s, u, l, c = new Set(e), f = a0(c), d = new Set(t);
  try {
    for (var h = pt(d), p = h.next(); !p.done; p = h.next())
      for (var v = p.value, m = v.parent; m && !d.has(m); )
        d.add(m), m = m.parent;
  } catch (O) {
    r = {
      error: O
    };
  } finally {
    try {
      p && !p.done && (n = h.return) && n.call(h);
    } finally {
      if (r)
        throw r.error;
    }
  }
  var x = a0(d);
  try {
    for (var y = pt(d), g = y.next(); !g.done; g = y.next()) {
      var v = g.value;
      if (v.type === "compound" && (!x.get(v) || !x.get(v).length))
        f.get(v) ? f.get(v).forEach(function(T) {
          return d.add(T);
        }) : v.initialStateNodes.forEach(function(T) {
          return d.add(T);
        });
      else if (v.type === "parallel")
        try {
          for (var E = (o = void 0, pt(Go(v))), b = E.next(); !b.done; b = E.next()) {
            var w = b.value;
            d.has(w) || (d.add(w), f.get(w) ? f.get(w).forEach(function(T) {
              return d.add(T);
            }) : w.initialStateNodes.forEach(function(T) {
              return d.add(T);
            }));
          }
        } catch (T) {
          o = {
            error: T
          };
        } finally {
          try {
            b && !b.done && (s = E.return) && s.call(E);
          } finally {
            if (o)
              throw o.error;
          }
        }
    }
  } catch (O) {
    i = {
      error: O
    };
  } finally {
    try {
      g && !g.done && (a = y.return) && a.call(y);
    } finally {
      if (i)
        throw i.error;
    }
  }
  try {
    for (var _ = pt(d), A = _.next(); !A.done; A = _.next())
      for (var v = A.value, m = v.parent; m && !d.has(m); )
        d.add(m), m = m.parent;
  } catch (O) {
    u = {
      error: O
    };
  } finally {
    try {
      A && !A.done && (l = _.return) && l.call(_);
    } finally {
      if (u)
        throw u.error;
    }
  }
  return d;
}
function Ew(e, t) {
  var r = t.get(e);
  if (!r)
    return {};
  if (e.type === "compound") {
    var n = r[0];
    if (n) {
      if (Ju(n))
        return n.key;
    } else
      return {};
  }
  var i = {};
  return r.forEach(function(a) {
    i[a.key] = Ew(a, t);
  }), i;
}
function a0(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = pt(e), a = i.next(); !a.done; a = i.next()) {
      var o = a.value;
      n.has(o) || n.set(o, []), o.parent && (n.has(o.parent) || n.set(o.parent, []), n.get(o.parent).push(o));
    }
  } catch (s) {
    t = {
      error: s
    };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return n;
}
function h9(e, t) {
  var r = wo([e], t);
  return Ew(e, a0(r));
}
function So(e, t) {
  return Array.isArray(e) ? e.some(function(r) {
    return r === t;
  }) : e instanceof Set ? e.has(t) : !1;
}
function p9(e) {
  return ht([], Ke(new Set(mt(ht([], Ke(e.map(function(t) {
    return t.ownEvents;
  })), !1)))), !1);
}
function yu(e, t) {
  return t.type === "compound" ? Go(t).some(function(r) {
    return r.type === "final" && So(e, r);
  }) : t.type === "parallel" ? Go(t).every(function(r) {
    return yu(e, r);
  }) : !1;
}
function v9(e) {
  return e === void 0 && (e = []), e.reduce(function(t, r) {
    return r.meta !== void 0 && (t[r.id] = r.meta), t;
  }, {});
}
function ky(e) {
  return new Set(mt(e.map(function(t) {
    return t.tags;
  })));
}
function ww(e, t) {
  if (e === t)
    return !0;
  if (e === void 0 || t === void 0)
    return !1;
  if (Ue(e) || Ue(t))
    return e === t;
  var r = Object.keys(e), n = Object.keys(t);
  return r.length === n.length && r.every(function(i) {
    return ww(e[i], t[i]);
  });
}
function Yie(e) {
  return typeof e != "object" || e === null ? !1 : "value" in e && "_event" in e;
}
function Vie(e, t) {
  var r = e.exec, n = ue(ue({}, e), {
    exec: r !== void 0 ? function() {
      return r(t.context, t.event, {
        action: e,
        state: t,
        _event: t._event
      });
    } : void 0
  });
  return n;
}
var Mn = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this, n;
      this.actions = [], this.activities = Ay, this.meta = {}, this.events = [], this.value = t.value, this.context = t.context, this._event = t._event, this._sessionid = t._sessionid, this.event = this._event.data, this.historyValue = t.historyValue, this.history = t.history, this.actions = t.actions || [], this.activities = t.activities || Ay, this.meta = v9(t.configuration), this.events = t.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = t.configuration, this.transitions = t.transitions, this.children = t.children, this.done = !!t.done, this.tags = (n = Array.isArray(t.tags) ? new Set(t.tags) : t.tags) !== null && n !== void 0 ? n : /* @__PURE__ */ new Set(), this.machine = t.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return p9(r.configuration);
        }
      });
    }
    return e.from = function(t, r) {
      if (t instanceof e)
        return t.context !== r ? new e({
          value: t.value,
          context: r,
          _event: t._event,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          actions: [],
          activities: t.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : t;
      var n = n0;
      return new e({
        value: t,
        context: r,
        _event: n,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, e.create = function(t) {
      return new e(t);
    }, e.inert = function(t, r) {
      if (t instanceof e) {
        if (!t.actions.length)
          return t;
        var n = n0;
        return new e({
          value: t.value,
          context: r,
          _event: n,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          activities: t.activities,
          configuration: t.configuration,
          transitions: [],
          children: {}
        });
      }
      return e.from(t, r);
    }, e.prototype.toStrings = function(t, r) {
      var n = this;
      if (t === void 0 && (t = this.value), r === void 0 && (r = "."), Ue(t))
        return [t];
      var i = Object.keys(t);
      return i.concat.apply(i, ht([], Ke(i.map(function(a) {
        return n.toStrings(t[a], r).map(function(o) {
          return a + r + o;
        });
      })), !1));
    }, e.prototype.toJSON = function() {
      var t = this;
      t.configuration, t.transitions;
      var r = t.tags;
      t.machine;
      var n = Wh(t, ["configuration", "transitions", "tags", "machine"]);
      return ue(ue({}, n), {
        tags: Array.from(r)
      });
    }, e.prototype.matches = function(t) {
      return Yh(t, this.value);
    }, e.prototype.hasTag = function(t) {
      return this.tags.has(t);
    }, e.prototype.can = function(t) {
      var r;
      pr && En(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
      var n = (r = this.machine) === null || r === void 0 ? void 0 : r.getTransitionData(this, t);
      return !!(n != null && n.transitions.length) && // Check that at least one transition is not forbidden
      n.transitions.some(function(i) {
        return i.target !== void 0 || i.actions.length;
      });
    }, e;
  }()
);
function m9(e) {
  if (typeof e == "string") {
    var t = {
      type: e
    };
    return t.toString = function() {
      return e;
    }, t;
  }
  return e;
}
function Gs(e) {
  return ue(ue({
    type: e0
  }, e), {
    toJSON: function() {
      e.onDone, e.onError;
      var t = Wh(e, ["onDone", "onError"]);
      return ue(ue({}, t), {
        type: e0,
        src: m9(e.src)
      });
    }
  });
}
var oa = "", o0 = "#", po = "*", ra = {}, na = function(e) {
  return e[0] === o0;
}, y9 = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
}, g9 = function(e, t, r) {
  var n = r.slice(0, -1).some(function(a) {
    return !("cond" in a) && !("in" in a) && (Ue(a.target) || qo(a.target));
  }), i = t === oa ? "the transient event" : "event '".concat(t, "'");
  En(!n, "One or more transitions for ".concat(i, " on state '").concat(e.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
}, x9 = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r, n, i) {
      n === void 0 && (n = "context" in t ? t.context : void 0);
      var a = this, o;
      this.config = t, this._context = n, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(y9(), r), this.parent = i == null ? void 0 : i.parent, this.key = this.config.key || (i == null ? void 0 : i.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : fw), this.id = this.config.id || ht([this.machine.key], Ke(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (o = this.config.schema) !== null && o !== void 0 ? o : {}, this.description = this.config.description, pr || En(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead.")), this.initial = this.config.initial, this.states = this.config.states ? Eo(this.config.states, function(l, c) {
        var f, d = new e(l, {}, void 0, {
          parent: a,
          key: c
        });
        return Object.assign(a.idMap, ue((f = {}, f[d.id] = d, f), d.idMap)), d;
      }) : ra;
      var s = 0;
      function u(l) {
        var c, f;
        l.order = s++;
        try {
          for (var d = pt(xw(l)), h = d.next(); !h.done; h = d.next()) {
            var p = h.value;
            u(p);
          }
        } catch (v) {
          c = {
            error: v
          };
        } finally {
          try {
            h && !h.done && (f = d.return) && f.call(d);
          } finally {
            if (c)
              throw c.error;
          }
        }
      }
      u(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(l) {
        var c = l.event;
        return c === oa;
      }) : oa in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = Ar(this.config.entry || this.config.onEntry).map(function(l) {
        return Vo(l);
      }), this.onExit = Ar(this.config.exit || this.config.onExit).map(function(l) {
        return Vo(l);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = Ar(this.config.invoke).map(function(l, c) {
        var f, d;
        if (qo(l)) {
          var h = Ys(a.id, c);
          return a.machine.options.services = ue((f = {}, f[h] = l, f), a.machine.options.services), Gs({
            src: h,
            id: h
          });
        } else if (Ue(l.src)) {
          var h = l.id || Ys(a.id, c);
          return Gs(ue(ue({}, l), {
            id: h,
            src: l.src
          }));
        } else if (qo(l.src) || st(l.src)) {
          var h = l.id || Ys(a.id, c);
          return a.machine.options.services = ue((d = {}, d[h] = l.src, d), a.machine.options.services), Gs(ue(ue({
            id: h
          }, l), {
            src: h
          }));
        } else {
          var p = l.src;
          return Gs(ue(ue({
            id: Ys(a.id, c)
          }, l), {
            src: p
          }));
        }
      }), this.activities = Ar(this.config.activities).concat(this.invoke).map(function(l) {
        return Kh(l);
      }), this.transition = this.transition.bind(this), this.tags = Ar(this.config.tags);
    }
    return e.prototype._init = function() {
      this.__cache.transitions || bw(this).forEach(function(t) {
        return t.on;
      });
    }, e.prototype.withConfig = function(t, r) {
      var n = this.options, i = n.actions, a = n.activities, o = n.guards, s = n.services, u = n.delays;
      return new e(this.config, {
        actions: ue(ue({}, i), t.actions),
        activities: ue(ue({}, a), t.activities),
        guards: ue(ue({}, o), t.guards),
        services: ue(ue({}, s), t.services),
        delays: ue(ue({}, u), t.delays)
      }, r ?? this.context);
    }, e.prototype.withContext = function(t) {
      return new e(this.config, this.options, t);
    }, Object.defineProperty(e.prototype, "context", {
      get: function() {
        return st(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: Eo(this.states, function(t) {
            return t.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(e.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var t = this.transitions;
        return this.__cache.on = t.reduce(function(r, n) {
          return r[n.eventType] = r[n.eventType] || [], r[n.eventType].push(n), r;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getCandidates = function(t) {
      if (this.__cache.candidates[t])
        return this.__cache.candidates[t];
      var r = t === oa, n = this.transitions.filter(function(i) {
        var a = i.eventType === t;
        return r ? a : a || i.eventType === po;
      });
      return this.__cache.candidates[t] = n, n;
    }, e.prototype.getDelayedTransitions = function() {
      var t = this, r = this.config.after;
      if (!r)
        return [];
      var n = function(a, o) {
        var s = st(a) ? "".concat(t.id, ":delay[").concat(o, "]") : a, u = a9(s, t.id);
        return t.onEntry.push(X5(u, {
          delay: a
        })), t.onExit.push(e9(u)), u;
      }, i = bs(r) ? r.map(function(a, o) {
        var s = n(a.delay, o);
        return ue(ue({}, a), {
          event: s
        });
      }) : mt(Object.keys(r).map(function(a, o) {
        var s = r[a], u = Ue(s) ? {
          target: s
        } : s, l = isNaN(+a) ? a : +a, c = n(l, o);
        return Ar(u).map(function(f) {
          return ue(ue({}, f), {
            event: c,
            delay: l
          });
        });
      }));
      return i.map(function(a) {
        var o = a.delay;
        return ue(ue({}, t.formatTransition(a)), {
          delay: o
        });
      });
    }, e.prototype.getStateNodes = function(t) {
      var r, n = this;
      if (!t)
        return [];
      var i = t instanceof Mn ? t.value : Do(t, this.delimiter);
      if (Ue(i)) {
        var a = this.getStateNode(i).initial;
        return a !== void 0 ? this.getStateNodes((r = {}, r[i] = a, r)) : [this, this.states[i]];
      }
      var o = Object.keys(i), s = [this];
      return s.push.apply(s, ht([], Ke(mt(o.map(function(u) {
        return n.getStateNode(u).getStateNodes(i[u]);
      }))), !1)), s;
    }, e.prototype.handles = function(t) {
      var r = dw(t);
      return this.events.includes(r);
    }, e.prototype.resolveState = function(t) {
      var r = t instanceof Mn ? t : Mn.create(t), n = Array.from(wo([], this.getStateNodes(r.value)));
      return new Mn(ue(ue({}, r), {
        value: this.resolve(r.value),
        configuration: n,
        done: yu(n, this),
        tags: ky(n),
        machine: this.machine
      }));
    }, e.prototype.transitionLeafNode = function(t, r, n) {
      var i = this.getStateNode(t), a = i.next(r, n);
      return !a || !a.transitions.length ? this.next(r, n) : a;
    }, e.prototype.transitionCompoundNode = function(t, r, n) {
      var i = Object.keys(t), a = this.getStateNode(i[0]), o = a._transition(t[i[0]], r, n);
      return !o || !o.transitions.length ? this.next(r, n) : o;
    }, e.prototype.transitionParallelNode = function(t, r, n) {
      var i, a, o = {};
      try {
        for (var s = pt(Object.keys(t)), u = s.next(); !u.done; u = s.next()) {
          var l = u.value, c = t[l];
          if (c) {
            var f = this.getStateNode(l), d = f._transition(c, r, n);
            d && (o[l] = d);
          }
        }
      } catch (x) {
        i = {
          error: x
        };
      } finally {
        try {
          u && !u.done && (a = s.return) && a.call(s);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var h = Object.keys(o).map(function(x) {
        return o[x];
      }), p = mt(h.map(function(x) {
        return x.transitions;
      })), v = h.some(function(x) {
        return x.transitions.length > 0;
      });
      if (!v)
        return this.next(r, n);
      var m = mt(Object.keys(o).map(function(x) {
        return o[x].configuration;
      }));
      return {
        transitions: p,
        exitSet: mt(h.map(function(x) {
          return x.exitSet;
        })),
        configuration: m,
        source: r,
        actions: mt(Object.keys(o).map(function(x) {
          return o[x].actions;
        }))
      };
    }, e.prototype._transition = function(t, r, n) {
      return Ue(t) ? this.transitionLeafNode(t, r, n) : Object.keys(t).length === 1 ? this.transitionCompoundNode(t, r, n) : this.transitionParallelNode(t, r, n);
    }, e.prototype.getTransitionData = function(t, r) {
      return this._transition(t.value, t, Yo(r));
    }, e.prototype.next = function(t, r) {
      var n, i, a = this, o = r.name, s = [], u = [], l;
      try {
        for (var c = pt(this.getCandidates(o)), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, h = d.cond, p = d.in, v = t.context, m = p ? Ue(p) && na(p) ? (
            // Check if in state by ID
            t.matches(Do(this.getStateNodeById(p).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            Yh(Do(p, this.delimiter), H5(this.path.slice(0, -2))(t.value))
          ) : !0, x = !1;
          try {
            x = !h || yw(this.machine, h, v, r, t);
          } catch (E) {
            throw new Error("Unable to evaluate guard '".concat(h.name || h.type, "' in transition for event '").concat(o, "' in state node '").concat(this.id, `':
`).concat(E.message));
          }
          if (x && m) {
            d.target !== void 0 && (u = d.target), s.push.apply(s, ht([], Ke(d.actions), !1)), l = d;
            break;
          }
        }
      } catch (E) {
        n = {
          error: E
        };
      } finally {
        try {
          f && !f.done && (i = c.return) && i.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      if (l) {
        if (!u.length)
          return {
            transitions: [l],
            exitSet: [],
            configuration: t.value ? [this] : [],
            source: t,
            actions: s
          };
        var y = mt(u.map(function(E) {
          return a.getRelativeStateNodes(E, t.historyValue);
        })), g = !!l.internal;
        return {
          transitions: [l],
          exitSet: g ? [] : mt(u.map(function(E) {
            return a.getPotentiallyReenteringNodes(E);
          })),
          configuration: y,
          source: t,
          actions: s
        };
      }
    }, e.prototype.getPotentiallyReenteringNodes = function(t) {
      if (this.order < t.order)
        return [this];
      for (var r = [], n = this, i = t; n && n !== i; )
        r.push(n), n = n.parent;
      return n !== i ? [] : (r.push(i), r);
    }, e.prototype.getActions = function(t, r, n, i, a, o, s) {
      var u, l, c, f, d = this, h = o ? wo([], this.getStateNodes(o.value)) : [], p = /* @__PURE__ */ new Set();
      try {
        for (var v = pt(Array.from(t).sort(function(C, $) {
          return C.order - $.order;
        })), m = v.next(); !m.done; m = v.next()) {
          var x = m.value;
          (!So(h, x) || So(n.exitSet, x) || x.parent && p.has(x.parent)) && p.add(x);
        }
      } catch (C) {
        u = {
          error: C
        };
      } finally {
        try {
          m && !m.done && (l = v.return) && l.call(v);
        } finally {
          if (u)
            throw u.error;
        }
      }
      try {
        for (var y = pt(h), g = y.next(); !g.done; g = y.next()) {
          var x = g.value;
          (!So(t, x) || So(n.exitSet, x.parent)) && n.exitSet.push(x);
        }
      } catch (C) {
        c = {
          error: C
        };
      } finally {
        try {
          g && !g.done && (f = y.return) && f.call(y);
        } finally {
          if (c)
            throw c.error;
        }
      }
      n.exitSet.sort(function(C, $) {
        return $.order - C.order;
      });
      var E = Array.from(p).sort(function(C, $) {
        return C.order - $.order;
      }), b = new Set(n.exitSet), w = mt(E.map(function(C) {
        var $ = [];
        if (C.type !== "final")
          return $;
        var P = C.parent;
        if (!P.parent)
          return $;
        $.push(
          Vs(C.id, C.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          Vs(P.id, C.doneData ? pw(C.doneData, i, a) : void 0)
        );
        var j = P.parent;
        return j.type === "parallel" && Go(j).every(function(W) {
          return yu(n.configuration, W);
        }) && $.push(Vs(j.id)), $;
      })), _ = E.map(function(C) {
        var $ = C.onEntry, P = C.activities.map(function(j) {
          return t9(j);
        });
        return {
          type: "entry",
          actions: bi(s ? ht(ht([], Ke($), !1), Ke(P), !1) : ht(ht([], Ke(P), !1), Ke($), !1), d.machine.options.actions)
        };
      }).concat({
        type: "state_done",
        actions: w.map(function(C) {
          return K5(C);
        })
      }), A = Array.from(b).map(function(C) {
        return {
          type: "exit",
          actions: bi(ht(ht([], Ke(C.onExit), !1), Ke(C.activities.map(function($) {
            return r9($);
          })), !1), d.machine.options.actions)
        };
      }), O = A.concat({
        type: "transition",
        actions: bi(n.actions, this.machine.options.actions)
      }).concat(_);
      if (r) {
        var T = bi(mt(ht([], Ke(t), !1).sort(function(C, $) {
          return $.order - C.order;
        }).map(function(C) {
          return C.onExit;
        })), this.machine.options.actions).filter(function(C) {
          return !Dy(C);
        });
        return O.concat({
          type: "stop",
          actions: T
        });
      }
      return O;
    }, e.prototype.transition = function(t, r, n, i) {
      t === void 0 && (t = this.initialState);
      var a = Yo(r), o;
      if (t instanceof Mn)
        o = n === void 0 ? t : this.resolveState(Mn.from(t, n));
      else {
        var s = Ue(t) ? this.resolve(Xu(this.getResolvedPath(t))) : this.resolve(t), u = n ?? this.machine.context;
        o = this.resolveState(Mn.from(s, u));
      }
      if (!pr && a.name === po)
        throw new Error("An event cannot have the wildcard type ('".concat(po, "')"));
      if (this.strict && !this.events.includes(a.name) && !z5(a.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(a.name, "'"));
      var l = this._transition(o.value, o, a) || {
        transitions: [],
        configuration: [],
        exitSet: [],
        source: o,
        actions: []
      }, c = wo([], this.getStateNodes(o.value)), f = l.configuration.length ? wo(c, l.configuration) : c;
      return l.configuration = ht([], Ke(f), !1), this.resolveTransition(l, o, o.context, i, a);
    }, e.prototype.resolveRaisedTransition = function(t, r, n, i) {
      var a, o = t.actions;
      return t = this.transition(t, r, void 0, i), t._event = n, t.event = n.data, (a = t.actions).unshift.apply(a, ht([], Ke(o), !1)), t;
    }, e.prototype.resolveTransition = function(t, r, n, i, a) {
      var o, s, u, l, c = this;
      a === void 0 && (a = n0);
      var f = t.configuration, d = !r || t.transitions.length > 0, h = d ? t.configuration : r ? r.configuration : [], p = yu(h, this), v = d ? h9(this.machine, f) : void 0, m = r ? r.historyValue ? r.historyValue : t.source ? this.machine.historyValue(r.value) : void 0 : void 0, x = this.getActions(new Set(h), p, t, n, a, r, i), y = r ? ue({}, r.activities) : {};
      try {
        for (var g = pt(x), E = g.next(); !E.done; E = g.next()) {
          var b = E.value;
          try {
            for (var w = (u = void 0, pt(b.actions)), _ = w.next(); !_.done; _ = w.next()) {
              var A = _.value;
              A.type === Ty ? y[A.activity.id || A.activity.type] = A : A.type === cw && (y[A.activity.id || A.activity.type] = !1);
            }
          } catch (F) {
            u = {
              error: F
            };
          } finally {
            try {
              _ && !_.done && (l = w.return) && l.call(w);
            } finally {
              if (u)
                throw u.error;
            }
          }
        }
      } catch (F) {
        o = {
          error: F
        };
      } finally {
        try {
          E && !E.done && (s = g.return) && s.call(g);
        } finally {
          if (o)
            throw o.error;
        }
      }
      var O = Ke(i0(this, r, n, a, x, i, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), T = O[0], C = O[1], $ = Ke(q5(T, Dy), 2), P = $[0], j = $[1], W = T.filter(function(F) {
        var X;
        return F.type === Ty && ((X = F.activity) === null || X === void 0 ? void 0 : X.type) === e0;
      }), Y = W.reduce(function(F, X) {
        return F[X.activity.id] = c9(X.activity, c.machine, C, a), F;
      }, r ? ue({}, r.children) : {}), V = new Mn({
        value: v || r.value,
        context: C,
        _event: a,
        // Persist _sessionid between states
        _sessionid: r ? r._sessionid : null,
        historyValue: v ? m ? Y5(m, v) : void 0 : r ? r.historyValue : void 0,
        history: !v || t.source ? r : void 0,
        actions: v ? j : [],
        activities: v ? y : r ? r.activities : {},
        events: [],
        configuration: h,
        transitions: t.transitions,
        children: Y,
        done: p,
        tags: ky(h),
        machine: this
      }), ce = n !== C;
      V.changed = a.name === M5 || ce;
      var de = V.history;
      de && delete de.history;
      var L = !p && (this._transient || f.some(function(F) {
        return F._transient;
      }));
      if (!d && (!L || a.name === oa))
        return V;
      var D = V;
      if (!p)
        for (L && (D = this.resolveRaisedTransition(D, {
          type: P5
        }, a, i)); P.length; ) {
          var N = P.shift();
          D = this.resolveRaisedTransition(D, N._event, a, i);
        }
      var B = D.changed || (de ? !!D.actions.length || ce || typeof de.value != typeof D.value || !ww(D.value, de.value) : void 0);
      return D.changed = B, D.history = de, D;
    }, e.prototype.getStateNode = function(t) {
      if (na(t))
        return this.machine.getStateNodeById(t);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(t, "' from '").concat(this.id, "'; no child states exist."));
      var r = this.states[t];
      if (!r)
        throw new Error("Child state '".concat(t, "' does not exist on '").concat(this.id, "'"));
      return r;
    }, e.prototype.getStateNodeById = function(t) {
      var r = na(t) ? t.slice(o0.length) : t;
      if (r === this.id)
        return this;
      var n = this.machine.idMap[r];
      if (!n)
        throw new Error("Child state node '#".concat(r, "' does not exist on machine '").concat(this.id, "'"));
      return n;
    }, e.prototype.getStateNodeByPath = function(t) {
      if (typeof t == "string" && na(t))
        try {
          return this.getStateNodeById(t.slice(1));
        } catch {
        }
      for (var r = r0(t, this.delimiter).slice(), n = this; r.length; ) {
        var i = r.shift();
        if (!i.length)
          break;
        n = n.getStateNode(i);
      }
      return n;
    }, e.prototype.resolve = function(t) {
      var r, n = this;
      if (!t)
        return this.initialStateValue || ra;
      switch (this.type) {
        case "parallel":
          return Eo(this.initialStateValue, function(a, o) {
            return a ? n.getStateNode(o).resolve(t[o] || a) : ra;
          });
        case "compound":
          if (Ue(t)) {
            var i = this.getStateNode(t);
            return i.type === "parallel" || i.type === "compound" ? (r = {}, r[t] = i.initialStateValue, r) : t;
          }
          return Object.keys(t).length ? Eo(t, function(a, o) {
            return a ? n.getStateNode(o).resolve(a) : ra;
          }) : this.initialStateValue || {};
        default:
          return t || ra;
      }
    }, e.prototype.getResolvedPath = function(t) {
      if (na(t)) {
        var r = this.machine.idMap[t.slice(o0.length)];
        if (!r)
          throw new Error("Unable to find state node '".concat(t, "'"));
        return r.path;
      }
      return r0(t, this.delimiter);
    }, Object.defineProperty(e.prototype, "initialStateValue", {
      get: function() {
        var t;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var r;
        if (this.type === "parallel")
          r = Cy(this.states, function(n) {
            return n.initialStateValue || ra;
          }, function(n) {
            return n.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          r = Ju(this.states[this.initial]) ? this.initial : (t = {}, t[this.initial] = this.states[this.initial].initialStateValue, t);
        } else
          r = {};
        return this.__cache.initialStateValue = r, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getInitialState = function(t, r) {
      this._init();
      var n = this.getStateNodes(t);
      return this.resolveTransition({
        configuration: n,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, r ?? this.machine.context, void 0);
    }, Object.defineProperty(e.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var t = this.initialStateValue;
        if (!t)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var t;
        if (this.type === "history") {
          var r = this.config;
          Ue(r.target) ? t = na(r.target) ? Xu(this.machine.getStateNodeById(r.target).path.slice(this.path.length - 1)) : r.target : t = r.target;
        }
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getRelativeStateNodes = function(t, r, n) {
      return n === void 0 && (n = !0), n ? t.type === "history" ? t.resolveHistory(r) : t.initialStateNodes : [t];
    }, Object.defineProperty(e.prototype, "initialStateNodes", {
      get: function() {
        var t = this;
        if (Ju(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return pr || En(!1, "Compound state node '".concat(this.id, "' has no initial state.")), [this];
        var r = mu(this.initialStateValue);
        return mt(r.map(function(n) {
          return t.getFromRelativePath(n);
        }));
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getFromRelativePath = function(t) {
      if (!t.length)
        return [this];
      var r = Ke(t), n = r[0], i = r.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(n, "' from node with no states"));
      var a = this.getStateNode(n);
      if (a.type === "history")
        return a.resolveHistory();
      if (!this.states[n])
        throw new Error("Child state '".concat(n, "' does not exist on '").concat(this.id, "'"));
      return this.states[n].getFromRelativePath(i);
    }, e.prototype.historyValue = function(t) {
      if (Object.keys(this.states).length)
        return {
          current: t || this.initialStateValue,
          states: Cy(this.states, function(r, n) {
            if (!t)
              return r.historyValue();
            var i = Ue(t) ? void 0 : t[n];
            return r.historyValue(i || r.initialStateValue);
          }, function(r) {
            return !r.history;
          })
        };
    }, e.prototype.resolveHistory = function(t) {
      var r = this;
      if (this.type !== "history")
        return [this];
      var n = this.parent;
      if (!t) {
        var i = this.target;
        return i ? mt(mu(i).map(function(o) {
          return n.getFromRelativePath(o);
        })) : n.initialStateNodes;
      }
      var a = W5(n.path, "states")(t).current;
      return Ue(a) ? [n.getStateNode(a)] : mt(mu(a).map(function(o) {
        return r.history === "deep" ? n.getFromRelativePath(o) : [n.states[o[0]]];
      }));
    }, Object.defineProperty(e.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var t = this, r = mt(Object.keys(this.states).map(function(n) {
          return t.states[n].stateIds;
        }));
        return [this.id].concat(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var t, r, n, i;
        if (this.__cache.events)
          return this.__cache.events;
        var a = this.states, o = new Set(this.ownEvents);
        if (a)
          try {
            for (var s = pt(Object.keys(a)), u = s.next(); !u.done; u = s.next()) {
              var l = u.value, c = a[l];
              if (c.states)
                try {
                  for (var f = (n = void 0, pt(c.events)), d = f.next(); !d.done; d = f.next()) {
                    var h = d.value;
                    o.add("".concat(h));
                  }
                } catch (p) {
                  n = {
                    error: p
                  };
                } finally {
                  try {
                    d && !d.done && (i = f.return) && i.call(f);
                  } finally {
                    if (n)
                      throw n.error;
                  }
                }
            }
          } catch (p) {
            t = {
              error: p
            };
          } finally {
            try {
              u && !u.done && (r = s.return) && r.call(s);
            } finally {
              if (t)
                throw t.error;
            }
          }
        return this.__cache.events = Array.from(o);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var t = new Set(this.transitions.filter(function(r) {
          return !(!r.target && !r.actions.length && r.internal);
        }).map(function(r) {
          return r.eventType;
        }));
        return Array.from(t);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolveTarget = function(t) {
      var r = this;
      if (t !== void 0)
        return t.map(function(n) {
          if (!Ue(n))
            return n;
          var i = n[0] === r.delimiter;
          if (i && !r.parent)
            return r.getStateNodeByPath(n.slice(1));
          var a = i ? r.key + n : n;
          if (r.parent)
            try {
              var o = r.parent.getStateNodeByPath(a);
              return o;
            } catch (s) {
              throw new Error("Invalid transition definition for state node '".concat(r.id, `':
`).concat(s.message));
            }
          else
            return r.getStateNodeByPath(a);
        });
    }, e.prototype.formatTransition = function(t) {
      var r = this, n = V5(t.target), i = "internal" in t ? t.internal : n ? n.some(function(u) {
        return Ue(u) && u[0] === r.delimiter;
      }) : !0, a = this.machine.options.guards, o = this.resolveTarget(n), s = ue(ue({}, t), {
        actions: bi(Ar(t.actions)),
        cond: mw(t.cond, a),
        target: o,
        source: this,
        internal: i,
        eventType: t.event,
        toJSON: function() {
          return ue(ue({}, s), {
            target: s.target ? s.target.map(function(u) {
              return "#".concat(u.id);
            }) : void 0,
            source: "#".concat(r.id)
          });
        }
      });
      return s;
    }, e.prototype.formatTransitions = function() {
      var t, r, n = this, i;
      if (!this.config.on)
        i = [];
      else if (Array.isArray(this.config.on))
        i = this.config.on;
      else {
        var a = this.config.on, o = po, s = a[o], u = s === void 0 ? [] : s, l = Wh(a, [typeof o == "symbol" ? o : o + ""]);
        i = mt(Object.keys(l).map(function(y) {
          !pr && y === oa && En(!1, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(n.id, '".'));
          var g = ta(y, l[y]);
          return pr || g9(n, y, g), g;
        }).concat(ta(po, u)));
      }
      var c = this.config.always ? ta("", this.config.always) : [], f = this.config.onDone ? ta(String(Vs(this.id)), this.config.onDone) : [];
      pr || En(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
      var d = mt(this.invoke.map(function(y) {
        var g = [];
        return y.onDone && g.push.apply(g, ht([], Ke(ta(String(o9(y.id)), y.onDone)), !1)), y.onError && g.push.apply(g, ht([], Ke(ta(String(s9(y.id)), y.onError)), !1)), g;
      })), h = this.after, p = mt(ht(ht(ht(ht([], Ke(f), !1), Ke(d), !1), Ke(i), !1), Ke(c), !1).map(function(y) {
        return Ar(y).map(function(g) {
          return n.formatTransition(g);
        });
      }));
      try {
        for (var v = pt(h), m = v.next(); !m.done; m = v.next()) {
          var x = m.value;
          p.push(x);
        }
      } catch (y) {
        t = {
          error: y
        };
      } finally {
        try {
          m && !m.done && (r = v.return) && r.call(v);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return p;
    }, e;
  }()
), Ny = !1;
function b9(e, t) {
  return !pr && !("predictableActionArguments" in e) && !Ny && (Ny = !0, console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html")), new x9(e, t);
}
var zr = i9;
function E9() {
  this.__data__ = [], this.size = 0;
}
var w9 = E9;
function S9(e, t) {
  return e === t || e !== e && t !== t;
}
var cc = S9, _9 = cc;
function T9(e, t) {
  for (var r = e.length; r--; )
    if (_9(e[r][0], t))
      return r;
  return -1;
}
var fc = T9, A9 = fc, C9 = Array.prototype, O9 = C9.splice;
function D9(e) {
  var t = this.__data__, r = A9(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : O9.call(t, r, 1), --this.size, !0;
}
var F9 = D9, I9 = fc;
function k9(e) {
  var t = this.__data__, r = I9(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var N9 = k9, P9 = fc;
function $9(e) {
  return P9(this.__data__, e) > -1;
}
var R9 = $9, M9 = fc;
function B9(e, t) {
  var r = this.__data__, n = M9(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var j9 = B9, L9 = w9, U9 = F9, H9 = N9, W9 = R9, z9 = j9;
function Wa(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Wa.prototype.clear = L9;
Wa.prototype.delete = U9;
Wa.prototype.get = H9;
Wa.prototype.has = W9;
Wa.prototype.set = z9;
var dc = Wa, q9 = dc;
function Y9() {
  this.__data__ = new q9(), this.size = 0;
}
var V9 = Y9;
function G9(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var K9 = G9;
function Q9(e) {
  return this.__data__.get(e);
}
var X9 = Q9;
function J9(e) {
  return this.__data__.has(e);
}
var Z9 = J9, ej = typeof he == "object" && he && he.Object === Object && he, Sw = ej, tj = Sw, rj = typeof self == "object" && self && self.Object === Object && self, nj = tj || rj || Function("return this")(), fn = nj, ij = fn, aj = ij.Symbol, za = aj, Py = za, _w = Object.prototype, oj = _w.hasOwnProperty, sj = _w.toString, vo = Py ? Py.toStringTag : void 0;
function uj(e) {
  var t = oj.call(e, vo), r = e[vo];
  try {
    e[vo] = void 0;
    var n = !0;
  } catch {
  }
  var i = sj.call(e);
  return n && (t ? e[vo] = r : delete e[vo]), i;
}
var lj = uj, cj = Object.prototype, fj = cj.toString;
function dj(e) {
  return fj.call(e);
}
var hj = dj, $y = za, pj = lj, vj = hj, mj = "[object Null]", yj = "[object Undefined]", Ry = $y ? $y.toStringTag : void 0;
function gj(e) {
  return e == null ? e === void 0 ? yj : mj : Ry && Ry in Object(e) ? pj(e) : vj(e);
}
var qa = gj;
function xj(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ai = xj, bj = qa, Ej = ai, wj = "[object AsyncFunction]", Sj = "[object Function]", _j = "[object GeneratorFunction]", Tj = "[object Proxy]";
function Aj(e) {
  if (!Ej(e))
    return !1;
  var t = bj(e);
  return t == Sj || t == _j || t == wj || t == Tj;
}
var Tw = Aj, Cj = fn, Oj = Cj["__core-js_shared__"], Dj = Oj, Kf = Dj, My = function() {
  var e = /[^.]+$/.exec(Kf && Kf.keys && Kf.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Fj(e) {
  return !!My && My in e;
}
var Ij = Fj, kj = Function.prototype, Nj = kj.toString;
function Pj(e) {
  if (e != null) {
    try {
      return Nj.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Aw = Pj, $j = Tw, Rj = Ij, Mj = ai, Bj = Aw, jj = /[\\^$.*+?()[\]{}|]/g, Lj = /^\[object .+?Constructor\]$/, Uj = Function.prototype, Hj = Object.prototype, Wj = Uj.toString, zj = Hj.hasOwnProperty, qj = RegExp(
  "^" + Wj.call(zj).replace(jj, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Yj(e) {
  if (!Mj(e) || Rj(e))
    return !1;
  var t = $j(e) ? qj : Lj;
  return t.test(Bj(e));
}
var Vj = Yj;
function Gj(e, t) {
  return e == null ? void 0 : e[t];
}
var Kj = Gj, Qj = Vj, Xj = Kj;
function Jj(e, t) {
  var r = Xj(e, t);
  return Qj(r) ? r : void 0;
}
var Wi = Jj, Zj = Wi, e7 = fn, t7 = Zj(e7, "Map"), Qh = t7, r7 = Wi, n7 = r7(Object, "create"), hc = n7, By = hc;
function i7() {
  this.__data__ = By ? By(null) : {}, this.size = 0;
}
var a7 = i7;
function o7(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var s7 = o7, u7 = hc, l7 = "__lodash_hash_undefined__", c7 = Object.prototype, f7 = c7.hasOwnProperty;
function d7(e) {
  var t = this.__data__;
  if (u7) {
    var r = t[e];
    return r === l7 ? void 0 : r;
  }
  return f7.call(t, e) ? t[e] : void 0;
}
var h7 = d7, p7 = hc, v7 = Object.prototype, m7 = v7.hasOwnProperty;
function y7(e) {
  var t = this.__data__;
  return p7 ? t[e] !== void 0 : m7.call(t, e);
}
var g7 = y7, x7 = hc, b7 = "__lodash_hash_undefined__";
function E7(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = x7 && t === void 0 ? b7 : t, this;
}
var w7 = E7, S7 = a7, _7 = s7, T7 = h7, A7 = g7, C7 = w7;
function Ya(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ya.prototype.clear = S7;
Ya.prototype.delete = _7;
Ya.prototype.get = T7;
Ya.prototype.has = A7;
Ya.prototype.set = C7;
var O7 = Ya, jy = O7, D7 = dc, F7 = Qh;
function I7() {
  this.size = 0, this.__data__ = {
    hash: new jy(),
    map: new (F7 || D7)(),
    string: new jy()
  };
}
var k7 = I7;
function N7(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var P7 = N7, $7 = P7;
function R7(e, t) {
  var r = e.__data__;
  return $7(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var pc = R7, M7 = pc;
function B7(e) {
  var t = M7(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var j7 = B7, L7 = pc;
function U7(e) {
  return L7(this, e).get(e);
}
var H7 = U7, W7 = pc;
function z7(e) {
  return W7(this, e).has(e);
}
var q7 = z7, Y7 = pc;
function V7(e, t) {
  var r = Y7(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var G7 = V7, K7 = k7, Q7 = j7, X7 = H7, J7 = q7, Z7 = G7;
function Va(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Va.prototype.clear = K7;
Va.prototype.delete = Q7;
Va.prototype.get = X7;
Va.prototype.has = J7;
Va.prototype.set = Z7;
var Xh = Va, eL = dc, tL = Qh, rL = Xh, nL = 200;
function iL(e, t) {
  var r = this.__data__;
  if (r instanceof eL) {
    var n = r.__data__;
    if (!tL || n.length < nL - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new rL(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var aL = iL, oL = dc, sL = V9, uL = K9, lL = X9, cL = Z9, fL = aL;
function Ga(e) {
  var t = this.__data__ = new oL(e);
  this.size = t.size;
}
Ga.prototype.clear = sL;
Ga.prototype.delete = uL;
Ga.prototype.get = lL;
Ga.prototype.has = cL;
Ga.prototype.set = fL;
var Jh = Ga, dL = "__lodash_hash_undefined__";
function hL(e) {
  return this.__data__.set(e, dL), this;
}
var pL = hL;
function vL(e) {
  return this.__data__.has(e);
}
var mL = vL, yL = Xh, gL = pL, xL = mL;
function Zu(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new yL(); ++t < r; )
    this.add(e[t]);
}
Zu.prototype.add = Zu.prototype.push = gL;
Zu.prototype.has = xL;
var bL = Zu;
function EL(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var wL = EL;
function SL(e, t) {
  return e.has(t);
}
var _L = SL, TL = bL, AL = wL, CL = _L, OL = 1, DL = 2;
function FL(e, t, r, n, i, a) {
  var o = r & OL, s = e.length, u = t.length;
  if (s != u && !(o && u > s))
    return !1;
  var l = a.get(e), c = a.get(t);
  if (l && c)
    return l == t && c == e;
  var f = -1, d = !0, h = r & DL ? new TL() : void 0;
  for (a.set(e, t), a.set(t, e); ++f < s; ) {
    var p = e[f], v = t[f];
    if (n)
      var m = o ? n(v, p, f, t, e, a) : n(p, v, f, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      d = !1;
      break;
    }
    if (h) {
      if (!AL(t, function(x, y) {
        if (!CL(h, y) && (p === x || i(p, x, r, n, a)))
          return h.push(y);
      })) {
        d = !1;
        break;
      }
    } else if (!(p === v || i(p, v, r, n, a))) {
      d = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), d;
}
var Cw = FL, IL = fn, kL = IL.Uint8Array, Ow = kL;
function NL(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
var PL = NL;
function $L(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var RL = $L, Ly = za, Uy = Ow, ML = cc, BL = Cw, jL = PL, LL = RL, UL = 1, HL = 2, WL = "[object Boolean]", zL = "[object Date]", qL = "[object Error]", YL = "[object Map]", VL = "[object Number]", GL = "[object RegExp]", KL = "[object Set]", QL = "[object String]", XL = "[object Symbol]", JL = "[object ArrayBuffer]", ZL = "[object DataView]", Hy = Ly ? Ly.prototype : void 0, Qf = Hy ? Hy.valueOf : void 0;
function eU(e, t, r, n, i, a, o) {
  switch (r) {
    case ZL:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case JL:
      return !(e.byteLength != t.byteLength || !a(new Uy(e), new Uy(t)));
    case WL:
    case zL:
    case VL:
      return ML(+e, +t);
    case qL:
      return e.name == t.name && e.message == t.message;
    case GL:
    case QL:
      return e == t + "";
    case YL:
      var s = jL;
    case KL:
      var u = n & UL;
      if (s || (s = LL), e.size != t.size && !u)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= HL, o.set(e, t);
      var c = BL(s(e), s(t), n, i, a, o);
      return o.delete(e), c;
    case XL:
      if (Qf)
        return Qf.call(e) == Qf.call(t);
  }
  return !1;
}
var tU = eU;
function rU(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var Zh = rU, nU = Array.isArray, gr = nU, iU = Zh, aU = gr;
function oU(e, t, r) {
  var n = t(e);
  return aU(e) ? n : iU(n, r(e));
}
var Dw = oU;
function sU(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, a = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (a[i++] = o);
  }
  return a;
}
var uU = sU;
function lU() {
  return [];
}
var Fw = lU, cU = uU, fU = Fw, dU = Object.prototype, hU = dU.propertyIsEnumerable, Wy = Object.getOwnPropertySymbols, pU = Wy ? function(e) {
  return e == null ? [] : (e = Object(e), cU(Wy(e), function(t) {
    return hU.call(e, t);
  }));
} : fU, ep = pU;
function vU(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var mU = vU;
function yU(e) {
  return e != null && typeof e == "object";
}
var oi = yU, gU = qa, xU = oi, bU = "[object Arguments]";
function EU(e) {
  return xU(e) && gU(e) == bU;
}
var wU = EU, zy = wU, SU = oi, Iw = Object.prototype, _U = Iw.hasOwnProperty, TU = Iw.propertyIsEnumerable, AU = zy(function() {
  return arguments;
}()) ? zy : function(e) {
  return SU(e) && _U.call(e, "callee") && !TU.call(e, "callee");
}, tp = AU, el = { exports: {} };
function CU() {
  return !1;
}
var OU = CU;
el.exports;
(function(e, t) {
  var r = fn, n = OU, i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, u = s ? s.isBuffer : void 0, l = u || n;
  e.exports = l;
})(el, el.exports);
var rp = el.exports, DU = 9007199254740991, FU = /^(?:0|[1-9]\d*)$/;
function IU(e, t) {
  var r = typeof e;
  return t = t ?? DU, !!t && (r == "number" || r != "symbol" && FU.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var np = IU, kU = 9007199254740991;
function NU(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= kU;
}
var ip = NU, PU = qa, $U = ip, RU = oi, MU = "[object Arguments]", BU = "[object Array]", jU = "[object Boolean]", LU = "[object Date]", UU = "[object Error]", HU = "[object Function]", WU = "[object Map]", zU = "[object Number]", qU = "[object Object]", YU = "[object RegExp]", VU = "[object Set]", GU = "[object String]", KU = "[object WeakMap]", QU = "[object ArrayBuffer]", XU = "[object DataView]", JU = "[object Float32Array]", ZU = "[object Float64Array]", eH = "[object Int8Array]", tH = "[object Int16Array]", rH = "[object Int32Array]", nH = "[object Uint8Array]", iH = "[object Uint8ClampedArray]", aH = "[object Uint16Array]", oH = "[object Uint32Array]", it = {};
it[JU] = it[ZU] = it[eH] = it[tH] = it[rH] = it[nH] = it[iH] = it[aH] = it[oH] = !0;
it[MU] = it[BU] = it[QU] = it[jU] = it[XU] = it[LU] = it[UU] = it[HU] = it[WU] = it[zU] = it[qU] = it[YU] = it[VU] = it[GU] = it[KU] = !1;
function sH(e) {
  return RU(e) && $U(e.length) && !!it[PU(e)];
}
var uH = sH;
function lH(e) {
  return function(t) {
    return e(t);
  };
}
var vc = lH, tl = { exports: {} };
tl.exports;
(function(e, t) {
  var r = Sw, n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, a = i && i.exports === n, o = a && r.process, s = function() {
    try {
      var u = i && i.require && i.require("util").types;
      return u || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(tl, tl.exports);
var ap = tl.exports, cH = uH, fH = vc, qy = ap, Yy = qy && qy.isTypedArray, dH = Yy ? fH(Yy) : cH, kw = dH, hH = mU, pH = tp, vH = gr, mH = rp, yH = np, gH = kw, xH = Object.prototype, bH = xH.hasOwnProperty;
function EH(e, t) {
  var r = vH(e), n = !r && pH(e), i = !r && !n && mH(e), a = !r && !n && !i && gH(e), o = r || n || i || a, s = o ? hH(e.length, String) : [], u = s.length;
  for (var l in e)
    (t || bH.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    yH(l, u))) && s.push(l);
  return s;
}
var Nw = EH, wH = Object.prototype;
function SH(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || wH;
  return e === r;
}
var op = SH;
function _H(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Pw = _H, TH = Pw, AH = TH(Object.keys, Object), CH = AH, OH = op, DH = CH, FH = Object.prototype, IH = FH.hasOwnProperty;
function kH(e) {
  if (!OH(e))
    return DH(e);
  var t = [];
  for (var r in Object(e))
    IH.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var NH = kH, PH = Tw, $H = ip;
function RH(e) {
  return e != null && $H(e.length) && !PH(e);
}
var Es = RH, MH = Nw, BH = NH, jH = Es;
function LH(e) {
  return jH(e) ? MH(e) : BH(e);
}
var ws = LH, UH = Dw, HH = ep, WH = ws;
function zH(e) {
  return UH(e, WH, HH);
}
var $w = zH, Vy = $w, qH = 1, YH = Object.prototype, VH = YH.hasOwnProperty;
function GH(e, t, r, n, i, a) {
  var o = r & qH, s = Vy(e), u = s.length, l = Vy(t), c = l.length;
  if (u != c && !o)
    return !1;
  for (var f = u; f--; ) {
    var d = s[f];
    if (!(o ? d in t : VH.call(t, d)))
      return !1;
  }
  var h = a.get(e), p = a.get(t);
  if (h && p)
    return h == t && p == e;
  var v = !0;
  a.set(e, t), a.set(t, e);
  for (var m = o; ++f < u; ) {
    d = s[f];
    var x = e[d], y = t[d];
    if (n)
      var g = o ? n(y, x, d, t, e, a) : n(x, y, d, e, t, a);
    if (!(g === void 0 ? x === y || i(x, y, r, n, a) : g)) {
      v = !1;
      break;
    }
    m || (m = d == "constructor");
  }
  if (v && !m) {
    var E = e.constructor, b = t.constructor;
    E != b && "constructor" in e && "constructor" in t && !(typeof E == "function" && E instanceof E && typeof b == "function" && b instanceof b) && (v = !1);
  }
  return a.delete(e), a.delete(t), v;
}
var KH = GH, QH = Wi, XH = fn, JH = QH(XH, "DataView"), ZH = JH, eW = Wi, tW = fn, rW = eW(tW, "Promise"), nW = rW, iW = Wi, aW = fn, oW = iW(aW, "Set"), sW = oW, uW = Wi, lW = fn, cW = uW(lW, "WeakMap"), fW = cW, s0 = ZH, u0 = Qh, l0 = nW, c0 = sW, f0 = fW, Rw = qa, Ka = Aw, Gy = "[object Map]", dW = "[object Object]", Ky = "[object Promise]", Qy = "[object Set]", Xy = "[object WeakMap]", Jy = "[object DataView]", hW = Ka(s0), pW = Ka(u0), vW = Ka(l0), mW = Ka(c0), yW = Ka(f0), vi = Rw;
(s0 && vi(new s0(new ArrayBuffer(1))) != Jy || u0 && vi(new u0()) != Gy || l0 && vi(l0.resolve()) != Ky || c0 && vi(new c0()) != Qy || f0 && vi(new f0()) != Xy) && (vi = function(e) {
  var t = Rw(e), r = t == dW ? e.constructor : void 0, n = r ? Ka(r) : "";
  if (n)
    switch (n) {
      case hW:
        return Jy;
      case pW:
        return Gy;
      case vW:
        return Ky;
      case mW:
        return Qy;
      case yW:
        return Xy;
    }
  return t;
});
var mc = vi, Xf = Jh, gW = Cw, xW = tU, bW = KH, Zy = mc, eg = gr, tg = rp, EW = kw, wW = 1, rg = "[object Arguments]", ng = "[object Array]", Ks = "[object Object]", SW = Object.prototype, ig = SW.hasOwnProperty;
function _W(e, t, r, n, i, a) {
  var o = eg(e), s = eg(t), u = o ? ng : Zy(e), l = s ? ng : Zy(t);
  u = u == rg ? Ks : u, l = l == rg ? Ks : l;
  var c = u == Ks, f = l == Ks, d = u == l;
  if (d && tg(e)) {
    if (!tg(t))
      return !1;
    o = !0, c = !1;
  }
  if (d && !c)
    return a || (a = new Xf()), o || EW(e) ? gW(e, t, r, n, i, a) : xW(e, t, u, r, n, i, a);
  if (!(r & wW)) {
    var h = c && ig.call(e, "__wrapped__"), p = f && ig.call(t, "__wrapped__");
    if (h || p) {
      var v = h ? e.value() : e, m = p ? t.value() : t;
      return a || (a = new Xf()), i(v, m, r, n, a);
    }
  }
  return d ? (a || (a = new Xf()), bW(e, t, r, n, i, a)) : !1;
}
var TW = _W, AW = TW, ag = oi;
function Mw(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !ag(e) && !ag(t) ? e !== e && t !== t : AW(e, t, r, n, Mw, i);
}
var Bw = Mw, CW = Jh, OW = Bw, DW = 1, FW = 2;
function IW(e, t, r, n) {
  var i = r.length, a = i, o = !n;
  if (e == null)
    return !a;
  for (e = Object(e); i--; ) {
    var s = r[i];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < a; ) {
    s = r[i];
    var u = s[0], l = e[u], c = s[1];
    if (o && s[2]) {
      if (l === void 0 && !(u in e))
        return !1;
    } else {
      var f = new CW();
      if (n)
        var d = n(l, c, u, e, t, f);
      if (!(d === void 0 ? OW(c, l, DW | FW, n, f) : d))
        return !1;
    }
  }
  return !0;
}
var kW = IW, NW = ai;
function PW(e) {
  return e === e && !NW(e);
}
var jw = PW, $W = jw, RW = ws;
function MW(e) {
  for (var t = RW(e), r = t.length; r--; ) {
    var n = t[r], i = e[n];
    t[r] = [n, i, $W(i)];
  }
  return t;
}
var BW = MW;
function jW(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var Lw = jW, LW = kW, UW = BW, HW = Lw;
function WW(e) {
  var t = UW(e);
  return t.length == 1 && t[0][2] ? HW(t[0][0], t[0][1]) : function(r) {
    return r === e || LW(r, e, t);
  };
}
var zW = WW, qW = qa, YW = oi, VW = "[object Symbol]";
function GW(e) {
  return typeof e == "symbol" || YW(e) && qW(e) == VW;
}
var Ss = GW, KW = gr, QW = Ss, XW = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, JW = /^\w*$/;
function ZW(e, t) {
  if (KW(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || QW(e) ? !0 : JW.test(e) || !XW.test(e) || t != null && e in Object(t);
}
var sp = ZW, Uw = Xh, ez = "Expected a function";
function up(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(ez);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], a = r.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, n);
    return r.cache = a.set(i, o) || a, o;
  };
  return r.cache = new (up.Cache || Uw)(), r;
}
up.Cache = Uw;
var tz = up, rz = tz, nz = 500;
function iz(e) {
  var t = rz(e, function(n) {
    return r.size === nz && r.clear(), n;
  }), r = t.cache;
  return t;
}
var az = iz, oz = az, sz = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, uz = /\\(\\)?/g, lz = oz(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(sz, function(r, n, i, a) {
    t.push(i ? a.replace(uz, "$1") : n || r);
  }), t;
}), cz = lz;
function fz(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var yc = fz, og = za, dz = yc, hz = gr, pz = Ss, vz = 1 / 0, sg = og ? og.prototype : void 0, ug = sg ? sg.toString : void 0;
function Hw(e) {
  if (typeof e == "string")
    return e;
  if (hz(e))
    return dz(e, Hw) + "";
  if (pz(e))
    return ug ? ug.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -vz ? "-0" : t;
}
var mz = Hw, yz = mz;
function gz(e) {
  return e == null ? "" : yz(e);
}
var Ww = gz, xz = gr, bz = sp, Ez = cz, wz = Ww;
function Sz(e, t) {
  return xz(e) ? e : bz(e, t) ? [e] : Ez(wz(e));
}
var gc = Sz, _z = Ss, Tz = 1 / 0;
function Az(e) {
  if (typeof e == "string" || _z(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Tz ? "-0" : t;
}
var _s = Az, Cz = gc, Oz = _s;
function Dz(e, t) {
  t = Cz(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Oz(t[r++])];
  return r && r == n ? e : void 0;
}
var xc = Dz, Fz = xc;
function Iz(e, t, r) {
  var n = e == null ? void 0 : Fz(e, t);
  return n === void 0 ? r : n;
}
var kz = Iz;
function Nz(e, t) {
  return e != null && t in Object(e);
}
var Pz = Nz, $z = gc, Rz = tp, Mz = gr, Bz = np, jz = ip, Lz = _s;
function Uz(e, t, r) {
  t = $z(t, e);
  for (var n = -1, i = t.length, a = !1; ++n < i; ) {
    var o = Lz(t[n]);
    if (!(a = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return a || ++n != i ? a : (i = e == null ? 0 : e.length, !!i && jz(i) && Bz(o, i) && (Mz(e) || Rz(e)));
}
var Hz = Uz, Wz = Pz, zz = Hz;
function qz(e, t) {
  return e != null && zz(e, t, Wz);
}
var Yz = qz, Vz = Bw, Gz = kz, Kz = Yz, Qz = sp, Xz = jw, Jz = Lw, Zz = _s, eq = 1, tq = 2;
function rq(e, t) {
  return Qz(e) && Xz(t) ? Jz(Zz(e), t) : function(r) {
    var n = Gz(r, e);
    return n === void 0 && n === t ? Kz(r, e) : Vz(t, n, eq | tq);
  };
}
var nq = rq;
function iq(e) {
  return e;
}
var Ts = iq;
function aq(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var oq = aq, sq = xc;
function uq(e) {
  return function(t) {
    return sq(t, e);
  };
}
var lq = uq, cq = oq, fq = lq, dq = sp, hq = _s;
function pq(e) {
  return dq(e) ? cq(hq(e)) : fq(e);
}
var vq = pq, mq = zW, yq = nq, gq = Ts, xq = gr, bq = vq;
function Eq(e) {
  return typeof e == "function" ? e : e == null ? gq : typeof e == "object" ? xq(e) ? yq(e[0], e[1]) : mq(e) : bq(e);
}
var zw = Eq, wq = /\s/;
function Sq(e) {
  for (var t = e.length; t-- && wq.test(e.charAt(t)); )
    ;
  return t;
}
var _q = Sq, Tq = _q, Aq = /^\s+/;
function Cq(e) {
  return e && e.slice(0, Tq(e) + 1).replace(Aq, "");
}
var Oq = Cq, Dq = Oq, lg = ai, Fq = Ss, cg = 0 / 0, Iq = /^[-+]0x[0-9a-f]+$/i, kq = /^0b[01]+$/i, Nq = /^0o[0-7]+$/i, Pq = parseInt;
function $q(e) {
  if (typeof e == "number")
    return e;
  if (Fq(e))
    return cg;
  if (lg(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = lg(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Dq(e);
  var r = kq.test(e);
  return r || Nq.test(e) ? Pq(e.slice(2), r ? 2 : 8) : Iq.test(e) ? cg : +e;
}
var Rq = $q, fg = za, Mq = tp, Bq = gr, dg = fg ? fg.isConcatSpreadable : void 0;
function jq(e) {
  return Bq(e) || Mq(e) || !!(dg && e && e[dg]);
}
var Lq = jq, Uq = Zh, Hq = Lq;
function qw(e, t, r, n, i) {
  var a = -1, o = e.length;
  for (r || (r = Hq), i || (i = []); ++a < o; ) {
    var s = e[a];
    t > 0 && r(s) ? t > 1 ? qw(s, t - 1, r, n, i) : Uq(i, s) : n || (i[i.length] = s);
  }
  return i;
}
var Yw = qw;
function Wq(e) {
  return function(t, r, n) {
    for (var i = -1, a = Object(t), o = n(t), s = o.length; s--; ) {
      var u = o[e ? s : ++i];
      if (r(a[u], u, a) === !1)
        break;
    }
    return t;
  };
}
var zq = Wq, qq = zq, Yq = qq(), Vq = Yq, Gq = Vq, Kq = ws;
function Qq(e, t) {
  return e && Gq(e, t, Kq);
}
var Xq = Qq, Jq = Es;
function Zq(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Jq(r))
      return e(r, n);
    for (var i = r.length, a = t ? i : -1, o = Object(r); (t ? a-- : ++a < i) && n(o[a], a, o) !== !1; )
      ;
    return r;
  };
}
var eY = Zq, tY = Xq, rY = eY, nY = rY(tY), iY = nY, aY = iY, oY = Es;
function sY(e, t) {
  var r = -1, n = oY(e) ? Array(e.length) : [];
  return aY(e, function(i, a, o) {
    n[++r] = t(i, a, o);
  }), n;
}
var Vw = sY;
function uY(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var lY = uY, hg = Ss;
function cY(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, i = e === e, a = hg(e), o = t !== void 0, s = t === null, u = t === t, l = hg(t);
    if (!s && !l && !a && e > t || a && o && u && !s && !l || n && o && u || !r && u || !i)
      return 1;
    if (!n && !a && !l && e < t || l && r && i && !n && !a || s && r && i || !o && i || !u)
      return -1;
  }
  return 0;
}
var fY = cY, dY = fY;
function hY(e, t, r) {
  for (var n = -1, i = e.criteria, a = t.criteria, o = i.length, s = r.length; ++n < o; ) {
    var u = dY(i[n], a[n]);
    if (u) {
      if (n >= s)
        return u;
      var l = r[n];
      return u * (l == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var pY = hY, Jf = yc, vY = xc, mY = zw, yY = Vw, gY = lY, xY = vc, bY = pY, EY = Ts, wY = gr;
function SY(e, t, r) {
  t.length ? t = Jf(t, function(a) {
    return wY(a) ? function(o) {
      return vY(o, a.length === 1 ? a[0] : a);
    } : a;
  }) : t = [EY];
  var n = -1;
  t = Jf(t, xY(mY));
  var i = yY(e, function(a, o, s) {
    var u = Jf(t, function(l) {
      return l(a);
    });
    return { criteria: u, index: ++n, value: a };
  });
  return gY(i, function(a, o) {
    return bY(a, o, r);
  });
}
var _Y = SY;
function TY(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var AY = TY, CY = AY, pg = Math.max;
function OY(e, t, r) {
  return t = pg(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, i = -1, a = pg(n.length - t, 0), o = Array(a); ++i < a; )
      o[i] = n[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = n[i];
    return s[t] = r(o), CY(e, this, s);
  };
}
var Gw = OY;
function DY(e) {
  return function() {
    return e;
  };
}
var FY = DY, IY = Wi, kY = function() {
  try {
    var e = IY(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Kw = kY, NY = FY, vg = Kw, PY = Ts, $Y = vg ? function(e, t) {
  return vg(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: NY(t),
    writable: !0
  });
} : PY, RY = $Y, MY = 800, BY = 16, jY = Date.now;
function LY(e) {
  var t = 0, r = 0;
  return function() {
    var n = jY(), i = BY - (n - r);
    if (r = n, i > 0) {
      if (++t >= MY)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var UY = LY, HY = RY, WY = UY, zY = WY(HY), Qw = zY, qY = Ts, YY = Gw, VY = Qw;
function GY(e, t) {
  return VY(YY(e, t, qY), e + "");
}
var Xw = GY, KY = cc, QY = Es, XY = np, JY = ai;
function ZY(e, t, r) {
  if (!JY(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? QY(r) && XY(t, r.length) : n == "string" && t in r) ? KY(r[t], e) : !1;
}
var eV = ZY, tV = Yw, rV = _Y, nV = Xw, mg = eV, iV = nV(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && mg(e, t[0], t[1]) ? t = [] : r > 2 && mg(t[0], t[1], t[2]) && (t = [t[0]]), rV(e, tV(t, 1), []);
}), aV = iV;
const Gie = /* @__PURE__ */ Nt(aV), Kie = b9(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QDsAOsB0BLCAbMAxAGICiAKgMIASA2gAwC6ioqA9rFgC5avLMgAPRAEYAbMIwBmaZICssuqIBMADnGyAnABoQATxFKA7BgAshpUroLZS4So0BfBzrSYAZmE4BjABZZkUADKAK4ATgBuYLoEELxg2MjhrADW8a4YHt5+ASERUQj+SV4Ahty89AwV-GwcZXxIgogmoipSdLZKspImJnQmGmI6+gjCPaYaExqSwhoqsqJ0hpJOLugZnr7+QWGR0WChoayhGKi4pW5HALYY6ZmbOTv5hawldRVVDTVcPPWgQgjNVqSdrCTrdXr9QZ6RAqEwYQwKOh0OSiQx0YR0WYrEDpWBgfBeTiBLxHQiBEgAGRIFDIAH1AhQAPIAJRIHxY7G+vH4-zUEjkJlsshMNgmnSGIhMElEMtEwsFJkkSimSiczhxrAgcH4rmqnLqPMQAFpRBKECaMEirdbraNsekcPg9bUfoaAUozaDjBpzJYNIqlNJhHZ7Ws7tltnlhhyXdyGv8jJIMBoWoZRBpZMJJCplRnPX0MKJs2purNRWnQ5hYI9dABVZDFcLFLBnABGTs++td8cQRe9Zg0qlR2dUkjNKgkYhlaLT4lhshUlYweIJRJJoTAzq5v0aCFRomT-pUwPasjRUs9gowU9RMx69hUiyXK7AhOZYGKsDjMe3boxkg0UwxBnVQrDBS8lGvWVDDvEwHzVBwgA */
    id: "nps",
    predictableActionArguments: !0,
    tsTypes: {},
    schema: {
      context: {},
      events: {},
      services: {}
    },
    on: {
      SET_SURVEY_ID: {
        actions: ["setSurveyId"]
      },
      SET_CLIENT_ID: {
        actions: ["setClientId"]
      },
      SET_MDN: {
        actions: ["setMdn"]
      },
      SET_SCORE_QUESTION_ID: {
        actions: ["setScoreQuestionId"]
      }
    },
    context: {
      surveyId: "",
      clientId: "",
      mdn: "",
      reasons: {
        PROMOTER: {
          questionId: "",
          description: "",
          reasons: []
        },
        PASSIVE: {
          questionId: "",
          description: "",
          reasons: []
        },
        DETRACTOR: {
          questionId: "",
          description: "",
          reasons: []
        }
      },
      scoreQuestionId: "",
      score: null,
      customerCategory: null,
      selectedReasons: [],
      surveyResult: null,
      errors: null
    },
    initial: "idle",
    states: {
      idle: {
        on: {
          FETCH: { target: "fetchingSurvey" }
        }
      },
      fetchingSurvey: {
        tags: ["loading"],
        invoke: {
          src: "getSurvey",
          onDone: { target: "selectScore", actions: ["setReasonsPerCategory"] },
          onError: {
            target: "surveyUnavailable"
          }
        }
      },
      surveyUnavailable: {
        type: "final"
      },
      selectScore: {
        on: {
          SET_SCORE: {
            actions: ["setScore", "setCustomerCategory"]
          },
          SUBMIT_SCORE: {
            target: "selectReason"
          }
        }
      },
      selectReason: {
        on: {
          UPDATE_REASONS: {
            actions: ["setReasons"]
          },
          SUBMIT_NPS: "submittingSurvey"
        }
      },
      submittingSurvey: {
        tags: ["loading"],
        invoke: {
          src: "submitSurvey",
          onDone: {
            target: "surveySubmitted",
            actions: "setSurveyResult"
          },
          onError: {
            target: "selectReason",
            actions: "setError"
          }
        }
      },
      surveySubmitted: {
        type: "final"
      }
    }
  },
  {
    actions: {
      setSurveyId: zr({
        surveyId: (e, t) => t.id
      }),
      setClientId: zr({
        clientId: (e, t) => t.id
      }),
      setMdn: zr({
        mdn: (e, t) => t.mdn
      }),
      setScoreQuestionId: zr({
        scoreQuestionId: (e, t) => t.id
      }),
      setReasonsPerCategory: zr({
        reasons: (e, t) => t.data
      }),
      setCustomerCategory: zr({
        customerCategory: (e, { score: t }) => t > 8 ? "PROMOTER" : t > 6 ? "PASSIVE" : t !== null ? "DETRACTOR" : null
      }),
      setScore: zr({
        score: (e, t) => t.score
      }),
      setReasons: zr({
        selectedReasons: (e, t) => t.selectedReasons
      }),
      setSurveyResult: zr({
        surveyResult: (e, t) => t.data
      }),
      setError: zr({
        errors: (e, t) => t.data.message || t.data.response.data || "Unknown error occured"
      })
    }
  }
);
var Jw = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n();
  })(he, function() {
    function r(l, c) {
      return typeof c > "u" ? c = { autoBom: !1 } : typeof c != "object" && (console.warn("Deprecated: Expected third argument to be a object"), c = { autoBom: !c }), c.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(l.type) ? new Blob(["\uFEFF", l], { type: l.type }) : l;
    }
    function n(l, c, f) {
      var d = new XMLHttpRequest();
      d.open("GET", l), d.responseType = "blob", d.onload = function() {
        u(d.response, c, f);
      }, d.onerror = function() {
        console.error("could not download file");
      }, d.send();
    }
    function i(l) {
      var c = new XMLHttpRequest();
      c.open("HEAD", l, !1);
      try {
        c.send();
      } catch {
      }
      return 200 <= c.status && 299 >= c.status;
    }
    function a(l) {
      try {
        l.dispatchEvent(new MouseEvent("click"));
      } catch {
        var c = document.createEvent("MouseEvents");
        c.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), l.dispatchEvent(c);
      }
    }
    var o = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof he == "object" && he.global === he ? he : void 0, s = o.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), u = o.saveAs || (typeof window != "object" || window !== o ? function() {
    } : "download" in HTMLAnchorElement.prototype && !s ? function(l, c, f) {
      var d = o.URL || o.webkitURL, h = document.createElement("a");
      c = c || l.name || "download", h.download = c, h.rel = "noopener", typeof l == "string" ? (h.href = l, h.origin === location.origin ? a(h) : i(h.href) ? n(l, c, f) : a(h, h.target = "_blank")) : (h.href = d.createObjectURL(l), setTimeout(function() {
        d.revokeObjectURL(h.href);
      }, 4e4), setTimeout(function() {
        a(h);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(l, c, f) {
      if (c = c || l.name || "download", typeof l != "string")
        navigator.msSaveOrOpenBlob(r(l, f), c);
      else if (i(l))
        n(l, c, f);
      else {
        var d = document.createElement("a");
        d.href = l, d.target = "_blank", setTimeout(function() {
          a(d);
        });
      }
    } : function(l, c, f, d) {
      if (d = d || open("", "_blank"), d && (d.document.title = d.document.body.innerText = "downloading..."), typeof l == "string")
        return n(l, c, f);
      var h = l.type === "application/octet-stream", p = /constructor/i.test(o.HTMLElement) || o.safari, v = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((v || h && p || s) && typeof FileReader < "u") {
        var m = new FileReader();
        m.onloadend = function() {
          var g = m.result;
          g = v ? g : g.replace(/^data:[^;]*;/, "data:attachment/file;"), d ? d.location.href = g : location = g, d = null;
        }, m.readAsDataURL(l);
      } else {
        var x = o.URL || o.webkitURL, y = x.createObjectURL(l);
        d ? d.location = y : location.href = y, d = null, setTimeout(function() {
          x.revokeObjectURL(y);
        }, 4e4);
      }
    });
    o.saveAs = u.saveAs = u, e.exports = u;
  });
})(Jw);
var Qie = Jw.exports;
const d0 = ({ children: e }) => /* @__PURE__ */ S.jsx(S.Fragment, { children: e ?? /* @__PURE__ */ S.jsxs(Mp, { children: [
  /* @__PURE__ */ S.jsx(Qi, { children: /* @__PURE__ */ S.jsx(Ce, { fontSize: "md", children: /* @__PURE__ */ S.jsx(
    _t,
    {
      text: "At least 10 characters long",
      translationKey: "ChangePassword/password-requirements-rule-1"
    }
  ) }) }),
  /* @__PURE__ */ S.jsxs(Qi, { children: [
    /* @__PURE__ */ S.jsx(Ce, { fontSize: "md", children: /* @__PURE__ */ S.jsx(
      _t,
      {
        text: "Must contain a combination of 4 out of 4 of the following attributes:",
        translationKey: "ChangePassword/password-requirements-rule-header"
      }
    ) }),
    /* @__PURE__ */ S.jsxs(Mp, { children: [
      /* @__PURE__ */ S.jsx(Qi, { children: /* @__PURE__ */ S.jsx(Ce, { fontSize: "md", children: /* @__PURE__ */ S.jsx(
        _t,
        {
          text: "At least one uppercase letter (A-Z)",
          translationKey: "ChangePassword/password-requirements-rule-2"
        }
      ) }) }),
      /* @__PURE__ */ S.jsx(Qi, { children: /* @__PURE__ */ S.jsx(Ce, { fontSize: "md", children: /* @__PURE__ */ S.jsx(
        _t,
        {
          text: "At least one lowercase letter (a-z)",
          translationKey: "ChangePassword/password-requirements-rule-3"
        }
      ) }) }),
      /* @__PURE__ */ S.jsx(Qi, { children: /* @__PURE__ */ S.jsx(Ce, { fontSize: "md", children: /* @__PURE__ */ S.jsx(
        _t,
        {
          text: "At least one special character (!@#$%&*)",
          translationKey: "ChangePassword/password-requirements-rule-4"
        }
      ) }) }),
      /* @__PURE__ */ S.jsx(Qi, { children: /* @__PURE__ */ S.jsx(Ce, { fontSize: "md", children: /* @__PURE__ */ S.jsx(
        _t,
        {
          text: "At least one numeric character (0-9)",
          translationKey: "ChangePassword/password-requirements-rule-5"
        }
      ) }) })
    ] })
  ] })
] }) });
var oV = function(t) {
  return sV(t) && !uV(t);
};
function sV(e) {
  return !!e && typeof e == "object";
}
function uV(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || fV(e);
}
var lV = typeof Symbol == "function" && Symbol.for, cV = lV ? Symbol.for("react.element") : 60103;
function fV(e) {
  return e.$$typeof === cV;
}
function dV(e) {
  return Array.isArray(e) ? [] : {};
}
function rl(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Ko(dV(e), e, t) : e;
}
function hV(e, t, r) {
  return e.concat(t).map(function(n) {
    return rl(n, r);
  });
}
function pV(e, t, r) {
  var n = {};
  return r.isMergeableObject(e) && Object.keys(e).forEach(function(i) {
    n[i] = rl(e[i], r);
  }), Object.keys(t).forEach(function(i) {
    !r.isMergeableObject(t[i]) || !e[i] ? n[i] = rl(t[i], r) : n[i] = Ko(e[i], t[i], r);
  }), n;
}
function Ko(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || hV, r.isMergeableObject = r.isMergeableObject || oV;
  var n = Array.isArray(t), i = Array.isArray(e), a = n === i;
  return a ? n ? r.arrayMerge(e, t, r) : pV(e, t, r) : rl(t, r);
}
Ko.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, i) {
    return Ko(n, i, r);
  }, {});
};
var h0 = Ko, vV = typeof global == "object" && global && global.Object === Object && global;
const Zw = vV;
var mV = typeof self == "object" && self && self.Object === Object && self, yV = Zw || mV || Function("return this")();
const dn = yV;
var gV = dn.Symbol;
const ti = gV;
var eS = Object.prototype, xV = eS.hasOwnProperty, bV = eS.toString, mo = ti ? ti.toStringTag : void 0;
function EV(e) {
  var t = xV.call(e, mo), r = e[mo];
  try {
    e[mo] = void 0;
    var n = !0;
  } catch {
  }
  var i = bV.call(e);
  return n && (t ? e[mo] = r : delete e[mo]), i;
}
var wV = Object.prototype, SV = wV.toString;
function _V(e) {
  return SV.call(e);
}
var TV = "[object Null]", AV = "[object Undefined]", yg = ti ? ti.toStringTag : void 0;
function zi(e) {
  return e == null ? e === void 0 ? AV : TV : yg && yg in Object(e) ? EV(e) : _V(e);
}
function tS(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var CV = tS(Object.getPrototypeOf, Object);
const lp = CV;
function qi(e) {
  return e != null && typeof e == "object";
}
var OV = "[object Object]", DV = Function.prototype, FV = Object.prototype, rS = DV.toString, IV = FV.hasOwnProperty, kV = rS.call(Object);
function gg(e) {
  if (!qi(e) || zi(e) != OV)
    return !1;
  var t = lp(e);
  if (t === null)
    return !0;
  var r = IV.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && rS.call(r) == kV;
}
var xg = Array.isArray, bg = Object.keys, NV = Object.prototype.hasOwnProperty, PV = typeof Element < "u";
function p0(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    var r = xg(e), n = xg(t), i, a, o;
    if (r && n) {
      if (a = e.length, a != t.length)
        return !1;
      for (i = a; i-- !== 0; )
        if (!p0(e[i], t[i]))
          return !1;
      return !0;
    }
    if (r != n)
      return !1;
    var s = e instanceof Date, u = t instanceof Date;
    if (s != u)
      return !1;
    if (s && u)
      return e.getTime() == t.getTime();
    var l = e instanceof RegExp, c = t instanceof RegExp;
    if (l != c)
      return !1;
    if (l && c)
      return e.toString() == t.toString();
    var f = bg(e);
    if (a = f.length, a !== bg(t).length)
      return !1;
    for (i = a; i-- !== 0; )
      if (!NV.call(t, f[i]))
        return !1;
    if (PV && e instanceof Element && t instanceof Element)
      return e === t;
    for (i = a; i-- !== 0; )
      if (o = f[i], !(o === "_owner" && e.$$typeof) && !p0(e[o], t[o]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var $V = function(t, r) {
  try {
    return p0(t, r);
  } catch (n) {
    if (n.message && n.message.match(/stack|recursion/i) || n.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", n.name, n.message), !1;
    throw n;
  }
};
const mi = /* @__PURE__ */ Nt($V);
var RV = process.env.NODE_ENV === "production";
function Mt(e, t) {
  if (!RV) {
    if (e)
      return;
    var r = "Warning: " + t;
    typeof console < "u" && console.warn(r);
    try {
      throw Error(r);
    } catch {
    }
  }
}
function MV() {
  this.__data__ = [], this.size = 0;
}
function nS(e, t) {
  return e === t || e !== e && t !== t;
}
function bc(e, t) {
  for (var r = e.length; r--; )
    if (nS(e[r][0], t))
      return r;
  return -1;
}
var BV = Array.prototype, jV = BV.splice;
function LV(e) {
  var t = this.__data__, r = bc(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : jV.call(t, r, 1), --this.size, !0;
}
function UV(e) {
  var t = this.__data__, r = bc(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function HV(e) {
  return bc(this.__data__, e) > -1;
}
function WV(e, t) {
  var r = this.__data__, n = bc(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Dn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Dn.prototype.clear = MV;
Dn.prototype.delete = LV;
Dn.prototype.get = UV;
Dn.prototype.has = HV;
Dn.prototype.set = WV;
function zV() {
  this.__data__ = new Dn(), this.size = 0;
}
function qV(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function YV(e) {
  return this.__data__.get(e);
}
function VV(e) {
  return this.__data__.has(e);
}
function As(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var GV = "[object AsyncFunction]", KV = "[object Function]", QV = "[object GeneratorFunction]", XV = "[object Proxy]";
function iS(e) {
  if (!As(e))
    return !1;
  var t = zi(e);
  return t == KV || t == QV || t == GV || t == XV;
}
var JV = dn["__core-js_shared__"];
const Zf = JV;
var Eg = function() {
  var e = /[^.]+$/.exec(Zf && Zf.keys && Zf.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ZV(e) {
  return !!Eg && Eg in e;
}
var eG = Function.prototype, tG = eG.toString;
function Yi(e) {
  if (e != null) {
    try {
      return tG.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var rG = /[\\^$.*+?()[\]{}|]/g, nG = /^\[object .+?Constructor\]$/, iG = Function.prototype, aG = Object.prototype, oG = iG.toString, sG = aG.hasOwnProperty, uG = RegExp(
  "^" + oG.call(sG).replace(rG, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function lG(e) {
  if (!As(e) || ZV(e))
    return !1;
  var t = iS(e) ? uG : nG;
  return t.test(Yi(e));
}
function cG(e, t) {
  return e == null ? void 0 : e[t];
}
function Vi(e, t) {
  var r = cG(e, t);
  return lG(r) ? r : void 0;
}
var fG = Vi(dn, "Map");
const Qo = fG;
var dG = Vi(Object, "create");
const Xo = dG;
function hG() {
  this.__data__ = Xo ? Xo(null) : {}, this.size = 0;
}
function pG(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var vG = "__lodash_hash_undefined__", mG = Object.prototype, yG = mG.hasOwnProperty;
function gG(e) {
  var t = this.__data__;
  if (Xo) {
    var r = t[e];
    return r === vG ? void 0 : r;
  }
  return yG.call(t, e) ? t[e] : void 0;
}
var xG = Object.prototype, bG = xG.hasOwnProperty;
function EG(e) {
  var t = this.__data__;
  return Xo ? t[e] !== void 0 : bG.call(t, e);
}
var wG = "__lodash_hash_undefined__";
function SG(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Xo && t === void 0 ? wG : t, this;
}
function Bi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Bi.prototype.clear = hG;
Bi.prototype.delete = pG;
Bi.prototype.get = gG;
Bi.prototype.has = EG;
Bi.prototype.set = SG;
function _G() {
  this.size = 0, this.__data__ = {
    hash: new Bi(),
    map: new (Qo || Dn)(),
    string: new Bi()
  };
}
function TG(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ec(e, t) {
  var r = e.__data__;
  return TG(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function AG(e) {
  var t = Ec(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function CG(e) {
  return Ec(this, e).get(e);
}
function OG(e) {
  return Ec(this, e).has(e);
}
function DG(e, t) {
  var r = Ec(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function si(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
si.prototype.clear = _G;
si.prototype.delete = AG;
si.prototype.get = CG;
si.prototype.has = OG;
si.prototype.set = DG;
var FG = 200;
function IG(e, t) {
  var r = this.__data__;
  if (r instanceof Dn) {
    var n = r.__data__;
    if (!Qo || n.length < FG - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new si(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Qa(e) {
  var t = this.__data__ = new Dn(e);
  this.size = t.size;
}
Qa.prototype.clear = zV;
Qa.prototype.delete = qV;
Qa.prototype.get = YV;
Qa.prototype.has = VV;
Qa.prototype.set = IG;
function kG(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var NG = function() {
  try {
    var e = Vi(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const wg = NG;
function aS(e, t, r) {
  t == "__proto__" && wg ? wg(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var PG = Object.prototype, $G = PG.hasOwnProperty;
function oS(e, t, r) {
  var n = e[t];
  (!($G.call(e, t) && nS(n, r)) || r === void 0 && !(t in e)) && aS(e, t, r);
}
function wc(e, t, r, n) {
  var i = !r;
  r || (r = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var s = t[a], u = n ? n(r[s], e[s], s, r, e) : void 0;
    u === void 0 && (u = e[s]), i ? aS(r, s, u) : oS(r, s, u);
  }
  return r;
}
function RG(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var MG = "[object Arguments]";
function Sg(e) {
  return qi(e) && zi(e) == MG;
}
var sS = Object.prototype, BG = sS.hasOwnProperty, jG = sS.propertyIsEnumerable, LG = Sg(function() {
  return arguments;
}()) ? Sg : function(e) {
  return qi(e) && BG.call(e, "callee") && !jG.call(e, "callee");
};
const UG = LG;
var HG = Array.isArray;
const Cs = HG;
function WG() {
  return !1;
}
var uS = typeof exports == "object" && exports && !exports.nodeType && exports, _g = uS && typeof module == "object" && module && !module.nodeType && module, zG = _g && _g.exports === uS, Tg = zG ? dn.Buffer : void 0, qG = Tg ? Tg.isBuffer : void 0, YG = qG || WG;
const lS = YG;
var VG = 9007199254740991, GG = /^(?:0|[1-9]\d*)$/;
function KG(e, t) {
  var r = typeof e;
  return t = t ?? VG, !!t && (r == "number" || r != "symbol" && GG.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var QG = 9007199254740991;
function cS(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= QG;
}
var XG = "[object Arguments]", JG = "[object Array]", ZG = "[object Boolean]", eK = "[object Date]", tK = "[object Error]", rK = "[object Function]", nK = "[object Map]", iK = "[object Number]", aK = "[object Object]", oK = "[object RegExp]", sK = "[object Set]", uK = "[object String]", lK = "[object WeakMap]", cK = "[object ArrayBuffer]", fK = "[object DataView]", dK = "[object Float32Array]", hK = "[object Float64Array]", pK = "[object Int8Array]", vK = "[object Int16Array]", mK = "[object Int32Array]", yK = "[object Uint8Array]", gK = "[object Uint8ClampedArray]", xK = "[object Uint16Array]", bK = "[object Uint32Array]", at = {};
at[dK] = at[hK] = at[pK] = at[vK] = at[mK] = at[yK] = at[gK] = at[xK] = at[bK] = !0;
at[XG] = at[JG] = at[cK] = at[ZG] = at[fK] = at[eK] = at[tK] = at[rK] = at[nK] = at[iK] = at[aK] = at[oK] = at[sK] = at[uK] = at[lK] = !1;
function EK(e) {
  return qi(e) && cS(e.length) && !!at[zi(e)];
}
function cp(e) {
  return function(t) {
    return e(t);
  };
}
var fS = typeof exports == "object" && exports && !exports.nodeType && exports, Fo = fS && typeof module == "object" && module && !module.nodeType && module, wK = Fo && Fo.exports === fS, ed = wK && Zw.process, SK = function() {
  try {
    var e = Fo && Fo.require && Fo.require("util").types;
    return e || ed && ed.binding && ed.binding("util");
  } catch {
  }
}();
const Da = SK;
var Ag = Da && Da.isTypedArray, _K = Ag ? cp(Ag) : EK;
const TK = _K;
var AK = Object.prototype, CK = AK.hasOwnProperty;
function dS(e, t) {
  var r = Cs(e), n = !r && UG(e), i = !r && !n && lS(e), a = !r && !n && !i && TK(e), o = r || n || i || a, s = o ? RG(e.length, String) : [], u = s.length;
  for (var l in e)
    (t || CK.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    KG(l, u))) && s.push(l);
  return s;
}
var OK = Object.prototype;
function fp(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || OK;
  return e === r;
}
var DK = tS(Object.keys, Object);
const FK = DK;
var IK = Object.prototype, kK = IK.hasOwnProperty;
function NK(e) {
  if (!fp(e))
    return FK(e);
  var t = [];
  for (var r in Object(e))
    kK.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function hS(e) {
  return e != null && cS(e.length) && !iS(e);
}
function dp(e) {
  return hS(e) ? dS(e) : NK(e);
}
function PK(e, t) {
  return e && wc(t, dp(t), e);
}
function $K(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var RK = Object.prototype, MK = RK.hasOwnProperty;
function BK(e) {
  if (!As(e))
    return $K(e);
  var t = fp(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !MK.call(e, n)) || r.push(n);
  return r;
}
function hp(e) {
  return hS(e) ? dS(e, !0) : BK(e);
}
function jK(e, t) {
  return e && wc(t, hp(t), e);
}
var pS = typeof exports == "object" && exports && !exports.nodeType && exports, Cg = pS && typeof module == "object" && module && !module.nodeType && module, LK = Cg && Cg.exports === pS, Og = LK ? dn.Buffer : void 0, Dg = Og ? Og.allocUnsafe : void 0;
function UK(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = Dg ? Dg(r) : new e.constructor(r);
  return e.copy(n), n;
}
function vS(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
function HK(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, a = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (a[i++] = o);
  }
  return a;
}
function mS() {
  return [];
}
var WK = Object.prototype, zK = WK.propertyIsEnumerable, Fg = Object.getOwnPropertySymbols, qK = Fg ? function(e) {
  return e == null ? [] : (e = Object(e), HK(Fg(e), function(t) {
    return zK.call(e, t);
  }));
} : mS;
const pp = qK;
function YK(e, t) {
  return wc(e, pp(e), t);
}
function yS(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var VK = Object.getOwnPropertySymbols, GK = VK ? function(e) {
  for (var t = []; e; )
    yS(t, pp(e)), e = lp(e);
  return t;
} : mS;
const gS = GK;
function KK(e, t) {
  return wc(e, gS(e), t);
}
function xS(e, t, r) {
  var n = t(e);
  return Cs(e) ? n : yS(n, r(e));
}
function QK(e) {
  return xS(e, dp, pp);
}
function XK(e) {
  return xS(e, hp, gS);
}
var JK = Vi(dn, "DataView");
const v0 = JK;
var ZK = Vi(dn, "Promise");
const m0 = ZK;
var eQ = Vi(dn, "Set");
const y0 = eQ;
var tQ = Vi(dn, "WeakMap");
const g0 = tQ;
var Ig = "[object Map]", rQ = "[object Object]", kg = "[object Promise]", Ng = "[object Set]", Pg = "[object WeakMap]", $g = "[object DataView]", nQ = Yi(v0), iQ = Yi(Qo), aQ = Yi(m0), oQ = Yi(y0), sQ = Yi(g0), yi = zi;
(v0 && yi(new v0(new ArrayBuffer(1))) != $g || Qo && yi(new Qo()) != Ig || m0 && yi(m0.resolve()) != kg || y0 && yi(new y0()) != Ng || g0 && yi(new g0()) != Pg) && (yi = function(e) {
  var t = zi(e), r = t == rQ ? e.constructor : void 0, n = r ? Yi(r) : "";
  if (n)
    switch (n) {
      case nQ:
        return $g;
      case iQ:
        return Ig;
      case aQ:
        return kg;
      case oQ:
        return Ng;
      case sQ:
        return Pg;
    }
  return t;
});
const vp = yi;
var uQ = Object.prototype, lQ = uQ.hasOwnProperty;
function cQ(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && lQ.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var fQ = dn.Uint8Array;
const Rg = fQ;
function mp(e) {
  var t = new e.constructor(e.byteLength);
  return new Rg(t).set(new Rg(e)), t;
}
function dQ(e, t) {
  var r = t ? mp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var hQ = /\w*$/;
function pQ(e) {
  var t = new e.constructor(e.source, hQ.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Mg = ti ? ti.prototype : void 0, Bg = Mg ? Mg.valueOf : void 0;
function vQ(e) {
  return Bg ? Object(Bg.call(e)) : {};
}
function mQ(e, t) {
  var r = t ? mp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var yQ = "[object Boolean]", gQ = "[object Date]", xQ = "[object Map]", bQ = "[object Number]", EQ = "[object RegExp]", wQ = "[object Set]", SQ = "[object String]", _Q = "[object Symbol]", TQ = "[object ArrayBuffer]", AQ = "[object DataView]", CQ = "[object Float32Array]", OQ = "[object Float64Array]", DQ = "[object Int8Array]", FQ = "[object Int16Array]", IQ = "[object Int32Array]", kQ = "[object Uint8Array]", NQ = "[object Uint8ClampedArray]", PQ = "[object Uint16Array]", $Q = "[object Uint32Array]";
function RQ(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case TQ:
      return mp(e);
    case yQ:
    case gQ:
      return new n(+e);
    case AQ:
      return dQ(e, r);
    case CQ:
    case OQ:
    case DQ:
    case FQ:
    case IQ:
    case kQ:
    case NQ:
    case PQ:
    case $Q:
      return mQ(e, r);
    case xQ:
      return new n();
    case bQ:
    case SQ:
      return new n(e);
    case EQ:
      return pQ(e);
    case wQ:
      return new n();
    case _Q:
      return vQ(e);
  }
}
var jg = Object.create, MQ = function() {
  function e() {
  }
  return function(t) {
    if (!As(t))
      return {};
    if (jg)
      return jg(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const BQ = MQ;
function jQ(e) {
  return typeof e.constructor == "function" && !fp(e) ? BQ(lp(e)) : {};
}
var LQ = "[object Map]";
function UQ(e) {
  return qi(e) && vp(e) == LQ;
}
var Lg = Da && Da.isMap, HQ = Lg ? cp(Lg) : UQ;
const WQ = HQ;
var zQ = "[object Set]";
function qQ(e) {
  return qi(e) && vp(e) == zQ;
}
var Ug = Da && Da.isSet, YQ = Ug ? cp(Ug) : qQ;
const VQ = YQ;
var GQ = 1, KQ = 2, QQ = 4, bS = "[object Arguments]", XQ = "[object Array]", JQ = "[object Boolean]", ZQ = "[object Date]", eX = "[object Error]", ES = "[object Function]", tX = "[object GeneratorFunction]", rX = "[object Map]", nX = "[object Number]", wS = "[object Object]", iX = "[object RegExp]", aX = "[object Set]", oX = "[object String]", sX = "[object Symbol]", uX = "[object WeakMap]", lX = "[object ArrayBuffer]", cX = "[object DataView]", fX = "[object Float32Array]", dX = "[object Float64Array]", hX = "[object Int8Array]", pX = "[object Int16Array]", vX = "[object Int32Array]", mX = "[object Uint8Array]", yX = "[object Uint8ClampedArray]", gX = "[object Uint16Array]", xX = "[object Uint32Array]", et = {};
et[bS] = et[XQ] = et[lX] = et[cX] = et[JQ] = et[ZQ] = et[fX] = et[dX] = et[hX] = et[pX] = et[vX] = et[rX] = et[nX] = et[wS] = et[iX] = et[aX] = et[oX] = et[sX] = et[mX] = et[yX] = et[gX] = et[xX] = !0;
et[eX] = et[ES] = et[uX] = !1;
function gu(e, t, r, n, i, a) {
  var o, s = t & GQ, u = t & KQ, l = t & QQ;
  if (r && (o = i ? r(e, n, i, a) : r(e)), o !== void 0)
    return o;
  if (!As(e))
    return e;
  var c = Cs(e);
  if (c) {
    if (o = cQ(e), !s)
      return vS(e, o);
  } else {
    var f = vp(e), d = f == ES || f == tX;
    if (lS(e))
      return UK(e, s);
    if (f == wS || f == bS || d && !i) {
      if (o = u || d ? {} : jQ(e), !s)
        return u ? KK(e, jK(o, e)) : YK(e, PK(o, e));
    } else {
      if (!et[f])
        return i ? e : {};
      o = RQ(e, f, s);
    }
  }
  a || (a = new Qa());
  var h = a.get(e);
  if (h)
    return h;
  a.set(e, o), VQ(e) ? e.forEach(function(m) {
    o.add(gu(m, t, r, m, e, a));
  }) : WQ(e) && e.forEach(function(m, x) {
    o.set(x, gu(m, t, r, x, e, a));
  });
  var p = l ? u ? XK : QK : u ? hp : dp, v = c ? void 0 : p(e);
  return kG(v || e, function(m, x) {
    v && (x = m, m = e[x]), oS(o, x, gu(m, t, r, x, e, a));
  }), o;
}
var bX = 4;
function Hg(e) {
  return gu(e, bX);
}
function SS(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var EX = "[object Symbol]";
function yp(e) {
  return typeof e == "symbol" || qi(e) && zi(e) == EX;
}
var wX = "Expected a function";
function gp(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(wX);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], a = r.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, n);
    return r.cache = a.set(i, o) || a, o;
  };
  return r.cache = new (gp.Cache || si)(), r;
}
gp.Cache = si;
var SX = 500;
function _X(e) {
  var t = gp(e, function(n) {
    return r.size === SX && r.clear(), n;
  }), r = t.cache;
  return t;
}
var TX = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, AX = /\\(\\)?/g, CX = _X(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(TX, function(r, n, i, a) {
    t.push(i ? a.replace(AX, "$1") : n || r);
  }), t;
});
const OX = CX;
var DX = 1 / 0;
function FX(e) {
  if (typeof e == "string" || yp(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -DX ? "-0" : t;
}
var IX = 1 / 0, Wg = ti ? ti.prototype : void 0, zg = Wg ? Wg.toString : void 0;
function _S(e) {
  if (typeof e == "string")
    return e;
  if (Cs(e))
    return SS(e, _S) + "";
  if (yp(e))
    return zg ? zg.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -IX ? "-0" : t;
}
function kX(e) {
  return e == null ? "" : _S(e);
}
function TS(e) {
  return Cs(e) ? SS(e, FX) : yp(e) ? [e] : vS(OX(kX(e)));
}
var AS = X0(), NX = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, PX = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, CS = {};
CS[AS.ForwardRef] = NX;
CS[AS.Memo] = PX;
function ot() {
  return ot = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ot.apply(this, arguments);
}
function fa(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var Sc = /* @__PURE__ */ Rr(void 0);
Sc.displayName = "FormikContext";
var $X = Sc.Provider;
Sc.Consumer;
function xp() {
  var e = sn(Sc);
  return e || (process.env.NODE_ENV !== "production" ? Mt(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : Mt(!1)), e;
}
var zt = function(t) {
  return typeof t == "function";
}, _c = function(t) {
  return t !== null && typeof t == "object";
}, RX = function(t) {
  return String(Math.floor(Number(t))) === t;
}, td = function(t) {
  return Object.prototype.toString.call(t) === "[object String]";
}, OS = function(t) {
  return _0.count(t) === 0;
}, rd = function(t) {
  return _c(t) && zt(t.then);
};
function MX(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function nr(e, t, r, n) {
  n === void 0 && (n = 0);
  for (var i = TS(t); e && n < i.length; )
    e = e[i[n++]];
  return n !== i.length && !e || e === void 0 ? r : e;
}
function Ii(e, t, r) {
  for (var n = Hg(e), i = n, a = 0, o = TS(t); a < o.length - 1; a++) {
    var s = o[a], u = nr(e, o.slice(0, a + 1));
    if (u && (_c(u) || Array.isArray(u)))
      i = i[s] = Hg(u);
    else {
      var l = o[a + 1];
      i = i[s] = RX(l) && Number(l) >= 0 ? [] : {};
    }
  }
  return (a === 0 ? e : i)[o[a]] === r ? e : (r === void 0 ? delete i[o[a]] : i[o[a]] = r, a === 0 && r === void 0 && delete n[o[a]], n);
}
function DS(e, t, r, n) {
  r === void 0 && (r = /* @__PURE__ */ new WeakMap()), n === void 0 && (n = {});
  for (var i = 0, a = Object.keys(e); i < a.length; i++) {
    var o = a[i], s = e[o];
    _c(s) ? r.get(s) || (r.set(s, !0), n[o] = Array.isArray(s) ? [] : {}, DS(s, t, r, n[o])) : n[o] = t;
  }
  return n;
}
function BX(e, t) {
  switch (t.type) {
    case "SET_VALUES":
      return ot({}, e, {
        values: t.payload
      });
    case "SET_TOUCHED":
      return ot({}, e, {
        touched: t.payload
      });
    case "SET_ERRORS":
      return mi(e.errors, t.payload) ? e : ot({}, e, {
        errors: t.payload
      });
    case "SET_STATUS":
      return ot({}, e, {
        status: t.payload
      });
    case "SET_ISSUBMITTING":
      return ot({}, e, {
        isSubmitting: t.payload
      });
    case "SET_ISVALIDATING":
      return ot({}, e, {
        isValidating: t.payload
      });
    case "SET_FIELD_VALUE":
      return ot({}, e, {
        values: Ii(e.values, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return ot({}, e, {
        touched: Ii(e.touched, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_ERROR":
      return ot({}, e, {
        errors: Ii(e.errors, t.payload.field, t.payload.value)
      });
    case "RESET_FORM":
      return ot({}, e, t.payload);
    case "SET_FORMIK_STATE":
      return t.payload(e);
    case "SUBMIT_ATTEMPT":
      return ot({}, e, {
        touched: DS(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return ot({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return ot({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var hi = {}, Qs = {};
function jX(e) {
  var t = e.validateOnChange, r = t === void 0 ? !0 : t, n = e.validateOnBlur, i = n === void 0 ? !0 : n, a = e.validateOnMount, o = a === void 0 ? !1 : a, s = e.isInitialValid, u = e.enableReinitialize, l = u === void 0 ? !1 : u, c = e.onSubmit, f = fa(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), d = ot({
    validateOnChange: r,
    validateOnBlur: i,
    validateOnMount: o,
    onSubmit: c
  }, f), h = qr(d.initialValues), p = qr(d.initialErrors || hi), v = qr(d.initialTouched || Qs), m = qr(d.initialStatus), x = qr(!1), y = qr({});
  process.env.NODE_ENV !== "production" && He(function() {
    typeof s > "u" || (process.env.NODE_ENV !== "production" ? Mt(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : Mt(!1));
  }, []), He(function() {
    return x.current = !0, function() {
      x.current = !1;
    };
  }, []);
  var g = Oe(0), E = g[1], b = qr({
    values: d.initialValues,
    errors: d.initialErrors || hi,
    touched: d.initialTouched || Qs,
    status: d.initialStatus,
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), w = b.current, _ = Me(function(R) {
    var Q = b.current;
    b.current = BX(Q, R), Q !== b.current && E(function(te) {
      return te + 1;
    });
  }, []), A = Me(function(R, Q) {
    return new Promise(function(te, fe) {
      var Ee = d.validate(R, Q);
      Ee == null ? te(hi) : rd(Ee) ? Ee.then(function(ke) {
        te(ke || hi);
      }, function(ke) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", ke), fe(ke);
      }) : te(Ee);
    });
  }, [d.validate]), O = Me(function(R, Q) {
    var te = d.validationSchema, fe = zt(te) ? te(Q) : te, Ee = Q && fe.validateAt ? fe.validateAt(Q, R) : HX(R, fe);
    return new Promise(function(ke, Et) {
      Ee.then(function() {
        ke(hi);
      }, function(Zt) {
        Zt.name === "ValidationError" ? ke(UX(Zt)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", Zt), Et(Zt));
      });
    });
  }, [d.validationSchema]), T = Me(function(R, Q) {
    return new Promise(function(te) {
      return te(y.current[R].validate(Q));
    });
  }, []), C = Me(function(R) {
    var Q = Object.keys(y.current).filter(function(fe) {
      return zt(y.current[fe].validate);
    }), te = Q.length > 0 ? Q.map(function(fe) {
      return T(fe, nr(R, fe));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(te).then(function(fe) {
      return fe.reduce(function(Ee, ke, Et) {
        return ke === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || ke && (Ee = Ii(Ee, Q[Et], ke)), Ee;
      }, {});
    });
  }, [T]), $ = Me(function(R) {
    return Promise.all([C(R), d.validationSchema ? O(R) : {}, d.validate ? A(R) : {}]).then(function(Q) {
      var te = Q[0], fe = Q[1], Ee = Q[2], ke = h0.all([te, fe, Ee], {
        arrayMerge: WX
      });
      return ke;
    });
  }, [d.validate, d.validationSchema, C, A, O]), P = fr(function(R) {
    return R === void 0 && (R = w.values), _({
      type: "SET_ISVALIDATING",
      payload: !0
    }), $(R).then(function(Q) {
      return x.current && (_({
        type: "SET_ISVALIDATING",
        payload: !1
      }), _({
        type: "SET_ERRORS",
        payload: Q
      })), Q;
    });
  });
  He(function() {
    o && x.current === !0 && mi(h.current, d.initialValues) && P(h.current);
  }, [o, P]);
  var j = Me(function(R) {
    var Q = R && R.values ? R.values : h.current, te = R && R.errors ? R.errors : p.current ? p.current : d.initialErrors || {}, fe = R && R.touched ? R.touched : v.current ? v.current : d.initialTouched || {}, Ee = R && R.status ? R.status : m.current ? m.current : d.initialStatus;
    h.current = Q, p.current = te, v.current = fe, m.current = Ee;
    var ke = function() {
      _({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!R && !!R.isSubmitting,
          errors: te,
          touched: fe,
          status: Ee,
          values: Q,
          isValidating: !!R && !!R.isValidating,
          submitCount: R && R.submitCount && typeof R.submitCount == "number" ? R.submitCount : 0
        }
      });
    };
    if (d.onReset) {
      var Et = d.onReset(w.values, H);
      rd(Et) ? Et.then(ke) : ke();
    } else
      ke();
  }, [d.initialErrors, d.initialStatus, d.initialTouched, d.onReset]);
  He(function() {
    x.current === !0 && !mi(h.current, d.initialValues) && l && (h.current = d.initialValues, j(), o && P(h.current));
  }, [l, d.initialValues, j, o, P]), He(function() {
    l && x.current === !0 && !mi(p.current, d.initialErrors) && (p.current = d.initialErrors || hi, _({
      type: "SET_ERRORS",
      payload: d.initialErrors || hi
    }));
  }, [l, d.initialErrors]), He(function() {
    l && x.current === !0 && !mi(v.current, d.initialTouched) && (v.current = d.initialTouched || Qs, _({
      type: "SET_TOUCHED",
      payload: d.initialTouched || Qs
    }));
  }, [l, d.initialTouched]), He(function() {
    l && x.current === !0 && !mi(m.current, d.initialStatus) && (m.current = d.initialStatus, _({
      type: "SET_STATUS",
      payload: d.initialStatus
    }));
  }, [l, d.initialStatus, d.initialTouched]);
  var W = fr(function(R) {
    if (y.current[R] && zt(y.current[R].validate)) {
      var Q = nr(w.values, R), te = y.current[R].validate(Q);
      return rd(te) ? (_({
        type: "SET_ISVALIDATING",
        payload: !0
      }), te.then(function(fe) {
        return fe;
      }).then(function(fe) {
        _({
          type: "SET_FIELD_ERROR",
          payload: {
            field: R,
            value: fe
          }
        }), _({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (_({
        type: "SET_FIELD_ERROR",
        payload: {
          field: R,
          value: te
        }
      }), Promise.resolve(te));
    } else if (d.validationSchema)
      return _({
        type: "SET_ISVALIDATING",
        payload: !0
      }), O(w.values, R).then(function(fe) {
        return fe;
      }).then(function(fe) {
        _({
          type: "SET_FIELD_ERROR",
          payload: {
            field: R,
            value: nr(fe, R)
          }
        }), _({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), Y = Me(function(R, Q) {
    var te = Q.validate;
    y.current[R] = {
      validate: te
    };
  }, []), V = Me(function(R) {
    delete y.current[R];
  }, []), ce = fr(function(R, Q) {
    _({
      type: "SET_TOUCHED",
      payload: R
    });
    var te = Q === void 0 ? i : Q;
    return te ? P(w.values) : Promise.resolve();
  }), de = Me(function(R) {
    _({
      type: "SET_ERRORS",
      payload: R
    });
  }, []), L = fr(function(R, Q) {
    var te = zt(R) ? R(w.values) : R;
    _({
      type: "SET_VALUES",
      payload: te
    });
    var fe = Q === void 0 ? r : Q;
    return fe ? P(te) : Promise.resolve();
  }), D = Me(function(R, Q) {
    _({
      type: "SET_FIELD_ERROR",
      payload: {
        field: R,
        value: Q
      }
    });
  }, []), N = fr(function(R, Q, te) {
    _({
      type: "SET_FIELD_VALUE",
      payload: {
        field: R,
        value: Q
      }
    });
    var fe = te === void 0 ? r : te;
    return fe ? P(Ii(w.values, R, Q)) : Promise.resolve();
  }), B = Me(function(R, Q) {
    var te = Q, fe = R, Ee;
    if (!td(R)) {
      R.persist && R.persist();
      var ke = R.target ? R.target : R.currentTarget, Et = ke.type, Zt = ke.name, Ki = ke.id, Hr = ke.value, li = ke.checked, Oc = ke.outerHTML, Xa = ke.options, Ds = ke.multiple;
      te = Q || Zt || Ki, !te && process.env.NODE_ENV !== "production" && qg({
        htmlContent: Oc,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), fe = /number|range/.test(Et) ? (Ee = parseFloat(Hr), isNaN(Ee) ? "" : Ee) : /checkbox/.test(Et) ? qX(nr(w.values, te), li, Hr) : Xa && Ds ? zX(Xa) : Hr;
    }
    te && N(te, fe);
  }, [N, w.values]), F = fr(function(R) {
    if (td(R))
      return function(Q) {
        return B(Q, R);
      };
    B(R);
  }), X = fr(function(R, Q, te) {
    Q === void 0 && (Q = !0), _({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: R,
        value: Q
      }
    });
    var fe = te === void 0 ? i : te;
    return fe ? P(w.values) : Promise.resolve();
  }), Z = Me(function(R, Q) {
    R.persist && R.persist();
    var te = R.target, fe = te.name, Ee = te.id, ke = te.outerHTML, Et = Q || fe || Ee;
    !Et && process.env.NODE_ENV !== "production" && qg({
      htmlContent: ke,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), X(Et, !0);
  }, [X]), ne = fr(function(R) {
    if (td(R))
      return function(Q) {
        return Z(Q, R);
      };
    Z(R);
  }), K = Me(function(R) {
    zt(R) ? _({
      type: "SET_FORMIK_STATE",
      payload: R
    }) : _({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return R;
      }
    });
  }, []), we = Me(function(R) {
    _({
      type: "SET_STATUS",
      payload: R
    });
  }, []), I = Me(function(R) {
    _({
      type: "SET_ISSUBMITTING",
      payload: R
    });
  }, []), k = fr(function() {
    return _({
      type: "SUBMIT_ATTEMPT"
    }), P().then(function(R) {
      var Q = R instanceof Error, te = !Q && Object.keys(R).length === 0;
      if (te) {
        var fe;
        try {
          if (fe = ee(), fe === void 0)
            return;
        } catch (Ee) {
          throw Ee;
        }
        return Promise.resolve(fe).then(function(Ee) {
          return x.current && _({
            type: "SUBMIT_SUCCESS"
          }), Ee;
        }).catch(function(Ee) {
          if (x.current)
            throw _({
              type: "SUBMIT_FAILURE"
            }), Ee;
        });
      } else if (x.current && (_({
        type: "SUBMIT_FAILURE"
      }), Q))
        throw R;
    });
  }), M = fr(function(R) {
    if (R && R.preventDefault && zt(R.preventDefault) && R.preventDefault(), R && R.stopPropagation && zt(R.stopPropagation) && R.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var Q = MX();
      Q !== null && Q instanceof HTMLButtonElement && (Q.attributes && Q.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? Mt(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : Mt(!1)));
    }
    k().catch(function(te) {
      console.warn("Warning: An unhandled error was caught from submitForm()", te);
    });
  }), H = {
    resetForm: j,
    validateForm: P,
    validateField: W,
    setErrors: de,
    setFieldError: D,
    setFieldTouched: X,
    setFieldValue: N,
    setStatus: we,
    setSubmitting: I,
    setTouched: ce,
    setValues: L,
    setFormikState: K,
    submitForm: k
  }, ee = fr(function() {
    return c(w.values, H);
  }), xe = fr(function(R) {
    R && R.preventDefault && zt(R.preventDefault) && R.preventDefault(), R && R.stopPropagation && zt(R.stopPropagation) && R.stopPropagation(), j();
  }), ye = Me(function(R) {
    return {
      value: nr(w.values, R),
      error: nr(w.errors, R),
      touched: !!nr(w.touched, R),
      initialValue: nr(h.current, R),
      initialTouched: !!nr(v.current, R),
      initialError: nr(p.current, R)
    };
  }, [w.errors, w.touched, w.values]), be = Me(function(R) {
    return {
      setValue: function(te, fe) {
        return N(R, te, fe);
      },
      setTouched: function(te, fe) {
        return X(R, te, fe);
      },
      setError: function(te) {
        return D(R, te);
      }
    };
  }, [N, X, D]), ze = Me(function(R) {
    var Q = _c(R), te = Q ? R.name : R, fe = nr(w.values, te), Ee = {
      name: te,
      value: fe,
      onChange: F,
      onBlur: ne
    };
    if (Q) {
      var ke = R.type, Et = R.value, Zt = R.as, Ki = R.multiple;
      ke === "checkbox" ? Et === void 0 ? Ee.checked = !!fe : (Ee.checked = !!(Array.isArray(fe) && ~fe.indexOf(Et)), Ee.value = Et) : ke === "radio" ? (Ee.checked = fe === Et, Ee.value = Et) : Zt === "select" && Ki && (Ee.value = Ee.value || [], Ee.multiple = !0);
    }
    return Ee;
  }, [ne, F, w.values]), rt = Vn(function() {
    return !mi(h.current, w.values);
  }, [h.current, w.values]), Ft = Vn(function() {
    return typeof s < "u" ? rt ? w.errors && Object.keys(w.errors).length === 0 : s !== !1 && zt(s) ? s(d) : s : w.errors && Object.keys(w.errors).length === 0;
  }, [s, rt, w.errors, d]), bt = ot({}, w, {
    initialValues: h.current,
    initialErrors: p.current,
    initialTouched: v.current,
    initialStatus: m.current,
    handleBlur: ne,
    handleChange: F,
    handleReset: xe,
    handleSubmit: M,
    resetForm: j,
    setErrors: de,
    setFormikState: K,
    setFieldTouched: X,
    setFieldValue: N,
    setFieldError: D,
    setStatus: we,
    setSubmitting: I,
    setTouched: ce,
    setValues: L,
    submitForm: k,
    validateForm: P,
    validateField: W,
    isValid: Ft,
    dirty: rt,
    unregisterField: V,
    registerField: Y,
    getFieldProps: ze,
    getFieldMeta: ye,
    getFieldHelpers: be,
    validateOnBlur: i,
    validateOnChange: r,
    validateOnMount: o
  });
  return bt;
}
function LX(e) {
  var t = jX(e), r = e.component, n = e.children, i = e.render, a = e.innerRef;
  return d_(a, function() {
    return t;
  }), process.env.NODE_ENV !== "production" && He(function() {
    e.render && (process.env.NODE_ENV !== "production" ? Mt(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : Mt(!1));
  }, []), Ei($X, {
    value: t
  }, r ? Ei(r, t) : i ? i(t) : n ? zt(n) ? n(t) : OS(n) ? null : _0.only(n) : null);
}
function qg(e) {
  var t = e.htmlContent, r = e.documentationAnchorLink, n = e.handlerName;
  console.warn("Warning: Formik called `" + n + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + t + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + r + `
  `);
}
function UX(e) {
  var t = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return Ii(t, e.path, e.message);
    for (var i = e.inner, r = Array.isArray(i), n = 0, i = r ? i : i[Symbol.iterator](); ; ) {
      var a;
      if (r) {
        if (n >= i.length)
          break;
        a = i[n++];
      } else {
        if (n = i.next(), n.done)
          break;
        a = n.value;
      }
      var o = a;
      nr(t, o.path) || (t = Ii(t, o.path, o.message));
    }
  }
  return t;
}
function HX(e, t, r, n) {
  r === void 0 && (r = !1);
  var i = x0(e);
  return t[r ? "validateSync" : "validate"](i, {
    abortEarly: !1,
    context: n || i
  });
}
function x0(e) {
  var t = Array.isArray(e) ? [] : {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var n = String(r);
      Array.isArray(e[n]) === !0 ? t[n] = e[n].map(function(i) {
        return Array.isArray(i) === !0 || gg(i) ? x0(i) : i !== "" ? i : void 0;
      }) : gg(e[n]) ? t[n] = x0(e[n]) : t[n] = e[n] !== "" ? e[n] : void 0;
    }
  return t;
}
function WX(e, t, r) {
  var n = e.slice();
  return t.forEach(function(a, o) {
    if (typeof n[o] > "u") {
      var s = r.clone !== !1, u = s && r.isMergeableObject(a);
      n[o] = u ? h0(Array.isArray(a) ? [] : {}, a, r) : a;
    } else
      r.isMergeableObject(a) ? n[o] = h0(e[o], a, r) : e.indexOf(a) === -1 && n.push(a);
  }), n;
}
function zX(e) {
  return Array.from(e).filter(function(t) {
    return t.selected;
  }).map(function(t) {
    return t.value;
  });
}
function qX(e, t, r) {
  if (typeof e == "boolean")
    return !!t;
  var n = [], i = !1, a = -1;
  if (Array.isArray(e))
    n = e, a = e.indexOf(r), i = a >= 0;
  else if (!r || r == "true" || r == "false")
    return !!t;
  return t && r && !i ? n.concat(r) : i ? n.slice(0, a).concat(n.slice(a + 1)) : n;
}
var YX = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? h_ : He;
function fr(e) {
  var t = qr(e);
  return YX(function() {
    t.current = e;
  }), Me(function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    return t.current.apply(void 0, n);
  }, []);
}
function nd(e) {
  var t = e.validate, r = e.name, n = e.render, i = e.children, a = e.as, o = e.component, s = e.className, u = fa(e, ["validate", "name", "render", "children", "as", "component", "className"]), l = xp(), c = fa(l, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && He(function() {
    n && (process.env.NODE_ENV !== "production" ? Mt(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + r + '" render={({field, form}) => ...} /> with <Field name="' + r + '">{({field, form, meta}) => ...}</Field>') : Mt(!1)), a && i && zt(i) && (process.env.NODE_ENV !== "production" ? Mt(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : Mt(!1)), o && i && zt(i) && (process.env.NODE_ENV !== "production" ? Mt(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : Mt(!1)), n && i && !OS(i) && (process.env.NODE_ENV !== "production" ? Mt(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : Mt(!1));
  }, []);
  var f = c.registerField, d = c.unregisterField;
  He(function() {
    return f(r, {
      validate: t
    }), function() {
      d(r);
    };
  }, [f, d, r, t]);
  var h = c.getFieldProps(ot({
    name: r
  }, u)), p = c.getFieldMeta(r), v = {
    field: h,
    form: c
  };
  if (n)
    return n(ot({}, v, {
      meta: p
    }));
  if (zt(i))
    return i(ot({}, v, {
      meta: p
    }));
  if (o) {
    if (typeof o == "string") {
      var m = u.innerRef, x = fa(u, ["innerRef"]);
      return Ei(o, ot({
        ref: m
      }, h, x, {
        className: s
      }), i);
    }
    return Ei(o, ot({
      field: h,
      form: c
    }, u, {
      className: s
    }), i);
  }
  var y = a || "input";
  if (typeof y == "string") {
    var g = u.innerRef, E = fa(u, ["innerRef"]);
    return Ei(y, ot({
      ref: g
    }, h, E, {
      className: s
    }), i);
  }
  return Ei(y, ot({}, h, u, {
    className: s
  }), i);
}
var FS = /* @__PURE__ */ f_(function(e, t) {
  var r = e.action, n = fa(e, ["action"]), i = r ?? "#", a = xp(), o = a.handleReset, s = a.handleSubmit;
  return Ei("form", ot({
    onSubmit: s,
    ref: t,
    onReset: o,
    action: i
  }, n));
});
FS.displayName = "Form";
var VX = "Expected a function";
function GX(e, t, r) {
  if (typeof e != "function")
    throw new TypeError(VX);
  return setTimeout(function() {
    e.apply(void 0, r);
  }, t);
}
var KX = GX, QX = KX, XX = Xw, JX = Rq, ZX = XX(function(e, t, r) {
  return QX(e, JX(t) || 0, r);
}), eJ = ZX;
const tJ = /* @__PURE__ */ Nt(eJ);
var rJ = Ww, nJ = 0;
function iJ(e) {
  var t = ++nJ;
  return rJ(e) + t;
}
var aJ = iJ;
const oJ = /* @__PURE__ */ Nt(aJ), { useEffect: sJ } = Fe, uJ = ({ onChange: e = B0 }) => {
  const { values: t, errors: r } = xp();
  return sJ(() => {
    e == null || e(t, r);
  }, [t, r]), null;
}, lJ = O_(FS), cJ = ({
  id: e,
  submitLabel: t = "Submit",
  onChange: r = B0,
  hasDefaultControls: n = !0,
  sx: i,
  children: a
}) => {
  const [o] = sb(a, {
    buttons: cd
  });
  return /* @__PURE__ */ S.jsxs(
    lJ,
    {
      id: e,
      display: "flex",
      flexDirection: "column",
      h: "full",
      justifyContent: "space-between",
      sx: i,
      children: [
        me.Children.toArray(a).filter(
          (s) => {
            var u;
            return me.isValidElement(s) && s.type !== ((u = o.buttons) == null ? void 0 : u.type);
          }
        ),
        /* @__PURE__ */ S.jsx(uJ, { onChange: r }),
        n && (o.buttons ?? /* @__PURE__ */ S.jsx(cd, { type: "submit", w: "full", children: t }))
      ]
    }
  );
}, fJ = Object.assign(cJ, {
  Button: cd
});
var dJ = yc, hJ = zw, pJ = Vw, vJ = gr;
function mJ(e, t) {
  var r = vJ(e) ? dJ : pJ;
  return r(e, hJ(t));
}
var yJ = mJ;
const gJ = /* @__PURE__ */ Nt(yJ);
function xJ(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var bJ = xJ, Yg = Kw;
function EJ(e, t, r) {
  t == "__proto__" && Yg ? Yg(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var IS = EJ, wJ = IS, SJ = cc, _J = Object.prototype, TJ = _J.hasOwnProperty;
function AJ(e, t, r) {
  var n = e[t];
  (!(TJ.call(e, t) && SJ(n, r)) || r === void 0 && !(t in e)) && wJ(e, t, r);
}
var kS = AJ, CJ = kS, OJ = IS;
function DJ(e, t, r, n) {
  var i = !r;
  r || (r = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var s = t[a], u = n ? n(r[s], e[s], s, r, e) : void 0;
    u === void 0 && (u = e[s]), i ? OJ(r, s, u) : CJ(r, s, u);
  }
  return r;
}
var Os = DJ, FJ = Os, IJ = ws;
function kJ(e, t) {
  return e && FJ(t, IJ(t), e);
}
var NJ = kJ;
function PJ(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var $J = PJ, RJ = ai, MJ = op, BJ = $J, jJ = Object.prototype, LJ = jJ.hasOwnProperty;
function UJ(e) {
  if (!RJ(e))
    return BJ(e);
  var t = MJ(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !LJ.call(e, n)) || r.push(n);
  return r;
}
var HJ = UJ, WJ = Nw, zJ = HJ, qJ = Es;
function YJ(e) {
  return qJ(e) ? WJ(e, !0) : zJ(e);
}
var bp = YJ, VJ = Os, GJ = bp;
function KJ(e, t) {
  return e && VJ(t, GJ(t), e);
}
var QJ = KJ, nl = { exports: {} };
nl.exports;
(function(e, t) {
  var r = fn, n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, a = i && i.exports === n, o = a ? r.Buffer : void 0, s = o ? o.allocUnsafe : void 0;
  function u(l, c) {
    if (c)
      return l.slice();
    var f = l.length, d = s ? s(f) : new l.constructor(f);
    return l.copy(d), d;
  }
  e.exports = u;
})(nl, nl.exports);
var XJ = nl.exports;
function JJ(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var ZJ = JJ, eZ = Os, tZ = ep;
function rZ(e, t) {
  return eZ(e, tZ(e), t);
}
var nZ = rZ, iZ = Pw, aZ = iZ(Object.getPrototypeOf, Object), Ep = aZ, oZ = Zh, sZ = Ep, uZ = ep, lZ = Fw, cZ = Object.getOwnPropertySymbols, fZ = cZ ? function(e) {
  for (var t = []; e; )
    oZ(t, uZ(e)), e = sZ(e);
  return t;
} : lZ, NS = fZ, dZ = Os, hZ = NS;
function pZ(e, t) {
  return dZ(e, hZ(e), t);
}
var vZ = pZ, mZ = Dw, yZ = NS, gZ = bp;
function xZ(e) {
  return mZ(e, gZ, yZ);
}
var PS = xZ, bZ = Object.prototype, EZ = bZ.hasOwnProperty;
function wZ(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && EZ.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var SZ = wZ, Vg = Ow;
function _Z(e) {
  var t = new e.constructor(e.byteLength);
  return new Vg(t).set(new Vg(e)), t;
}
var wp = _Z, TZ = wp;
function AZ(e, t) {
  var r = t ? TZ(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var CZ = AZ, OZ = /\w*$/;
function DZ(e) {
  var t = new e.constructor(e.source, OZ.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var FZ = DZ, Gg = za, Kg = Gg ? Gg.prototype : void 0, Qg = Kg ? Kg.valueOf : void 0;
function IZ(e) {
  return Qg ? Object(Qg.call(e)) : {};
}
var kZ = IZ, NZ = wp;
function PZ(e, t) {
  var r = t ? NZ(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var $Z = PZ, RZ = wp, MZ = CZ, BZ = FZ, jZ = kZ, LZ = $Z, UZ = "[object Boolean]", HZ = "[object Date]", WZ = "[object Map]", zZ = "[object Number]", qZ = "[object RegExp]", YZ = "[object Set]", VZ = "[object String]", GZ = "[object Symbol]", KZ = "[object ArrayBuffer]", QZ = "[object DataView]", XZ = "[object Float32Array]", JZ = "[object Float64Array]", ZZ = "[object Int8Array]", eee = "[object Int16Array]", tee = "[object Int32Array]", ree = "[object Uint8Array]", nee = "[object Uint8ClampedArray]", iee = "[object Uint16Array]", aee = "[object Uint32Array]";
function oee(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case KZ:
      return RZ(e);
    case UZ:
    case HZ:
      return new n(+e);
    case QZ:
      return MZ(e, r);
    case XZ:
    case JZ:
    case ZZ:
    case eee:
    case tee:
    case ree:
    case nee:
    case iee:
    case aee:
      return LZ(e, r);
    case WZ:
      return new n();
    case zZ:
    case VZ:
      return new n(e);
    case qZ:
      return BZ(e);
    case YZ:
      return new n();
    case GZ:
      return jZ(e);
  }
}
var see = oee, uee = ai, Xg = Object.create, lee = function() {
  function e() {
  }
  return function(t) {
    if (!uee(t))
      return {};
    if (Xg)
      return Xg(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), cee = lee, fee = cee, dee = Ep, hee = op;
function pee(e) {
  return typeof e.constructor == "function" && !hee(e) ? fee(dee(e)) : {};
}
var vee = pee, mee = mc, yee = oi, gee = "[object Map]";
function xee(e) {
  return yee(e) && mee(e) == gee;
}
var bee = xee, Eee = bee, wee = vc, Jg = ap, Zg = Jg && Jg.isMap, See = Zg ? wee(Zg) : Eee, _ee = See, Tee = mc, Aee = oi, Cee = "[object Set]";
function Oee(e) {
  return Aee(e) && Tee(e) == Cee;
}
var Dee = Oee, Fee = Dee, Iee = vc, ex = ap, tx = ex && ex.isSet, kee = tx ? Iee(tx) : Fee, Nee = kee, Pee = Jh, $ee = bJ, Ree = kS, Mee = NJ, Bee = QJ, jee = XJ, Lee = ZJ, Uee = nZ, Hee = vZ, Wee = $w, zee = PS, qee = mc, Yee = SZ, Vee = see, Gee = vee, Kee = gr, Qee = rp, Xee = _ee, Jee = ai, Zee = Nee, ete = ws, tte = bp, rte = 1, nte = 2, ite = 4, $S = "[object Arguments]", ate = "[object Array]", ote = "[object Boolean]", ste = "[object Date]", ute = "[object Error]", RS = "[object Function]", lte = "[object GeneratorFunction]", cte = "[object Map]", fte = "[object Number]", MS = "[object Object]", dte = "[object RegExp]", hte = "[object Set]", pte = "[object String]", vte = "[object Symbol]", mte = "[object WeakMap]", yte = "[object ArrayBuffer]", gte = "[object DataView]", xte = "[object Float32Array]", bte = "[object Float64Array]", Ete = "[object Int8Array]", wte = "[object Int16Array]", Ste = "[object Int32Array]", _te = "[object Uint8Array]", Tte = "[object Uint8ClampedArray]", Ate = "[object Uint16Array]", Cte = "[object Uint32Array]", tt = {};
tt[$S] = tt[ate] = tt[yte] = tt[gte] = tt[ote] = tt[ste] = tt[xte] = tt[bte] = tt[Ete] = tt[wte] = tt[Ste] = tt[cte] = tt[fte] = tt[MS] = tt[dte] = tt[hte] = tt[pte] = tt[vte] = tt[_te] = tt[Tte] = tt[Ate] = tt[Cte] = !0;
tt[ute] = tt[RS] = tt[mte] = !1;
function xu(e, t, r, n, i, a) {
  var o, s = t & rte, u = t & nte, l = t & ite;
  if (r && (o = i ? r(e, n, i, a) : r(e)), o !== void 0)
    return o;
  if (!Jee(e))
    return e;
  var c = Kee(e);
  if (c) {
    if (o = Yee(e), !s)
      return Lee(e, o);
  } else {
    var f = qee(e), d = f == RS || f == lte;
    if (Qee(e))
      return jee(e, s);
    if (f == MS || f == $S || d && !i) {
      if (o = u || d ? {} : Gee(e), !s)
        return u ? Hee(e, Bee(o, e)) : Uee(e, Mee(o, e));
    } else {
      if (!tt[f])
        return i ? e : {};
      o = Vee(e, f, s);
    }
  }
  a || (a = new Pee());
  var h = a.get(e);
  if (h)
    return h;
  a.set(e, o), Zee(e) ? e.forEach(function(m) {
    o.add(xu(m, t, r, m, e, a));
  }) : Xee(e) && e.forEach(function(m, x) {
    o.set(x, xu(m, t, r, x, e, a));
  });
  var p = l ? u ? zee : Wee : u ? tte : ete, v = c ? void 0 : p(e);
  return $ee(v || e, function(m, x) {
    v && (x = m, m = e[x]), Ree(o, x, xu(m, t, r, x, e, a));
  }), o;
}
var Ote = xu;
function Dte(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Fte = Dte;
function Ite(e, t, r) {
  var n = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), r = r > i ? i : r, r < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(i); ++n < i; )
    a[n] = e[n + t];
  return a;
}
var kte = Ite, Nte = xc, Pte = kte;
function $te(e, t) {
  return t.length < 2 ? e : Nte(e, Pte(t, 0, -1));
}
var Rte = $te, Mte = gc, Bte = Fte, jte = Rte, Lte = _s;
function Ute(e, t) {
  return t = Mte(t, e), e = jte(e, t), e == null || delete e[Lte(Bte(t))];
}
var Hte = Ute, Wte = qa, zte = Ep, qte = oi, Yte = "[object Object]", Vte = Function.prototype, Gte = Object.prototype, BS = Vte.toString, Kte = Gte.hasOwnProperty, Qte = BS.call(Object);
function Xte(e) {
  if (!qte(e) || Wte(e) != Yte)
    return !1;
  var t = zte(e);
  if (t === null)
    return !0;
  var r = Kte.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && BS.call(r) == Qte;
}
var Jte = Xte, Zte = Jte;
function ere(e) {
  return Zte(e) ? void 0 : e;
}
var tre = ere, rre = Yw;
function nre(e) {
  var t = e == null ? 0 : e.length;
  return t ? rre(e, 1) : [];
}
var ire = nre, are = ire, ore = Gw, sre = Qw;
function ure(e) {
  return sre(ore(e, void 0, are), e + "");
}
var lre = ure, cre = yc, fre = Ote, dre = Hte, hre = gc, pre = Os, vre = tre, mre = lre, yre = PS, gre = 1, xre = 2, bre = 4, Ere = mre(function(e, t) {
  var r = {};
  if (e == null)
    return r;
  var n = !1;
  t = cre(t, function(a) {
    return a = hre(a, e), n || (n = a.length > 1), a;
  }), pre(e, yre(e), r), n && (r = fre(r, gre | xre | bre, vre));
  for (var i = t.length; i--; )
    dre(r, t[i]);
  return r;
}), wre = Ere;
const Sre = /* @__PURE__ */ Nt(wre);
function _re(e, t) {
  for (var r, n = -1, i = e.length; ++n < i; ) {
    var a = t(e[n]);
    a !== void 0 && (r = r === void 0 ? a : r + a);
  }
  return r;
}
var Tre = _re, Are = Tre, Cre = Ts;
function Ore(e) {
  return e && e.length ? Are(e, Cre) : 0;
}
var Dre = Ore;
const Fre = /* @__PURE__ */ Nt(Dre);
function Gi(e) {
  this._maxSize = e, this.clear();
}
Gi.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Gi.prototype.get = function(e) {
  return this._values[e];
};
Gi.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var Ire = /[^.^\]^[]+|(?=\[\]|\.\.)/g, jS = /^\d+$/, kre = /^\d/, Nre = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Pre = /^\s*(['"]?)(.*?)(\1)\s*$/, Sp = 512, rx = new Gi(Sp), nx = new Gi(Sp), ix = new Gi(Sp), ki = {
  Cache: Gi,
  split: b0,
  normalizePath: id,
  setter: function(e) {
    var t = id(e);
    return nx.get(e) || nx.set(e, function(n, i) {
      for (var a = 0, o = t.length, s = n; a < o - 1; ) {
        var u = t[a];
        if (u === "__proto__" || u === "constructor" || u === "prototype")
          return n;
        s = s[t[a++]];
      }
      s[t[a]] = i;
    });
  },
  getter: function(e, t) {
    var r = id(e);
    return ix.get(e) || ix.set(e, function(i) {
      for (var a = 0, o = r.length; a < o; )
        if (i != null || !t)
          i = i[r[a++]];
        else
          return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (_p(r) || jS.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    $re(Array.isArray(e) ? e : b0(e), t, r);
  }
};
function id(e) {
  return rx.get(e) || rx.set(
    e,
    b0(e).map(function(t) {
      return t.replace(Pre, "$2");
    })
  );
}
function b0(e) {
  return e.match(Ire) || [""];
}
function $re(e, t, r) {
  var n = e.length, i, a, o, s;
  for (a = 0; a < n; a++)
    i = e[a], i && (Bre(i) && (i = '"' + i + '"'), s = _p(i), o = !s && /^\d+$/.test(i), t.call(r, i, s, o, a, e));
}
function _p(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function Rre(e) {
  return e.match(kre) && !e.match(jS);
}
function Mre(e) {
  return Nre.test(e);
}
function Bre(e) {
  return !_p(e) && (Rre(e) || Mre(e));
}
const jre = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, Tc = (e) => e.match(jre) || [], Ac = (e) => e[0].toUpperCase() + e.slice(1), Tp = (e, t) => Tc(e).join(t).toLowerCase(), LS = (e) => Tc(e).reduce(
  (t, r) => `${t}${t ? r[0].toUpperCase() + r.slice(1).toLowerCase() : r.toLowerCase()}`,
  ""
), Lre = (e) => Ac(LS(e)), Ure = (e) => Tp(e, "_"), Hre = (e) => Tp(e, "-"), Wre = (e) => Ac(Tp(e, " ")), zre = (e) => Tc(e).map(Ac).join(" ");
var ad = {
  words: Tc,
  upperFirst: Ac,
  camelCase: LS,
  pascalCase: Lre,
  snakeCase: Ure,
  kebabCase: Hre,
  sentenceCase: Wre,
  titleCase: zre
}, Ap = { exports: {} };
Ap.exports = function(e) {
  return US(qre(e), e);
};
Ap.exports.array = US;
function US(e, t) {
  var r = e.length, n = new Array(r), i = {}, a = r, o = Yre(t), s = Vre(e);
  for (t.forEach(function(l) {
    if (!s.has(l[0]) || !s.has(l[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    i[a] || u(e[a], a, /* @__PURE__ */ new Set());
  return n;
  function u(l, c, f) {
    if (f.has(l)) {
      var d;
      try {
        d = ", node was:" + JSON.stringify(l);
      } catch {
        d = "";
      }
      throw new Error("Cyclic dependency" + d);
    }
    if (!s.has(l))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(l));
    if (!i[c]) {
      i[c] = !0;
      var h = o.get(l) || /* @__PURE__ */ new Set();
      if (h = Array.from(h), c = h.length) {
        f.add(l);
        do {
          var p = h[--c];
          u(p, s.get(p), f);
        } while (c);
        f.delete(l);
      }
      n[--r] = l;
    }
  }
}
function qre(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, n = e.length; r < n; r++) {
    var i = e[r];
    t.add(i[0]), t.add(i[1]);
  }
  return Array.from(t);
}
function Yre(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++) {
    var i = e[r];
    t.has(i[0]) || t.set(i[0], /* @__PURE__ */ new Set()), t.has(i[1]) || t.set(i[1], /* @__PURE__ */ new Set()), t.get(i[0]).add(i[1]);
  }
  return t;
}
function Vre(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++)
    t.set(e[r], r);
  return t;
}
var Gre = Ap.exports;
const Kre = /* @__PURE__ */ Nt(Gre), Qre = Object.prototype.toString, Xre = Error.prototype.toString, Jre = RegExp.prototype.toString, Zre = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", ene = /^Symbol\((.*)\)(.*)$/;
function tne(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function ax(e, t = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const r = typeof e;
  if (r === "number")
    return tne(e);
  if (r === "string")
    return t ? `"${e}"` : e;
  if (r === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol")
    return Zre.call(e).replace(ene, "Symbol($1)");
  const n = Qre.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + Xre.call(e) + "]" : n === "RegExp" ? Jre.call(e) : null;
}
function Yn(e, t) {
  let r = ax(e, t);
  return r !== null ? r : JSON.stringify(e, function(n, i) {
    let a = ax(this[n], t);
    return a !== null ? a : i;
  }, 2);
}
function HS(e) {
  return e == null ? [] : [].concat(e);
}
let WS, rne = /\$\{\s*(\w+)\s*\}/g;
WS = Symbol.toStringTag;
class Kt extends Error {
  static formatError(t, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = Object.assign({}, r, {
      path: n
    })), typeof t == "string" ? t.replace(rne, (i, a) => Yn(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, n, i, a) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this[WS] = "Error", this.name = "ValidationError", this.value = r, this.path = n, this.type = i, this.errors = [], this.inner = [], HS(t).forEach((o) => {
      if (Kt.isError(o)) {
        this.errors.push(...o.errors);
        const s = o.inner.length ? o.inner : [o];
        this.inner.push(...s);
      } else
        this.errors.push(o);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], !a && Error.captureStackTrace && Error.captureStackTrace(this, Kt);
  }
}
let Gr = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: n
  }) => {
    const i = n != null && n !== r ? ` (cast from the value \`${Yn(n, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${Yn(r, !0)}\`` + i : `${e} must match the configured type. The validated value was: \`${Yn(r, !0)}\`` + i;
  }
}, Sr = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, nne = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, E0 = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ine = {
  isValue: "${path} field must be ${value}"
}, w0 = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, ane = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, one = {
  notType: (e) => {
    const {
      path: t,
      value: r,
      spec: n
    } = e, i = n.types.length;
    if (Array.isArray(r)) {
      if (r.length < i)
        return `${t} tuple value has too few items, expected a length of ${i} but got ${r.length} for value: \`${Yn(r, !0)}\``;
      if (r.length > i)
        return `${t} tuple value has too many items, expected a length of ${i} but got ${r.length} for value: \`${Yn(r, !0)}\``;
    }
    return Kt.formatError(Gr.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Gr,
  string: Sr,
  number: nne,
  date: E0,
  object: w0,
  array: ane,
  boolean: ine,
  tuple: one
});
const Cp = (e) => e && e.__isYupSchema__;
class il {
  static fromOptions(t, r) {
    if (!r.then && !r.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: i,
      otherwise: a
    } = r, o = typeof n == "function" ? n : (...s) => s.every((u) => u === n);
    return new il(t, (s, u) => {
      var l;
      let c = o(...s) ? i : a;
      return (l = c == null ? void 0 : c(u)) != null ? l : u;
    });
  }
  constructor(t, r) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = r;
  }
  resolve(t, r) {
    let n = this.refs.map((a) => (
      // TODO: ? operator here?
      a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)
    )), i = this.fn(n, t, r);
    if (i === void 0 || // @ts-ignore this can be base
    i === t)
      return t;
    if (!Cp(i))
      throw new TypeError("conditions must return a schema object");
    return i.resolve(r);
  }
}
const Xs = {
  context: "$",
  value: "."
};
function sne(e, t) {
  return new ui(e, t);
}
class ui {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Xs.context, this.isValue = this.key[0] === Xs.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? Xs.context : this.isValue ? Xs.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && ki.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, n) {
    let i = this.isContext ? n : this.isValue ? t : r;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
ui.prototype.__isYupRef = !0;
const Ci = (e) => e == null;
function ia(e) {
  function t({
    value: r,
    path: n = "",
    options: i,
    originalValue: a,
    schema: o
  }, s, u) {
    const {
      name: l,
      test: c,
      params: f,
      message: d,
      skipAbsent: h
    } = e;
    let {
      parent: p,
      context: v,
      abortEarly: m = o.spec.abortEarly,
      disableStackTrace: x = o.spec.disableStackTrace
    } = i;
    function y(C) {
      return ui.isRef(C) ? C.getValue(r, p, v) : C;
    }
    function g(C = {}) {
      var $;
      const P = Object.assign({
        value: r,
        originalValue: a,
        label: o.spec.label,
        path: C.path || n,
        spec: o.spec
      }, f, C.params);
      for (const W of Object.keys(P))
        P[W] = y(P[W]);
      const j = new Kt(Kt.formatError(C.message || d, P), r, P.path, C.type || l, ($ = C.disableStackTrace) != null ? $ : x);
      return j.params = P, j;
    }
    const E = m ? s : u;
    let b = {
      path: n,
      parent: p,
      type: l,
      from: i.from,
      createError: g,
      resolve: y,
      options: i,
      originalValue: a,
      schema: o
    };
    const w = (C) => {
      Kt.isError(C) ? E(C) : C ? u(null) : E(g());
    }, _ = (C) => {
      Kt.isError(C) ? E(C) : s(C);
    };
    if (h && Ci(r))
      return w(!0);
    let O;
    try {
      var T;
      if (O = c.call(b, r, b), typeof ((T = O) == null ? void 0 : T.then) == "function") {
        if (i.sync)
          throw new Error(`Validation test of type: "${b.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(O).then(w, _);
      }
    } catch (C) {
      _(C);
      return;
    }
    w(O);
  }
  return t.OPTIONS = e, t;
}
function une(e, t, r, n = r) {
  let i, a, o;
  return t ? (ki.forEach(t, (s, u, l) => {
    let c = u ? s.slice(1, s.length - 1) : s;
    e = e.resolve({
      context: n,
      parent: i,
      value: r
    });
    let f = e.type === "tuple", d = l ? parseInt(c, 10) : 0;
    if (e.innerType || f) {
      if (f && !l)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${o}" must contain an index to the tuple element, e.g. "${o}[0]"`);
      if (r && d >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      i = r, r = r && r[d], e = f ? e.spec.types[d] : e.innerType;
    }
    if (!l) {
      if (!e.fields || !e.fields[c])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${o} which is a type: "${e.type}")`);
      i = r, r = r && r[c], e = e.fields[c];
    }
    a = c, o = u ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: i,
    parentPath: a
  }) : {
    parent: i,
    parentPath: t,
    schema: e
  };
}
class al extends Set {
  describe() {
    const t = [];
    for (const r of this.values())
      t.push(ui.isRef(r) ? r.describe() : r);
    return t;
  }
  resolveAll(t) {
    let r = [];
    for (const n of this.values())
      r.push(t(n));
    return r;
  }
  clone() {
    return new al(this.values());
  }
  merge(t, r) {
    const n = this.clone();
    return t.forEach((i) => n.add(i)), r.forEach((i) => n.delete(i)), n;
  }
}
function da(e, t = /* @__PURE__ */ new Map()) {
  if (Cp(e) || !e || typeof e != "object")
    return e;
  if (t.has(e))
    return t.get(e);
  let r;
  if (e instanceof Date)
    r = new Date(e.getTime()), t.set(e, r);
  else if (e instanceof RegExp)
    r = new RegExp(e), t.set(e, r);
  else if (Array.isArray(e)) {
    r = new Array(e.length), t.set(e, r);
    for (let n = 0; n < e.length; n++)
      r[n] = da(e[n], t);
  } else if (e instanceof Map) {
    r = /* @__PURE__ */ new Map(), t.set(e, r);
    for (const [n, i] of e.entries())
      r.set(n, da(i, t));
  } else if (e instanceof Set) {
    r = /* @__PURE__ */ new Set(), t.set(e, r);
    for (const n of e)
      r.add(da(n, t));
  } else if (e instanceof Object) {
    r = {}, t.set(e, r);
    for (const [n, i] of Object.entries(e))
      r[n] = da(i, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return r;
}
class on {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new al(), this._blacklist = new al(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Gr.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((r) => {
      r.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeCheck = this._typeCheck, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.internalTests = Object.assign({}, this.internalTests), r.exclusiveTests = Object.assign({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = da(Object.assign({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = r, n;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, n = t.clone();
    const i = Object.assign({}, r.spec, n.spec);
    return n.spec = i, n.internalTests = Object.assign({}, r.internalTests, n.internalTests), n._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((a) => {
      t.tests.forEach((o) => {
        a.test(o.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((i, a) => a.resolve(i, t), r), r = r.resolve(t);
    }
    return r;
  }
  resolveOptions(t) {
    var r, n, i, a;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (r = t.strict) != null ? r : this.spec.strict,
      abortEarly: (n = t.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (i = t.recursive) != null ? i : this.spec.recursive,
      disableStackTrace: (a = t.disableStackTrace) != null ? a : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, r = {}) {
    let n = this.resolve(Object.assign({
      value: t
    }, r)), i = r.assert === "ignore-optionality", a = n._cast(t, r);
    if (r.assert !== !1 && !n.isType(a)) {
      if (i && Ci(a))
        return a;
      let o = Yn(t), s = Yn(a);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${o} 
` + (s !== o ? `result of cast: ${s}` : ""));
    }
    return a;
  }
  _cast(t, r) {
    let n = t === void 0 ? t : this.transforms.reduce((i, a) => a.call(this, i, t, this), t);
    return n === void 0 && (n = this.getDefault(r)), n;
  }
  _validate(t, r = {}, n, i) {
    let {
      path: a,
      originalValue: o = t,
      strict: s = this.spec.strict
    } = r, u = t;
    s || (u = this._cast(u, Object.assign({
      assert: !1
    }, r)));
    let l = [];
    for (let c of Object.values(this.internalTests))
      c && l.push(c);
    this.runTests({
      path: a,
      value: u,
      originalValue: o,
      options: r,
      tests: l
    }, n, (c) => {
      if (c.length)
        return i(c, u);
      this.runTests({
        path: a,
        value: u,
        originalValue: o,
        options: r,
        tests: this.tests
      }, n, i);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, r, n) {
    let i = !1, {
      tests: a,
      value: o,
      originalValue: s,
      path: u,
      options: l
    } = t, c = (v) => {
      i || (i = !0, r(v, o));
    }, f = (v) => {
      i || (i = !0, n(v, o));
    }, d = a.length, h = [];
    if (!d)
      return f([]);
    let p = {
      value: o,
      originalValue: s,
      path: u,
      options: l,
      schema: this
    };
    for (let v = 0; v < a.length; v++) {
      const m = a[v];
      m(p, c, function(y) {
        y && (Array.isArray(y) ? h.push(...y) : h.push(y)), --d <= 0 && f(h);
      });
    }
  }
  asNestedTest({
    key: t,
    index: r,
    parent: n,
    parentPath: i,
    originalParent: a,
    options: o
  }) {
    const s = t ?? r;
    if (s == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const u = typeof s == "number";
    let l = n[s];
    const c = Object.assign({}, o, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: l,
      originalValue: a[s],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [u ? "index" : "key"]: s,
      path: u || s.includes(".") ? `${i || ""}[${l ? s : `"${s}"`}]` : (i ? `${i}.` : "") + t
    });
    return (f, d, h) => this.resolve(c)._validate(l, c, d, h);
  }
  validate(t, r) {
    var n;
    let i = this.resolve(Object.assign({}, r, {
      value: t
    })), a = (n = r == null ? void 0 : r.disableStackTrace) != null ? n : i.spec.disableStackTrace;
    return new Promise((o, s) => i._validate(t, r, (u, l) => {
      Kt.isError(u) && (u.value = l), s(u);
    }, (u, l) => {
      u.length ? s(new Kt(u, l, void 0, void 0, a)) : o(l);
    }));
  }
  validateSync(t, r) {
    var n;
    let i = this.resolve(Object.assign({}, r, {
      value: t
    })), a, o = (n = r == null ? void 0 : r.disableStackTrace) != null ? n : i.spec.disableStackTrace;
    return i._validate(t, Object.assign({}, r, {
      sync: !0
    }), (s, u) => {
      throw Kt.isError(s) && (s.value = u), s;
    }, (s, u) => {
      if (s.length)
        throw new Kt(s, t, void 0, void 0, o);
      a = u;
    }), a;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (n) => {
      if (Kt.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (n) {
      if (Kt.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault(t) {
    let r = this.spec.default;
    return r == null ? r : typeof r == "function" ? r.call(this, t) : da(r);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, r) {
    const n = this.clone({
      nullable: t
    });
    return n.internalTests.nullable = ia({
      message: r,
      name: "nullable",
      test(i) {
        return i === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(t, r) {
    const n = this.clone({
      optional: t
    });
    return n.internalTests.optionality = ia({
      message: r,
      name: "optionality",
      test(i) {
        return i === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = Gr.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = Gr.notNull) {
    return this.nullability(!1, t);
  }
  required(t = Gr.required) {
    return this.clone().withMutation((r) => r.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = Gr.default), typeof r.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), i = ia(r), a = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((o) => !(o.OPTIONS.name === r.name && (a || o.OPTIONS.test === i.OPTIONS.test))), n.tests.push(i), n;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let n = this.clone(), i = HS(t).map((a) => new ui(a));
    return i.forEach((a) => {
      a.isSibling && n.deps.push(a.key);
    }), n.conditions.push(typeof r == "function" ? new il(i, r) : il.fromOptions(i, r)), n;
  }
  typeError(t) {
    let r = this.clone();
    return r.internalTests.typeError = ia({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), r;
  }
  oneOf(t, r = Gr.oneOf) {
    let n = this.clone();
    return t.forEach((i) => {
      n._whitelist.add(i), n._blacklist.delete(i);
    }), n.internalTests.whiteList = ia({
      message: r,
      name: "oneOf",
      skipAbsent: !0,
      test(i) {
        let a = this.schema._whitelist, o = a.resolveAll(this.resolve);
        return o.includes(i) ? !0 : this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: o
          }
        });
      }
    }), n;
  }
  notOneOf(t, r = Gr.notOneOf) {
    let n = this.clone();
    return t.forEach((i) => {
      n._blacklist.add(i), n._whitelist.delete(i);
    }), n.internalTests.blacklist = ia({
      message: r,
      name: "notOneOf",
      test(i) {
        let a = this.schema._blacklist, o = a.resolveAll(this.resolve);
        return o.includes(i) ? this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), {
      label: n,
      meta: i,
      optional: a,
      nullable: o
    } = r.spec;
    return {
      meta: i,
      label: n,
      optional: a,
      nullable: o,
      default: r.getDefault(t),
      type: r.type,
      oneOf: r._whitelist.describe(),
      notOneOf: r._blacklist.describe(),
      tests: r.tests.map((u) => ({
        name: u.OPTIONS.name,
        params: u.OPTIONS.params
      })).filter((u, l, c) => c.findIndex((f) => f.name === u.name) === l)
    };
  }
}
on.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  on.prototype[`${e}At`] = function(t, r, n = {}) {
    const {
      parent: i,
      parentPath: a,
      schema: o
    } = une(this, t, r, n.context);
    return o[e](i && i[a], Object.assign({}, n, {
      parent: i,
      path: t
    }));
  };
for (const e of ["equals", "is"])
  on.prototype[e] = on.prototype.oneOf;
for (const e of ["not", "nope"])
  on.prototype[e] = on.prototype.notOneOf;
let lne = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), cne = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), fne = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, dne = (e) => Ci(e) || e === e.trim(), hne = {}.toString();
function bu() {
  return new zS();
}
class zS extends on {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => {
        if (!n.spec.coerce || n.isType(t) || Array.isArray(t))
          return t;
        const i = t != null && t.toString ? t.toString() : t;
        return i === hne ? t : i;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((r) => r.test({
      message: t || Gr.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t));
  }
  length(t, r = Sr.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(t);
      }
    });
  }
  min(t, r = Sr.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Sr.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let n = !1, i, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: i,
      name: a
    } = r : i = r), this.test({
      name: a || "matches",
      message: i || Sr.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (o) => o === "" && n || o.search(t) !== -1
    });
  }
  email(t = Sr.email) {
    return this.matches(lne, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Sr.url) {
    return this.matches(cne, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Sr.uuid) {
    return this.matches(fne, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Sr.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: dne
    });
  }
  lowercase(t = Sr.lowercase) {
    return this.transform((r) => Ci(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => Ci(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Sr.uppercase) {
    return this.transform((r) => Ci(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => Ci(r) || r === r.toUpperCase()
    });
  }
}
bu.prototype = zS.prototype;
const pne = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function pn(e, t = 0) {
  return Number(e) || t;
}
function vne(e) {
  const t = pne.exec(e);
  if (!t)
    return Date.parse ? Date.parse(e) : Number.NaN;
  const r = {
    year: pn(t[1]),
    month: pn(t[2], 1) - 1,
    day: pn(t[3], 1),
    hour: pn(t[4]),
    minute: pn(t[5]),
    second: pn(t[6]),
    millisecond: t[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      pn(t[7].substring(0, 3))
    ) : 0,
    z: t[8] || void 0,
    plusMinus: t[9] || void 0,
    hourOffset: pn(t[10]),
    minuteOffset: pn(t[11])
  };
  if (r.z === void 0 && r.plusMinus === void 0)
    return new Date(r.year, r.month, r.day, r.hour, r.minute, r.second, r.millisecond).valueOf();
  let n = 0;
  return r.z !== "Z" && r.plusMinus !== void 0 && (n = r.hourOffset * 60 + r.minuteOffset, r.plusMinus === "+" && (n = 0 - n)), Date.UTC(r.year, r.month, r.day, r.hour, r.minute + n, r.second, r.millisecond);
}
let mne = /* @__PURE__ */ new Date(""), yne = (e) => Object.prototype.toString.call(e) === "[object Date]";
class Cc extends on {
  constructor() {
    super({
      type: "date",
      check(t) {
        return yne(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => !n.spec.coerce || n.isType(t) || t === null ? t : (t = vne(t), isNaN(t) ? Cc.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, r) {
    let n;
    if (ui.isRef(t))
      n = t;
    else {
      let i = this.cast(t);
      if (!this._typeCheck(i))
        throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = i;
    }
    return n;
  }
  min(t, r = E0.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(i) {
        return i >= this.resolve(n);
      }
    });
  }
  max(t, r = E0.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(i) {
        return i <= this.resolve(n);
      }
    });
  }
}
Cc.INVALID_DATE = mne;
Cc.prototype;
function gne(e, t = []) {
  let r = [], n = /* @__PURE__ */ new Set(), i = new Set(t.map(([o, s]) => `${o}-${s}`));
  function a(o, s) {
    let u = ki.split(o)[0];
    n.add(u), i.has(`${s}-${u}`) || r.push([s, u]);
  }
  for (const o of Object.keys(e)) {
    let s = e[o];
    n.add(o), ui.isRef(s) && s.isSibling ? a(s.path, o) : Cp(s) && "deps" in s && s.deps.forEach((u) => a(u, o));
  }
  return Kre.array(Array.from(n), r).reverse();
}
function ox(e, t) {
  let r = 1 / 0;
  return e.some((n, i) => {
    var a;
    if ((a = t.path) != null && a.includes(n))
      return r = i, !0;
  }), r;
}
function qS(e) {
  return (t, r) => ox(e, t) - ox(e, r);
}
const xne = (e, t, r) => {
  if (typeof e != "string")
    return e;
  let n = e;
  try {
    n = JSON.parse(e);
  } catch {
  }
  return r.isType(n) ? n : e;
};
function Eu(e) {
  if ("fields" in e) {
    const t = {};
    for (const [r, n] of Object.entries(e.fields))
      t[r] = Eu(n);
    return e.setFields(t);
  }
  if (e.type === "array") {
    const t = e.optional();
    return t.innerType && (t.innerType = Eu(t.innerType)), t;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(Eu)
  }) : "optional" in e ? e.optional() : e;
}
const bne = (e, t) => {
  const r = [...ki.normalizePath(t)];
  if (r.length === 1)
    return r[0] in e;
  let n = r.pop(), i = ki.getter(ki.join(r), !0)(e);
  return !!(i && n in i);
};
let sx = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Ene(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((n) => r.indexOf(n) === -1);
}
const wne = qS([]);
function Op(e) {
  return new YS(e);
}
class YS extends on {
  constructor(t) {
    super({
      type: "object",
      check(r) {
        return sx(r) || typeof r == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = wne, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, r = {}) {
    var n;
    let i = super._cast(t, r);
    if (i === void 0)
      return this.getDefault(r);
    if (!this._typeCheck(i))
      return i;
    let a = this.fields, o = (n = r.stripUnknown) != null ? n : this.spec.noUnknown, s = [].concat(this._nodes, Object.keys(i).filter((f) => !this._nodes.includes(f))), u = {}, l = Object.assign({}, r, {
      parent: u,
      __validating: r.__validating || !1
    }), c = !1;
    for (const f of s) {
      let d = a[f], h = f in i;
      if (d) {
        let p, v = i[f];
        l.path = (r.path ? `${r.path}.` : "") + f, d = d.resolve({
          value: v,
          context: r.context,
          parent: u
        });
        let m = d instanceof on ? d.spec : void 0, x = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          c = c || f in i;
          continue;
        }
        p = !r.__validating || !x ? (
          // TODO: use _cast, this is double resolving
          d.cast(i[f], l)
        ) : i[f], p !== void 0 && (u[f] = p);
      } else
        h && !o && (u[f] = i[f]);
      (h !== f in u || u[f] !== i[f]) && (c = !0);
    }
    return c ? u : i;
  }
  _validate(t, r = {}, n, i) {
    let {
      from: a = [],
      originalValue: o = t,
      recursive: s = this.spec.recursive
    } = r;
    r.from = [{
      schema: this,
      value: o
    }, ...a], r.__validating = !0, r.originalValue = o, super._validate(t, r, n, (u, l) => {
      if (!s || !sx(l)) {
        i(u, l);
        return;
      }
      o = o || l;
      let c = [];
      for (let f of this._nodes) {
        let d = this.fields[f];
        !d || ui.isRef(d) || c.push(d.asNestedTest({
          options: r,
          key: f,
          parent: l,
          parentPath: r.path,
          originalParent: o
        }));
      }
      this.runTests({
        tests: c,
        value: l,
        originalValue: o,
        options: r
      }, n, (f) => {
        i(f.sort(this._sortErrors).concat(u), l);
      });
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = Object.assign({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), n = r.fields;
    for (let [i, a] of Object.entries(this.fields)) {
      const o = n[i];
      n[i] = o === void 0 ? a : o;
    }
    return r.withMutation((i) => (
      // XXX: excludes here is wrong
      i.setFields(n, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let r = {};
    return this._nodes.forEach((n) => {
      var i;
      const a = this.fields[n];
      let o = t;
      (i = o) != null && i.value && (o = Object.assign({}, o, {
        parent: o.value,
        value: o.value[n]
      })), r[n] = a && "getDefault" in a ? a.getDefault(o) : void 0;
    }), r;
  }
  setFields(t, r) {
    let n = this.clone();
    return n.fields = t, n._nodes = gne(t, r), n._sortErrors = qS(Object.keys(t)), r && (n._excludedEdges = r), n;
  }
  shape(t, r = []) {
    return this.clone().withMutation((n) => {
      let i = n._excludedEdges;
      return r.length && (Array.isArray(r[0]) || (r = [r]), i = [...n._excludedEdges, ...r]), n.setFields(Object.assign(n.fields, t), i);
    });
  }
  partial() {
    const t = {};
    for (const [r, n] of Object.entries(this.fields))
      t[r] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
    return this.setFields(t);
  }
  deepPartial() {
    return Eu(this);
  }
  pick(t) {
    const r = {};
    for (const n of t)
      this.fields[n] && (r[n] = this.fields[n]);
    return this.setFields(r, this._excludedEdges.filter(([n, i]) => t.includes(n) && t.includes(i)));
  }
  omit(t) {
    const r = [];
    for (const n of Object.keys(this.fields))
      t.includes(n) || r.push(n);
    return this.pick(r);
  }
  from(t, r, n) {
    let i = ki.getter(t, !0);
    return this.transform((a) => {
      if (!a)
        return a;
      let o = a;
      return bne(a, t) && (o = Object.assign({}, a), n || delete o[t], o[r] = i(a)), o;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(xne);
  }
  noUnknown(t = !0, r = w0.noUnknown) {
    typeof t != "boolean" && (r = t, t = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(i) {
        if (i == null)
          return !0;
        const a = Ene(this.schema, i);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = t, n;
  }
  unknown(t = !0, r = w0.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => {
      if (!r)
        return r;
      const n = {};
      for (const i of Object.keys(r))
        n[t(i)] = r[i];
      return n;
    });
  }
  camelCase() {
    return this.transformKeys(ad.camelCase);
  }
  snakeCase() {
    return this.transformKeys(ad.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => ad.snakeCase(t).toUpperCase());
  }
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), n = super.describe(t);
    n.fields = {};
    for (const [a, o] of Object.entries(r.fields)) {
      var i;
      let s = t;
      (i = s) != null && i.value && (s = Object.assign({}, s, {
        parent: s.value,
        value: s.value[a]
      })), n.fields[a] = o.describe(s);
    }
    return n;
  }
}
Op.prototype = YS.prototype;
const VS = {
  oldPassword: bu().required("Please kindly use the password you have registered"),
  newPassword: bu().required("No password provided").min(10, "The password entered is not long enough").test({
    name: "has-cap",
    exclusive: !0,
    message: "Password must have an uppercase letter",
    test: (e) => /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]/.test(e)
  }).test({
    name: "has-lower",
    exclusive: !0,
    message: "The password does not have a lowercase letter",
    test: (e) => /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]/.test(e)
  }).test({
    name: "has-integer",
    exclusive: !0,
    message: "The password does not have integer",
    test: (e) => /^(?=.*\d+)[A-Za-z\d!@#$%&*]/.test(e)
  }).test({
    name: "has-special",
    exclusive: !0,
    message: "Password should have (and be limited to) these special characters: !@#$%&*",
    test: (e) => Fre(gJ([
      /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*\d+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*[!@#$%&*]+)^[A-Za-z\d!@#$%&*]{10,}$/
    ], (n) => n.test(e))) === 4
  }),
  // .test({
  //     name: 'is-valid-pattern',
  //     exclusive: true,
  //     message:
  //         'Password must contain at least one uppercase letter, one lowercase letter, one numeric character and one special character',
  //     test: (value: string) => {
  //         const patterns = [
  //             /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*\d+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*[!@#$%&*]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //         ];
  //         const matched = sum(map(patterns, (pattern) => pattern.test(value)));
  //         return matched >= 3;
  //     },
  // }),
  confirmNewPassword: bu().when("newPassword", (e, t) => e ? t.required("Confirm Password is required") : t).oneOf([sne("newPassword"), ""], "Your passwords do not match")
}, ux = Op(VS), Sne = Op(Sre(VS, "oldPassword"));
var _ne = /* @__PURE__ */ ((e) => (e.CHANGE = "change", e.RESET = "reset", e.NEW = "new", e))(_ne || {});
const Tne = {
  new: Sne,
  change: ux,
  reset: ux
}, od = ({ placeholder: e, border: t, ...r }) => {
  const [n, i] = Oe(), a = qr(null), o = () => i(!0), s = () => i(!1);
  return Gn("focus", o, a), Gn("blur", s, a), /* @__PURE__ */ S.jsxs(Ce, { position: "relative", children: [
    n && /* @__PURE__ */ S.jsx(
      Ce,
      {
        pos: "absolute",
        top: "2px",
        left: "10px",
        fontSize: "sm",
        fontWeight: 400,
        color: "gray.500",
        children: e
      }
    ),
    /* @__PURE__ */ S.jsx(C0, { children: /* @__PURE__ */ S.jsx(
      sl,
      {
        type: "password",
        p: n ? "8px 12px" : "12px",
        minH: "56px",
        border: t || void 0,
        placeholder: n ? "" : e,
        ref: a,
        onFocus: o,
        onBlur: s,
        ...r
      }
    ) })
  ] });
}, Ane = ({
  title: e,
  isLoading: t = !1,
  mode: r = "new",
  apiErrors: n = {},
  initialValues: i = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  },
  initialErrors: a = {},
  schema: o,
  onSubmit: s = Bp,
  onChange: u = Bp,
  hashingFn: l = U_,
  hashingFnParams: c = [""],
  formId: f = oJ("form-password-reset-"),
  sx: d,
  children: h
}) => {
  const [p] = sb(h, {
    helperText: d0
  });
  o = o ?? Tne[r];
  const v = (y) => y.preventDefault(), [m, x] = Oe(!1);
  return /* @__PURE__ */ S.jsx(
    LX,
    {
      initialValues: i,
      enableReinitialize: !0,
      initialErrors: a,
      validationSchema: o,
      onSubmit: (y) => {
        x(!0), tJ(() => {
          const g = l.apply(null, [
            y.oldPassword ?? "",
            ...c
          ]), E = l.apply(null, [
            y.newPassword ?? "",
            ...c
          ]);
          s({
            ...y,
            oldPassword: g,
            newPassword: E
          }), x(!1);
        }, 1e3);
      },
      children: ({ isValid: y, dirty: g }) => /* @__PURE__ */ S.jsx(fJ, { id: f, onChange: u, sx: d, hasDefaultControls: !1, children: /* @__PURE__ */ S.jsxs(Oi, { w: "full", h: "full", justifyContent: "space-between", children: [
        /* @__PURE__ */ S.jsxs(Oi, { gap: 4, w: "full", children: [
          /* @__PURE__ */ S.jsx(
            mx,
            {
              w: "full",
              letterSpacing: -0.352,
              fontWeight: "light",
              lineHeight: "shorter",
              fontSize: "2rem",
              children: e || "Change password"
            }
          ),
          r === "change" && /* @__PURE__ */ S.jsx(nd, { name: "oldPassword", children: ({ field: E, form: b }) => /* @__PURE__ */ S.jsxs(
            Fc,
            {
              isInvalid: b.errors.oldPassword && b.touched.oldPassword || n && n.oldPassword && n.oldPassword.length > 0,
              children: [
                /* @__PURE__ */ S.jsx(
                  od,
                  {
                    placeholder: "Current password",
                    isDisabled: t || m,
                    onPaste: v,
                    ...E
                  }
                ),
                /* @__PURE__ */ S.jsx(Ic, { children: b.errors.oldPassword || n.oldPassword })
              ]
            }
          ) }),
          /* @__PURE__ */ S.jsx(Ce, { fontWeight: "light", lineHeight: "shorter", fontSize: "xl", children: /* @__PURE__ */ S.jsx(
            _t,
            {
              text: "Your password must meet the following requirements:",
              translationKey: "ChangePassword/password-requirements-header"
            }
          ) }),
          p.helperText ?? /* @__PURE__ */ S.jsx(d0, {}),
          /* @__PURE__ */ S.jsx(nd, { name: "newPassword", children: ({ field: E, form: b }) => /* @__PURE__ */ S.jsxs(
            Fc,
            {
              isInvalid: b.errors.newPassword && b.touched.newPassword || n && n.newPassword && n.newPassword.length > 0,
              children: [
                /* @__PURE__ */ S.jsx(
                  od,
                  {
                    placeholder: "New password",
                    isDisabled: t || m,
                    border: y && g ? "2px solid green" : "1px solid black",
                    onPaste: v,
                    ...E
                  }
                ),
                /* @__PURE__ */ S.jsx(Ic, { children: b.errors.newPassword || n.newPassword })
              ]
            }
          ) }),
          /* @__PURE__ */ S.jsx(nd, { name: "confirmNewPassword", children: ({ field: E, form: b }) => /* @__PURE__ */ S.jsxs(
            Fc,
            {
              isInvalid: b.errors.confirmNewPassword && b.touched.confirmNewPassword || n && n.confirmNewPassword && n.confirmNewPassword.length > 0,
              children: [
                /* @__PURE__ */ S.jsx(
                  od,
                  {
                    placeholder: "Confirm New password",
                    isDisabled: t || m,
                    border: y && g ? "2px solid green" : "1px solid black",
                    isValid: y,
                    onPaste: v,
                    ...E
                  }
                ),
                /* @__PURE__ */ S.jsx(Ic, { children: b.errors.confirmNewPassword || n.confirmNewPassword })
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ S.jsx(
          ri,
          {
            w: "full",
            type: "submit",
            isLoading: t || m,
            isDisabled: !g || !y,
            bgColor: { base: "primary.500", md: "black" },
            children: "Proceed"
          }
        )
      ] }) })
    }
  );
}, Xie = Object.assign(Ane, { HelperText: d0 });
export {
  q$ as $,
  mie as A,
  HT as B,
  Oie as C,
  jh as D,
  _C as E,
  sb as F,
  h4 as G,
  XE as H,
  Zne as I,
  n4 as J,
  Om as K,
  nM as L,
  py as M,
  Cie as N,
  BI as O,
  Xie as P,
  FO as Q,
  zR as R,
  aM as S,
  _t as T,
  Eie as U,
  Aie as V,
  lie as W,
  wie as X,
  Fx as Y,
  _ie as Z,
  n1 as _,
  Bh as a,
  G5 as a$,
  tie as a0,
  rie as a1,
  nie as a2,
  iie as a3,
  uie as a4,
  aie as a5,
  die as a6,
  cie as a7,
  Sie as a8,
  oie as a9,
  Ke as aA,
  bi as aB,
  i0 as aC,
  Dy as aD,
  En as aE,
  Rie as aF,
  f9 as aG,
  Bie as aH,
  zie as aI,
  Lie as aJ,
  qo as aK,
  jie as aL,
  M5 as aM,
  s9 as aN,
  Hie as aO,
  Vh as aP,
  bs as aQ,
  Gh as aR,
  Qu as aS,
  Ue as aT,
  Uie as aU,
  Mie as aV,
  Fy as aW,
  $5 as aX,
  cw as aY,
  Ty as aZ,
  Ze as a_,
  sie as aa,
  hie as ab,
  fie as ac,
  gie as ad,
  xie as ae,
  bie as af,
  Nie as ag,
  RT as ah,
  o4 as ai,
  s4 as aj,
  SB as ak,
  ue as al,
  pr as am,
  qie as an,
  Wie as ao,
  pt as ap,
  n0 as aq,
  pw as ar,
  o9 as as,
  l9 as at,
  Yie as au,
  Mn as av,
  st as aw,
  Yo as ax,
  mt as ay,
  ht as az,
  p4 as b,
  N5 as b0,
  zh as b1,
  lc as b2,
  Vie as b3,
  zw as b4,
  Es as b5,
  ws as b6,
  Rq as b7,
  Kie as b8,
  wt as b9,
  Gie as ba,
  $ie as bb,
  Pie as bc,
  MB as bd,
  Qie as be,
  fd as bf,
  kS as bg,
  gc as bh,
  np as bi,
  ai as bj,
  _s as bk,
  Nn as bl,
  Be as bm,
  Bl as c,
  M0 as d,
  vie as e,
  yie as f,
  pie as g,
  kie as h,
  Tie as i,
  Pf as j,
  Die as k,
  d4 as l,
  Iie as m,
  Xne as n,
  Fie as o,
  oM as p,
  Vd as q,
  eie as r,
  Sne as s,
  ux as t,
  Jt as u,
  _ne as v,
  Jne as w,
  QI as x,
  LT as y,
  Px as z
};
